
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49a6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49a6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4Idm1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f067efb92be4643$var$UnifiedShell;

var $jAW8V = parcelRequire("jAW8V");

var $3f067efb92be4643$var$_CookieError = $3f067efb92be4643$var$_interopRequireWildcard((parcelRequire("c12kb")));

var $bzq4v = parcelRequire("bzq4v");

var $jVeiz = parcelRequire("jVeiz");

var $iNslS = parcelRequire("iNslS");

var $3f067efb92be4643$var$_core = $3f067efb92be4643$var$_interopRequireWildcard((parcelRequire("4KddD")));

var $dDEjQ = parcelRequire("dDEjQ");

var $hCG2Z = parcelRequire("hCG2Z");

var $aspzj = parcelRequire("aspzj");

var $15j1u = parcelRequire("15j1u");

var $3f067efb92be4643$var$_react = $3f067efb92be4643$var$_interopRequireDefault((parcelRequire("7eprg")));

var $ctGaZ = parcelRequire("ctGaZ");

function $3f067efb92be4643$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3f067efb92be4643$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $3f067efb92be4643$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $3f067efb92be4643$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3f067efb92be4643$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ function $3f067efb92be4643$var$sortByPath(arr, key) {
    const getValue = (obj)=>key.split(".").reduce((prev, subKey)=>prev?.[subKey], obj) || "";
    return arr.sort((a, b)=>{
        const aLen = getValue(a).split("/").length;
        const bLen = getValue(b).split("/").length;
        if (aLen < bLen) return 1;
        else if (aLen > bLen) return -1;
        return 0;
    });
}
/*
 * Process solutions and combine with locally defined solutions.
 */ const $3f067efb92be4643$var$generateSolutions = (localSolutions)=>{
    let solutions = (0, $aspzj.getRoutes)();
    if (localSolutions) solutions = {
        ...solutions,
        ...localSolutions
    };
    const denyParams = []; // Get the name of the solution export added onto the solution object.
    Object.keys(solutions).forEach((name)=>{
        const solution = solutions[name];
        solution.exportName = name;
        if (solution.spaAppId) denyParams.push(`${solution.spaAppId}_version`);
        if (solution.mfeAppIds?.length) solution.mfeAppIds.forEach((appId)=>denyParams.push(`${appId}_version`));
    });
    (0, $jVeiz.denyBrowserParams)(denyParams); // Sort the solutions by number of chunks in the path. This is required to
    // handle /home and /home/notifications. The latter needs to come first so
    // that it matches correctly in the router.
    return $3f067efb92be4643$var$sortByPath(Object.values(solutions), "path");
};
/*
 * Generate redirect routes for each solution.
 */ const $3f067efb92be4643$var$generateRedirects = (solutions)=>{
    const redirects = [];
    solutions.forEach(({ path: path, redirectFrom: redirectFrom })=>redirectFrom && redirectFrom.forEach((redirect)=>redirects.push({
                path: path,
                redirect: redirect
            })));
    return redirects;
};
function $3f067efb92be4643$var$UnifiedShell({ cdn: cdn, env: env, region: region, scriptsPath: scriptsPath, solutionsOverride: solutionsOverride, spaVersion: spaVersion }) {
    const { hash: hash, origin: origin, pathname: pathname, search: search } = window.location;
    env = env.toLowerCase();
    const bootstrap = (0, $dDEjQ.getBootstrap)(); // If the Shell is loaded within a parent, we should send up a redirect to
    // this page that we're on. This supports redirects within other applications
    // that may end up in this situation. Additionally, don't do this if this
    // is running in a Cypress test because it will break!
    if (window !== window.parent && !bootstrap.inAutomation()) {
        window.parent.postMessage({
            appId: "unified-shell",
            type: $iNslS.Events.QUEUE,
            unifiedShell: 1,
            value: [
                [
                    $iNslS.Events.SHELL_REDIRECT,
                    {
                        discovery: true,
                        path: (0, $jVeiz.getPathWithoutTenant)(hash.replace(/^#/, ""))
                    }
                ]
            ]
        }, origin);
        return null;
    }
    if (!(0, $3f067efb92be4643$var$_CookieError.storageAvailable)("localStorage")) return /*#__PURE__*/ $3f067efb92be4643$var$_react.default.createElement($3f067efb92be4643$var$_CookieError.default, null);
    const solutions = solutionsOverride || $3f067efb92be4643$var$generateSolutions(bootstrap.localSolutions);
    const skyline = (0, $15j1u.isSkyline)();
    const nonSkylineSolutions = Object.values(solutions).filter((solution)=>!solution.withinSkyline);
    const skylineSolutions = Object.values(solutions).filter((solution)=>solution.withinSkyline);
    const thunderbird = (0, $hCG2Z.getQueryValue)("thunderbird");
    if ([
        "force",
        "off"
    ].includes(thunderbird)) // Turn thunderbird on or off for all applicable solutions.
    solutions.filter((solution)=>!!solution.spaAppId).forEach((solution)=>solution.thunderbird = thunderbird === "force" ? $ctGaZ.THUNDERBIRD.SERVICE_WORKER : $ctGaZ.THUNDERBIRD.OFF);
     // If there is a path defined, it's not valid in the Unified Shell URL. It
    // replaces the history path to `/` and updates the hash history (`history`)
    // to the provided path.
    if ($bzq4v.history && /^(\/((?!login|unifiedshell|ui).)+)$/.test(pathname)) {
        window.history.replaceState(null, "", "/"); // The hash property defaults to `#/` since Unified Shell uses hash history.
        // Don't want this to transfer to the final path.
        $bzq4v.history.replace({
            hash: hash === "#/" ? "" : hash,
            pathname: pathname,
            search: search
        });
    } // Sets up the list of redirects that will be used to generate routes
    // specifically meant to navigate to a different path.
    const redirects = $3f067efb92be4643$var$generateRedirects(solutions);
    return /*#__PURE__*/ $3f067efb92be4643$var$_react.default.createElement($3f067efb92be4643$var$_core.default, {
        cdn: cdn || window.location.origin,
        environment: env,
        listedApps: solutions,
        region: region,
        scriptsPath: scriptsPath,
        spaVersion: spaVersion
    }, /*#__PURE__*/ $3f067efb92be4643$var$_react.default.createElement($bzq4v.Router, {
        history: $bzq4v.history
    }, skyline && nonSkylineSolutions.map((solution, idx)=>/*#__PURE__*/ $3f067efb92be4643$var$_react.default.createElement($bzq4v.Route, {
            key: `nonSkyline-${idx}`,
            path: `/:id(@[^/]+)?/:contextParam([^/]+:[^/]+)?${solution.path}`,
            redirect: ({ route: route })=>{
                const redirectMatcher = (0, $jAW8V.pathToRegexp)(solution.path, undefined, {
                    end: false
                });
                if (!redirectMatcher.exec((0, $jVeiz.getPathWithoutContext)((0, $jVeiz.getPathWithoutTenant)(route)))) return;
                window.open((0, $jVeiz.getUnifiedShellUrl)(env, route), "_self"); // This is pretty clever. Sends the path to a wait spinner so that
                // there is something to show while the window.open is triggering.
                return "/wait";
            }
        })), $3f067efb92be4643$var$sortByPath(redirects, "redirect.path").map(({ path: path, redirect: { options: options, path: redirectedPath } }, redirectIdx)=>{
        redirectedPath = /:[^/]*$/.test(redirectedPath) ? `${redirectedPath}([^/#?]+)` : redirectedPath;
        return /*#__PURE__*/ $3f067efb92be4643$var$_react.default.createElement($bzq4v.Route, {
            exact: true,
            key: redirectIdx,
            path: `/:id(@[^/]+)?/:contextParam([^/]+:[^/]+)?${redirectedPath}(/.*)?`,
            redirect: ({ route: route })=>{
                const keys = [];
                const redirectMatcher = (0, $jAW8V.pathToRegexp)(redirectedPath, keys, options || {
                    end: false
                });
                const matchResult = redirectMatcher.exec((0, $jVeiz.getPathWithoutContext)((0, $jVeiz.getPathWithoutTenant)(route)));
                if (!matchResult) return;
                const toNewPath = (0, $jAW8V.compile)(path, {
                    encode: encodeURIComponent
                });
                const params = {};
                for(let i = 1; i < matchResult.length; i++){
                    const key = keys[i - 1];
                    const val = matchResult[i];
                    if (val !== undefined) params[key.name] = val;
                }
                return route.replace(matchResult[0], toNewPath(params));
            }
        });
    }), (skyline ? skylineSolutions : nonSkylineSolutions).map((solution, idx)=>/*#__PURE__*/ $3f067efb92be4643$var$_react.default.createElement($bzq4v.Route, {
            key: idx,
            path: `/:id(@[^/]+)?/:contextParam([^/]+:[^/]+)?${solution.path}`
        }, "alternateRoute" in solution ? /*#__PURE__*/ $3f067efb92be4643$var$_react.default.createElement($3f067efb92be4643$var$_core.AppSelectorSandbox, {
            config: solution
        }) : /*#__PURE__*/ $3f067efb92be4643$var$_react.default.createElement($3f067efb92be4643$var$_core.Sandbox, {
            config: solution
        }))), /*#__PURE__*/ $3f067efb92be4643$var$_react.default.createElement($bzq4v.Route, {
        exact: true,
        path: "/@:id",
        redirect: ({ route: route })=>`${route}${route.endsWith("/") ? "" : "/"}home`
    }), /*#__PURE__*/ $3f067efb92be4643$var$_react.default.createElement($bzq4v.Route, {
        key: "profile",
        path: "(/@|):id?/profile"
    }), /*#__PURE__*/ $3f067efb92be4643$var$_react.default.createElement($bzq4v.Route, {
        path: "(/@|):id?/wait"
    }, $3f067efb92be4643$var$_core.waitComponent), /*#__PURE__*/ $3f067efb92be4643$var$_react.default.createElement($bzq4v.Route, {
        exact: true,
        path: "/",
        redirect: ()=>(0, $15j1u.isSkyline)() ? "/aem" : "/home"
    }), /*#__PURE__*/ $3f067efb92be4643$var$_react.default.createElement($bzq4v.Route, null, /*#__PURE__*/ $3f067efb92be4643$var$_react.default.createElement($3f067efb92be4643$var$_core.ErrorView, {
        resetSolution: true,
        type: $3f067efb92be4643$var$_core.ErrorTypes.NOT_FOUND
    }))));
}

});
parcelRegister("jAW8V", function(module, exports) {

$parcel$export(module.exports, "compile", function () { return $e43e7b120308d767$export$ef7acd7185315e22; });
$parcel$export(module.exports, "pathToRegexp", function () { return $e43e7b120308d767$export$71304158c7e35877; });
/**
 * Tokenize input string.
 */ function $e43e7b120308d767$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at " + i);
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError('Pattern cannot start with "?" at ' + j);
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at " + j);
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at " + i);
            if (!pattern) throw new TypeError("Missing pattern at " + i);
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $e43e7b120308d767$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $e43e7b120308d767$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
    var defaultPattern = "[^" + $e43e7b120308d767$var$escapeString(options.delimiter || "/#?") + "]+?";
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected " + nextType + " at " + index + ", expected " + type);
    };
    var consumeText = function() {
        var result = "";
        var value;
        // tslint:disable-next-line
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || defaultPattern,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $e43e7b120308d767$export$ef7acd7185315e22(str, options) {
    return $e43e7b120308d767$export$5b9bad9e403cf3d9($e43e7b120308d767$export$98e6a39c04603d36(str, options), options);
}
function $e43e7b120308d767$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $e43e7b120308d767$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:" + token.pattern + ")$", reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but got an array');
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"');
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"');
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError('Expected "' + token.name + '" to be ' + typeOfMessage);
        }
        return path;
    };
}
function $e43e7b120308d767$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $e43e7b120308d767$export$71304158c7e35877(str, keys, options);
    return $e43e7b120308d767$export$968e97c88708237a(re, keys, options);
}
function $e43e7b120308d767$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            // tslint:disable-next-line
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $e43e7b120308d767$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $e43e7b120308d767$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $e43e7b120308d767$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $e43e7b120308d767$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $e43e7b120308d767$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:" + parts.join("|") + ")", $e43e7b120308d767$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $e43e7b120308d767$var$stringToRegexp(path, keys, options) {
    return $e43e7b120308d767$export$9a9303716def6456($e43e7b120308d767$export$98e6a39c04603d36(path, options), keys, options);
}
function $e43e7b120308d767$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d;
    var endsWith = "[" + $e43e7b120308d767$var$escapeString(options.endsWith || "") + "]|$";
    var delimiter = "[" + $e43e7b120308d767$var$escapeString(options.delimiter || "/#?") + "]";
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $e43e7b120308d767$var$escapeString(encode(token));
        else {
            var prefix = $e43e7b120308d767$var$escapeString(encode(token.prefix));
            var suffix = $e43e7b120308d767$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:" + prefix + "((?:" + token.pattern + ")(?:" + suffix + prefix + "(?:" + token.pattern + "))*)" + suffix + ")" + mod;
                    } else route += "(?:" + prefix + "(" + token.pattern + ")" + suffix + ")" + token.modifier;
                } else route += "(" + token.pattern + ")" + token.modifier;
            } else route += "(?:" + prefix + suffix + ")" + token.modifier;
        }
    }
    if (end) {
        if (!strict) route += delimiter + "?";
        route += !options.endsWith ? "$" : "(?=" + endsWith + ")";
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiter.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:" + delimiter + "(?=" + endsWith + "))?";
        if (!isEndDelimited) route += "(?=" + delimiter + "|" + endsWith + ")";
    }
    return new RegExp(route, $e43e7b120308d767$var$flags(options));
}
function $e43e7b120308d767$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $e43e7b120308d767$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $e43e7b120308d767$var$arrayToRegexp(path, keys, options);
    return $e43e7b120308d767$var$stringToRegexp(path, keys, options);
}

});

parcelRegister("c12kb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a8a8631a7a0e3157$var$cookieError;
module.exports.storageAvailable = void 0;

var $4KddD = parcelRequire("4KddD");

var $gigHb = parcelRequire("gigHb");

var $hnXu3 = parcelRequire("hnXu3");

var $a8a8631a7a0e3157$var$_react = $a8a8631a7a0e3157$var$_interopRequireDefault((parcelRequire("7eprg")));
function $a8a8631a7a0e3157$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * Check if storage is available
 * See: {@link https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#feature-detecting_localstorage}
 * @param {string} type - Session type: localStorage or sessionStorage
 * @returns {boolean} true if storage is available
 */ const $a8a8631a7a0e3157$var$storageAvailable = function(type) {
    let storage;
    try {
        storage = window[type];
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") && storage?.length !== 0;
    }
};
module.exports.storageAvailable = $a8a8631a7a0e3157$var$storageAvailable;
function $a8a8631a7a0e3157$var$cookieError() {
    const locale = (0, $gigHb.getBestSupportedLocale)([
        navigator.language
    ], $gigHb.SUPPORTED_LOCALES);
    return /*#__PURE__*/ $a8a8631a7a0e3157$var$_react.default.createElement($a8a8631a7a0e3157$var$_react.default.Suspense, {
        fallback: null
    }, /*#__PURE__*/ $a8a8631a7a0e3157$var$_react.default.createElement($hnXu3.default, {
        locale: locale
    }, /*#__PURE__*/ $a8a8631a7a0e3157$var$_react.default.createElement("div", null, /*#__PURE__*/ $a8a8631a7a0e3157$var$_react.default.createElement($4KddD.ErrorView, {
        type: $4KddD.ErrorTypes.COOKIE_NEEDED
    }))));
}

});
parcelRegister("4KddD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "AppSelectorSandbox", {
    enumerable: true,
    get: function() {
        return $jdphR.AppSelectorSandbox;
    }
});
Object.defineProperty(module.exports, "getQueryValue", {
    enumerable: true,
    get: function() {
        return $hCG2Z.getQueryValue;
    }
});
Object.defineProperty(module.exports, "getPathWithoutTenant", {
    enumerable: true,
    get: function() {
        return $jVeiz.getPathWithoutTenant;
    }
});
Object.defineProperty(module.exports, "ErrorTypes", {
    enumerable: true,
    get: function() {
        return $fi30R.ErrorTypes;
    }
});
Object.defineProperty(module.exports, "Sandbox", {
    enumerable: true,
    get: function() {
        return $3745b6545f08e8df$var$_Sandbox.default;
    }
});
module.exports.default = module.exports.waitComponent = module.exports.ErrorView = void 0;

var $jdphR = parcelRequire("jdphR");

var $lRoWp = parcelRequire("lRoWp");

var $dDEjQ = parcelRequire("dDEjQ");

var $hCG2Z = parcelRequire("hCG2Z");

var $3745b6545f08e8df$var$_Core = $3745b6545f08e8df$var$_interopRequireDefault((parcelRequire("5EtxO")));

var $3745b6545f08e8df$var$coreLocaleData = $3745b6545f08e8df$var$_interopRequireWildcard((parcelRequire("ePsJb")));

var $9QLmC = parcelRequire("9QLmC");
var $jxYT9 = parcelRequire("jxYT9");

var $jVeiz = parcelRequire("jVeiz");

var $fi30R = parcelRequire("fi30R");

var $gigHb = parcelRequire("gigHb");

var $bzq4v = parcelRequire("bzq4v");

var $3x6rS = parcelRequire("3x6rS");

var $gYPan = parcelRequire("gYPan");

var $3745b6545f08e8df$var$_metrics = $3745b6545f08e8df$var$_interopRequireWildcard((parcelRequire("83dfQ")));

var $3745b6545f08e8df$var$_react = $3745b6545f08e8df$var$_interopRequireDefault((parcelRequire("7eprg")));

var $3745b6545f08e8df$var$_Sandbox = $3745b6545f08e8df$var$_interopRequireDefault((parcelRequire("hENHA")));

var $3745b6545f08e8df$var$_ShellWait = $3745b6545f08e8df$var$_interopRequireDefault((parcelRequire("a7nYS")));

var $2qT0f = parcelRequire("2qT0f");
function $3745b6545f08e8df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3745b6545f08e8df$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $3745b6545f08e8df$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $3745b6545f08e8df$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3745b6545f08e8df$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
const $3745b6545f08e8df$var$ACCESS_PREFIX = "#/access_token=";
const $3745b6545f08e8df$var$SSO_PREFIX = "#/sso:";
const $3745b6545f08e8df$var$SSO_REGEX = /#\/sso:(.*?)(\/.*|$)/;

const $3745b6545f08e8df$var$ErrorView = /*#__PURE__*/ $3745b6545f08e8df$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("eFujB"));
    }).then((res)=>$3745b6545f08e8df$var$_interopRequireWildcard(res)));
module.exports.ErrorView = $3745b6545f08e8df$var$ErrorView;
const $3745b6545f08e8df$var$waitComponent = /*#__PURE__*/ $3745b6545f08e8df$var$_react.default.createElement("div", {
    className: "full-screen"
}, /*#__PURE__*/ $3745b6545f08e8df$var$_react.default.createElement($3745b6545f08e8df$var$_ShellWait.default, {
    locale: "en-US"
}));
module.exports.waitComponent = $3745b6545f08e8df$var$waitComponent;

class $3745b6545f08e8df$var$Main extends $3745b6545f08e8df$var$_react.default.Component {
    constructor(props){
        super(props);
        this.metrics = $3745b6545f08e8df$var$_metrics.default.create("exc.core.App");
        this.shellTimer = this.metrics.start("Shell");
        this.metrics.event($3745b6545f08e8df$var$_metrics.Events.PAGE_LOAD_START, "App constructed");
        const locale = (0, $gigHb.getBestSupportedLocale)([
            navigator.language
        ], $gigHb.SUPPORTED_LOCALES);
        this.ssoDomain = null;
        this.debugHashes = []; // Triple of [initialHash, currentHash, newHash]
        let { hash: initialHash } = window.location;
        const firstHash = initialHash;
        if (initialHash.startsWith($3745b6545f08e8df$var$SSO_PREFIX)) {
            const [, domain, hash = ""] = initialHash.match($3745b6545f08e8df$var$SSO_REGEX) || [];
            if (domain && domain.startsWith("@") && domain.includes(".")) this.ssoDomain = domain;
            (0, $2qT0f.updatePath)({
                path: hash
            }, true);
        } // If the hash is #/access_token, that will break the routing, so we need
        // to push that to #/home instead.
        if (initialHash.includes($3745b6545f08e8df$var$ACCESS_PREFIX)) (0, $2qT0f.updatePath)({
            path: initialHash.substring(0, initialHash.indexOf($3745b6545f08e8df$var$ACCESS_PREFIX)).replace(/^#/, "") || "/home"
        }, true);
         // If the hash is not already encoded (e.g. user is logged out and clicks on a bookmarked link)
        // we should encode the hash to properly redirect once the user is logged in.
        this.redirectUri = window.location.href.includes("old_hash") ? window.location.href : (0, $jVeiz.encodeForRedirect)(); // This is the trigger that can be used to
        // replace the history with the hash of the login history. The history types
        // are different because login uses browser history while the app uses hash
        // history.
        // The old_hash property is added by us and passed through by IMS so we
        // know what page to load. There are scenarios where this value is
        // encoded and isn't handled properly. This will decode the URL hash to
        // get the correct hash to parse params.
        let hasOldHash = false;
        if (initialHash.includes("old_hash")) {
            this.debugHashes.push([
                firstHash,
                window.location.hash,
                ""
            ]);
            initialHash = this.decodeHash(initialHash, /old_hash=/);
            hasOldHash = true;
        } // Pull the tenant and path off of the hash so that tenant can be
        // added back later. This allows us to keep tenant in certain scenarios.
        const { path: path, tenant: tenant } = (0, $jVeiz.getTenantAndPath)((0, $jVeiz.hashToPath)({
            hash: initialHash,
            removePrecedingSlash: /^#\/(?!@)/.test(initialHash)
        }));
        const params = (0, $hCG2Z.getQueryParams)(path.replace(/^\//, ""));
        this.redirectTenant = tenant;
        if ("old_hash" in params) {
            initialHash = decodeURIComponent(params.old_hash); // Remove any extra old_hash's leaving only the rightmost (oldest) value
            initialHash = initialHash.replace(/.*old_hash=#/, ""); // If tenant was in the URL, make sure it stays unless hash already
            // has it since old_hash was from a previous session.
            if (tenant && !initialHash.includes("/@")) initialHash = `#/@${tenant}${initialHash.substring(1)}`;
            this.metrics.info("Login.old_hash", {
                hash: initialHash
            });
            hasOldHash = true;
        }
        if (hasOldHash) {
            this.debugHashes.push([
                firstHash,
                window.location.hash,
                initialHash
            ]);
            $bzq4v.history.replace((0, $jVeiz.hashToPath)({
                hash: initialHash
            }));
        } // Clean token from URL if it exists
        const cleanedHash = (0, $hCG2Z.cleanTokenFromHash)(window.location.hash);
        if (cleanedHash) {
            this.metrics.warn("Access token found in window hash");
            $bzq4v.history.replace((0, $jVeiz.hashToPath)({
                hash: cleanedHash
            }));
        }
        const { search: search } = location;
        if (search.includes("redirectLocation=")) {
            const urlPath = (0, $jVeiz.removeQueryParamsFromPath)(`${location.pathname}${search}${location.hash}`, [
                "redirectLocation"
            ]); // We need to use window.history and not history here because we are cleaning
            // a query parameter, not the hash.
            window.history.replaceState({}, undefined, urlPath);
        } // User is likely offline. With a service worker, Unified Shell can still
        // start loading even if there is no internet connection.
        navigator.onLine || this.verifyNetworkState();
        this.initAuth();
        this.state = {
            auth: null,
            defaultComponent: $3745b6545f08e8df$var$waitComponent,
            error: null,
            loading: true,
            locale: locale,
            ...this.authState
        };
    }
    /**
   * Verify that the user is indeed offline and show a message in that case.
   */ async verifyNetworkState() {
        const setOffline = ()=>this.setState({
                error: $fi30R.ErrorTypes.OFFLINE
            });
        try {
            this.metrics.warn("Browser online state is false, verifying");
            const { verifyBrowserIsOffline: verifyBrowserIsOffline } = await Promise.resolve().then(function() {
                return (parcelRequire("58zmb"));
            }).then((res)=>$3745b6545f08e8df$var$_interopRequireWildcard(res));
            if (await verifyBrowserIsOffline()) setOffline();
        } catch (error) {
            this.metrics.error("Failed to verify network state", {
                error: error.toString()
            }); // Failed to dynamically import - This can happen if the user is offline
            // and the offline verification script is not yet cached, assume offline.
            setOffline();
        }
        window.addEventListener("online", ()=>(0, $lRoWp.reload)({
                initiator: "Online Check",
                reason: "Back Online"
            }));
    }
    async initAuth() {
        const listeners = {
            "auth.accesstokenexpired": async ()=>{
                this.metrics.event("Auth.userToken.fail", "Access token expired, logged out", {
                    level: $3745b6545f08e8df$var$_metrics.Level.WARN
                });
                this.state.auth && await this.state.auth.signOut();
            },
            "auth.apiFailure": ()=>{
                this.metrics.event("Auth.apiFailure", "API for getting user profile failed. Showing message to user.", {
                    level: $3745b6545f08e8df$var$_metrics.Level.WARN
                });
                this.setState({
                    error: $fi30R.ErrorTypes.UNKNOWN
                });
            },
            "auth.initializeError": ()=>{
                // If there is an error during initialization, adobeIMS does an internal redirect
                // to the login page therefore we don't need to handle it ourselves.
                this.metrics.event("Auth.initializeError", "IMS Token check call aborted. Showing login page to user.", {
                    level: $3745b6545f08e8df$var$_metrics.Level.ERROR
                });
            },
            "auth.rateLimited": ()=>{
                this.metrics.event("Auth.rateLimited", "IMS is rate limited. Showing message to user.", {
                    level: $3745b6545f08e8df$var$_metrics.Level.WARN
                });
                this.setState({
                    error: $fi30R.ErrorTypes.RATE_LIMIT
                });
            },
            "auth.validatetokenfailed": async (event)=>{
                if (!event || event.isExcClient) {
                    this.metrics.event("Auth.userToken.fail", "User token validation failed, logged out", {
                        level: $3745b6545f08e8df$var$_metrics.Level.WARN
                    });
                    await $3x6rS.Internal.flush();
                    this.state.auth && await this.state.auth.signOut();
                }
            }
        };
        const bootstrap = (0, $dDEjQ.getBootstrap)();
        const { config: config } = bootstrap;
        this.metrics.event("Auth.start", (0, $jVeiz.getCurrentTenantAndPath)());
        const { authState: authState, fromIMS: fromIMS, ...imsObjects } = bootstrap.authInformation || await bootstrap.getAuthInformation();
        const auth = (0, $lRoWp.AuthInstance)({
            accountClusterPromise: bootstrap.getAccountCluster(),
            env: config.environment,
            imsConfig: {
                ...config.ims
            },
            imsObjects: imsObjects,
            listeners: listeners
        });
        this.shellTimer.time("imslib.loaded");
        if (this.debugHashes.length) {
            this.debugHashes.forEach(([initialHash, currentHash, newHash])=>{
                this.metrics.debug("Index.old_hash", {
                    authState: authState,
                    fromIMS: fromIMS,
                    hash: currentHash,
                    href: window.location.href,
                    initialHash: initialHash,
                    newHash: newHash,
                    params: (0, $hCG2Z.getQueryParams)((0, $jVeiz.hashToPath)({
                        hash: currentHash,
                        removePrecedingSlash: true
                    }))
                });
            });
            this.debugHashes = [];
        }
        if (authState === $dDEjQ.AuthState.NO_AUTH) return auth.signIn(this.redirectUri, this.ssoDomain, {
            tenantId: this.redirectTenant
        });
         // If auth is available upfront, this code will execute before the initial state is created
        // in the class constructor. In that case "setState" should not be used and this.authState
        // will be used instead by the constructor.
        this.authState = {
            auth: auth,
            isLogin: authState === $dDEjQ.AuthState.LOGIN,
            loading: false
        };
        if (this.state) this.setState(this.authState);
    }
    decodeHash(hash, regex, attempts = 2) {
        if (regex.test(hash) || attempts === 0) return hash;
        return this.decodeHash(decodeURIComponent(hash), regex, attempts - 1);
    }
    /**
   * Move Shell back to a spinner ahead of a logout or reload.
   * Done in order to remove the active iframe and prevent navigation block.
   */ showSpinner() {
        return new Promise((resolve)=>this.setState({
                reloading: true
            }, resolve));
    }
    onLocale(locale) {
        if (locale && locale !== this.state.locale) this.setState({
            locale: locale
        });
    }
    render() {
        const { defaultComponent: defaultComponent, loading: loading, locale: locale, reloading: reloading } = this.state; // If loading or logging off, show spinner.
        const renderSpinner = reloading || loading; // If already loaded, track page.
        return /*#__PURE__*/ $3745b6545f08e8df$var$_react.default.createElement($gYPan.IntlProvider, {
            locale: locale,
            messages: $3745b6545f08e8df$var$coreLocaleData
        }, renderSpinner ? /*#__PURE__*/ $3745b6545f08e8df$var$_react.default.createElement($jxYT9.Provider, {
            colorScheme: "light",
            theme: $9QLmC.theme
        }, defaultComponent) : null, /*#__PURE__*/ $3745b6545f08e8df$var$_react.default.createElement($3745b6545f08e8df$var$_Core.default, {
            auth: this.state.auth,
            defaultComponent: defaultComponent,
            error: this.state.error,
            isLogin: this.state.isLogin,
            listedApps: this.props.listedApps,
            onLocale: (currentLocale)=>this.onLocale(currentLocale),
            shellTimer: this.shellTimer,
            showSpinner: ()=>this.showSpinner()
        }, this.props.children));
    }
}
module.exports.default = $3745b6545f08e8df$var$Main;

});
parcelRegister("jdphR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AppSelectorSandbox = void 0;

var $dfd2d8b64819a015$var$_context = $dfd2d8b64819a015$var$_interopRequireDefault((parcelRequire("fTzIe")));

var $jVeiz = parcelRequire("jVeiz");

var $hCG2Z = parcelRequire("hCG2Z");

var $dfd2d8b64819a015$var$_stringHash = $dfd2d8b64819a015$var$_interopRequireDefault((parcelRequire("h9eEw")));

var $dfd2d8b64819a015$var$_react = $dfd2d8b64819a015$var$_interopRequireWildcard((parcelRequire("7eprg")));

var $dfd2d8b64819a015$var$_Sandbox = $dfd2d8b64819a015$var$_interopRequireDefault((parcelRequire("hENHA")));

var $dfd2d8b64819a015$var$_SandboxSpinner = $dfd2d8b64819a015$var$_interopRequireDefault((parcelRequire("3ZVxL")));

var $2qT0f = parcelRequire("2qT0f");
function $dfd2d8b64819a015$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $dfd2d8b64819a015$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $dfd2d8b64819a015$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $dfd2d8b64819a015$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $dfd2d8b64819a015$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dfd2d8b64819a015$var$_extends() {
    $dfd2d8b64819a015$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dfd2d8b64819a015$var$_extends.apply(this, arguments);
}
/**
 * If there are two configs for a given route, Sandbox selector waits to recieve feature flags
 * to determine the correct sandbox to load.
 */ const $dfd2d8b64819a015$var$AppSelectorSandbox = (props)=>{
    const { config: config, params: params } = props;
    const { featureFlags: featureFlags } = (0, $dfd2d8b64819a015$var$_react.useContext)($dfd2d8b64819a015$var$_context.default);
    const [activeConfig, setActiveConfig] = (0, $dfd2d8b64819a015$var$_react.useState)(null);
    const [key, setKey] = (0, $dfd2d8b64819a015$var$_react.useState)("current");
    const processAltRoute = (_config, urlPath)=>{
        // Finds the first alternate route that matches in the array. If incorrect
        // matching is happening, check the order of the array to make sure it is
        // correctly ordered.
        const route = _config.alternateRoute.find((altRoute)=>{
            const { flag: flag, param: param, path: path, redirect: redirect, regex: regex, signalsInactive: signalsInactive } = altRoute;
            if (path) {
                // If there is a path but it does not match, this route is invalid.
                if (!path.test(urlPath)) return false;
                 // If there is a redirect property defined, do a regex replace with the
                // path and the redirect, so that additional values can be copied over
                // such as paths.
                if (redirect) altRoute.redirect = urlPath.replace(path, redirect);
            }
            const flagValue = featureFlags?.[flag];
            const flagEnabled = regex && flagValue ? new RegExp(flagValue).test(urlPath) : flagValue === "true";
            const flagOrParam = flagEnabled || !!(param && (0, $hCG2Z.getQueryParams)()[param]);
            return signalsInactive ? !flagOrParam : flagOrParam;
        });
        if (!route) return setActiveConfig(_config);
        if (route.redirect) return (0, $2qT0f.updatePath)({
            path: route.redirect
        }, true);
         // The current key needs to be updated to be an alternative version, as the
        // remainder of this function both have the alternative matching.
        setKey(`alt-${(0, $dfd2d8b64819a015$var$_stringHash.default)(JSON.stringify(route))}`); // If the newly matched config has an alternateRoute defined, process that
        // now too. Recursion!!!
        if (route.config.alternateRoute) return processAltRoute(route.config, urlPath);
        setActiveConfig(route.config);
    };
    (0, $dfd2d8b64819a015$var$_react.useEffect)(()=>{
        // Ignore feature flag changes if they are undefined, empty.
        if (!featureFlags) return;
        const { path: path } = (0, $jVeiz.getTenantAndPath)((0, $jVeiz.getPathWithoutContext)(window.location.hash.replace(/^#/, "")));
        processAltRoute(config, path);
    }, [
        JSON.stringify(params),
        JSON.stringify(featureFlags)
    ]);
    return activeConfig ? /*#__PURE__*/ $dfd2d8b64819a015$var$_react.default.createElement($dfd2d8b64819a015$var$_Sandbox.default, $dfd2d8b64819a015$var$_extends({}, props, {
        config: activeConfig,
        isAlternateRoute: key.startsWith("alt"),
        key: key
    })) : /*#__PURE__*/ $dfd2d8b64819a015$var$_react.default.createElement("div", {
        className: "exc-core-sandbox-common"
    }, /*#__PURE__*/ $dfd2d8b64819a015$var$_react.default.createElement($dfd2d8b64819a015$var$_SandboxSpinner.default, null));
};
module.exports.AppSelectorSandbox = $dfd2d8b64819a015$var$AppSelectorSandbox;

});
parcelRegister("fTzIe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52fe35e33c7e7fbc$var$_react = $52fe35e33c7e7fbc$var$_interopRequireDefault((parcelRequire("7eprg")));
function $52fe35e33c7e7fbc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ var $52fe35e33c7e7fbc$var$_default = /*#__PURE__*/ $52fe35e33c7e7fbc$var$_react.default.createContext({
    appContainer: "",
    environment: "",
    imsOrg: "",
    imsOrgName: "",
    locale: "",
    shellHeight: 49,
    shellSideNavWidth: 0,
    tenant: ""
});
module.exports.default = $52fe35e33c7e7fbc$var$_default;

});

parcelRegister("jVeiz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "getCurrentTenantAndPath", {
    enumerable: true,
    get: function() {
        return $hCG2Z.getCurrentTenantAndPath;
    }
});
Object.defineProperty(module.exports, "getTenantAndPath", {
    enumerable: true,
    get: function() {
        return $hCG2Z.getTenantAndPath;
    }
});
Object.defineProperty(module.exports, "hashToPath", {
    enumerable: true,
    get: function() {
        return $hCG2Z.hashToPath;
    }
});
module.exports.addParamToUrl = module.exports.getPaths = module.exports.splitPath = module.exports.isExperienceOrigin = module.exports.hasChanges = module.exports.getUpdatedPath = module.exports.getFullUrl = module.exports.getUnifiedShellUrl = module.exports.getUnifiedShellPath = module.exports.getValueFromPath = module.exports.getTenantFromPath = module.exports.getContextFromPath = module.exports.encodeForRedirect = module.exports.addIframeSrcParams = module.exports.getPathPrefix = module.exports.getPathWithoutContext = module.exports.getPathWithoutTenant = module.exports.cleanQuery = module.exports.filterSearchParams = module.exports.removeQueryParamsFromPath = module.exports.cleanQueryParams = module.exports.denyBrowserParams = module.exports.addQueryParam = void 0;

var $iNslS = parcelRequire("iNslS");

var $hCG2Z = parcelRequire("hCG2Z");

var $9B59M = parcelRequire("9B59M");
var $e80e6e9220d0b780$var$__values = function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $e80e6e9220d0b780$var$__read = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $e80e6e9220d0b780$var$__spreadArray = function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /* eslint-disable sort-keys */ var $e80e6e9220d0b780$var$EXPERIENCE_ORIGINS = {
    dev: "https://localhost.corp.adobe.com:1234",
    qa: "https://experience-qa.adobe.com",
    stage: "https://experience-stage.adobe.com",
    prod: "https://experience.adobe.com"
};
/* eslint-enable sort-keys */ var $e80e6e9220d0b780$var$IFRAME_DENIED_PARAMS = new Set([
    "shell_customtoken",
    "shell_devmode",
    "shell_ims",
    "shell_source",
    "unified-shell_version"
]);
/**
 * Adds a query paramater.
 * @param params - `URL.searchParams` object to remove params from.
 * @param key - key to add.
 * @param value - value to add.
 * @param override - Override existing params (Defaults to false)
 */ var $e80e6e9220d0b780$var$addQueryParam = function(params, key, value, override) {
    if (override === void 0) override = false;
    if (!key || $e80e6e9220d0b780$var$IFRAME_DENIED_PARAMS.has(key) || params.has(key) && !override) return;
    (Array.isArray(value) ? value : [
        value
    ]).forEach(function(v) {
        return override ? params.set(key, v) : params.append(key, v);
    });
};
module.exports.addQueryParam = $e80e6e9220d0b780$var$addQueryParam;
var $e80e6e9220d0b780$var$denyBrowserParams = function(params) {
    return params.forEach($iNslS.BROWSER_FILTER_PARAMS.add, $iNslS.BROWSER_FILTER_PARAMS);
};
/**
 * Cleans the query params by removing any denied params that
 * exist in the browser URL's query or iframe URL's query. This is to remove
 * duplication of params and any unneeded params.
 * @param params - `URL.searchParams` object to remove params from.
 * @param filterParams additional params to filter (optional)
 */ module.exports.denyBrowserParams = $e80e6e9220d0b780$var$denyBrowserParams;
var $e80e6e9220d0b780$var$cleanQueryParams = function(params, filterParams) {
    var e_1, _a;
    var toDelete = [];
    try {
        for(var _b = $e80e6e9220d0b780$var$__values(params.keys()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            ($iNslS.BROWSER_FILTER_PARAMS.has(key) || $e80e6e9220d0b780$var$IFRAME_DENIED_PARAMS.has(key) || (filterParams === null || filterParams === void 0 ? void 0 : filterParams.has(key))) && toDelete.push(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    toDelete.push.apply(toDelete, $e80e6e9220d0b780$var$__spreadArray([], $e80e6e9220d0b780$var$__read(Object.keys((0, $9B59M.parse)(window.location.search.slice(1)))), false));
    toDelete.forEach(function(key) {
        return params.delete(key);
    });
};
/**
 * Removes unwanted query parameters from a given path.
 * @param path - Path
 * @param params - Query parameters to remove
 * @returns - Path with parameters removed.
 */ module.exports.cleanQueryParams = $e80e6e9220d0b780$var$cleanQueryParams;
var $e80e6e9220d0b780$var$removeQueryParamsFromPath = function(path, params) {
    var url = new URL("".concat(window.location.origin).concat(path));
    params.forEach(function(param) {
        return url.searchParams.delete(param);
    });
    return "".concat(url.pathname).concat(url.search).concat(url.hash);
};
/**
 * Filter query parameters
 * @param {URLSearchParams} params - Parameters
 * @param paramsToKeep - Parameters to keep
 * @returns Search string including only those marked to keep.
 */ module.exports.removeQueryParamsFromPath = $e80e6e9220d0b780$var$removeQueryParamsFromPath;
var $e80e6e9220d0b780$var$filterSearchParams = function(params, paramsToKeep) {
    var keepSet = new Set(paramsToKeep);
    var searchParams = new URLSearchParams();
    params.forEach(function(value, name) {
        return keepSet.has(name) && searchParams.set(name, value);
    });
    var search = searchParams.toString();
    return search ? "?".concat(search) : "";
};
/**
 * Removes empty query parameters
 * @param query - The query object.
 * @returns Cleaned query object.
 */ module.exports.filterSearchParams = $e80e6e9220d0b780$var$filterSearchParams;
var $e80e6e9220d0b780$var$cleanQuery = function(query) {
    for(var key in query)if (key === "") delete query[key];
    return query;
};
/**
 * Get URL pathname without tenant or sandbox.
 * @param path - Full URL pathname.
 * @returns Pathname without tenant or sandbox.
 */ module.exports.cleanQuery = $e80e6e9220d0b780$var$cleanQuery;
var $e80e6e9220d0b780$var$getPathWithoutTenant = function(path) {
    return path.replace(/^\/@[^/]*/, "").replace(/^((\/[^/]+:))[^/]*/, "");
};
/**
 * Get URL pathname without sandbox, suborg, or other context value.
 * @param path - Full URL pathname.
 * @returns Pathname without context value, e.g. /@tenant/sname:sandbox/abc -> /@tenant/abc
 */ module.exports.getPathWithoutTenant = $e80e6e9220d0b780$var$getPathWithoutTenant;
var $e80e6e9220d0b780$var$getPathWithoutContext = function(path) {
    var contextMatch = path.match(/^(?:\/@[^/]+)?(\/[^/]+:[^/]+)/) || [];
    return contextMatch.length ? path.replace(contextMatch[1], "") : path;
};
/**
 * Get URL pathname without tenant, context, or subpaths.
 * @param path - Full URL pathname.
 * @returns Pathname without context value, tenant, or subpaths. e.g. /@tenant/sname:sandbox/abc -> abc
 */ module.exports.getPathWithoutContext = $e80e6e9220d0b780$var$getPathWithoutContext;
var $e80e6e9220d0b780$var$getPathPrefix = function(path) {
    if (path === void 0) path = "";
    var cleaned = $e80e6e9220d0b780$var$getPathWithoutTenant($e80e6e9220d0b780$var$getPathWithoutContext(path));
    var matchGroup = cleaned.replace(/^\//, "").match(/^([^/]*)/);
    return matchGroup && matchGroup[1];
};
/**
 * Adds necessary parameters to iframe source URL.
 * @param options - Function arguments.
 * @param [options.addToQuery] - Should add shell query params to iframe (Default: true)
 * @param [options.overrideParams] - When addToQuery is set, should shell query params override iframe params (Default: false)
 * @param [options.runtimeParam] - Runtime script URL/param.
 * @param [options.spaApps] - SPA config for pipeline apps (optional)
 * @param [options.src] - Iframe source url.
 */ module.exports.getPathPrefix = $e80e6e9220d0b780$var$getPathPrefix;
var $e80e6e9220d0b780$var$addIframeSrcParams = function(_a) {
    var _b = _a.addRuntimeParams, addRuntimeParams = _b === void 0 ? true : _b, _c = _a.addToQuery, addToQuery = _c === void 0 ? true : _c, appId = _a.appId, _d = _a.overrideParams, overrideParams = _d === void 0 ? false : _d, runtimeParam = _a.runtimeParam, spaApps = _a.spaApps, src = _a.src;
    var _e = window.location, hash = _e.hash, host = _e.host, origin = _e.origin;
    var srcParams = src.searchParams;
    if (addRuntimeParams) {
        $e80e6e9220d0b780$var$addQueryParam(srcParams, "_mr", runtimeParam, true);
        $e80e6e9220d0b780$var$addQueryParam(srcParams, "shell_domain", host, true);
    }
    appId && $e80e6e9220d0b780$var$addQueryParam(srcParams, "appId", appId, true); // Pass all non-config query params through to the iframe.
    var url = new URL("".concat(origin).concat(hash.slice(1)));
    var queryParams = (0, $hCG2Z.getQueryParams)();
    if (addToQuery) {
        var hashQueryParams_1 = (0, $hCG2Z.getQueryParams)(url.search.slice(1));
        Object.keys(queryParams).forEach(function(key) {
            return $e80e6e9220d0b780$var$addQueryParam(srcParams, key, queryParams[key], overrideParams);
        });
        Object.keys(hashQueryParams_1).forEach(function(key) {
            return $e80e6e9220d0b780$var$addQueryParam(srcParams, key, hashQueryParams_1[key], overrideParams);
        });
    } // Add SPA version if the argument is provided.
    if (spaApps === null || spaApps === void 0 ? void 0 : spaApps.length) spaApps.forEach(function(spa) {
        if (spa === null || spa === void 0 ? void 0 : spa.spaName) {
            var liveVersion = spa.liveVersion, spaName = spa.spaName;
            var param = "".concat(spaName, "_version");
            var version = queryParams[param] || liveVersion;
            version && $e80e6e9220d0b780$var$addQueryParam(srcParams, param, version, true);
        }
    });
};
/**
 * Encodes the current URL so it can be properly passed to IMS.
 * @param tenant - Whether or not to keep the tenant in the URL.
 * @returns URL with encoded hash.
 */ module.exports.addIframeSrcParams = $e80e6e9220d0b780$var$addIframeSrcParams;
var $e80e6e9220d0b780$var$encodeForRedirect = function(tenant) {
    if (tenant === void 0) tenant = true;
    var _a = window.location, hash = _a.hash, origin = _a.origin, pathname = _a.pathname, _b = _a.search, search = _b === void 0 ? "" : _b;
    var oldHash = hash.replace(/^#/, "");
    tenant || (oldHash = $e80e6e9220d0b780$var$getPathWithoutTenant(oldHash));
    return "".concat(origin).concat(pathname).concat(search, "#old_hash=").concat(encodeURIComponent("#".concat(oldHash)));
};
/**
 * Get the context from the path.
 * @param path - Full URL pathname.
 * @returns context.
 */ module.exports.encodeForRedirect = $e80e6e9220d0b780$var$encodeForRedirect;
var $e80e6e9220d0b780$var$getContextFromPath = function(path) {
    return (path.match(/^(?:\/@[^/]+)?(\/[^/]+:[^/]+)/) || [])[1];
};
/**
 * Get tenant from path.
 * @param path - Full URL pathname.
 * @param name - Get tenant name only (Without @)
 * @returns Tenant (if none exist, return ''.
 * If none exist and the name was requested, return undefined).
 */ module.exports.getContextFromPath = $e80e6e9220d0b780$var$getContextFromPath;
var $e80e6e9220d0b780$var$getTenantFromPath = function(path, name) {
    if (name === void 0) name = false;
    return /^#?((?:\/@([^/]+))?)/.exec(path)[name ? 2 : 1];
};
/**
 * Get sandbox from path.
 * @param path - Full URL pathname.
 * @param param - context parameter to search for.
 * @returns Sandbox Name (if none exist, return undefined)
 */ module.exports.getTenantFromPath = $e80e6e9220d0b780$var$getTenantFromPath;
var $e80e6e9220d0b780$var$getValueFromPath = function(path, param) {
    return new RegExp("^#?(?:/@[^/]+)?(/".concat(param, ":([^/]+))?")).exec(path)[2];
};
/**
 * Determines if link is a unified shell path .
 * @param url Href of application
 * @param env Current environment.
 */ module.exports.getValueFromPath = $e80e6e9220d0b780$var$getValueFromPath;
var $e80e6e9220d0b780$var$getUnifiedShellPath = function(env, url) {
    if (url === void 0) url = "";
    var matches = env === "dev" ? url.match(/localhost\.corp\.adobe\.com:\d{4}(\/#)?(\/.*)/) : url.match(/experience(?:|-qa|-stage)\.adobe\.com(\/#)?(\/.*)/);
    return matches && $e80e6e9220d0b780$var$getPathWithoutTenant(matches[2]);
};
module.exports.getUnifiedShellPath = $e80e6e9220d0b780$var$getUnifiedShellPath;
var $e80e6e9220d0b780$var$getUnifiedShellUrl = function(env, path) {
    if (path === void 0) path = "";
    var origin = $e80e6e9220d0b780$var$EXPERIENCE_ORIGINS[env];
    var _a = window.location, hash = _a.hash, search = _a.search;
    var tenant = $e80e6e9220d0b780$var$getTenantFromPath(hash);
    return "".concat(origin, "/").concat(search || "", "#").concat(tenant).concat(path);
};
/**
 * Returns the full Unified Shell url with the workspace or nav item `path`
 * appended to the end. Meaning, a path of `/analytics/some/deep/path` would
 * become https://experience.adobe.com/#/@tenant/analytics/some/deep/path.
 * @param path Relative url of workspace or nav item.
 * @returns Full Unified Shell url with workspace or nav item path.
 */ module.exports.getUnifiedShellUrl = $e80e6e9220d0b780$var$getUnifiedShellUrl;
var $e80e6e9220d0b780$var$getFullUrl = function(path) {
    if (/^https?:/.test(path)) return path;
    var _a = window.location, hash = _a.hash, origin = _a.origin, search = _a.search;
    var tenant = $e80e6e9220d0b780$var$getTenantFromPath(hash);
    return "".concat(origin, "/").concat(search || "", "#").concat(tenant).concat(path);
};
/**
 * Get URL pathname with tenant.
 * @param pathname - Old URL pathname with tenant.
 * @param  path - New path to be used, has no tenant.
 * @param hideTenant - Whether or not to keep tenant in URL.
 * @returns New path updated with or without tenant.
 */ module.exports.getFullUrl = $e80e6e9220d0b780$var$getFullUrl;
var $e80e6e9220d0b780$var$getUpdatedPath = function(pathname, path, hideTenant) {
    if (hideTenant === void 0) hideTenant = false;
    if (!hideTenant) // Adds tenantId from old pathname to path
    path = pathname.replace(/^(\/?@[^/]*)\/.*/, "$1".concat(path));
    return path.startsWith("/") ? path : "/".concat(path);
};
/**
 * Compares two paths. This is especially useful because it sorts
 * the search params prior to the comparison since the order in the URL doesn't
 * matter but a string compare will fail.
 * @param path1 - First path to compare.
 * @param path2 - Second path to compare.
 * @returns Specific sections that have or have not changed.
 */ module.exports.getUpdatedPath = $e80e6e9220d0b780$var$getUpdatedPath;
var $e80e6e9220d0b780$var$hasChanges = function(path1, path2) {
    var url1 = new URL("".concat(window.location.origin).concat(path1));
    var url2 = new URL("".concat(window.location.origin).concat(path2));
    url1.searchParams.sort();
    url2.searchParams.sort();
    var res = {
        hash: url1.hash !== url2.hash,
        pathname: url1.pathname !== url2.pathname,
        search: url1.search !== url2.search
    };
    return Object.assign(res, {
        any: res.hash || res.pathname || res.search
    });
};
module.exports.hasChanges = $e80e6e9220d0b780$var$hasChanges;
var $e80e6e9220d0b780$var$isExperienceOrigin = function(url) {
    var origin = url ? new URL(url).origin : window.location.origin;
    return /experience(|-qa|-stage)\.adobe\.com/.test(origin);
};
/**
 * Splits a path with the separator. This returns everything after
 * the first separator and ensures that it starts with a `/` if it did at the
 * beginning.
 * @param path - The path to split.
 * @param separator - The character or string to split on.
 * @returns The remains of the path after the `separator`.
 */ module.exports.isExperienceOrigin = $e80e6e9220d0b780$var$isExperienceOrigin;
var $e80e6e9220d0b780$var$splitPath = function(path, separator) {
    var idx = path.indexOf(separator);
    var res = idx > -1 ? path.slice(idx + separator.length) : path;
    return res.startsWith("/") ? res : "/".concat(res);
};
/**
 * Get browser and iframe pathnames and search strings.
 * @param iframePath - Pathname of iframe.
 * @param iframeSearch - Search from iframe.
 * @param iframeHash - Hash from iframe.
 * @param absolutePaths - Whether or not the solution uses absolute paths.
 * @param basePath - Solution basePath.
 * @param configURL - config URL.
 * @returns Browser and iFrame path and search strings.
 */ module.exports.splitPath = $e80e6e9220d0b780$var$splitPath;
var $e80e6e9220d0b780$var$getPaths = function(iframePath, iframeSearch, iframeHash, absolutePaths, basePath, configURL) {
    var _a = window.location, hash = _a.hash, origin = _a.origin;
    var browser = new URL("".concat(origin).concat(hash.slice(1)));
    var iframe = new URL("".concat(origin).concat(iframePath).concat(iframeSearch).concat(iframeHash)); // Update the pathname to be the actual path of the solution. For example,
    // changing /@tenant/analytics/path/subpath => /path/subpath. This tells us
    // where the browser is currently pointed.
    browser.pathname = $e80e6e9220d0b780$var$splitPath(browser.pathname, basePath); // Update the pathname to be the actual path of the iframe. For example,
    // changing https://analytics.com/root/path/subpath => /path/subpath where
    // https://analytics.com/root is the configURL that was initially loaded.
    // This tells us where the iframe is currently pointed.
    if (!absolutePaths) iframe.pathname = $e80e6e9220d0b780$var$splitPath(iframe.pathname, configURL.pathname);
     // Clean up the query params so that they can be compared apples to apples.
    // Specifically removing _mr and other browser query params (e.g. shell
    // version or dev mode)
    $e80e6e9220d0b780$var$cleanQueryParams(browser.searchParams);
    $e80e6e9220d0b780$var$cleanQueryParams(iframe.searchParams);
    return {
        browser: {
            hash: browser.hash,
            path: browser.pathname,
            search: browser.search
        },
        iframe: {
            hash: iframe.hash,
            path: iframe.pathname,
            search: iframe.search
        }
    };
};
/**
 * Adds a search param to a URL.
 * @param url - URL.
 * @param name - Parameter name.
 * @param value - Parameter value.
 * @returns URL - URL with parameter added.
 */ module.exports.getPaths = $e80e6e9220d0b780$var$getPaths;
var $e80e6e9220d0b780$var$addParamToUrl = function(url, name, value) {
    var inputUrl = new URL(url);
    inputUrl.searchParams.set(name, value);
    return inputUrl.toString();
};
module.exports.addParamToUrl = $e80e6e9220d0b780$var$addParamToUrl;

});

parcelRegister("h9eEw", function(module, exports) {
"use strict";
function $c7bea4a48e1c28a2$var$hash(str) {
    var hash = 5381, i = str.length;
    while(i)hash = hash * 33 ^ str.charCodeAt(--i);
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return hash >>> 0;
}
module.exports = $c7bea4a48e1c28a2$var$hash;

});

parcelRegister("hENHA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jVeiz = parcelRequire("jVeiz");

var $cCPTR = parcelRequire("cCPTR");

var $fi30R = parcelRequire("fi30R");

var $fb1b6abce2533cf7$var$_AppLoadState = $fb1b6abce2533cf7$var$_interopRequireDefault((parcelRequire("fe7SK")));

var $fb1b6abce2533cf7$var$_classnames = $fb1b6abce2533cf7$var$_interopRequireDefault((parcelRequire("g3elz")));

var $fb1b6abce2533cf7$var$_context = $fb1b6abce2533cf7$var$_interopRequireDefault((parcelRequire("fTzIe")));

var $fb1b6abce2533cf7$var$_CoreStrings = $fb1b6abce2533cf7$var$_interopRequireDefault((parcelRequire("jEU9n")));

var $iNslS = parcelRequire("iNslS");

var $loe8n = parcelRequire("loe8n");

var $3Zpnv = parcelRequire("3Zpnv");

var $bzq4v = parcelRequire("bzq4v");

var $ctGaZ = parcelRequire("ctGaZ");

var $fb1b6abce2533cf7$var$_Iframe = $fb1b6abce2533cf7$var$_interopRequireDefault((parcelRequire("kCZQ1")));

var $9OLey = parcelRequire("9OLey");

var $c0cwc = parcelRequire("c0cwc");

var $8DaMC = parcelRequire("8DaMC");

var $fb1b6abce2533cf7$var$_metrics = $fb1b6abce2533cf7$var$_interopRequireWildcard((parcelRequire("17AVh")));

var $fb1b6abce2533cf7$var$_OrchestrationService = $fb1b6abce2533cf7$var$_interopRequireDefault((parcelRequire("gah5j")));

var $fb1b6abce2533cf7$var$_react = $fb1b6abce2533cf7$var$_interopRequireDefault((parcelRequire("7eprg")));

var $fb1b6abce2533cf7$var$_SandboxSpinner = $fb1b6abce2533cf7$var$_interopRequireDefault((parcelRequire("3ZVxL")));

var $c3nD4 = parcelRequire("c3nD4");

var $fb1b6abce2533cf7$var$_TitleService = $fb1b6abce2533cf7$var$_interopRequireDefault((parcelRequire("1pABw")));
function $fb1b6abce2533cf7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fb1b6abce2533cf7$var$_extends() {
    $fb1b6abce2533cf7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fb1b6abce2533cf7$var$_extends.apply(this, arguments);
}
function $fb1b6abce2533cf7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fb1b6abce2533cf7$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $fb1b6abce2533cf7$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $fb1b6abce2533cf7$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $fb1b6abce2533cf7$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

const $fb1b6abce2533cf7$var$ErrorView = /*#__PURE__*/ $fb1b6abce2533cf7$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("eFujB"));
    }).then((res)=>$fb1b6abce2533cf7$var$_interopRequireWildcard(res)));


class $fb1b6abce2533cf7$var$Sandbox extends $fb1b6abce2533cf7$var$_react.default.Component {
    // eslint-disable-next-line react/static-property-placement
    constructor(props, context){
        super(props);
        $fb1b6abce2533cf7$var$_defineProperty(this, "_discoveryTime", 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "appDone", false);
        $fb1b6abce2533cf7$var$_defineProperty(this, "currentSection", "");
        $fb1b6abce2533cf7$var$_defineProperty(this, "invalidSource", "");
        $fb1b6abce2533cf7$var$_defineProperty(this, "blockedUri", "");
        $fb1b6abce2533cf7$var$_defineProperty(this, "messageService", new $8DaMC.MessageService());
        $fb1b6abce2533cf7$var$_defineProperty(this, "monitorService", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "monitorServicePromise", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "prevContext", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "prevSection", "");
        $fb1b6abce2533cf7$var$_defineProperty(this, "apiService", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "historyConfig", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "isComposedApp", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "sandboxId", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "sandboxStart", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "sandboxTimer", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "sections", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "userInputServicePromise", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "initialState", {});
        $fb1b6abce2533cf7$var$_defineProperty(this, "readyProperties", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "waitForContext", false);
        $fb1b6abce2533cf7$var$_defineProperty(this, "waitForDiscovery", false);
        $fb1b6abce2533cf7$var$_defineProperty(this, "waitForReady", false);
        $fb1b6abce2533cf7$var$_defineProperty(this, "basePath", "");
        $fb1b6abce2533cf7$var$_defineProperty(this, "configURL", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "connected", false);
        $fb1b6abce2533cf7$var$_defineProperty(this, "context", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "customIms", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "frame", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "initialized", false);
        $fb1b6abce2533cf7$var$_defineProperty(this, "lastAppId", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "metricsAppId", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "mounted", true);
        $fb1b6abce2533cf7$var$_defineProperty(this, "origin", "");
        $fb1b6abce2533cf7$var$_defineProperty(this, "appId", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "historyType", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "metrics", $fb1b6abce2533cf7$var$_metrics.default.create("exc.core.modules.Sandbox"));
        $fb1b6abce2533cf7$var$_defineProperty(this, "titleService", void 0);
        $fb1b6abce2533cf7$var$_defineProperty(this, "waitForRuntime", false);
        $fb1b6abce2533cf7$var$_defineProperty(this, "inErrorState", ()=>!!this.state.error);
        $fb1b6abce2533cf7$var$_defineProperty(this, "inNotFoundState", ()=>this.state.notFound);
        $fb1b6abce2533cf7$var$_defineProperty(this, "isSpinnerOn", ()=>{
            const { src: src, spinner: spinner } = this.state;
            return !src || this.context.htmlReady === $fi30R.HTMLStatus.PENDING || spinner;
        });
        $fb1b6abce2533cf7$var$_defineProperty(this, "getLoadState", ()=>{
            const { blockedUri: blockedUri, connected: connected, frame: frame, initialized: initialized, invalidSource: invalidSource, waitForContext: waitForContext, waitForDiscovery: waitForDiscovery, waitForReady: waitForReady, waitForRuntime: waitForRuntime } = this;
            return {
                blockedUri: blockedUri,
                connected: connected,
                hasFrame: !!frame,
                initialized: initialized,
                invalidSource: invalidSource,
                spinnerOn: this.isSpinnerOn(),
                waitForContext: waitForContext,
                waitForDiscovery: waitForDiscovery,
                waitForReady: waitForReady,
                waitForRuntime: waitForRuntime
            };
        });
        $fb1b6abce2533cf7$var$_defineProperty(this, "onMessage", (message)=>this.messageService.processMessage(message, this));
        $fb1b6abce2533cf7$var$_defineProperty(this, "onNotFound", ()=>this.setState({
                notFound: true
            }));
        $fb1b6abce2533cf7$var$_defineProperty(this, "onFrameReload", (cacheBust)=>{
            this.metrics.event("Sandbox.iframeReload", {
                cacheBust: cacheBust
            });
            cacheBust ? this.generateIframeSource(true) : this.setState({
                frameKey: this.state.frameKey + 1
            });
        });
        $fb1b6abce2533cf7$var$_defineProperty(this, "onCSPViolation", (blockedURI)=>{
            // This allows us to capture cases where the application redirects to the
            // IMS login page. IMS blocks these requests as it cannot be loaded in an
            // iframe. For Workfront now, maybe globally in the future, we want to
            // handle this and sign out the user to ensure they have a valid session on
            // all levels of applications.
            if (this.appId === "workfront" && blockedURI.indexOf("ims-na1.adobelogin.com") > 0) {
                this.context.onSignOut(true, "Iframe redirected to SUSI");
                return;
            }
            this.blockedUri = blockedURI;
        });
        $fb1b6abce2533cf7$var$_defineProperty(this, "handlePostMessage", (type, value)=>this.apiService.handleMessage(type, value, this));
        this.context = context;
        this.apiService = new $cCPTR.APIService(this.messageService);
        this.userInputServicePromise = Promise.resolve().then(function() {
            return (parcelRequire("7rHmB"));
        }).then((res)=>$fb1b6abce2533cf7$var$_interopRequireWildcard(res)).then(({ UserInputService: UserInputService })=>new UserInputService(this.messageService, this));
        const { appId: appId, metricsAppId: metricsAppId = appId, sandbox: { hideInitialSpinner: hideInitialSpinner, history: historyConfig, ims: ims }, sections: sections, sideNav: sideNav } = props.config;
        const { workHubResponse: workHubResponse } = context;
        const { config: config } = typeof historyConfig === "object" ? historyConfig : {}; // Create the title service for managing titles for this current application.
        this.titleService = new $fb1b6abce2533cf7$var$_TitleService.default(props.config, undefined, workHubResponse);
        this.customIms = ims;
        this.appId = appId;
        this.isComposedApp = !!sideNav?.workHubId;
        this.metricsAppId = metricsAppId;
        (0, $loe8n.initSandbox)(this);
        this.sections = sections; // If the user switched from app A to app B, and app A did not call "page.done",
        // we want to turn firstRender off so we don't log performance metrics for app B.
        const { lastAppId: lastAppId, sandboxId: sandboxId } = $fb1b6abce2533cf7$var$_AppLoadState.default.onSandboxLoad(appId);
        this.lastAppId = lastAppId;
        this.sandboxId = sandboxId; // On app switch, we time the load from the Sandbox constructor since Unified Shell
        // is already loaded.
        this.lastAppId && (this.sandboxStart = performance.now());
        this.historyConfig = config || {};
        this.historyType = (0, $3Zpnv.getHistoryType)(props.config);
        this.onMessage = this.onMessage.bind(this);
        this.onMount = this.onMount.bind(this);
        this.sandboxTimer = this.metrics.start("Sandbox", {
            applicationId: this.metricsAppId
        });
        this.generateIframeSource();
        this.state = {
            frameKey: 0,
            main: false,
            noSource: false,
            notFound: false,
            showWaitMessage: false,
            spinner: !hideInitialSpinner,
            ...this.initialState
        };
    }
    get solutionConfig() {
        return this.props.config;
    }
    get source() {
        return this.state.src;
    }
    set customFeedback(feedback) {
        this.userInputServicePromise.then((userInputService)=>userInputService.customFeedback = feedback);
    }
    setSpinner(show) {
        this.metrics.event(show ? $fb1b6abce2533cf7$var$_metrics.Events.SPINNER_START : $fb1b6abce2533cf7$var$_metrics.Events.SPINNER_DONE);
        show ? this.setState({
            spinner: true
        }) : this.setState({
            showWaitMessage: false,
            spinner: false
        });
    }
    async setPageTimeout() {
        if (this.props.config.sandbox.pageTimeout === 0) {
            // PageTimeout set to 0 means there is no page timeout so we don't need
            // to bother setting up the monitor service
            this.metrics.event("Sandbox.noTimeout", {
                level: $fb1b6abce2533cf7$var$_metrics.Level.INFO
            });
            return;
        }
        const start = Date.now();
        const needTimeout = ()=>(!this.initialized || this.isSpinnerOn()) && (0, $loe8n.isAppHealthy)(this);
        if (!this.monitorServicePromise) {
            // Wait 5 seconds before loading the monitor JS - We might not need it at all.
            // We'll deduct the 5 seconds + JS load time later by using 'start' above.
            await (0, $iNslS.wait)(5000);
            if (!needTimeout()) // No need anymore for a timeout, return.
            return;
             // 5 seconds passed, load the service if not loaded already.
            this.monitorServicePromise || (this.monitorServicePromise = Promise.resolve().then(function() {
                return (parcelRequire("fruYL"));
            }).then((res)=>$fb1b6abce2533cf7$var$_interopRequireWildcard(res)).then(({ AppMonitorService: AppMonitorService })=>{
                this.monitorService = new AppMonitorService(this);
                this.monitorService.on($fi30R.AppEvents.SLOW, ()=>this.setState({
                        showWaitMessage: true
                    }));
                this.monitorService.on($fi30R.AppEvents.TIMEOUT, ({ error: error, errorCode: errorCode })=>this.setState({
                        error: error,
                        errorCode: errorCode
                    }));
            }));
        }
        await this.monitorServicePromise;
        needTimeout() && this.monitorService?.setPageTimeout(this, start);
    }
    /**
   * Set state if component is mounted, otherwise set initial state.
   * Initial state will be applied to state by the constructor.
   * @param state
   * @private
   */ safeSetState(state) {
        if (this.state) return this.setState(state);
        this.initialState = {
            ...this.initialState,
            ...state
        };
    }
    updateSource(src, useRootPath = false) {
        // If we don't have a legit source, send diagnostic info to EIM.
        (!src || !src.toString().startsWith("http")) && this.metrics.event("Sandbox.invalidSource", {
            level: $fb1b6abce2533cf7$var$_metrics.Level.ERROR
        }, {
            appId: this.metricsAppId,
            nonSupportedBrowser: this.context.nonSupportedBrowser,
            src: src
        });
        $fb1b6abce2533cf7$var$_OrchestrationService.default.onStartLoad(); // Future improvement: Set Not Found or Error state if can't get a source.
        // This should be done in ticket EXC-14593 after we verify there is no
        // legit reason for source to be empty here.
        if (useRootPath) src.pathname = "/";
        return this.safeSetState({
            src: src
        });
    }
    async generateIframeSource(forceReload = false, useRootPath = false) {
        const { addParamsToHash: addParamsToHash } = this.historyConfig;
        const { mfeAppIds: mfeAppIds, sandbox: { overrideParams: overrideParams = false }, spaAppId: spaAppId } = this.props.config;
        const isHashType = this.historyType === $ctGaZ.HISTORY.HASH;
        const src = (0, $loe8n.getApplicationSourceUrl)(this);
        if (!src) {
            this.safeSetState({
                noSource: true,
                notFound: true
            });
            return;
        } // Waiting for IMS to return in the case of a discovery URL.
        // In the case of a regular source, let's proceed!
        this.waitForContext = (0, $loe8n.shouldWaitForContextUpdates)(this, src);
        if (this.waitForContext) return;
        this.basePath = (0, $loe8n.getBasePath)(this);
        let discoveryHasUrl = false;
        const iframeTimer = this.metrics.start("IframeTimer");
        if (typeof src === "object") {
            const { discoveryService: discoveryService } = this.context; // Restart the timeout countdown for discovery
            this.setPageTimeout();
            this.waitForDiscovery = true;
            const result = await discoveryService.generateIframeSourceDiscovery(src, this);
            if ("src" in result) {
                const { customIms: customIms, hasUrl: hasUrl, src: srcUrl } = result;
                customIms && (this.customIms = customIms);
                discoveryHasUrl = hasUrl;
                this.configURL = srcUrl;
            } else {
                const { error: error, showErrorPage: showErrorPage } = result;
                showErrorPage && this.safeSetState({
                    error: error,
                    noSource: true,
                    notFound: true
                });
                return;
            }
            this.waitForDiscovery = false;
            this.inErrorState() && this.safeSetState({
                error: undefined,
                noSource: false,
                notFound: false
            });
            this.setPageTimeout();
        } else this.configURL = new URL((0, $loe8n.updateTemplatedURL)(src, this, this.props.params));
        this.origin = this.configURL.origin;
        let spaApp; // Gets the spaApp and gets the liveVersion from the window config or an
        // enabled feature flag. If no liveVersion is available, don't use it.
        if (spaAppId) {
            const spaAppData = (0, $loe8n.getSpaAppConfig)(spaAppId, this);
            spaAppData.liveVersion !== undefined && (spaApp = spaAppData);
        }
        let spaApps = spaApp ? [
            spaApp
        ] : [];
        if (mfeAppIds?.length) spaApps = [
            ...spaApps,
            ...mfeAppIds.map((id)=>(0, $loe8n.getSpaAppConfig)(id, this))
        ];
         // SPA Pipeline apps should always get Runtime from the same domain as Shell.
        const runtimeParam = (0, $loe8n.getRuntimeParam)(this);
        const iframeSrc = new URL(this.configURL);
        const isThunderbird = iframeSrc.pathname.startsWith($c3nD4.THUNDERBIRD_SPA_ROOT);
        isThunderbird && $9OLey.Internal.preloadEngine();
        (0, $jVeiz.addIframeSrcParams)({
            addRuntimeParams: !isThunderbird,
            addToQuery: !discoveryHasUrl && !(isHashType && addParamsToHash),
            appId: iframeSrc.origin === window.origin ? this.appId : undefined,
            overrideParams: overrideParams,
            runtimeParam: runtimeParam,
            spaApps: spaApps,
            src: iframeSrc
        }); // Set the application in metrics
        (0, $loe8n.setMetricsApplication)(this.metricsAppId, this.props.config, spaApp); // If discovery was used and is not from the cache, we should have the
        // entire URL, so we can just set the src and stop. If the discovery
        // response didn't have the url (came from config), or if the discovery came
        // from cache, we need to pull all the path and query params from the
        // current URL so that it's on the correct page.
        if (discoveryHasUrl || useRootPath) {
            forceReload && iframeSrc.searchParams.set("shell_forceReload", Date.now().toString());
            if (discoveryHasUrl) {
                this._discoveryTime = iframeTimer.time("Loaded.Discovery.NotCache", {
                    url: src
                }); // Update the digital data for the current app.
                (0, $loe8n.updateDigitalData)(this);
            }
            return this.updateSource(iframeSrc, useRootPath);
        } // Update the digital data for the current app.
        (0, $loe8n.updateDigitalData)(this, spaApp?.liveVersion);
        const url = (0, $loe8n.updateSourceWithParams)(iframeSrc, forceReload, this);
        this.origin = url.origin;
        this._discoveryTime = iframeTimer.time("Loaded", {
            url: url
        });
        this.updateSource(url); // If app not yet initialized, start countdown again
        this.setPageTimeout();
    }
    componentWillUnmount() {
        this.userInputServicePromise.then((userInputService)=>userInputService.unmount());
        this.apiService.unmount(this);
        this.frame = undefined;
        this.mounted = false;
        this.monitorServicePromise?.then(()=>this.monitorService?.reset());
        $fb1b6abce2533cf7$var$_AppLoadState.default.unregisterSandbox(this.sandboxId);
    }
    componentDidMount() {
        this.monitorServicePromise || this.setPageTimeout();
    }
    componentDidUpdate(prevProps) {
        const getParam = (p)=>(Object.keys(p).length ? p[0] : "") || "";
        const { prevContext: prevContext, props: { hash: hash, params: params } } = this;
        const query = (0, $jVeiz.cleanQuery)(this.props.query);
        const nextParams = getParam(params);
        const prevParams = getParam(prevProps.params);
        const paramsTheSame = prevParams === nextParams && prevProps.params.contextParam === params.contextParam && JSON.stringify(prevProps.query) === JSON.stringify(query) && prevProps.hash === hash;
        this.prevContext = this.context;
        if (!paramsTheSame) {
            // This could possibly be moved into a different lifecycle method
            const { spinnerOnChange: spinnerOnChange } = this.historyConfig;
            if (this.historyType === $ctGaZ.HISTORY.SERVER && spinnerOnChange) this.setState({
                spinner: true
            });
            this.basePath = (0, $loe8n.getBasePath)(this);
            this.apiService.updateAppHistory(nextParams, this); // The path within the application is different, but the previous appId
            // and the current appId are the same. For Platform and AJO Platform,
            // remove the block navigation configuration.
            //
            // This is necessary because Platform is itself a monolith that contains
            // many applications within it. When an application changes, a new Sandbox
            // does not load because the main application does not change.
            const { appId: appId } = this.props.config;
            const { appId: prevAppId } = prevProps.config;
            if (prevAppId === appId && [
                "experiencePlatformUI",
                "cjm-platform"
            ].includes(appId) && prevParams.split("/")[1] !== nextParams.split("/")[1]) {
                this.titleService.update(undefined, true);
                this.apiService.unblockNavigation();
            }
        }
        this.apiService.resetOnNewConfig(prevProps, this) && this.generateIframeSource(); // On ready failed because the token wasn't available at the time. Trigger
        // it again now that the custom token is available. The readyProperties is
        // used to ensure that ready has been called already and is waiting for
        // the custom token to be available.
        if (this.customIms && !this.initialized && this.context.appToken && this.readyProperties && (0, $loe8n.hasConfigChanges)(prevContext, this.context, [
            "appToken"
        ])) this.onReady(this.readyProperties);
         // The path changed (& fired a history event in shouldComponentUpdate)
        // And Not Found was previously active.
        // We should hide Not Found since the page navigated and may not be needed now.
        !paramsTheSame && this.state.notFound && !this.state.noSource && this.setState({
            notFound: false
        });
        const shouldWaitForContext = (0, $loe8n.shouldWaitForContextUpdates)(this);
        shouldWaitForContext || this.apiService.processEventQueue(this); // Should always update the hero portion of the title if this is the first
        // load (no prevContext) or there are changes to the hero.
        if (!prevContext || (0, $loe8n.hasConfigChanges)(prevContext, this.context, [
            "hero"
        ])) this.titleService.hero = this.context.hero;
         // If the Sandbox is not yet connected and imsOrg is available, prefetch data.
        !this.connected && (0, $loe8n.hasConfigChanges)(prevContext, this.context, [
            "imsOrg"
        ]) && (0, $loe8n.prefetchOnLoad)(this); // If this is a Work Hub-enabled composed app,
        // update title once Work Hub response is defined.
        if (this.isComposedApp && (0, $loe8n.hasConfigChanges)(prevContext, this.context, [
            "workHubResponse"
        ])) this.titleService.workHubResponse = this.context.workHubResponse;
         // Regenerate iframe source when IMS profile is known.
        // This is the case when discovery URL needs to be invoked.
        // Otherwise, dont need to do this since IMS profile isn't needed to start loading.
        if (this.waitForContext && !shouldWaitForContext) {
            this.waitForContext = false;
            this.generateIframeSource();
            return;
        } else if (shouldWaitForContext) // Wait for context reason might have changed, update.
        this.waitForContext = shouldWaitForContext;
        const { generateSource: generateSource, sendConfiguration: sendConfiguration, useRootPath: useRootPath } = this.apiService.onContextUpdate(prevContext, this);
        generateSource && this.generateIframeSource(true, useRootPath);
        sendConfiguration && this.sendConfiguration();
    }
    onMount(frame) {
        this.frame = frame;
        this.sandboxTimer.time("init", {
            appId: this.metricsAppId,
            discoveryTime: this._discoveryTime
        }); // If somehow we got a ping before mount, process queue.
        this.connected && this.messageService.processMessageAfterMount(this);
    }
    /**
   * To be run on page load. Runs on every server history change.
   * @param obj The below params.
   * @param obj.hash Hash from iframe.
   * @param obj.href Full iframe URL.
   * @param obj.pathname Pathname of iframe.
   * @param obj.search Search from iframe.
   */ async onReady({ hash: hash, href: href, pathname: pathname, search: search }) {
        this.waitForReady = true;
        this.basePath = (0, $loe8n.getBasePath)(this); // In the "server" case (meaning, traditional server rendered app)
        // we want to redirect to the correct url if not already served on ready
        if (this.historyType === $ctGaZ.HISTORY.SERVER) {
            // Get and combine paths and search strings
            const { absolutePaths: absolutePaths } = this.historyConfig;
            const { browser: browser, iframe: iframe } = (0, $jVeiz.getPaths)(pathname, search, hash, !!absolutePaths, this.basePath, this.configURL);
            const browserString = browser.path + browser.search + browser.hash;
            const iframeString = iframe.path + iframe.search + iframe.hash; // Update metrics app ID if section has changed.
            // i.e. Analytics move between its SPA and PHP sections.
            if (this.sections) {
                const section = this.sections.find((sec)=>iframeString.startsWith(sec.route));
                if (section) {
                    this.metricsAppId = section.metricsAppId;
                    this.prevSection = this.currentSection || "";
                    this.currentSection = section.name;
                    (0, $loe8n.setMetricsApplication)(this.metricsAppId, this.props.config);
                }
            } // Compare the iframe's path with the current browser path
            if ((0, $jVeiz.hasChanges)(browserString, iframeString).any) // If not matching, update the browser's path to match iframe path.
            // Additionally, protect against multiple // in a row.
            $bzq4v.history.replace((this.basePath + iframeString).replace(/^\/{2,}/g, "/"));
        } // If custom IMS is required but the custom token is not available yet, set
        // the ready properties so that it can be called from the componentDidUpdate
        // method when appToken is available.
        if (this.customIms) {
            if (!this.context.appToken || !this.context.imsInfo?.imsProfile?.userId) {
                this.readyProperties = {
                    hash: hash,
                    href: href,
                    pathname: pathname,
                    search: search
                };
                return;
            } // If the custom token exists, validate that the user is correct. This was
            // previously caused by a timing issue due to regular profiles and type2e
            // profiles.
            if (this.context.appToken) {
                const { user_id: userId } = (0, $iNslS.extractTokenMetadata)(this.context.appToken) || {}; // If the userId from the token does not match the userId of the profile
                // of the loaded user, request a new token for this client.
                if (userId !== this.context.imsInfo.imsProfile.userId) {
                    this.metrics.info("custom token userId mismatch");
                    this.context.configureCustomIms(this.customIms).catch(()=>{
                        this.metrics.error("custom token failed to match userId of profile");
                        this.setState({
                            error: $fi30R.ErrorTypes.UNKNOWN
                        });
                    }); // Since all the token data comes from the context, this should wait for
                    // the next context update to finish initialization and trigger
                    // sendConfiguration.
                    this.readyProperties = {
                        hash: hash,
                        href: href,
                        pathname: pathname,
                        search: search
                    };
                    return;
                }
            }
        }
        this.sandboxTimer.time(this.initialized ? "reconnected" : "connected", `Solution loaded: ${this.metricsAppId}`, {
            appId: this.metricsAppId,
            customIms: this.customIms,
            hash: hash,
            href: href,
            pathname: pathname,
            search: search
        });
        this.initialized = true;
        this.waitForReady = false;
        this.sendConfiguration(true);
    }
    /**
   * Only send configuration payloads if it's initialized and there is
   * a valid profile. If the app requests sandboxes, ensure that they are present.
   * @param force - If force is true, we always send the configuration event.
   */ shouldSendConfiguration(force) {
        const { accountCluster: accountCluster, appProfile: appProfile, imsOrg: imsOrg, imsProfile: imsProfile, sandbox: sandbox, subOrg: subOrg } = this.context;
        const { urlContext: urlContext } = this.props.config;
        const waitForSandboxes = urlContext?.key === "sandbox" && (!("optional" in urlContext) || !urlContext.optional) && (!sandbox || !!sandbox.imsOrg && sandbox.imsOrg !== imsOrg);
        const waitForSubOrg = urlContext?.key === "subOrg" && !subOrg;
        const profile = this.customIms ? appProfile : imsProfile;
        const orgAccountMismatch = !(0, $loe8n.isOrgInAccount)(accountCluster, imsOrg, imsProfile);
        (0, $loe8n.isShellInfoForIncorrectOrg)(this);
        if (!force && !this.initialized || orgAccountMismatch || waitForSandboxes || waitForSubOrg) {
            // If solution is not yet ready but Shell is (not initialized and imsProfile available)
            // send a sendConfiguration event with solutionReady false.
            if (!this.initialized && profile && !waitForSandboxes && !waitForSubOrg) this.sandboxTimer.time("sendConfiguration", {
                solutionReady: false
            });
            return false;
        }
        return true;
    }
    async sendConfiguration(force = false) {
        // Check to see if there is any reason to delay sending the configuration
        if (this.shouldSendConfiguration(force)) {
            const sent = await this.apiService.sendConfiguration(this);
            sent && this.sandboxTimer.time("sendConfiguration", {
                firstSend: this.apiService.isFirstSend,
                solutionReady: true
            });
        }
    }
    /**
   * Get app load performance data.
   * @param iframePerformance - Serialized Iframe performance JSON
   * @param version - SPA version (optional)
   * @returns Performance data
   */ getLoadInfo({ iframePerformance: iframePerformance = "", version: version = "" }) {
        const { spaAppId: spaAppId, thunderbird: thunderbird } = this.props.config;
        const { getPerformanceMarks: getPerformanceMarks } = this.context;
        const firstRender = $fb1b6abce2533cf7$var$_AppLoadState.default.updateFirstRender();
        if (getPerformanceMarks) return getPerformanceMarks({
            appDone: this.appDone,
            appId: this.metricsAppId,
            firstRender: firstRender,
            iframePerformance: iframePerformance,
            lastAppId: this.lastAppId,
            spaAppId: spaAppId,
            src: this.state.src || "",
            start: this.sandboxStart,
            thunderbird: thunderbird,
            version: version
        });
        return {
            appId: this.metricsAppId,
            error: "getPerformanceMarks not available",
            serviceWorker: (0, $c0cwc.isWorkerActivated)(),
            version: version
        };
    }
    onDone(value) {
        this.setState({
            main: value.addMainElement,
            showWaitMessage: false,
            spinner: false
        });
        let loadInfo = this.getLoadInfo(value);
        if (this.currentSection) loadInfo = {
            ...loadInfo,
            previousSection: this.prevSection,
            section: this.currentSection
        };
        this.sandboxTimer.time({
            event: $fb1b6abce2533cf7$var$_metrics.Events.PAGE_LOAD_DONE
        }, this.metricsAppId, loadInfo); // For availability KPI, need an event that only fires once.
        this.appDone || this.metrics.event("Sandbox.appDone", {
            appId: this.metricsAppId
        });
        this.appDone = true;
        (0, $loe8n.updateDigitalData)(this); // Invoke TUX check in Core for all users
        this.context.getTux();
        this.metrics.analytics.trackPage({
            attributes: {
                done: true
            }
        });
        return loadInfo;
    }
    render() {
        const { appContainer: appContainer, intl: intl } = this.context;
        const { error: error, errorCode: errorCode, main: main, noSource: noSource, notFound: notFound, showWaitMessage: showWaitMessage, src: src } = this.state;
        if (error) {
            // The error property can be either a string or an object. Grab the
            // properties from the object (or converted string to object) and pass
            // the additional information (rest) into the Error component.
            const { id: id, ...rest } = typeof error === "string" ? {
                errorCode: errorCode,
                id: error
            } : error;
            this.sandboxTimer.time("render", {
                message: id
            });
            return /*#__PURE__*/ $fb1b6abce2533cf7$var$_react.default.createElement($fb1b6abce2533cf7$var$_react.default.Suspense, {
                fallback: $fb1b6abce2533cf7$var$_SandboxSpinner.default
            }, /*#__PURE__*/ $fb1b6abce2533cf7$var$_react.default.createElement($fb1b6abce2533cf7$var$ErrorView, $fb1b6abce2533cf7$var$_extends({
                type: id
            }, rest)));
        }
        const spinner = this.isSpinnerOn();
        const name = intl.formatMessage($fb1b6abce2533cf7$var$_CoreStrings.default.solutionIframe);
        const sandboxProps = main ? {
            role: "main"
        } : {};
        this.sandboxTimer.time("render", {
            appId: this.metricsAppId,
            main: main,
            spinner: spinner,
            src: src
        });
        const showSpinner = !notFound && spinner;
        const permissionsPolicy = `fullscreen;${(this.props.config.permissionsPolicy || []).join(";")}`;
        return /*#__PURE__*/ $fb1b6abce2533cf7$var$_react.default.createElement("div", $fb1b6abce2533cf7$var$_extends({
            className: (0, $fb1b6abce2533cf7$var$_classnames.default)("exc-core-sandbox exc-core-sandbox-common", {
                appContainer: appContainer
            })
        }, sandboxProps), notFound && /*#__PURE__*/ $fb1b6abce2533cf7$var$_react.default.createElement($fb1b6abce2533cf7$var$_react.default.Suspense, {
            fallback: $fb1b6abce2533cf7$var$_SandboxSpinner.default
        }, /*#__PURE__*/ $fb1b6abce2533cf7$var$_react.default.createElement($fb1b6abce2533cf7$var$ErrorView, {
            type: noSource ? $fi30R.ErrorTypes.UNKNOWN : $fi30R.ErrorTypes.NOT_FOUND
        })), src && !notFound && /*#__PURE__*/ $fb1b6abce2533cf7$var$_react.default.createElement($fb1b6abce2533cf7$var$_Iframe.default, {
            frameKey: String(this.state.frameKey),
            name: name,
            onFrameSrcViolation: this.onCSPViolation,
            onInvalidSource: (source)=>this.invalidSource = source,
            onMessage: this.onMessage,
            onMount: this.onMount,
            permissionsPolicy: permissionsPolicy,
            sandboxId: this.sandboxId,
            src: src ? src.toString() : ""
        }), showSpinner && /*#__PURE__*/ $fb1b6abce2533cf7$var$_react.default.createElement($fb1b6abce2533cf7$var$_SandboxSpinner.default, {
            ignoreNav: false,
            showWaitMessage: showWaitMessage
        }));
    }
}
module.exports.default = $fb1b6abce2533cf7$var$Sandbox;
$fb1b6abce2533cf7$var$Sandbox.contextType = $fb1b6abce2533cf7$var$_context.default;

});
parcelRegister("cCPTR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.APIService = module.exports.SECONDARY_IGNORED_EVENTS = void 0;

var $W80N2 = parcelRequire("W80N2");

var $3Zpnv = parcelRequire("3Zpnv");

var $iNslS = parcelRequire("iNslS");

var $loe8n = parcelRequire("loe8n");

var $jVeiz = parcelRequire("jVeiz");

var $bzq4v = parcelRequire("bzq4v");

var $15j1u = parcelRequire("15j1u");

var $e75deef64c02f7b2$var$_OrchestrationService = $e75deef64c02f7b2$var$_interopRequireDefault((parcelRequire("gah5j")));
function $e75deef64c02f7b2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e75deef64c02f7b2$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $e75deef64c02f7b2$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $e75deef64c02f7b2$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e75deef64c02f7b2$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e75deef64c02f7b2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $e75deef64c02f7b2$var$SECONDARY_IGNORED_EVENTS = [
    $iNslS.Events.TITLE,
    $iNslS.Events.SHELL_REDIRECT
];
module.exports.SECONDARY_IGNORED_EVENTS = $e75deef64c02f7b2$var$SECONDARY_IGNORED_EVENTS;
const $e75deef64c02f7b2$var$configureService = new $W80N2.AppConfigureService();

class $e75deef64c02f7b2$var$APIService {
    constructor(messageService){
        $e75deef64c02f7b2$var$_defineProperty(this, "messageService", void 0);
        $e75deef64c02f7b2$var$_defineProperty(this, "sendHistoryMessage", void 0);
        $e75deef64c02f7b2$var$_defineProperty(this, "apiProcessingPromise", void 0);
        $e75deef64c02f7b2$var$_defineProperty(this, "lastConfiguration", void 0);
        $e75deef64c02f7b2$var$_defineProperty(this, "firstSend", true);
        $e75deef64c02f7b2$var$_defineProperty(this, "historyUpdateInProgress", false);
        $e75deef64c02f7b2$var$_defineProperty(this, "waitForProcessing", false);
        $e75deef64c02f7b2$var$_defineProperty(this, "getNextConfig", (props)=>{
            const { hash: hash } = window.location;
            const match = props.match((0, $jVeiz.hashToPath)({
                hash: hash
            }));
            return match ? match.props?.children?.props?.config : undefined;
        });
        this.messageService = messageService;
        this.apiProcessingPromise = Promise.resolve().then(function() {
            return (parcelRequire("7rHmB"));
        }).then((res)=>$e75deef64c02f7b2$var$_interopRequireWildcard(res)).then(({ APIProcessingService: APIProcessingService })=>new APIProcessingService(messageService)); // Debounce the history message so that we can wait for additional updates
        // from the framed application so that we know we're sending to the right
        // place. Additionally, this should solve issues around navigation loops
        // because it's letting the app send all the events it needs.
        this.sendHistoryMessage = (0, $3Zpnv.debounce)(messageService.sendMessage.bind(messageService), 100);
    }
    /**
   * Returns true if the last payload sent was the first sent by this instance.
   */ get isFirstSend() {
        return this.firstSend;
    }
    /**
   * Unblocks navigation (If blocked).
   */ async unblockNavigation() {
        (await this.apiProcessingPromise).unblockNavigation();
    }
    unmount(app) {
        const { appId: appId, context: context, props: props } = app;
        this.unblockNavigation();
        if (!app.secondary) {
            // Secondary sandboxes (i.e. SandboxInner) should not update Unified Shell state.
            const { appId: nextAppId, sandbox: sandbox, sideNav: nextSideNav } = this.getNextConfig(props) || {};
            const { ims: ims } = sandbox || {};
            context.resetConfigStates(appId, nextAppId, nextSideNav, ims);
        }
    }
    /**
   * Process and respond to messages coming from the iframe (AppSandbox).
   * @param type - Message type
   * @param value - Message payload
   * @param app - AppSandbox object.
   */ async handleMessage(type, value, app) {
        const { context: context } = app;
        if (app.secondary && $e75deef64c02f7b2$var$SECONDARY_IGNORED_EVENTS.includes(type)) // These events do not apply to secondary sandboxes (i.e. SandboxInner), ignore.
        return;
        this.waitForProcessing && await this.apiProcessingPromise;
        switch(type){
            case $iNslS.Events.DONE:
                {
                    // Secondary sandboxes (i.e. SandboxInner) should not update Unified Shell state.
                    app.secondary || context.setConfigStates({
                        solutionLoaded: true
                    });
                    const performanceData = app.onDone(value);
                    this.messageService.sendMessage({
                        type: $iNslS.Events.DONE,
                        value: performanceData
                    }, app);
                    $e75deef64c02f7b2$var$_OrchestrationService.default.onLoaded();
                    break;
                }
            case $iNslS.Events.READY:
                app.onReady(value);
                break;
            case $iNslS.Events.SHELL_REDIRECT:
                this.redirectHandler(value, app);
                break;
            case $iNslS.Events.TITLE:
                app.titleService?.update(value.title);
                break;
            default:
                this.waitForProcessing = true;
                (await this.apiProcessingPromise).handleMessage(type, value, app, this.lastConfiguration);
                this.waitForProcessing = false;
        }
    }
    /**
   * Sends the configuration payload to the iframe.
   * @param app - AppSandbox object.
   * @returns true if configuration was sent, false otherwise.
   */ async sendConfiguration(app) {
        let imsData = {};
        const { customIms: customIms, metrics: metrics } = app;
        if (customIms) {
            const data = (0, $loe8n.getCustomImsData)(app); // If there is no custom ims data, don't send the configuration.
            if (!data) {
                metrics.info("sendConfiguration had no required customIms data");
                return false;
            }
            if (!(0, $loe8n.isValidCustomImsToken)(app)) metrics.warn("sendConfiguration had invalid custom token data", {
                customIms: customIms
            });
            metrics.info("sendConfiguration has valid customIms data");
            imsData = data;
        }
        this.firstSend = !this.lastConfiguration;
        const config = await $e75deef64c02f7b2$var$configureService.getConfigurePayload(app);
        const value = {
            ...config,
            ...imsData
        };
        const changed = $e75deef64c02f7b2$var$configureService.getChangedConfig(value, this.lastConfiguration);
        this.lastConfiguration = value;
        $e75deef64c02f7b2$var$configureService.setGainsight(app, config.gainsight);
        this.messageService.sendMessage({
            changed: changed,
            type: $iNslS.Events.CONFIGURE,
            value: value
        }, app);
        (await this.apiProcessingPromise).processOpenDataRequests(app, this.lastConfiguration);
        return true;
    }
    /**
   * Process delayed incoming data messages.
   * @param app App Sandbox object
   */ async processEventQueue(app) {
        (await this.apiProcessingPromise).processEventQueue(app);
    }
    updateAppHistory(nextPath, app) {
        if (!this.historyUpdateInProgress) {
            const { context: { environment: environment }, props: { hash: hash, querystring: query } } = app;
            const { solutionConfig: { sandbox: { pathPrefix: pathPrefix } } } = app;
            const prefix = environment === "dev" && pathPrefix?.dev || pathPrefix?.default || "";
            const path = prefix + (/^\//.test(nextPath) ? nextPath : `/${nextPath}`);
            this.sendHistoryMessage({
                type: $iNslS.Events.HISTORY,
                value: path + (query ? `?${query}` : "") + (hash ? `#${hash}` : "")
            }, app);
        }
    }
    /**
   * Determines if the IMS values have changed enough for the iframe source to
   * be updated. This is specific to org and sub-org changes.
   * @param prevContext Previous context from Core.js.
   * @param app App Sandbox object.
   * @returns True if IMS change has occurred.
   */ shouldTriggerFrameUpdate(prevContext, app) {
        const { context: context, solutionConfig: { refreshOnImsChange: refreshOnImsChange, urlContext: urlContext } } = app; // If sandbox is showing an explicit error, then we should try
        // updating the iframe in hopes of resolving the issue on new discovery.
        if (app.inErrorState()) return true;
        if (!refreshOnImsChange) return false;
        const orgConfigChanged = (0, $loe8n.hasConfigChanges)(prevContext, context, [
            "imsOrg"
        ], true);
        const subOrgConfigChanged = (0, $loe8n.hasConfigChanges)(prevContext, context, [
            "subOrg"
        ]);
        const subOrgEnabled = urlContext?.key === "subOrg"; // If nothing changed, don't update.
        if (!orgConfigChanged && !subOrgConfigChanged) return false;
         // Checks for validity of a sub-org. If the sub-org itself is valid, the id
        // is set. The default value set by Core.js sets an object without a valid
        // id property.
        const validSubOrg = !!context.subOrg?.id; // A valid sub-org change happens if the sub-org value has changed and is
        // valid in terms of having a valid id.
        const validSubOrgChange = subOrgConfigChanged && validSubOrg; // Checks for a valid org change. If the org changed happened but sub-orgs
        // are enabled, there will be an update in the future that includes the
        // updated sub-orgs, so we need to wait for that.
        if (orgConfigChanged && !subOrgEnabled) return true;
         // The sub org has changed to a valid value.
        return validSubOrgChange;
    }
    /**
   * After the component has updated, we may need to send certain updates to the iframe.
   */ onContextUpdate(prevContext, app) {
        const { context: context, customIms: customIms, solutionConfig: { spaAppId: spaAppId, urlContext: urlContext }, source: source } = app; // Don't send a configuration update if nothing has changed, or the src has not been set
        // unless the sandbox is in an error state
        if (!source && !app.inErrorState() || JSON.stringify(prevContext) === JSON.stringify(context)) return {
            generateSource: false
        };
         // Send event if Coach Marks position updated in Core state
        (0, $loe8n.hasConfigChanges)(prevContext, context, [
            "coachMarkPosition"
        ]) && this.messageService.sendMessage({
            type: $iNslS.Events.COACH_MARK_POSITIONED,
            value: context.coachMarkPosition
        }, app); // Send the open/closed value of a global shell component to module runtime
        // When open, module runtime needs to hide the accessibility tree
        // i.e. Unified Nav or Global Search
        (0, $loe8n.hasConfigChanges)(prevContext, context, [
            "globalDialogOpen"
        ]) && this.messageService.sendMessage({
            type: $iNslS.Events.GLOBAL_DIALOG_OPEN,
            value: context.globalDialogOpen
        }, app); // If the feature flags have changed, determine if we should re-render the
        // app in case of SPA and AB testing version change.
        if (spaAppId && context.featureFlags && (0, $loe8n.hasConfigChanges)(prevContext, context, [
            "featureFlags"
        ])) {
            const { ABTesting: ABTesting, liveVersion: liveVersion, spaName: spaName } = (0, $loe8n.getSpaAppConfig)(spaAppId, app);
            const srcVersion = source?.searchParams.get(`${spaName}_version`); // If AB testing is enabled and the version of the SPA app that was
            // previously loaded is different from the newly generated one, update
            // the state's src property to reload the app.
            if (ABTesting && srcVersion !== liveVersion) return {
                generateSource: true
            };
        } // If refreshOnImsChange is set and IMS has actually changed, refresh the
        // iframe source.
        if (this.shouldTriggerFrameUpdate(prevContext, app)) {
            const useRootPathOnChange = !!(urlContext && "config" in urlContext && urlContext.config?.useRootPathOnChange);
            return {
                generateSource: true,
                useRootPath: useRootPathOnChange && (0, $loe8n.hasConfigChanges)(prevContext, context, [
                    "subOrg"
                ])
            };
        } // If the imsToken has changed but the application has customIms enabled,
        // don't bother sending the configuration because the actual token hasn't
        // changed. `imsToken` is ONLY for EXC tokens, `appToken` is what is
        // needed if customIms is set.
        const sendConfiguration = !((0, $loe8n.hasConfigChanges)(prevContext, context, [
            "imsToken"
        ]) && customIms);
        sendConfiguration && !app.secondary && this.apiProcessingPromise.then((processingService)=>processingService.sendCustomSearchValue(app));
        return {
            sendConfiguration: sendConfiguration
        };
    }
    redirectHandler(value, app) {
        const { discovery: discovery, replace: replace = true, url: urlStr } = value;
        const { solutionConfig: { hideTenant: hideTenant } } = app;
        let { path: path = "" } = value; // If the path is a full url, we need to ensure that it's valid, meaning
        // it's a supported hostname that is delivered by Unified Shell. It can
        // be adobeaemcloud.com or experience.adobe.com.
        if (urlStr) {
            const url = new URL(urlStr); // The full URL MUST be either AEM Skyline OR Unified Shell.
            if (!(0, $15j1u.isSkyline)(url) && !/^https:\/\/experience(-qa|-stage)?\.adobe\.com/.test(url.toString())) return;
             // If the origin is the same as the new url, only change the hash.
            if (url.origin === window.location.origin) path = (0, $jVeiz.getPathWithoutTenant)(url.hash.substring(1));
            else return window.open(url.toString(), "_self");
        }
        discovery && (this.historyUpdateInProgress = true);
        const updatedPath = (0, $jVeiz.getUpdatedPath)((0, $jVeiz.hashToPath)({
            removePrecedingSlash: true
        }), path, hideTenant);
        $bzq4v.history[replace ? "replace" : "push"](updatedPath);
        this.historyUpdateInProgress = false;
        discovery && app.generateIframeSource(true);
    }
    /**
   * If the config has changed, reset state and load the new iframe source
   * This should only happen on an org change where an alternate app needs
   * to be loaded at the same route.
   */ resetOnNewConfig(prevProps, app) {
        const { context: context, solutionConfig: solutionConfig } = app;
        const { config: prevConfig } = prevProps;
        if (prevConfig !== solutionConfig) {
            const { appId: appId, sandbox: { ims: ims }, sideNav: sideNav } = solutionConfig;
            context.resetConfigStates(prevConfig.appId, appId, sideNav, ims, true);
            return true;
        }
        return false;
    }
}
module.exports.APIService = $e75deef64c02f7b2$var$APIService;

});
parcelRegister("W80N2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AppConfigureService = void 0;

var $iNslS = parcelRequire("iNslS");

var $loe8n = parcelRequire("loe8n");

var $dDEjQ = parcelRequire("dDEjQ");

var $3Zpnv = parcelRequire("3Zpnv");

var $jVeiz = parcelRequire("jVeiz");

var $17AVh = parcelRequire("17AVh");

var $1ELZt = parcelRequire("1ELZt");
function $a1276d0763eee35a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $a1276d0763eee35a$var$AppConfigureService {
    constructor(){
        $a1276d0763eee35a$var$_defineProperty(this, "getNestedApps", ({ context: context, solutionConfig: solutionConfig })=>solutionConfig.nestedApps?.reduce((nestedApps, nestedApp)=>{
                const { appId: appId, gainsight: gainsight, spaAppId: spaAppId } = nestedApp;
                const analyticsConfig = this.getAnalyticsScript(context, nestedApp);
                if (spaAppId && analyticsConfig) nestedApps[spaAppId] = {
                    appId: appId,
                    gainsight: gainsight,
                    ...analyticsConfig
                };
                return nestedApps;
            }, {}));
    }
    getOmegaScripts({ analytics: analytics }) {
        if (analytics) {
            if ("omegaGlobal" in analytics && analytics.omegaGlobal) return $1ELZt.pdhGlobalMap[analytics.omegaGlobal].scripts;
            if ("scripts" in analytics) return analytics.scripts;
        }
    }
    /**
   * Returns Omega (Data Collection) script for the iframe to initialize Omega if one is configured.
   * @param context - Context object.
   * @param solutionConfig - Application config.
   * @returns script to load or undefined if no script is configured.
   * @private
   */ getAnalyticsScript(context, solutionConfig) {
        const solution = (0, $loe8n.getAnalyticsSolution)(solutionConfig);
        const scripts = this.getOmegaScripts(solutionConfig);
        const env = (0, $loe8n.getAppEnvironment)(context, solutionConfig);
        if (solution && scripts?.[env]) return {
            script: scripts[env],
            solution: solution
        };
    }
    /**
   * Returns FIs to trigger Gainsight if configured and available for the current user.
   * @param context - Context object
   * @param triggers - Triggers configuration
   * @returns array of trigger FIs. Empty array if none available.
   * @private
   */ getGainsightTriggers(context, triggers) {
        const { fulfillableItems: userFIs, imsOrg: imsOrg } = context;
        const { fulfillableItems: fulfillableItems, serviceCode: serviceCode } = triggers;
        if (fulfillableItems && serviceCode) {
            const availableFIs = userFIs[imsOrg]?.[serviceCode] || [];
            return availableFIs.filter((key)=>fulfillableItems.includes(key));
        }
        return [];
    }
    /**
   * Initializes Gainsight if configured for the active application.
   * @param solutionConfig - Application Config.
   * @param gainsight - Gainsight configuration.
   */ setGainsight({ metrics: metrics, secondary: secondary, solutionConfig: solutionConfig }, gainsight) {
        const { analytics: analytics } = solutionConfig;
        const analyticsSolution = (0, $loe8n.getAnalyticsSolution)(solutionConfig);
        if (secondary) // Unified Shell Gainsight should only sync with the primary sandbox.
        // Secondary sandboxes (i.e. SandboxInner) should be ignored.
        return;
         // Add the Gainsight configuration to the Unified Shell window as well as
        // the iframe so that it will also abide by the user permissions.
        window.shellGainsight = gainsight;
        window.dispatchEvent(new CustomEvent("shellGainsight"));
        if (analyticsSolution) {
            const omegaGlobal = !!analytics && "omegaGlobal" in analytics && analytics.omegaGlobal;
            (0, $3Zpnv.waitForGainsightCallback)().then((callback)=>callback(analyticsSolution, !!omegaGlobal)).catch(()=>{
                metrics.event("Sandbox.noGainsight", {
                    analyticsSolution: analyticsSolution,
                    omegaGlobal: omegaGlobal
                }, {
                    level: $17AVh.Level.ERROR
                });
            });
        }
    }
    /**
   * Constructs the iframe configuration payload from the context, config and app sandbox state.
   * @returns configuration payload.
   * @param app
   */ async getConfigurePayload(app) {
        const { configURL: configURL, context: context, metricsAppId: metricsAppId, props: props, solutionConfig: solutionConfig } = app;
        const { cdn: cdn, endpoints: endpoints } = (0, $dDEjQ.getBootstrap)().config;
        const { activeProductContext: activeProductContext, apiKey: apiKey, appContainer: appContainer, avatar: avatar, environment: environment, featureFlags: featureFlags, fulfillableItems: contextFulfillableItems, gainsightRoles: gainsightRoles, imsClientId: imsClientId, imsEnvironment: imsEnvironment, imsInfo: imsInfo, imsOrg: imsOrg, imsOrgs: imsOrgs, imsOrgName: imsOrgName, imsProfile: imsProfile, imsToken: imsToken, internal: internal, lastRecentTs: lastRecentTs, locale: locale, metricsEnv: metricsEnv, orgRegion: orgRegion, preferredLanguages: preferredLanguages, sandbox: selectedSandbox, shellHeight: shellHeight, shellInfo: shellInfo, shellSideNavPresent: shellSideNavPresent, shellSideNavWidth: shellSideNavWidth, sideNavOpen: sideNavOpen, subOrg: subOrg, tenant: tenant, theme: theme, userConsent: userConsent } = context;
        const { appId: appId, browserParamFilterList: browserParamFilterList, fiServiceCode: fiServiceCode, gainsight: gainsightConfig, gqlEndpoint: gqlEndpoint, metadata: metadata, omegaSuiteId: omegaSuiteId = appId, parent: parent, spaAppId: spaAppId } = solutionConfig; // eslint-disable-next-line no-unused-vars
        const { triggers: triggers, ...gainsightRest } = gainsightConfig || {};
        const analytics = this.getAnalyticsScript(context, solutionConfig);
        const baseUrl = (0, $loe8n.setBaseUrl)(app.basePath);
        const fulfillableItems = fiServiceCode ? contextFulfillableItems?.[imsOrg]?.[fiServiceCode] || [] : [];
        const metricsConfig = await (0, $loe8n.getMetricsConfig)(app);
        const nestedApps = this.getNestedApps(app);
        const quiteToastPromise = (0, $loe8n.getQuietToastEnabled)(app); // Filter this list, so we don't send down data that might cause security issues
        // (IMS related stuff, other?)
        const gainsight = {
            appId: appId,
            appParent: app.secondary ? "component" : parent,
            enabled: "aptrinsic" in window,
            environment: environment,
            fulfillableItems: fulfillableItems,
            omegaSuiteId: omegaSuiteId,
            productKey: "AP-4BHKD5GITH0M-2",
            // Default gainsight key, overridden by defined configs.
            shellPath: (0, $jVeiz.getPathWithoutTenant)(window.location.hash.replace(/^#/, "")),
            user: {
                authId: imsProfile?.authId,
                internal: internal,
                permissions: userConsent,
                roles: gainsightRoles,
                theme: theme.includes("light") ? "light" : "dark",
                triggers: triggers ? this.getGainsightTriggers(context, triggers) : []
            },
            ...gainsightRest
        };
        const runtimeConfig = {
            activeProductContext: activeProductContext,
            analytics: analytics,
            apiGatewayUrl: endpoints.apiGateway,
            apiKey: apiKey,
            appContainer: appContainer,
            appId: appId,
            appMetadata: metadata,
            avatar: avatar,
            baseFrameUrl: configURL?.toString() || "",
            basePath: (0, $jVeiz.getPathWithoutTenant)(app.basePath),
            baseUrl: baseUrl,
            browserParamFilterList: browserParamFilterList,
            cdn: cdn,
            componentBootstrapData: app.secondary ? props.bootstrapData : undefined,
            discovery: !!(0, $loe8n.getDiscoverySource)(app),
            environment: environment,
            externalQueryParams: window.location.search,
            featureFlags: featureFlags,
            fulfillableItems: fulfillableItems,
            gainsight: gainsight,
            gqlEndpoint: gqlEndpoint,
            historyType: (0, $3Zpnv.getHistoryType)(solutionConfig),
            imsClientId: imsClientId,
            imsEnvironment: imsEnvironment,
            imsInfo: imsInfo,
            imsOrg: imsOrg,
            imsOrgName: imsOrgName,
            imsOrgs: imsOrgs,
            imsProfile: imsProfile,
            imsToken: imsToken,
            inModal: app.secondary,
            internal: internal,
            ioGatewayUrl: endpoints.ioGateway,
            ioRegionSpecificMap: endpoints.regionGatewayIoMap,
            isAWSOrg: (0, $iNslS.isAWSOrgRegion)(orgRegion),
            lastRecentTs: lastRecentTs,
            locale: locale,
            metricsAppId: metricsAppId,
            metricsConfig: metricsConfig,
            metricsEnv: metricsEnv,
            nestedApps: nestedApps,
            orgRegion: orgRegion,
            preferredLanguages: preferredLanguages,
            sandbox: selectedSandbox,
            shellHeight: shellHeight,
            shellInfo: shellInfo,
            shellSideNavCollapsed: !sideNavOpen,
            shellSideNavPresent: shellSideNavPresent,
            shellSideNavWidth: shellSideNavWidth,
            sourceEnvironment: (0, $loe8n.getSourceEnvironment)(context, solutionConfig),
            spaAppId: spaAppId,
            subOrg: subOrg,
            tenant: tenant,
            theme: `spectrum--${theme}`,
            toastQuietModeEnabled: await quiteToastPromise,
            userConsentPermissions: userConsent,
            xqlGatewayUrl: endpoints.xql
        }; // Add the runtimeConfig to the Shell's digitalData
        // - but not for inner sandbox frames as they should
        // have the digitalData from the outer sandbox
        if (!app.secondary) {
            window.digitalData = {
                ...window.digitalData,
                unifiedShell: {
                    config: (0, $iNslS.sanitizeConfiguration)(runtimeConfig)
                }
            };
            (0, $iNslS.digitalDataUpdated)("unifiedShell");
        }
        return runtimeConfig;
    }
    /**
   * Compares the current and previous configuration payloads.
   * @param payload - Current configuration payload
   * @param lastPayload - Previous configuration payload
   * @returns array of changed configuration keys.
   */ getChangedConfig(payload, lastPayload) {
        // On first config event, mark all values as changed
        const keys = Object.keys(payload);
        if (!lastPayload) return keys.filter((key)=>payload[key] !== undefined);
        return keys.filter((key)=>JSON.stringify(payload[key]) !== JSON.stringify(lastPayload[key]));
    }
}
module.exports.AppConfigureService = $a1276d0763eee35a$var$AppConfigureService;

});
parcelRegister("loe8n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAppController = module.exports.isValidCustomImsToken = module.exports.getCustomImsData = module.exports.updateDigitalData = module.exports.isAppHealthy = module.exports.updateTemplatedURL = module.exports.updateSourceWithParams = module.exports.getApplicationSourceUrl = module.exports.isShellInfoForIncorrectOrg = module.exports.shouldWaitForContextUpdates = module.exports.getBasePath = module.exports.getSpaAppConfig = module.exports.hasConfigChanges = module.exports.initSandbox = module.exports.getRuntimeParam = module.exports.setMetricsApplication = module.exports.getDiscoverySource = module.exports.getAnalyticsSolution = module.exports.getSpaApp = module.exports.setBaseUrl = module.exports.getQuietToastEnabled = module.exports.isOrgInAccount = module.exports.getSourceEnvironment = module.exports.isDifferentAppEnvironment = module.exports.getAppEnvironment = module.exports.prefetchOnLoad = module.exports.getMetricsConfig = void 0;

var $fi30R = parcelRequire("fi30R");

var $3Zpnv = parcelRequire("3Zpnv");

var $iNslS = parcelRequire("iNslS");

var $dDEjQ = parcelRequire("dDEjQ");

var $1HQDe = parcelRequire("1HQDe");

var $jVeiz = parcelRequire("jVeiz");

var $ihFuI = parcelRequire("ihFuI");

var $hCG2Z = parcelRequire("hCG2Z");

var $ctGaZ = parcelRequire("ctGaZ");

var $9OLey = parcelRequire("9OLey");

var $15j1u = parcelRequire("15j1u");

var $hCZmk = parcelRequire("hCZmk");

var $c3nD4 = parcelRequire("c3nD4");

var $iJaYo = parcelRequire("iJaYo");

var $5jesu = parcelRequire("5jesu");
function $19e7b8a0323531b4$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $19e7b8a0323531b4$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $19e7b8a0323531b4$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $19e7b8a0323531b4$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// AEM proxies Content server at /ui - The proxy is used to serve Unified Shell
// or any SPA Pipeline HTML.
const $19e7b8a0323531b4$var$AEM_BASE_PATH = "/ui";
/**
 * Returns Metrics (EIM) config for a given app
 * @param app - App Sandbox object.
 * @returns Metrics Configuration
 */ const $19e7b8a0323531b4$var$getMetricsConfig = async (app)=>{
    const { environment: environment, metricsEnv: metricsEnv } = app.context;
    return {
        ...await $9OLey.Internal.configureMetrics(),
        application: {
            id: app.metricsAppId,
            parent: app.solutionConfig.parent
        },
        environment: metricsEnv || environment
    };
};
/**
 * Prefetch data needed for the current application.
 * @param app - App Sandbox object.
 */ module.exports.getMetricsConfig = $19e7b8a0323531b4$var$getMetricsConfig;

const $19e7b8a0323531b4$var$prefetchOnLoad = async (app)=>{
    const { appId: appId, context: context, solutionConfig: { dataPrefetchContracts: dataPrefetchContracts } } = app;
    const { imsOrg: imsOrg } = context;
    if (dataPrefetchContracts?.length && imsOrg) {
        const dataPrefetchService = context.dataPrefetchService || (await Promise.resolve().then(function() {
            return (parcelRequire("7rHmB"));
        }).then((res)=>$19e7b8a0323531b4$var$_interopRequireWildcard(res))).dataPrefetchService;
        app.connected || dataPrefetchContracts.forEach((key)=>{
            if (!dataPrefetchService.isContextMissing(key, context)) dataPrefetchService.getData(key, context, appId);
        });
    }
};
/**
 * Returns the current environment (qa/stage/prod).
 * @param context - Core Context object
 * @param solutionConfig - Solution Config
 */ module.exports.prefetchOnLoad = $19e7b8a0323531b4$var$prefetchOnLoad;
const $19e7b8a0323531b4$var$getAppEnvironment = (context, solutionConfig)=>{
    const source = (0, $hCG2Z.getQueryValue)("source");
    const qaSources = (0, $hCG2Z.getQueryValue)("source_qa")?.split(",") || [];
    const { appId: appId, parent: parent } = solutionConfig;
    const qaSource = qaSources.includes(appId) || parent && qaSources.includes(parent) ? "qa" : null;
    return source || qaSource || context.environment;
};
/**
 * Checks if the current application environment is different from the current
 * Shell environment.
 * @param env - Application environment which may be different from Shell environment.
 * @param context - Core Context object.
 */ module.exports.getAppEnvironment = $19e7b8a0323531b4$var$getAppEnvironment;
const $19e7b8a0323531b4$var$isDifferentAppEnvironment = (env, context)=>env !== context.environment && [
        "dev",
        "qa",
        "stage",
        "prod"
    ].includes(env);
/**
 * Gets the source environment being loaded.
 * 1. Uses `metricsEnv` first to see if it's set to `dev` since it uses the
 *    `shell_devmode` query param and `devmodeEnabled` property in the
 *    `unifiedShellConfig` development local storage config.
 * 2. Uses `shell_source` query param
 * 3. Uses the Shell's environment
 * @returns The source environment.
 */ module.exports.isDifferentAppEnvironment = $19e7b8a0323531b4$var$isDifferentAppEnvironment;
const $19e7b8a0323531b4$var$getSourceEnvironment = (context, solutionConfig)=>context.metricsEnv === "dev" ? "dev" : $19e7b8a0323531b4$var$getAppEnvironment(context, solutionConfig);
/**
 * Checks if the org exists within the current ims profile.
 * @param accounts - ims account cluster
 * @param imsOrg - IMS Org
 * @param imsProfile - IMS Profile
 * @returns Returns true if the org is found in the current account
 */ module.exports.getSourceEnvironment = $19e7b8a0323531b4$var$getSourceEnvironment;
const $19e7b8a0323531b4$var$isOrgInAccount = (accounts, imsOrg, imsProfile)=>{
    const { userId: userId, projectedProductContext: projectedProductContext = [] } = imsProfile || {}; // In order for check to proceed we need the imsOrg and either the account cluster or the profile
    if (!imsOrg || !(accounts || imsProfile)) return false;
    if (accounts) {
        const { owningOrg: owningOrg, orgs: accountOrgs = [] } = accounts.find((acct)=>acct.userId === userId) || {};
        const orgs = owningOrg ? accountOrgs.concat([
            owningOrg
        ]) : accountOrgs;
        return orgs.some((o)=>o.imsOrgId === imsOrg);
    } // Fallback to the profile check, if it is available before accounts become ready
    return projectedProductContext.some(({ prodCtx: prodCtx })=>prodCtx.owningEntity === imsOrg);
};
/**
 * Returns true if quiet toast mode is enabled.
 * @param app - App Sandbox object
 */ module.exports.isOrgInAccount = $19e7b8a0323531b4$var$isOrgInAccount;
const $19e7b8a0323531b4$var$getQuietToastEnabled = async (app)=>{
    const { featureFlags: featureFlags, internal: internal } = app.context;
    return internal && !app.secondary && [
        "cjm-platform",
        "experiencePlatformUI"
    ].includes(app.solutionConfig.appId) && featureFlags?.["demo-quiet-mode"] === "true" && (await $iJaYo.storage.local.get("shellQuietToastEnabled") || false);
};
/**
 * Constructs baseUrl using basePath.
 * @param basePath The base path of the url.
 * @returns The full base url.
 */ module.exports.getQuietToastEnabled = $19e7b8a0323531b4$var$getQuietToastEnabled;
const $19e7b8a0323531b4$var$setBaseUrl = (basePath)=>{
    const baseUrl = new URL(window.location.origin);
    (0, $15j1u.isSkyline)() && (baseUrl.pathname = $19e7b8a0323531b4$var$AEM_BASE_PATH);
    baseUrl.hash = basePath;
    baseUrl.search = window.location.search;
    return baseUrl.toString().replace(/\/$/, "");
};
/**
 * Returns SPA Config object
 * @param spaAppId - SPA Pipeline App ID
 */ module.exports.setBaseUrl = $19e7b8a0323531b4$var$setBaseUrl;
const $19e7b8a0323531b4$var$getSpaApp = (spaAppId)=>(window.config?.solutions || {})[spaAppId];
module.exports.getSpaApp = $19e7b8a0323531b4$var$getSpaApp;
const $19e7b8a0323531b4$var$getAnalyticsSolution = ({ analytics: analytics = {}, appId: appId, omegaSuiteId: omegaSuiteId = appId })=>{
    // Trigger gainsight callback when it's available with the appId of the
    // application that is loading.
    if ("omegaGlobal" in analytics) return omegaSuiteId;
    if ("code" in analytics) return analytics.code;
};
module.exports.getAnalyticsSolution = $19e7b8a0323531b4$var$getAnalyticsSolution;
const $19e7b8a0323531b4$var$getDiscoverySource = (app)=>{
    const { context: context, solutionConfig: { sandbox: sandbox } } = app;
    const env = $19e7b8a0323531b4$var$getAppEnvironment(context, app.solutionConfig) || "";
    const srcEnv = sandbox.sources[env];
    return srcEnv && typeof srcEnv === "object" ? srcEnv : undefined;
};
/**
 * Configure Application data for the Metrics SDK (EIM).
 * @param id - Application ID
 * @param solutionConfig - Solution Config
 * @param spaApp - Spa Pipeline Config
 * @param component - Component ID
 */ module.exports.getDiscoverySource = $19e7b8a0323531b4$var$getDiscoverySource;
const $19e7b8a0323531b4$var$setMetricsApplication = (id, solutionConfig, spaApp, component)=>{
    const { releaseType: releaseType = $ctGaZ.RELEASE_TYPE.GA, parent: parent } = solutionConfig; // Set the application in metrics
    const solution = {
        id: id,
        parent: parent,
        releaseType: releaseType,
        version: spaApp?.liveVersion
    };
    const application = component ? {
        component: component,
        solution: solution
    } : {
        solution: solution
    };
    $9OLey.Internal.setApplication(application);
};
module.exports.setMetricsApplication = $19e7b8a0323531b4$var$setMetricsApplication;
const $19e7b8a0323531b4$var$replaceLegacyCDN = (url)=>url.replace("cdn.", "exc-unifiedcontent.").replace("experience-qa.adobe.net", "experience-qa.adobe.com");
/**
 * Returns runtime.js param (_mr) to use for the current application
 * @param app - App Sandbox object.
 */ const $19e7b8a0323531b4$var$getRuntimeParam = (app)=>{
    const bootstrap = (0, $dDEjQ.getBootstrap)();
    const { cdn: cdn, environment: environment } = bootstrap.config;
    const { solutionConfig: { runtime: runtime, spaAppId: spaAppId } } = app; // The older version of runtime loader prohibits using the AWS CDN,
    // therefore all SPAs must be routed to the AFD CDN unless they indicate
    // that they've updated the loader script via the config by using RUNTIME.CDN
    const runtimeScript = document.getElementById("runtimeScript");
    const runtimeUrl = runtimeScript?.getAttribute("data-src");
    if (!runtimeUrl) throw new Error("Missing Module Runtime src");
    if (runtime === $ctGaZ.RUNTIME.CDN) {
        // Use the new _mr secure format.
        const envPrefix = [
            "stage",
            "prod"
        ].includes(environment) ? environment.substring(0, 1) : "q";
        const cdnProvider = cdn.includes("cdn.") ? "cf" : "fd";
        const runtimeFile = runtimeUrl.split("/").pop()?.replace(".js", "");
        return `${envPrefix}_${cdnProvider}_${runtimeFile}`;
    }
    const runtimeOrigin = !!spaAppId || runtime === $ctGaZ.RUNTIME.CDN_LEGACY ? $19e7b8a0323531b4$var$replaceLegacyCDN(cdn) : origin;
    return new URL(runtimeUrl, runtimeOrigin).toString();
};
/**
 * Initializes App Sandbox:
 * 1. Updates Core with the current config
 * 2. Initializes Metrics
 * 3. Prefetch data if needed.
 * 4. Add dev util (On non-prod)
 * @param app - App Sandbox object.
 */ module.exports.getRuntimeParam = $19e7b8a0323531b4$var$getRuntimeParam;
const $19e7b8a0323531b4$var$initSandbox = (app)=>{
    const { context: context, metricsAppId: metricsAppId, solutionConfig: solutionConfig } = app;
    const { environment: environment } = context;
    const { exportName: exportName = "application" } = solutionConfig;
    if (!app.secondary) {
        // Secondary sandboxes (i.e. SandboxInner) should not update Unified Shell and EIM state.
        context.setSolutionConfig(solutionConfig);
        $19e7b8a0323531b4$var$setMetricsApplication(metricsAppId, solutionConfig);
    }
    $19e7b8a0323531b4$var$prefetchOnLoad(app); // Development mode configuration config function on the window which allows
    // developers to get the configuration for the current application, so they
    // don't have to generate it themselves.
    [
        "qa",
        "stage"
    ].includes(environment) && (window.shellDev = {
        getConfig: ()=>{
            const wrapper = {
                devmodeEnabled: true,
                solutions: {
                    [exportName]: solutionConfig
                }
            }; // eslint-disable-next-line no-console
            console.log(`window.localStorage.setItem('unifiedShellConfig', JSON.stringify(${JSON.stringify(wrapper, null, 2)}));`);
        }
    });
};
module.exports.initSandbox = $19e7b8a0323531b4$var$initSandbox;
const $19e7b8a0323531b4$var$hasConfigChanges = (prevContext, context, keys, ignorePreviousEmpty = false)=>!!prevContext && keys.some((key)=>(!ignorePreviousEmpty || prevContext[key] !== undefined) && !(0, $3Zpnv.deepEqual)(prevContext[key], context[key]));
/**
 * Gets the config for the SPA app by id. It uses the window.config.solutions
 * object to get the base config and uses feature flags to get a specific
 * version, if available.
 * @param spaAppId The AppId of the SPA-Pipeline SPA.
 * @param context - Core Context object.
 * @param metrics - App Sandbox metrics object.
 * @returns App config if set, undefined otherwise.
 */ module.exports.hasConfigChanges = $19e7b8a0323531b4$var$hasConfigChanges;
const $19e7b8a0323531b4$var$getSpaAppConfig = (spaAppId, { context: context, metrics: metrics })=>{
    const { featureFlags: featureFlags = {} } = context;
    const featureKey = `${spaAppId}_controlrollout`;
    const spaApp = {
        ...$19e7b8a0323531b4$var$getSpaApp(spaAppId) || {},
        spaName: spaAppId
    }; // If the AB testing flag isn't set, the feature flag isn't available for
    // the current spaApp, or the flag exists but is set to the LIVEVERSION
    // string, use the configuration provided by the content server.
    if (!spaApp.ABTesting || !(featureKey in featureFlags) || featureFlags[featureKey] === "LIVEVERSION") return spaApp;
     // Use the liveversion from the feature flag.
    const configVersion = spaApp.liveVersion;
    spaApp.liveVersion = featureFlags[featureKey];
    metrics.info(`${spaAppId} is using AB testing`, {
        configVersion: configVersion,
        liveVersion: spaApp.liveVersion,
        spaAppId: spaAppId
    });
    return spaApp;
};
module.exports.getSpaAppConfig = $19e7b8a0323531b4$var$getSpaAppConfig;
const $19e7b8a0323531b4$var$getBasePath = (app)=>{
    const { props: { params: params, path: path }, solutionConfig: solutionConfig } = app;
    const context = (0, $jVeiz.getContextFromPath)(path);
    const { path: justPath = "", tenant: tenant } = (0, $jVeiz.getTenantAndPath)((0, $jVeiz.getPathWithoutContext)(path));
    let basePath = justPath.replace(params[0] || "", "").replace(/\/$/, "") // Remove trailing slash
    .replace(/\/{2,}/, "/"); // Remove any double slashes
    // Ensure correct context is on the basepath
    if (context) basePath = `${context}${basePath}`;
     // Ensure correct base path if switching between tenanted and tenantless
    if (tenant && !solutionConfig.hideTenant) basePath = `/@${tenant}${basePath}`;
     // Secondary sandboxes (i.e. SandboxInner) should not update Unified Shell state.
    app.secondary || app.context.setConfigStates({
        basePath: basePath
    });
    return basePath;
};
/**
 * Determines whether we should wait for context updates to load the iframe.
 * This happens in the following cases:
 *  1. We want to delay discovery until we know that the org is permissioned on the solution.
 *  2. We want to delay discovery until we have all the url context information.
 *  3. IMS profile is required for discovery calls
 *  4. Access flag is defined in solution config, so feature flags are necessary
 *  5. SPA apps with AB testing enabled
 */ module.exports.getBasePath = $19e7b8a0323531b4$var$getBasePath;
const $19e7b8a0323531b4$var$shouldWaitForContextUpdates = (app, src)=>{
    const { context: { discoveryService: discoveryService, featureFlags: featureFlags, imsProfile: imsProfile, orgPermissioned: orgPermissioned, subOrg: subOrg }, solutionConfig: { access: { flag: flag } = {}, spaAppId: spaAppId, urlContext: urlContext } } = app;
    if (src) {
        const discoveryUrl = typeof src === "object";
        const urlNeedsImsInfo = discoveryUrl || !!src.match(/{[A-Za-z]+}/g);
        if (discoveryUrl) {
            if (!orgPermissioned) return $fi30R.ContextWaitingState.WAIT_FOR_PERMISSION;
            if (!discoveryService?.canGeneratePayload(src, app)) return $fi30R.ContextWaitingState.WAIT_FOR_DISCOVERY;
        }
        if (urlNeedsImsInfo && !imsProfile) return $fi30R.ContextWaitingState.WAIT_FOR_PROFILE;
    }
    if (flag && !featureFlags || spaAppId && $19e7b8a0323531b4$var$getSpaApp(spaAppId)?.ABTesting && !featureFlags) return $fi30R.ContextWaitingState.WAIT_FOR_FLAGS;
     // Stateless SPAs can start loading their iframe before sub org information is available.
    // For those SPAs "dontWaitForLoad" is true, Sandbox will instead wait for subOrg data
    // inside the "shouldSendConfiguration" method.
    if (urlContext?.key === "subOrg" && !urlContext.config.dontWaitForLoad && !subOrg) return imsProfile ? $fi30R.ContextWaitingState.WAIT_FOR_SUBORG : $fi30R.ContextWaitingState.WAIT_FOR_PROFILE;
    return false;
};
/**
 * Method to log shell info mismatches for EXC-34406. Can be removed after the ticket is resolved.
 */ module.exports.shouldWaitForContextUpdates = $19e7b8a0323531b4$var$shouldWaitForContextUpdates;
const $19e7b8a0323531b4$var$isShellInfoForIncorrectOrg = (app)=>{
    const { context: context, metrics: metrics } = app;
    const { shellInfo: shellInfo, imsOrg: imsOrg } = context; // If the org is different from what shellInfo was generated with, log to metrics.
    if ((shellInfo?.orgId || imsOrg) && shellInfo?.orgId !== imsOrg) {
        app.shellInfoIncorrect = true;
        return metrics.warn("ShellInfo: mismatch", {
            imsOrg: imsOrg ?? "n/a",
            shellInfoOrgId: shellInfo?.orgId ?? "n/a"
        });
    } // If a mismatch has been previously recorded and it has been fixed, log to metrics.
    if (app.shellInfoIncorrect) {
        app.shellInfoIncorrect = false;
        return metrics.info("ShellInfo: Fixed to be generated for correct org", {
            imsOrg: shellInfo?.orgId
        });
    }
};
/**
 * Gets the application source for the current environment - URL (String) or Discovery (Object)
 * @param app - App Sandbox object
 */ module.exports.isShellInfoForIncorrectOrg = $19e7b8a0323531b4$var$isShellInfoForIncorrectOrg;
const $19e7b8a0323531b4$var$getApplicationSourceUrl = (app)=>{
    const { context: context, historyType: historyType, metrics: metrics, solutionConfig: { appId: appId, sandbox: { pathPrefix: { default: prefix, dev: devPrefix, preHash: preHash } = {
        default: ""
    }, sources: sources }, spaAppId: spaAppId, thunderbird: thunderbird = $5jesu.THUNDERBIRD.OFF } } = app;
    const { config: { cdn: cdn, iframeUseSameOrigin: iframeUseSameOrigin } } = (0, $dDEjQ.getBootstrap)();
    const env = $19e7b8a0323531b4$var$getAppEnvironment(context, app.solutionConfig);
    let srcEnv = sources[env];
    const isHash = historyType === $ctGaZ.HISTORY.HASH; // If SpaAppId exists, set the config URL for the respective environment
    if (env && spaAppId && srcEnv === undefined) {
        const sameOrigin = iframeUseSameOrigin || thunderbird !== $5jesu.THUNDERBIRD.OFF;
        let spaOrigin = sameOrigin ? origin : cdn;
        let spaPath = thunderbird === $5jesu.THUNDERBIRD.SERVICE_WORKER ? $c3nD4.THUNDERBIRD_SPA_ROOT : $c3nD4.SPA_ROOT; // For skyline applications, we need to use the skyline path and window
        // origin if thunderbird is also enabled.
        if (thunderbird !== $5jesu.THUNDERBIRD.OFF && (0, $15j1u.isSkyline)()) spaPath = `${$19e7b8a0323531b4$var$AEM_BASE_PATH}${spaPath}`;
        else if ($19e7b8a0323531b4$var$isDifferentAppEnvironment(env, context)) // If the env is different from the current Shell environment, we shouldn't
        // be using the origin or cdn as they are the wrong environment. Grab the
        // correct value from the configuration.
        spaOrigin = (0, $1HQDe.getConfiguration)({
            environment: env
        }, "none").endpoints.cdn;
        srcEnv = `${spaOrigin}${spaPath}/${spaAppId}`; // Only add prefix if it's set. Not doing this can lead to an extra # at the
        // end of the srcEnv if no prefix exists.
        prefix && (srcEnv = `${srcEnv}${isHash && !preHash ? "#" : ""}${prefix}`);
    } else if (srcEnv && spaAppId && (devPrefix || prefix) && env === "dev") // If env is dev, append dev path prefix if it exists, even if it's an empty string.
    // Setting dev path prefix to '' will tell the framed application to ignore default path prefix.
    // Else, append default path prefix if it exists.
    srcEnv = `${srcEnv}${isHash && !preHash ? "#" : ""}${devPrefix ?? prefix}`;
    if (!env || !srcEnv) {
        metrics.error(`No matching configuration source for env ${env} in app ${appId}`);
        return;
    }
    return srcEnv;
};
module.exports.getApplicationSourceUrl = $19e7b8a0323531b4$var$getApplicationSourceUrl;
const $19e7b8a0323531b4$var$updateSourceWithParams = (src, forceReload, app)=>{
    const { props: props, solutionConfig: solutionConfig } = app;
    const { decodeUrl: decodeUrl, sandbox: { history: history } } = solutionConfig;
    const historyType = (0, $3Zpnv.getHistoryType)(solutionConfig);
    const { origin: origin1 } = window.location;
    const { absolutePaths: absolutePaths = false, addParamsToHash: addParamsToHash, hashType: hashType } = typeof history === "object" && history.config || {};
    const isHashType = historyType === $ctGaZ.HISTORY.HASH;
    const pathType = isHashType ? "hash" : "pathname";
    const updatedSrc = new URL(src.toString());
    let urlHashAsPath = (0, $jVeiz.hashToPath)(); // Append the correct path from the outer frame (useful for deep linking)
    // This should correct to the "right" url (e.g. the page that is initially
    // loaded) if our src is just the base (eg '/').
    const params = props.params[0] || "";
    if (params) {
        let path = hashType === $ctGaZ.HASH_TYPE.NOSLASH ? params : `/${params}`; // In some cases, like analytics, encoded URLs (for example links pasted
        // into slack) can break when loading in the iframe, so we clean them up
        if (!isHashType && decodeUrl) {
            path = path.replace(/%23/, "#").split("#")[0];
            urlHashAsPath = urlHashAsPath.replace(/%23/, "#");
        } // Replacing any duplicate slashes (e.g. //something) with a single slash
        // so that the URL is not broken.
        updatedSrc[pathType] = `${absolutePaths ? "" : src[pathType]}${path}`.replace(/([/]+)/g, "/");
    }
    const url = new URL(`${origin1}${urlHashAsPath}`); // If the history type isn't hash, the hash should be set.
    if (!isHashType) updatedSrc.hash = url.hash;
     // Append the search parameters to the hash if the solution config property
    // is set.
    if (isHashType && addParamsToHash) updatedSrc.hash += url.search;
    forceReload && updatedSrc.searchParams.set("shell_forceReload", Date.now().toString());
    return updatedSrc;
};
module.exports.updateSourceWithParams = $19e7b8a0323531b4$var$updateSourceWithParams;
const $19e7b8a0323531b4$var$updateTemplatedURL = (urlString, app, extraParams = {})=>{
    // Skyline url strings are allowed to be paths since the discovery call is
    // being made to the same origin that the user is already on.
    const { context: context, metrics: metrics, props: { params: params } } = app;
    let targetUrl = urlString;
    if ((0, $15j1u.isSkyline)() && targetUrl.startsWith("/")) targetUrl = `${window.location.origin}${targetUrl}`;
    const templateStrings = targetUrl.match(/{[A-Za-z0-1]+}/g);
    const url = new URL(window.location.href);
    let securityTest = targetUrl;
    if (templateStrings) {
        templateStrings.forEach((string)=>{
            const contextString = string.substring(1, string.length - 1);
            const replacement = contextString in context && context[contextString] || url.searchParams.get(contextString) || params[contextString] || extraParams[contextString];
            if (replacement) {
                targetUrl = targetUrl.replace(string, replacement); // Build a url for later host comparison
                securityTest = securityTest.replace(string, "test");
            }
        });
        const realUrl = new URL(targetUrl); // If we have the full URL, and it is an adobe domain, skip checks and return the url.
        if (realUrl.protocol === "https:" && realUrl.origin.endsWith("adobe.com")) return targetUrl;
        if (!securityTest.startsWith("https:")) {
            // Non adobe.com are not allowed through templates.
            metrics.event("Sandbox.nonAdobeTemplateDetected", {
                url: realUrl.toString()
            }, {
                level: $hCZmk.Level.ERROR
            });
            throw Error("Forbidden URL template detected");
        }
        const realUrlParts = realUrl.host.split(".");
        const testUrl = new URL(securityTest).host.split(".");
        if (realUrlParts[realUrlParts.length - 1] !== testUrl[realUrlParts.length - 1] || realUrlParts[realUrlParts.length - 2] !== testUrl[realUrlParts.length - 2]) {
            // The discovery template is being missused, possibly to direct a request with
            // a working token header to a malicious domain.
            metrics.event("Sandbox.urlInconsistencyDetected", {
                test: testUrl.toString(),
                url: realUrl.toString()
            }, {
                level: $hCZmk.Level.ERROR
            });
            throw Error("URL inconsistency detected");
        }
    }
    return targetUrl;
};
/**
 * Returns true if the app is alive and well.
 * @param app - App Sandbox object.
 */ module.exports.updateTemplatedURL = $19e7b8a0323531b4$var$updateTemplatedURL;
const $19e7b8a0323531b4$var$isAppHealthy = (app)=>app.mounted && !app.inErrorState() && !app.inNotFoundState();
module.exports.isAppHealthy = $19e7b8a0323531b4$var$isAppHealthy;
const $19e7b8a0323531b4$var$updateDigitalData = ({ secondary: secondary, solutionConfig: solutionConfig }, version = "")=>{
    if (secondary) // Only primary sandboxes should update digital data.
    return;
     // Builds the digital data object in case it doesn't exist yet.
    const digitalData = window.digitalData = window.digitalData || {};
    let ddObj = digitalData;
    [
        "page",
        "solution"
    ].forEach((key)=>{
        ddObj[key] = ddObj[key] || {};
        ddObj = ddObj[key];
    });
    const solution = {
        name: $19e7b8a0323531b4$var$getAnalyticsSolution(solutionConfig) || "exc"
    };
    version && (solution.version = version);
    digitalData.page.solution = {
        ...digitalData.page.solution,
        ...solution
    };
    (0, $iNslS.digitalDataUpdated)("page");
};
/**
 * Parse out the custom ims information from the context and return it if the
 * customIms property is set on the AppSandbox instance.
 * @param app - AppSandbox object.
 * @returns Custom IMS data if enabled, undefined otherwise.
 */ module.exports.updateDigitalData = $19e7b8a0323531b4$var$updateDigitalData;
const $19e7b8a0323531b4$var$getCustomImsData = (app)=>{
    const { context: context, customIms: customIms } = app;
    const { appProfile: imsProfile, appToken: imsToken, imsInfo: imsInfo } = context;
    if (customIms && imsToken) return {
        imsClientId: customIms.client_id,
        imsInfo: {
            ...imsInfo,
            imsProfile: imsProfile,
            imsToken: imsToken
        },
        imsProfile: imsProfile,
        imsToken: imsToken
    };
};
/**
 * Determines if the custom IMS token is valid for the current application.
 * Compares the client_id and user_id from the token to the customIms object and
 * imsProfile userId respectively.
 * @param app - AppSandbox object.
 * @returns Whether the custom IMS token is valid.
 */ module.exports.getCustomImsData = $19e7b8a0323531b4$var$getCustomImsData;
const $19e7b8a0323531b4$var$isValidCustomImsToken = (app)=>{
    const { context: context, customIms: customIms } = app;
    const { appToken: appToken, imsProfile: imsProfile } = context; // If customIms is not set, the token is valid.
    if (!customIms) return true;
     // Return early if there is no custom token as this means it's already invalid.
    if (!appToken) return false;
    const { client_id: client_id, user_id: user_id } = (0, $iNslS.extractTokenMetadata)(appToken) ?? {};
    const isValidClientId = client_id === customIms.client_id;
    const isValidUserId = user_id === imsProfile.userId; // Warn for specific validity checks when invalid.
    isValidClientId || app.metrics.warn("Custom IMS token client_id does not match customIms.client_id");
    isValidUserId || app.metrics.warn("Custom IMS token user_id does not match imsProfile.userId");
    return isValidClientId && isValidUserId;
};
module.exports.isValidCustomImsToken = $19e7b8a0323531b4$var$isValidCustomImsToken;
const $19e7b8a0323531b4$var$getAppController = ()=>(0, $ihFuI.getImpl)("internal");
module.exports.getAppController = $19e7b8a0323531b4$var$getAppController;

});
parcelRegister("fi30R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContextWaitingState = module.exports.AppEvents = module.exports.AuthType = module.exports.LoadState = module.exports.RecentStatus = module.exports.HTMLStatus = module.exports.PingResult = module.exports.AuthMessages = module.exports.ErrorTypes = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ let $1cfb14b091f6ac62$var$ErrorTypes;
module.exports.ErrorTypes = $1cfb14b091f6ac62$var$ErrorTypes;
(function(ErrorTypes) {
    ErrorTypes["COOKIE_NEEDED"] = "COOKIE_NEEDED";
    ErrorTypes["HTML_FAIL"] = "HTML_FAIL";
    ErrorTypes["LOCAL_TIMEOUT"] = "LOCAL_TIMEOUT";
    ErrorTypes["NO_SANDBOXES"] = "NO_SANDBOXES";
    ErrorTypes["NOT_FOUND"] = "NOT_FOUND";
    ErrorTypes["OFFLINE"] = "OFFLINE";
    ErrorTypes["RATE_LIMIT"] = "RATE_LIMIT";
    ErrorTypes["SANDBOX_FAIL"] = "SANDBOX_FAIL";
    ErrorTypes["SUBORG_FAIL"] = "SUBORG_FAIL";
    ErrorTypes["TIMEOUT"] = "TIMEOUT";
    ErrorTypes["UNKNOWN"] = "UNKNOWN";
})($1cfb14b091f6ac62$var$ErrorTypes || (module.exports.ErrorTypes = $1cfb14b091f6ac62$var$ErrorTypes = {}));
let $1cfb14b091f6ac62$var$AuthMessages;
module.exports.AuthMessages = $1cfb14b091f6ac62$var$AuthMessages;
(function(AuthMessages) {
    AuthMessages["LOGIN"] = "LOGIN";
    AuthMessages["LOGOUT"] = "LOGOUT";
})($1cfb14b091f6ac62$var$AuthMessages || (module.exports.AuthMessages = $1cfb14b091f6ac62$var$AuthMessages = {}));
let $1cfb14b091f6ac62$var$PingResult;
module.exports.PingResult = $1cfb14b091f6ac62$var$PingResult;
(function(PingResult) {
    PingResult["FAILED"] = "FAILED";
    PingResult["PENDING"] = "PENDING";
    PingResult["SUCCESS"] = "SUCCESS";
})($1cfb14b091f6ac62$var$PingResult || (module.exports.PingResult = $1cfb14b091f6ac62$var$PingResult = {}));
let $1cfb14b091f6ac62$var$HTMLStatus;
module.exports.HTMLStatus = $1cfb14b091f6ac62$var$HTMLStatus;
(function(HTMLStatus) {
    HTMLStatus["CORRUPT"] = "CORRUPT";
    HTMLStatus["HEADERLIMIT"] = "HEADER_LIMIT";
    HTMLStatus["OK"] = "OK";
    HTMLStatus["OUTDATED"] = "OUTDATED";
    HTMLStatus["PENDING"] = "PENDING";
    HTMLStatus["TIMEOUT"] = "TIMEOUT";
    HTMLStatus["UNREACHABLE"] = "UNREACHABLE";
})($1cfb14b091f6ac62$var$HTMLStatus || (module.exports.HTMLStatus = $1cfb14b091f6ac62$var$HTMLStatus = {}));
let $1cfb14b091f6ac62$var$RecentStatus;
module.exports.RecentStatus = $1cfb14b091f6ac62$var$RecentStatus;
(function(RecentStatus) {
    RecentStatus["ERROR"] = "ERROR";
    RecentStatus["LOADING"] = "LOADING";
    RecentStatus["SUCCESS"] = "SUCCESS";
})($1cfb14b091f6ac62$var$RecentStatus || (module.exports.RecentStatus = $1cfb14b091f6ac62$var$RecentStatus = {}));
let $1cfb14b091f6ac62$var$LoadState;
module.exports.LoadState = $1cfb14b091f6ac62$var$LoadState;
(function(LoadState) {
    LoadState[LoadState["INIT"] = 0] = "INIT";
    LoadState[LoadState["LOAD_START"] = 1] = "LOAD_START";
    LoadState[LoadState["LOADED"] = 2] = "LOADED";
    LoadState[LoadState["TIMEOUT"] = 3] = "TIMEOUT";
})($1cfb14b091f6ac62$var$LoadState || (module.exports.LoadState = $1cfb14b091f6ac62$var$LoadState = {}));
let $1cfb14b091f6ac62$var$AuthType;
module.exports.AuthType = $1cfb14b091f6ac62$var$AuthType;
(function(AuthType) {
    AuthType["TYPE1"] = "ind";
    AuthType["TYPE2E"] = "eoa";
    AuthType["TYPE3"] = "fed";
})($1cfb14b091f6ac62$var$AuthType || (module.exports.AuthType = $1cfb14b091f6ac62$var$AuthType = {}));
let $1cfb14b091f6ac62$var$AppEvents;
module.exports.AppEvents = $1cfb14b091f6ac62$var$AppEvents;
(function(AppEvents) {
    AppEvents["SLOW"] = "SLOW";
    AppEvents["TIMEOUT"] = "TIMEOUT";
})($1cfb14b091f6ac62$var$AppEvents || (module.exports.AppEvents = $1cfb14b091f6ac62$var$AppEvents = {}));
let $1cfb14b091f6ac62$var$ContextWaitingState;
module.exports.ContextWaitingState = $1cfb14b091f6ac62$var$ContextWaitingState;
(function(ContextWaitingState) {
    ContextWaitingState["WAIT_FOR_DISCOVERY"] = "DISCOVERY";
    ContextWaitingState["WAIT_FOR_PERMISSION"] = "PERMISSION";
    ContextWaitingState["WAIT_FOR_PROFILE"] = "PROFILE";
    ContextWaitingState["WAIT_FOR_SUBORG"] = "SUBORG";
    ContextWaitingState["WAIT_FOR_FLAGS"] = "FLAGS";
})($1cfb14b091f6ac62$var$ContextWaitingState || (module.exports.ContextWaitingState = $1cfb14b091f6ac62$var$ContextWaitingState = {}));

});

parcelRegister("3Zpnv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isInternal = $4cf4a05b64b14b6c$var$isInternal;
module.exports.isOrgOrSubOrgChange = $4cf4a05b64b14b6c$var$isOrgOrSubOrgChange;
module.exports.getOrgMetadata = $4cf4a05b64b14b6c$var$getOrgMetadata;
module.exports.debounce = $4cf4a05b64b14b6c$var$debounce;
module.exports.getAvatarUrls = $4cf4a05b64b14b6c$var$getAvatarUrls;
module.exports.getValidSourcesRegexString = $4cf4a05b64b14b6c$var$getValidSourcesRegexString;
module.exports.runInBackground = $4cf4a05b64b14b6c$var$runInBackground;
module.exports.staleWhileRevalidate = $4cf4a05b64b14b6c$var$staleWhileRevalidate;
module.exports.orgHasServiceCode = $4cf4a05b64b14b6c$var$orgHasServiceCode;
module.exports.isCustomTokenValid = module.exports.allOrgsInProfile = module.exports.generateUserHash = module.exports.getHistoryType = module.exports.resetSolutionId = module.exports.deepEqual = module.exports.waitForGainsightInit = module.exports.waitForGainsightCallback = void 0;

var $iNslS = parcelRequire("iNslS");

var $jVeiz = parcelRequire("jVeiz");

var $4cf4a05b64b14b6c$var$_stringHash = $4cf4a05b64b14b6c$var$_interopRequireDefault((parcelRequire("h9eEw")));

var $9OLey = parcelRequire("9OLey");

var $17AVh = parcelRequire("17AVh");
function $4cf4a05b64b14b6c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $4cf4a05b64b14b6c$var$w = window;
const $4cf4a05b64b14b6c$var$INTERNAL_EMAIL_DOMAINS = [
    "([a-z]*.)?adobe.com",
    "([a-z]*.)?adobevlab.com",
    "adobe-aemmson.com",
    "adobecreate.com",
    "adobedemo.com",
    "adobedemo.de",
    "adobeeventlab.com",
    "adobetest.com",
    "omniture.com",
    "tryadobe.com"
];
const $4cf4a05b64b14b6c$var$EMAIL_REGEX = new RegExp(`^(${$4cf4a05b64b14b6c$var$INTERNAL_EMAIL_DOMAINS.join("|")})$`, "i");
/**
 * Returns true if the user is an internal user.
 * @param email The user's email address.
 * @returns True if the user is an internal user.
 */ function $4cf4a05b64b14b6c$var$isInternal(email) {
    return $4cf4a05b64b14b6c$var$EMAIL_REGEX.test(email.split("@")[1]);
}
/**
 * Returns true if the navigation was an org change.
 * @param {string} oldPath window location pathname.
 * @param {string} newPath history location pathname.
 * @returns {boolean} Returns true if the navigation was an org change.
 */ function $4cf4a05b64b14b6c$var$isOrgOrSubOrgChange(oldPath, newPath) {
    const oldPathArr = oldPath.split("/");
    const newPathArr = newPath.split("/"); // Check if the tenant has changed
    if (oldPathArr[1] !== newPathArr[1]) return true;
     // Check if the suborg has changed
    if ((0, $jVeiz.getValueFromPath)(oldPath, "so") !== (0, $jVeiz.getValueFromPath)(newPath, "so")) return true;
     // If the length is not the same, more has changed than just the tenant meaning
    // it is not an org change.
    if (oldPathArr.length !== newPathArr.length) return false;
     // Because we are splitting by '/' arr[0] will be "" and arr[1] will be the tenant.
    for(let i = 2; i < oldPathArr.length - 1; i++){
        if (oldPathArr[i] !== newPathArr[i]) return false;
    }
    return oldPathArr[1] !== newPathArr[1];
}
/**
 * Get name and acp region of org.
 * @param {string} org String with org.
 * @param {ImsOrganization[]} map List of orgs.
 * @returns {orgMetadata} Org name and Org region.
 */ function $4cf4a05b64b14b6c$var$getOrgMetadata(org, map) {
    const { orgName: orgName, aepRegion: orgRegion } = map.find(({ imsOrgId: imsOrgId })=>imsOrgId === org) || {};
    return {
        orgName: orgName,
        orgRegion: orgRegion
    };
}
/**
 * Debounce a function for the provided wait amount in ms.
 * @param {function} callback - The callback to call once the wait period is over.
 * @param {number} wait - The amount of time to wait in milliseconds.
 * @returns {function}
 */ function $4cf4a05b64b14b6c$var$debounce(callback, wait) {
    let timeout;
    /**
   * Function that does the debouncing.
   */ return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(()=>callback(...args), wait);
    };
}
/**
 * Gets the preferred avatar URL from the PPS payload.
 * @param {AvatarData} avatar PPS avatar information.
 * @param {number[]} sizes Array of preferred sizes, ordered by preference.
 * @returns {AvatarUrls} Avatar URL and Data URL.
 */ function $4cf4a05b64b14b6c$var$getAvatarUrls(avatar, sizes) {
    if (avatar && avatar.images) {
        const size = sizes.find((s)=>avatar.images[String(s)]);
        return {
            avatar: avatar.images[String(size)],
            avatarSrc: avatar.encodedImage ? `data:image/jpeg;base64, ${avatar.encodedImage}` : undefined
        };
    }
    return {};
}
const $4cf4a05b64b14b6c$var$gainsightPromise = {
    promise: undefined
};
const $4cf4a05b64b14b6c$var$gainsightInitPromise = {
    promise: undefined
};
const $4cf4a05b64b14b6c$var$pollForCondition = (check, interval, maxAttempts, promiseContainer)=>{
    if (promiseContainer?.promise) return promiseContainer.promise;
    const promise = new Promise((resolve, reject)=>{
        let cnt = 0;
        const poll = ()=>{
            cnt++;
            const result = check();
            if (result) resolve(result);
            else if (cnt >= maxAttempts) {
                // Reset the promise, so it can be retried later on.
                promiseContainer && (promiseContainer.promise = undefined);
                reject(new Error(`Condition not met after ${maxAttempts} attempts`));
            } else setTimeout(poll, interval);
        };
        poll();
    });
    promiseContainer && (promiseContainer.promise = promise);
    return promise;
};
/**
 * Promise for grabbing the gainsight callback off of the window. This will
 * be used to trigger when a new app is loaded. This method only runs the
 * promise on the first run and caches the result for future calls.
 * @returns The promise that will include the callback.
 */ const $4cf4a05b64b14b6c$var$waitForGainsightCallback = ()=>$4cf4a05b64b14b6c$var$pollForCondition(()=>$4cf4a05b64b14b6c$var$w.initGainsight, 500, 10, $4cf4a05b64b14b6c$var$gainsightPromise);
/**
 * Promise that waits for Gainsight to be initialized in the Unified Shell frame.
 */ module.exports.waitForGainsightCallback = $4cf4a05b64b14b6c$var$waitForGainsightCallback;
const $4cf4a05b64b14b6c$var$waitForGainsightInit = ()=>$4cf4a05b64b14b6c$var$pollForCondition(()=>$4cf4a05b64b14b6c$var$w.aptrinsic?.init, 500, 20, $4cf4a05b64b14b6c$var$gainsightInitPromise);
/**
 * Enhances security and defense against HTML injections on post messages.
 * @returns {string} Valid source strings translated to a regex string.
 */ module.exports.waitForGainsightInit = $4cf4a05b64b14b6c$var$waitForGainsightInit;
function $4cf4a05b64b14b6c$var$getValidSourcesRegexString() {
    const frameSrc = $4cf4a05b64b14b6c$var$w.config.csp?.frameSrc || [];
    if (!frameSrc.length) return /.*/;
    let regexSources = "";
    frameSrc.filter((str)=>!str.includes("blob:")).map((str)=>{
        str = str.replace(/\./g, "\\.").replace(/\*/g, ".*").replace(/\/\//g, "\\/\\/");
        regexSources += `${str}$|`;
    });
    return new RegExp(regexSources.slice(0, -2));
}
/**
 * Wait for idle time to execute.
 * (On browsers supporting the requestIdleCallback API)
 * @param {boolean} background - Wait for idle? (Defaults to true)
 */ function $4cf4a05b64b14b6c$var$runInBackground(background = true) {
    const requestCallback = $4cf4a05b64b14b6c$var$w.requestIdleCallback ? $4cf4a05b64b14b6c$var$w.requestIdleCallback : (callback)=>callback();
    if (background) return new Promise((resolve)=>requestCallback(resolve));
    return Promise.resolve();
}
/**
 * Executes a request using a stale-while-revalidate strategy.
 * If data already exists, return it right away and fetch in the background.
 * Otherwise, fetch.
 * @template T
 * @param {() => Promise<T>} getPromise A function to request data.
 * @param {T} cached cached data (Or undefined if no data cached)
 * @param {boolean} runImmediate Whether or not to wait until page is idle to execute promise.
 * @param {err => void} onBackgroundError (Optional) Error handler for background requests only.
 */ function $4cf4a05b64b14b6c$var$staleWhileRevalidate(getPromise, cached, runImmediate = false, onBackgroundError) {
    if (cached) {
        (runImmediate ? Promise.resolve() : $4cf4a05b64b14b6c$var$runInBackground()).then(getPromise).catch((err)=>onBackgroundError && onBackgroundError(err));
        return Promise.resolve(cached);
    }
    return getPromise();
}
function $4cf4a05b64b14b6c$var$orgHasServiceCode(imsOrg, imsProfile, serviceCode) {
    const serviceCodes = typeof serviceCode === "string" ? [
        serviceCode
    ] : serviceCode;
    if (imsOrg && imsProfile?.projectedProductContext) {
        for (const code of serviceCodes){
            const pc = imsProfile.projectedProductContext.find(({ prodCtx: prodCtx = {} })=>prodCtx.owningEntity === imsOrg && prodCtx.serviceCode === code);
            if (!pc) return false;
        }
        return true;
    }
    return false;
}
const $4cf4a05b64b14b6c$var$deepEqual = (x, y)=>{
    const ok = Object.keys, tx = typeof x, ty = typeof y;
    return x && y && tx === "object" && tx === ty ? ok(x).length === ok(y).length && ok(x).every((key)=>$4cf4a05b64b14b6c$var$deepEqual(x[key], y[key])) : x === y;
};
module.exports.deepEqual = $4cf4a05b64b14b6c$var$deepEqual;
const $4cf4a05b64b14b6c$var$resetSolutionId = ()=>$9OLey.Internal.setApplication({
        solution: {
            id: "n/a"
        }
    });
/**
 * Returns the application's history type (Hash, History or Server)
 * @param history - History configuration
 * @returns history type (HASH/HISTORY/SERVER)
 */ module.exports.resetSolutionId = $4cf4a05b64b14b6c$var$resetSolutionId;
const $4cf4a05b64b14b6c$var$getHistoryType = ({ sandbox: { history: history } })=>typeof history === "object" ? history.type : history;
/**
 * Returns a hash value of the email address.
 * @param email - User's email address.
 * @returns hash value of the email address.
 */ module.exports.getHistoryType = $4cf4a05b64b14b6c$var$getHistoryType;
const $4cf4a05b64b14b6c$var$generateUserHash = (email)=>{
    if (email) {
        email = email.toLowerCase();
        return `${email.substring(0, 2)}${(0, $4cf4a05b64b14b6c$var$_stringHash.default)(email)}`;
    }
    return undefined;
};
/**
 * Checks if all org names for profile are available.
 * @param {array} orgsMap - Array of org names
 * @param {IMSProfile} profile - IMS Profile
 *
 * @returns {boolean} True if all profile orgs are in map, false otherwise.
 */ module.exports.generateUserHash = $4cf4a05b64b14b6c$var$generateUserHash;
const $4cf4a05b64b14b6c$var$allOrgsInProfile = (orgsMap, profile, metrics)=>{
    try {
        if (orgsMap && orgsMap.length && profile) {
            const pcEntries = profile.projectedProductContext.filter((pc)=>pc.prodCtx.serviceCode === "dma_tartan").map((pc)=>pc.prodCtx.owningEntity);
            const orgs = orgsMap.map((org)=>org.imsOrgId);
            if (pcEntries.every((org)=>orgs.includes(org))) return true;
            metrics.event("Core.cachedOrgsStale");
            return false;
        }
        profile && metrics.event("Core.noCachedOrgs");
    } catch (err) {
        const errMsg = (0, $iNslS.getErrorMessage)(err);
        metrics.event("Core.cachedOrgsError", {
            err: errMsg
        }, {
            level: $17AVh.Level.ERROR
        });
    }
    return false;
};
/**
 * Determine if the customToken argument is valid for the customIms argument.
 * @param customIms IMS client object to validate against.
 * @param customToken Token to validate.
 * @returns True if the token is valid for the client, false otherwise.
 */ module.exports.allOrgsInProfile = $4cf4a05b64b14b6c$var$allOrgsInProfile;
const $4cf4a05b64b14b6c$var$isCustomTokenValid = (customIms, customToken)=>{
    if (!customIms || !customToken) return false;
    const sortScopes = (scopes)=>scopes?.split(",").sort().join(",");
    const { client_id: client_id, scope: scope } = (0, $iNslS.extractTokenMetadata)(customToken) || {};
    return client_id === customIms.client_id && sortScopes(scope) === sortScopes(customIms.scopes);
};
module.exports.isCustomTokenValid = $4cf4a05b64b14b6c$var$isCustomTokenValid;

});

parcelRegister("ctGaZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "RELEASE_SCOPE", {
    enumerable: true,
    get: function() {
        return $5jesu.RELEASE_SCOPE;
    }
});
Object.defineProperty(module.exports, "RELEASE_TYPE", {
    enumerable: true,
    get: function() {
        return $5jesu.RELEASE_TYPE;
    }
});
Object.defineProperty(module.exports, "THUNDERBIRD", {
    enumerable: true,
    get: function() {
        return $5jesu.THUNDERBIRD;
    }
});
module.exports.HASH_TYPE = module.exports.THEME = module.exports.RUNTIME = module.exports.HISTORY = module.exports.PDH_GLOBAL = module.exports.SessionScope = void 0;

var $5jesu = parcelRequire("5jesu");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // eslint-disable-next-line no-unused-vars
let $b2fdbbf1fdece932$var$SessionScope;
module.exports.SessionScope = $b2fdbbf1fdece932$var$SessionScope;
(function(SessionScope) {
    SessionScope["USER"] = "user";
    SessionScope["ORG"] = "org";
    SessionScope["CONTEXT"] = "context";
})($b2fdbbf1fdece932$var$SessionScope || (module.exports.SessionScope = $b2fdbbf1fdece932$var$SessionScope = {}));
let $b2fdbbf1fdece932$var$PDH_GLOBAL;
module.exports.PDH_GLOBAL = $b2fdbbf1fdece932$var$PDH_GLOBAL;
(function(PDH_GLOBAL) {
    PDH_GLOBAL["AA"] = "aa";
    PDH_GLOBAL["WEBSDK"] = "websdk";
    PDH_GLOBAL["BOTH"] = "both";
})($b2fdbbf1fdece932$var$PDH_GLOBAL || (module.exports.PDH_GLOBAL = $b2fdbbf1fdece932$var$PDH_GLOBAL = {}));
let $b2fdbbf1fdece932$var$HISTORY;
module.exports.HISTORY = $b2fdbbf1fdece932$var$HISTORY;
(function(HISTORY) {
    HISTORY["HASH"] = "HASH";
    HISTORY["HISTORY"] = "HISTORY";
    HISTORY["SERVER"] = "SERVER";
})($b2fdbbf1fdece932$var$HISTORY || (module.exports.HISTORY = $b2fdbbf1fdece932$var$HISTORY = {}));
let $b2fdbbf1fdece932$var$RUNTIME;
module.exports.RUNTIME = $b2fdbbf1fdece932$var$RUNTIME;
(function(RUNTIME) {
    RUNTIME[RUNTIME["LEGACY"] = 0] = "LEGACY";
    RUNTIME[RUNTIME["CDN_LEGACY"] = 1] = "CDN_LEGACY";
    RUNTIME[RUNTIME["CDN"] = 2] = "CDN";
})($b2fdbbf1fdece932$var$RUNTIME || (module.exports.RUNTIME = $b2fdbbf1fdece932$var$RUNTIME = {}));
let $b2fdbbf1fdece932$var$THEME;
module.exports.THEME = $b2fdbbf1fdece932$var$THEME;
(function(THEME) {
    THEME["DARK"] = "darkest";
    THEME["LIGHT"] = "lightest";
})($b2fdbbf1fdece932$var$THEME || (module.exports.THEME = $b2fdbbf1fdece932$var$THEME = {}));
let $b2fdbbf1fdece932$var$HASH_TYPE;
module.exports.HASH_TYPE = $b2fdbbf1fdece932$var$HASH_TYPE;
(function(HASH_TYPE) {
    HASH_TYPE["NOSLASH"] = "noslash";
})($b2fdbbf1fdece932$var$HASH_TYPE || (module.exports.HASH_TYPE = $b2fdbbf1fdece932$var$HASH_TYPE = {}));

});
parcelRegister("5jesu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.THUNDERBIRD = module.exports.SRC_DOC = module.exports.RELEASE_TYPE = module.exports.RELEASE_SCOPE = module.exports.ObservableType = void 0;

var $ihFuI = parcelRequire("ihFuI");
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * APIs that let solutions interact with the main page and personalize it, e.g. setting the title,
 * favicon, refreshing the solution iframe, etc.
 *
 * ***Import:***
 *
 * ```typescript
 * import page from '@adobe/exc-app/page';
 * ```
 *
 * ***Default export:***
 *
 * [PageApi](../interfaces/page.pageapi.md#interface-pageapi)
 *
 * ***Usage:***
 *
 * ```typescript
 * import page from '@adobe/exc-app/page';
 *
 * page.title = 'Experience Cloud';
 *
 * // Show spinner while performing an async operation
 * page.spinner = true;
 * try {
 *   await performOperation();
 * } finally {
 *   page.spinner = false;
 * }
 *
 * // Generate a shell URL that directly opens the specified solution URL
 * const shellUrl = page.generateShellUrl('/relative/path');
 *
 * // Navigate to another solution
 * page.shellRedirect('/target');
 * ```
 * @packageDocumentation
 * @module page
 */ let $f99b35ee625c3ad1$var$ObservableType;
/**
 * Scope for the solution's release type in the product lifecycle
 */ module.exports.ObservableType = $f99b35ee625c3ad1$var$ObservableType;
(function(ObservableType) {
    ObservableType["MODAL"] = "MODAL";
    ObservableType["POPOVER"] = "POPOVER";
})($f99b35ee625c3ad1$var$ObservableType || (module.exports.ObservableType = $f99b35ee625c3ad1$var$ObservableType = {}));
let $f99b35ee625c3ad1$var$RELEASE_SCOPE;
/**
 * Solution's release type in the product lifecycle
 */ module.exports.RELEASE_SCOPE = $f99b35ee625c3ad1$var$RELEASE_SCOPE;
(function(RELEASE_SCOPE) {
    RELEASE_SCOPE["PARENT"] = "parent";
    RELEASE_SCOPE["SELF"] = "self";
})($f99b35ee625c3ad1$var$RELEASE_SCOPE || (module.exports.RELEASE_SCOPE = $f99b35ee625c3ad1$var$RELEASE_SCOPE = {}));
let $f99b35ee625c3ad1$var$RELEASE_TYPE;
/**
 * @deprecated Solution's list of multiple subdomains
 */ module.exports.RELEASE_TYPE = $f99b35ee625c3ad1$var$RELEASE_TYPE;
(function(RELEASE_TYPE) {
    RELEASE_TYPE["POC"] = "poc";
    RELEASE_TYPE["DEV"] = "dev";
    RELEASE_TYPE["ALPHA"] = "alpha";
    RELEASE_TYPE["BETA"] = "beta";
    RELEASE_TYPE["GA"] = "ga";
})($f99b35ee625c3ad1$var$RELEASE_TYPE || (module.exports.RELEASE_TYPE = $f99b35ee625c3ad1$var$RELEASE_TYPE = {}));
let $f99b35ee625c3ad1$var$SRC_DOC;
module.exports.SRC_DOC = $f99b35ee625c3ad1$var$SRC_DOC;
(function(SRC_DOC) {
    SRC_DOC[SRC_DOC["DISABLED"] = 0] = "DISABLED";
    SRC_DOC[SRC_DOC["HTML"] = 1] = "HTML";
    SRC_DOC[SRC_DOC["MANIFEST"] = 2] = "MANIFEST";
})($f99b35ee625c3ad1$var$SRC_DOC || (module.exports.SRC_DOC = $f99b35ee625c3ad1$var$SRC_DOC = {}));
let $f99b35ee625c3ad1$var$THUNDERBIRD;
module.exports.THUNDERBIRD = $f99b35ee625c3ad1$var$THUNDERBIRD;
(function(THUNDERBIRD) {
    THUNDERBIRD[THUNDERBIRD["OFF"] = 0] = "OFF";
    THUNDERBIRD[THUNDERBIRD["SRC_DOC"] = 1] = "SRC_DOC";
    THUNDERBIRD[THUNDERBIRD["SERVICE_WORKER"] = 2] = "SERVICE_WORKER";
})($f99b35ee625c3ad1$var$THUNDERBIRD || (module.exports.THUNDERBIRD = $f99b35ee625c3ad1$var$THUNDERBIRD = {}));
const $f99b35ee625c3ad1$var$page = (0, $ihFuI.connect)("page", [
    [
        "afterPrintHandler"
    ],
    [
        "appContainer"
    ],
    [
        "beforePrintHandler"
    ],
    [
        "blockNavigation",
        true
    ],
    [
        "clipboardWrite",
        true
    ],
    [
        "done",
        true
    ],
    [
        "generateShellUrl",
        true
    ],
    [
        "getModalQuerySelectors"
    ],
    [
        "getObservableQuerySelectors"
    ],
    [
        "favicon"
    ],
    [
        "iframeReload",
        true
    ],
    [
        "modal"
    ],
    [
        "modalAutoDetect"
    ],
    [
        "notFound",
        true
    ],
    [
        "openInNewTab",
        true
    ],
    [
        "preventDefaultCombos"
    ],
    [
        "print",
        true
    ],
    [
        "reloadSandbox",
        true
    ],
    [
        "shellRedirect",
        true
    ],
    [
        "setModalQuerySelectors"
    ],
    [
        "setObservableQuerySelectors"
    ],
    [
        "spinner"
    ],
    [
        "title"
    ],
    [
        "toggleAutoDetect"
    ],
    [
        "unloadPromptMessage"
    ]
]);
var $f99b35ee625c3ad1$var$_default = $f99b35ee625c3ad1$var$page;
module.exports.default = $f99b35ee625c3ad1$var$_default;

});


parcelRegister("7rHmB", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = Promise.all([
    $Ha5sG("ds4Wh"),
    $Ha5sG("jrioA")
]).then(()=>parcelRequire("dlwiS"));

});


parcelRegister("1ELZt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pdhGlobalMap = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $61d5e089fe9aff56$var$pdhGlobalMap = {
    [$ctGaZ.PDH_GLOBAL.AA]: {
        scripts: {
            dev: `https://exc-unifiedcontent.experience-stage.adobe.net/static/launch/a7d65461e54e/9facf15f232c/launch-72ef4c8b9d13-development.min.js`,
            qa: `https://exc-unifiedcontent.experience-stage.adobe.net/static/launch/a7d65461e54e/9facf15f232c/launch-72ef4c8b9d13-development.min.js`,
            stage: `https://exc-unifiedcontent.experience-stage.adobe.net/static/launch/a7d65461e54e/9facf15f232c/launch-5ec5233fa57f-staging.min.js`,
            prod: `https://exc-unifiedcontent.experience.adobe.net/static/launch/a7d65461e54e/9facf15f232c/launch-d7625967ab29.min.js`
        }
    },
    [$ctGaZ.PDH_GLOBAL.WEBSDK]: {
        scripts: {
            dev: "https://exc-unifiedcontent.experience-stage.adobe.net/static/launch/a7d65461e54e/42cd47aaea34/launch-7a9519e58acb-development.min.js",
            qa: "https://exc-unifiedcontent.experience-stage.adobe.net/static/launch/a7d65461e54e/42cd47aaea34/launch-7a9519e58acb-development.min.js",
            stage: "https://exc-unifiedcontent.experience-stage.adobe.net/static/launch/a7d65461e54e/42cd47aaea34/launch-f9d24f81368c-staging.min.js",
            prod: "https://exc-unifiedcontent.experience.adobe.net/static/launch/a7d65461e54e/42cd47aaea34/launch-27e001f5444b.min.js"
        }
    },
    [$ctGaZ.PDH_GLOBAL.BOTH]: {
        scripts: {
            dev: "https://exc-unifiedcontent.experience-stage.adobe.net/static/launch/a7d65461e54e/799ee354b05f/launch-0c3516d9a43b-development.min.js",
            qa: "https://exc-unifiedcontent.experience-stage.adobe.net/static/launch/a7d65461e54e/799ee354b05f/launch-0c3516d9a43b-development.min.js",
            stage: "https://exc-unifiedcontent.experience-stage.adobe.net/static/launch/a7d65461e54e/799ee354b05f/launch-7ee01764bcdd-staging.min.js",
            prod: "https://exc-unifiedcontent.experience.adobe.net/static/launch/a7d65461e54e/799ee354b05f/launch-38f35b9cfbad.min.js"
        }
    }
};
module.exports.pdhGlobalMap = $61d5e089fe9aff56$var$pdhGlobalMap;

});


parcelRegister("bzq4v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Router = $3ca89b4ffa40120c$var$Router;
module.exports.Route = $3ca89b4ffa40120c$var$Route;
module.exports.history = module.exports.setUserConfirmationCallback = void 0;

var $7eprg = parcelRequire("7eprg");

var $3wBe4 = parcelRequire("3wBe4");

var $9B59M = parcelRequire("9B59M");

var $jAW8V = parcelRequire("jAW8V");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ let $3ca89b4ffa40120c$var$userConfirmationCallback;
const $3ca89b4ffa40120c$var$setUserConfirmationCallback = (fn)=>{
    $3ca89b4ffa40120c$var$userConfirmationCallback = fn;
};
module.exports.setUserConfirmationCallback = $3ca89b4ffa40120c$var$setUserConfirmationCallback;
const $3ca89b4ffa40120c$var$defaultHistory = (0, $3wBe4.createHashHistory)({
    getUserConfirmation (message, callback) {
        $3ca89b4ffa40120c$var$userConfirmationCallback?.(message, callback);
    }
});
module.exports.history = $3ca89b4ffa40120c$var$defaultHistory;
function $3ca89b4ffa40120c$var$matchRoute(pathTemplate, testPath, exact) {
    const exactModifier = exact || pathTemplate.endsWith("/") ? "" : "/(.*)?";
    const keys = []; // Can we cache these? or even the children maybe using keys on routes for simplicity
    const regexp = (0, $jAW8V.pathToRegexp)(`${pathTemplate}${exactModifier}`, keys);
    const matchingRoute = regexp.exec(testPath);
    if (!matchingRoute) return [
        false,
        {}
    ];
     // construct the params thing for backwards compat
    const params = {};
    keys.forEach((key, index)=>{
        const routeParam = matchingRoute[index + 1];
        if (routeParam) params[key.name] = routeParam;
    });
    return [
        true,
        params
    ];
}
function $3ca89b4ffa40120c$var$Router({ children: children, history: history }) {
    const routerHistory = (0, $7eprg.useRef)(history || $3ca89b4ffa40120c$var$defaultHistory);
    const [currentLocation, setCurrentLocation] = (0, $7eprg.useState)(routerHistory.current.location);
    (0, $7eprg.useEffect)(()=>{
        const updateRoute = (location)=>{
            if (location !== currentLocation) setCurrentLocation(location);
        };
        const unlisten = routerHistory.current.listen(updateRoute);
        updateRoute(routerHistory.current.location);
        return ()=>unlisten();
    }, []);
    let params = {}; // iterate over each child to test whether the redirect or route matches.
    const childrenArray = $7eprg.Children.toArray(children);
    const matchingChild = childrenArray.find((child)=>{
        if (!/*#__PURE__*/ (0, $7eprg.isValidElement)(child)) return false;
        const { exact: exact, path: path, redirect: redirect } = child.props; // test all routes with paths
        if (path) {
            const [isMatch, matchParams] = $3ca89b4ffa40120c$var$matchRoute(path, currentLocation.pathname, exact);
            if (isMatch) params = matchParams;
             // test redirects
            if (typeof redirect === "function" && isMatch) {
                const redirectResult = redirect({
                    route: `${currentLocation.pathname}${currentLocation.search}${currentLocation.hash}`
                });
                if (redirectResult) {
                    routerHistory.current.replace(redirectResult);
                    return true;
                }
                return false;
            }
            return isMatch;
        } // if there is a route with no path, and we are here, then this is it!
        return true;
    }); // this is for backwards compatibility only with older router
    const { hash: hash, pathname: pathname, search: search } = currentLocation;
    const cleanQuery = search.startsWith("?") ? search.substring(1) : search;
    const legacyProps = {
        hash: hash.substring(1),
        // The match function is only used in sandbox today, and strictly to figure
        // out whether during a redirect whether the new app that is being loaded
        // has the same appId as the new one.
        // We skip parsing or returning redirects, since they redirect us to another
        // route that we will find anyways later in the children array (as opposed
        // to following them and having to do a recursive function).
        match: (testPath)=>$7eprg.Children.toArray(children).find((child)=>{
                if (child && /*#__PURE__*/ (0, $7eprg.isValidElement)(child) && child.props.path) {
                    const { exact: exact, path: path, redirect: redirect } = child.props;
                    const [isMatch] = $3ca89b4ffa40120c$var$matchRoute(path, testPath, exact);
                    return typeof redirect === "function" ? false : isMatch;
                }
                return false;
            }),
        params: params,
        path: pathname,
        query: (0, $9B59M.parse)(cleanQuery),
        querystring: cleanQuery
    };
    if (!matchingChild) throw new Error(`Cannot find component for matching route ${pathname}`);
    return /*#__PURE__*/ (0, $7eprg.cloneElement)(matchingChild, {
        legacyProps: legacyProps
    });
}
function $3ca89b4ffa40120c$var$Route({ children: children, legacyProps: legacyProps }) {
    return children ? /*#__PURE__*/ (0, $7eprg.cloneElement)(children, legacyProps) : null;
}

});
parcelRegister("3wBe4", function(module, exports) {

$parcel$export(module.exports, "createHashHistory", function () { return $29113c910ce6f2c5$export$b71fdd3798280242; });

var $fLJOt = parcelRequire("fLJOt");

var $gZF0e = parcelRequire("gZF0e");

var $1zqFO = parcelRequire("1zqFO");


var $d9OlU = parcelRequire("d9OlU");
function $29113c910ce6f2c5$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $29113c910ce6f2c5$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $29113c910ce6f2c5$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $29113c910ce6f2c5$var$stripBasename(path, prefix) {
    return $29113c910ce6f2c5$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $29113c910ce6f2c5$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $29113c910ce6f2c5$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $29113c910ce6f2c5$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $29113c910ce6f2c5$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $29113c910ce6f2c5$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $fLJOt.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $gZF0e.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $29113c910ce6f2c5$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $1zqFO.default)(a.state, b.state);
}
function $29113c910ce6f2c5$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $29113c910ce6f2c5$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $29113c910ce6f2c5$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $29113c910ce6f2c5$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $29113c910ce6f2c5$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $29113c910ce6f2c5$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $29113c910ce6f2c5$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $29113c910ce6f2c5$var$PopStateEvent = "popstate";
var $29113c910ce6f2c5$var$HashChangeEvent = "hashchange";
function $29113c910ce6f2c5$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $29113c910ce6f2c5$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$29113c910ce6f2c5$var$canUseDOM && (0, $d9OlU.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $29113c910ce6f2c5$var$supportsHistory();
    var needsHashChangeListener = !$29113c910ce6f2c5$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $29113c910ce6f2c5$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $29113c910ce6f2c5$var$stripTrailingSlash($29113c910ce6f2c5$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $29113c910ce6f2c5$var$stripBasename(path, basename);
        return $29113c910ce6f2c5$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $29113c910ce6f2c5$var$createTransitionManager();
    function setState(nextState) {
        (0, $fLJOt.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($29113c910ce6f2c5$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($29113c910ce6f2c5$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($29113c910ce6f2c5$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $29113c910ce6f2c5$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $29113c910ce6f2c5$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $29113c910ce6f2c5$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($29113c910ce6f2c5$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($29113c910ce6f2c5$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($29113c910ce6f2c5$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($29113c910ce6f2c5$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $29113c910ce6f2c5$var$HashChangeEvent$1 = "hashchange";
var $29113c910ce6f2c5$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $29113c910ce6f2c5$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $29113c910ce6f2c5$var$stripLeadingSlash,
        decodePath: $29113c910ce6f2c5$var$addLeadingSlash
    },
    slash: {
        encodePath: $29113c910ce6f2c5$var$addLeadingSlash,
        decodePath: $29113c910ce6f2c5$var$addLeadingSlash
    }
};
function $29113c910ce6f2c5$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $29113c910ce6f2c5$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $29113c910ce6f2c5$var$pushHashPath(path) {
    window.location.hash = path;
}
function $29113c910ce6f2c5$var$replaceHashPath(path) {
    window.location.replace($29113c910ce6f2c5$var$stripHash(window.location.href) + "#" + path);
}
function $29113c910ce6f2c5$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$29113c910ce6f2c5$var$canUseDOM && (0, $d9OlU.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $29113c910ce6f2c5$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $29113c910ce6f2c5$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $29113c910ce6f2c5$var$stripTrailingSlash($29113c910ce6f2c5$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $29113c910ce6f2c5$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($29113c910ce6f2c5$var$getHashPath());
        if (basename) path = $29113c910ce6f2c5$var$stripBasename(path, basename);
        return $29113c910ce6f2c5$export$90c043f1c57770b8(path);
    }
    var transitionManager = $29113c910ce6f2c5$var$createTransitionManager();
    function setState(nextState) {
        (0, $fLJOt.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $29113c910ce6f2c5$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $29113c910ce6f2c5$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $29113c910ce6f2c5$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($29113c910ce6f2c5$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($29113c910ce6f2c5$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $29113c910ce6f2c5$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $29113c910ce6f2c5$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $29113c910ce6f2c5$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $29113c910ce6f2c5$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $29113c910ce6f2c5$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $29113c910ce6f2c5$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $29113c910ce6f2c5$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $29113c910ce6f2c5$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $29113c910ce6f2c5$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($29113c910ce6f2c5$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $29113c910ce6f2c5$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $29113c910ce6f2c5$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $29113c910ce6f2c5$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $29113c910ce6f2c5$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($29113c910ce6f2c5$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($29113c910ce6f2c5$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($29113c910ce6f2c5$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $29113c910ce6f2c5$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $29113c910ce6f2c5$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $29113c910ce6f2c5$var$createTransitionManager();
    function setState(nextState) {
        (0, $fLJOt.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $29113c910ce6f2c5$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $29113c910ce6f2c5$export$90c043f1c57770b8(entry, undefined, createKey()) : $29113c910ce6f2c5$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $29113c910ce6f2c5$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $29113c910ce6f2c5$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $29113c910ce6f2c5$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $29113c910ce6f2c5$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("fLJOt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7aec85360dbe90f$export$2e2bcd8739ae039; });
function $b7aec85360dbe90f$export$2e2bcd8739ae039() {
    $b7aec85360dbe90f$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b7aec85360dbe90f$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("gZF0e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5f22625c76dc515$export$2e2bcd8739ae039; });
function $c5f22625c76dc515$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $c5f22625c76dc515$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $c5f22625c76dc515$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $c5f22625c76dc515$var$isAbsolute(to);
    var isFromAbs = from && $c5f22625c76dc515$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $c5f22625c76dc515$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $c5f22625c76dc515$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $c5f22625c76dc515$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $c5f22625c76dc515$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$c5f22625c76dc515$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $c5f22625c76dc515$export$2e2bcd8739ae039 = $c5f22625c76dc515$var$resolvePathname;

});

parcelRegister("1zqFO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $124dc019432e32f6$export$2e2bcd8739ae039; });
function $124dc019432e32f6$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $124dc019432e32f6$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $124dc019432e32f6$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $124dc019432e32f6$var$valueOf(a);
        var bValue = $124dc019432e32f6$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $124dc019432e32f6$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $124dc019432e32f6$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $124dc019432e32f6$export$2e2bcd8739ae039 = $124dc019432e32f6$var$valueEqual;

});

parcelRegister("d9OlU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99432c8ba98745e7$export$2e2bcd8739ae039; });
var $99432c8ba98745e7$var$isProduction = true;
var $99432c8ba98745e7$var$prefix = "Invariant failed";
function $99432c8ba98745e7$var$invariant(condition, message) {
    if (condition) return;
    if ($99432c8ba98745e7$var$isProduction) throw new Error($99432c8ba98745e7$var$prefix);
    else throw new Error($99432c8ba98745e7$var$prefix + ": " + (message || ""));
}
var $99432c8ba98745e7$export$2e2bcd8739ae039 = $99432c8ba98745e7$var$invariant;

});



parcelRegister("gah5j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.TIMEOUT_MS = void 0;

var $fi30R = parcelRequire("fi30R");

var $3Zpnv = parcelRequire("3Zpnv");
function $d31190843d149194$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $d31190843d149194$var$TIMEOUT_MS = 2000;
module.exports.TIMEOUT_MS = $d31190843d149194$var$TIMEOUT_MS;
const $d31190843d149194$var$getNewPromise = ()=>{
    let resolve;
    const promise = new Promise((resolveFn)=>resolve = resolveFn);
    return {
        promise: promise,
        resolve: resolve
    };
};
class $d31190843d149194$var$OrchestrationService {
    constructor(){
        $d31190843d149194$var$_defineProperty(this, "state", $fi30R.LoadState.INIT);
        $d31190843d149194$var$_defineProperty(this, "readyForBackground", $d31190843d149194$var$getNewPromise());
        $d31190843d149194$var$_defineProperty(this, "loaded", $d31190843d149194$var$getNewPromise());
        $d31190843d149194$var$_defineProperty(this, "timer", 0);
        // Start a timeout for solution load.
        this.startTimeout();
    }
    /**
   * Clear any existing timeouts.
   * @private
   */ clearTimeout() {
        if (this.timer) {
            window.clearTimeout(this.timer);
            this.timer = 0;
        }
    }
    /**
   * Set state to timeout if state has not progress in a given time.
   * @private
   */ startTimeout() {
        const currentState = this.state;
        this.clearTimeout();
        this.timer = window.setTimeout(()=>{
            if (this.state === currentState) {
                // Solution did not progress in a timely manner, timeout.
                this.state = $fi30R.LoadState.TIMEOUT;
                this.timer = 0;
                this.readyForBackground.resolve();
            }
        }, $d31190843d149194$var$TIMEOUT_MS);
    }
    /**
   * Called when an application starts loading.
   */ onStartLoad() {
        if (this.state === $fi30R.LoadState.INIT) {
            this.state = $fi30R.LoadState.LOAD_START;
            this.startTimeout();
        }
    }
    /**
   * Called when an application is done loading.
   */ onLoaded() {
        if (this.state !== $fi30R.LoadState.LOADED) {
            if (this.state !== $fi30R.LoadState.TIMEOUT) this.readyForBackground.resolve();
            this.loaded.resolve();
            this.state = $fi30R.LoadState.LOADED;
        }
    }
    /**
   * Returns a promise that resolves when we are ready to run background tasks.
   */ waitForBackground() {
        return this.readyForBackground.promise.then(()=>(0, $3Zpnv.runInBackground)(true));
    }
    /**
   * Returns a promise that resolves when the first application has loaded.
   */ waitForFirstLoad(idle = true) {
        const { promise: promise } = this.loaded;
        return idle ? promise.then(()=>(0, $3Zpnv.runInBackground)(true)) : promise;
    }
}
const $d31190843d149194$var$orchestrationService = new $d31190843d149194$var$OrchestrationService();
var $d31190843d149194$var$_default = $d31190843d149194$var$orchestrationService;
module.exports.default = $d31190843d149194$var$_default;

});


parcelRegister("fe7SK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $loe8n = parcelRequire("loe8n");
function $8bccd305e28c434e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $8bccd305e28c434e$var$AppLoadState {
    constructor(){
        $8bccd305e28c434e$var$_defineProperty(this, "firstRender", true);
        $8bccd305e28c434e$var$_defineProperty(this, "lastAppId", "");
        $8bccd305e28c434e$var$_defineProperty(this, "unregisterSandbox", (sandboxId)=>(0, $loe8n.getAppController)().unregisterApp(sandboxId));
    }
    /**
   * Records state when app loads.
   * @param appId - Application ID
   * @returns Previous app ID, or nothing if this is the first loaded application.
   */ onSandboxLoad(appId) {
        const sandboxId = `${appId}-${Date.now()}`;
        const state = {
            sandboxId: sandboxId
        };
        if (this.lastAppId && this.lastAppId !== appId) {
            this.firstRender = false;
            state.lastAppId = this.lastAppId;
        } else this.lastAppId = appId;
        (0, $loe8n.getAppController)().registerApp(sandboxId, {
            appId: appId
        });
        return state;
    }
    /**
   * Records state when application renders
   * @returns true if this is the first application rendered, false otherwise.
   */ updateFirstRender() {
        const { firstRender: firstRender } = this;
        this.firstRender = false;
        return firstRender;
    }
}
var $8bccd305e28c434e$var$_default = new $8bccd305e28c434e$var$AppLoadState();
module.exports.default = $8bccd305e28c434e$var$_default;

});

parcelRegister("g3elz", function(module, exports) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("jEU9n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // Harvester picks up the intlMessages variable name
/* eslint sort-keys: 0 */ const $3e00ed67045b34d9$var$intlMessages = {
    iframeWaitingMessage: {
        defaultMessage: "Thank you for waiting. Just a few more moments...",
        description: "Message displayed to users when the application is taking a long time to load",
        id: "iframeWaitingMessage"
    },
    solutionIframe: {
        defaultMessage: "Main Content",
        description: "Name of the iframe element",
        id: "solutionIframe"
    }
};
var $3e00ed67045b34d9$var$_default = $3e00ed67045b34d9$var$intlMessages;
module.exports.default = $3e00ed67045b34d9$var$_default;

});

parcelRegister("kCZQ1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $iNslS = parcelRequire("iNslS");

var $loe8n = parcelRequire("loe8n");

var $3Zpnv = parcelRequire("3Zpnv");

var $4a463b49762705bf$var$_metrics = $4a463b49762705bf$var$_interopRequireWildcard((parcelRequire("17AVh")));

var $4a463b49762705bf$var$_react = $4a463b49762705bf$var$_interopRequireDefault((parcelRequire("7eprg")));
function $4a463b49762705bf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4a463b49762705bf$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $4a463b49762705bf$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $4a463b49762705bf$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4a463b49762705bf$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4a463b49762705bf$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $4a463b49762705bf$var$LISTENER_TIMEOUT = 30000;
class $4a463b49762705bf$var$Iframe extends $4a463b49762705bf$var$_react.default.Component {
    constructor(props){
        super(props);
        $4a463b49762705bf$var$_defineProperty(this, "box", void 0);
        $4a463b49762705bf$var$_defineProperty(this, "id", `exc-app-sandbox-${Math.random()}`);
        $4a463b49762705bf$var$_defineProperty(this, "metrics", void 0);
        $4a463b49762705bf$var$_defineProperty(this, "iframeTimer", void 0);
        $4a463b49762705bf$var$_defineProperty(this, "validSourcesRegexString", (0, $3Zpnv.getValidSourcesRegexString)());
        $4a463b49762705bf$var$_defineProperty(this, "cspTimeout", 0);
        $4a463b49762705bf$var$_defineProperty(this, "onLoad", ()=>this.iframeTimer.time("onLoad"));
        $4a463b49762705bf$var$_defineProperty(this, "onPostMessage", (event)=>{
            const { sandboxId: sandboxId } = this.props; // This event came from a different window than is assigned to this iframe
            // instance. This can happen because this listens to events on the window.
            // Don't process this, as it will cause badness.
            if (event.source !== this.box?.contentWindow && (event.source !== window || !(0, $loe8n.getAppController)().verifyMessage(event.data, sandboxId))) {
                if (event.data?.unifiedShell === 1 && event.data.type === $iNslS.Events.PING) {
                    let source = "unknown";
                    try {
                        source = event.source && "location" in event.source && event.source.location?.href || "no-location";
                    } catch  {}
                    this.props.onInvalidSource(source);
                }
                return;
            }
            if (event.origin) {
                // Enhances security and defense against HTML injections on post messages.
                // Returns early if the origin is not one of the csp allowed origins.
                if (!this.validSourcesRegexString.test(event.origin)) {
                    this.metrics.event("Iframe.postOriginInvalid", "Invalid origin", {
                        level: $4a463b49762705bf$var$_metrics.Level.WARN
                    }, {
                        origin: event.origin
                    });
                    return;
                }
                this.props.onMessage(event);
            }
        });
        $4a463b49762705bf$var$_defineProperty(this, "onCSPViolation", (event)=>{
            const { blockedURI: blockedURI, violatedDirective: violatedDirective } = event; // Frame source violation during iframe load. This likely will lead to a timeout.
            violatedDirective === "frame-src" && this.props.onFrameSrcViolation(blockedURI);
        });
        $4a463b49762705bf$var$_defineProperty(this, "removeCSPViolationListener", ()=>{
            if (this.cspTimeout) {
                clearTimeout(this.cspTimeout);
                this.cspTimeout = 0;
                window.removeEventListener("securitypolicyviolation", this.onCSPViolation, false);
            }
        });
        this.metrics = $4a463b49762705bf$var$_metrics.default.create("exc.core.modules.Iframe", props);
        this.metrics.event("Iframe.constructed");
        this.iframeTimer = this.metrics.start("Sandbox.iframe");
    }
    componentDidMount() {
        window.addEventListener("message", this.onPostMessage, false);
    }
    componentWillUnmount() {
        window.removeEventListener("message", this.onPostMessage, false);
        this.removeCSPViolationListener();
    }
    shouldComponentUpdate(nextProps) {
        return !!nextProps.src && (this.props.src !== nextProps.src || this.props.frameKey !== nextProps.frameKey || this.props.name !== nextProps.name);
    }
    onRef(ref) {
        if (ref && this.box !== ref) {
            this.box = ref;
            this.props.onMount(this.box);
            this.iframeTimer.time("init");
        }
    }
    detectCSPViolations() {
        this.removeCSPViolationListener();
        window.addEventListener("securitypolicyviolation", this.onCSPViolation, false);
        this.cspTimeout = window.setTimeout(this.removeCSPViolationListener, $4a463b49762705bf$var$LISTENER_TIMEOUT);
    }
    render() {
        const { frameKey: frameKey, name: name, permissionsPolicy: permissionsPolicy, src: src } = this.props;
        src && this.detectCSPViolations();
        return /*#__PURE__*/ $4a463b49762705bf$var$_react.default.createElement("iframe", {
            allow: permissionsPolicy,
            id: this.id,
            key: frameKey,
            name: name,
            onLoad: this.onLoad,
            ref: (iframeRef)=>this.onRef(iframeRef),
            src: src,
            title: name
        });
    }
}
var $4a463b49762705bf$var$_default = $4a463b49762705bf$var$Iframe;
module.exports.default = $4a463b49762705bf$var$_default;

});

parcelRegister("8DaMC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MessageService = void 0;

var $iNslS = parcelRequire("iNslS");

var $loe8n = parcelRequire("loe8n");

var $3Zpnv = parcelRequire("3Zpnv");

var $hCZmk = parcelRequire("hCZmk");

var $16566b0f06d31dac$var$_metrics = $16566b0f06d31dac$var$_interopRequireDefault((parcelRequire("17AVh")));
function $16566b0f06d31dac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $16566b0f06d31dac$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $16566b0f06d31dac$var$MessageService {
    constructor(){
        $16566b0f06d31dac$var$_defineProperty(this, "metrics", $16566b0f06d31dac$var$_metrics.default.create("exc.core.services.MessageService"));
        $16566b0f06d31dac$var$_defineProperty(this, "validSourcesRegexString", (0, $3Zpnv.getValidSourcesRegexString)());
        $16566b0f06d31dac$var$_defineProperty(this, "outQueue", []);
    }
    /**
   * Posts a message to the iframe using the postMessage API.
   * @param frame - Iframe DOM element
   * @param origin - Iframe origin.
   * @param message - Message to send
   * @returns true if message was sent, false otherwise.
   * @private
   */ postMessage({ frame: frame, origin: origin }, message) {
        if (frame?.contentWindow) {
            frame?.contentWindow.postMessage({
                ...message,
                unifiedShell: 1
            }, origin);
            return true;
        }
        return false;
    }
    /**
   * Sends a message to the iframe.
   * If connection has not yet established, the message would be queued.
   * @param message - Message to send
   * @param app - AppSandbox object
   */ sendMessage(message, app) {
        const { connected: connected, frame: frame, origin: origin } = app; // Send messages when we are connected and have the iframe reference.
        // Queue otherwise.
        if (connected && frame) {
            // Enhances security and defense against HTML injections on post messages.
            // Returns early if the origin is not one of the csp allowed origins.
            if (!this.validSourcesRegexString.test(origin)) {
                this.metrics.event("Sandbox.postOriginInvalid", "Invalid origin", {
                    level: $hCZmk.Level.WARN
                }, {
                    origin: origin
                });
                return;
            }
            if (this.postMessage(app, message)) return;
            app.inErrorState() || this.metrics.error("Sandbox frame has no contentWindow");
            return;
        }
        app.mounted && this.metrics.info(`${message.type || "unknown"} message sent before connection - Queueing.`, {
            connected: connected,
            hasFrame: !!app.frame
        });
        this.outQueue.push(message);
    }
    /**
   * Sends any outgoing messages waiting in the queue after the connection with the iframe
   * was established.
   * @param app - AppSandbox object.
   * @private
   */ processMessageQueue(app) {
        const { connected: connected, frame: frame } = app;
        if (this.outQueue.length && connected && frame) {
            // Flush all outgoing messages now that we got a Ping.
            this.metrics.event("Sandbox.onMessage.queue.flush", {
                length: this.outQueue.length
            });
            this.outQueue.forEach((message)=>this.sendMessage(message, app));
            this.outQueue = [];
        }
    }
    /**
   * Establish a connection with the iframe following an incoming Ping message.
   * @param message - Incoming ping message.
   * @param app - AppSandbox object.
   * @private
   */ async onPing(message, app) {
        const { appId: appId, autoInstantiateRuntime: autoInstantiateRuntime } = app.solutionConfig;
        const { data: { value: value = {} }, origin: origin } = message; // Second ping means iframe reloaded, need to restart timeout.
        app.connected && this.metrics.event("Sandbox.secondPing", {
            appId: appId
        });
        app.connected = true;
        app.origin = origin;
        this.metrics.event("Sandbox.onMessage.ping", {
            appId: appId,
            hasFrame: !!app.frame,
            ...value
        }); // Reset timeout as we know the frame is alive.
        app.setPageTimeout(); // Return empty message to initiate origin
        const metricsConfig = await (0, $loe8n.getMetricsConfig)(app); // Many SPAs load Runtime.js early but instantiate the Runtime object later.
        // For these scenarios, we send some useful information to the iframe via the PONG
        // event so that the iframe can do a few things ahead of Runtime instantiation such as
        // 1. Use EIM
        // PONG event is only dependent on the iframe loading Runtime.js
        this.sendMessage({
            appId: appId,
            type: $iNslS.Events.PONG,
            value: {
                autoInstantiateRuntime: autoInstantiateRuntime,
                metricsConfig: metricsConfig
            }
        }, app);
        this.processMessageQueue(app);
    }
    /**
   * Processes messages batch incoming from the iframe.
   * @param value - Incoming messages array.
   * @param app - AppSandbox object.
   * @private
   */ processIncomingQueue(value, app) {
        const historyEvents = [];
        let queue = value.filter((v)=>{
            if (v[0] === $iNslS.Events.HISTORY) {
                historyEvents.push(v);
                return false;
            }
            return true;
        });
        if (historyEvents.length) queue.push(historyEvents[historyEvents.length - 1]);
         // Ignore CLICK event if this is an OPEN_HELP_CENTER event
        if (queue.find((v)=>v[0] === $iNslS.Events.OPEN_HELP_CENTER)) queue = queue.filter((v)=>v[0] !== $iNslS.Events.CLICK);
        const { sandbox: { thirdParty: thirdParty } } = app.solutionConfig;
        queue.forEach(([type, val])=>{
            // If loading a third party solution, check if a supported event.
            if (thirdParty && !(type in $iNslS.EventsThirdParty)) {
                this.metrics.event("Sandbox.3rdPartyForbbiden", type, {
                    level: $hCZmk.Level.ERROR
                });
                return;
            }
            app.handlePostMessage(type, val);
        });
    }
    /**
   * In rare scenarios a Ping message can be processed before the iframe element has mounted.
   * When this happens, process the outgoing message queue.
   * @param app - AppSandbox object.
   */ processMessageAfterMount(app) {
        this.metrics.event("Sandbox.mountAfterConnect");
        this.processMessageQueue(app);
    }
    /**
   * Process an incoming message from the iframe.
   * This only handles a handful of message types, as most messages would come inside a batch.
   * @param message - Incoming message.
   * @param app - AppSandbox object.
   */ processMessage(message, app) {
        if (message.data?.unifiedShell !== 1) return;
        const { solutionConfig: { sandbox: { thirdParty: thirdParty } } } = app;
        const { appId: appId, type: type, value: value } = message.data; // If loading a third party solution, check if a supported event.
        if (thirdParty && !(type in $iNslS.EventsThirdParty)) {
            this.metrics.event("Sandbox.3rdPartyForbbiden", type, {
                level: $hCZmk.Level.ERROR
            });
            return;
        }
        switch(type){
            case $iNslS.Events.RUNTIME_REQ:
                {
                    const runtimeUrl = (0, $loe8n.getRuntimeParam)(app);
                    this.postMessage(app, {
                        type: $iNslS.Events.RUNTIME_RESP,
                        value: runtimeUrl
                    });
                    return;
                }
            case $iNslS.Events.NOT_INITIALIZED:
                app.waitForRuntime = true;
                this.metrics.event("Sandbox.waitingForRuntimeInit");
                return;
            case $iNslS.Events.PING:
                app.mounted && this.onPing(message, app);
                return;
        } // Ignore events that come from a different iframe than what is currently loaded
        if (appId !== app.appId && appId !== "unified-shell") {
            if (appId && app.lastAppId === appId) {
                this.metrics.info(`Post message received from previous app (${appId}). Current appId ${app.appId} - Ignoring.`, {
                    message: message.data,
                    origin: message.origin
                });
                return;
            }
            this.metrics.info(`Post message appId ${appId} does not match current appId ${app.appId}`, {
                message: message.data,
                origin: message.origin
            });
        }
        if (type === $iNslS.Events.QUEUE) {
            this.processIncomingQueue(value, app);
            return;
        }
        this.metrics.warn(`${type} event sent outside of a queue`);
    }
}
module.exports.MessageService = $16566b0f06d31dac$var$MessageService;

});

parcelRegister("3ZVxL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b4cf45edf148a33$var$_context = $0b4cf45edf148a33$var$_interopRequireDefault((parcelRequire("fTzIe")));

var $0b4cf45edf148a33$var$_CoreStrings = $0b4cf45edf148a33$var$_interopRequireDefault((parcelRequire("jEU9n")));

var $0b4cf45edf148a33$var$_react = $0b4cf45edf148a33$var$_interopRequireWildcard((parcelRequire("7eprg")));

var $0b4cf45edf148a33$var$_ShellWait = $0b4cf45edf148a33$var$_interopRequireDefault((parcelRequire("a7nYS")));
function $0b4cf45edf148a33$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0b4cf45edf148a33$var$_extends() {
    $0b4cf45edf148a33$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0b4cf45edf148a33$var$_extends.apply(this, arguments);
}
function $0b4cf45edf148a33$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $0b4cf45edf148a33$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $0b4cf45edf148a33$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0b4cf45edf148a33$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

const $0b4cf45edf148a33$var$Heading = /*#__PURE__*/ $0b4cf45edf148a33$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("7nEoK"));
    }).then((res)=>$0b4cf45edf148a33$var$_interopRequireWildcard(res)));
/**
 * Stylized Wait Component
 */ const $0b4cf45edf148a33$var$SandboxSpinner = ({ ignoreNav: ignoreNav, showWaitMessage: showWaitMessage })=>{
    const { intl: intl, sideNavOpen: sideNavOpen, shellSideNavPresent: shellSideNavPresent, shellSideNavWidth: shellSideNavWidth } = (0, $0b4cf45edf148a33$var$_react.useContext)($0b4cf45edf148a33$var$_context.default);
    const sideNavStyles = {};
    const waitingStyles = {};
    if (!ignoreNav && shellSideNavPresent && sideNavOpen) {
        waitingStyles.style = {
            left: `calc(50% + ${shellSideNavWidth / 2}px)`
        };
        sideNavStyles.style = {
            left: shellSideNavWidth
        };
    }
    return /*#__PURE__*/ $0b4cf45edf148a33$var$_react.default.createElement($0b4cf45edf148a33$var$_react.default.Fragment, null, /*#__PURE__*/ $0b4cf45edf148a33$var$_react.default.createElement("div", $0b4cf45edf148a33$var$_extends({
        className: "spinner-overlay"
    }, sideNavStyles)), /*#__PURE__*/ $0b4cf45edf148a33$var$_react.default.createElement("div", $0b4cf45edf148a33$var$_extends({
        className: "spinner-container spinner-light"
    }, sideNavStyles), /*#__PURE__*/ $0b4cf45edf148a33$var$_react.default.createElement($0b4cf45edf148a33$var$_ShellWait.default, {
        centered: true,
        locale: intl.locale,
        size: "L"
    })), showWaitMessage && /*#__PURE__*/ $0b4cf45edf148a33$var$_react.default.createElement($0b4cf45edf148a33$var$_react.default.Suspense, {
        fallback: null
    }, /*#__PURE__*/ $0b4cf45edf148a33$var$_react.default.createElement($0b4cf45edf148a33$var$Heading, $0b4cf45edf148a33$var$_extends({
        className: "still-waiting",
        variant: "subtitle1"
    }, waitingStyles), intl.formatMessage($0b4cf45edf148a33$var$_CoreStrings.default.iframeWaitingMessage))));
};
var $0b4cf45edf148a33$var$_default = $0b4cf45edf148a33$var$SandboxSpinner;
module.exports.default = $0b4cf45edf148a33$var$_default;

});
parcelRegister("a7nYS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02dd0a28b0d5be10$var$_classnames = $02dd0a28b0d5be10$var$_interopRequireDefault((parcelRequire("g3elz")));

var $gYPan = parcelRequire("gYPan");

var $gZvNz = parcelRequire("gZvNz");

var $02dd0a28b0d5be10$var$_react = $02dd0a28b0d5be10$var$_interopRequireDefault((parcelRequire("7eprg")));

var $7MkSZ = parcelRequire("7MkSZ");

var $02dd0a28b0d5be10$var$waitLocaleData = $02dd0a28b0d5be10$var$_interopRequireWildcard((parcelRequire("02Sv5")));

function $02dd0a28b0d5be10$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $02dd0a28b0d5be10$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $02dd0a28b0d5be10$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $02dd0a28b0d5be10$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $02dd0a28b0d5be10$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $02dd0a28b0d5be10$var$_extends() {
    $02dd0a28b0d5be10$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $02dd0a28b0d5be10$var$_extends.apply(this, arguments);
}
const $02dd0a28b0d5be10$var$I18nShellWait = ({ centered: centered = true, size: size, ...otherProps })=>{
    const { formatMessage: formatMessage } = (0, $7MkSZ.default)();
    delete otherProps.className;
    return /*#__PURE__*/ $02dd0a28b0d5be10$var$_react.default.createElement("div", {
        className: (0, $02dd0a28b0d5be10$var$_classnames.default)("shell-wait", {
            centered: centered
        })
    }, /*#__PURE__*/ $02dd0a28b0d5be10$var$_react.default.createElement($gZvNz.ProgressCircle, $02dd0a28b0d5be10$var$_extends({
        alignSelf: centered ? "center" : "flex-start",
        "aria-label": formatMessage({
            defaultMessage: "Loading",
            id: "shellWaitLabel"
        }) || "Loading",
        "aria-live": "polite",
        id: "spinner",
        isIndeterminate: true,
        justifySelf: centered ? "center" : "flex-start",
        size: size || "L"
    }, otherProps)));
};
const $02dd0a28b0d5be10$var$ShellWait = ({ locale: locale = "en-US", ...otherProps })=>/*#__PURE__*/ $02dd0a28b0d5be10$var$_react.default.createElement($gYPan.IntlProvider, {
        locale: locale,
        messages: $02dd0a28b0d5be10$var$waitLocaleData
    }, /*#__PURE__*/ $02dd0a28b0d5be10$var$_react.default.createElement($02dd0a28b0d5be10$var$I18nShellWait, otherProps));
var $02dd0a28b0d5be10$var$_default = /*#__PURE__*/ $02dd0a28b0d5be10$var$_react.default.memo($02dd0a28b0d5be10$var$ShellWait);
module.exports.default = $02dd0a28b0d5be10$var$_default;

});
parcelRegister("02Sv5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "en_US", {
    enumerable: true,
    get: function() {
        return $008a76ab5144691a$var$_en_us.default;
    }
});
Object.defineProperty(module.exports, "de_DE", {
    enumerable: true,
    get: function() {
        return $008a76ab5144691a$var$_de_de.default;
    }
});
Object.defineProperty(module.exports, "es_ES", {
    enumerable: true,
    get: function() {
        return $008a76ab5144691a$var$_es_es.default;
    }
});
Object.defineProperty(module.exports, "fr_FR", {
    enumerable: true,
    get: function() {
        return $008a76ab5144691a$var$_fr_fr.default;
    }
});
Object.defineProperty(module.exports, "it_IT", {
    enumerable: true,
    get: function() {
        return $008a76ab5144691a$var$_it_it.default;
    }
});
Object.defineProperty(module.exports, "ja_JP", {
    enumerable: true,
    get: function() {
        return $008a76ab5144691a$var$_ja_jp.default;
    }
});
Object.defineProperty(module.exports, "ko_KR", {
    enumerable: true,
    get: function() {
        return $008a76ab5144691a$var$_ko_kr.default;
    }
});
Object.defineProperty(module.exports, "pt_BR", {
    enumerable: true,
    get: function() {
        return $008a76ab5144691a$var$_pt_br.default;
    }
});
Object.defineProperty(module.exports, "zh_CN", {
    enumerable: true,
    get: function() {
        return $008a76ab5144691a$var$_zh_cn.default;
    }
});
Object.defineProperty(module.exports, "zh_TW", {
    enumerable: true,
    get: function() {
        return $008a76ab5144691a$var$_zh_tw.default;
    }
});

var $008a76ab5144691a$var$_en_us = $008a76ab5144691a$var$_interopRequireDefault((parcelRequire("h2Lg4")));

var $008a76ab5144691a$var$_de_de = $008a76ab5144691a$var$_interopRequireDefault((parcelRequire("dRMM8")));

var $008a76ab5144691a$var$_es_es = $008a76ab5144691a$var$_interopRequireDefault((parcelRequire("3b5M5")));

var $008a76ab5144691a$var$_fr_fr = $008a76ab5144691a$var$_interopRequireDefault((parcelRequire("5OA44")));

var $008a76ab5144691a$var$_it_it = $008a76ab5144691a$var$_interopRequireDefault((parcelRequire("3HD4r")));

var $008a76ab5144691a$var$_ja_jp = $008a76ab5144691a$var$_interopRequireDefault((parcelRequire("3xQ1o")));

var $008a76ab5144691a$var$_ko_kr = $008a76ab5144691a$var$_interopRequireDefault((parcelRequire("96YRc")));

var $008a76ab5144691a$var$_pt_br = $008a76ab5144691a$var$_interopRequireDefault((parcelRequire("15d19")));

var $008a76ab5144691a$var$_zh_cn = $008a76ab5144691a$var$_interopRequireDefault((parcelRequire("1ElIa")));

var $008a76ab5144691a$var$_zh_tw = $008a76ab5144691a$var$_interopRequireDefault((parcelRequire("boitw")));
function $008a76ab5144691a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("h2Lg4", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellWaitLabel":"Loading"}');

});

parcelRegister("dRMM8", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellWaitLabel":"Wird geladen"}');

});

parcelRegister("3b5M5", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellWaitLabel":"Cargando"}');

});

parcelRegister("5OA44", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellWaitLabel":"Chargement"}');

});

parcelRegister("3HD4r", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellWaitLabel":"Caricamento in corso"}');

});

parcelRegister("3xQ1o", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellWaitLabel":"\u8AAD\u307F\u8FBC\u307F\u4E2D"}');

});

parcelRegister("96YRc", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellWaitLabel":"\uB85C\uB4DC \uC911"}');

});

parcelRegister("15d19", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellWaitLabel":"Carregando"}');

});

parcelRegister("1ElIa", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellWaitLabel":"\u6B63\u5728\u52A0\u8F7D"}');

});

parcelRegister("boitw", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellWaitLabel":"\u6B63\u5728\u8F09\u5165"}');

});



parcelRegister("7nEoK", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = $Ha5sG("7zD5V").then(()=>parcelRequire("4X0pd"));

});


parcelRegister("1pABw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3Zpnv = parcelRequire("3Zpnv");
function $44ab6db5bd39733f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Capability applicationId:id that should be mapped to a specific path. Using
// a key that is combination of applicationId and id, both from WorkHub, is
// necessary in case there is a different mapping for the same id in a different
// application within WorkHub.
const $44ab6db5bd39733f$var$CAPABILITY_OVERRIDE = {
    "CJM:assets": "/journey-optimizer/assets"
};
/**
 * Update method type required because debounce is used.
 */ /**
 * Title Service that manages various aspects of the current application that is
 * loaded and makes sure the page title reflects that.
 */ class $44ab6db5bd39733f$var$TitleService {
    /**
   * Constructor for the TitleService class. Uses the provided arguments to set
   * up the initial version of the service. If the app portion of the title is
   * available, it triggers an update of the page title.
   * @param appConfig - Application configuration for the current app.
   * @param hero - Hero configuration for the current app.
   * @param workHubResponse - Work Hub response for the composed app.
   */ constructor(appConfig, hero, workHubResponse){
        $44ab6db5bd39733f$var$_defineProperty(this, "_app", void 0);
        $44ab6db5bd39733f$var$_defineProperty(this, "_appConfig", void 0);
        $44ab6db5bd39733f$var$_defineProperty(this, "_capability", void 0);
        $44ab6db5bd39733f$var$_defineProperty(this, "_detail", void 0);
        $44ab6db5bd39733f$var$_defineProperty(this, "_divider", "|");
        $44ab6db5bd39733f$var$_defineProperty(this, "_workHubResponse", void 0);
        $44ab6db5bd39733f$var$_defineProperty(this, "update", (0, $3Zpnv.debounce)((detail, force)=>{
            // Always regenerate capability on AEP and AJO. Competition between title updates from Sandbox and
            // proxied config changes through APIProcessingService may cause the force param to be missed.
            if (force || [
                "experiencePlatformUI",
                "cjm-platform"
            ].includes(this._appConfig.appId)) this._capability = this.getCapabilityName();
             // If a detail is provided that includes sections separated by a pipe, only
            // use the first section.
            this._detail = (detail || "").split(" | ")[0];
            document.title = this.format();
        }, 500));
        this._appConfig = appConfig;
        this._workHubResponse = workHubResponse; // Set some initial values.
        this._app = hero?.title || hero?.shortTitle;
        this._capability = this.getCapabilityName(); // Set initial title.
        this._app && this.update();
    }
    /**
   * Sets the Hero. With the hero, the app portion of the title can also be
   * determined by the values within the Hero. It also triggers an update of the
   * page title with the newly set app instance variable.
   * @public
   * @param hero - The Hero object for the current application.
   */ set hero(hero) {
        this._app = hero?.title || hero?.shortTitle;
        this.update();
    }
    /**
   * Sets the Work Hub response. With the response, the capability portion of
   * the title can also be determined. It also triggers an update of the page
   * title with the newly set capability instance variable.
   * @public
   * @param workHubResponse - Response from Work Hub for the composed app.
   */ set workHubResponse(workHubResponse) {
        this._workHubResponse = workHubResponse;
        this._capability = this.getCapabilityName();
        this.update();
    }
    /**
   * Build the title string out of the 3 parts: detail, capability, and app. If
   * any of the pieces aren't available, they are not included. Additionally,
   * if the first part is the same as the next part, one of them is removed to
   * reduce duplicates.
   * @private
   * @returns Formatted title string.
   */ format() {
        const output = [
            this._detail,
            this._capability,
            this._app
        ].reduce((prev, value, idx)=>{
            if (!value) return prev;
            const toAdd = idx === 0 ? value : ` ${this._divider} ${value}`;
            return `${prev}${toAdd}`;
        }, ""); // If there a duplicate entries (e.g. "Assets | Assets"), remove one of them.
        return output.replace(/^([a-zA-Z ]*) \| \1/, "$1");
    }
    /**
   * Gets the capability name from the Work Hub repsonse. The urlTemplate from
   * Work Hub is matched against the path in the application config to find the
   * best match. If there is an application that has a special case, like Assets,
   * the CAPABILITY_OVERRIDE object is used.
   * @private
   * @returns The matched Work Hub capability name or an empty string if none found.
   */ getCapabilityName() {
        const { path: path } = this._appConfig;
        const capability = this._workHubResponse?.find(({ applicationId: applicationId, enabled: enabled, id: id, urlTemplate: urlTemplate })=>{
            urlTemplate = $44ab6db5bd39733f$var$CAPABILITY_OVERRIDE[`${applicationId}:${id}`] || urlTemplate; // If urlTemplate path and config path are not an exact match, check if
            // full hash contains urlTemplate path
            if (urlTemplate !== path && urlTemplate.startsWith(path)) return window.location.hash.includes(urlTemplate) && enabled;
            return urlTemplate === path && enabled;
        });
        return capability?.displayName || "";
    }
}
module.exports.default = $44ab6db5bd39733f$var$TitleService;

});

parcelRegister("eFujB", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");




module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("7UsoS")),
    $Ha5sG("ctfMK"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("gPPdO")),
    $Ha5sG("i2aes")
]).then(()=>parcelRequire("ihUSa"));

});
parcelRegister("98wYO", function(module, exports) {
"use strict";

var $leQbj = parcelRequire("leQbj");
module.exports = $leQbj(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("leQbj", function(module, exports) {
"use strict";
var $f76361f3fc373757$var$cachedBundles = {};
var $f76361f3fc373757$var$cachedPreloads = {};
var $f76361f3fc373757$var$cachedPrefetches = {};
function $f76361f3fc373757$var$getCache(type) {
    switch(type){
        case "preload":
            return $f76361f3fc373757$var$cachedPreloads;
        case "prefetch":
            return $f76361f3fc373757$var$cachedPrefetches;
        default:
            return $f76361f3fc373757$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f76361f3fc373757$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("fruYL", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = $Ha5sG("6gGye").then(()=>parcelRequire("cbJZW"));

});


parcelRegister("2qT0f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.updateValueInPath = module.exports.updatePath = module.exports.cleanPath = void 0;

var $jVeiz = parcelRequire("jVeiz");

var $bzq4v = parcelRequire("bzq4v");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * Cleans any unnecessary query params from the provided path.
 * @param path - The path string to clean.
 * @param filterParams - additional params to filter (optional)
 * @returns Cleaned path.
 */ var $1c58acf1c9fb0907$var$cleanPath = function(path, filterParams) {
    var url = new URL("".concat(window.location.origin).concat(path));
    (0, $jVeiz.cleanQueryParams)(url.searchParams, filterParams);
    return "".concat(url.pathname).concat(url.search).concat(url.hash);
};
/**
 * Updates path with or without tenant.
 * @param url New url information such as path, tenant, sandbox, or sub org.
 * @param replace Whether or not to replace vs push to history.
 * @param hasTenant Whether or not the updated path should have a tenant.
 * @param contextParam Url context parameter, e.g. so or sname.
 * @param assign If true, use location assign, if false use replace/psuh.
 * @param filterParams additional params to filter (optional)
 */ module.exports.cleanPath = $1c58acf1c9fb0907$var$cleanPath;
var $1c58acf1c9fb0907$var$updatePath = function(url, replace, hasTenant, contextParam, assign, filterParams) {
    if (replace === void 0) replace = false;
    if (hasTenant === void 0) hasTenant = true;
    if (assign === void 0) assign = false;
    var path = url.path, sandbox = url.sandbox, subOrg = url.subOrg, tenant = url.tenant;
    var _a = $bzq4v.history.location, hash = _a.hash, pathname = _a.pathname, search = _a.search;
    pathname = pathname || window.location.pathname;
    var fullPath = path ? $1c58acf1c9fb0907$var$cleanPath((0, $jVeiz.getPathWithoutTenant)(path), filterParams) : "".concat((0, $jVeiz.getPathWithoutTenant)(pathname)).concat(search).concat(hash); // If a particular sandbox/suborg has been supplied in URL, we must replace the current one.
    var updatedContextParamValue = sandbox || subOrg;
    if (contextParam && updatedContextParamValue) fullPath = "/".concat(contextParam, ":").concat(updatedContextParamValue).concat(fullPath);
    else {
        var currentUrlContextParam = (0, $jVeiz.getValueFromPath)(pathname, contextParam || "");
        fullPath = currentUrlContextParam && contextParam ? "/".concat(contextParam, ":").concat(currentUrlContextParam).concat(fullPath) : fullPath;
    } // Clean up tenant
    if (tenant) tenant = tenant.startsWith("/@") ? tenant : "/@".concat(tenant);
    var pathTenant = hasTenant ? tenant || (0, $jVeiz.getTenantFromPath)(pathname) : "";
    if (assign) window.location.assign(pathTenant + fullPath);
    else $bzq4v.history[replace ? "replace" : "push"](pathTenant + fullPath);
};
/**
 * Updates sandbox in the URL
 * @param key - context url key, e.g. sname or so.
 * @param name - New value.
 * @param hasTenant - Whether or not the updated path should have a tenant.
 * @param replace - Whether or not the history event should be a replace.
 */ module.exports.updatePath = $1c58acf1c9fb0907$var$updatePath;
var $1c58acf1c9fb0907$var$updateValueInPath = function(key, name, hasTenant, replace) {
    if (hasTenant === void 0) hasTenant = true;
    if (replace === void 0) replace = true;
    var _a = $bzq4v.history.location, hash = _a.hash, pathname = _a.pathname, search = _a.search;
    name = name ? "/".concat(key, ":").concat(name) : "";
    var fullPath = "".concat(name).concat((0, $jVeiz.getPathWithoutTenant)(pathname)).concat(search).concat(hash);
    var pathTenant = hasTenant ? (0, $jVeiz.getTenantFromPath)(pathname) : "";
    $bzq4v.history[replace ? "replace" : "push"](pathTenant + fullPath);
};
module.exports.updateValueInPath = $1c58acf1c9fb0907$var$updateValueInPath;

});


parcelRegister("lRoWp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "AuthInstance", {
    enumerable: true,
    get: function() {
        return $jTDJq.AuthInstance;
    }
});
Object.defineProperty(module.exports, "getTokenKey", {
    enumerable: true,
    get: function() {
        return $d2Ld2.getTokenKey;
    }
});
Object.defineProperty(module.exports, "queueMetrics", {
    enumerable: true,
    get: function() {
        return $01ci4.queueMetrics;
    }
});
Object.defineProperty(module.exports, "reload", {
    enumerable: true,
    get: function() {
        return $ggkvY.reload;
    }
});

var $jTDJq = parcelRequire("jTDJq");

var $d2Ld2 = parcelRequire("d2Ld2");

var $01ci4 = parcelRequire("01ci4");

var $ggkvY = parcelRequire("ggkvY");

});
parcelRegister("jTDJq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthInstance = void 0;

var $e7c1f93ce62570e3$var$_emitter = $e7c1f93ce62570e3$var$_interopRequireDefault((parcelRequire("dJSrf")));

var $jVeiz = parcelRequire("jVeiz");

var $3LITL = parcelRequire("3LITL");

var $iNslS = parcelRequire("iNslS");

var $01ci4 = parcelRequire("01ci4");

var $aywNo = parcelRequire("aywNo");

var $hCG2Z = parcelRequire("hCG2Z");

var $85ztx = parcelRequire("85ztx");

var $d2Ld2 = parcelRequire("d2Ld2");

var $e7c1f93ce62570e3$var$_stringHash = $e7c1f93ce62570e3$var$_interopRequireDefault((parcelRequire("h9eEw")));

var $3x6rS = parcelRequire("3x6rS");

var $e7c1f93ce62570e3$var$_logout = $e7c1f93ce62570e3$var$_interopRequireDefault((parcelRequire("1Jct3")));

var $e7c1f93ce62570e3$var$_metrics = $e7c1f93ce62570e3$var$_interopRequireWildcard((parcelRequire("83dfQ")));

var $ggkvY = parcelRequire("ggkvY");

var $iJaYo = parcelRequire("iJaYo");
function $e7c1f93ce62570e3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e7c1f93ce62570e3$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $e7c1f93ce62570e3$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $e7c1f93ce62570e3$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e7c1f93ce62570e3$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e7c1f93ce62570e3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * IMS Validate Token scheduler default interval in millis
 */ const $e7c1f93ce62570e3$var$QA_INTERVAL = 120000;
const $e7c1f93ce62570e3$var$PROD_INTERVAL = 30000;
const $e7c1f93ce62570e3$var$BACKGROUND_INTERVAL = 600000;
const $e7c1f93ce62570e3$var$VALIDATION_DELAY = 30000;
let $e7c1f93ce62570e3$var$imsLoaded = false;
const $e7c1f93ce62570e3$var$trackedTokens = new Set();

class $e7c1f93ce62570e3$var$Auth extends $e7c1f93ce62570e3$var$_emitter.default {
    constructor(...args){
        super(...args);
        $e7c1f93ce62570e3$var$_defineProperty(this, "validateTokenAndEmit", async (emit = true)=>{
            // If the token has already been validated, wait 5 minutes until it's
            // validated again. This saves us from triggering a bunch of validation
            // calls on the same token if requested multiple times.
            let token = this.fetchAccessToken();
            const almostExpired = this.refresher.getRefreshAt(token) < Date.now();
            if (!token || almostExpired) {
                // Token might have expired in which case IMS lib no longer has it.
                // Try to get a new token first.
                this.metrics.warn(almostExpired ? "Token is past 80% threshold" : "Token is null, refreshing");
                try {
                    token = (await this.refreshToken()).token;
                } catch  {
                    // Actual error is logged in refreshToken.
                    this.metrics.error("Failed to refresh token while validating.");
                    return {
                        success: false
                    };
                }
                if (!token) {
                    this.metrics.error("Token is null");
                    return {
                        success: false
                    };
                }
            }
            if (token in this.validateAndEmitMap && this.validateAndEmitMap[token].expires > Date.now()) return this.validateAndEmitMap[token].promise;
            const promise = this.adobeIMS.imsApis.validateToken({
                client_id: this.adobeid.client_id,
                token: token
            }).then((res)=>{
                this.metrics.event(res.valid ? "Auth.tokenIsValid" : "Auth.tokenInvalid");
                if (!res.valid) {
                    (0, $01ci4.queueMetrics)("Failure to validate token", {
                        data: {
                            adobeIMSResponse: res
                        }
                    });
                    emit && this.emit("auth.validatetokenfailed");
                    return {
                        success: false
                    };
                }
                emit && this.emit("auth.validatetokensuccess");
                return {
                    success: true
                };
            }).catch((error)=>{
                // Network is flakey - never emit to log user out.
                if (error?.error === "networkError") {
                    (0, $01ci4.queueMetrics)("Network error", {
                        error: error
                    });
                    return {
                        success: false
                    };
                }
                (0, $01ci4.queueMetrics)("Failure to validate token", {
                    error: error
                });
                emit && this.emit("auth.validatetokenfailed");
                return {
                    success: false
                };
            });
            this.validateAndEmitMap[token] = {
                expires: Date.now() + $e7c1f93ce62570e3$var$VALIDATION_DELAY,
                promise: promise
            };
            return promise;
        });
    }
    load(configuration) {
        const { accountClusterPromise: accountClusterPromise, env: env, imsConfig: imsConfig, imsObjects: { adobeIMS: adobeIMS, adobeid: adobeid, storedEvents: storedEvents }, listeners: listeners } = configuration;
        this._activityMonitor = null;
        this.accountClusterPromise = accountClusterPromise;
        this.env = env;
        this.imsEnv = imsConfig.environment || this.env;
        this.backupAccessTokensInfos = {};
        this.validateAndEmitMap = {};
        this.validateAndRefreshMap = {};
        this.addListenersToAuth(listeners);
        this.logout = $e7c1f93ce62570e3$var$_logout.default;
        this.metrics = $e7c1f93ce62570e3$var$_metrics.default.create("exc.auth.Auth");
        this.metrics.event("Auth.init"); // Create a promise to pull the activity monitor and set it as an instance
        // in the class. Pass the promise to the refresher so it can have an
        // instance as well. This is used to get the last active time for the user.
        const activityMonitorPromise = $3x6rS.Internal.getActivityMonitor().then((activityMonitor)=>{
            this._activityMonitor = activityMonitor;
            return activityMonitor;
        });
        this.refresher = (0, $85ztx.getRefresher)(activityMonitorPromise);
        const onError = (err)=>{
            // `err` is not always a string, so let's convert to an object for
            // consistent handling later on.
            const errObj = typeof err === "string" ? {
                error: err
            } : err;
            this.metrics.error("Error making a request in IMS after init", errObj);
            const { debug: debug, error: error, name: name } = errObj;
            const status = ((debug || {}).url || {}).error; // The request was aborted and we don't really know why.
            if ((error === "aborted" || error === "initialize_error") && !$e7c1f93ce62570e3$var$imsLoaded) {
                this.emit("auth.initializeError");
                return;
            } // There are a variety of cases that can trigger rate limit errors.
            if (error === "rate_limited" || status === "rate_limited" || name === "rate_limit") this.emit("auth.rateLimited");
        };
        window["exc-ims-error-handler"] = onError;
        if (!$e7c1f93ce62570e3$var$imsLoaded) {
            $e7c1f93ce62570e3$var$imsLoaded = true;
            storedEvents.forEach((event)=>this.emit(event));
            adobeid.onError = onError;
            this.adobeIMS = adobeIMS;
            this.adobeid = adobeid; // Initialize the custom token service.
            this.customTokenServicePromise = Promise.resolve().then(function() {
                return (parcelRequire("1DHFD"));
            }).then((res)=>$e7c1f93ce62570e3$var$_interopRequireWildcard(res)).then(({ default: CustomTokenService })=>{
                this.customTokenService = new CustomTokenService();
                this.customTokenService.on("rideError", (err)=>this.emit("auth.rideError", err));
            }); // Enable verbose IMS logging if specified via query param
            (0, $hCG2Z.getQueryValue)("verboseIms") && this.adobeIMS.enableLogging();
            this.isSessionEnvValid(imsConfig.environment, this.imsEnv);
            if (this.isAuthenticated()) {
                const inactivity = (0, $hCG2Z.getQueryValue)("inactivity");
                (0, $01ci4.flushQueuedMetrics)();
                if (inactivity && this.imsEnv !== "prod") {
                    const inactivityTimeoutSec = Number(inactivity);
                    if (inactivityTimeoutSec >= 30) {
                        this.metrics.info(`Setting inactivity period to ${inactivityTimeoutSec} seconds`);
                        $3x6rS.Internal.configurePolling({
                            inactivityTimeoutSec: inactivityTimeoutSec
                        });
                    }
                }
                $3x6rS.Internal.addPoller({
                    activeFrequency: this.imsEnv === "prod" ? $e7c1f93ce62570e3$var$PROD_INTERVAL : $e7c1f93ce62570e3$var$QA_INTERVAL,
                    immediate: true,
                    inactiveFrequency: $e7c1f93ce62570e3$var$BACKGROUND_INTERVAL,
                    name: "ValidateToken",
                    pollFn: ()=>this.validateTokenAndEmit()
                }).then((pollerHandle)=>this.tokenPoller = pollerHandle);
            }
        }
        return this;
    }
    isAuthenticated(force) {
        return this.adobeIMS.isSignedInUser() || force;
    }
    async signIn(redirect_uri, domain = "", filterOptions = {}) {
        this.clear();
        const tenantMap = await $iJaYo.storage.local.get("tenantMap");
        const context = {
            locale: navigator.language,
            redirect_uri: redirect_uri
        };
        if (domain && domain.startsWith("@") && domain.includes(".")) // Add domain hint for SSO.
        context.puser = domain;
        if (redirect_uri.includes("old_hash") && !filterOptions.tenantId) {
            const [, oldHash] = decodeURIComponent(redirect_uri).split("old_hash=#");
            oldHash && (filterOptions.tenantId = (0, $jVeiz.getTenantAndPath)(oldHash).tenant);
        }
        const { tenantId: tenantId } = filterOptions;
        if (tenantMap && !filterOptions.imsOrgId) {
            const defaultOrg = tenantMap.DEFAULT_ORG || tenantMap.LAST_ORG;
            filterOptions.imsOrgId = tenantId ? tenantMap[tenantId] : defaultOrg;
        }
        context.profile_filter = (0, $aywNo.getImsFilter)(filterOptions);
        this.adobeIMS.signIn(context);
    }
    /**
   * A helper to emit and auto clear token status and login status
   * Generates: auth.validatetokensuccess event - on successful validation.
   * Generates: auth.validatetokenfailed event - on invalid/expired token and clears login.
   * @param {boolean} emit - Emit events? (Default: true)
   * @returns {boolean} returns if the session is valid or not
   */ async validateTokenAndRefresh({ clientId: clientId, scope: scope, token: token, userId: userId }) {
        // If the token has already been validated, wait 5 minutes until it's
        // validated again. This saves us from triggering a bunch of validation
        // calls on the same token if requested multiple times.
        if (token in this.validateAndRefreshMap && this.validateAndRefreshMap[token].expires > Date.now()) return this.validateAndRefreshMap[token].promise;
        const isExcClient = this.isExcClient(clientId);
        const validatePromise = isExcClient ? this.adobeIMS.validateToken() : this.adobeIMS.imsApis.validateToken({
            client_id: clientId,
            token: token
        }); // Validate the token as the first step. If it's successful, the response
        // should say it's valid.
        const promise = validatePromise.then((res)=>{
            let errMessage;
            token = isExcClient ? this.fetchAccessToken() : token; // adobeIMS.imsApis.validateToken response is an object and is resolved
            // whether the token is valid or not.
            if (!isExcClient && typeof res === "object" && !res?.valid) errMessage = `Validation request failed: ${res?.reason || "Unknown Reason"}`; // Refresh the token if it's past the refresh time.
            else if (this.refresher.getRefreshAt(token) < Date.now()) errMessage = "Token is past refresh time";
            if (errMessage) {
                const err = new Error(errMessage);
                err.fromValidate = true;
                throw err;
            } // adobeIMS.validateToken response is a boolean
            return {
                clientId: clientId,
                scope: scope,
                success: true,
                userId: userId
            };
        }).catch((validateError)=>{
            const message = validateError.fromValidate ? validateError.message : "Token validation failed";
            this.metrics.info(message, validateError); // The validation was invalid, so now we attempt to refresh the token.
            // If the request succeeds, use the response to determine if the refresh
            // was successful.
            return (isExcClient ? this.refreshToken() : this.refreshCustomToken({
                clientId: clientId,
                scope: scope,
                userId: userId
            })).then((imsData)=>{
                const response = {
                    imsData: imsData,
                    success: !!imsData
                };
                if (imsData) {
                    // Remove the old token and track validation on the new one.
                    delete this.validateAndRefreshMap[token];
                    this.validateAndRefreshMap[imsData.token] = {
                        expires: Date.now() + $e7c1f93ce62570e3$var$VALIDATION_DELAY,
                        promise: Promise.resolve(response)
                    };
                } else this.emit("auth.validatetokenfailed");
                return response;
            }).catch((refreshError)=>{
                this.metrics.error("Token validate and refresh failed", refreshError);
                this.emit("auth.validatetokenfailed");
                return {
                    success: false
                };
            });
        });
        this.validateAndRefreshMap[token] = {
            expires: Date.now() + $e7c1f93ce62570e3$var$VALIDATION_DELAY,
            promise: promise
        };
        return promise;
    }
    /** Gets session Id from access token. */ getSessionId() {
        const accessTokenInfo = this.fetchAccessTokenInfo();
        return accessTokenInfo && accessTokenInfo.sid;
    }
    /**
   * Gets impersonation id from access token.
   */ getImpersonationId(token) {
        const impersonationId = this.impersonationId || (0, $iNslS.extractTokenMetadata)(token)?.imp_id;
        return {
            impersonationId: impersonationId
        };
    }
    /**
   * Gets userId and hashes it for use in local storage.
   */ getHashedUserId() {
        const userId = this.getUserId();
        return userId && (0, $e7c1f93ce62570e3$var$_stringHash.default)(userId).toString();
    }
    /**
   * TO DO: Get this value via a more stable IMSLib API
   * Gets authId from access token.
   */ getAuthId() {
        return this.authId;
    }
    /**
   * TO DO: Get this value via a more stable IMSLib API
   * Gets userId from access token.
   */ getUserId() {
        const accessTokenInfo = this.adobeIMS.tokenService.getTokenFieldsFromStorage();
        accessTokenInfo || this.metrics.warn("getTokenFieldsFromStorage returned an empty token");
        return (accessTokenInfo || {}).user_id;
    }
    /**
   * Gets hashed authId from profile.
   */ getHashedAuthId() {
        const authId = this.getAuthId();
        return authId && (0, $e7c1f93ce62570e3$var$_stringHash.default)(authId).toString();
    }
    /**
   * Creates a new CustomAppClient instance with the specified client id and
   * scopes. It also set the usage type to APP so it can be used for the current
   * active application and tracks it with the refresher.
   * @param clientId Custom (e.g. non exc_app) client id.
   * @param scope Custom scopes to fetch for the client.
   * @returns The token using the requested clientId and scope.
   */ async createCustomClient(clientId, scope) {
        await this.customTokenServicePromise;
        return this.customTokenService.getToken(clientId, scope, this.getUserId(), this);
    }
    /**
   * Get stored profile from IMS lib.
   * @param {boolean} signOutIfNone - Sign out if no profile is available (Default: true)
   * @returns {IMSProfile} profile
   */ async fetchUserProfile(signOutIfNone = true) {
        const profile = await this.adobeIMS.getProfile();
        if (profile) {
            this.authId = profile.authId || profile.userId;
            return profile;
        } // There is a session, so likely the profile is failing to load for some
        // reason related to 429 or other error from the IMS request. There will
        // likely be an error shown to the user, so we don't need to log out.
        if (this.adobeIMS.getAccessToken() || !signOutIfNone) return null;
        this.signOut(true);
    }
    /**
   * Fetch token for custom client ID and scopes. Adds an additional field
   * `userInactiveSince` onto the request if it's a valid number so IMS can
   * handle the case where the user might have been inactive longer than the PBA
   * setting.
   * @async
   * @param {string} clientId - Custom (e.g. non exc_app) client id.
   * @param {string} scope - Custom scopes to fetch.
   * @param {string} userId - User ID
   * @returns {Promise<Object | null>} - Token information or null if invalid or
   *  clientId or scope don't exist.
   */ async fetchCustomImsAccessToken(clientId, scope, userId = this.getUserId()) {
        if (!clientId || !scope) return null;
        const userInactiveSince = this.getSecondsSinceLastActive();
        const args = {
            clientId: clientId,
            env: this.imsEnv,
            scope: scope,
            userId: userId
        };
        typeof userInactiveSince === "number" && (args.userInactiveSince = userInactiveSince);
        const tokenInfo = await (0, $d2Ld2.getToken)(args);
        this.trackToken(tokenInfo.access_token, {
            clientId: clientId,
            scope: scope,
            userId: userId
        });
        return tokenInfo;
    }
    fetchAccessToken() {
        const accessTokenInfo = this.fetchAccessTokenInfo();
        if (accessTokenInfo && accessTokenInfo.token) {
            this.trackToken(accessTokenInfo.token);
            return accessTokenInfo.token;
        }
        this.metrics.warn("fetchAccessToken failed to return a token");
        return null;
    }
    trackToken(token, custom) {
        if ($e7c1f93ce62570e3$var$trackedTokens.has(token)) // Token already tracked.
        return;
         // If the token has the `pba` property, disable the idle polling. The
        // property means that there is a token idle restriction defined by the
        // customer and we can't automatically refresh or keep tokens active.
        //
        // ONLY does this on exc_app tokens so that we don't overload metrics with
        // unnecessary logging.
        const { created_at: created_at, expires_in: expires_in, imp_id: imp_id, pba: pba } = (0, $iNslS.extractTokenMetadata)(token) || {};
        if (created_at && expires_in && !custom) sessionStorage.setItem("shellTokenExpireAt", created_at + expires_in);
        this.impersonationId = imp_id;
        const pbaEnabled = (pba || "").toLowerCase().split(",").includes("org");
        $3x6rS.Internal.configurePolling({
            pollWhileInactive: !pbaEnabled
        });
        pbaEnabled && this.metrics.info("PBA enabled for customer");
        const refreshAt = this.refresher.getRefreshAt(token);
        this.metrics.event("Token.tracked", {
            refreshAt: refreshAt
        });
        $e7c1f93ce62570e3$var$trackedTokens.add(token);
        const props = {
            ...custom || {
                clientId: this.getClientId(),
                scope: this.adobeid.scope,
                userId: this.getUserId()
            }
        };
        this.refresher.trackRefresh({
            ...props,
            eventFn: this.emit.bind(this),
            isExcClient: !custom,
            refreshAt: refreshAt,
            refreshFn: ()=>custom ? this.refreshCustomToken(props) : this.refreshToken()
        });
    }
    fetchAccessTokenInfo() {
        return this.adobeIMS.getAccessToken();
    }
    async signOut() {
        if (this.isAuthenticated()) await this.logout.invoke();
        this.clear();
        (0, $01ci4.queueMetrics)("Auth signOut", {
            data: {
                authenticated: this.isAuthenticated()
            }
        });
        this.adobeIMS.signOut({
            redirect_uri: (0, $jVeiz.encodeForRedirect)()
        });
    }
    clear() {
        $3x6rS.Internal.clearUser();
        $iJaYo.storage.local.clearOnLogout();
        $iJaYo.storage.session.clear();
        sessionStorage.removeItem("shellTokenExpireAt");
        this.logout.remove();
        this.tokenPoller && $3x6rS.Internal.removePoller(this.tokenPoller);
        this.validateAndEmitMap = {};
        this.validateAndRefreshMap = {};
    }
    addListenersToAuth(listeners) {
        listeners && Object.keys(listeners).forEach((event)=>{
            document.addEventListener(event, listeners[event]);
            this.on(event, listeners[event]);
        });
    }
    getClientId() {
        return this.adobeid.client_id;
    }
    async storeExchangeToken({ token: { expires_in: expires_in, access_token: token }, profile: profile }) {
        const expirems = expires_in < 100000 ? expires_in * 1000 : expires_in;
        await this.updateProfile(profile);
        this.adobeIMS.setStandAloneToken({
            expirems: expirems,
            token: token
        });
        await this.updateTrackedTokens(profile.userId);
    }
    async switchProfile(userId, clusterToken) {
        try {
            if (clusterToken && this.refresher.canUseTokenForUser(clusterToken, userId)) {
                this.metrics.event("Auth.ClusterToken");
                return this.storeExchangeToken(clusterToken);
            }
            await this.adobeIMS.switchProfile(userId, {
                client_id: this.getClientId(),
                prompt: "none",
                response_type: "token",
                scope: this.adobeid.scope,
                target_profile: userId
            });
            await this.updateTrackedTokens(userId);
        } catch (error) {
            const message = (0, $iNslS.getErrorMessage)(error);
            if (message.includes("invalid_credentials")) try {
                const { exchangeToken: token } = await (0, $3LITL.exchangeToken)({
                    targetUserId: userId
                });
                await this.storeExchangeToken(token);
            } catch (e) {
                this.metrics.event("Fallback Token Exchange Failure", {
                    error: (0, $iNslS.getErrorMessage)(e)
                }, {
                    level: $e7c1f93ce62570e3$var$_metrics.Level.ERROR
                });
            }
            else this.metrics.event("Switch Profile Failure", {
                error: message
            }, {
                level: $e7c1f93ce62570e3$var$_metrics.Level.ERROR
            });
        }
    }
    async updateTrackedTokens(userId) {
        const expirations = this.refresher.expirationTracker;
        let res; // Grab the current set of keys that are being checked for expiration. We
        // need to use the current tracked tokens to know which tokens to regenerate
        // using the new userId, so that is why we need to store this list now to
        // remove later.
        const keysToRemove = Object.keys(expirations); // Loop through the current set of expirations to know which tokens to
        // regenerate with the new userId from the profile switch. Emits change or
        // fail events for these so that the appropriate services know about it.
        for (const { isExcClient: isExcClient, clientId: clientId, scope: scope } of Object.values(expirations)){
            res = {};
            if (isExcClient) {
                res.profile = await this.adobeIMS.getProfile();
                res.token = this.fetchAccessToken();
            } else {
                const { access_token: token, ...profile } = await this.fetchCustomImsAccessToken(clientId, scope, userId);
                res = {
                    profile: profile,
                    token: token
                };
            }
            if (!res.token) {
                this.emit("auth.validatetokenfailed", {
                    clientId: clientId,
                    isExcClient: isExcClient
                });
                continue;
            }
            this.emit("auth.token.change", {
                ...res,
                clientId: clientId,
                isExcClient: isExcClient,
                scope: scope,
                userId: userId
            });
        } // Finally, remove the previous set of expirations from the expirations
        // check so that only the new set are tracked.
        this.refresher.removeExpirationKeys(keysToRemove);
    }
    isSessionEnvValid(imsEnv, buildEnv) {
        if (!(0, $d2Ld2.isSessionEnvValid)(imsEnv, buildEnv)) {
            this.metrics.event("Auth.ims.conflict", {
                level: $e7c1f93ce62570e3$var$_metrics.Level.ERROR
            });
            this.signOut(true);
        }
    }
    /**
   * Determines whether or not to sign out the user after an error.
   * @param error
   * @param description
   * @returns {boolean} True if browser is refreshing (sign out or reload)
   */ async signoutOnError(error, description) {
        const errors = (error || {}).errors || {};
        if (401 in errors) {
            const { success: success } = await this.validateTokenAndEmit(false);
            (0, $01ci4.queueMetrics)("401 error", {
                data: {
                    validToken: success
                },
                description: description,
                error: error
            });
            if (!success) {
                try {
                    await this.refreshToken();
                    const reloaded = await (0, $ggkvY.reload)({
                        initiator: "Auth",
                        reason: "New Token After 401"
                    });
                    (0, $01ci4.queueMetrics)("401 error, refresh token and reload attempt", {
                        data: {
                            reloadAttempt: reloaded,
                            validToken: success
                        }
                    });
                    if (!reloaded) await this.signOut();
                } catch (err) {
                    (0, $01ci4.queueMetrics)("401 error, refresh token and reload error", {
                        data: {
                            validToken: success
                        },
                        error: err
                    });
                    await this.signOut();
                }
                return true;
            }
            return false;
        }
        if (429 in errors) {
            (0, $01ci4.queueMetrics)("429 error, auth rate limited", {
                description: description,
                error: error
            });
            this.emit("auth.rateLimited");
            return false;
        }
        this.metrics.error(`${description} Load error: ${Object.keys(errors).join(", ")}`, error);
        return false;
    }
    /**
   * Get the number of seconds since the last time the user was active.
   * @returns {number | null} - Number of seconds or null if
   *  `this._activityMonitor` is not defined yet.
   */ getSecondsSinceLastActive() {
        return this._activityMonitor && Math.floor((Date.now() - this._activityMonitor.lastActive) / 1000);
    }
    /**
   * Get a new access token from IMS. Adds an additional field
   * `userInactiveSince` onto the request if it's a valid number so IMS can
   * handle the case where the user might have been inactive longer than the PBA
   * setting.
   * @async
   * @returns {Promise<Object>} - Token and profile data.
   */ async refreshToken() {
        try {
            const userInactiveSince = this.getSecondsSinceLastActive();
            const refreshArgs = typeof userInactiveSince === "number" && {
                userInactiveSince: userInactiveSince
            };
            const { profile: profile, tokenInfo: { token: token } } = await this.adobeIMS.refreshToken(refreshArgs);
            this.metrics.info("Refreshed token");
            this.trackToken(token);
            return {
                profile: profile,
                token: token
            };
        } catch (e) {
            this.metrics.error(`Failed refreshing ${this.getClientId()} token`, e);
            throw e;
        }
    }
    isExcClient(clientId) {
        return clientId === this.getClientId();
    }
    /**
   *
   */ async refreshCustomToken({ clientId: clientId, scope: scope, userId: userId }) {
        const res = await this.fetchCustomImsAccessToken(clientId, scope, userId);
        return {
            profile: res,
            token: res.access_token
        };
    }
    /**
   * Get initial data for Shell - User Profile, Org & Login data from GraphQL
   * @param {boolean} isReload - True for reload, false for Login
   * @returns {Promise<*>} Initial data
   */ async gqlHandler(isReload) {
        // Grab the org from the path and use that as the selected org. If there
        // is no org yet, use the selected one from IMS.
        try {
            const shellInitData = await this.accountClusterPromise;
            if (!isReload) await this.updateProfile((shellInitData || {}).userProfileJson);
             // Make sure there is an account cluster before proceeding
            if (!shellInitData?.imsExtendedAccountClusterData?.data) throw new Error("GQL failed to return the account cluster");
             // If there is more data to be fetched,
            // we will need to keep fetching until we have all the data.
            while(shellInitData?.imsExtendedAccountClusterData?.next !== null){
                const { data: data, next: next } = shellInitData.imsExtendedAccountClusterData;
                const { imsExtendedAccountClusterData: userAccounts } = await (0, $3LITL.getPaginatedAccountClusters)({
                    from: next
                });
                data.push.apply(data, userAccounts.data);
                shellInitData.imsExtendedAccountClusterData.next = userAccounts.next;
            }
            return shellInitData;
        } catch (error) {
            const reloading = await this.signoutOnError(error, "GQL");
            if (reloading) error.reload = true;
            throw error;
        }
    }
    async updateProfile(profile) {
        if (!profile) return this.adobeIMS.getProfile();
         // set fetched profile from gql in IMS Session storage
        this.adobeIMS.profileService.saveProfileToStorage(profile);
        this.authId = profile.authId || profile.userId;
        return profile;
    }
}
const $e7c1f93ce62570e3$var$instance = new $e7c1f93ce62570e3$var$Auth();
const $e7c1f93ce62570e3$var$AuthInstance = (config)=>{
    if (!$e7c1f93ce62570e3$var$imsLoaded) $e7c1f93ce62570e3$var$instance.load(config);
    return $e7c1f93ce62570e3$var$instance;
};
module.exports.AuthInstance = $e7c1f93ce62570e3$var$AuthInstance;

});
parcelRegister("dJSrf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $a009b4ad3f1b9a9e$var$Emitter = /** @class */ function() {
    function Emitter(all) {
        this.all = all || Object.create(null);
    }
    /**
   * Register an event handler for the given type.
   * @param type Type of event to listen for.
   * @param handler Function to call in response to given event.
   */ Emitter.prototype.on = function(type, handler) {
        (this.all[type] || (this.all[type] = [])).push(handler);
    };
    /**
   * Remove an event handler for the given type.
   * @param type Type of event to unregister `handler` from.
   * @param handler Handler function to remove.
   */ Emitter.prototype.off = function(type, handler) {
        if (this.all[type]) this.all[type].splice(this.all[type].indexOf(handler) >>> 0, 1);
    };
    /**
   * Removes all event handlers to prevent memory leaks.
   */ Emitter.prototype.reset = function() {
        this.all = {};
    };
    /**
   * Invoke all handlers for the given type.
   * @param type The event type to invoke.
   * @param evt Any value (object is recommended and powerful),
   * passed to each handler.
   * @param changed Any changed values if the event encompasses more.
   */ Emitter.prototype.emit = function(type, evt, changed) {
        (this.all[type] || []).slice().forEach(function(handler) {
            return changed ? handler(evt, changed) : handler(evt);
        });
    };
    return Emitter;
}();
var $a009b4ad3f1b9a9e$var$_default = $a009b4ad3f1b9a9e$var$Emitter;
module.exports.default = $a009b4ad3f1b9a9e$var$_default;

});

parcelRegister("01ci4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.queueMetrics = module.exports.flushQueuedMetrics = module.exports.STORAGE_DURATION = module.exports.DAY = void 0;

var $6f552ca451bbfe59$var$_metrics = $6f552ca451bbfe59$var$_interopRequireWildcard((parcelRequire("17AVh")));

var $iJaYo = parcelRequire("iJaYo");
function $6f552ca451bbfe59$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $6f552ca451bbfe59$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $6f552ca451bbfe59$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6f552ca451bbfe59$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $6f552ca451bbfe59$var$DAY = 86400000;
module.exports.DAY = $6f552ca451bbfe59$var$DAY;
const $6f552ca451bbfe59$var$STORAGE_DURATION = $6f552ca451bbfe59$var$DAY * 30; // 30 days
module.exports.STORAGE_DURATION = $6f552ca451bbfe59$var$STORAGE_DURATION;
const $6f552ca451bbfe59$var$STORAGE_KEY = "queuedMetrics";
const $6f552ca451bbfe59$var$metrics = $6f552ca451bbfe59$var$_metrics.default.create("exc.auth.queuedMetrics");
/**
 * Push all of the metrics stored locally out through the current metrics instance
 */ const $6f552ca451bbfe59$var$flushQueuedMetrics = ()=>{
    const { items: items } = $iJaYo.storage.local.getSync($6f552ca451bbfe59$var$STORAGE_KEY) || {};
    (items || []).forEach((item)=>{
        // item is a tuple of [msg, queuedMetrics]
        $6f552ca451bbfe59$var$metrics.event("QueuedMetrics.Flush", item[0], item[1], {
            level: $6f552ca451bbfe59$var$_metrics.Level.INFO
        });
    }); // Clear the storage so we don't log the same thing multiple times
    $iJaYo.storage.local.remove($6f552ca451bbfe59$var$STORAGE_KEY);
};
/**
 * Queue a metric to be saved and send on login.
 */ module.exports.flushQueuedMetrics = $6f552ca451bbfe59$var$flushQueuedMetrics;
const $6f552ca451bbfe59$var$queueMetrics = (msg, queueData)=>{
    const { instanceId: instanceId } = window.adobeMetrics.metricsState;
    const timestamp = new Date().toISOString(); // '2023-12-18T00:00:00.0000000Z'
    const { items: items = [] } = $iJaYo.storage.local.getSync($6f552ca451bbfe59$var$STORAGE_KEY) || {};
    items.push([
        msg,
        {
            instanceId: instanceId,
            timestamp: timestamp,
            ...queueData
        }
    ]);
    $iJaYo.storage.local.set($6f552ca451bbfe59$var$STORAGE_KEY, {
        items: items
    }, $6f552ca451bbfe59$var$STORAGE_DURATION);
};
module.exports.queueMetrics = $6f552ca451bbfe59$var$queueMetrics;

});

parcelRegister("aywNo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getImsFilter = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $74305d7b18036c63$var$STANDARD_METADATA = '"findFirst":true, "fallbackToAA":true, "preferForwardProfile":true';
/**
 * Returns a T2E Profile filter for the given IMS org information.
 * For more information about filter syntax see:
 * {@link https://wiki.corp.adobe.com/display/ims/Profile+Filter+syntax}
 * @param imsOrgId - IMS Org ID (Optional)
 * @param tenantId - Tenant ID (Optional)
 * @returns Profile filter string
 */ const $74305d7b18036c63$var$getImsFilter = ({ imsOrgId: imsOrgId, tenantId: tenantId } = {})=>{
    let filter = 'hasPC("dma_tartan")'; // Unified Shell supports both tenant IDs and IMS orgs in the URL.
    // If the tenant ends with "@AdobeOrg", treat it as an IMS org.
    if (imsOrgId || tenantId?.endsWith("@AdobeOrg")) filter = `isOwnedByOrg('${imsOrgId || tenantId}')`;
    else if (tenantId) filter = `hasPcParam('dma_tartan','tenant_id','${tenantId}')`;
    return `{${$74305d7b18036c63$var$STANDARD_METADATA}, "searchEntireCluster":${filter.startsWith("isOwnedByOrg")}}; ${filter}`;
};
module.exports.getImsFilter = $74305d7b18036c63$var$getImsFilter;

});

parcelRegister("85ztx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRefresher = module.exports.Refresher = void 0;

var $iNslS = parcelRequire("iNslS");

var $d2Ld2 = parcelRequire("d2Ld2");

var $57eed5e3337e8fcd$var$_metrics = $57eed5e3337e8fcd$var$_interopRequireDefault((parcelRequire("17AVh")));
function $57eed5e3337e8fcd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $57eed5e3337e8fcd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $57eed5e3337e8fcd$var$EXPIRATION_PERC = .20;
const $57eed5e3337e8fcd$var$MAX_TIME_REMAINING = 7200000;
const $57eed5e3337e8fcd$var$SCHEDULE_FREQ = 60000;
class $57eed5e3337e8fcd$var$Refresher {
    constructor(activityMonitorPromise){
        $57eed5e3337e8fcd$var$_defineProperty(this, "_activityMonitor", null);
        $57eed5e3337e8fcd$var$_defineProperty(this, "_expirationTracker", {});
        $57eed5e3337e8fcd$var$_defineProperty(this, "_lastRefresh", 0);
        $57eed5e3337e8fcd$var$_defineProperty(this, "_metrics", $57eed5e3337e8fcd$var$_metrics.default.create("exc.auth.Refresher"));
        $57eed5e3337e8fcd$var$_defineProperty(this, "_tokenPoller", null);
        // Grab the activity monitor so that we have access to the last active
        // prpoerty to determine if the user was active since their last token
        // refresh.
        activityMonitorPromise.then((activityMonitor)=>{
            this._activityMonitor = activityMonitor;
        });
    }
    get expirationTracker() {
        return this._expirationTracker;
    }
    parseTrackedTokens() {
        const tracked = {};
        Object.keys(this._expirationTracker).forEach((key)=>{
            const { clientId: clientId, refreshAt: refreshAt } = this._expirationTracker[key];
            tracked[key] = {
                clientId: clientId,
                refreshAt: refreshAt
            };
        });
        return tracked;
    }
    /**
   * Checks tracked tokens for expiration and refreshes. If the refresh is a
   * success, it emits an event. If the refresh fails, it logs it. Only checks
   * if the user has been active since the last refresh.
   */ async checkForExpirations() {
        // If the user hasn't been active since the last token refresh, there is no
        // need to check for expirations. We should only be refreshing tokens if
        // the user has been active.
        if (!this._activityMonitor || this._activityMonitor.lastActive < this._lastRefresh) {
            this._metrics.event("checkForExpiration.skipped", {
                hasActivityMonitor: !!this._activityMonitor,
                lastActive: this._activityMonitor?.lastActive,
                lastRefresh: this._lastRefresh,
                tracked: this.parseTrackedTokens()
            });
            return;
        }
        const date = Date.now();
        let hasRefreshed = false;
        const promises = [];
        Object.values(this._expirationTracker).forEach(({ clientId: clientId, eventFn: eventFn, isExcClient: isExcClient, refreshAt: refreshAt, refreshFn: refreshFn, scope: scope, userId: userId })=>{
            if (date >= refreshAt) {
                const promise = refreshFn({
                    clientId: clientId,
                    scope: scope,
                    userId: userId
                }).then(({ profile: profile, token: token })=>{
                    this._metrics.event("Token.refresh", {
                        clientId: clientId,
                        isExcClient: isExcClient,
                        userId: userId
                    });
                    eventFn("auth.token.change", {
                        clientId: clientId,
                        isExcClient: isExcClient,
                        profile: profile,
                        scope: scope,
                        token: token,
                        userId: userId
                    });
                    hasRefreshed = true;
                }).catch((err)=>this._metrics.error(`Unable to refresh token for client: ${clientId}`, {
                        error: err?.message || "unknown error"
                    }));
                promises.push(promise);
            }
        });
        await Promise.all(promises); // If there was a refresh, set the epoch of the refresh so that it can be
        // compared to the last active epoch on subsequent calls of this method.
        hasRefreshed && (this._lastRefresh = Date.now());
    }
    /**
   * Gets the epoch time in which this token should be refreshed.
   * @param {string} token - The token to get time to refresh for.
   * @returns {number} - The epoch time to refresh the token.
   */ getRefreshAt(token) {
        const { created_at: created_at = Date.now(), expires_in: expires_in = 3600000 } = (0, $iNslS.extractTokenMetadata)(token) || {};
        return created_at + expires_in - Math.min(expires_in * $57eed5e3337e8fcd$var$EXPIRATION_PERC, $57eed5e3337e8fcd$var$MAX_TIME_REMAINING);
    }
    /**
   * Remove the provided list of keys from the tracking map.
   * @param {Array.<string>} keys - List of keys to remove.
   */ removeExpirationKeys(keys) {
        keys.forEach((key)=>delete this._expirationTracker[key]);
    }
    /**
   * Tracks a new token expiration object for refreshing. Adds the entry to the
   * map and kicks off the tracking interval if it's not already active.
   * @param {Object} expiration - The token expiration object to track.
   */ trackRefresh(expiration) {
        const { clientId: clientId, scope: scope, userId: userId } = expiration;
        const key = (0, $d2Ld2.getTokenKey)(clientId, scope, userId);
        this._expirationTracker[key] = expiration; // Only create a new token poller if it's not active already.
        if (this._tokenPoller) return;
        this._tokenPoller = window.setInterval(()=>this.checkForExpirations(), $57eed5e3337e8fcd$var$SCHEDULE_FREQ);
    }
    canUseTokenForUser({ token: { access_token: token } }, userId) {
        const refreshAt = this.getRefreshAt(token);
        const { user_id: user_id } = (0, $iNslS.extractTokenMetadata)(token) || {};
        return user_id === userId && refreshAt > Date.now();
    }
}
module.exports.Refresher = $57eed5e3337e8fcd$var$Refresher;
let $57eed5e3337e8fcd$var$refresher;
const $57eed5e3337e8fcd$var$getRefresher = (activityMonitorPromise)=>{
    if (!$57eed5e3337e8fcd$var$refresher) $57eed5e3337e8fcd$var$refresher = new $57eed5e3337e8fcd$var$Refresher(activityMonitorPromise);
    return $57eed5e3337e8fcd$var$refresher;
};
module.exports.getRefresher = $57eed5e3337e8fcd$var$getRefresher;

});
parcelRegister("d2Ld2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSessionEnvValid = $c6875ec19ed7956d$var$isSessionEnvValid;
module.exports.getTokenKey = module.exports.getToken = void 0;

var $c6875ec19ed7956d$var$cookie = $c6875ec19ed7956d$var$_interopRequireWildcard((parcelRequire("2S1XV")));

var $4ua75 = parcelRequire("4ua75");

var $c6875ec19ed7956d$var$_stringHash = $c6875ec19ed7956d$var$_interopRequireDefault((parcelRequire("h9eEw")));
function $c6875ec19ed7956d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c6875ec19ed7956d$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $c6875ec19ed7956d$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $c6875ec19ed7956d$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c6875ec19ed7956d$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /* eslint-disable sort-keys */ const $c6875ec19ed7956d$var$ENVS = {
    test: "stg1",
    dev: "stg1",
    qa: "stg1",
    stage: "stg1",
    prod: ""
};
/* eslint-enable sort-keys */ function $c6875ec19ed7956d$var$getIMSOrigin(env) {
    const imsExt = /^(prod)$/.test(env) ? "" : `-${$c6875ec19ed7956d$var$ENVS[env]}`;
    return `https://adobeid-na1${imsExt}.services.adobe.com`;
}
const $c6875ec19ed7956d$var$handleTokenResponse = async (res)=>{
    let data;
    try {
        data = await res.json();
    } catch  {
        // No JSON.
        throw new Error(`Error parsing JSON: ${res.status} ${res.statusText}`);
    }
    if (!res.ok || !data.access_token) throw data;
    return data;
};
/**
 * Retrieves the token from IMS. Adds an additional field
 * `userInactiveSince` onto the request if it's a valid number so IMS can
 * handle the case where the user might have been inactive longer than the PBA
 * setting.
 * @async
 * @param {GetTokenProps} props - Token props.
 * @param {string} clientId - Client id to fetch token with.
 * @param {string} env - IMS environment to use.
 * @param {string} scope - Scopes to pull for the token.
 * @param {string} userId - ID of the user to fetch.
 * @param {number} userInactiveSince - Time in seconds since the user was active.
 * @returns {Promise<CheckTokenResponse>} - The token data.
 */ const $c6875ec19ed7956d$var$getToken = async ({ clientId: clientId, env: env, scope: scope, userId: userId, userInactiveSince: userInactiveSince })=>{
    let url = `${$c6875ec19ed7956d$var$getIMSOrigin(env)}/ims/check/v6/token?client_id=${clientId}&scope=${scope}&user_id=${userId}`;
    userInactiveSince && (url = `${url}&userInactiveSince=${userInactiveSince}`);
    let res = await (0, $4ua75.fetch)(url, {
        credentials: "include",
        method: "POST",
        scope: $4ua75.FetchScope.ORG
    });
    let data;
    try {
        data = await $c6875ec19ed7956d$var$handleTokenResponse(res);
    } catch  {
        // NOTE: this is a hack to enable e2e tests for Cypress/wdio.
        // If the response fails, try again with the V1 endpoint.
        url = `${$c6875ec19ed7956d$var$getIMSOrigin(env)}/ims/check/v1/token?client_id=${clientId}&scope=${scope}`;
        res = await (0, $4ua75.fetch)(url, {
            credentials: "include",
            scope: $4ua75.FetchScope.ORG
        });
        data = await $c6875ec19ed7956d$var$handleTokenResponse(res);
    }
    return data || {};
};
module.exports.getToken = $c6875ec19ed7956d$var$getToken;
const $c6875ec19ed7956d$var$IMS_ENV_COOKIE = "shellImsEnv";
/**
 * Validates that the current environment on which we have a session is the same as the
 * requested one. This works around various IMS bugs.
 * @param {string} curImsEnv Currently selected IMS env
 * @param {string} buildEnv Current build environment (dev|qa|stage|prod)
 * @returns {boolean}
 */ function $c6875ec19ed7956d$var$isSessionEnvValid(curImsEnv, buildEnv) {
    const prevImsEnv = $c6875ec19ed7956d$var$cookie.get($c6875ec19ed7956d$var$IMS_ENV_COOKIE);
    const standardImsEnv = buildEnv === "prod" ? "prod" : "stage";
    let conflictingEnv; // The default IMS env is being used but the previous IMS environment is
    // different, we should sign out of the previous environment.
    if (standardImsEnv === curImsEnv && prevImsEnv && curImsEnv !== prevImsEnv) conflictingEnv = prevImsEnv;
     // The default IMS env is NOT being used (e.g. `shell_ims`)
    if (standardImsEnv !== curImsEnv) {
        // No previous IMS env, this means that the user hasn't gone through the
        // updated code yet. Sign out of the standard env just to be safe.
        if (!prevImsEnv) conflictingEnv = standardImsEnv; // There is a previous IMS env and it's not the same as the current one.
        else if (prevImsEnv && curImsEnv !== prevImsEnv) conflictingEnv = prevImsEnv;
    } // The auth env wasn't updated, so we can continue on.
    if (!conflictingEnv) {
        $c6875ec19ed7956d$var$cookie.set($c6875ec19ed7956d$var$IMS_ENV_COOKIE, curImsEnv, true);
        return true;
    }
    $c6875ec19ed7956d$var$cookie.del($c6875ec19ed7956d$var$IMS_ENV_COOKIE, true);
    return false;
}
/**
 * Returns token key.
 * @param clientId Client id string.
 * @param scope List of scopes.
 * @param userId User ID.
 */ const $c6875ec19ed7956d$var$getTokenKey = (clientId, scope, userId)=>btoa([
        clientId,
        scope,
        (0, $c6875ec19ed7956d$var$_stringHash.default)(userId).toString()
    ].join("|"));
module.exports.getTokenKey = $c6875ec19ed7956d$var$getTokenKey;

});
parcelRegister("2S1XV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.del = $22546daaee4f69c0$var$del;
module.exports.get = $22546daaee4f69c0$var$get;
module.exports.set = $22546daaee4f69c0$var$set;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /* eslint-disable no-useless-escape */ function $22546daaee4f69c0$var$del(name, secure) {
    document.cookie = `${name}=;domain=.adobe.com;expires=Thu, 01 Jan 1970 00:00:00 UTC;${secure ? "secure" : ""}`;
}
function $22546daaee4f69c0$var$get(name) {
    const cookie = decodeURIComponent(document.cookie).split(";").find((c)=>new RegExp(`\s*${name}=`).test(c));
    return cookie && cookie.split("=")[1];
}
function $22546daaee4f69c0$var$set(name, value, secure) {
    document.cookie = `${name}=${value};domain=.adobe.com;${secure ? "secure" : ""}`;
}

});



parcelRegister("3x6rS", function(module, exports) {
"use strict";
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Internal = void 0;

var $4jIM2 = parcelRequire("4jIM2");
/**
 * @ignore
 */ class $292974bcd09d8b47$var$Internal {
    static addPoller(poller) {
        return (0, $4jIM2.getImpl)("internal").addPoller(poller);
    }
    static configureMetrics(config) {
        return (0, $4jIM2.getImpl)("internal").configureMetrics(config);
    }
    static configureNetwork(config) {
        return (0, $4jIM2.getImpl)("internal").configureNetwork(config);
    }
    static configurePolling(config) {
        return (0, $4jIM2.getImpl)("internal").configurePolling(config);
    }
    static flush() {
        return (0, $4jIM2.getImpl)("internal").flush();
    }
    static getActivityMonitor() {
        return (0, $4jIM2.getImpl)("internal").getActivityMonitor();
    }
    static preloadEngine() {
        return (0, $4jIM2.getImpl)("internal").preloadEngine();
    }
    static registerActivityEmitter(emitter) {
        return (0, $4jIM2.getImpl)("internal").registerActivityEmitter(emitter);
    }
    static removePoller(handle) {
        return (0, $4jIM2.getImpl)("internal").removePoller(handle);
    }
    static setApplication(app) {
        return (0, $4jIM2.getImpl)("internal").setApplication(app);
    }
    static setFilter(filterFunction) {
        return (0, $4jIM2.getImpl)("internal").setFilter(filterFunction);
    }
    static setUser(user, version) {
        return (0, $4jIM2.getImpl)("internal").setUser(user, version);
    }
    static clearUser(version) {
        return (0, $4jIM2.getImpl)("internal").clearUser(version);
    }
    static waitForGainsight() {
        return (0, $4jIM2.getImpl)("internal").waitForGainsight();
    }
}
module.exports.Internal = $292974bcd09d8b47$var$Internal;

});
parcelRegister("4jIM2", function(module, exports) {
"use strict";
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.connect = module.exports.getImpl = void 0;
/**
 * Gets the implementation for the module.
 * @ignore
 * @param moduleName The name of the module.
 * @returns The implementation.
 */ function $324baae87a7230b0$var$getImpl(moduleName) {
    const emr = window["exc-module-runtime"];
    if (!emr) throw new Error(`module-runtime APIs not available (Fetching ${moduleName}).`);
    return emr[moduleName];
}
module.exports.getImpl = $324baae87a7230b0$var$getImpl;
/**
 * Connects attributes of the specified API.
 * @ignore
 * @param apiName Name of the API.
 * @param attributes The attributes to connect.
 * @returns The API instance.
 */ function $324baae87a7230b0$var$connect(apiName, attributes) {
    const api = {};
    attributes.forEach((feature)=>{
        const featureName = feature[0];
        if (feature[1]) api[featureName] = (...args)=>{
            return $324baae87a7230b0$var$getImpl(apiName)[featureName](...args);
        };
        else Object.defineProperty(api, featureName, {
            get: ()=>{
                return $324baae87a7230b0$var$getImpl(apiName)[featureName];
            },
            set: (value)=>{
                $324baae87a7230b0$var$getImpl(apiName)[featureName] = value;
            }
        });
    });
    return api;
}
module.exports.connect = $324baae87a7230b0$var$connect;
module.exports.default = window;

});


parcelRegister("1Jct3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ea66b8b6a5b5b6a1$var$_metrics = $ea66b8b6a5b5b6a1$var$_interopRequireDefault((parcelRequire("17AVh")));

var $01ci4 = parcelRequire("01ci4");
function $ea66b8b6a5b5b6a1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $ea66b8b6a5b5b6a1$var$KEY = "logoutUrls";
const $ea66b8b6a5b5b6a1$var$metrics = $ea66b8b6a5b5b6a1$var$_metrics.default.create("exc.auth.utils.Logout");
var $ea66b8b6a5b5b6a1$var$_default = {
    add (url, { distinctDomain: distinctDomain } = {}) {
        let logoutUrls = JSON.parse(localStorage.getItem($ea66b8b6a5b5b6a1$var$KEY) || "[]") || []; // If the `distinctDomain` property is true, filter out any logout URLs
        // that match the `url` host name. This ensures that applications adding
        // logout URLs won't accidentally be adding multiple.
        if (distinctDomain) try {
            const { host: host } = new URL(url);
            logoutUrls = logoutUrls.filter((logoutUrl)=>!logoutUrl.includes(host));
        } catch  {
            $ea66b8b6a5b5b6a1$var$metrics.error("Invalid URL when processing logoutUrl add", {
                url: url
            });
        }
         // Only add the logout URL if it doesn't already exist in the list.
        if (logoutUrls.indexOf(url) === -1) {
            logoutUrls.push(url);
            localStorage.setItem($ea66b8b6a5b5b6a1$var$KEY, JSON.stringify(logoutUrls));
        }
    },
    async invoke () {
        const logoutUrls = JSON.parse(localStorage.getItem($ea66b8b6a5b5b6a1$var$KEY) || "[]") || [];
        try {
            await Promise.all(logoutUrls.map((url)=>fetch(url, {
                    credentials: "include",
                    redirect: "manual"
                })));
        } catch (error) {
            if (error instanceof Error) (0, $01ci4.queueMetrics)("logoutUrls error", {
                data: {
                    logoutUrls: logoutUrls
                },
                error: error
            });
        }
    },
    remove () {
        localStorage.removeItem($ea66b8b6a5b5b6a1$var$KEY);
    }
};
module.exports.default = $ea66b8b6a5b5b6a1$var$_default;

});

parcelRegister("83dfQ", function(module, exports) {
"use strict";
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Level = module.exports.Events = void 0;

var $4jIM2 = parcelRequire("4jIM2");

var $7uUFJ = parcelRequire("7uUFJ");
Object.defineProperty(module.exports, "Events", {
    enumerable: true,
    get: function() {
        return $7uUFJ.Events;
    }
});

var $4ho1j = parcelRequire("4ho1j");
Object.defineProperty(module.exports, "Level", {
    enumerable: true,
    get: function() {
        return $4ho1j.Level;
    }
});
const $5dc8e299e8ffb1e9$var$api = (0, $4jIM2.connect)("metrics", [
    [
        "create",
        true
    ]
]);
module.exports.default = $5dc8e299e8ffb1e9$var$api;

});
parcelRegister("7uUFJ", function(module, exports) {
"use strict";
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Events = void 0;
/**
 * @packageDocumentation
 * @module metrics
 */ /**
 * Named events in loading lifecycle
 */ /**
 * @ignore
 */ var $57574bab048986ac$var$Events;
(function(Events) {
    Events["PAGE_LOAD_DONE"] = "exc.metrics.pageState.load.done";
    Events["PAGE_LOAD_START"] = "exc.metrics.pageState.load.start";
    Events["SPINNER_DONE"] = "exc.metrics.pageState.spinner.done";
    Events["SPINNER_START"] = "exc.metrics.pageState.spinner.start";
})($57574bab048986ac$var$Events = module.exports.Events || (module.exports.Events = {}));

});

parcelRegister("4ho1j", function(module, exports) {
"use strict";
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Level = void 0;
/**
 * @packageDocumentation
 * @module metrics
 */ /**
 * Log levels, for RecordType == Log.
 */ /**
 * @ignore
 */ var $31db61e060a2d102$var$Level;
(function(Level) {
    Level["ERROR"] = "ERROR";
    Level["WARN"] = "WARN";
    Level["INFO"] = "INFO";
    Level["DEBUG"] = "DEBUG";
    Level["TRACE"] = "TRACE";
})($31db61e060a2d102$var$Level = module.exports.Level || (module.exports.Level = {}));

});


parcelRegister("ggkvY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.reload = void 0;

var $9OLey = parcelRequire("9OLey");

var $4a609e3d6351e9b8$var$_metrics = $4a609e3d6351e9b8$var$_interopRequireWildcard((parcelRequire("17AVh")));

var $iJaYo = parcelRequire("iJaYo");
function $4a609e3d6351e9b8$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $4a609e3d6351e9b8$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $4a609e3d6351e9b8$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4a609e3d6351e9b8$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $4a609e3d6351e9b8$var$metrics = $4a609e3d6351e9b8$var$_metrics.default.create("exc.storage.Reloader");
let $4a609e3d6351e9b8$var$readPreviousResolve;
const $4a609e3d6351e9b8$var$readPreviousPromise = new Promise((resolve)=>$4a609e3d6351e9b8$var$readPreviousResolve = resolve);
let $4a609e3d6351e9b8$var$previousReloadReason = null;
if ($iJaYo.storage.session.get) // Check storage for a reload reason from the previous session.
$iJaYo.storage.session.get("reloadReason").then((reasonData)=>{
    $4a609e3d6351e9b8$var$previousReloadReason = reasonData;
    if (reasonData) {
        const { data: data = {}, forced: forced = false, initiator: initiator, reason: reason } = reasonData; // Log reload reason to EIM and clean storage.
        $4a609e3d6351e9b8$var$metrics.event(`Reload.Reason`, {
            forced: forced,
            initiator: initiator,
            reason: reason,
            ...data
        });
        $iJaYo.storage.session.remove("reloadReason"); // Forget previous reason after 10 minutes.
        setTimeout(()=>$4a609e3d6351e9b8$var$previousReloadReason = null, 600000);
    }
    $4a609e3d6351e9b8$var$readPreviousResolve();
});
else {
    $4a609e3d6351e9b8$var$metrics.event(`Reload.NoStorage`, {
        level: $4a609e3d6351e9b8$var$_metrics.Level.ERROR
    });
    $9OLey.Internal.flush();
}
/**
 * Reloads Unified Shell, storing reload reason in session storage so it can be
 * logged to EIM after reload. Reload reason will also be used to prevent reload loops.
 * @param {ReloadReason} reason - Reload reason
 * @param {boolean} force - Force reload - Will reload even after a previous reload.
 *
 * @returns {boolean} true if browser was reloaded, false otherwise.
 */ const $4a609e3d6351e9b8$var$reload = async (reasonData, force = false)=>{
    await $4a609e3d6351e9b8$var$readPreviousPromise;
    if ($4a609e3d6351e9b8$var$previousReloadReason && $4a609e3d6351e9b8$var$previousReloadReason.initiator === reasonData.initiator) {
        if (!force) {
            $4a609e3d6351e9b8$var$metrics.event("Reload.doubleReloadBlocked", {
                currentReload: reasonData,
                previousReload: $4a609e3d6351e9b8$var$previousReloadReason
            }, {
                level: $4a609e3d6351e9b8$var$_metrics.Level.ERROR
            });
            return false;
        } // eslint-disable-next-line no-param-reassign
        reasonData = {
            forced: true,
            ...reasonData
        };
    }
    const { data: data = {}, forced: forced = false, initiator: initiator, reason: reason } = reasonData;
    $4a609e3d6351e9b8$var$metrics.event("Reload.WillReload", {
        forced: forced,
        initiator: initiator,
        reason: reason,
        ...data
    });
    await $iJaYo.storage.session.set("reloadReason", reasonData);
    location.reload();
    return true;
};
module.exports.reload = $4a609e3d6351e9b8$var$reload;

});

parcelRegister("1DHFD", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = $Ha5sG("7j7ww").then(()=>parcelRequire("dRaxq"));

});



parcelRegister("5EtxO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3Zpnv = parcelRequire("3Zpnv");

var $fi30R = parcelRequire("fi30R");

var $jBKJw = parcelRequire("jBKJw");

var $41d79b167f2f22c7$var$_context = $41d79b167f2f22c7$var$_interopRequireDefault((parcelRequire("fTzIe")));

var $bMVp5 = parcelRequire("bMVp5");

var $dwEdq = parcelRequire("dwEdq");

var $etiLO = parcelRequire("etiLO");

var $41d79b167f2f22c7$var$_decodeUrl = $41d79b167f2f22c7$var$_interopRequireDefault((parcelRequire("1sIGS")));

var $9QLmC = parcelRequire("9QLmC");
var $jxYT9 = parcelRequire("jxYT9");

var $41d79b167f2f22c7$var$_metrics = $41d79b167f2f22c7$var$_interopRequireWildcard((parcelRequire("83dfQ")));

var $gigHb = parcelRequire("gigHb");

var $dDEjQ = parcelRequire("dDEjQ");

var $bToDy = parcelRequire("bToDy");

var $a2nzs = parcelRequire("a2nzs");

var $jVeiz = parcelRequire("jVeiz");

var $hCG2Z = parcelRequire("hCG2Z");

var $15j1u = parcelRequire("15j1u");

var $41d79b167f2f22c7$var$_stringHash = $41d79b167f2f22c7$var$_interopRequireDefault((parcelRequire("h9eEw")));

var $2GWWF = parcelRequire("2GWWF");

var $bzq4v = parcelRequire("bzq4v");

var $3LITL = parcelRequire("3LITL");

var $fKhPa = parcelRequire("fKhPa");

var $3x6rS = parcelRequire("3x6rS");

var $iNslS = parcelRequire("iNslS");

var $7CZdW = parcelRequire("7CZdW");

var $41d79b167f2f22c7$var$_OrchestrationService = $41d79b167f2f22c7$var$_interopRequireDefault((parcelRequire("gah5j")));

var $dXqQN = parcelRequire("dXqQN");

var $apIgy = parcelRequire("apIgy");

var $ftx2l = parcelRequire("ftx2l");

var $lRoWp = parcelRequire("lRoWp");

var $41d79b167f2f22c7$var$_react = $41d79b167f2f22c7$var$_interopRequireDefault((parcelRequire("7eprg")));

var $ctGaZ = parcelRequire("ctGaZ");

var $41d79b167f2f22c7$var$_ServiceWorkerControllerService = $41d79b167f2f22c7$var$_interopRequireDefault((parcelRequire("jNTva")));

var $fLrqA = parcelRequire("fLrqA");

var $cOPHH = parcelRequire("cOPHH");

var $bPa83 = parcelRequire("bPa83");

var $41d79b167f2f22c7$var$_Shell = $41d79b167f2f22c7$var$_interopRequireWildcard((parcelRequire("11cjw")));

var $iJaYo = parcelRequire("iJaYo");

var $41d79b167f2f22c7$var$_TranslationService = $41d79b167f2f22c7$var$_interopRequireDefault((parcelRequire("fnqzv")));

var $41d79b167f2f22c7$var$_UnifiedShellSessionService = $41d79b167f2f22c7$var$_interopRequireDefault((parcelRequire("d5KeZ")));

var $2qT0f = parcelRequire("2qT0f");

var $41d79b167f2f22c7$var$_WorkHubService = $41d79b167f2f22c7$var$_interopRequireDefault((parcelRequire("4dTp4")));
function $41d79b167f2f22c7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $41d79b167f2f22c7$var$_extends() {
    $41d79b167f2f22c7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $41d79b167f2f22c7$var$_extends.apply(this, arguments);
}
function $41d79b167f2f22c7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $41d79b167f2f22c7$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $41d79b167f2f22c7$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $41d79b167f2f22c7$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $41d79b167f2f22c7$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

const $41d79b167f2f22c7$var$DebugView = /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("1bitX"));
    }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res)));

const $41d79b167f2f22c7$var$ErrorView = /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("eFujB"));
    }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res)));

const $41d79b167f2f22c7$var$ShellNoAccess = /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("405KG"));
    }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res)));

const $41d79b167f2f22c7$var$ShellRolesModal = /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("ftmUA"));
    }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res)));

const $41d79b167f2f22c7$var$ShellRolesModalInvite = /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("6E0hT"));
    }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res)));

const $41d79b167f2f22c7$var$TuxContainer = /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("6VQBX"));
    }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res)));

const $41d79b167f2f22c7$var$UserConsentDialog = /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("3DCrn"));
    }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res)));

const $41d79b167f2f22c7$var$DialogContainer = /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("8zvyw"));
    }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res)).then((module)=>({
            default: module.DialogContainer
        })));

const $41d79b167f2f22c7$var$HistoryBlockerDialog = /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("9i99Z"));
    }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res)));

const $41d79b167f2f22c7$var$BetaAgreement = /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("iL5Qm"));
    }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res)));
const $41d79b167f2f22c7$var$RESETTABLE_ERRORS = [
    $fi30R.ErrorTypes.SANDBOX_FAIL,
    $fi30R.ErrorTypes.SUBORG_FAIL,
    $fi30R.ErrorTypes.TIMEOUT
];
const $41d79b167f2f22c7$var$LAST_LOGGED_IN = "LAST_LOGGED_IN";
const $41d79b167f2f22c7$var$AVATAR_SIZES = [
    110,
    115
];
const $41d79b167f2f22c7$var$DAY = 86400000;
const $41d79b167f2f22c7$var$MONTH = $41d79b167f2f22c7$var$DAY * 30;
const $41d79b167f2f22c7$var$TEN_YEARS = $41d79b167f2f22c7$var$DAY * 3650;
const $41d79b167f2f22c7$var$TOAST_TIMEOUT = 11000;
const $41d79b167f2f22c7$var$FULL_ZOOM_WIDTH = 768;
const $41d79b167f2f22c7$var$SHELL_SIDE_NAV_WIDTH = 222;
const $41d79b167f2f22c7$var$SIDE_NAV_FULL_ZOOM_WIDTH = 768; // This supports assets/content hub ask to decode and decompress
// fulfillable_data in the IMS product contexts. Should future apps need this
// they will need to be added to this list. But for now this is a special case
const $41d79b167f2f22c7$var$SERVICE_CODES_USING_GZIP = [
    "dma_aem_cloud"
];
const $41d79b167f2f22c7$var$RECENTS_RESET = {
    cursor: {
        isSet: false,
        value: null
    },
    recents: [],
    status: $fi30R.RecentStatus.LOADING
};
const $41d79b167f2f22c7$var$cleanTenant = (tenant)=>tenant && tenant.split(":")[0];










class $41d79b167f2f22c7$var$Core extends $41d79b167f2f22c7$var$_react.default.Component {
    constructor(props){
        super(props);
        $41d79b167f2f22c7$var$_defineProperty(this, "getSessionId", ()=>this.bootstrap.getSid() || "unknown");
        $41d79b167f2f22c7$var$_defineProperty(this, "updateLastRecent", (recentTimestamp)=>{
            const { selectedImsOrg: selectedImsOrg } = this.state;
            this.lastRecents = {
                ...this.lastRecents || {},
                [selectedImsOrg]: recentTimestamp
            };
            this.setSetting({
                lastRecents: this.lastRecents
            });
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "handlePrefetch", ({ key: key, value: value })=>{
            if (key.startsWith("recents-") && value?.recents?.length > 0) {
                const { clickTimestamp: clickTimestamp } = value.recents[0];
                const { selectedImsOrg: selectedImsOrg } = this.state;
                if (clickTimestamp > (this.lastRecents?.[selectedImsOrg] || 0)) this.updateLastRecent(clickTimestamp);
            }
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "updateCollapsedState", ()=>{
            const oldOpen = this.state.sideNavOpen;
            if (window.innerWidth <= $41d79b167f2f22c7$var$FULL_ZOOM_WIDTH && oldOpen) // Since this is a temporary close, we don't need to save to settings / session
            this.setState({
                sideNavOpen: false,
                sideNavOpenByHover: false
            });
            else if (window.innerWidth > $41d79b167f2f22c7$var$FULL_ZOOM_WIDTH) {
                const savedState = this.getSideNavState(true);
                savedState && savedState !== oldOpen && this.toggleSideNav(savedState);
            }
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "setProductContextValues", async (productContexts)=>{
            for (const ctx of productContexts){
                // Function to update service mappings
                const updateServices = (map, servicesKey, canSplit = true)=>{
                    map[owningEntity] = map[owningEntity] || {}; // Putting concatenated array of service keys into a set to de-dupe the
                    // list of keys before converting back to an array.
                    map[owningEntity][serviceCode] = Array.from(new Set((map[owningEntity][serviceCode] || []).concat(canSplit ? servicesKey.split(",") : servicesKey)));
                };
                const { enable_sub_service: enable_sub_service, fulfillable_data: fulfillable_data, services_enabled: services_enabled, owningEntity: owningEntity, serviceCode: serviceCode, user_visible_name: user_visible_name } = ctx.prodCtx; // Keep track of all of the org ids that are in this user's product context.
                this.allOrgs.add(owningEntity); // Create a map of org id to list of service codes.
                this.userServiceCodes[owningEntity] = this.userServiceCodes[owningEntity] || [];
                this.userServiceCodes[owningEntity].push(serviceCode); // Create map of org id / service code to FIs.
                services_enabled && updateServices(this.userFulfillableItems, services_enabled); // Create map of org id / service code to fulfillable data (limited to a list of apps).
                // First, parse the data string to remove extra escaped characters for the encoding check
                if ($41d79b167f2f22c7$var$SERVICE_CODES_USING_GZIP.includes(serviceCode) && fulfillable_data) {
                    let fulfillableData = (0, $etiLO.parseIfJson)(fulfillable_data);
                    const decoded = fulfillableData && (0, $etiLO.decodeBase64String)(fulfillableData);
                    if (decoded) fulfillableData = JSON.parse(await (0, $etiLO.decompressString)(decoded));
                    fulfillableData && updateServices(this.userFulfillableData, fulfillableData, false);
                } // Create map of org id / sub service codes
                enable_sub_service && updateServices(this.userSubServices, enable_sub_service); // Adds a region to the region map. Only region from ACP service code is required.
                if (serviceCode === "acp") this.orgRegions[owningEntity] = this.orgRegions[owningEntity] || ctx.prodCtx.region;
                 // Adds a user visible name to the visible names map.
                user_visible_name && updateServices(this.userVisibleNames, user_visible_name, false);
            }
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "storeTenantMap", (selectedImsOrg)=>$41d79b167f2f22c7$var$_OrchestrationService.default.waitForBackground().then(()=>$iJaYo.storage.local.set("tenantMap", {
                    ...this.tenantMap,
                    LAST_ORG: selectedImsOrg
                }, $41d79b167f2f22c7$var$MONTH)));
        $41d79b167f2f22c7$var$_defineProperty(this, "getBetaAgreements", ()=>this.getSetting({
                betaAgreements: {}
            }, $fLrqA.SettingsLevel.USERORG).then((res)=>res?.settings?.betaAgreements));
        $41d79b167f2f22c7$var$_defineProperty(this, "correctAEMOrg", async (selectedImsOrg, userId, completeLoading)=>{
            if (!this.aemPromise) this.aemPromise = Promise.resolve().then(function() {
                return (parcelRequire("hFGrB"));
            }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res)).then(({ getOrgFromRepo: getOrgFromRepo })=>getOrgFromRepo());
            const imsOrg = await this.aemPromise;
            if (imsOrg && imsOrg !== selectedImsOrg) {
                const { orgAccountMap: orgAccountMap } = await this.getAccountCluster() || {};
                if (!orgAccountMap) return;
                this.updateUrlOnOrgChange(imsOrg, selectedImsOrg, true, null);
                return orgAccountMap[imsOrg] === userId ? this.onImsOrgChange(imsOrg, selectedImsOrg, null, true) : this.onType2eOrgChange(orgAccountMap[imsOrg], true);
            }
            completeLoading();
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "getSelectedImsOrg", async (orgsMap, profile, pathOrg, loginOrgsData)=>{
            const localSession = await $41d79b167f2f22c7$var$_UnifiedShellSessionService.default.get() || {};
            this.sessionId = this.getSessionId();
            if (this.sessionId && !localSession.session) await $41d79b167f2f22c7$var$_UnifiedShellSessionService.default.update("session", this.sessionId);
            const fallbackOrgId = await this.getFallbackOrg(orgsMap);
            let selectedImsOrg = fallbackOrgId;
            const { lastLoggedInOrg: lastLoggedInOrg, loginOrg: loginOrg } = loginOrgsData || {};
            const activeOrg = localSession.activeOrg || loginOrg;
            if (this.isValidOrg(orgsMap, pathOrg)) selectedImsOrg = pathOrg;
            else if (this.isValidOrg(orgsMap, activeOrg)) selectedImsOrg = activeOrg;
            else if (this.isValidOrg(orgsMap, loginOrg)) selectedImsOrg = loginOrg;
            else if (this.isValidOrg(orgsMap, lastLoggedInOrg)) selectedImsOrg = lastLoggedInOrg;
            $41d79b167f2f22c7$var$_UnifiedShellSessionService.default.update("activeOrg", selectedImsOrg);
            return {
                activeOrg: activeOrg,
                selectedImsOrg: selectedImsOrg
            };
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "getPathOrg", (location = this.history.location)=>{
            const pathTenant = (0, $jVeiz.getTenantFromPath)(location.pathname, true);
            const { solutionConfig: solutionConfig } = this.state;
            let pathOrg = pathTenant; // For cases where a solution wants to gather the pathOrg. Specifically,
            // Analytics checks the search string for `current_org` and provides that
            // value as the pathOrg.
            if (!pathOrg && solutionConfig.getPathOrgFromContext) pathOrg = solutionConfig.getPathOrgFromContext(location);
            if (pathTenant && pathTenant.indexOf("AdobeOrg") === -1) {
                pathOrg = this.tenantOrgMap[pathTenant];
                if (Object.keys(this.tenantOrgMap).length && !pathOrg) this.metrics.warn(`User doesn't have access to ${pathTenant} tenant`);
            }
            return pathOrg;
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "getFallbackOrg", async (orgs = [])=>{
            const orgAccountMap = await $41d79b167f2f22c7$var$_UnifiedShellSessionService.default.get("shellOrgAccountMap") || {}; // First check the current account for the fallback org, then fallback to any org in the list
            const userHash = this.state.auth.getHashedUserId();
            const fallbackOrg = orgs.find((org)=>orgAccountMap[org.imsOrgId] === userHash) || orgs[0];
            return fallbackOrg?.imsOrgId;
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "isValidOrg", (orgs, selectedImsOrg)=>selectedImsOrg && orgs?.find((org)=>org.imsOrgId === selectedImsOrg));
        $41d79b167f2f22c7$var$_defineProperty(this, "handleSideNavMouseLeave", ()=>{
            setTimeout(()=>{
                // find where the mouse is
                const hoveredElements = document.querySelectorAll(":hover");
                const elementMouseIsOver = hoveredElements[hoveredElements.length - 1];
                const mouseOnSideNav = elementMouseIsOver?.className?.toLowerCase().includes("sidenav"); // if mouse is not over the side nav, close side nav
                if (!mouseOnSideNav && this.state.sideNavOpenByHover) {
                    this.setState({
                        sideNavOpen: false,
                        sideNavOpenByHover: false
                    });
                    this.fireSideNavOmegaEvent("mouseleave", false);
                }
            }, 500);
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "sideNavSetAllToState", async (toggleState)=>{
            const { settings: settings } = await this.getSetting({
                shellNav: null
            }); // Fetch from settings to ensure we're not overriding any entries.
            $iJaYo.storage.session.set("sideNavOpen", toggleState);
            if (!settings.shellNav || settings.shellNav.open !== toggleState) this.setSetting({
                shellNav: {
                    ...settings?.shellNav,
                    open: toggleState
                }
            });
            this.setState({
                sideNavOpen: toggleState,
                sideNavOpenByHover: false
            });
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "fireSideNavOmegaEvent", (uiInteraction, open)=>{
            let action = "hamburger click";
            let widgetType = "button";
            switch(uiInteraction){
                case "nav":
                    action = "SideNavItem click";
                    widgetType = "SideNavItem";
                    break;
                case "hover":
                case "mouseleave":
                    action = "hamburger hover";
                    break;
            }
            this.metrics.analytics.trackEvent({
                action: action,
                attributes: {
                    opened: open
                },
                element: open ? "nav open" : "nav close",
                feature: "left nav",
                type: "button",
                widget: {
                    name: "nav interaction",
                    type: widgetType
                }
            });
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "toggleSideNav", async (toggleTo, uiInteraction)=>{
            const { customLeftNavClick: customLeftNavClick, leftNavCloseOnSelection: leftNavCloseOnSelection, sideNavOpen: sideNavOpen, sideNavOpenByHover: sideNavOpenByHover } = this.state; // toggle to opposite of current state if no e provided
            const toggleState = typeof toggleTo === "boolean" ? toggleTo : !sideNavOpen; // toggle from non-ui interactions
            if (!uiInteraction) return this.state.sideNavOpen !== toggleState && this.sideNavSetAllToState(toggleState);
            let open;
            switch(uiInteraction){
                case "nav":
                    if (window.innerWidth <= $41d79b167f2f22c7$var$SIDE_NAV_FULL_ZOOM_WIDTH) {
                        // Navigating should close the side nav if its opened only thru hover
                        open = sideNavOpenByHover ? false : sideNavOpen;
                        sideNavOpenByHover && this.setState({
                            sideNavOpen: open,
                            sideNavOpenByHover: false
                        });
                    } // If the custom left nav is in use, close based on the config set
                    if (leftNavCloseOnSelection) customLeftNavClick && customLeftNavClick(false);
                    break;
                case "hover":
                    open = !sideNavOpen;
                    open && this.setState({
                        sideNavOpen: open,
                        sideNavOpenByHover: true
                    });
                    break;
                case "menu":
                    // Clicking the menu should lock open the side nav if its opened thru hover
                    open = sideNavOpenByHover ? true : !sideNavOpen;
                    this.sideNavSetAllToState(open); // Call the customLeftNav callback function
                    customLeftNavClick && customLeftNavClick(open);
                    break;
                case "mouseleave":
                    // Fires its own event, so doesn't need to set open
                    this.handleSideNavMouseLeave();
                    break;
            } // Don't fire an event if we aren't doing anything
            if (open === undefined) return;
            this.fireSideNavOmegaEvent(uiInteraction, open);
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "orgHasAEP", (orgId)=>this.userServiceCodes[orgId || this.state.selectedImsOrg]?.includes("acp"));
        $41d79b167f2f22c7$var$_defineProperty(this, "getComponentContext", ()=>{
            const { accessOverridesEnabled: accessOverridesEnabled, accessToken: accessToken, activeFeatureFlags: activeFeatureFlags, activeFulfillableItems: activeFulfillableItems, activeProductContext: activeProductContext, appContainer: appContainer, appProfile: appProfile, appToken: appToken, auth: auth, coachMark: coachMark, coachMarkPosition: coachMarkPosition, customSearch: customSearch, featureFlags: featureFlags, gainsightRoles: gainsightRoles, globalDialogOpen: globalDialogOpen, hero: hero, imsOrgs: imsOrgs, locale: locale, orgPermissioned: orgPermissioned, preferredLanguages: preferredLanguages, profile: profile, sandbox: sandbox, sandboxesAvailable: sandboxesAvailable, selectedOrgRegion: selectedOrgRegion, selectedImsOrg: selectedImsOrg, selectedImsOrgName: selectedImsOrgName, shellResponse: shellResponse, sideNavOpen: sideNavOpen, solutionConfig: solutionConfig, theme: userTheme, userAccounts: userAccounts, userConsent: userConsent, workHubResponse: workHubResponse } = this.state;
            const tenant = $41d79b167f2f22c7$var$cleanTenant((this.orgTenantMap || {})[selectedImsOrg] || "");
            const theme = solutionConfig?.theme || userTheme;
            return {
                ...this.getUserOrgContext(),
                ...this.services || {},
                accessOverridesEnabled: accessOverridesEnabled,
                accountCluster: userAccounts,
                activeProductContext: activeProductContext,
                aemInstanceId: (0, $15j1u.getSkylineInstance)(),
                agreements: this.agreements,
                apiKey: $dDEjQ.UNIFIED_SHELL_APIKEY,
                appContainer: appContainer,
                appProfile: appProfile,
                appToken: appToken,
                availability: this.availability,
                avatar: profile && profile.avatar || "",
                cdn: this.cdn,
                coachMark: coachMark,
                coachMarkPosition: coachMarkPosition,
                configureCustomIms: this.configureCustomIms,
                contextFetchPromise: this.contextFetchPromise,
                contextId: this.contextService?.getId(),
                contextKey: this.contextKey,
                customSearch: customSearch,
                enableFeedback: (config)=>this.enableFeedback(config),
                favicon: this.favicon,
                featureFlags: activeFeatureFlags || featureFlags,
                fulfillableItems: activeFulfillableItems || this.userFulfillableItems,
                gainsightRoles: gainsightRoles,
                getCapabilityWithIconUrl: this.getCapabilityWithIconUrl,
                getCustomToken: this.getCustomToken,
                getPerformanceMarks: this.getPerformanceMarks,
                getShellConfigurationExtended: ()=>this.getShellConfigurationExtended(),
                getSubOrgFromProductContext: (prodCtx)=>this.contextService?.isSubOrg ? this.contextService.getSubOrgFromProductContext(prodCtx) : undefined,
                getTux: this.getTux,
                globalDialogOpen: globalDialogOpen,
                hashedAuthId: auth && auth.getHashedAuthId(),
                hero: hero,
                htmlReady: this.htmlReady,
                imsClientId: this.config.ims.client_id,
                imsEnvironment: this.config.ims.environment,
                imsInfo: {
                    imsOrg: selectedImsOrg,
                    imsOrgName: selectedImsOrgName,
                    imsProfile: profile,
                    imsToken: accessToken,
                    locale: locale,
                    tenant: tenant
                },
                imsOrgName: selectedImsOrgName,
                imsOrgs: imsOrgs.filter(({ value: value })=>/@AdobeOrg$/.test(value)),
                imsSessionId: this.getSessionId(),
                imsToken: accessToken,
                internal: this.internal,
                intl: this.props.intl,
                lastRecentTs: this.lastRecents?.[selectedImsOrg] || 0,
                locale: locale,
                metricsEnv: this.metricsEnv,
                nonSupportedBrowser: this.nonSupportedBrowser,
                on401: this.on401,
                onSignOut: this.onSignOut,
                orgPermissioned: orgPermissioned,
                orgRegion: selectedOrgRegion,
                pageRedirect: this.pageRedirect,
                preferredLanguages: preferredLanguages || [],
                pulseButton: this.state.pulse.customButton,
                resetConfigStates: (appId, nextAppId, nextSideNav, nextIms, force)=>this.resetConfigStates(appId, nextAppId, nextSideNav, nextIms, force),
                sandboxes: sandbox.sandboxes,
                sandboxesAvailable: sandboxesAvailable,
                setConfigStates: (config)=>this.setConfigStates(config),
                setLogoutUrl: ({ url: url, ...rest })=>this.state.auth.logout.add(url, rest),
                setSolutionConfig: this.setSolutionConfig,
                setSubOrgs: this.setSubOrgs,
                settingsService: this.settingsRef,
                shellHeight: $iNslS.SHELL_HEIGHT,
                shellInfo: shellResponse,
                shellSideNavPresent: this.isSideNavEnabled() && this.state.sidenav?.visible !== false && this.state.sidebar?.visible !== false && this.state.sideNavOpen,
                shellSideNavWidth: this.state.sideNavOpenByHover ? 0 : $41d79b167f2f22c7$var$SHELL_SIDE_NAV_WIDTH,
                showToast: (messageId, variant = "info")=>this.showToast(messageId, {
                        timeout: $41d79b167f2f22c7$var$TOAST_TIMEOUT,
                        variant: variant
                    }),
                sideNavOpen: sideNavOpen,
                tenant: tenant,
                theme: theme,
                toggleComponentModal: (open, data, callback)=>open ? this.renderComponentModal(data, callback) : this.removeComponentModal(data),
                toggleSideNav: this.toggleSideNav,
                translationService: this.translationService,
                updateConsent: (permissions)=>this.setState({
                        userConsent: {
                            ...this.state.userConsent,
                            ...permissions
                        }
                    }),
                userConsent: userConsent,
                workHubResponse: workHubResponse
            };
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "getResetConfigState", (nextSideNav, nextIms)=>({
                activeProductContext: null,
                afterPrintHandler: null,
                appContainer: undefined,
                beforePrintHandler: null,
                coachMark: {},
                coachMarkPosition: null,
                customButtons: [],
                customEnvLabel: [],
                customHeroClick: null,
                customLeftNavClick: null,
                customSearch: {
                    enabled: false,
                    open: false
                },
                digitalData: null,
                feedback: {},
                globalDialogOpen: false,
                helpCenter: null,
                leftNavCloseOnSelection: false,
                modal: false,
                onCustomButtonClick: $iNslS.NOOP,
                orgToSubOrgsMap: {},
                pulse: {},
                selectedSubOrg: null,
                workHubResponse: null,
                workspaces: [],
                // Only reset the custom profile and token if the next IMS config is unset
                // or the custom token is invalid for the next IMS config.
                ...nextIms && (0, $3Zpnv.isCustomTokenValid)(nextIms, this.state.appToken) ? {} : {
                    appProfile: null,
                    appToken: null
                },
                // Only reset if there's not another sidenav config.
                ...!nextSideNav || !Object.keys(nextSideNav).length ? {
                    sidebar: null,
                    sidenav: null
                } : {}
            }));
        $41d79b167f2f22c7$var$_defineProperty(this, "resetConfigStates", (appId, nextAppId, nextSideNav, nextIms, force = false)=>{
            // Same app is being loaded next. Don't reset so experience doesn't shift.
            // If state is already reset for current app (this.appId updated), don't reset again.
            if (!force && (appId === nextAppId || this.appId === nextAppId)) return;
             // Reset the beta feedback service on a config change.
            this.feedbackService?.clear();
            this.setState(this.getResetConfigState(nextSideNav, nextIms));
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "onImsOrgChange", async (selectedImsOrg, currentImsOrg, selectedSubOrg, init)=>{
            this.metrics.event("Shell.orgChange", {
                currentImsOrg: currentImsOrg,
                selectedImsOrg: selectedImsOrg,
                selectedSubOrg: selectedSubOrg
            });
            this.setState({
                imsOrgChanging: true
            });
            if (this.contextService?.isSubOrg && selectedSubOrg && selectedImsOrg === currentImsOrg) {
                const { activeProductContext: activeProductContext } = this.contextService.change(selectedImsOrg, selectedSubOrg, false);
                return this.setState({
                    activeProductContext: activeProductContext,
                    selectedImsOrg: selectedImsOrg,
                    selectedSubOrg: selectedSubOrg
                });
            }
            try {
                $41d79b167f2f22c7$var$_UnifiedShellSessionService.default.update("activeOrg", selectedImsOrg);
                const subOrgState = selectedSubOrg && this.contextService?.isSubOrg && this.contextService.change(selectedImsOrg, selectedSubOrg, false);
                const { orgName: selectedImsOrgName, orgRegion: selectedOrgRegion } = (0, $3Zpnv.getOrgMetadata)(selectedImsOrg, this.state.orgsMap);
                $3x6rS.Internal.setUser({
                    data: {
                        internal: this.internal,
                        tenantId: $41d79b167f2f22c7$var$cleanTenant(this.orgTenantMap[selectedImsOrg])
                    },
                    groupId: selectedImsOrg,
                    groupName: selectedImsOrgName,
                    groupRegion: selectedOrgRegion
                });
                this.setSetting({
                    lastLoggedInOrg: selectedImsOrg
                });
                this.storeTenantMap(selectedImsOrg);
                const state = {
                    recentsData: $41d79b167f2f22c7$var$RECENTS_RESET,
                    selectedImsOrg: selectedImsOrg,
                    selectedImsOrgName: selectedImsOrgName,
                    selectedOrgRegion: selectedOrgRegion,
                    selectedSubOrg: selectedSubOrg,
                    ...subOrgState
                }; // Using the direct bootstrap configureNetwork because we need to set the
                // selectedImsOrg but don't need any of the other stuff at this time. Upon
                // saving state and fetching context, it will fire again with the Core
                // version.
                this.bootstrap.configureNetwork(selectedImsOrg, false, selectedOrgRegion); // Only fetch launch darkly on non-init (authorize) workflows because
                // authorize does it already and onImsOrgChange only happens when the
                // org needs to be changed due to the path's tenant.
                if (!init) {
                    const ffData = await this.getFeatureFlagData(false, selectedImsOrg, selectedImsOrgName);
                    Object.assign(state, ffData);
                }
                this.setState(state, async ()=>{
                    if (!await this.isOrgPermissionedOnSolution(selectedImsOrg)) this.homeRedirectToast({
                        selectedImsOrg: selectedImsOrg,
                        solutionConfig: this.state.solutionConfig,
                        tenant: this.orgTenantMap[selectedImsOrg],
                        toastMessage: "orgSwitchRedirectToast"
                    });
                     // On org change, re-fetch current URL context. This is done before the
                    // network is configured so that:
                    // 1. the permission check has a chance to go through before fetching context.
                    // 2. the latest context is available.
                    this.refreshContext(undefined, true);
                    this.contextFetchPromise && await this.contextFetchPromise;
                    this.configureNetwork(selectedImsOrg, false, selectedOrgRegion); // Ensure this runs after `configureNetwork`.
                    this.metrics.analytics.trackPage();
                });
            } catch (error) {
                this.metrics.error(error.message);
                this.showToast("orgFailToast", {
                    variant: "error"
                });
                return;
            } // Since sideNav is force disaled on sandbox failure, an org change may fix the issue.
            // We should re-enable sideNav if it is a part of the app.
            if (this.state.error === $fi30R.ErrorTypes.SANDBOX_FAIL) {
                if (this.isSideNavEnabled()) {
                    const nav = {
                        visible: true
                    };
                    this.setState({
                        sidebar: nav,
                        sidenav: nav
                    });
                }
            } // Clear Active Product Context
            selectedSubOrg || this.setState({
                activeProductContext: null
            }); // if org changed and no sub org selected, reset selectedSubOrg
            if (selectedImsOrg !== currentImsOrg && !selectedSubOrg) this.setState({
                selectedSubOrg: {
                    id: null,
                    name: null
                }
            });
            this.setState({
                imsOrgChanging: false
            });
            return true;
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "updateUrlOnOrgChange", async (selectedImsOrg, currentImsOrg, replace, selectedSubOrg)=>{
            // Since the org has not changed, the subOrg must have changed.
            // We must update the path before updating.
            // state or localStorage to enable navigation blocking for subOrgs.
            if (selectedImsOrg === currentImsOrg && this.contextService?.isSubOrg) return (0, $2qT0f.updateValueInPath)(this.contextKey, this.contextService.getSubOrgPathname(selectedSubOrg), this.hasTenantInUrl, false);
             // If the `selectedImsOrg` ends in AdobeID, that means it's an attempt to
            // load an account instead of an org. This will only happen in the following
            // scenarios:
            //  - In Type1 and click on Type2E org in switcher
            //  - In Type2E and click on Type2E org in switcher
            //  - In Type2E and click on Type1 account in switcher
            if (!/@AdobeOrg$/.test(selectedImsOrg)) return this.onType2eOrgChange(selectedImsOrg);
             // If user is on skyline domain, this means they are in an AEM instance and if they switch orgs
            // then they need to be taken to /experiencemanager on the experience domain.
            const tenant = this.orgTenantMap[selectedImsOrg] || selectedImsOrg;
            if ((0, $15j1u.isSkyline)()) return this.pageRedirect({
                path: "/experiencemanager",
                tenant: tenant
            });
             // If there is a new subOrg and the new subOrg belongs to the new org, we can add it to the path as well.
            if (selectedSubOrg?.owningEntity === selectedImsOrg) (0, $2qT0f.updatePath)({
                subOrg: this.contextService?.getSubOrgPathname(selectedSubOrg),
                tenant: tenant
            }, replace, this.hasTenantInUrl, this.contextService?.getUrlKey());
            else (0, $2qT0f.updatePath)({
                tenant: tenant
            }, replace, this.hasTenantInUrl);
             // An org switch for a tenantless solution won't change the URL, so no history update is fired.
            // To counter this, we should check if the org change was a type2e org change and in that case
            // switch the profile. In the type2e case, authProcessWithProfile will not call onImsOrgChange
            // if the URL is tenantless, so we need to call it here. In the non-type2e org change case,
            // onHistoryChange will not call onImsOrgChange, so we need to call it here.
            if (this.state.solutionConfig.hideTenant) {
                await this.checkForType2eChange(selectedImsOrg);
                this.onImsOrgChange(selectedImsOrg, currentImsOrg, selectedSubOrg);
            }
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "onType2eOrgChange", async (userId, init = false)=>{
            const { auth: auth, userAccounts: userAccounts } = this.state;
            const switchTimer = this.metrics.start("SwitchAccount"); // Remember the initial user hash so we can log the before/after user hashes to EIM.
            const fromUser = auth.getHashedUserId();
            const selectedAccount = userAccounts.find((account)=>account.userId === userId);
            try {
                await auth.switchProfile(userId, selectedAccount?.exchangeToken);
            } catch  {
                return this.showToast("type2eError", {
                    variant: "error"
                });
            }
            switchTimer.time("switchDone", {
                from: fromUser,
                to: (0, $41d79b167f2f22c7$var$_stringHash.default)(userId).toString()
            });
            await this.authProcessWithProfile();
            switchTimer.time("authProcessDone");
            this.setState({
                recentsData: $41d79b167f2f22c7$var$RECENTS_RESET
            }); // If user is on skyline domain, this means they are in an AEM instance and if they switch orgs
            // then they need to be taken to /experiencemanager on the experience domain.
            const tenant = this.orgTenantMap[this.state.selectedImsOrg];
            if ((0, $15j1u.isSkyline)() && !init) return this.pageRedirect({
                path: "/experiencemanager",
                tenant: tenant
            });
            (0, $2qT0f.updatePath)({
                tenant: tenant
            }, false, this.hasTenantInUrl, this.contextKey);
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "logMetricsForShellInfo", (shellResponse, location)=>{
            const { orgId: orgId } = shellResponse; // Log if shell info is being fetched for a potentially wrong org
            const pathOrg = this.getPathOrg();
            if (orgId !== this.state.selectedImsOrg || pathOrg && orgId !== pathOrg) this.metrics.warn(`ShellInfo: Generated in ${location}`, {
                pathOrg: pathOrg ?? "n/a",
                selectedOrgInState: this.state.selectedImsOrg ?? "n/a",
                shellInfoOrgId: orgId ?? "n/a"
            });
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "clearErrorByType", (error)=>{
            const update = {};
            if ($41d79b167f2f22c7$var$RESETTABLE_ERRORS.includes(error)) update.error = null;
            if (this.isSideNavEnabled()) {
                const nav = {
                    visible: true
                };
                Object.assign(update, {
                    sidebar: nav,
                    sidenav: nav
                });
            }
            this.setState(update);
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "checkForType2eChange", async (pathOrg)=>{
            // If the new org is from a different account, trigger a type2e switch.
            const orgAccountMap = await $41d79b167f2f22c7$var$_UnifiedShellSessionService.default.get("shellOrgAccountMap") || {};
            const requestedAccount = orgAccountMap[pathOrg];
            if (orgAccountMap[this.state.selectedImsOrg] !== requestedAccount) {
                const accountData = await this.getAccountCluster();
                if (accountData) this.onType2eOrgChange(accountData.orgAccountMap[pathOrg]);
                return true;
            }
            return false;
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "onHistoryChange", async (location)=>{
            const pathOrg = this.getPathOrg(location);
            const pathSubOrg = (0, $jVeiz.getValueFromPath)(location.pathname, this.contextKey);
            const { basePath: basePath, error: error, orgToSubOrgsMap: orgToSubOrgsMap, sandbox: sandbox, selectedImsOrg: selectedImsOrg, selectedSubOrg: selectedSubOrg } = this.state;
            const orgChange = pathOrg && selectedImsOrg && pathOrg !== selectedImsOrg;
            if (basePath && (0, $jVeiz.getPathPrefix)(location.pathname) !== (0, $jVeiz.getPathPrefix)(basePath)) {
                // On app switch, we should reset the suborg in case its needed by the discovery call
                this.metrics.event("Shell.resetSubOrg", {
                    basePath: basePath,
                    pathname: location.pathname
                });
                const stateConfig = {
                    selectedSubOrg: null
                }; // If the history change is both an org and solution change, update the selected ims org so that
                // it is available in setSolutionConfig to properly initialize the new app. The rest of the org
                // change will still be handled by onImsOrgChange
                if (orgChange) stateConfig.selectedImsOrg = pathOrg;
                this.setState(stateConfig);
            } // The history has changed, so close the modal since it doesn't make sense
            // to keep it open anymore.
            this.removeComponentModal(); // If the user was on a page with an error message and they navigate to a new route, we should remove
            // the error from the state in case the navigation fixes the issue.
            error && !orgChange && this.clearErrorByType(error); // If the selectedImsOrg is different than what is in state, this is an org change.
            // We can skip modifying the URL context value here because it will be updated in onImsOrgChange.
            if (!orgChange) this.contextService?.onHistoryChange(location, {
                orgToSubOrgsMap: orgToSubOrgsMap,
                pathOrg: pathOrg,
                sandbox: sandbox,
                selectedImsOrg: selectedImsOrg,
                selectedSubOrg: selectedSubOrg
            });
             // If the org is not set, update the URL with the current one.
            if (!pathOrg && this.hasTenantInUrl && selectedImsOrg) setTimeout(()=>(0, $2qT0f.updatePath)({
                    tenant: this.orgTenantMap[selectedImsOrg] || selectedImsOrg
                }, true, this.hasTenantInUrl, this.contextKey), 0);
            const subOrgChange = this.contextService?.isSubOrg && pathSubOrg && selectedSubOrg && pathSubOrg !== this.contextService?.getSubOrgPathname(selectedSubOrg); // Compare the new org with the current one. If they are different, trigger an org change.
            // For a solution that supports suborgs, compare the pathSubOrg with the current one.
            // If they are both present and different, trigger an org change. If there is no pathOrg,
            // that means the solution has hideTenant and this can be skipped when tenant id isn't
            // the part of the history that changed.
            if (orgChange || subOrgChange) {
                // If the new org is from a different account, trigger a type2e switch.
                const type2eSwitch = await this.checkForType2eChange(pathOrg);
                if (!type2eSwitch) {
                    // Replace argument is `true` because the URL has already been updated,
                    // so we don't want to push anything else to the history.
                    const newSubOrg = subOrgChange && (this.state.orgToSubOrgsMap[pathOrg] || []).find((so)=>so.orgIdName === pathSubOrg); // If its a suborg change but the orgToSubOrgsMap has been wiped, that means the history event fired
                    // before the new context service could initialize. It will update the suborg when it does, so we can skip this.
                    if (subOrgChange && !this.state.orgToSubOrgsMap[pathOrg]) return;
                    return this.onImsOrgChange(pathOrg, selectedImsOrg, newSubOrg || this.state.selectedSubOrg);
                }
            }
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "silentSignOut", async (authExpired)=>{
            authExpired && this.props.showSpinner();
            await this.state.auth.signOut();
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "on401", async ()=>this.state.auth.validateTokenAndEmit());
        $41d79b167f2f22c7$var$_defineProperty(this, "onSignOut", async (authExpired, message = "User signed out")=>{
            this.metrics.event("Shell.signOut", undefined, message, {
                authExpired: authExpired
            });
            (0, $lRoWp.queueMetrics)(message, {
                data: {
                    authExpired: authExpired
                }
            });
            this.silentSignOut(authExpired, message);
            this.authChannel?.postMessage({
                message: $fi30R.AuthMessages.LOGOUT
            });
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "onCustomSearchClick", ()=>{
            const { enabled: enabled, onClick: onClick, open: open } = this.state.customSearch;
            open && this.metrics.analytics.trackEvent({
                action: "click",
                element: "custom search",
                feature: "shell header",
                type: "button",
                widget: {
                    name: "custom search",
                    type: "button"
                }
            });
            this.setState({
                customSearch: {
                    enabled: enabled,
                    onClick: onClick,
                    open: !open
                }
            });
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "onSandboxChange", (selected)=>{
            // To allow navigation blocking to stop sandbox changes, the change must be a URL update.
            // After the URL is updated, onHistoryChange is called. This calls the onHistoryChange handler
            // for the context (suborg) service and updates the selected suborg there. The context service then
            // calls its updateState function (as defined in setupContextService) that calls configureNetwork
            // and updates the permission service.
            (0, $2qT0f.updateValueInPath)("sname", selected.name, this.hasTenantInUrl, false);
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "setupContextService", (solutionConfig)=>{
            this.contextService = (0, $bToDy.getContextService)(solutionConfig, (ctx, error)=>this.setState(ctx, async ()=>{
                    if (!this.contextService?.isSandbox) return;
                    this.configureNetwork();
                    const { sandbox: sandbox, selectedImsOrg: selectedImsOrg, tenant: tenant } = this.state;
                    const { appId: appId, urlContext: { optional: optional } } = solutionConfig; // If there are no sandboxes, the user should know that the reason they
                    // can't load the app is because they don't have any and sandboxes are
                    // required. Send the user to the landing page and show a toast.
                    if (!error && !(sandbox?.sandboxes || []).length && !optional) {
                        this.pageRedirect({
                            hasTenantInUrl: this.hasTenantInUrl,
                            replace: true,
                            tenant: this.orgTenantMap[selectedImsOrg]
                        });
                        this.showToast("noSandboxesToast", {
                            timeout: $41d79b167f2f22c7$var$TOAST_TIMEOUT,
                            variant: "error"
                        });
                        this.metrics.event("Shell.noSandboxes", {
                            appId: appId,
                            selectedImsOrg: selectedImsOrg
                        });
                        return;
                    } // If the org is not permissioned on the current solution, send the user
                    // back to the home app.
                    if (!await this.isOrgPermissionedOnSolution(selectedImsOrg, solutionConfig)) setTimeout(()=>this.homeRedirectToast({
                            selectedImsOrg: selectedImsOrg,
                            solutionConfig: solutionConfig,
                            tenant: tenant
                        }), 100);
                }), this.settingsRef);
            this.contextKey = this.contextService && this.contextService.getUrlKey();
            this.contextService?.isSandbox && this.setState({
                sandboxesAvailable: true
            });
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "setSolutionConfig", (solutionConfig)=>{
            const { environment: environment, hero: hero, sandbox: sandbox, selectedImsOrg: selectedImsOrg, shellResponse: shellResponse, sidebar: sidebar, sidenav: sidenav } = this.state;
            const { appContainer: appContainer, appId: appId, betaFeedbackConfigId: jiraConfigId, decodeUrl: configDecodeUrl, hideTenant: hideTenant, releaseType: releaseType, sandbox: { ims: ims } = {}, sideNav: configSideNav, path: path, urlContext: urlContext } = solutionConfig;
            configDecodeUrl && (0, $41d79b167f2f22c7$var$_decodeUrl.default)(this.history);
            this.setupContextService(solutionConfig);
            const heroConfig = (0, $a2nzs.getHeroConfig)(shellResponse, solutionConfig, hero); // Because we don't clear sandboxes on solution change we must reset the sandboxes if the new
            // solution doesn't support them.
            const sandboxConfig = this.contextService?.isSandbox ? Object.assign(sandbox, {
                enabled: true,
                incognito: urlContext?.incognito,
                onChange: this.onSandboxChange
            }) : {
                enabled: false,
                incognito: urlContext?.incognito,
                onChange: $iNslS.NOOP,
                sandboxes: [],
                selected: null
            };
            let sideNavOpen = this.getSideNavState();
            if (configSideNav?.closeOnLoad) sideNavOpen = false;
             // Updates the state based on the existence (or non-existence) of a custom
            // ims configuration for the solution.
            this.configureCustomIms(ims); // Reset the beta feedback service on a config change.
            this.feedbackService?.clear(); // Set the appId to prevent second state reset by resetConfigStates
            this.appId = appId;
            this.setState({
                ...this.getResetConfigState(configSideNav, ims),
                // appContainer can only be set for landing on QA and Stage since it is
                // being powered by Pueblo. On Production it is not, and appContainer is not
                // supported.
                appContainer: appId === "landing" && environment === "prod" ? null : appContainer,
                error: null,
                favicon: hero.icon,
                helpCenter: {
                    solution: solutionConfig.appId,
                    solutionConfig: solutionConfig,
                    solutionParent: solutionConfig.appRoot
                },
                hero: heroConfig,
                orgPermissioned: false,
                sandbox: sandboxConfig,
                sidebar: {
                    ...sidebar,
                    config: configSideNav || null
                },
                sidenav: {
                    ...sidenav,
                    config: configSideNav || null
                },
                sideNavOpen: sideNavOpen,
                solutionConfig: solutionConfig,
                urlContext: urlContext
            }, async ()=>{
                const workHubPromise = this.setWorkHub(); // Honor the old-style (solution config) beta feedback but still use the
                // new-style set-up. Converts the original values into the new config and
                // sets the path to trigger on any sub-path of the root application path.
                // Setting releaseType will add buttons and labels to the UI. (Unless in demo mode)
                // Setting jiraConfigId (from betaFeedbackConfigId in solution config)
                // will route Open Feedback to create JIRA tickets.
                const isDemoMode = this.bootstrap.isDemoMode();
                const lifecycleType = isDemoMode ? $ctGaZ.RELEASE_TYPE.GA : releaseType;
                const feedbackReleaseType = [
                    $ctGaZ.RELEASE_TYPE.ALPHA,
                    $ctGaZ.RELEASE_TYPE.BETA
                ].includes(lifecycleType);
                (feedbackReleaseType || jiraConfigId) && this.enableFeedback([
                    {
                        jiraConfigId: jiraConfigId,
                        paths: [
                            path,
                            `${path}/(.*)`
                        ],
                        releaseType: lifecycleType
                    }
                ]); // updatePath triggers onHistoryChange which relies on solution config values from the state.
                // This code has been moved to the callback of setState so we can ensure that the new solution config values
                // have been set in state before onHistoryChange is called.
                this.metrics.event("Shell.solutionConfig.set", {
                    solutionConfig: solutionConfig
                });
                this.hasTenantInUrl = !hideTenant;
                const tenant = this.orgTenantMap[selectedImsOrg] || selectedImsOrg; // Check if the org is allowed to access the new solution.
                if (selectedImsOrg && !await this.isOrgPermissionedOnSolution(selectedImsOrg, solutionConfig)) {
                    // If this is triggered during an org change, onImsOrgChange will handle this correctly instead.
                    if (this.state.imsOrgChanging) return;
                    return this.homeRedirectToast({
                        selectedImsOrg: selectedImsOrg,
                        solutionConfig: solutionConfig,
                        tenant: tenant
                    });
                } // If the selected sandbox is defined, the previous solution and the new solution both support sandboxes
                // therefore we don't need to fetch sandboxes again. Only fetch if coming from a solution without sandboxes to a
                // solution with sandboxes enabled and the imsOrg is set (it is not a refresh or login).
                sandboxConfig.selected || selectedImsOrg && this.refreshContext();
                (0, $2qT0f.updatePath)({
                    tenant: tenant
                }, true, this.hasTenantInUrl, this.contextKey); // Roles Modal requires data from settings to determine whether to
                // show. Needs work hub for recommendations, so awaits it.
                await workHubPromise;
                this.showRolesModalInvite();
            });
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "getTux", async ()=>{
            // Check for the force query param
            const force = (0, $hCG2Z.getQueryValue)("forcetux"); // TUX should NOT display during automated test runs
            if (!force && (this.internal || this.bootstrap.inAutomation())) return;
             // The TUX survey is intentionally delayed so the user has time to
            // navigate to their primary application of usage
            // The delay is skipped when using the force query param
            force || await (0, $iNslS.wait)(10000); // We don't want to inundate users with multiple modals
            // If one is open, we suppress TUX
            const { modal: modal, showRolesInvite: showRolesInvite, showRolesModal: showRolesModal, showUserConsent: showUserConsent } = this.state;
            const blockingDialogs = [
                modal,
                showRolesInvite,
                showRolesModal,
                showUserConsent
            ];
            if (this.userConsentShown || blockingDialogs.some((state)=>!!state)) // In this case, ensure we prevent further sampling during the user's session
            await $41d79b167f2f22c7$var$_UnifiedShellSessionService.default.update("tuxSessionCheckCompleted", true);
            const { environment: environment, featureFlags: featureFlags, locale: locale, settings: settings, shellResponse: shellResponse, solutionConfig: solutionConfig } = this.state; // This should never happen with the delay but to capture our intent,
            // return early if we're missing the data we need
            if (!featureFlags || !shellResponse || !solutionConfig) return;
             // Support feature flag for disabled apps
            const disabledApps = featureFlags["tux-disabled-apps"]; // Check to see if TUX should be displayed first
            const { displayTuxSurvey: displayTuxSurvey } = await this.postAuth;
            const tuxConfig = await displayTuxSurvey({
                disabledApps: disabledApps,
                environment: environment,
                firstTimeUser: this.firstTimeUser,
                force: force,
                isLogin: this.props.isLogin,
                locale: locale,
                metrics: this.metrics,
                settings: settings,
                settingsService: this.settingsRef,
                shellResponse: shellResponse,
                showToast: this.showToast,
                solutionConfig: solutionConfig,
                translationService: this.translationService
            }).catch((err)=>this.metrics.error("Error processing display TUX survey", err)); // Store flag to prevent further sampling during the user's session
            // We use unifiedShellSession (localStorage) to ensure this works across tabs
            await $41d79b167f2f22c7$var$_UnifiedShellSessionService.default.update("tuxSessionCheckCompleted", true); // If a config is not returned, the survey should NOT display
            if (!tuxConfig) return;
             // Update state to enable rendering
            this.setState({
                showTux: !!tuxConfig,
                tuxConfig: tuxConfig
            });
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "renderHistoryDialog", ()=>{
            const { locale: locale, historyDialogProps: historyDialogProps } = this.state;
            return /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$_react.default.Suspense, {
                fallback: null
            }, /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$HistoryBlockerDialog, $41d79b167f2f22c7$var$_extends({
                hide: ()=>this.setState({
                        historyDialogProps: null
                    }),
                locale: locale
            }, historyDialogProps)));
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "renderTuxSurvey", ()=>{
            const { tuxConfig: tuxConfig } = this.state;
            return /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$_react.default.Suspense, {
                fallback: null
            }, /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$TuxContainer, $41d79b167f2f22c7$var$_extends({
                hide: ()=>this.setState({
                        showTux: null
                    })
            }, tuxConfig)));
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "logBetaAgreement", (agreementId, action)=>{
            const { auth: auth, selectedImsOrg: selectedImsOrg, selectedImsOrgName: selectedImsOrgName } = this.state;
            const date = Date.now();
            /**
       * This needs to be sent on a delay because another omega
       * event is triggered on the button click that calls this function.
       * Once this race condition is fixed in EIM, we can remove the timeout.
       */ setTimeout(()=>this.metrics.analytics.trackEvent({
                    action: action,
                    attributes: {
                        agreementId: agreementId,
                        appId: this.appId,
                        authId: auth?.getHashedAuthId(),
                        date: date,
                        orgId: selectedImsOrg,
                        orgName: selectedImsOrgName,
                        userId: auth?.getHashedUserId()
                    },
                    element: agreementId,
                    feature: "shell agreements",
                    type: "modal",
                    widget: {
                        name: `${agreementId} agreement`,
                        type: "agreement modal"
                    }
                }), 1000);
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "showBetaAgreement", async (agreementId, options)=>{
            // Get agreements from settings
            const betaAgreements = await this.getBetaAgreements(); // If the agreement has already been accepted, return the status
            if (betaAgreements?.[agreementId]?.accepted) return Promise.resolve(betaAgreements[agreementId]);
            this.logBetaAgreement(agreementId, "show agreement");
            let agreementPromiseResolve;
            const agreementPromise = new Promise((resolve)=>agreementPromiseResolve = resolve);
            this.setState({
                agreementPromiseResolve: agreementPromiseResolve,
                betaAgreementConfig: {
                    id: agreementId,
                    ...options
                }
            });
            return agreementPromise;
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "getAgreementResponse", async (id)=>{
            const betaAgreements = await this.getBetaAgreements();
            return betaAgreements?.[id] ?? {};
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "clearAgreementResponse", async (id)=>{
            const betaAgreements = await this.getBetaAgreements();
            const updatedAgreements = {
                ...betaAgreements,
                [id]: null
            };
            return this.setSetting({
                betaAgreements: updatedAgreements
            }, $fLrqA.SettingsLevel.USERORG).then(()=>true).catch(()=>false);
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "closeBetaAgreement", async (accepted)=>{
            const { agreementPromiseResolve: agreementPromiseResolve, betaAgreementConfig: { id: betaAgreementId } } = this.state;
            const agreementStatus = {
                accepted: accepted,
                date: Date.now()
            };
            this.logBetaAgreement(betaAgreementId, accepted ? "accept" : "decline"); // Resolve the promise with the agreement status
            agreementPromiseResolve(agreementStatus); // Update agreements in settings
            const betaAgreements = await this.getBetaAgreements();
            const updatedBetaAgreements = {
                ...betaAgreements,
                [betaAgreementId]: agreementStatus
            };
            this.setSetting({
                betaAgreements: updatedBetaAgreements
            }, $fLrqA.SettingsLevel.USERORG);
            this.setState({
                agreementPromiseResolve: null,
                betaAgreementConfig: null
            });
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "renderBetaAgreement", ()=>/*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$_react.default.Suspense, {
                fallback: null
            }, /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$DialogContainer, {
                isKeyboardDismissDisabled: true,
                type: "modal"
            }, /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$BetaAgreement, {
                close: this.closeBetaAgreement,
                config: this.state.betaAgreementConfig,
                settingsService: this.settingsRef
            }))));
        $41d79b167f2f22c7$var$_defineProperty(this, "isSideNavEnabled", (solutionConfig = this.state.solutionConfig)=>{
            const { sideNav: sideNav } = solutionConfig;
            const { featureFlags: featureFlags = {}, sidenav: stateSidenav } = this.state;
            return stateSidenav?.config?.menu || stateSidenav?.config?.workHubId || sideNav && (!sideNav.workHubFeatureFlag || featureFlags?.[sideNav.workHubFeatureFlag] === "true");
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "updateTargetNode", ()=>{
            const { coachMark: coachMark } = this.state;
            if (!coachMark.enabled) return;
            const targetNode = document.querySelector(coachMark.element);
            if (!targetNode) {
                this.setState({
                    coachMark: {
                        ...coachMark,
                        hidden: true
                    }
                });
                return;
            } // Get the position of the leftmost edge of the element and the width of the element
            const { left: left, width: width } = targetNode.getBoundingClientRect(); // Calculation for the middle of the element minus indicator width
            const coachMarkPosition = left + width / 2 - 16;
            this.setState({
                coachMark: {
                    ...coachMark,
                    hidden: false
                },
                coachMarkPosition: coachMarkPosition
            });
            return coachMarkPosition;
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "userThemeHandler", async (theme, onToggle)=>{
            const { auth: auth, settings: settings } = this.state;
            const themeParam = (0, $hCG2Z.getQueryValue)("theme"); // If theme is set via query param, use it and don't do anything with
            // storage or settings. This is purely an override value.
            if (themeParam) {
                this.setState({
                    theme: themeParam
                });
                return;
            } // If no theme is given, settings service is the source of truth
            if (!theme) theme = settings?.theme;
            const shellTheme = this.state.theme; // If localStorage (state) and theme match and this is not a user toggle
            // from the profile popover, then we do nothing. Also, if there is no data
            // from settings, we should be using the default theme set in state.
            if (!onToggle && (!theme || shellTheme === theme)) return;
             // If they do NOT match, then theme (settings service || user toggled value)
            // is the source of truth and we update the state, localStorage and settings
            this.setState({
                settings: {
                    ...settings,
                    theme: theme
                },
                theme: theme
            });
            $iJaYo.storage.local.set("spectrumTheme", {
                [auth.getHashedAuthId()]: theme
            }, $41d79b167f2f22c7$var$TEN_YEARS);
            if (theme !== settings?.theme || onToggle) this.setSetting({
                theme: theme
            });
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "orderRecentSandboxes", (sandbox, recentSandboxes, sandboxInRecents)=>{
            // If sandbox is already in recents,
            // remove it from its place, and add it back to the top of the list.
            // If array length already 5, remove least recent sandbox.
            if (sandboxInRecents) recentSandboxes = recentSandboxes.filter((sb)=>sb.name !== sandbox.name);
            else if (recentSandboxes.length === 5) recentSandboxes.splice(4);
            return [
                sandbox,
                ...recentSandboxes
            ];
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "userRecentSandboxesHandler", (sandbox)=>{
            const { settings: settings } = this.state;
            let { recentSandboxes: recentSandboxes } = this.state;
            if (!settings) return;
            recentSandboxes = recentSandboxes || settings.recentSandboxes;
            recentSandboxes = Array.isArray(recentSandboxes) ? recentSandboxes : []; // If no new sandbox passed in, just set state.
            if (!sandbox) {
                this.setState({
                    recentSandboxes: recentSandboxes
                });
                return;
            } // If sandbox already in recents, don't add it again. Otherwise, update.
            const sandboxInRecents = recentSandboxes.filter(({ name: name })=>name === sandbox.name);
            recentSandboxes = this.orderRecentSandboxes(sandbox, recentSandboxes, sandboxInRecents.length);
            this.setState({
                recentSandboxes: recentSandboxes
            });
            this.setSetting({
                recentSandboxes: recentSandboxes
            });
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "getCustomToken", async ({ client_id: client_id, scopes: scopes })=>{
            await this.authPromise;
            return this.state.auth.createCustomClient(client_id, scopes);
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "configureCustomIms", async (customIms)=>{
            await this.authPromise;
            const { appToken: appToken } = this.state; // customIms is not defined, so we shouldn't do anything with the token, but
            // we still need to update the state to ensure the profile and token are
            // updated.
            if (!customIms) return;
             // If we're trying to use the same token, no more processing.
            if ((0, $3Zpnv.isCustomTokenValid)(customIms, appToken)) return;
            try {
                const { profile: profile, token: token } = await this.getCustomToken(customIms);
                this.setState({
                    appProfile: profile,
                    appToken: token
                });
            } catch (e) {
                this.metrics.error("Error fetching custom token", e);
                throw e;
            }
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "showUserConsent", async ()=>{
            // Use the settings data to populate the user consent object.
            const { locale: locale, settings: settings, userConsentResponse: userConsentResponse } = this.state;
            const { isLogin: isLogin } = this.props;
            const { metrics: metrics, onUserConsentDismissed: hide, onUserConsentSubmit: onSubmit, setSetting: setSetting, showToast: showToast, userConsentShown: userConsentShown } = this;
            const userConsent = {};
            (userConsentResponse?.permissions || []).forEach(({ name: name, enabled: enabled })=>{
                userConsent[name] = enabled;
            });
            (0, $7CZdW.onConsent)(userConsent, this.metrics);
            const { showUserConsent: showUserConsent } = await this.postAuth;
            const consentProps = await showUserConsent({
                hide: hide,
                isLogin: isLogin,
                locale: locale,
                metrics: metrics,
                onSubmit: onSubmit,
                setSetting: setSetting,
                settings: settings,
                showToast: showToast,
                userConsentResponse: userConsentResponse,
                userConsentShown: userConsentShown
            }); // Load event for user consent so that we can capture the data in EIM in the
            // case that it's not there already but is in settings. Also capture whether
            // or not the dialog was shown.
            this.metrics.event("Shell.UserConsent.Load", {
                consent: userConsent,
                lastUpdated: settings?.userConsent?.last_update_dts,
                show: !!consentProps
            }); // Always set userConsent into state, but optionally add the other
            // properties as user consent may not always be shown.
            let state = {
                showUserConsent: !!consentProps,
                userConsent: userConsent
            };
            consentProps && (state = {
                ...state,
                consentProps: consentProps
            });
            this.setState(state);
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "renderUserConsentModal", ()=>{
            const { consentProps: consentProps } = this.state; // We set userConsentShown in case the dialog was just shown
            // (i.e. org switching use case where isLogin is still true)
            this.userConsentShown = true; // Add a new class to the body for our CSS to handle Gainsight guides that
            // interfere with the Consent Modal.
            // We check that the clasName isn't already there because render COULD
            // get called more than once
            if (!document.body.className.includes("consent-active")) document.body.className += " consent-active";
            return /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$_react.default.Suspense, {
                fallback: null
            }, /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$DialogContainer, {
                hide: ()=>this.setState({
                        showUserConsent: null
                    }),
                isKeyboardDismissDisabled: false,
                type: "fullscreen"
            }, /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$UserConsentDialog, consentProps)));
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "showRolesModalInvite", async ()=>{
            const { activeFeatureFlags: activeFeatureFlags, settings: settings, solutionConfig: solutionConfig } = this.state;
            const { metrics: metrics, setSetting: setSetting } = this;
            const { showRolesModalInvite: showRolesModalInvite } = await this.postAuth;
            showRolesModalInvite({
                featureFlags: activeFeatureFlags,
                metrics: metrics,
                setSetting: setSetting,
                settings: settings,
                showRolesInvite: ()=>this.setState({
                        showRolesInvite: true
                    }),
                solutionConfig: solutionConfig
            });
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "handleGainsightRoles", async (submittedRoles)=>{
            const { settings: settings } = this.state;
            const { handleGainsightRoles: handleGainsightRoles } = await this.postAuth;
            const updatedRoles = await handleGainsightRoles(settings, submittedRoles);
            updatedRoles && this.setState(updatedRoles);
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "renderRolesModal", ()=>{
            this.metrics.analytics.trackEvent({
                action: "display",
                element: "roles selection modal",
                feature: "roles pilot",
                type: "modal",
                widget: {
                    name: "roles selection modal",
                    type: "job function-modal"
                }
            });
            const { auth: auth, featureFlags: featureFlags, settings: { userRoles: settingsUserRoles }, showRolesModal: showRolesModal, userRoles: userRoles, workHubResponse: workHubResponse } = this.state;
            const hashedAuthId = auth.getHashedAuthId();
            return /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$_react.default.Suspense, {
                fallback: null
            }, /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$DialogContainer, {
                hide: ()=>this.setState({
                        showRolesModal: null
                    }),
                settingsService: this.settingsRef,
                type: "modal"
            }, /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$ShellRolesModal, {
                featureFlags: featureFlags,
                fromAPI: showRolesModal === "API",
                handleGainsightRoles: this.handleGainsightRoles,
                hashedAuthId: hashedAuthId,
                hide: ()=>this.setState({
                        showRolesModal: null
                    }),
                settingsService: this.settingsRef,
                showToast: this.showToast,
                userOrgContext: this.getUserOrgContext(),
                userRoles: userRoles || settingsUserRoles,
                workHubResponse: workHubResponse
            })));
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "renderRolesInvite", ()=>/*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$_react.default.Suspense, {
                fallback: null
            }, /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$ShellRolesModalInvite, {
                show: this.state.showRolesInvite,
                showRolesModal: ()=>this.setState({
                        showRolesModal: "TOAST"
                    })
            })));
        $41d79b167f2f22c7$var$_defineProperty(this, "toggleAccessOverrides", async (override)=>{
            // If the overrides on being toggled on (true), fetch and update
            if (override) {
                const { auth: auth, selectedImsOrg: selectedImsOrg } = this.state;
                const hashedAuthId = auth.getHashedAuthId();
                return this.checkToSetAccessOverrides(selectedImsOrg, hashedAuthId, override);
            } // Otherwise, reset the state
            this.setState({
                accessOverridesEnabled: override,
                activeFeatureFlags: this.state.featureFlags,
                activeFulfillableItems: this.userFulfillableItems
            });
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "checkToSetAccessOverrides", async (selectedImsOrg, hashedAuthId, enabledState)=>{
            const { auth: auth, featureFlags: featureFlags, solutionConfig: { fiServiceCode: fiServiceCode } } = this.state;
            const { appAssemblyService: appAssemblyService, userFulfillableItems: userFulfillableItems } = this;
            const { setAccessOverrides: setAccessOverrides } = await this.postAuth;
            let stateUpdate = await setAccessOverrides({
                appAssemblyService: appAssemblyService,
                enabledState: enabledState,
                featureFlags: featureFlags,
                fiServiceCode: fiServiceCode,
                hashedAuthId: hashedAuthId || auth?.getHashedAuthId(),
                selectedImsOrg: selectedImsOrg,
                userFulfillableItems: userFulfillableItems
            }); // If there are overrides, we need to update the shell response data
            let shellResponse;
            if (stateUpdate) {
                shellResponse = this.appAssemblyService.fetchShell(selectedImsOrg, this.orgTenantMap[selectedImsOrg]);
                stateUpdate = {
                    ...stateUpdate,
                    shellResponse: shellResponse
                };
            }
            stateUpdate && this.setState(stateUpdate);
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "onUserConsentSubmit", ({ permissionsObj: permissionsObj, settingsPermissions: settingsPermissions, success: success })=>{
            if (!success) return this.onUserConsentClose();
            const updatedPermissionKeys = Object.keys(permissionsObj);
            const permissions = (this.state.settings?.userConsent?.permissions || []).filter((permission)=>!updatedPermissionKeys.includes(permission.name));
            const consentData = {
                last_update_dts: new Date().toISOString().replace(/Z$/, "+00:00"),
                permissions: settingsPermissions.concat(permissions)
            };
            this.onUserConsentClose({
                settings: {
                    ...this.state.settings,
                    userConsent: consentData,
                    userConsentDismissed: 0
                },
                userConsent: {
                    ...this.state.userConsent || {},
                    ...permissionsObj
                },
                userConsentResponse: {
                    ...this.state.userConsentResponse,
                    ...consentData
                }
            });
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "onUserConsentDismissed", (userConsentDismissed)=>{
            const state = {};
            if (typeof userConsentDismissed === "number") state.settings = {
                ...this.state.settings,
                userConsentDismissed: userConsentDismissed
            };
            this.onUserConsentClose(state);
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "onUserConsentClose", (state = {})=>{
            this.setState({
                ...state,
                showUserConsent: false
            }); // Remove the class when consent is closed so that the Gainsight guides can
            // start working again.
            document.body.className = document.body.className.replace("consent-active", "").replace(/\s{2,}/, " ");
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "showRideError", async (error)=>{
            if (this.state.showUserConsent) this.onUserConsentDismissed();
            if (this.componentModal) this.removeComponentModal();
            const locale = this.state.locale;
            await Promise.resolve().then(function() {
                return (parcelRequire("23swY"));
            }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res)).then((RideError)=>{
                RideError.default.show(error, locale);
            });
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "onLanguageChange", (languages, onInitialize = false)=>{
            const { auth: auth, preferredLanguages: preferredLanguages, profile: profile } = this.state;
            const { onLocale: onLocale } = this.props; // Format the languages for easy comparison and best supported locale handling
            const formatLanguages = (langArray)=>langArray.map((language)=>{
                    // Check for a region with the language (['en'] vs ['en-us']);
                    if (language.length === 2) language = (0, $gigHb.getLocaleRegion)(language);
                    const parts = language.replace("_", "-").split("-");
                    return `${parts[0]}-${parts[1].toUpperCase()}`;
                });
            languages = languages && formatLanguages(languages); // Check if languages match, including order. Update on a mismatch.
            if (onInitialize) {
                // If there are no languages, which would only happen if the account cluster
                // did not include language preferences
                if (!languages?.length) return;
                 // For the account cluster flow from Auth/GraphQL, the languages in state
                // would be the stored languages from the account cluster or the IMS profile
                // languages (which could be old). The account cluster is the source of truth.
                const languagesInState = preferredLanguages && formatLanguages(preferredLanguages);
                if (languagesInState && languages.every((lang, index)=>lang === languagesInState[index])) return;
            }
            this.metrics.analytics.trackEvent({
                action: `${languages[0]}, ${languages[1]}`,
                element: "submit",
                feature: "language_selector",
                type: "button",
                widget: {
                    name: "language interactions",
                    type: "button"
                }
            });
            const locale = (0, $gigHb.getBestSupportedLocale)(languages, $gigHb.SUPPORTED_LOCALES);
            onLocale(locale);
            if (!onInitialize) // Fetch the updated account cluster and update the profile with the correct languages
            this.postAuth.then(({ updateProfileOnLanguageChange: updateProfileOnLanguageChange })=>updateProfileOnLanguageChange(this, locale, profile));
             // Store for future use for speed/to avoid updates
            $iJaYo.storage.local.set("accountLanguagePreferences", {
                [auth.getHashedAuthId()]: languages
            });
            this.setState({
                locale: locale,
                preferredLanguages: languages,
                showLanguagePicker: false
            });
            this.setWorkHub();
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "isGlobalSearchEnabled", ()=>{
            const { featureFlags: featureFlags, solutionConfig: solutionConfig, profile: profile, selectedImsOrg: selectedImsOrg, shellResponse: shellResponse } = this.state;
            if (!this.orgHasAEP(selectedImsOrg)) return false;
            const { access: access, enabled: enabled } = solutionConfig?.unifiedSearch || {}; // If search is not enabled via solution config, return false, since
            // global search isn't enabled for this application or org.
            if (!access && !enabled || !profile) return false;
             // If access property is undefined, global search is enabled for everyone.
            if (!access) return true;
            const { appIds: appIds, flag: flag, logicOp: logicOp } = access;
            const hasFF = flag && featureFlags?.[flag] === "true";
            const hasAppIds = appIds && shellResponse.services && shellResponse.services.concat(shellResponse.solutions).some(({ appId: appId, enabled: appEnabled })=>appIds.includes(appId) && appEnabled);
            return !!(logicOp === "AND" ? hasAppIds && hasFF : hasAppIds || hasFF);
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "initRecents", async ()=>{
            let { recents: recents, status: status } = this.state.recentsData;
            const recentsFromCache = await this.services.recentsService.getRecents(this.getUserOrgContext());
            if (recentsFromCache) {
                recents = recentsFromCache.recents || [];
                status = recentsFromCache.recents ? $fi30R.RecentStatus.SUCCESS : $fi30R.RecentStatus.ERROR;
                const cursor = {
                    isSet: true,
                    value: recentsFromCache.cursor || null
                };
                this.setState({
                    recentsData: {
                        cursor: cursor,
                        recents: recents,
                        status: status
                    }
                });
            }
            return {
                list: recents,
                status: status
            };
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "loadMoreRecents", async ()=>{
            // As this is only called via config, do not expect a case where cursor is not already set.
            // If not set or set but value is null, return whatever is in recents state.
            const { recentsData: recentsData } = this.state;
            if (recentsData.cursor.isSet && recentsData.cursor.value) {
                const { cursor: cursor, recents: recents } = await this.services.recentsService.getOlderRecents(recentsData.recents, recentsData.cursor.value);
                recentsData.recents = recents;
                recentsData.cursor.value = cursor;
                this.setState({
                    recentsData: recentsData
                });
                return {
                    isMore: !!cursor,
                    moreRecents: recents
                };
            }
            return {
                isMore: false,
                moreRecents: recentsData.recents
            };
        });
        $41d79b167f2f22c7$var$_defineProperty(this, "hasAssistantPermission", async ()=>{
            const { sandbox: { selected: selected }, selectedImsOrg: selectedImsOrg, solutionConfig: { appId: appId } } = this.state;
            this.services || await this.postAuth; // All permissions must have a selected org.
            if (!selectedImsOrg) return;
             // CJA: Must have an org and a selected sandbox.
            if (appId === "platformAnalytics") try {
                const context = this.getUserOrgContext();
                const { value: { permissions: permissions } } = await this.services.dataPrefetchService.getData("cja-permissions-org", context, appId);
                return !!permissions?.includes("Omni.Tools.AIAssistantDocumentation");
            } catch  {
                return false;
            }
             // Default: Must have a selected sandbox. This uses the `parent` property so
            // it can be used on all AEP capabilities.
            if (selected) {
                const { permissions: permissions } = await this.services.permissionService.get({
                    permissions: [
                        "enable-ai-assistant"
                    ]
                }, selectedImsOrg, selected);
                return !!permissions?.["enable-ai-assistant"];
            }
        });
        this.metrics = $41d79b167f2f22c7$var$_metrics.default.create("exc.core.Core");
        this.serviceWorkerService = new $41d79b167f2f22c7$var$_ServiceWorkerControllerService.default();
        this.appAssemblyPromise = Promise.resolve().then(function() {
            return (parcelRequire("2uQiR"));
        }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res)).then((module)=>this.appAssemblyModule = module);
        this.postAuth = Promise.resolve().then(function() {
            return (parcelRequire("7rHmB"));
        }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res)).then((module)=>this.initializeServices(module));
        this.shellTimer = props.shellTimer || this.metrics.start("Shell");
        this.bootstrap = (0, $dDEjQ.getBootstrap)();
        this.config = this.bootstrap.config;
        this.metricsEnv = this.bootstrap.metricsEnv;
        this.cdn = this.bootstrap.activeCdn;
        this.tenantMap = {};
        const _hero = $a2nzs.HERO_CONFIGS.cloud;
        this.favicon = _hero.icon;
        this.nonSupportedBrowser = false;
        (0, $bzq4v.setUserConfirmationCallback)((message, callback)=>{
            this.setState({
                historyDialogProps: {
                    callback: callback,
                    message: message
                }
            });
        });
        this.authProcessingInitialized = false;
        this.state = {
            accessOverridesEnabled: false,
            accessToken: null,
            activeFeatureFlags: {},
            activeFulfillableItems: {},
            activeProductContext: null,
            afterPrintHandler: false,
            appProfile: null,
            appToken: null,
            auth: null,
            backgroundReady: false,
            beforePrintHandler: false,
            coachMark: {},
            coachMarkPosition: null,
            customEnvLabel: [],
            customHeroClick: false,
            customLeftNavClick: false,
            customSearch: {},
            debug: false,
            defaultComponent: props.defaultComponent,
            environment: this.config.environment,
            error: null,
            featureFlags: null,
            feedback: {},
            feedbackConfig: null,
            gainsightRoles: null,
            globalDialogOpen: false,
            helpCenter: {},
            hero: _hero,
            imsOrgs: [],
            initialAppLoaded: false,
            innerModalAppId: null,
            isAWSOrg: null,
            leftNavCloseOnSelection: false,
            locale: "en-US",
            modal: false,
            onCustomButtonClick: $iNslS.NOOP,
            orgRegion: null,
            orgsMap: [],
            orgToSubOrgsMap: {},
            profile: null,
            pulse: {},
            recentSandboxes: null,
            recentsData: $41d79b167f2f22c7$var$RECENTS_RESET,
            sandbox: {
                enabled: false,
                incognito: false,
                onChange: this.onSandboxChange,
                sandboxes: [],
                selected: null
            },
            selectedImsOrg: null,
            selectedOrgRegion: null,
            selectedSubOrg: null,
            shellResponse: {},
            showNetworkDisconnected: (0, $hCG2Z.getQueryValue)("showDisconnect"),
            showRolesInvite: null,
            showRolesModal: null,
            showUserConsent: null,
            sidebar: null,
            sidenav: null,
            sideNavOpen: this.getSideNavState(true),
            sideNavOpenByHover: false,
            solutionConfig: {},
            theme: "lightest",
            toastPlacement: "top center",
            userAccounts: null,
            workHubResponse: null,
            workspaces: []
        };
        const { endpoints: endpoints } = this.config;
        this.allOrgs = new Set();
        this.authPromise = new Promise((resolve)=>this.authResolve = resolve);
        this.ffPromises = {};
        this.translationService = new $41d79b167f2f22c7$var$_TranslationService.default(endpoints.translation);
        this.workHubService = new $41d79b167f2f22c7$var$_WorkHubService.default(this.props.listedApps);
        this.hasTenantInUrl = true;
        this.history = props.history || $bzq4v.history;
        this.orgRegions = {};
        this.orgTenantMap = {};
        this.debouncedUpdateCollapsedState = (0, $dwEdq.debounceRaF)(this.updateCollapsedState);
        this.debouncedUpdateTargetNode = (0, $dwEdq.debounceRaF)(this.updateTargetNode);
        this.tenantOrgMap = {};
        this.userFulfillableData = {};
        this.userFulfillableItems = {};
        this.userServiceCodes = {};
        this.userSubServices = {};
        this.userVisibleNames = {};
        this.unlisten = this.history.listen(this.onHistoryChange);
        this.getLDFeatureFlags = this.getLDFeatureFlags.bind(this);
        this.settingsHandler = this.settingsHandler.bind(this);
        this.setSetting = this.setSetting.bind(this);
        this.showToast = this.showToast.bind(this);
        this.settingsRef = {
            getSetting: this.getSetting,
            setSetting: this.setSetting,
            settingsHandler: this.settingsHandler
        };
        this.agreements = {
            clear: this.clearAgreementResponse,
            get: this.getAgreementResponse,
            show: this.showBetaAgreement
        }; // If HTML timeout is falsy (0), it means the HTML is fresh, we don't need to wait for it.
        this.htmlReady = this.serviceWorkerService.getWaitTimeout() ? $fi30R.HTMLStatus.PENDING : $fi30R.HTMLStatus.OK;
        this.availability = {
            html: this.htmlReady,
            ping: $fi30R.PingResult.PENDING
        };
        this.pingPromise = (0, $jBKJw.checkCDN)().then((pingResponse)=>{
            if (pingResponse.success) {
                this.availability.ping = $fi30R.PingResult.SUCCESS;
                this.metrics.event("PingCDN.Success");
            } else {
                this.availability.ping = $fi30R.PingResult.FAILED;
                this.metrics.event("PingCDN.Fail", pingResponse, {
                    level: $41d79b167f2f22c7$var$_metrics.Level.ERROR
                });
            }
            return pingResponse;
        });
        $41d79b167f2f22c7$var$_OrchestrationService.default.waitForBackground().then(()=>this.setState({
                backgroundReady: true
            }));
        $41d79b167f2f22c7$var$_OrchestrationService.default.waitForFirstLoad(true).then(()=>this.setState({
                initialAppLoaded: true
            })); // Tokens are handled in sessionstorage. If there are lingering local storage cached tokens,
        // remove them completely.
        $iJaYo.storage.local.remove("shellCachedTokens"); // The userConsentShown flag helps determine when we want to show the dialog
        // for some cases like org switching. We store and update the value without
        // state so we don't re-render
        this.userConsentShown = false; // The firstTimeUser flag supports TUX delivery logic. It is also stored
        // and updated without state to avert re-rendering
        this.firstTimeUser = null;
    }
    toggleDebugModal(open) {
        if (open && (this.componentModal || this.state.showUserConsent)) return;
        this.setState({
            debug: open
        });
    }
    componentDidMount() {
        // Normally Core would be mounted with auth empty, but in case it's not - Run onAuth.
        this.props.auth && this.onAuth();
    }
    initializeServices(postAuthModule) {
        const { eventObserver: eventObserver, getAEMOrg: getAEMOrg, getBroadcastChannel: getBroadcastChannel, getCapabilityWithIconUrl: getCapabilityWithIconUrl, getPerformanceMarks: getPerformanceMarks, setupServices: setupServices } = postAuthModule;
        setupServices(this);
        eventObserver.registerKeyHandler({
            ctrlKey: true,
            key: "i"
        }, ()=>this.toggleDebugModal(true));
        eventObserver.registerKeyHandler({
            key: "Escape"
        }, ()=>this.state.showNetworkDisconnected && this.setState({
                showNetworkDisconnected: null
            }));
        this.getPerformanceMarks = getPerformanceMarks;
        this.getCapabilityWithIconUrl = getCapabilityWithIconUrl;
        this.authChannel = getBroadcastChannel(this.props.showSpinner, this); // Need to listen for updates to Launch Darkly flags. It's possible to force
        // fetch flags from the API.
        this.services.getFlagService($ftx2l.PROVIDERS.LAUNCH_DARKLY).on("change", (featureFlags)=>{
            // Unified Shell is the only project that matters for this component,
            // thus it's the only one we care about.
            if ($bPa83.SHELL_LD_PROJECT in featureFlags) // Set the updated flags. Also, run the check for access overrides so
            // that it can be updated properly if enabled.
            this.setState({
                featureFlags: featureFlags[$bPa83.SHELL_LD_PROJECT]
            }, async ()=>{
                await this.authPromise;
                const { accessOverridesEnabled: accessOverridesEnabled, auth: auth, featureFlags: flags, selectedImsOrg: selectedImsOrg } = this.state;
                const hashedAuthId = auth.getHashedAuthId(); // Update the feature flags if access overrides are enabled.
                accessOverridesEnabled && this.checkToSetAccessOverrides(selectedImsOrg, hashedAuthId, accessOverridesEnabled); // Set activeFeatureFlags to the new basic flags if access overrides
                // are not enabled.
                accessOverridesEnabled || this.setState({
                    activeFeatureFlags: flags
                });
            });
        }); // If this is the Skyline domain, kick off the discovery call immediately
        // in order to get the AEM org that is used by this instance, in addition
        // to creating the session now. When the original discovery call is made
        // from Sandbox, it will use the cached response.
        if ((0, $15j1u.isSkyline)()) this.aemPromise = getAEMOrg(this.props.listedApps, this.state.environment);
        this.services.dataPrefetchService.on("prefetch", (prefetched)=>this.handlePrefetch(prefetched)); // This state update is necessary to trigger a context update for the
        // sandboxes, as currently they depend on discovery service coming from context.
        this.setState({
            servicesLoaded: true
        });
        return postAuthModule;
    }
    onAuth() {
        const { auth: auth } = this.props;
        if (this.props.error || this.state.error) return;
        this.setState({
            auth: auth
        }, ()=>this.authProcessing());
        window.addEventListener("resize", this.debouncedUpdateTargetNode);
        window.addEventListener("resize", this.debouncedUpdateCollapsedState);
    }
    componentWillUnmount() {
        this.unlisten && this.unlisten();
        window.removeEventListener("resize", this.debouncedUpdateTargetNode);
        window.removeEventListener("resize", this.debouncedUpdateCollapsedState);
    }
    componentDidUpdate() {
        if (this.props.error && !this.state.error) this.setState({
            error: this.props.error
        });
         // Process when we get auth.
        if (this.props.auth && !this.state.auth) this.onAuth();
    }
    getSideNavState(skipSetState) {
        const getOpen = (val, defaultValue = null)=>typeof val === "boolean" ? val : defaultValue; // Grab the shell open setting and use as a backup to any existing session
        // storage setting there might be.
        const open = getOpen(this.state?.settings?.shellNav?.open);
        let sideNavOpen = getOpen($iJaYo.storage.session.getSync("sideNavOpen"), open);
        if (sideNavOpen === null) sideNavOpen = true;
        if (this.state?.solutionConfig?.sideNav?.closeOnLoad) sideNavOpen = false;
        if (!skipSetState) this.setState({
            sideNavOpen: sideNavOpen,
            sideNavOpenByHover: false
        });
        return sideNavOpen;
    }
    async setWorkHub(selectedImsOrg) {
        await this.authPromise;
        const { locale: locale, sandbox: sandbox, solutionConfig: solutionConfig } = this.state;
        const { workHubId: workHubId } = solutionConfig?.sideNav || {};
        const { urlContext: urlContext } = solutionConfig || {};
        const imsOrgId = selectedImsOrg || this.state.selectedImsOrg; // Don't execute if not a Work-Hub enabled left nav.
        if (!workHubId || !this.isSideNavEnabled()) return;
        /*
    Call WorkHub if...
    1. Sandboxes are enabled for the app, AEP is provisioned for the user on the org, Sandboxes are required for the app, A sandbox is selected
    2. Sandboxes are enabled for the app, Sandboxes are NOT required
    3. Sandboxes are NOT enabled for the app
    */ const sandboxesEnabled = urlContext?.key === "sandbox";
        const sandboxesRequired = !urlContext?.optional;
        if (!(!sandboxesEnabled || !sandboxesRequired || this.orgHasAEP() && sandbox?.selected)) return;
        const workHubResponse = await this.workHubService.getWorkHub({
            capability: workHubId,
            imsOrgId: imsOrgId,
            locale: locale || "en-US",
            sandbox: sandbox?.selected?.name || "none"
        });
        workHubResponse && this.setState({
            workHubResponse: workHubResponse.items
        });
    }
    /**
   * Gets the following data from GraphQL:
   *   1. Pulse (Timeline, Org Settings & Preferences) - To update the Shell header.
   *   2. Next profile - Only if we are using a cached profile (Reload), used to ensure a new open tab will always contain a fresh profile.
   *   3. Avatar - To update in both current and next profile with avatar, in case any SPA uses the avatar (i.e. Preferences)
   * @param {string} locale Current locale to get localized notifications.
   * @param {IMSProfile} profile Current profile
   */ async getHeaderData(locale, profile) {
        const { auth: auth } = this.state;
        const pulseDataPromise = $41d79b167f2f22c7$var$_OrchestrationService.default.waitForBackground().then(()=>(0, $3LITL.initializeShellDataForHeader)({
                config_version: 0,
                getProfile: !this.props.isLogin,
                imageKeySize: $41d79b167f2f22c7$var$AVATAR_SIZES,
                locale: locale,
                settings: {
                    lastClickTimestamp: "",
                    lastNotificationSeenTimestamp: "",
                    lastSeenAnnouncementsTimestamp: ""
                }
            }));
        const { getPPSProfile: getPPSProfile, timeline: timelineResponse, userOrgPreferences: userOrgPreferences, getSettings: settingsResponse, userProfileJson: userProfileJson } = await pulseDataPromise || {};
        const { avatar: avatar, avatarSrc: userAvatar } = (0, $3Zpnv.getAvatarUrls)(getPPSProfile, $41d79b167f2f22c7$var$AVATAR_SIZES);
        if (userAvatar && profile.avatarSrc !== userAvatar) {
            // Different or no avatar in profile. Update state.
            profile.avatar = avatar;
            profile.avatarSrc = userAvatar;
            this.setState({
                profile: profile,
                userAvatar: userAvatar
            });
        }
        this.setState({
            pulseLoaded: true,
            settingsResponse: settingsResponse,
            timelineResponse: timelineResponse,
            userOrgPreferences: userOrgPreferences
        }); // In case we used a stored profile, we got a fresh profile and store it in the session.
        // This ensures on browser refresh profile will be fresh.
        if (userProfileJson) {
            if (userAvatar) {
                // Add the avatar to the profile we are caching.
                // If the user refresh the browser, the avatar will show right away.
                userProfileJson.avatar = avatar;
                userProfileJson.avatarSrc = userAvatar;
            }
            auth.updateProfile(userProfileJson);
        }
    }
    /**
   * Common function to handle errors in feature flag fetching for solution access.
   * @param {Error} erorr Error message
   * @param {string} provider Provider name
   */ handleFeatureFlagApiError(error, provider) {
        const access = this.state.solutionConfig.access || {};
        const flagsRequired = access.flag && (!access.code || access.logicOp === "AND");
        if (flagsRequired) {
            this.showApiFailureErrorScreen({
                api: "User Data",
                error: error,
                failureMessage: `Feature Flag ${provider} API failed.`
            });
            throw error;
        }
    }
    /**
   * Wrapper function to send requests for both feature flag providers
   * @param {boolean} setState Whether to set the state after getting the data.
   * @param {string} selectedImsOrg Currently selectedImsOrg.
   */ async getFeatureFlagData(setState = true, selectedImsOrg = this.state.selectedImsOrg) {
        await this.authPromise;
        const { auth: auth, locale: locale, profile: profile, sandbox: sandbox } = this.state;
        const ffPromise = this.createFFPromise(selectedImsOrg);
        this.services || await this.postAuth;
        const context = {
            hashedAuthId: auth.getHashedAuthId(),
            imsInfo: {
                imsProfile: profile
            },
            imsOrg: selectedImsOrg,
            internal: this.internal,
            locale: locale,
            ...sandbox && {
                sandbox: sandbox
            }
        }; // Get the data from the services
        const launchDarklyFlags = await this.getLaunchDarklyData(context, ffPromise);
        const floodgateFlags = await this.getFloodgateData(context, ffPromise); // Merge the flags. All FG flags receive a prefix to avoid collision with LD flags.
        const featureFlags = {
            ...launchDarklyFlags,
            ...floodgateFlags
        }; // Resolve the flag promise
        ffPromise.resolve(featureFlags); // Update App Assembly
        this.appAssemblyService.setFeatureFlags(featureFlags);
        const shellResponse = this.getShellConfiguration(selectedImsOrg);
        this.logMetricsForShellInfo(shellResponse, "getFeatureFlagData"); // Get and set the state if needed
        const state = {
            activeFeatureFlags: featureFlags,
            featureFlags: featureFlags,
            shellResponse: shellResponse
        };
        setState && this.setState(state); // We can now check for feature flag overrides
        this.checkToSetAccessOverrides(selectedImsOrg);
        return state;
    }
    async getFloodgateData(context, flagPromise) {
        const fgDataTimer = this.metrics.start("FloodgateData");
        let floodgateFlags = {};
        try {
            let flags = await this.services.getFlagService($ftx2l.PROVIDERS.FLOODGATE).getFeatureFlags([
                $cOPHH.SHELL_FG_PROJECT
            ], {
                ...context,
                sandbox: null
            });
            flags = flags[$cOPHH.SHELL_FG_PROJECT]; // We add the prefix `fg:` to floodgate flags to:
            // - prevent a collision of matching feature flags in Launch Darkly
            // - diiferentiate between flags by provider used for solution access
            // The prefix only applies to Core, not any feature flag services
            for(const key in flags)floodgateFlags[`${$cOPHH.SHELL_FLAG_PREFIX}${key}`] = flags[key];
        } catch (error) {
            flagPromise.reject();
            this.metrics.error("Failed to retrieve feature flags from floodgate via GQL", error);
            floodgateFlags = {};
            this.handleFeatureFlagApiError(error, $ftx2l.PROVIDERS.FLOODGATE);
        }
        fgDataTimer.time("done", "floodgate feature flags were pulled from GQL");
        return floodgateFlags;
    }
    async getLaunchDarklyData(context, flagPromise) {
        const ldDataTimer = this.metrics.start("LaunchDarklyData");
        let featureFlags;
        try {
            const flags = await this.services.getFlagService($ftx2l.PROVIDERS.LAUNCH_DARKLY).getFeatureFlags([
                $bPa83.SHELL_LD_PROJECT
            ], context);
            featureFlags = flags[$bPa83.SHELL_LD_PROJECT];
        } catch (error) {
            flagPromise.reject();
            this.metrics.error("Failed to retrieve feature flags from launch darkly via GQL", error);
            featureFlags = {};
            this.handleFeatureFlagApiError(error, $ftx2l.PROVIDERS.LAUNCH_DARKLY);
        }
        ldDataTimer.time("done", "launch darkly feature flags were pulled from GQL");
        return featureFlags;
    }
    createFFPromise(selectedImsOrg) {
        if (!this.ffPromises[selectedImsOrg]) {
            const promise = {};
            promise.promise = new Promise((resolve, reject)=>{
                promise.reject = reject;
                promise.resolve = (featureFlags)=>{
                    promise.featureFlags = featureFlags;
                    resolve(featureFlags);
                };
            });
            promise.promise.catch(()=>null);
            this.ffPromises[selectedImsOrg] = promise;
        }
        return this.ffPromises[selectedImsOrg];
    }
    async getLDFeatureFlags(projectIds = [
        $bPa83.SHELL_LD_PROJECT
    ]) {
        await this.authPromise;
        this.services || await this.postAuth;
        const { auth: auth, locale: locale, profile: imsProfile, selectedImsOrg: selectedImsOrg } = this.state;
        const hashedAuthId = auth.getHashedAuthId();
        const flags = await this.services.getFlagService($ftx2l.PROVIDERS.LAUNCH_DARKLY)?.getFeatureFlags(projectIds, {
            hashedAuthId: hashedAuthId,
            imsInfo: {
                imsProfile: imsProfile
            },
            imsOrg: selectedImsOrg,
            internal: this.internal,
            locale: locale
        });
        return (0, $dXqQN.overrideFeatureFlags)(flags, hashedAuthId);
    }
    configureNetwork(selectedImsOrg, skipWorkHub, selectedOrgRegion = this.state.selectedOrgRegion) {
        const { sandbox: { selected: selectedSandbox } = {}, selectedImsOrg: stateOrg } = this.state;
        const imsOrg = selectedImsOrg || stateOrg; //configure network runtime API
        this.bootstrap.configureNetwork(imsOrg, selectedSandbox, selectedOrgRegion);
        if (selectedSandbox) {
            const setPermissionContext = ()=>this.services.permissionService.setContext(imsOrg, selectedSandbox, this.orgHasAEP());
            this.services ? setPermissionContext() : this.postAuth.then(setPermissionContext);
        }
        skipWorkHub || this.setWorkHub(imsOrg);
        this.createFFPromise(imsOrg);
    }
    /**
   * Shows API failure error screen and sends metrics event.
   * @param {string} failureMessage Custom failure message
   */ async showApiFailureErrorScreen({ api: api, error: error = {}, errorMessageType: errorMessageType = $fi30R.ErrorTypes.UNKNOWN, failureMessage: failureMessage = "API failed.", showError: showError = true }) {
        await this.pingPromise;
        if (this.state.error) // Another error is already shown.
        return;
        let errorData = {
            api: api,
            availability: this.availability,
            existingErrorShown: !!this.state.error,
            showError: showError
        };
        if (error?.message) {
            const { message: message, errors: errors, requestId: requestId, stack: stack } = error;
            errorData = {
                ...errorData,
                error: message,
                errors: errors,
                requestId: requestId,
                stack: stack
            };
        }
        if (error.reload) this.props.showSpinner();
        this.metrics.event("Core.apiFailure", `${failureMessage}${showError && !this.state.error ? " Showing message to user." : ""}`, {
            level: $41d79b167f2f22c7$var$_metrics.Level.ERROR
        }, errorData);
        showError && this.setState({
            error: errorMessageType
        });
    }
    /**
   * Get user orgs from GraphQL with IMS fallback, and store to session.
   * @param {object} gqlResponse - GraphQL call response
   * @returns {Promise<{loginOrg, userOrgs}>} User Orgs
   */ async getUserOrgData(gqlResponse) {
        const { getSettings: getSettings = {}, imsExtendedAccountClusterData: { data: userAccounts } } = gqlResponse || {};
        const { defaultOrg: defaultOrg = "", lastLoggedInOrg: lastLoggedInOrg = "", userSandboxes: userSandboxes = {} } = getSettings?.settings || {}; // Put all org data into local and session storage
        const { orgAccountMap: orgAccountMap, userOrgs: userOrgs } = await this.storeOrgData(userAccounts);
        this.setState({
            hasAccountClusterData: true,
            userAccounts: userAccounts
        });
        const isDefaultOrgSet = defaultOrg && defaultOrg !== $41d79b167f2f22c7$var$LAST_LOGGED_IN && this.isValidOrg(userOrgs, defaultOrg);
        const loginOrg = isDefaultOrgSet ? defaultOrg : lastLoggedInOrg;
        isDefaultOrgSet && (this.tenantMap.DEFAULT_ORG = defaultOrg);
        return {
            lastLoggedInOrg: lastLoggedInOrg,
            loginOrg: loginOrg,
            orgAccountMap: orgAccountMap,
            userAccounts: userAccounts,
            userOrgs: userOrgs,
            userSandboxes: userSandboxes
        };
    }
    /**
   * Store org data does:
   * 1. Concatenates list of all the orgs accross all accounts
   * 2. Adds user specific data to unifiedShellSession
   * 3. Creates orgAccountMap to put in session storage
   * @returns {Promise<{userOrgs}>} User Orgs
   */ async storeOrgData(userAccounts) {
        let userOrgs = [];
        const localSession = await $41d79b167f2f22c7$var$_UnifiedShellSessionService.default.get() || {};
        localSession.shellOrgAccountMap = {};
        const orgAccountMap = {};
        userAccounts.forEach(({ owningOrg: owningOrg, orgs: orgs, userId: userId, userType: userType })=>{
            orgs = userType === $fi30R.AuthType.TYPE2E ? [
                owningOrg
            ] : orgs;
            userOrgs = userOrgs.concat(orgs);
            const hashedUserId = (0, $41d79b167f2f22c7$var$_stringHash.default)(userId).toString();
            localSession[hashedUserId] = {
                ...localSession[hashedUserId],
                userOrgs: orgs,
                userType: userType
            };
            orgs.forEach(({ imsOrgId: imsOrgId, tenantId: tenantId })=>{
                // If the org is already mapped to a type2e account, don't override it
                if (orgAccountMap[imsOrgId] && userType !== $fi30R.AuthType.TYPE2E) {
                    this.metrics.event("Auth.duplicateOrg", `${orgAccountMap[imsOrgId]} and ${userId} both have access to org ${imsOrgId}`, {
                        level: $41d79b167f2f22c7$var$_metrics.Level.WARN
                    });
                    return;
                } // Return a map with the real IDs, but pushed the hashed values in local storage
                orgAccountMap[imsOrgId] = userId;
                this.tenantMap[tenantId] = imsOrgId;
                localSession.shellOrgAccountMap[imsOrgId] = hashedUserId;
            });
        });
        localSession.userOrgs = userOrgs;
        await $41d79b167f2f22c7$var$_UnifiedShellSessionService.default.set(localSession);
        this.metrics.event("Auth.orgsStored", {
            totalAccounts: userAccounts.length,
            totalOrgs: userOrgs.length
        });
        return {
            orgAccountMap: orgAccountMap,
            userOrgs: userOrgs
        };
    }
    async authProcessing() {
        const authProcessingTimer = this.metrics.start("AuthProcessing");
        const { auth: auth } = this.state;
        const getOrgsPromise = auth.gqlHandler(!this.props.isLogin);
        this.getAccountCluster = ()=>getOrgsPromise.then((response)=>this.getUserOrgData(response)).catch((error)=>this.showApiFailureErrorScreen({
                    api: "User Data",
                    error: error,
                    failureMessage: "API for getting user accounts failed on orgAccountMap request."
                })); // Call GraphQL to fetch profile, org, languages, and spectrum theme.
        const getOrgsData = ()=>getOrgsPromise.then((response)=>{
                // Get the preferred languages from the IMS account cluster
                const { imsExtendedAccountClusterData: { preferredLanguages: preferredLanguages = [] } } = response;
                this.metrics.info(`Auth account cluster data: preferredLanguages ${preferredLanguages}`);
                this.onLanguageChange(preferredLanguages, true);
                const clusterLanguage = (0, $gigHb.getBestSupportedLocale)(preferredLanguages, $gigHb.SUPPORTED_LOCALES);
                if (this.state.profile) {
                    const profileLanguage = (0, $gigHb.getBestSupportedLocale)(this.state.profile?.preferred_languages, $gigHb.SUPPORTED_LOCALES);
                    if (clusterLanguage !== profileLanguage) {
                        auth.updateProfile({
                            ...this.state.profile,
                            preferred_languages: preferredLanguages
                        });
                        (0, $lRoWp.reload)({
                            data: {
                                actual: clusterLanguage,
                                cached: profileLanguage
                            },
                            initiator: "Core",
                            reason: "Cached locale is incorrect"
                        });
                    }
                } // Handle user consent
                const userConsentResponse = response?.getConsentPermissions || null; // Save the settings data for future use
                const settings = response?.getSettings?.settings || null;
                settings && this.setState({
                    settings: settings,
                    userConsentResponse: userConsentResponse
                }, ()=>this.processSettings());
                return this.getUserOrgData(response);
            }).catch((error)=>{
                // On login, show the user the error screen. Otherwise, throw the error but don't show
                // the error screen in case there are cached orgs that can be used
                if (this.props.isLogin) this.showApiFailureErrorScreen({
                    api: "User Data",
                    error: error,
                    failureMessage: "API for getting user accounts failed on login."
                });
                else throw error;
            });
        const getOrgsMap = ()=>getOrgsData().then((data)=>data?.userOrgs);
        let orgsMap;
        let profile;
        let loginOrgsData;
        (0, $apIgy.setUnauthorizedHandler)(this.on401); // This prevents checking the HTML through the service worker on app switch.
        if (this.htmlReady === $fi30R.HTMLStatus.PENDING) {
            this.htmlReady = await this.serviceWorkerService.checkHtmlForUpdates(this.state.solutionConfig);
            this.availability.html = this.htmlReady;
            if (this.htmlReady === $fi30R.HTMLStatus.UNREACHABLE || this.htmlReady === $fi30R.HTMLStatus.TIMEOUT) {
                // Service worker failed to download HTML, check ping.
                const { success: success } = await this.pingPromise;
                if (!success) {
                    // Both PING and HTML failed - Show offline error.
                    (0, $jBKJw.waitForPingSuccess)(()=>(0, $lRoWp.reload)({
                            initiator: "Core",
                            reason: "Ping success after offline"
                        }));
                    this.setState({
                        error: $fi30R.ErrorTypes.OFFLINE
                    });
                    return;
                }
            }
        }
        try {
            // If this is not a login but the userId is not in local storage this is the first
            // time the user has switched to this account in the current session. We should treat
            // it like a login in order to get the correct data from GQL for the current account.
            if (this.props.isLogin) {
                // Wait for GraphQL if this is a login.
                loginOrgsData = await getOrgsData();
                orgsMap = loginOrgsData.userOrgs;
                profile = await auth.fetchUserProfile();
            } else {
                const [cachedProfile, cachedOrgs] = await Promise.all([
                    auth.fetchUserProfile(false),
                    $41d79b167f2f22c7$var$_UnifiedShellSessionService.default.get("userOrgs")
                ]);
                profile = cachedProfile;
                const { avatarSrc: userAvatar } = profile || {};
                if (userAvatar && !this.state.userAvatar) this.setState({
                    userAvatar: userAvatar
                });
                if ((0, $3Zpnv.allOrgsInProfile)(cachedOrgs, profile, this.metrics)) orgsMap = cachedOrgs;
                orgsMap = await (0, $3Zpnv.staleWhileRevalidate)(getOrgsMap, orgsMap, true, async (error)=>this.showApiFailureErrorScreen({
                        api: "User Data",
                        error: error,
                        failureMessage: "API for getting user orgs failed on reload.",
                        showError: false
                    }));
            }
        } catch (error) {
            // If fresh login, there is no cache so if GQL and IMS api fail, show error screen
            this.showApiFailureErrorScreen({
                api: "User Data",
                error: error,
                failureMessage: "API for getting user orgs failed."
            });
            return;
        } // Generate org / tenant maps from orgsMap
        orgsMap.forEach(({ imsOrgId: imsOrgId, tenantId: tenantId })=>{
            let tenantKey = tenantId; // Handle duplicate orgs
            if (tenantKey in this.tenantOrgMap) {
                this.metrics.warn(`Duplicate tenant ID: IMS orgs ${imsOrgId} and ${this.tenantOrgMap[tenantKey]} both contain dma_tartan and linked to tenant ${tenantKey}`);
                tenantKey = `${tenantKey}:${imsOrgId.slice(0, 4)}`;
            }
            this.orgTenantMap[imsOrgId] = tenantKey;
            this.tenantOrgMap[tenantKey] = imsOrgId;
        });
        const pathOrg = this.getPathOrg();
        const userOrgs = await $41d79b167f2f22c7$var$_UnifiedShellSessionService.default.get("userOrgs", auth.getHashedUserId());
        if (!(userOrgs && orgsMap)) this.metrics.warn("Org list missing", {
            hash: auth.getHashedUserId(),
            isLogin: this.props.isLogin,
            orgsMap: !!orgsMap,
            userOrgs: !!userOrgs
        });
        const orgData = await this.getSelectedImsOrg(orgsMap, profile, pathOrg, loginOrgsData);
        const { selectedImsOrg: selectedImsOrg } = orgData; // If the selected org is not in the current account, switch to that account.
        if (selectedImsOrg && this.isValidOrg(orgsMap, selectedImsOrg) && !this.isValidOrg(userOrgs, selectedImsOrg)) {
            const { orgAccountMap: orgAccountMap } = await this.getAccountCluster() || {};
            orgAccountMap && await this.onType2eOrgChange(orgAccountMap[selectedImsOrg], true); // Fulfill authPromise so any processes awaiting it can start. As of now this includes only custom tokens.
            this.authResolve(auth);
        } else {
            // Fulfill authPromise so any processes awaiting it can start. As of now this includes only custom tokens.
            this.authResolve(auth);
            await this.authProcessWithProfile(profile, orgData, orgsMap, loginOrgsData);
        }
        authProcessingTimer.time("done");
        this.shellTimer.time(this.props.isLogin ? "isLoginFlow.done" : "done", {
            region: this.config.region,
            satellite: !!window._satellite
        }); // step 9 ready
    }
    async authProcessWithProfile(profile, orgData, orgsMap, loginOrgsData = {}) {
        const { auth: auth } = this.state;
        const { onLocale: onLocale } = this.props;
        const { userSandboxes: userSandboxes } = loginOrgsData;
        profile = profile || await auth.fetchUserProfile(); // possibly false as argument here!?
        const accessToken = auth.fetchAccessToken(); // Get user's Spectrum theme from local storage
        // Set state asap to reduce flickers
        const storedThemes = await $iJaYo.storage.local.get("spectrumTheme");
        const hashedAuthId = auth.getHashedAuthId();
        if (storedThemes?.[hashedAuthId]) this.setState({
            theme: storedThemes[hashedAuthId]
        });
         // Handle languages preferences
        const queryLocale = (0, $hCG2Z.getQueryValue)("locale");
        const forcedLocale = queryLocale ? (0, $gigHb.getBestSupportedLocale)([
            queryLocale
        ], $gigHb.SUPPORTED_LOCALES) : undefined; // Check local storage for user account language preferences, these are the
        // source of truth over the IMS profile language preferences
        const storedLanguages = $iJaYo.storage.local.getSync("accountLanguagePreferences")?.[hashedAuthId];
        let preferredLanguages = profile.preferred_languages;
        if (storedLanguages && storedLanguages.join(",").toLowerCase() !== preferredLanguages?.join(",").toLowerCase()) {
            profile.preferred_languages = preferredLanguages = storedLanguages;
            auth.updateProfile(profile);
        }
        this.metrics.info("authProcessWithProfile preferredLanguages", {
            profileLanguages: profile.preferred_languages,
            storedLanguages: storedLanguages
        });
        const locale = forcedLocale || (0, $gigHb.getBestSupportedLocale)(preferredLanguages, $gigHb.SUPPORTED_LOCALES);
        onLocale(locale);
        document.documentElement.setAttribute("lang", locale);
        const productContext = profile.projectedProductContext;
        await this.setProductContextValues(productContext); // Track the number of orgs that a user has with the dma_tartan service code and the number without.
        // This will help us determine the need for this service code in the future.
        const numWithTartan = Object.keys(this.orgTenantMap).length;
        this.metrics.info("User dma_tartan orgs information", {
            with: numWithTartan,
            without: this.allOrgs.size - numWithTartan
        }); // Grab the org from the path and use that as the selected org. If there
        // is no org yet, use the selected one from IMS.
        const pathOrg = this.getPathOrg();
        const tenantInPath = !!pathOrg;
        orgsMap = orgsMap || await $41d79b167f2f22c7$var$_UnifiedShellSessionService.default.get("userOrgs");
        const { activeOrg: activeOrg, selectedImsOrg: selectedImsOrg } = orgData || await this.getSelectedImsOrg(orgsMap, profile, pathOrg, loginOrgsData);
        const { orgName: selectedImsOrgName, orgRegion: selectedOrgRegion } = (0, $3Zpnv.getOrgMetadata)(selectedImsOrg, orgsMap); // Re-configure network so sandbox GQL call has the correct selectedImsOrg and selectedOrgRegion
        this.configureNetwork(selectedImsOrg, false, selectedOrgRegion);
        const tenantId = this.orgTenantMap[selectedImsOrg] || selectedImsOrg;
        this.metrics.event("Auth.done", {
            selectedOrg: selectedImsOrg,
            selectedTenant: $41d79b167f2f22c7$var$cleanTenant(tenantId)
        });
        const imsOrgs = orgsMap.map((org)=>({
                label: org.orgName,
                value: org.imsOrgId
            }));
        imsOrgs.sort((a, b)=>a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1);
        const wasTenantSelected = pathOrg === activeOrg;
        const showNoAccessShell = !selectedImsOrg; // If the user does not have a selected IMS org, that means they don't have
        // any because the fallback picks one. Sets the state so that it will render
        // that view to the user.
        if (showNoAccessShell) {
            this.metrics.event("Shell.noAccess", {
                level: $41d79b167f2f22c7$var$_metrics.Level.WARN
            });
            this.setState({
                locale: locale,
                profile: profile,
                showNoAccessShell: showNoAccessShell
            });
            return;
        }
        this.internal = (0, $3Zpnv.isInternal)((profile?.email || "").toLowerCase());
        const impersonationIdData = auth.getImpersonationId(accessToken);
        this.isImpersonating = !!impersonationIdData?.impersonationId; // Falls back to the org id if there is no tenant available for the org
        $3x6rS.Internal.setUser({
            accountType: profile.account_type,
            authId: profile.authId,
            authSystem: "ims",
            data: {
                internal: this.internal,
                tenantId: $41d79b167f2f22c7$var$cleanTenant(tenantId),
                ...impersonationIdData
            },
            displayName: profile.displayName,
            groupId: selectedImsOrg,
            groupName: selectedImsOrgName,
            groupRegion: selectedOrgRegion,
            language: locale,
            sessionId: profile.session,
            userId: profile.userId
        });
        const appAssemblyTimer = this.metrics.start("AppAssembly");
        this.appAssemblyModule || await this.appAssemblyPromise;
        const { default: AppAssemblyService } = this.appAssemblyModule; // Instantiate the App Assembly Service when we have the values we need
        this.appAssemblyService = new AppAssemblyService({
            cdn: this.cdn,
            environment: this.config.serviceEnvironment,
            imsOrgs: imsOrgs,
            isDemoMode: this.bootstrap.isDemoMode(),
            listedApps: this.props.listedApps,
            locale: locale,
            orgTenantMap: this.orgTenantMap,
            profile: profile,
            userFulfillableData: this.userFulfillableData,
            userFulfillableItems: this.userFulfillableItems,
            userRoles: profile.roles,
            userServiceCodes: this.userServiceCodes,
            userSubServices: this.userSubServices,
            userVisibleNames: this.userVisibleNames
        });
        appAssemblyTimer.time("done"); // We can now check for some overrides
        this.checkToSetAccessOverrides(selectedImsOrg, hashedAuthId); // Redirect to profile page if profile is in path
        if ((0, $jVeiz.getPathWithoutTenant)((0, $jVeiz.hashToPath)()) === "/profile") return window.location.assign(this.appAssemblyService.getProfileComponent(tenantId).editProfileLink);
         // Reset orgToSubOrgsMap so it can be generated in the context service.
        const orgToSubOrgsMap = {};
        this.setState({
            accessToken: accessToken,
            activeFulfillableData: this.userFulfillableData,
            activeFulfillableItems: this.userFulfillableItems,
            imsOrgs: imsOrgs,
            locale: locale,
            orgsMap: orgsMap,
            orgToSubOrgsMap: orgToSubOrgsMap,
            preferredLanguages: preferredLanguages,
            profile: profile,
            selectedImsOrg: selectedImsOrg,
            selectedImsOrgName: selectedImsOrgName,
            selectedOrgRegion: selectedOrgRegion,
            showNoAccessShell: showNoAccessShell,
            userSandboxes: userSandboxes
        }, async ()=>{
            // Because of timing - trigger the userTheme again, which requires settings and profile
            this.userThemeHandler();
            this.storeTenantMap(selectedImsOrg);
            this.refreshContext(selectedImsOrg); // Notify hidden tabs so they can check if their session is dead.
            // This is needed after account switching (T2E), because any inactive tabs
            // will be running against an invalid token & session. Informing inactive tabs allows
            // them to reload themselves with a token acquired against the active T2E account.
            if (this.props.isLogin && this.sessionId) this.authChannel?.postMessage({
                message: $fi30R.AuthMessages.LOGIN,
                sessionId: this.sessionId
            });
            /**
       * Separate method for processing the last few pieces of authProcessing
       * so that it can be used in a `then` statement after a possible account
       * cluster fetch by the AEM Skyline process.
       * @async
       * @returns {Promise}
       */ const completeLoading = async ()=>{
                const { solutionConfig: solutionConfig } = this.state; // Only await on the feature flag data request when there is a feature
                // flag required to determine access of the current application. Doing
                // it all the time will cause unnecessary delays to other apps.
                const access = solutionConfig.access || {};
                try {
                    const ffPromise = this.getFeatureFlagData();
                    access.flag && await ffPromise;
                } catch  {
                    // Error handling already covered in getFeatureFlagData.
                    return;
                } // The tenant is in the URL and it was not the current IMS org in the session.
                if (tenantInPath && !wasTenantSelected) {
                    let selectedSubOrg; // While doing org changes, we have already kicked off the sub-org
                    // fetch for this new org. Wait for that to finish and use that in
                    // the org change call. Otherwise, onImsOrgChange will unset the
                    // sub-org value and we'll get into a weird state.
                    if (this.contextService?.isSubOrg && this.contextFetchPromise) ({ selectedSubOrg: selectedSubOrg } = await this.contextFetchPromise || {});
                     // If the tenant is already in the URL, we don't need to update the path.
                    // Instead, trigger an org change to let IMS know that this is the current org
                    await this.onImsOrgChange(selectedImsOrg, activeOrg, selectedSubOrg, true);
                } else {
                    // The tenant is not in the URL or it is and was already the current IMS
                    // org in the session. Get shell configuration and update the URL.
                    const shellResponse = this.getShellConfiguration(selectedImsOrg);
                    this.logMetricsForShellInfo(shellResponse, "completeLoading");
                    const hero = (0, $a2nzs.getHeroConfig)(shellResponse, solutionConfig, this.state.hero);
                    this.setState({
                        favicon: hero.icon,
                        hero: hero,
                        shellResponse: shellResponse
                    }); // If the org isn't authorized for the solution or the solution
                    // requires sandboxes but the org doesn't have AEP, redirect to home
                    if (!await this.isOrgPermissionedOnSolution(selectedImsOrg)) return this.homeRedirectToast({
                        selectedImsOrg: selectedImsOrg,
                        solutionConfig: solutionConfig,
                        tenant: tenantId
                    });
                    (0, $2qT0f.updatePath)({
                        tenant: tenantId
                    }, true, this.hasTenantInUrl, this.contextKey);
                }
                this.authProcessingInitialized = true;
            }; // Call GraphQL to fetch IMS Avatar and Pulse data.
            this.getHeaderData(locale, profile); // Special processing for the Skyline use case. Grabs the orgId from the
            // AEM discovery response so that the org can be handled appropriately.
            if ((0, $15j1u.isSkyline)()) return this.processSkylineOrg(selectedImsOrg, profile, completeLoading);
            else if ((0, $hCG2Z.getQueryParams)()["repo"] && !this.authProcessingInitialized) return this.correctAEMOrg(selectedImsOrg, profile.userId, completeLoading);
            completeLoading();
        });
    }
    /**
   * If the URL contains the repo param, check if we are on the org corresponding
   * to the AEM instance in the repo param and switch to the correct org if necessary
   * @param {string} selectedImsOrg The currently selected org
   * @param {string} userId The user ID
   * @param {function} completeLoading Function to finish loading if not switching orgs
   * @returns {string | undefined} The correct org ID or undefined if the org is not found
   */ /**
   * Determines what the organization is for the current instance (in subdomain
   * e.g. author-p58154-e463621). If it is the same as is currently selected by
   * the Unified Shell, nothing happens. If it is different and is a type2e, the
   * profile is switched. If it is different and is not type2e, the normal org
   * change happens.
   *
   * If the discovery call that was triggered earlier in the loading flow
   * returns an imsOrg, it is the org related to the current instance and this
   * function will end early. If, however, no org is returned, it is the
   * old-style endpoint and extra processing needs to happen.
   *
   * Upon completion, if the org did not change or there was an error, the
   * callback is called, which handles the non-Skyline related finishing touches
   * such as fetching feature flags.
   * @param {string} selectedImsOrg Current org that the user has activated.
   * @param {Object} profile IMS profile for the currently authenticated user.
   * @param {function} callback Callback to be used if no org changes were made.
   * @returns {Promise} Depending on the response of the discovery
   *   call, imsOrg in response means undefined is returned, empty response
   *   means promise is returned.
   */ async processSkylineOrg(selectedImsOrg, profile, callback) {
        const accountClusterPromise = this.getAccountCluster();
        /**
     * Scenarios:
     *   1. Instance is not within the current org but is within the current profile (change org)
     *   2. Instance is not within the current org nor the current profile (change profiles)
     * @async
     * @param {string} imsOrg - Org ID of the IMS org associated with the instance.
     * @param {Object} orgAccountMap - Map of org to account.
     * @returns {Promise}
     */ const processAEMOrg = async (imsOrg, orgAccountMap)=>{
            if (!imsOrg || imsOrg === selectedImsOrg) {
                this.metrics.info("AEM instance on same org", {
                    imsOrg: imsOrg,
                    same: imsOrg === selectedImsOrg
                });
                return callback();
            }
            const usersMatch = orgAccountMap[imsOrg] === profile.userId;
            const type = usersMatch ? "ORG" : "Type2e";
            this.metrics.info(`AEM instance required ${type} switch`, {
                imsOrg: imsOrg,
                type: type,
                userId: orgAccountMap[imsOrg]
            });
            usersMatch ? this.onImsOrgChange(imsOrg, selectedImsOrg, null, true) : this.onType2eOrgChange(orgAccountMap[imsOrg], true);
        };
        try {
            const { imsOrg: imsOrg } = await this.aemPromise || {}; // The new endpoint is used in this AEM instance, so we can process the
            // org immediately w/ the results of the account cluster call that does
            // NOT include AEM.
            if (imsOrg) {
                const { orgAccountMap: orgAccountMap } = await accountClusterPromise || {};
                processAEMOrg(imsOrg, orgAccountMap);
                return;
            }
        } catch (e) {
            // Don't do anything here because it will be handled in the actual
            // discovery call later.
            this.metrics.error("Skyline org discovery failed", e);
        } // The Skyline instance has not been updated. Log it so that we can track
        // when we can remove this fallback code.
        this.metrics.info("Skyline fallback");
        const { processFallback: processFallback } = await Promise.resolve().then(function() {
            return (parcelRequire("hFGrB"));
        }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res));
        processFallback({
            accountClusterPromise: accountClusterPromise,
            completeCallback: callback,
            processAEMOrg: processAEMOrg
        });
    }
    /**
   * On login or a full page refresh, chooses the correct ims org and stores
   * that data in the unified shell session.
   * @param {Object} orgsMap List of all ims orgs in the entire user account.
   * @param {Object} profile IMS profile
   * @param {string} pathOrg Org in the url
   * @param {Object} loginOrgsData GraphQL SSO information such as the last
   * logged in org (lastLoggedInOrg) or the user's default org (loginOrg).
   */ /**
   * Navigate to the /home application. Depending on the TLD, this will either
   * be a full redirect to the Experience Cloud domain in addition to the /home
   * path change. Otherwise it will just update the path.
   * @param {boolean} hasTenantInUrl If the tenant is in the URL.
   * @param {boolean} replace If the history should be replaced or pushed.
   * @param {string} tenant Tenant value to put in the URL.
   */ pageRedirect({ env: env, hasTenantInUrl: hasTenantInUrl = true, path: path = "/home", replace: replace, tenant: tenant }) {
        // If we are not on the Experience Cloud domain, we are likely on AEM. Any
        // navigation to /home must include a redirect to the Experience Cloud domain.
        if (!(0, $jVeiz.isExperienceOrigin)()) return window.open((0, $jVeiz.getUnifiedShellUrl)(env || this.config.environment, `@${tenant}${path}`), "_self");
        const url = {
            path: path
        };
        tenant && (url.tenant = tenant);
        (0, $2qT0f.updatePath)(url, replace, hasTenantInUrl);
    }
    /**
   * Get a fallback org in a standard way. Currently it sorts the list of org
   * ids in ascending order and takes the first one.
   * @param {string[]} orgs List of org ids.
   * @returns {string} The fallback org.
   */ getUserOrgContext() {
        const { environment: environment, profile: imsProfile, sandbox: sandbox, selectedImsOrg: imsOrg, selectedSubOrg: subOrg } = this.state;
        return {
            environment: environment,
            imsOrg: imsOrg,
            imsProfile: imsProfile,
            sandbox: sandbox.selected,
            subOrg: subOrg
        };
    }
    setConfigStates(config) {
        const { coachMark: coachMark, customEnvLabel: customEnvLabel, customSearch: customSearch, helpCenter: helpCenter, hero: hero, pulse: pulse, showRolesPicker: showRolesPicker, sidebar: sidebar } = config;
        if (hero) config.hero = (0, $a2nzs.getHeroConfig)(this.state.shellResponse, this.state.solutionConfig, hero);
        helpCenter && Object.assign(config, {
            helpCenter: {
                ...this.state.helpCenter,
                ...helpCenter
            }
        }); // Some calls to setConfigStates will exlude `customEnvLabel` as a key and we will ignore those
        // Other calls may specify `customEnvLabel` as `null` or `undefined` and we want to process them
        if ("customEnvLabel" in config) {
            // Ensure we are working with an array from here forward
            const labelsList = Array.isArray(customEnvLabel) ? customEnvLabel : [
                customEnvLabel
            ]; // Ensure each value is truthy and each string is converted to a default CustomLabelDesc
            const normalizedCustomLabels = labelsList.reduce((list, val)=>{
                val && list.push(typeof val === "string" ? {
                    type: $bMVp5.CustomLabelType.ENVIRONMENT,
                    value: val
                } : val);
                return list;
            }, []);
            Object.assign(config, {
                customEnvLabel: normalizedCustomLabels
            });
        }
        customSearch && Object.assign(config, {
            customSearch: {
                // If an enabled value is not explicitly set, maintain the current state
                enabled: customSearch.enabled === undefined ? this.state.customSearch.enabled : customSearch.enabled,
                onClick: this.onCustomSearchClick,
                open: customSearch.open || false
            }
        }); // This is now deprecated in favor of the sidenav config, which should be used instead.
        // Remove this if statement once all solutions have been transitioned to sidenav
        if (sidebar) {
            Object.assign(config, {
                sidebar: {
                    ...sidebar,
                    config: sidebar.config || this.state.sidebar?.config
                }
            });
            if (sidebar.collapsed !== undefined) {
                this.setState({
                    sideNavOpen: !sidebar.collapsed
                });
                $iJaYo.storage.session.set("sideNavOpen", !sidebar.collapsed);
            }
        }
        const sidenav = config["sidenav/collapsed"] !== undefined || config["sidenav/visible"] !== undefined || config["sidenav/config"]; // The application has triggered the roles modal. Open it with the fromAPI
        // argument being true as there is some different handling in this case.
        if (showRolesPicker) this.setState({
            showRolesModal: "API"
        });
        if (sidenav) {
            Object.assign(config, {
                sidenav: {
                    collapsed: config["sidenav/collapsed"] !== undefined ? config["sidenav/collapsed"] : this.state.sidenav?.collapsed,
                    config: config["sidenav/config"] || this.state.sidenav?.config,
                    visible: config["sidenav/visible"] !== undefined ? config["sidenav/visible"] : this.state.sidenav?.visible
                }
            });
            if (config["sidenav/collapsed"] !== undefined) {
                this.setState({
                    sideNavOpen: !config["sidenav/collapsed"]
                });
                $iJaYo.storage.session.set("sideNavOpen", !config["sidenav/collapsed"]);
            }
        }
        if (pulse) config.pulse = {
            ...this.state.pulse,
            ...pulse
        };
        this.metrics.log("Shell.setConfigStates", {
            keys: Object.keys(config)
        });
        this.setState(config);
        coachMark && this.debouncedUpdateTargetNode();
    }
    async enableFeedback(programs) {
        if (!this.feedbackService) {
            const { default: FeedbackService } = await Promise.resolve().then(function() {
                return (parcelRequire("hg1YG"));
            }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res));
            this.feedbackService = new FeedbackService(this.history); // Handle the config change event from the service. When the service runs
            // the check, this will always fire, either with a config based on a
            // matched path or null if nothing matched. Both are valid since we need
            // to hide the icon and button if there are no active beta programs on the
            // current path.
            this.feedbackService.on("CONFIG", (config)=>{
                const { sandbox: sandbox, subOrg: subOrg } = this.getUserOrgContext();
                const feedbackConfig = !config ? null : {
                    ...config,
                    custom: {
                        ...config.custom || {},
                        sandbox: sandbox,
                        subOrg: subOrg
                    }
                };
                this.setState({
                    feedbackConfig: feedbackConfig,
                    releaseType: this.bootstrap.isDemoMode() ? $ctGaZ.RELEASE_TYPE.GA : config?.releaseType || null
                });
            });
        }
        this.feedbackService.addConfig(programs);
    }
    /**
   * Returns a clean state for the config values. This is used when an app
   * unmounts or a new app is loaded.
   * @param {Object} nextSideNav The sideNav configuration of the next app.
   * @returns State object
   */ async getLastSelectedSubOrgs() {
        let { lastSelectedSubOrgs: lastSelectedSubOrgs } = this.state.settings || {};
        if (!this.state.settings) {
            this.metrics.info("Retrieving lastSelectedSubOrgs from settings");
            const { settings: settings } = await this.getSetting({
                lastSelectedSubOrgs: null
            }) || {};
            lastSelectedSubOrgs = settings?.lastSelectedSubOrgs;
            lastSelectedSubOrgs && this.setState({
                settings: {
                    ...this.state.settings,
                    lastSelectedSubOrgs: lastSelectedSubOrgs
                }
            });
        }
        return lastSelectedSubOrgs;
    }
    async getShellConfigurationExtended() {
        const { auth: auth, selectedImsOrg: selectedImsOrg } = this.state;
        const unifiedShellSessionData = (await $41d79b167f2f22c7$var$_UnifiedShellSessionService.default.get())?.[auth.getHashedUserId()];
        const lastSelectedSubOrgs = await this.getLastSelectedSubOrgs();
        return this.appAssemblyService.fetchShell(selectedImsOrg, this.orgTenantMap[selectedImsOrg], unifiedShellSessionData || {}, lastSelectedSubOrgs || {});
    }
    /**
   * Synchronous version of getShellConfiguration which does not include adding
   * the sub-orgs to the shellResponse data. This is the default action unless
   * subOrgsInShellInfo is set on the application config.
   * @returns {Object} Shell information.
   */ getShellConfiguration(selectedImsOrg) {
        const selectedOrg = selectedImsOrg || this.state.selectedImsOrg;
        return this.appAssemblyService.fetchShell(selectedOrg, this.orgTenantMap[selectedOrg]);
    }
    /**
   * Checks whether an ims org is permissioned on a given solution.
   * @param {string} orgId The IMS org.
   * @param {Object} solutionConfig Optional solution config.
   * @returns {boolean} If the org is permissioned.
   */ async isOrgPermissionedOnSolution(orgId, solutionConfig) {
        const { selectedImsOrg: selectedImsOrg, solutionConfig: config } = this.state;
        let { featureFlags: featureFlags } = this.state;
        const { access: access = {}, urlContext: urlContext } = solutionConfig || config; // Only wait for flags if the solution requires it.
        if (access?.flag || access?.sandboxFlag) try {
            featureFlags = featureFlags || await this.createFFPromise(selectedImsOrg).promise;
        } catch  {
            // Failed to fetch feature flags, but don't die here. An empty object
            // is fine b/c if the access uses OR, feature flags may not be required
            // to determine access.
            featureFlags = {};
        }
         // If the app does not require sandboxes or they are optional, it shouldn't
        // affect the outcome of this permissions check, so it's treated as
        // supported. If sandboxes are required, check the available service codes
        // for the org to see if ACP is enabled.
        const sandboxesSupported = urlContext?.key !== "sandbox" || urlContext?.optional ? true : this.orgHasAEP(orgId); // We intentionally do NOT include feature flag overrides in this check.
        // This is to protect against a user being able to give themselves access
        const hasPermissionForSolution = (0, $2GWWF.hasPermission)(access, {
            featureFlags: featureFlags,
            fulfillableData: this.userFulfillableData[orgId],
            fulfillableItems: this.userFulfillableItems[orgId],
            serviceCodes: this.userServiceCodes[orgId],
            userSubServices: this.userSubServices[orgId],
            userVisibleNames: this.userVisibleNames[orgId]
        });
        const orgPermissioned = hasPermissionForSolution && sandboxesSupported;
        this.setState({
            orgPermissioned: orgPermissioned
        });
        return orgPermissioned;
    }
    /**
   * Displays a toast with a custom message.
   * @param {string} messageId The message ID of the localized string to populate the toast.
   * @param {Object} options Optional object of objects such as variant.
   */ async showToast(messageId, options) {
        const { showShellToast: showShellToast } = await Promise.resolve().then(function() {
            return (parcelRequire("9gBaS"));
        }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res));
        await (0, $41d79b167f2f22c7$var$_Shell.waitForShellHeader)();
        this.setState({
            toastPlacement: options.position || "top center"
        });
        showShellToast(messageId, this.state.locale, options);
    }
    homeRedirectToast({ eimEvent: eimEvent = "Shell.notPermissioned", selectedImsOrg: selectedImsOrg, solutionConfig: solutionConfig, tenant: tenant, toastMessage: toastMessage = "orgHomeRedirectToast" }) {
        this.pageRedirect({
            hasTenantInUrl: this.hasTenantInUrl,
            replace: true,
            tenant: tenant
        });
        this.metrics.event(eimEvent, {
            appId: solutionConfig.appId,
            selectedImsOrg: selectedImsOrg
        });
        this.showToast(toastMessage, {
            timeout: $41d79b167f2f22c7$var$TOAST_TIMEOUT,
            variant: "info"
        });
    }
    /**
   * Fetches the current URL context, e.g. sandboxes or suborgs
   * @param {string} selectedImsOrg The current ims org.
   * subOrgs on login and we need to select the subOrg associated with the login APC.
   */ refreshContext(selectedImsOrg = this.state.selectedImsOrg) {
        if (!this.contextService) return;
        const { featureFlags: featureFlags, orgToSubOrgsMap: orgToSubOrgsMap, profile: profile, sandbox: sandbox, selectedSubOrg: selectedSubOrg, shellResponse: shellResponse, solutionConfig: solutionConfig, userSandboxes: userSandboxes } = this.state;
        this.contextFetchPromise = this.contextService.fetch({
            featureFlags: featureFlags,
            hasAEP: this.orgHasAEP(),
            orgToSubOrgsMap: orgToSubOrgsMap,
            profile: profile,
            sandbox: sandbox,
            selectedImsOrg: selectedImsOrg,
            selectedSubOrg: selectedSubOrg,
            shellResponse: shellResponse,
            solutionConfig: solutionConfig,
            userSandboxes: userSandboxes
        }).catch((error)=>{
            const nav = {
                visible: false
            }; // If the request failed for getting sandboxes or suborgs, show an error to the user
            // so they don't experience a weird UI. Additionally,
            // remove the side nav since the app won't load.
            this.contextService?.isSandbox && this.setState({
                sidebar: nav,
                sidenav: nav
            }, ()=>this.showApiFailureErrorScreen({
                    api: "Sandbox Data",
                    error: error,
                    errorMessageType: $fi30R.ErrorTypes.SANDBOX_FAIL,
                    failureMessage: "Sandbox data fetch failed."
                }));
            this.contextService?.isSubOrg && this.setState({
                sidebar: nav,
                sidenav: nav
            }, ()=>this.showApiFailureErrorScreen({
                    api: "Suborgs",
                    error: error,
                    errorMessageType: $fi30R.ErrorTypes.SUBORG_FAIL,
                    failureMessage: "Suborgs fetch failed."
                }));
        });
    }
    /**
   * Sets up the context service
   * @param {Object} solutionConfig The solution config of the application.
   */ /**
   * Gets user setting.
   * @param {Object} settings The setting to be fetched.
   * @param {SettingsLevel} level The level of setting to get.
   */ async getSetting(settings, level = $fLrqA.SettingsLevel.USER) {
        return this.settingsHandler({
            groupId: $apIgy.PREF_GROUPID,
            level: level,
            settings: settings
        }, "GET", true, $apIgy.PREF_APPID);
    }
    /**
   * Updates user setting.
   * @param {Object} settings The setting to be updated.
   * @param {SettingsLevel} level The level of setting to set.
   */ async setSetting(settings, level = $fLrqA.SettingsLevel.USER) {
        return this.settingsHandler({
            groupId: $apIgy.PREF_GROUPID,
            level: level,
            settings: settings
        }, "POST", true, $apIgy.PREF_APPID);
    }
    /**
   * Read/Upsert/Delete settings.
   * @param {Object} data Required: JSONObject contaning requested groupId,
   * settings, and corresponding settings level(optional).
   * GET ex- {groupId: 'group1', level: SettingsLevel.USER,
   * settings: {key1: default value to fallback}}.
   * POST ex- {groupId: 'group1', settings: {key1: value1}}.
   * @param {string} method Required: Method Type: GET/POST/DELETE.
   * @param {Object} isUnifiedShell Optional: To be set to true
   * by unified shell apps to consume Unified Shell Application space.
   * @param {Object} appId - Optional: Used by unifiedShell apps to
   * consume settings from different app space overriding unified shell app space.
   * ex- settingsHandler(data, 'GET', false, 'not-unifiedshell-appId')
   * @param {boolean} enableSandboxForDifferentAppSpace - Optional: Used by unifiedShell apps that
   * consume settings from Unified Shell Application space or
   * different app space overriding unified shell app space to enable sandbox default: false.
   * ex- settingsHandler(data, 'GET', false, 'not-unifiedshell-appId', true)
   *
   * @returns {Promise} - Settings Response.
   */ async settingsHandler(data, method, isUnifiedShell, appId, enableSandboxForDifferentAppSpace) {
        const { accessToken: accessToken = this.state.auth.fetchAccessToken(), solutionConfig: solutionConfig, selectedImsOrg: selectedImsOrg, sandbox: sandbox } = this.state;
        const environment = this.config.serviceEnvironment;
        const { clientId: clientId } = this.bootstrap;
        const selectedAppId = appId || isUnifiedShell && $dDEjQ.UNIFIED_SHELL_APPID || // pick solutionConfig.settingsAppId if present rather than solutionConfig.appId
        solutionConfig.settingsAppId || solutionConfig.appId;
        const settingsPackageLoadTimer = this.metrics.start("SettingsLoadJS");
        const SettingsService = await Promise.resolve().then(function() {
            return (parcelRequire("lqH9o"));
        }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res));
        settingsPackageLoadTimer.time("done", `Core: Settings Request for appId: ${selectedAppId} and orgId: ${selectedImsOrg}`);
        SettingsService.configure({
            env: environment,
            imsInfo: {
                accessToken: accessToken,
                clientId: clientId
            }
        });
        let selectedSandbox = undefined;
        if (sandbox && sandbox.selected && !sandbox.selected.isDefault && (!(appId || isUnifiedShell && $dDEjQ.UNIFIED_SHELL_APPID) || enableSandboxForDifferentAppSpace)) selectedSandbox = sandbox.selected.name;
        return SettingsService.settingsHandler({
            appId: selectedAppId,
            data: data,
            imsOrgId: selectedImsOrg,
            method: method,
            sandbox: selectedSandbox
        });
    }
    /**
   * Process functionality that requires settings data to be available.
   */ async processSettings() {
        // A unique visitor will NOT have seen, submitted, or dismissed user consent
        const { userConsent: userConsent } = this.state.settings || {};
        this.firstTimeUser = !userConsent || JSON.stringify(userConsent) === "{}";
        this.lastRecents = this.state.settings?.lastRecents || {}; // UserConsent requires data from settings so we wait until the
        // settings data is in state to trigger the consent dialog
        this.showUserConsent(); // Roles Modal requires data from settings to determine whether or not to show
        this.showRolesModalInvite(); // Process theme related data now that settings is available.
        this.userThemeHandler(); // Process sandbox recents data now that settings is available.
        this.userRecentSandboxesHandler(); // Process the side nav state.
        this.getSideNavState(); // Process user roles for gainsight
        this.handleGainsightRoles();
    }
    /**
   * Handles shell theme on load and on toggle by user.
   * @param {string} theme Optional, theme string indicating new spectrum theme
   * @param {boolean} onToggle The user is toggling the theme
   */ onCustomTokenChange(appProfile, appToken) {
        const { sandbox: sandbox = {} } = this.state.solutionConfig || {};
        const { ims: ims = {} } = sandbox; // If the client_id is the same as the customIms version, it should be set
        // in state so that the application can use it.
        if ((0, $3Zpnv.isCustomTokenValid)(ims, appToken)) this.setState({
            appProfile: appProfile,
            appToken: appToken
        });
    }
    renderNoAccess() {
        const { defaultComponent: defaultComponent, hasAccountClusterData: hasAccountClusterData, locale: locale, profile: profile, userAccounts: userAccounts } = this.state;
        if (!hasAccountClusterData) return defaultComponent;
        const account = userAccounts.find(({ userId: userId, userType: userType })=>userId === profile.userId && userType !== $fi30R.AuthType.TYPE2E);
        const hasOtherAccounts = account && userAccounts.length > 1;
        return /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$_react.default.Suspense, {
            fallback: defaultComponent
        }, /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$ShellNoAccess, {
            hasOtherAccounts: !!hasOtherAccounts,
            locale: locale
        }));
    }
    renderDebugTool() {
        const { accessOverridesEnabled: accessOverridesEnabled, accessToken: accessToken, auth: auth, debug: debug, defaultComponent: defaultComponent, featureFlags: featureFlags, locale: locale, orgsMap: orgsMap, profile: profile, sandbox: { selected: selected }, selectedImsOrg: selectedImsOrg, solutionConfig: { fiServiceCode: fiServiceCode } } = this.state;
        const hashedAuthId = auth && auth.getHashedAuthId();
        return !debug ? null : /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$_react.default.Suspense, {
            fallback: defaultComponent
        }, /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$DebugView, {
            accessOverridesEnabled: accessOverridesEnabled,
            close: ()=>this.toggleDebugModal(false),
            featureFlags: featureFlags,
            fiServiceCode: fiServiceCode,
            getFlagService: this.services?.getFlagService,
            hashedAuthId: hashedAuthId,
            internal: this.internal,
            locale: locale,
            onImsOrgChange: this.updateUrlOnOrgChange,
            onLanguageChange: this.onLanguageChange,
            orgRegions: this.orgRegions,
            orgsMap: orgsMap,
            profile: profile,
            selectedImsOrg: selectedImsOrg,
            selectedSandbox: selected,
            serviceCodes: this.userServiceCodes,
            serviceEnvironment: this.config.serviceEnvironment,
            settingsService: this.settingsRef,
            showToast: this.showToast,
            toggleAccessOverrides: this.toggleAccessOverrides,
            userFulfillableItems: this.userFulfillableItems,
            userToken: accessToken
        }));
    }
    async renderComponentModal({ component: component, data: data }, closeCallback) {
        this.modalContainer = this.modalContainer || (await Promise.resolve().then(function() {
            return (parcelRequire("3qlqs"));
        }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res))).default;
        this.ComponentModalComp = this.ComponentModalComp || (await Promise.resolve().then(function() {
            return (parcelRequire("l9FnH"));
        }).then((res)=>$41d79b167f2f22c7$var$_interopRequireWildcard(res))).default;
        const appConfig = this.props.listedApps.find((config)=>config.appId === component);
        const params = {};
        if (!appConfig) {
            this.metrics.error(`Invalid app config for ${component}`);
            return;
        } // If the main application has specified a component path for the component
        // to load at in the modal, use it by setting it in the params, which is
        // added to the end of URL in Sandbox.
        if (data?.componentPath) params[0] = data?.componentPath;
        this.componentModalCloseCallback = closeCallback;
        this.componentModal = this.modalContainer.show(/*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$_context.default.Provider, {
            value: this.getComponentContext()
        }, /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement(this.ComponentModalComp, {
            bootstrapData: data,
            config: appConfig,
            locale: this.state.locale,
            params: params,
            path: "/"
        })));
    }
    removeComponentModal(data) {
        this.componentModal && this.modalContainer.hide(this.componentModal);
        this.componentModalCloseCallback && this.componentModalCloseCallback(data);
        this.componentModal = null;
        this.componentModalCloseCallback = null;
    }
    /**
   * Updates state upon submission of user consent. This will also hide the
   * modal as this is the only callback called when submission is completed.
   * @param {Record<string, number>} permissionsObj Map of permissions to value
   * @param {Record<string, boolean | string>[]} settingsPermissions Array of
   *   permissions which is set in settings.
   * @param {boolean} success If the consent submission was successful.
   */ render() {
        const { appContainer: appContainer, accessOverridesEnabled: accessOverridesEnabled, accessToken: accessToken, backgroundReady: backgroundReady, basePath: basePath, coachMark: coachMark, afterPrintHandler: afterPrintHandler, beforePrintHandler: beforePrintHandler, activeFeatureFlags: activeFeatureFlags, customEnvLabel: customEnvLabel, customHeroClick: customHeroClick, customButtons: customButtons, customSearch: customSearch, defaultComponent: defaultComponent, digitalData: digitalData, environment: environment, error: error, featureFlags: featureFlags, feedback: feedback, feedbackConfig: feedbackConfig, globalDialogOpen: globalDialogOpen, hasAccountClusterData: hasAccountClusterData, helpCenter: helpCenter, hero: hero, initialAppLoaded: initialAppLoaded, imsOrgs: imsOrgs, locale: locale, modal: modal, onCustomButtonClick: onCustomButtonClick, orgToSubOrgsMap: orgToSubOrgsMap, profile: profile, pulseLoaded: pulseLoaded, recentSandboxes: recentSandboxes, releaseType: releaseType, sandbox: sandbox, selectedImsOrg: selectedImsOrg, selectedImsOrgName: selectedImsOrgName, selectedSubOrg: selectedSubOrg, settings: settings, settingsResponse: settingsResponse, shellResponse: shellResponse, showLanguagePicker: showLanguagePicker, showNetworkDisconnected: showNetworkDisconnected, showNoAccessShell: showNoAccessShell, sidebar: sidebar, sidenav: sidenav, sideNavOpen: sideNavOpen, sideNavOpenByHover: sideNavOpenByHover, solutionConfig: solutionConfig, solutionLoaded: solutionLoaded, theme: userTheme, timelineResponse: timelineResponse, userAvatar: userAvatar, userOrgPreferences: userOrgPreferences, workHubResponse: workHubResponse, workspaces: workspaces } = this.state;
        let content = this.props.children;
        showNoAccessShell && (content = this.renderNoAccess());
        error && (content = /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$ErrorView, {
            type: error
        })); // This does the equivalent of a lodash groupBy(customButtons, 'scope');
        const scopedCustomButtons = (customButtons || []).reduce((r, v, i, a, k = v["scope"])=>((r[k] || (r[k] = [])).push(v), r), {});
        const globalSearchConfig = {
            accessToken: accessToken,
            compact: solutionConfig?.unifiedSearch?.compact,
            enabled: this.isGlobalSearchEnabled(),
            internal: this.internal,
            parent: solutionConfig?.parent,
            recents: {
                getRecentsData: ()=>this.state.recentsData,
                list: ()=>this.initRecents(),
                loadMore: ()=>this.loadMoreRecents()
            },
            selectedImsOrg: selectedImsOrg,
            selectedOrgName: selectedImsOrgName
        }; // HelpCenter restricts some things to only supported user roles
        // But we don't need to update state or rerender Core for this value
        // So we just get it and send it to the Shell/HelpCenter
        const isSupportedUser = (0, $2GWWF.hasValidRole)([
            "SUPPORT_ADMIN"
        ], selectedImsOrg, profile?.roles || []);
        const sideNavEnabled = this.isSideNavEnabled() && sidenav?.visible !== false && sidebar?.visible !== false;
        const theme = solutionConfig?.theme || userTheme;
        return /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($jxYT9.Provider, {
            colorScheme: theme ? theme.replace(/est$/, "") : "light",
            locale: locale,
            theme: $9QLmC.theme
        }, this.renderDebugTool(), /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$_context.default.Provider, {
            value: this.getComponentContext()
        }, /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$_Shell.default, {
            accessOverridesEnabled: accessOverridesEnabled,
            accessToken: accessToken,
            afterPrintHandler: afterPrintHandler,
            agreements: this.agreements,
            appContainer: appContainer,
            appId: solutionConfig.appId,
            appRoot: solutionConfig.appRoot,
            appTheme: solutionConfig.theme,
            authId: profile?.authId || profile?.userId,
            backgroundReady: backgroundReady,
            basePath: basePath,
            beforePrintHandler: beforePrintHandler,
            clientId: this.config.ims.client_id,
            closeLanguagePicker: (cancelled)=>{
                cancelled && this.metrics.analytics.trackEvent({
                    action: "cancel",
                    element: "cancel",
                    feature: "language_selector",
                    type: "button",
                    widget: {
                        name: "language interactions",
                        type: "button"
                    }
                });
                this.setState({
                    showLanguagePicker: false
                });
            },
            coachMark: coachMark,
            customButtons: scopedCustomButtons,
            customEnvLabel: customEnvLabel,
            customHeroClick: customHeroClick,
            customSearch: customSearch,
            defaultComponent: defaultComponent,
            digitalData: digitalData,
            disableShellFeedbackButton: solutionConfig.disableShellFeedbackButton,
            environment: environment,
            featureFlags: activeFeatureFlags || featureFlags,
            feedback: feedback,
            feedbackConfig: feedbackConfig,
            getCapabilityWithIconUrl: this.getCapabilityWithIconUrl,
            getComponentContext: this.getComponentContext,
            getLDFeatureFlags: this.getLDFeatureFlags,
            globalDialogOpen: globalDialogOpen,
            globalSearch: globalSearchConfig,
            hasAccountClusterData: hasAccountClusterData,
            hasAssistantPermission: this.hasAssistantPermission,
            helpCenter: {
                ...helpCenter,
                appConfiguration: solutionConfig.helpCenter,
                isSupportedUser: isSupportedUser
            },
            hero: hero,
            imsOrgs: imsOrgs,
            initialAppLoaded: initialAppLoaded,
            internal: this.internal,
            isImpersonating: this.isImpersonating,
            locale: locale,
            modal: modal,
            networkErrorProps: {
                onDismiss: ()=>this.setState({
                        showNetworkDisconnected: null
                    }),
                showNetworkDisconnected: showNetworkDisconnected
            },
            noAccess: showNoAccessShell,
            noSolution: !solutionConfig || !solutionConfig.path,
            onCustomButtonClick: onCustomButtonClick,
            onGlobalDialogOpen: (globalDialogOpen)=>this.setState({
                    globalDialogOpen: globalDialogOpen
                }),
            onImsOrgChange: this.updateUrlOnOrgChange,
            onLanguageChange: this.onLanguageChange,
            onSetUserTheme: this.userThemeHandler,
            onSignOut: this.onSignOut,
            orgToSubOrgsMap: orgToSubOrgsMap,
            parentId: solutionConfig.parent,
            profile: profile,
            pulse: {
                accessToken: accessToken,
                additionalCount: this.state.pulse.count,
                customButton: this.state.pulse.button,
                enabled: !!pulseLoaded && !!accessToken && Object.keys(shellResponse).length > 0,
                environment: this.config.serviceEnvironment,
                locale: locale,
                profile: profile,
                selectedImsOrg: selectedImsOrg,
                settingsResponse: settingsResponse,
                settingsService: this.settingsRef,
                shellResponse: shellResponse,
                timelineResponse: timelineResponse,
                userOrgPreferences: userOrgPreferences
            },
            recentSandboxes: recentSandboxes,
            releaseType: releaseType || solutionConfig.releaseType,
            sandbox: sandbox,
            selectedImsOrg: selectedImsOrg,
            selectedImsOrgName: selectedImsOrgName,
            selectedSubOrg: selectedSubOrg,
            selectedTenantId: $41d79b167f2f22c7$var$cleanTenant(this.orgTenantMap[selectedImsOrg]),
            serviceEnvironment: this.config.serviceEnvironment,
            settingsData: settings,
            settingsService: this.settingsRef,
            shellResponse: shellResponse,
            showDebugModal: ()=>this.toggleDebugModal(true),
            showLanguagePicker: showLanguagePicker,
            showToast: this.showToast,
            sideNav: {
                buttonEnabled: sideNavEnabled || this.state.customLeftNavClick,
                config: sidebar?.config?.menu || sidebar?.config?.workHubId ? sidebar?.config : sidenav?.config,
                enabled: sideNavEnabled,
                open: sideNavOpen,
                openByHover: sideNavOpenByHover,
                toggle: this.toggleSideNav
            },
            solutionLoaded: solutionLoaded,
            solutionParent: solutionConfig.parent,
            subOrgAccessOnlyOnCurrentOrg: orgToSubOrgsMap && solutionConfig.subOrgAccessOnlyOnCurrentOrg,
            theme: theme,
            toastPlacement: this.state.toastPlacement,
            translationService: this.translationService,
            userAvatar: userAvatar,
            userRecentSandboxesHandler: this.userRecentSandboxesHandler,
            workHubResponse: workHubResponse,
            workspaces: workspaces
        }, /*#__PURE__*/ $41d79b167f2f22c7$var$_react.default.createElement($41d79b167f2f22c7$var$_react.default.Fragment, null, content))), this.state.showRolesInvite && this.renderRolesInvite(), this.state.showRolesModal && this.renderRolesModal(), this.state.showUserConsent && this.renderUserConsentModal(), this.state.showTux && this.renderTuxSurvey(), this.state.historyDialogProps && this.renderHistoryDialog(), this.state.betaAgreementConfig?.id && this.renderBetaAgreement());
    }
}
$41d79b167f2f22c7$var$Core.defaultProps = {
    onLocale: $iNslS.NOOP,
    showSpinner: $iNslS.NOOP
};
var $41d79b167f2f22c7$var$_default = (0, $fKhPa.default)($41d79b167f2f22c7$var$Core);
module.exports.default = $41d79b167f2f22c7$var$_default;

});
parcelRegister("bMVp5", function(module, exports) {
"use strict";
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CustomRelease = module.exports.CustomLabelType = void 0;

var $4jIM2 = parcelRequire("4jIM2");
var $8950b48fb98e7b58$var$CustomLabelType;
(function(CustomLabelType) {
    /**
   * The default label type.
   */ CustomLabelType["ENVIRONMENT"] = "ENVIRONMENT";
    /**
   * Renders as a release badge. Can only render one badge and only for solutions in GA release.
   */ CustomLabelType["RELEASE"] = "RELEASE";
})($8950b48fb98e7b58$var$CustomLabelType = module.exports.CustomLabelType || (module.exports.CustomLabelType = {}));
var $8950b48fb98e7b58$var$CustomRelease;
(function(CustomRelease) {
    /**
   * "Trial" release badge. Can only be shown if your solution is already in GA.
   */ CustomRelease["TRIAL"] = "TRIAL";
})($8950b48fb98e7b58$var$CustomRelease = module.exports.CustomRelease || (module.exports.CustomRelease = {}));
const $8950b48fb98e7b58$var$topbar = (0, $4jIM2.connect)("topbar", [
    [
        "customEnvLabel"
    ],
    [
        "onHeroClick",
        true
    ],
    [
        "setCustomSearch",
        true
    ],
    [
        "setCoachMark",
        true
    ],
    [
        "setFeedbackButton",
        true
    ],
    [
        "solution"
    ],
    [
        "workspaces"
    ]
]);
module.exports.default = $8950b48fb98e7b58$var$topbar;

});

parcelRegister("dwEdq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "preload", {
    enumerable: true,
    get: function() {
        return $b5cK2.preload;
    }
});
module.exports.debounceRaF = void 0;

var $b5cK2 = parcelRequire("b5cK2");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * Debounces events.
 * @param fn Function to execute.
 * @returns Debouncing function.
 */ var $9d8d757f4b8c4548$var$debounceRaF = function(fn) {
    var timeout;
    return function() {
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (timeout) window.cancelAnimationFrame(timeout);
        timeout = window.requestAnimationFrame(function() {
            fn.apply(_this, args);
        });
    };
};
module.exports.debounceRaF = $9d8d757f4b8c4548$var$debounceRaF;

});
parcelRegister("b5cK2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.preload = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ var $811a0b8662e3f216$var$preload = function(doc, config) {
    var cdn = config.cdn || "";
    var scripts = config.scripts || {};
    var scriptsPath = config.scriptsPath || "/assets";
    function asset(href, resourceType) {
        config.preloaded = config.preloaded || {};
        if (!config.preloaded[href]) {
            var preloadLink = doc.createElement("link");
            preloadLink.rel = "preload";
            preloadLink.as = resourceType;
            preloadLink.href = href;
            preloadLink.crossOrigin = "anonymous";
            doc.head.appendChild(preloadLink);
            config.preloaded[href] = true;
        }
    }
    function script(name) {
        if (scripts[name]) {
            var scriptInfo = scripts[name];
            scriptInfo.hash && scriptInfo.hash.forEach(function(hash) {
                return hash && asset("".concat(cdn).concat(scriptsPath, "/").concat(name, ".").concat(hash, ".js"), "script");
            });
            scriptInfo.cssHash && scriptInfo.cssHash.forEach(function(hash) {
                return hash && asset("".concat(cdn).concat(scriptsPath, "/").concat(name, ".").concat(hash, ".css"), "style");
            });
        }
    }
    function onNeed(when) {
        for(var name in scripts){
            var scriptInfo = scripts[name];
            if (scriptInfo.when === when) script(name);
        }
    }
    return {
        asset: asset,
        onNeed: onNeed,
        script: script
    };
};
module.exports.preload = $811a0b8662e3f216$var$preload;

});


parcelRegister("etiLO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decompressString = module.exports.decodeBase64String = module.exports.parseIfJson = module.exports.checkForGZip = void 0;

var $37141d79b0df8fda$var$_metrics = $37141d79b0df8fda$var$_interopRequireDefault((parcelRequire("17AVh")));
function $37141d79b0df8fda$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $37141d79b0df8fda$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $37141d79b0df8fda$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $37141d79b0df8fda$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $37141d79b0df8fda$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/**
 * Checks for the gzip signature to ensure a string is compressed.
 */ const $37141d79b0df8fda$var$checkForGZip = (dataString)=>dataString.startsWith("\x1f\x8b");
/**
 * Checks for the valid JSON to prevent errors during parsing.
 */ module.exports.checkForGZip = $37141d79b0df8fda$var$checkForGZip;
const $37141d79b0df8fda$var$parseIfJson = (dataString)=>{
    // Invalid JSON will throw an error
    try {
        return JSON.parse(dataString);
    } catch (error) {
        return dataString;
    }
};
/**
 * Checks a data string from a product context for encoding by trying to decode it.
 */ module.exports.parseIfJson = $37141d79b0df8fda$var$parseIfJson;
const $37141d79b0df8fda$var$decodeBase64String = (dataString)=>{
    // Check if the data string is Base64 encoded
    try {
        return window.atob(dataString);
    } catch (error) {
        // If it is not Base64 encoded, an error will throw but we do nothing
        return undefined;
    }
};
/**
 * Helper function to decompress a gzipped data string.
 * Used for content hub fulfillable_data in IMS product context.
 * DecompressionStream steps attributed to GitHub user asidko - Alexander Sidko
 * https://gist.github.com/asidko/9c7064027039411a11323eaf7d8ea2a4
 * @param encodedString - A binary string (not base 64, must be decoded first)
 */ module.exports.decodeBase64String = $37141d79b0df8fda$var$decodeBase64String;

const $37141d79b0df8fda$var$decompressString = async (encodedString)=>{
    const decompressMetrics = $37141d79b0df8fda$var$_metrics.default.create("exc.core.utils.decompressString"); // Check to confirm it's a gzip compression
    const isGZip = $37141d79b0df8fda$var$checkForGZip(encodedString);
    if (!isGZip) {
        decompressMetrics.error("Core util decompressString - Data is not compressed with gzip.");
        return;
    }
    const bytes = Uint8Array.from(encodedString, (c)=>c.charCodeAt(0)); // Try to use DecompressionStream or fallback to pako
    try {
        const cs = new window.DecompressionStream("gzip");
        const writer = cs.writable.getWriter();
        writer.write(bytes);
        writer.close();
        const buffer = await new Response(cs.readable).arrayBuffer();
        return new TextDecoder().decode(buffer);
    } catch (e) {
        decompressMetrics.info("Core util decompressString - Error using DecompressionStream, falling back to pako.", {
            error: e
        });
    } // Not all browsers support DecompressionStream so we use pako as a fallback
    const pako = await Promise.resolve().then(function() {
        return (parcelRequire("iBbFh"));
    }).then((res)=>$37141d79b0df8fda$var$_interopRequireWildcard(res));
    return pako.inflate(encodedString, {
        to: "string"
    });
};
module.exports.decompressString = $37141d79b0df8fda$var$decompressString;

});
parcelRegister("iBbFh", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = $Ha5sG("1vCZj").then(()=>parcelRequire("crZr9"));

});


parcelRegister("1sIGS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * Some apps generate URLs that aren't technically spec compliant and when copied into things like Teams or Slack
 * get mangled since Teams and Slack encode problematic characters to make the urls spec compliant. The problem with this is
 * that when we recieve weirdly encoded URLs unexpected things can happen and apps lose metadata they were expecting.
 * It's particularly problematic in cases where we call discovery or need to pass the url to another service that
 * might then also need to encode or decode it. This function aims to resolve the issue with the '%23' or # instance
 * of this issue, but it theoretically could crop up with other percentage encoding reserved characters
 * like those listed here: https://developer.mozilla.org/en-US/docs/Glossary/percent-encoding
 * @param {ReactRouterHistory} routerHistory
 */ const $110b1292a92e76db$var$decodeUrl = (routerHistory)=>{
    const originalHash = window.location?.hash;
    if (originalHash) {
        const unencodedUrl = originalHash.replace("%23", "#");
        unencodedUrl !== originalHash && routerHistory.replace(unencodedUrl.slice(1));
    }
};
var $110b1292a92e76db$var$_default = $110b1292a92e76db$var$decodeUrl;
module.exports.default = $110b1292a92e76db$var$_default;

});

parcelRegister("gigHb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getBestSupportedLocale = module.exports.getLocaleRegion = module.exports.SUPPORTED_LOCALES = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $5bb5f31b44e2e0af$var$SUPPORTED_LOCALES = [
    "de-DE",
    "en-US",
    "es-ES",
    "fr-FR",
    "it-IT",
    "ja-JP",
    "ko-KR",
    "pt-BR",
    "zh-CN",
    "zh-TW"
];
/* eslint-disable sort-keys */ module.exports.SUPPORTED_LOCALES = $5bb5f31b44e2e0af$var$SUPPORTED_LOCALES;
const $5bb5f31b44e2e0af$var$LOCALE_MAPPING = {
    "en-US": [
        "en-AE",
        "en-GB",
        "en-HR",
        "en-KE",
        "en-IL",
        "en-MU",
        "en-NG",
        "en-TT",
        "en-US",
        "en-XM",
        "en-MO",
        "en-LK",
        "en-VN"
    ],
    "de-DE": [
        "de-DE"
    ],
    "es-ES": [
        "es-BO",
        "es-DO",
        "es-PA",
        "es-ES",
        "es-LA",
        "es-MX",
        "es-NA",
        "es-PY",
        "es-SV",
        "es-UY"
    ],
    "fr-FR": [
        "fr-CA",
        "fr-FR",
        "fr-MA",
        "fr-XM"
    ],
    "it-IT": [
        "it-IT"
    ],
    "ja-JP": [
        "ja-JP"
    ],
    "ko-KR": [
        "ko-KR"
    ],
    "pt-BR": [
        "pt-BR"
    ],
    "zh-CN": [
        "zh-CN",
        "zh-HANS",
        "zh-HANS-CN"
    ],
    "zh-TW": [
        "zh-TW",
        "zh-HANT",
        "zh-HANT-TW"
    ]
};
/* eslint-enable sort-keys */ /**
 * Takes a locale that's missing a region 'en' and does best guess 'en-US'
 * @param locale
 * @returns {string} Best Suitable Locale.
 */ const $5bb5f31b44e2e0af$var$getLocaleRegion = (locale)=>Object.keys($5bb5f31b44e2e0af$var$LOCALE_MAPPING).find((language)=>language.startsWith(locale)) || "en-US";
/**
 *
 * @param locale
 */ module.exports.getLocaleRegion = $5bb5f31b44e2e0af$var$getLocaleRegion;
const $5bb5f31b44e2e0af$var$getLocaleFromMapping = (locale)=>{
    const formattedLocale = locale.replace("_", "-");
    for(const language in $5bb5f31b44e2e0af$var$LOCALE_MAPPING){
        const prefix = formattedLocale.split("-")[0];
        const postfix = formattedLocale.split("-")[1] || "";
        if (!language.startsWith(prefix)) continue;
        if ($5bb5f31b44e2e0af$var$LOCALE_MAPPING[language].includes(`${prefix}-${postfix.toUpperCase()}`)) return language;
    }
    return locale;
};
/**
 * Get Best Locale Setting using User Preferences and Supported Locales.
 * @param {Array.<string>} preferredLanguages User's preferred languages.
 * @param {Array.<string>} supportedLanguages List of Supported Locales.
 * @returns {string} Best Suitable Locale.
 */ const $5bb5f31b44e2e0af$var$getBestSupportedLocale = (preferredLanguages, supportedLanguages)=>{
    preferredLanguages = (preferredLanguages || []).map($5bb5f31b44e2e0af$var$getLocaleFromMapping);
    const firstLocale = preferredLanguages && preferredLanguages.length > 0 ? preferredLanguages[0] : "en-US";
    const secondLocale = preferredLanguages && preferredLanguages.length > 1 ? preferredLanguages[1] : "en-US";
    const firstLocalePrefix = firstLocale.split("-")[0];
    const secondLocalePrefix = secondLocale.split("-")[0];
    let locale = supportedLanguages.find((lang)=>lang.toUpperCase() === firstLocale.toUpperCase());
    if (!locale && firstLocalePrefix !== secondLocalePrefix) locale = supportedLanguages.find((lang)=>lang.split("-")[0] === firstLocalePrefix);
    if (!locale) locale = supportedLanguages.find((lang)=>lang.toUpperCase() === secondLocale.toUpperCase()) || supportedLanguages.find((lang)=>lang.split("-")[0] === secondLocalePrefix);
    return locale || "en-US";
};
module.exports.getBestSupportedLocale = $5bb5f31b44e2e0af$var$getBestSupportedLocale;

});

parcelRegister("bToDy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getContextService = $8a87f12b981365f4$var$getContextService;

var $8a87f12b981365f4$var$_SandboxService = $8a87f12b981365f4$var$_interopRequireDefault((parcelRequire("dFPrO")));

var $8a87f12b981365f4$var$_SubOrgService = $8a87f12b981365f4$var$_interopRequireDefault((parcelRequire("9MQcQ")));
function $8a87f12b981365f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ function $8a87f12b981365f4$var$getContextService(solutionConfig, callback, settingsService) {
    const { urlContext: urlContext = {} } = solutionConfig;
    switch(urlContext.key){
        case "sandbox":
            return new $8a87f12b981365f4$var$_SandboxService.default(solutionConfig, callback, settingsService);
        case "subOrg":
            return new $8a87f12b981365f4$var$_SubOrgService.default(solutionConfig, callback, settingsService);
    }
}

});
parcelRegister("dFPrO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f47031895181528$var$_BaseService = $9f47031895181528$var$_interopRequireDefault((parcelRequire("6oJwF")));

var $afnQ2 = parcelRequire("afnQ2");

var $jVeiz = parcelRequire("jVeiz");

var $bzq4v = parcelRequire("bzq4v");

var $9f47031895181528$var$_metrics = $9f47031895181528$var$_interopRequireWildcard((parcelRequire("83dfQ")));

var $3Zpnv = parcelRequire("3Zpnv");

var $9f47031895181528$var$_UnifiedShellSessionService = $9f47031895181528$var$_interopRequireDefault((parcelRequire("d5KeZ")));

var $2qT0f = parcelRequire("2qT0f");
function $9f47031895181528$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $9f47031895181528$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $9f47031895181528$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9f47031895181528$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9f47031895181528$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9f47031895181528$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $9f47031895181528$var$SandboxService extends $9f47031895181528$var$_BaseService.default {
    constructor(solutionConfig, callback, settingsService = {}){
        super(solutionConfig, callback, "sname", "shellSandboxes", settingsService);
        $9f47031895181528$var$_defineProperty(this, "isSandbox", true);
        this.metrics = $9f47031895181528$var$_metrics.default.create("exc.core.SandboxService");
        this.solutionConfig = solutionConfig;
        this.hideFromUrl = solutionConfig.urlContext.incognito;
    }
    /**
   * Gets user sandboxes for the current IMS org from GraphQL.
   * @param {string} selectedImsOrg Current IMS Org
   * @returns {Promise<Sandbox[]>} Sandboxes array
   */ async gqlUserSandboxes(selectedImsOrg) {
        let variables;
        const env = this.auth.env; // Based on where AEP (serviceCode acp) was provisioned, we need to get the user sandboxes from
        // platform-stage when Shell is running on QA/Dev which are normally linked to platform-int.
        // The fulfillable data field provides the correct environment to the gql service.
        if (env === "dev" || env === "qa") {
            const { projectedProductContext: projectedProductContext } = await this.auth.fetchUserProfile();
            const { prodCtx: prodCtx } = projectedProductContext.find(({ prodCtx: ctx })=>ctx.serviceCode === "acp" && ctx.owningEntity === selectedImsOrg && ctx.fulfillable_data) || {};
            variables = prodCtx && {
                fulfillableData: JSON.parse(prodCtx.fulfillable_data)
            };
        } // TO DO: Remove fulfillableData
        return (0, $afnQ2.getUserSandboxes)(variables);
    }
    async fetch(state) {
        const { hasAEP: hasAEP, sandbox: sandbox, selectedImsOrg: selectedImsOrg, userSandboxes: excSettingsSandboxes } = state; // Don't attempt to fetch sandboxes if the org does not have AEP.
        if (!hasAEP) {
            this.set({
                newSandbox: {
                    sandboxes: [],
                    selected: null
                },
                oldSandbox: sandbox,
                replace: false,
                sandboxesAvailable: false
            });
            return {
                sandbox: null,
                sandboxes: []
            };
        }
        await super.fetch(state);
        const { urlContext: { optional: optional } } = this.solutionConfig;
        const userId = this.auth.getHashedUserId();
        const localSandboxes = await $9f47031895181528$var$_UnifiedShellSessionService.default.get(this.storageKey, userId, selectedImsOrg); // If this is a login, we should set the sandbox data from settings in local storage
        excSettingsSandboxes && !localSandboxes && $9f47031895181528$var$_UnifiedShellSessionService.default.update(this.storageKey, excSettingsSandboxes, userId);
        const settingsSandbox = excSettingsSandboxes && (excSettingsSandboxes[selectedImsOrg] || {}).lastSelectedSandbox;
        const selectedSandboxName = (0, $jVeiz.getValueFromPath)($bzq4v.history.location.pathname, this.urlKey) || localSandboxes?.lastSelectedSandbox || settingsSandbox; // Asynchronously update local storage with the most recently fetched Sandboxes
        // On the next refresh, the sandboxes will be up to date. selectedImsOrg passed here is only used
        // to generate fulfillableData. The selectedImsOrg passed to GQL is set in Core by the network configuration.
        const getSandboxes = ()=>this.gqlUserSandboxes(selectedImsOrg).then(({ userSandboxes: userSandboxes })=>{
                userSandboxes.forEach((sbox)=>sbox.imsOrg = selectedImsOrg);
                this.store({
                    sandboxes: userSandboxes
                }, selectedImsOrg);
                return userSandboxes;
            });
        let sandboxes;
        const errorHandler = (error)=>{
            this.set({
                error: error,
                newSandbox: {
                    sandboxes: [],
                    selected: null
                },
                oldSandbox: sandbox,
                sandboxesAvailable: false
            }); // Remove null palmSandbox entry from localStorage
            $9f47031895181528$var$_UnifiedShellSessionService.default.remove(this.storageKey, userId, selectedImsOrg); // Don't throw an error if Sandboxes are optional
            if (optional) return;
            const errorMessage = `User ${userId} doesn't have access to sandboxes in org ${selectedImsOrg}.`;
            this.metrics.info(errorMessage, {
                level: $9f47031895181528$var$_metrics.Level.WARN
            });
            throw new Error(errorMessage);
        };
        try {
            // Only fetch sandboxes from gql if they are not in local storage.
            sandboxes = await (0, $3Zpnv.staleWhileRevalidate)(getSandboxes, localSandboxes?.sandboxes);
        } catch (e) {
            return errorHandler(e);
        }
        const selectedSandbox = sandboxes.find(({ name: name })=>name === selectedSandboxName) || sandboxes.find((sb)=>sb.isDefault) || sandboxes[0];
        this.store({
            lastSelectedSandbox: selectedSandbox?.name,
            sandboxes: sandboxes
        }, selectedImsOrg);
        this.set({
            newSandbox: {
                sandboxes: sandboxes,
                selected: selectedSandbox
            },
            oldSandbox: sandbox
        });
        return {
            sandbox: selectedSandbox,
            sandboxes: sandboxes
        };
    }
    set({ error: error, newSandbox: newSandbox, oldSandbox: oldSandbox, replace: replace = true, sandboxesAvailable: sandboxesAvailable = true }) {
        const state = {
            sandbox: {
                ...oldSandbox,
                ...newSandbox
            },
            sandboxesAvailable: sandboxesAvailable
        };
        this.updateState(state, error);
        const { name: name } = newSandbox.selected || {};
        this.select(name);
        if (name !== (0, $jVeiz.getValueFromPath)($bzq4v.history.location.pathname, this.urlKey)) this.hideFromUrl || (0, $2qT0f.updateValueInPath)(this.urlKey, name, this.hasTenantInUrl, replace);
    }
    change(selectedImsOrg, selected, oldSandbox) {
        this.store({
            lastSelectedSandbox: selected.name
        }, selectedImsOrg);
        this.set({
            newSandbox: {
                selected: selected
            },
            oldSandbox: oldSandbox,
            replace: false
        });
    }
    async store(sandboxValues, selectedImsOrg) {
        await super.store(sandboxValues, selectedImsOrg); // Save lastSelectedSandbox into Exc Settings Service
        if (sandboxValues.lastSelectedSandbox) {
            const sandboxes = await $9f47031895181528$var$_UnifiedShellSessionService.default.get(this.storageKey, this.auth.getHashedUserId()) || {};
            const userSandboxes = {
                ...sandboxes,
                [selectedImsOrg]: {
                    lastSelectedSandbox: sandboxValues.lastSelectedSandbox
                }
            };
            this.settingsService.setSetting({
                userSandboxes: userSandboxes
            });
        }
    }
    onHistoryChange(location, state) {
        const { sandbox: sandbox, selectedImsOrg: selectedImsOrg } = state;
        const { sandboxes: sandboxes, selected: selected, enabled: enabled } = sandbox;
        const pathSandbox = (0, $jVeiz.getValueFromPath)(location.pathname, this.urlKey); // If the sandbox is manually changed in the URL, set the new sandbox.
        if (pathSandbox && pathSandbox !== (selected || {}).name) {
            const updatedSandbox = sandboxes.find((s)=>s.name === pathSandbox);
            updatedSandbox && this.change(selectedImsOrg, updatedSandbox, sandbox);
        } // If sandboxes are enabled and the link does not have it, add it.
        if (enabled && selected && !pathSandbox) this.hideFromUrl || (0, $2qT0f.updateValueInPath)(this.urlKey, selected.name, this.hasTenantInUrl, true);
    }
}
module.exports.default = $9f47031895181528$var$SandboxService;

});
parcelRegister("6oJwF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lRoWp = parcelRequire("lRoWp");

var $dDEjQ = parcelRequire("dDEjQ");

var $4a884c79bb2b8f0e$var$_UnifiedShellSessionService = $4a884c79bb2b8f0e$var$_interopRequireDefault((parcelRequire("d5KeZ")));
function $4a884c79bb2b8f0e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4a884c79bb2b8f0e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/* eslint-disable no-unused-vars */ class $4a884c79bb2b8f0e$var$BaseService {
    constructor(solutionConfig, callback, urlKey, storageKey, settingsService){
        $4a884c79bb2b8f0e$var$_defineProperty(this, "getUrlKey", ()=>{
            if (this.solutionConfig?.urlContext?.incognito) return undefined;
            return this.urlKey;
        });
        $4a884c79bb2b8f0e$var$_defineProperty(this, "getId", ()=>this.selectedId && `${this.urlKey}-${this.selectedId}`);
        this.contextConfig = solutionConfig.urlContext.config;
        this.hasTenantInUrl = !solutionConfig.hideTenant;
        this.initialized = false;
        this.serviceCode = solutionConfig.urlContext.config?.serviceCode || solutionConfig.serviceCode;
        this.storageKey = storageKey;
        this.updateState = callback;
        this.urlKey = urlKey;
        this.settingsService = settingsService;
    }
    /**
   * Initializes the service with values that won't change.
   */ async initialize() {
        const bootstrap = (0, $dDEjQ.getBootstrap)();
        bootstrap.authInformation || await bootstrap.getAuthInformation();
        this.auth = (0, $lRoWp.AuthInstance)();
        this.initialized = true;
    }
    /**
   * Get method to fetch refreshed value of current context from URL.
   * @param {Object} state - State values needed for fetching.
   */ async fetch(state) {
        this.initialized || await this.initialize();
    }
    /**
   * Returns the context parameter used in the URL.
   * @returns {string} The parameter in the URL, e.g. sname or so
   */ /**
   * Sets the current selected context
   * @param {string} selectedId
   */ select(selectedId) {
        this.selectedId = selectedId;
    }
    /**
   * Set method to set new value of current context.
   * @abstract
   * @param {Object|string} newValue - New context value.
   * @param {Object=} oldValue - If new value is an object, provide the old value so the two can be merged in the update.
   */ set(newValue, oldValue) {}
    /**
   * Stores url context values in local storage.
   * @param {Object|string} newValue - Value to be stored in local storage.
   * @param {string} selectedImsOrg - Org that the value should be stored under.
   */ async store(newValue, selectedImsOrg) {
        this.initialized || await this.initialize();
        $4a884c79bb2b8f0e$var$_UnifiedShellSessionService.default.update(this.storageKey, newValue, this.auth.getHashedUserId(), selectedImsOrg);
    }
    /**
   * Function to be called when context value is changed.
   * @abstract
   * @param {string} selectedImsOrg - Current ims org.
   * @param {string} newValue - New context value.
   * @param {Object=} oldValue - If new value is an object, provide the old value so the two can be merged in the update.
   */ change(selectedImsOrg, newValue, oldValue) {}
    /**
   * Function to be called when a history update is fired.
   * @abstract
   * @param {Object=} location - New location.
   * @param {Object} state - State values.
   */ onHistoryChange(location, state) {}
}
module.exports.default = $4a884c79bb2b8f0e$var$BaseService;

});
parcelRegister("d5KeZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $iJaYo = parcelRequire("iJaYo");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ class $987f9c6e6e516833$var$UnifiedShellSessionService {
    /**
   * Internal function to get unifiedShellSession value from local storage.
   * @async
   * @returns {Object} Returns value from local storage or an empty object.
   */ async _get() {
        return await $iJaYo.storage.local.get("unifiedShellSession") || {};
    }
    /**
   * Gets value from unifiedShellSession stored in localStorage.
   * If an imsOrg is supplied it assumes it follows the pattern {key: {imsOrg: value}}.
   * If no parameters are provided, returns the entire unifiedShellSession value.
   * @async
   * @param {string=} key Key to be queried.
   * @param {string=} imsOrg ImsOrg to be queried within object returned by key.
   * @param {string=} userId UserId if key is stored within a particular userId.
   * @returns Returns value from local storage and undefined if no value exists.
   */ async get(key, userId, imsOrg) {
        let localSession = await this._get();
        if (!key) return localSession;
        if (userId) localSession = localSession[userId] || {};
        if (!imsOrg) return localSession[key];
        return (localSession[key] || {})[imsOrg];
    }
    /**
   * Sets unifiedShellSession to localStorage.
   * @param {Object} session The full unifiedShellSession object.
   */ async set(session) {
        await $iJaYo.storage.local.set("unifiedShellSession", session);
    }
    /**
   * Updates key in unifiedShellSession with a provided value, optionally keyed by imsOrg.
   * @param {string} key Key to update in unifiedShellSession in local storage.
   * @param {*} value Value found in unifiedShellSession.
   * @param {string} userId UserId if key is stored within a particular userId.
   * @param {string} imsOrg If imsOrg is provided the updated value will be keyed first by key and then by imsOrg.
   * @param {boolean=} override If the new value should override the existing completely.
   */ async update(key, value, userId, imsOrg, override) {
        let session = await this._get();
        let localSession = session;
        let updatedSession;
        if (userId) localSession = session[userId] || {};
        const isObject = typeof value === "object" && !Array.isArray(value);
        const getValue = (prev)=>{
            if (override) return value;
            return isObject ? {
                ...prev,
                ...value
            } : value;
        };
        imsOrg && (updatedSession = {
            ...localSession,
            [key]: {
                ...localSession[key],
                [imsOrg]: getValue((localSession[key] || {})[imsOrg])
            }
        });
        imsOrg || (updatedSession = {
            ...localSession,
            [key]: getValue(localSession[key])
        });
        if (userId) session[userId] = updatedSession;
        else session = updatedSession;
        this.set(session);
    }
    /**
   * Removes key from unifiedShellSession.
   * @param {string} key Key to be removed from unifiedShellSession.
   * @param {string} userId UserId if key is stored within a particular userId.
   * @param {string} imsOrg If imsOrg is provided the value to delete will be keyed first by key and then by imsOrg.
   */ async remove(key, userId, imsOrg) {
        let localSession = await this._get();
        if (userId) {
            let userLocalSession = localSession[userId] || {};
            userLocalSession = this._remove(userLocalSession, key, imsOrg);
            localSession[userId] = userLocalSession;
        } else localSession = this._remove(localSession, key, imsOrg);
        this.set(localSession);
    }
    _remove(session, key, imsOrg) {
        if (imsOrg) delete (session[key] || {})[imsOrg];
        else delete session[key];
        return session;
    }
}
var $987f9c6e6e516833$var$_default = new $987f9c6e6e516833$var$UnifiedShellSessionService();
module.exports.default = $987f9c6e6e516833$var$_default;

});


parcelRegister("afnQ2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUserSandboxes = module.exports.getUserPermissions = module.exports.PERMISSIONS_QUERY = module.exports.SANDBOX_QUERY = void 0;

var $4ua75 = parcelRequire("4ua75");

var $apIgy = parcelRequire("apIgy");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $fd6d53183039d48d$var$SANDBOX_QUERY = `
  query getUserSandboxes($fulfillableData: FulfillableData) {
    userSandboxes(fulfillableData: $fulfillableData) {
      title
      region
      name
      state
      isDefault
      type
    }
  }
`;
module.exports.SANDBOX_QUERY = $fd6d53183039d48d$var$SANDBOX_QUERY;
const $fd6d53183039d48d$var$PERMISSIONS_QUERY = `
  query effectivePolicies {
    effectivePolicies {
      policies {
        name
        privileges
      }
    }
  }
`;
module.exports.PERMISSIONS_QUERY = $fd6d53183039d48d$var$PERMISSIONS_QUERY;
const $fd6d53183039d48d$var$getUserPermissions = ()=>(0, $apIgy.gqlQuery)($fd6d53183039d48d$var$PERMISSIONS_QUERY, undefined, {
        scope: $4ua75.FetchScope.SANDBOX
    });
module.exports.getUserPermissions = $fd6d53183039d48d$var$getUserPermissions;
const $fd6d53183039d48d$var$getUserSandboxes = (fulfillableData)=>(0, $apIgy.gqlQuery)($fd6d53183039d48d$var$SANDBOX_QUERY, fulfillableData || {});
module.exports.getUserSandboxes = $fd6d53183039d48d$var$getUserSandboxes;

});


parcelRegister("9MQcQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.getAllSubOrgsForApp = void 0;

var $720117d4f3908cd2$var$_BaseService = $720117d4f3908cd2$var$_interopRequireDefault((parcelRequire("6oJwF")));

var $jVeiz = parcelRequire("jVeiz");

var $720117d4f3908cd2$var$_stringHash = $720117d4f3908cd2$var$_interopRequireDefault((parcelRequire("h9eEw")));

var $bzq4v = parcelRequire("bzq4v");

var $720117d4f3908cd2$var$_metrics = $720117d4f3908cd2$var$_interopRequireDefault((parcelRequire("83dfQ")));

var $720117d4f3908cd2$var$_UnifiedShellSessionService = $720117d4f3908cd2$var$_interopRequireDefault((parcelRequire("d5KeZ")));

var $2qT0f = parcelRequire("2qT0f");
function $720117d4f3908cd2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $720117d4f3908cd2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $720117d4f3908cd2$var$compare = (a, b)=>a.name.localeCompare(b.name);
/**
 * Get the pathname of the suborg by key
 * @param {Object} selectedSubOrg Required: current selected sub org
 * @param {String} pathnameKey Required: the key to use to get the pathname from the suborg object
 *
 * @returns {String} Sub org pathname
 */ const $720117d4f3908cd2$var$getSubOrgPathname = (selectedSubOrg, pathnameKey)=>selectedSubOrg && selectedSubOrg[pathnameKey]?.split(" ").join("");
/**
 * Given a product context and the relevant url config, constructs the suborg
 * @param {Object} prodCtx Required: a product context object
 * @param {Object} contextConfig Required: the url config of the given app
 *
 * @returns {Object} The constructed suborg
 */ const $720117d4f3908cd2$var$getSubOrgFromProductContext = (prodCtx, contextConfig)=>{
    const { ident: ident, owningEntity: owningEntity } = prodCtx;
    const { id: id, name: name, orgIdName: orgIdName, preferred: preferred } = contextConfig;
    const subOrg = {
        id: ident,
        name: typeof name === "string" ? prodCtx[name] : name(prodCtx),
        orgIdName: typeof orgIdName === "function" ? orgIdName(prodCtx) : prodCtx[id],
        owningEntity: owningEntity,
        preferred: typeof preferred === "string" || !preferred ? prodCtx[preferred] : preferred(prodCtx)
    };
    subOrg.path = $720117d4f3908cd2$var$getSubOrgPathname(subOrg, contextConfig?.customPathKey || "orgIdName");
    return subOrg;
};
/**
 * Given an app url config, searches through all product contexts to find the suborgs for that app.
 * This function also finds the last used suborg for that app, if possible.
 * @param {Object} profile Required: the user profile object
 * @param {Object} appUrlConfig Required: the url config from the app configuration
 * @param {String} currentImsOrg Optional: the currectly active org
 * @param {Object} localSession Optional: the unified shell session data
 * @param {Object} lastSelectedSubOrgs Optional: an object containing the stored last used suborgs, if any
 *
 * @returns {Array} An alphabetical array of suborgs for the given app and org. If the last used suborg is
 * known it is noted with the prop `lastUsed`.
 */ const $720117d4f3908cd2$var$getAllSubOrgsForApp = (profile, appUrlConfig, currentImsOrg, localSession, lastSelectedSubOrgs)=>{
    const productContext = profile.projectedProductContext;
    const subOrgsForOrg = localSession?.[`shellSubOrgs-${appUrlConfig.serviceCode}`]?.[currentImsOrg] || {};
    const subOrgArray = [];
    const { id: id, serviceCode: serviceCode } = appUrlConfig;
    productContext.forEach(({ prodCtx: prodCtx })=>{
        const { owningEntity: owningEntity } = prodCtx;
        if (prodCtx[id] && prodCtx.serviceCode === serviceCode && (!currentImsOrg || owningEntity === currentImsOrg)) {
            const formattedSubOrg = $720117d4f3908cd2$var$getSubOrgFromProductContext(prodCtx, appUrlConfig);
            subOrgArray.find((subOrg)=>subOrg.id === formattedSubOrg.id) || subOrgArray.push(formattedSubOrg);
        }
    }); // If no suborgs, return
    if (subOrgArray.length === 0) return;
     // Add lastUsed
    const lastSelected = subOrgsForOrg.lastSelectedSubOrg || lastSelectedSubOrgs?.[currentImsOrg]?.[appUrlConfig.serviceCode];
    const isLastUsed = (orgName)=>subOrgArray.length === 1 || lastSelected === orgName;
    const subOrgs = subOrgArray.map((org)=>({
            ...org,
            lastUsed: isLastUsed(org.name)
        })); // Alphabetically sort
    return subOrgs.sort($720117d4f3908cd2$var$compare);
};
module.exports.getAllSubOrgsForApp = $720117d4f3908cd2$var$getAllSubOrgsForApp;
class $720117d4f3908cd2$var$SubOrgService extends $720117d4f3908cd2$var$_BaseService.default {
    constructor(solutionConfig, callback, settingsService){
        super(solutionConfig, callback, "so", `shellSubOrgs-${solutionConfig.urlContext.config.serviceCode}`, settingsService);
        $720117d4f3908cd2$var$_defineProperty(this, "isSubOrg", true);
        $720117d4f3908cd2$var$_defineProperty(this, "getSubOrgPathname", (selectedSubOrg)=>$720117d4f3908cd2$var$getSubOrgPathname(selectedSubOrg, this.pathnameKey));
        $720117d4f3908cd2$var$_defineProperty(this, "getSubOrgFromProductContext", (prodCtx)=>$720117d4f3908cd2$var$getSubOrgFromProductContext(prodCtx, this.contextConfig));
        $720117d4f3908cd2$var$_defineProperty(this, "getHashedUserId", (profile)=>{
            const userId = this.auth.getHashedUserId() || profile.userId && (0, $720117d4f3908cd2$var$_stringHash.default)(profile.userId).toString();
            userId || this.metrics.warn("No user id for fetching suborgs");
            return userId;
        });
        this.metrics = $720117d4f3908cd2$var$_metrics.default.create("exc.core.SubOrgService"); // Use either custom value from config or orgIdName in path.
        const { customPathKey: customPathKey } = this.contextConfig;
        this.pathnameKey = customPathKey || "orgIdName";
    }
    async fetch(state) {
        await super.fetch(state);
        if (!Object.keys(state.orgToSubOrgsMap).length) await this.getOrgsToSubOrgsMap(state.profile);
        const { profile: profile, selectedImsOrg: selectedImsOrg, shellResponse: shellResponse = {} } = state;
        const userId = this.getHashedUserId(profile);
        const { subOrgs: subOrgs, lastSelectedSubOrg: lastSelectedSubOrg } = await $720117d4f3908cd2$var$_UnifiedShellSessionService.default.get(this.storageKey, userId, selectedImsOrg) || {};
        let selectedSubOrg;
        if (subOrgs) {
            let pathSubOrg = (0, $jVeiz.getValueFromPath)($bzq4v.history.location.pathname, this.urlKey);
            pathSubOrg = pathSubOrg && subOrgs.find(({ path: path })=>path === pathSubOrg);
            if (pathSubOrg) selectedSubOrg = pathSubOrg;
            else {
                // Otherwise, select the last selected sub org from local storage, the default sub org, or the first in the list.
                selectedSubOrg = lastSelectedSubOrg && subOrgs.find((so)=>so.name === lastSelectedSubOrg);
                selectedSubOrg = selectedSubOrg || subOrgs.find((so)=>so.preferred) || subOrgs.sort($720117d4f3908cd2$var$compare)[0];
            }
        }
        if (selectedSubOrg && shellResponse.services) {
            const allApps = shellResponse.services.concat(shellResponse.solutions);
            const app = allApps.find((a)=>a.subOrgs?.some((subOrg)=>subOrg.name === selectedSubOrg.name));
            if (app && !app.subOrgs.find((subOrg)=>subOrg.name === selectedSubOrg.name).lastUsed) {
                const updatedSubOrgs = app.subOrgs.map((subOrg)=>({
                        ...subOrg,
                        lastUsed: subOrg.name === selectedSubOrg.name
                    }));
                let appType, key;
                if (shellResponse.services.some((a)=>a.appId === app.appId)) {
                    appType = shellResponse.services;
                    key = "services";
                } else {
                    appType = shellResponse.solutions;
                    key = "solutions";
                }
                const updatedApps = appType.map((s)=>s.appId === app.appId ? {
                        ...s,
                        subOrgs: updatedSubOrgs
                    } : s);
                const updatedShellResponse = {
                    ...shellResponse,
                    [key]: updatedApps
                };
                this.updateState({
                    shellResponse: updatedShellResponse
                });
            }
        }
        if (!selectedSubOrg) {
            this.metrics.warn("No selected sub org", {
                selectedImsOrg: selectedImsOrg,
                subOrgHashedUserId: userId
            });
            const orgAccountMap = await $720117d4f3908cd2$var$_UnifiedShellSessionService.default.get("shellOrgAccountMap") || {}; // If the IMS org of the suborg fetch is different from the account of the user, it might be a
            // type2e switch so we should not show the error page yet.
            if (!userId || userId === orgAccountMap[selectedImsOrg]) {
                this.set({
                    selectedImsOrg: selectedImsOrg,
                    selectedSubOrg: null
                });
                $720117d4f3908cd2$var$_UnifiedShellSessionService.default.remove(this.storageKey, userId, selectedImsOrg);
                const errorMessage = `User ${userId} doesn't have access to suborgs in org ${selectedImsOrg}.`;
                this.metrics.warn(errorMessage);
                throw new Error(errorMessage);
            }
        }
        this.store(selectedSubOrg, selectedImsOrg);
        this.set({
            selectedImsOrg: selectedImsOrg,
            selectedSubOrg: selectedSubOrg
        });
        return {
            selectedSubOrg: selectedSubOrg
        };
    }
    async getOrgsToSubOrgsMap(profile) {
        const session = await $720117d4f3908cd2$var$_UnifiedShellSessionService.default.get();
        const userId = this.getHashedUserId(profile);
        const localSession = session[userId] || {};
        const subOrgs = $720117d4f3908cd2$var$getAllSubOrgsForApp(profile, this.contextConfig, undefined, localSession, undefined);
        const orgToSubOrgsMap = {};
        subOrgs.forEach((suborg)=>{
            if (localSession[this.storageKey] && localSession[this.storageKey][suborg.owningEntity]) {
                // Add to storage entry unless it already exists
                localSession[this.storageKey][suborg.owningEntity].subOrgs.find((so)=>so.id === suborg.id) || localSession[this.storageKey][suborg.owningEntity].subOrgs.push(suborg); // Form orgs to subOrgs map
                if (!orgToSubOrgsMap[suborg.owningEntity]) orgToSubOrgsMap[suborg.owningEntity] = [
                    suborg
                ];
                else orgToSubOrgsMap[suborg.owningEntity].find((so)=>so.id === suborg.id) || orgToSubOrgsMap[suborg.owningEntity].push(suborg);
            } else {
                localSession[this.storageKey] = {
                    ...localSession[this.storageKey],
                    [suborg.owningEntity]: {
                        subOrgs: [
                            suborg
                        ]
                    }
                };
                orgToSubOrgsMap[suborg.owningEntity] = [
                    suborg
                ];
            }
        });
        this.updateState({
            orgToSubOrgsMap: orgToSubOrgsMap
        });
        session[userId] = localSession;
        return $720117d4f3908cd2$var$_UnifiedShellSessionService.default.set(session);
    }
    async store(selectedSubOrg, selectedImsOrg) {
        if (selectedSubOrg) {
            await super.store({
                lastSelectedSubOrg: selectedSubOrg.name
            }, selectedImsOrg);
            const settings = await this.settingsService?.getSetting({
                lastSelectedSubOrgs: null
            });
            const newOrgLastSelected = settings?.settings.lastSelectedSubOrgs?.[selectedImsOrg] ? {
                ...settings?.settings.lastSelectedSubOrgs[selectedImsOrg],
                [this.contextConfig.serviceCode]: selectedSubOrg.name
            } : {
                [this.contextConfig.serviceCode]: selectedSubOrg.name
            };
            this.settingsService?.setSetting({
                lastSelectedSubOrgs: {
                    ...settings?.settings.lastSelectedSubOrgs,
                    [selectedImsOrg]: newOrgLastSelected
                }
            });
        }
    }
    set({ selectedSubOrg: selectedSubOrg, selectedImsOrg: selectedImsOrg, setState: setState = true }) {
        let activeProductContext;
        const { customIdName: customIdName = "global_company_id" } = this.contextConfig;
        if (selectedSubOrg) {
            const { orgIdName: global_company_id, id: ident, owningEntity: owningEntity } = selectedSubOrg;
            activeProductContext = {
                [this.serviceCode]: {
                    [customIdName]: global_company_id,
                    ident: ident,
                    owningEntity: owningEntity,
                    serviceCode: this.serviceCode
                }
            };
        }
        const { orgIdName: orgIdName } = selectedSubOrg || {};
        this.select(orgIdName);
        setState && this.updateState({
            activeProductContext: activeProductContext,
            selectedImsOrg: selectedImsOrg,
            selectedSubOrg: selectedSubOrg
        });
        const { path: subOrgPathname } = selectedSubOrg || {};
        if (subOrgPathname && subOrgPathname !== (0, $jVeiz.getValueFromPath)($bzq4v.history.location.pathname, this.urlKey)) (0, $2qT0f.updateValueInPath)(this.urlKey, subOrgPathname, this.hasTenantInUrl);
        return {
            activeProductContext: activeProductContext
        };
    }
    change(selectedImsOrg, selectedSubOrg, setState = true) {
        this.store(selectedSubOrg, selectedImsOrg);
        return this.set({
            selectedImsOrg: selectedImsOrg,
            selectedSubOrg: selectedSubOrg,
            setState: setState
        });
    }
    onHistoryChange(location, state) {
        const { selectedSubOrg: selectedSubOrg, orgToSubOrgsMap: orgToSubOrgsMap, selectedImsOrg: selectedImsOrg } = state;
        const { path: subOrgPathname } = selectedSubOrg || {};
        const pathSubOrg = (0, $jVeiz.getValueFromPath)(location.pathname, this.urlKey); // If the suborg is manually changed in the URL, set the new suborg.
        if (pathSubOrg && subOrgPathname && pathSubOrg !== subOrgPathname) {
            const updatedSubOrg = (orgToSubOrgsMap[selectedImsOrg] || []).find(({ path: path })=>path === pathSubOrg);
            updatedSubOrg && this.change(selectedImsOrg, updatedSubOrg);
        }
        if (subOrgPathname && !(0, $jVeiz.getValueFromPath)(location.pathname, this.urlKey)) (0, $2qT0f.updateValueInPath)(this.urlKey, subOrgPathname, this.hasTenantInUrl);
    }
}
module.exports.default = $720117d4f3908cd2$var$SubOrgService;

});


parcelRegister("a2nzs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getHeroConfig = module.exports.HERO_CONFIGS = module.exports.COMPOSED_APP_CONFIGS = void 0;

var $74ec5ff4e5ccf685$var$_AdobeExperienceCloud = $74ec5ff4e5ccf685$var$_interopRequireDefault((parcelRequire("0fGRG")));

var $74ec5ff4e5ccf685$var$_AdobeExperiencePlatform = $74ec5ff4e5ccf685$var$_interopRequireDefault((parcelRequire("5LImQ")));

var $74ec5ff4e5ccf685$var$_AdobeExperienceSubCloud = $74ec5ff4e5ccf685$var$_interopRequireDefault((parcelRequire("6j8vY")));

var $dDEjQ = parcelRequire("dDEjQ");

var $jVeiz = parcelRequire("jVeiz");

var $74ec5ff4e5ccf685$var$_HeroIcons = $74ec5ff4e5ccf685$var$_interopRequireDefault((parcelRequire("ggZCg")));

var $ctGaZ = parcelRequire("ctGaZ");

var $74ec5ff4e5ccf685$var$_WorkfrontHero = $74ec5ff4e5ccf685$var$_interopRequireDefault((parcelRequire("cP3n8")));
function $74ec5ff4e5ccf685$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * This is something of a stop gap until work hub takes over more configuration work.
 * There exist apps that either have internal integrations, like Analytics,
 * or composed apps that require the same branding to be used for anything opened
 * inside of their context. To avoid needing to add explicit overrides for every
 * edge case or copying multiple things between solution configs and app assembly
 * we're just putting the branding for those cases here for now.
 */ const $74ec5ff4e5ccf685$var$COMPOSED_APP_CONFIGS = [
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceCloud`,
            path: "/journey-optimizer/home",
            shortTitle: "Journey Optimizer",
            title: "Adobe Journey Optimizer"
        },
        id: "journey-optimizer",
        pathMatchFragment: [
            "/cjm",
            "/journey-optimizer"
        ]
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceCloud`,
            path: "/data-collection",
            shortTitle: "Data Collection",
            title: "Adobe Experience Platform Data Collection"
        },
        id: "data-collection",
        pathMatchFragment: "/data-collection"
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceSubCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceSubCloud`,
            path: "/primetime/home",
            shortTitle: "Primetime",
            title: "Adobe Primetime"
        },
        id: "primetime",
        pathMatchFragment: "/primetime/home"
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceSubCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceSubCloud`,
            path: "/primetime/aiq",
            shortTitle: "Primetime Account IQ",
            title: "Adobe Primetime Account IQ"
        },
        id: "primetime",
        pathMatchFragment: "/primetime/aiq"
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceSubCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceSubCloud`,
            path: "/primetime/dai",
            shortTitle: "Adobe Primetime Ad Insertion",
            title: "Adobe Primetime Ad Insertion"
        },
        id: "primetime",
        pathMatchFragment: "/primetime/dai"
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceSubCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceSubCloud`,
            path: "/pass/authentication",
            shortTitle: "Pass Authentication",
            title: "Adobe Pass Authentication"
        },
        id: "adobepassunifiedshellconsoleclient",
        pathMatchFragment: "/pass/authentication"
    },
    // like data governance that need Analytics branding applied to them
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceSubCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceSubCloud`,
            path: "/analytics/spa/index.html",
            shortTitle: "Analytics",
            title: "Adobe Analytics"
        },
        id: "analytics",
        pathMatchFragment: "/analytics"
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceSubCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceSubCloud`,
            path: "/platform/analytics",
            shortTitle: "Customer Journey Analytics",
            title: "Customer Journey Analytics"
        },
        id: "platformAnalytics",
        pathMatchFragment: "/platform/analytics"
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperiencePlatform.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperiencePlatform`,
            path: "/platform",
            shortTitle: "Experience Platform",
            title: "Adobe Experience Platform"
        },
        id: "experiencePlatformUI",
        pathMatchFragment: "/platform",
        pathMatchIgnore: [
            "/platform/analytics",
            "/journey-optimizer-b2b/platform",
            "/platform/agora"
        ]
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceCloud`,
            path: "/platform/agora",
            shortTitle: "RTCDP Collaboration",
            title: "Real-Time CDP Collaboration"
        },
        id: "agoraUI",
        pathMatchFragment: "/platform/agora",
        pathMatchIgnore: [
            "/platform/analytics",
            "/journey-optimizer-b2b/platform"
        ]
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceSubCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceSubCloud`,
            path: "/acc",
            shortTitle: "Campaign",
            title: "Adobe Campaign"
        },
        id: "accwebui",
        pathMatchFragment: "/acc"
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceSubCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceSubCloud`,
            path: "/marketo",
            shortTitle: "Marketo Engage",
            title: "Adobe Marketo Engage"
        },
        id: "marketo",
        pathMatchFragment: "/marketo"
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceCloud`,
            path: "/mix-modeler",
            shortTitle: "Mix Modeler",
            title: "Adobe Mix Modeler"
        },
        id: "adobemixmodeler",
        pathMatchFragment: "/mix-modeler"
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceSubCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceSubCloud`,
            path: "/journey-optimizer-b2b/home",
            releaseType: $ctGaZ.RELEASE_TYPE.BETA,
            shortTitle: "Journey Optimizer B2B Edition",
            title: "Adobe Journey Optimizer B2B Edition"
        },
        id: "sapphireHome",
        pathMatchFragment: "/journey-optimizer-b2b"
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceCloud`,
            path: "/advertising/ssc",
            shortTitle: "Search, Social, & Commerce",
            title: "Adobe Advertising Search, Social, & Commerce"
        },
        id: "advertising-ssc",
        pathMatchFragment: "/advertising/ssc"
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceSubCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceSubCloud`,
            path: "/target",
            shortTitle: "Target",
            title: "Adobe Target"
        },
        id: "target",
        pathMatchFragment: "/target"
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceCloud`,
            path: "/orion/home",
            releaseType: $ctGaZ.RELEASE_TYPE.ALPHA,
            shortTitle: "Project Orion",
            title: "Project Orion"
        },
        id: "orion",
        pathMatchFragment: [
            "/orion"
        ]
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceSubCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceSubCloud`,
            path: "/assets/contenthub",
            shortTitle: "Experience Manager Assets Content Hub",
            title: "Adobe Experience Manager Assets Content Hub"
        },
        id: "ContentHub",
        pathMatchFragment: [
            "/assets/contenthub"
        ]
    },
    {
        heroConfig: {
            favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceSubCloud.default,
            icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceSubCloud`,
            path: "/genstudio",
            releaseType: $ctGaZ.RELEASE_TYPE.BETA,
            shortTitle: "GenStudio",
            title: "Adobe GenStudio"
        },
        id: "genstudio",
        pathMatchFragment: [
            "/genstudio"
        ]
    }
];
/**
 * These serve as the default branding of apps based off of their app assembly type.
 * These assumptions do not hold true for composed apps or some one off integrations.
 */ module.exports.COMPOSED_APP_CONFIGS = $74ec5ff4e5ccf685$var$COMPOSED_APP_CONFIGS;
const $74ec5ff4e5ccf685$var$HERO_CONFIGS = {
    application: {
        favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceSubCloud.default,
        icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceSubCloud`,
        shortTitle: "Adobe Experience Cloud"
    },
    cloud: {
        favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceCloud.default,
        icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceCloud`,
        path: "/home",
        shortTitle: "Adobe Experience Cloud"
    },
    fusion: {
        favicon: $74ec5ff4e5ccf685$var$_WorkfrontHero.default,
        icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#WorkfrontHero`,
        shortTitle: "Workfront Fusion"
    },
    platform: {
        favicon: $74ec5ff4e5ccf685$var$_AdobeExperiencePlatform.default,
        icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperiencePlatform`,
        shortTitle: "Adobe Experience Platform"
    },
    service: {
        favicon: $74ec5ff4e5ccf685$var$_AdobeExperienceCloud.default,
        icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#AdobeExperienceCloud`,
        shortTitle: "Adobe Experience Cloud"
    },
    workfront: {
        favicon: $74ec5ff4e5ccf685$var$_WorkfrontHero.default,
        icon: `${$74ec5ff4e5ccf685$var$_HeroIcons.default}#WorkfrontHero`,
        shortTitle: "Workfront"
    }
};
module.exports.HERO_CONFIGS = $74ec5ff4e5ccf685$var$HERO_CONFIGS;
const $74ec5ff4e5ccf685$var$getHeroConfig = (shellResponse, solutionConfig, stateHero)=>{
    const bootstrap = (0, $dDEjQ.getBootstrap)(); // Grab the current solution or service in order to get the proper name string
    const allSolutionsAndServices = (shellResponse.solutions || []).concat(shellResponse.services || []);
    const hashPath = (0, $jVeiz.getPathWithoutTenant)((0, $jVeiz.hashToPath)());
    const composedAppConfig = $74ec5ff4e5ccf685$var$COMPOSED_APP_CONFIGS.find(({ pathMatchFragment: pathMatchFragment, pathMatchIgnore: pathMatchIgnore })=>{
        const pathstoMatch = [].concat(pathMatchFragment);
        const matched = pathstoMatch.find((path)=>new RegExp(`^${path}(/|$)`).test(hashPath));
        return matched && (!pathMatchIgnore || !pathMatchIgnore.some((path)=>hashPath.startsWith(path)));
    });
    const current = allSolutionsAndServices.find((solServ)=>{
        const apps = Array.isArray(solServ.appId) ? solServ.appId : [
            solServ.appId
        ];
        const appId = hashPath.includes("/journey-optimizer/") ? "cjm-home" : solutionConfig.appId;
        return apps.indexOf(appId) > -1;
    });
    let newHero = $74ec5ff4e5ccf685$var$HERO_CONFIGS.cloud;
    const type = current && current.adobeBrandType || "cloud";
    const { longName: longName, name: name, releaseType: releaseType } = current || {};
    if (type !== "cloud" || longName === "Admin Tool") {
        // State hero is used here to push runtime changes forward in case getHeroConfig
        // is called in such a way that App Assembly load or a Solution config change occurs
        // after a meaningful runtime change has been made.
        let runtimeOverrides = {};
        if (stateHero) {
            runtimeOverrides = {
                path: stateHero.path
            };
            if (solutionConfig?.sandbox?.thirdParty) runtimeOverrides = stateHero;
        }
        const baseHeroConfig = $74ec5ff4e5ccf685$var$HERO_CONFIGS[type]; // Precedence: Runtime set hero values, solution set hero values, default type values.
        newHero = {
            ...baseHeroConfig,
            // shortTitle / name is the only required label for a solution, so all other labels fallback to it
            // or are generated from it.
            releaseType: bootstrap.isDemoMode() ? $ctGaZ.RELEASE_TYPE.GA : releaseType || baseHeroConfig.releaseType,
            shortTitle: name || baseHeroConfig.shortTitle,
            title: longName || name || baseHeroConfig.title,
            ...runtimeOverrides
        };
    } // Composed apps should override everything else (currently) with shared branding / behavior
    if (composedAppConfig) newHero = {
        composed: true,
        ...newHero,
        ...composedAppConfig.heroConfig
    };
     // Find and set the favicon to the new hero icon
    document.querySelectorAll("#favicon").forEach((link)=>{
        link.href = newHero.favicon;
    });
    return newHero;
};
module.exports.getHeroConfig = $74ec5ff4e5ccf685$var$getHeroConfig;

});
parcelRegister("0fGRG", function(module, exports) {
module.exports = new URL("AdobeExperienceCloud.bfdb429e.svg", import.meta.url).toString();

});

parcelRegister("5LImQ", function(module, exports) {
module.exports = new URL("AdobeExperiencePlatform.6e79ef30.svg", import.meta.url).toString();

});

parcelRegister("6j8vY", function(module, exports) {
module.exports = new URL("AdobeExperienceSubCloud.6e2f998e.svg", import.meta.url).toString();

});

parcelRegister("ggZCg", function(module, exports) {
module.exports = new URL("HeroIcons.6620f5dc.svg", import.meta.url).toString();

});

parcelRegister("cP3n8", function(module, exports) {
module.exports = new URL("WorkfrontHero.7efae3c8.svg", import.meta.url).toString();

});


parcelRegister("2GWWF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasPermission = module.exports.hasValidVisibleName = module.exports.hasValidSubService = module.exports.hasValidRole = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * Validates that some or all (depending on `codeLogicOp`) of the service codes
 * are enabled on the user's profile.
 * @param {Object} access - Object containing access properties.
 * @param {Object} services - The services used for checking permissions.
 * @param {string[]} [services.serviceCodes] - Service codes for the user.
 * @returns {boolean} - Valid or not.
 */ const $4bff461566f271e1$var$hasValidCodes = (access, { serviceCodes: serviceCodes = [] })=>{
    const { code: code = [], codeLogicOp: codeLogicOp = "OR" } = access;
    return codeLogicOp === "OR" ? code.some((accessCode)=>serviceCodes.indexOf(accessCode) > -1) : code.every((accessCode)=>serviceCodes.indexOf(accessCode) > -1);
};
/**
 * Validates that the feature flag is enabled.
 * @param {Object} access - Object containing access properties.
 * @param {Object | Array} [access.flag] - Feature flag or array of feature flags to validate.
 * @param {Object} services - The services used for checking permissions.
 * @param {Object} [services.featureFlags] - All feature flags for user.
 * @returns {boolean} - Valid or not.
 */ const $4bff461566f271e1$var$hasValidFeatureFlag = (access, { featureFlags: featureFlags = {} })=>{
    const { flag: flag = "", flagLogicOp: flagLogicOp = "OR" } = access;
    const flags = Array.isArray(flag) ? flag : [
        flag
    ];
    return flagLogicOp === "OR" ? flags.some((f)=>featureFlags?.[f] === "true") : flags.every((f)=>featureFlags?.[f] === "true");
};
/**
 * Validates that some or all (depending on `fdLogicOp`) of the fulfillable
 * data are enabled on each of the items associated service code.
 * @param {Object} access - Object containing access properties.
 * @param {Object} services - The services used for checking permissions.
 * @param {Object} [services.fulfillableData] - Fulfillable data associated
 *   with service code.
 * @returns {boolean} - Valid or not.
 */ const $4bff461566f271e1$var$hasValidFulfillableData = (access, { fulfillableData: fulfillableData = {} })=>{
    const { fd: fd = [], fdLogicOp: fdLogicOp = "OR" } = access;
    const checkFn = (fdConfig)=>{
        const { code: code, exists: exists = true, property: property, propertyDefault: propertyDefault, value: value } = fdConfig;
        return (fulfillableData[code] || []).some((item)=>{
            const propertyValue = item[property] || propertyDefault;
            const hasValue = propertyValue === value || propertyValue?.includes(value);
            return exists === hasValue;
        });
    };
    return fdLogicOp === "OR" ? fd.some(checkFn) : fd.every(checkFn);
};
/**
 * Validates that some or all (depending on `fiLogicOp`) of the fulfillable
 * items are enabled on each of the items associated service code.
 * @param {Object} access - Object containing access properties.
 * @param {Object} services - The services used for checking permissions.
 * @param {Object} [services.fulfillableItems] - Fulfillable items associated
 *   with service code.
 * @returns {boolean} - Valid or not.
 */ const $4bff461566f271e1$var$hasValidFulfillableItems = (access, { fulfillableItems: fulfillableItems = {} })=>{
    const { fi: fi = [], fiLogicOp: fiLogicOp = "OR" } = access;
    const callback = (item)=>{
        const [fiCode, fiValue] = item.split(":");
        return (fulfillableItems[fiCode] || []).indexOf(fiValue || "") > -1;
    };
    return fiLogicOp === "OR" ? fi.some(callback) : fi.every(callback);
};
/**
 * Validates enablement against user roles
 * @param {string[]} roles - Array (list) of role strings.
 * @param {string} org - The currently selected IMS org.
 * @param {Role[]} userRoles - The current user's enabled roles.
 * @returns {boolean} - Valid or not.
 */ const $4bff461566f271e1$var$hasValidRole = (roles, org, userRoles)=>userRoles.some(({ named_role: named_role, organization: organization })=>organization === org && roles.includes(named_role));
/**
 * Validates that any of the subservices are enabled on a service code.
 * @param {Object} access - Object containing access properties.
 * @param {Object} services - The services used for checking permissions.
 * @param {Object} [services.userSubServices] - Product context subservice items
 *   associated with service code.
 * @returns {boolean} - Valid or not.
 */ module.exports.hasValidRole = $4bff461566f271e1$var$hasValidRole;
const $4bff461566f271e1$var$hasValidSubService = (access, { userSubServices: userSubServices = {} })=>{
    const { code: code = [], subServiceCode: subServiceCode = [] } = access;
    const expandedCode = [
        ...code
    ];
    const alteredSubServiceCode = []; // Look through all of the subServiceCodes and parse out the service code and
    // the subServiceCode. This is because the it can take the form:
    // <serviceCode>:<subServiceCode> in addition to a normal string.
    subServiceCode.forEach((ssCode)=>{
        if (ssCode.indexOf(":") > -1) {
            const [newCode, newSubServiceCode] = ssCode.split(":");
            expandedCode.push(newCode);
            alteredSubServiceCode.push(newSubServiceCode);
        } else alteredSubServiceCode.push(ssCode);
    });
    return expandedCode.some((codeKey)=>(userSubServices[codeKey] || []).some((subServiceKey)=>alteredSubServiceCode.includes(subServiceKey || "")));
};
/**
 * Validates that any of the user visible names are enabled on a service code.
 * @param {Object} access - Object containing access properties.
 * @param {Object} services - The services used for checking permissions.
 * @param {Object} [services.userVisibleNames] - Product context user visible
 *   names associated with service code.
 * @returns {boolean} - Valid or not.
 */ module.exports.hasValidSubService = $4bff461566f271e1$var$hasValidSubService;
const $4bff461566f271e1$var$hasValidVisibleName = (access, { userVisibleNames: userVisibleNames = {} })=>{
    const { visibleName: visibleName = [] } = access;
    return visibleName.some(({ code: code, name: name })=>userVisibleNames[code]?.some((userVisibleName)=>name.test(userVisibleName)));
};
/* eslint-disable @typescript-eslint/ban-types */ module.exports.hasValidVisibleName = $4bff461566f271e1$var$hasValidVisibleName;
const $4bff461566f271e1$var$VALIDATION_MAP = {
    code: $4bff461566f271e1$var$hasValidCodes,
    fd: $4bff461566f271e1$var$hasValidFulfillableData,
    fi: $4bff461566f271e1$var$hasValidFulfillableItems,
    flag: $4bff461566f271e1$var$hasValidFeatureFlag,
    subServiceCode: $4bff461566f271e1$var$hasValidSubService,
    visibleName: $4bff461566f271e1$var$hasValidVisibleName
};
/* eslint-enable @typescript-eslint/ban-types */ /**
 * Checks if the provided arguments are enough to identify that an organization
 * has permission to the application. Uses the `access` property from the
 * solution configuration, feature flags from launch darkly, and the service
 * codes that the user has in their product context.
 * @param {Object} access - The access solution configuration.
 * @param {Object} services - The services used for checking permissions.
 * @param {Object} [services.featureFlags] - All feature flags for user.
 * @param {Object} [services.fulfillableData] - Fulfillable data associated
 *   with service code.
 * @param {Object} [services.fulfillableItems] - Fulfillable items associated
 *   with service code.
 * @param {string[]} [services.serviceCodes] - Service codes for the user.
 * @param {Object} [services.userSubServices] - Product context subservice items
 *   associated with service code.
 * @returns {boolean} - Whether the user has permission to the application.
 */ const $4bff461566f271e1$var$hasPermission = (access, services)=>{
    const { logicOp: logicOp = "OR" } = access;
    let valid = true; // Loops through each of the access properties and runs their associated
    // validation methods. It exits early if certain conditions are met due to
    // the optional logic operator.
    for (const key of Object.keys($4bff461566f271e1$var$VALIDATION_MAP)){
        // Don't validate this property if it doesn't exist in the access object or
        // is not a valid value (e.g. empty array).
        if (!(key in access) || !access[key] || !access[key].length) continue;
        valid = $4bff461566f271e1$var$VALIDATION_MAP[key](access, services); // If the logic operator is OR and this property is valid, that's all that
        // is needed because OR only needs 1 truthy value.
        if (logicOp === "OR" && valid) return true;
         // If the logic operator is AND and this property is invalid, that's all
        // that is needed because AND needs every value to be truthy.
        if (logicOp === "AND" && !valid) return false;
    }
    return valid;
};
module.exports.hasPermission = $4bff461566f271e1$var$hasPermission;

});

parcelRegister("dXqQN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.overrideApiFeatureFlags = module.exports.overrideFeatureFlags = module.exports.reduceOverridesToAdditions = module.exports.mergeFulfillableItemsForShell = module.exports.mergeFeatureFlagsForShell = module.exports.mergeOverridesAndList = module.exports.getNewOverrides = module.exports.OVERRIDE_TYPES = module.exports.ACCESS_TYPES = void 0;

var $7Hyk2 = parcelRequire("7Hyk2");

var $iJaYo = parcelRequire("iJaYo");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ let $72be99e40a9ba959$var$ACCESS_TYPES;
module.exports.ACCESS_TYPES = $72be99e40a9ba959$var$ACCESS_TYPES;
(function(ACCESS_TYPES) {
    ACCESS_TYPES["FEATURE_FLAGS"] = "featureFlags";
    ACCESS_TYPES["FLOODGATE"] = "floodgate";
    ACCESS_TYPES["FULFILLABLE_ITEMS"] = "fulfillableItems";
})($72be99e40a9ba959$var$ACCESS_TYPES || (module.exports.ACCESS_TYPES = $72be99e40a9ba959$var$ACCESS_TYPES = {}));
let $72be99e40a9ba959$var$OVERRIDE_TYPES;
/**
 * Handles adding new items into a list
 * Supports bulk adding through comma separated strings
 * Replaces space inside the string with an underscore
 * @param {string} inputString - The text string input
 * @param {string || boolean || number} defaultValue - The default value for reset items
 * @param {array} overrides - The list of overrides
 * Returns a formatted item for Quarry Inventory
 */ module.exports.OVERRIDE_TYPES = $72be99e40a9ba959$var$OVERRIDE_TYPES;
(function(OVERRIDE_TYPES) {
    OVERRIDE_TYPES["BOOLEAN"] = "Boolean";
    OVERRIDE_TYPES["STRING"] = "String";
})($72be99e40a9ba959$var$OVERRIDE_TYPES || (module.exports.OVERRIDE_TYPES = $72be99e40a9ba959$var$OVERRIDE_TYPES = {}));
const $72be99e40a9ba959$var$getNewOverrides = (inputString, defaultValue, overrides = [])=>{
    // Early return for empty strings;
    if (!inputString.length) return;
     // Support comma separated list of items entered by creating an array without duplicates
    let inputs = [
        ...new Set(inputString.split(/[,]+/))
    ]; // Strip spaces from the start/end and replace spaces with underscores
    inputs = inputs.map((i)=>i.trim().replace(/[ ]+/g, "_")); // Filter and format the added values
    return inputs.filter((input)=>!overrides.find((override)=>override.key === input)).map((input)=>({
            isOverride: true,
            key: input,
            value: defaultValue
        }));
};
/**
 * Merges the overrides and a list of access items in Quarry Inventory format
 * @param {array} list - The list of items for a project
 * @param {array} overrides - The list of a project's overrides
 */ module.exports.getNewOverrides = $72be99e40a9ba959$var$getNewOverrides;
const $72be99e40a9ba959$var$mergeOverridesAndList = (list = [], overrides = [])=>{
    const mergedList = [
        ...list
    ]; // We don't mutate the list or overrides data, so we can
    // support action buttons to "reset" rendered items etc
    overrides.forEach((override)=>{
        const index = mergedList.findIndex(({ key: key })=>key === override.key); // If the override is new, add it (added override use case)
        // Otherwise if it has a match, update it (override existing flag use case)
        if (index === -1) mergedList.push(override);
        else mergedList.splice(index, 1, override);
    }); // Return an alpha sorted list
    return mergedList.length > 1 ? mergedList.sort((fi1, fi2)=>fi1.key.localeCompare(fi2.key)) : mergedList;
};
/**
 * Merges feature flags object and flag overrides for use in Unified Shell
 * Is scoped to one project/client's feature flags
 * @param {array} overrides - The list of a project's overrides
 * @param {Object} flags - Feature flags by project object
 */ module.exports.mergeOverridesAndList = $72be99e40a9ba959$var$mergeOverridesAndList;
const $72be99e40a9ba959$var$mergeFeatureFlagsForShell = (overrides = [], flags = {})=>{
    if (!overrides.length) return flags;
     // Convert overrides to an object for easy merging
    const overridesObject = overrides.reduce((obj, { key: key, value: value })=>{
        obj[key] = value;
        return obj;
    }, {});
    return {
        ...flags,
        ...overridesObject
    };
};
/**
 * Merges overrides and a list of fulfillable items for Unified Shell (Core.js)
 * @param {string} selectedImsOrg - Current IMS org id
 * @param {string} fiServiceCode - Current service code for fulfillable items
 * @param {Object} fis - Fulfillable items object, keyed by org then code
 * @param {array} overrides - Overrides from storage, an array of objects
 */ module.exports.mergeFeatureFlagsForShell = $72be99e40a9ba959$var$mergeFeatureFlagsForShell;
const $72be99e40a9ba959$var$mergeFulfillableItemsForShell = (selectedImsOrg, fiServiceCode, fis = {}, overrides = [])=>{
    // Early return if there are no overrides to merge
    if (!overrides.length) return fis;
     // Save the whole userFulfillableItems object or construct one if it's missing
    const mergedFullData = !Object.keys(fis).length ? {
        [selectedImsOrg]: {
            [fiServiceCode]: []
        }
    } : {
        ...fis
    }; // Then update the current scope (IMS org, service code)
    const mergedList = [
        ...mergedFullData[selectedImsOrg][fiServiceCode]
    ];
    overrides.forEach(({ key: key, value: value })=>{
        // If there is an override already in the list:
        // If the override value is true, and it's already in the list, no action is needed
        // If the override is false, remove from the array
        if (mergedList.includes(key) && !value) {
            const index = mergedList.findIndex((fi)=>fi === key);
            mergedList.splice(index, 1);
        } else // If the override is NOT in the list AND the value is true, add it
        // False values should NOT be included in the override list
        value && mergedList.push(key);
    });
    return {
        ...mergedFullData,
        [selectedImsOrg]: {
            [fiServiceCode]: mergedList
        }
    };
};
/**
 * Reduces a list to the original state with only new overrides included
 * @param {array} list - The list of items
 * @param {string || boolean || number} defaultValue - The default value for reset items
 * @param {array} overrides - The list of overrides
 */ module.exports.mergeFulfillableItemsForShell = $72be99e40a9ba959$var$mergeFulfillableItemsForShell;
const $72be99e40a9ba959$var$reduceOverridesToAdditions = (list, defaultValue, overrides = [])=>{
    const listKeys = new Set(list.map(({ key: key })=>key));
    return overrides.reduce((filteredList, { key: key })=>{
        if (!listKeys.has(key)) filteredList.push({
            isOverride: true,
            key: key,
            value: defaultValue
        });
        return filteredList;
    }, []);
};
/**
 * Merges feature flag response data with overrides for development and testing
 * Wrapper scoped to object with multiple project/client ids
 * @param {FeatureFlagsById} projectFeatureFlags - Response of feature flags by project/client id
 * @param {string} hashedAuthId - User hash string used in storage of override values
 * @param {string} overrideKey - The key used to access the overrides in storage
 * @returns {FeatureFlagsById} - A flattened object of projects with feature flag properties
 */ module.exports.reduceOverridesToAdditions = $72be99e40a9ba959$var$reduceOverridesToAdditions;
const $72be99e40a9ba959$var$overrideFeatureFlags = (projectFeatureFlags, hashedAuthId, overrideKey = $72be99e40a9ba959$var$ACCESS_TYPES.FEATURE_FLAGS)=>{
    const storedData = $iJaYo.storage.local.getSync("accessOverrides");
    const featureFlags = storedData?.[hashedAuthId]?.[overrideKey] || {};
    const mergedFlags = {
        ...projectFeatureFlags
    };
    for (const [key, value] of Object.entries(featureFlags))mergedFlags[key] = $72be99e40a9ba959$var$mergeFeatureFlagsForShell(value, projectFeatureFlags[key]);
    return mergedFlags;
};
/**
 * Helper wrapper function that merges feature flag response data with overrides, filters, and sorts them for return
 * @param {FeatureFlagsById} response - Response of feature flags by project/client id
 * @param {array} projectIds - List of project/client ids
 * @param {string} hashedAuthId - User hash string used in storage of override values
 * @param {string} overrideKey - The key used to access the overrides in storage
 * @returns {FeatureFlagsById} - A flattened object of projects with feature flag properties
 */ module.exports.overrideFeatureFlags = $72be99e40a9ba959$var$overrideFeatureFlags;
const $72be99e40a9ba959$var$overrideApiFeatureFlags = (response, projectIds, hashedAuthId, overrideKey = $72be99e40a9ba959$var$ACCESS_TYPES.FEATURE_FLAGS)=>{
    const flagData = $72be99e40a9ba959$var$overrideFeatureFlags(response, hashedAuthId, overrideKey);
    return (0, $7Hyk2.sortAndFilterFlags)(projectIds, flagData);
};
module.exports.overrideApiFeatureFlags = $72be99e40a9ba959$var$overrideApiFeatureFlags;

});
parcelRegister("7Hyk2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sortAndFilterFlags = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * Cleans up and sorts a feature flags object for multiple flag requests
 * Because the response or response with access overrides could include
 * projects or clients NOT requested, we filter the list by just the requested ones
 * @param projectIds - Array of project/client ids
 * @param featureFlagsById - Response of feature flags by project/client ID (possibly from cache)
 * @returns An object of project/client ids with flattened feature flags
 */ const $85f9918b62bd49c4$var$sortAndFilterFlags = (projectIds, featureFlagsById = {})=>Object.keys(featureFlagsById).sort((a, b)=>a.localeCompare(b)).reduce((result, key)=>projectIds.includes(key) ? {
            ...result,
            [key]: featureFlagsById[key]
        } : result, {});
module.exports.sortAndFilterFlags = $85f9918b62bd49c4$var$sortAndFilterFlags;

});


parcelRegister("ftx2l", function(module, exports) {
"use strict";
/*************************************************************************
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SANDBOX_TYPES = module.exports.PROVIDERS = void 0;
/**
 * The Feature Flags API provides feature flag data from LaunchDarkly and Floodgate.
 *
 * To consume this API, add the following import to your code.
 *
 * ```typescript
 * import featureFlags from '@adobe/exc-app/featureflags';
 * ```
 *
 * The default export is an object of type [FeatureFlagsApi](../interfaces/_featureflags_.featureflags.md)
 *
 * API reference: [scroll down](#index)
 *
 * ### Sample code
 *
 * ```typescript
 * import featureFlags from '@adobe/exc-app/featureflags';
 *
 * const featureFlags = await featureFlags.get(['cjm', 'experience-platform']);
 * ```
 *
 * Feature flags can also be requested from Floodgate by:
 * - including the provider in the options
 * - including the clientIds in the options (instead of projectIds)
 * If no provider is specified, the default provider is LaunchDarkly.
 *
 * ```typescript
 * import featureFlags, {PROVIDERS} from '@adobe/exc-app/featureflags';
 *
 * const floodgateFlags = await featureFlags().get({clientIds: ['unified-shell'], provider: PROVIDERS.FLOODGATE});
 * ```
 *
 * All feature flags can be requested using the key '*'
 * ```typescript
 * import featureFlags, {PROVIDERS} from '@adobe/exc-app/featureflags';
 *
 * const featureFlags = await featureFlags.get(['*']);
 *
 * const featureFlags = await featureFlags.get({clientIds: ['*'], provider: PROVIDERS.FLOODGATE});
 *
 * ```
 * In some cases you may want to include context options that are not already
 * included in the current app's active context. For example, requesting feature
 * flags for a project that uses sandboxes from an app that does not.
 *
 * To include options in the request, pass an object with the projectIds or clientIds and the context options.
 *
 * ```typescript
 * import featureFlags from '@adobe/exc-app/featureflags';
 *
 * const sandbox = {name: 'name'};
 * const featureFlags = await featureFlags.get({projectsIds: ['cjm'], sandbox});
 * ```
 *
 * API for fetching app data.
 * @packageDocumentation
 * @module featureflags
 */ var $b44330e115e6fcb5$var$PROVIDERS;
(function(PROVIDERS) {
    PROVIDERS["FLOODGATE"] = "Floodgate";
    PROVIDERS["LAUNCH_DARKLY"] = "Launch Darkly";
})($b44330e115e6fcb5$var$PROVIDERS = module.exports.PROVIDERS || (module.exports.PROVIDERS = {}));
var $b44330e115e6fcb5$var$SANDBOX_TYPES;
(function(SANDBOX_TYPES) {
    SANDBOX_TYPES["development"] = "DEVELOPMENT";
    SANDBOX_TYPES["production"] = "PRODUCTION";
})($b44330e115e6fcb5$var$SANDBOX_TYPES = module.exports.SANDBOX_TYPES || (module.exports.SANDBOX_TYPES = {}));

var $4jIM2 = parcelRequire("4jIM2");
const $b44330e115e6fcb5$var$featureFlags = {
    get: (params)=>{
        return (0, $4jIM2.getImpl)("featureFlags")().get(params);
    }
};
module.exports.default = $b44330e115e6fcb5$var$featureFlags;

});

parcelRegister("jNTva", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jBKJw = parcelRequire("jBKJw");

var $iNslS = parcelRequire("iNslS");

var $c0cwc = parcelRequire("c0cwc");

var $fi30R = parcelRequire("fi30R");

var $8e90448385d6319e$var$_metrics = $8e90448385d6319e$var$_interopRequireWildcard((parcelRequire("17AVh")));

var $ggkvY = parcelRequire("ggkvY");

var $3Zpnv = parcelRequire("3Zpnv");
function $8e90448385d6319e$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $8e90448385d6319e$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $8e90448385d6319e$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8e90448385d6319e$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8e90448385d6319e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/** Timeout for service worker to fetch and check HTML */ const $8e90448385d6319e$var$ONE_MINUTE = 60000;
const $8e90448385d6319e$var$ONE_HOUR = 60 * $8e90448385d6319e$var$ONE_MINUTE;
const $8e90448385d6319e$var$HTML_LONG_TIMEOUT = 20000; // 20 seconds
const $8e90448385d6319e$var$HTML_SHORT_TIMEOUT = $8e90448385d6319e$var$HTML_LONG_TIMEOUT / 4; // 5 seconds
const $8e90448385d6319e$var$HTML_VERY_RECENT_THRESHOLD = 5 * $8e90448385d6319e$var$ONE_MINUTE; // 5 minutes
const $8e90448385d6319e$var$HTML_RECENT_THRESHOLD = 24 * $8e90448385d6319e$var$ONE_HOUR; // 1 day
const $8e90448385d6319e$var$CHECK_WAIT = 2 * $8e90448385d6319e$var$ONE_MINUTE; // 2 minutes

class $8e90448385d6319e$var$ServiceWorkerControllerService {
    constructor(){
        $8e90448385d6319e$var$_defineProperty(this, "metrics", $8e90448385d6319e$var$_metrics.default.create("exc.core.services.ServiceWorkerControllerService"));
        this.init();
    }
    async init() {
        await (0, $iNslS.wait)($8e90448385d6319e$var$CHECK_WAIT);
        await (0, $3Zpnv.runInBackground)();
        const { scheduleUpdates: scheduleUpdates } = await Promise.resolve().then(function() {
            return (parcelRequire("55Tx7"));
        }).then((res)=>$8e90448385d6319e$var$_interopRequireWildcard(res));
        scheduleUpdates();
    }
    /**
   * Checks if an SPA version has updated in the new config
   * @param {string} appId - SPA app ID
   * @param {UnifiedShellConfig} config - Incoming config object
   * @param {UnifiedShellConfig} windowConfig - Current config object (window.config)
   * @returns true if version changed, false otherwise.
   */ hasAppVersionChanged(appId, config, windowConfig) {
        const liveSolution = windowConfig.solutions[appId];
        const newSolution = config.solutions[appId];
        const changed = !liveSolution && newSolution || liveSolution && !newSolution || liveSolution.liveVersion !== newSolution.liveVersion;
        if (changed) return {
            appId: appId,
            newVersion: newSolution?.liveVersion,
            oldVersion: liveSolution?.liveVersion
        };
    }
    /**
   * Reloads Unified Shell when there is a new version of the active SPA available on load
   * @param config - Updated Unified Shell Config
   * @param spaAppId - New SPA app version
   * @returns HTML Status
   * @private
   */ async handleOutdatedResponse(config, spaAppId = "") {
        const windowConfig = (0, $c0cwc.getWindowConfig)(); // If solution that updated is current solution, refresh page.
        // Otherwise, update outdated solution versions.
        const updateData = spaAppId && this.hasAppVersionChanged(spaAppId, config, windowConfig);
        if (updateData) {
            await (0, $ggkvY.reload)({
                data: updateData,
                initiator: "Service Worker",
                reason: "New App Version"
            });
            return $fi30R.HTMLStatus.OUTDATED;
        }
        this.metrics.event("ServiceWorker.appsVersionUpdated"); // Copy solutions from new config.
        windowConfig.solutions = config.solutions;
        return $fi30R.HTMLStatus.OUTDATED;
    }
    /**
   * Reloads Unified Shell when a new version is available on load.
   * @param assetsCached - Total new version assets already cached by the worker
   * @param spaVersion - New Unified Shell version
   * @returns HTML Status
   * @private
   */ async handleNewVersion({ assetsCached: assetsCached, spaVersion: spaVersion }) {
        const windowConfig = (0, $c0cwc.getWindowConfig)(); // If spaVersion outdated
        const oldVersion = windowConfig.spaVersion;
        if (oldVersion.startsWith("PR-")) // This is a PR, not really outdated.
        return $fi30R.HTMLStatus.OK;
        if (spaVersion !== oldVersion) {
            await (0, $ggkvY.reload)({
                data: {
                    assetsCached: assetsCached,
                    newVersion: spaVersion,
                    oldVersion: oldVersion
                },
                initiator: "Service Worker",
                reason: "New Unified Shell Version"
            });
            return $fi30R.HTMLStatus.OUTDATED;
        } // Shouldn't happen.
        this.metrics.event("ServiceWorker.invalidVersionUpdate", {
            assetsCached: assetsCached,
            oldVersion: oldVersion,
            spaVersion: spaVersion
        }, {
            level: $8e90448385d6319e$var$_metrics.Level.ERROR
        });
        return $fi30R.HTMLStatus.OK;
    }
    /**
   * Unified Shell loads the cached HTML and waits for a fresh HTML from the service worker.
   * This method returns the maximum amount of time it should wait for a fresh HTML to be ready.
   * We want to keep the timeout is short as possible to avoid delaying Unified Shell load.
   * When the loaded HTML is already fresh (< 5 minutes old), the maximum wait time is 0.
   * When the loaded HTML is under 24 hours old, the maximum wait time is 5 seconds.
   * When the loaded HTML is over 24 hours old, the maximum wait time is 20 seconds.
   * Older cached HTMLs (> 24 hours) are more likely to point at outdated Unified Shell/SPA versions
   * hence the maximum time allowed is longer - Unified Shell will auto-refresh when fresh HTML
   * includes a newer version than the cached one.
   */ getWaitTimeout() {
        const { lastModified: lastModified, time: time } = window.config || {};
        const lastUpdate = time ?? lastModified;
        const timePassed = lastUpdate ? Date.now() - lastUpdate : 0;
        if (timePassed === 0 || timePassed > $8e90448385d6319e$var$HTML_RECENT_THRESHOLD) return $8e90448385d6319e$var$HTML_LONG_TIMEOUT;
        return timePassed < $8e90448385d6319e$var$HTML_VERY_RECENT_THRESHOLD ? 0 : $8e90448385d6319e$var$HTML_SHORT_TIMEOUT;
    }
    /**
   * Sends a fetch request to ping service worker to check the live index.html
   * version, compare it against the cached index.html version, and update
   * cached assets as needed. We will also need to reload the page to update
   * the HTML in some cases.
   * @param {Solution} solutionConfig Active solution config
   * @returns true if not reloading. false otherwise (But window.reload will cut execution)
   */ async checkHtmlForUpdates(solutionConfig) {
        const timeout = this.getWaitTimeout();
        if (timeout === 0 || !(0, $c0cwc.isWorkerActivated)()) // Don't check for updates if the HTML is very recent or worker not activated.
        return $fi30R.HTMLStatus.OK;
        try {
            const TIMEOUT_RESPONSE = new Response(JSON.stringify({
                status: "timeout"
            }));
            const res = await (0, $iNslS.runWithTimeout)((0, $c0cwc.getHtmlFromWorker)(), timeout, TIMEOUT_RESPONSE);
            const { data: statusData = {}, status: status } = await res.json();
            const { config: config, url: url } = statusData;
            switch(status){
                case "outdated":
                    return this.handleOutdatedResponse(config, solutionConfig?.spaAppId);
                case "new version":
                    return this.handleNewVersion(statusData);
                case "timeout":
                    {
                        const ping = await (0, $jBKJw.checkCDN)();
                        this.metrics.event("ServiceWorker.timeout", {
                            ping: ping,
                            timeout: timeout
                        }, {
                            level: $8e90448385d6319e$var$_metrics.Level.ERROR
                        });
                        return $fi30R.HTMLStatus.TIMEOUT;
                    }
                case "non standard url":
                    this.metrics.event("ServiceWorker.nonStandardUrl", {
                        url: url
                    });
                    return $fi30R.HTMLStatus.OK;
                case "html structure changed":
                    this.metrics.event("ServiceWorker.badHtml", statusData, {
                        level: $8e90448385d6319e$var$_metrics.Level.ERROR
                    });
                    return $fi30R.HTMLStatus.CORRUPT;
                case "failed to get html":
                    {
                        const ping = await (0, $jBKJw.checkCDN)();
                        this.metrics.event("ServiceWorker.unreachableHtml", {
                            ...statusData,
                            online: navigator.onLine,
                            ping: ping
                        }, {
                            level: $8e90448385d6319e$var$_metrics.Level.ERROR
                        });
                        return $fi30R.HTMLStatus.UNREACHABLE;
                    }
                case "no change":
                    this.metrics.event("ServiceWorker.noHtmlUpdates");
                    break;
                default:
                    this.metrics.event("ServiceWorker.noHtmlUpdates", {
                        status: status
                    });
            }
        } catch (err) {
            this.metrics.event("ServiceWorker.failedToCheckHTML", {
                error: (0, $iNslS.getErrorMessage)(err)
            }, {
                level: $8e90448385d6319e$var$_metrics.Level.ERROR
            });
        }
        return $fi30R.HTMLStatus.OK;
    }
}
module.exports.default = $8e90448385d6319e$var$ServiceWorkerControllerService;

});
parcelRegister("55Tx7", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = $Ha5sG("2l10r").then(()=>parcelRequire("Q6g0R"));

});


parcelRegister("fLrqA", function(module, exports) {
"use strict";
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SettingsLevel = void 0;

var $4jIM2 = parcelRequire("4jIM2");

var $6WeEI = parcelRequire("6WeEI");
Object.defineProperty(module.exports, "SettingsLevel", {
    enumerable: true,
    get: function() {
        return $6WeEI.SettingsLevel;
    }
});
const $b7a0855f825b08c9$var$settings = {
    get: (params)=>(0, $4jIM2.getImpl)("settings")().get(params),
    set: (params)=>(0, $4jIM2.getImpl)("settings")().set(params)
};
module.exports.default = $b7a0855f825b08c9$var$settings;

});
parcelRegister("6WeEI", function(module, exports) {
"use strict";
/*************************************************************************
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SettingsLevel = void 0;
/**
 * @ignore
 */ var $50d387331ffb8866$var$SettingsLevel;
(function(SettingsLevel) {
    /**
   * Settings specific to the org.
   */ SettingsLevel["ORG"] = "org";
    /**
   * Settings specific to the user.
   */ SettingsLevel["USER"] = "user";
    /**
   * Settings specific to the user-org combination.
   */ SettingsLevel["USERORG"] = "userorg";
})($50d387331ffb8866$var$SettingsLevel = module.exports.SettingsLevel || (module.exports.SettingsLevel = {}));

});


parcelRegister("cOPHH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VALID_CLIENT_IDS = module.exports.SANDBOX_VARIABLES_MAP = module.exports.CONTEXT_VARIABLES_MAP = module.exports.FG_GRAPHQL_QUERY_DATA_KEY = module.exports.SHELL_FLAG_PREFIX = module.exports.SHELL_FG_PROJECT = module.exports.ONBOARDED_CLIENT_IDS = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $b3456dca46b110c4$var$ONBOARDED_CLIENT_IDS = [
    "acp_ui_platform",
    "genstudio",
    "unified-shell"
];
module.exports.ONBOARDED_CLIENT_IDS = $b3456dca46b110c4$var$ONBOARDED_CLIENT_IDS;
const $b3456dca46b110c4$var$SHELL_FG_PROJECT = "unified-shell";
module.exports.SHELL_FG_PROJECT = $b3456dca46b110c4$var$SHELL_FG_PROJECT;
const $b3456dca46b110c4$var$SHELL_FLAG_PREFIX = "fg:";
module.exports.SHELL_FLAG_PREFIX = $b3456dca46b110c4$var$SHELL_FLAG_PREFIX;
const $b3456dca46b110c4$var$FG_GRAPHQL_QUERY_DATA_KEY = "fgFeatureFlags"; // Context value mapping for Floodgate
// Some are mandatory/common context variables (like 'region' and 'sandboxType')
// whereas others were created for Unified Shell (with the `dx` prefix)
module.exports.FG_GRAPHQL_QUERY_DATA_KEY = $b3456dca46b110c4$var$FG_GRAPHQL_QUERY_DATA_KEY;
const $b3456dca46b110c4$var$CONTEXT_VARIABLES_MAP = {
    authId: "dxAuthId",
    email: "dxEmail",
    imsOrg: "imsOrg",
    internal: "dxInternal",
    locale: "dxLocale",
    name: "dxName",
    userHash: "dxUserHash",
    userId: "dxUserId"
};
module.exports.CONTEXT_VARIABLES_MAP = $b3456dca46b110c4$var$CONTEXT_VARIABLES_MAP;
const $b3456dca46b110c4$var$SANDBOX_VARIABLES_MAP = {
    name: "dxSandboxName",
    region: "region",
    type: "sandboxType"
};
module.exports.SANDBOX_VARIABLES_MAP = $b3456dca46b110c4$var$SANDBOX_VARIABLES_MAP;
const $b3456dca46b110c4$var$VALID_CLIENT_IDS = [];
module.exports.VALID_CLIENT_IDS = $b3456dca46b110c4$var$VALID_CLIENT_IDS;

});

parcelRegister("bPa83", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LD_GRAPHQL_QUERY_DATA_KEY = module.exports.VALID_LAUNCH_DARKLY_PROJECTS = module.exports.ORG_SANDBOX_PROJECTS = module.exports.ORG_ONLY_PROJECTS = module.exports.FORCIBLE_PROJECTS = module.exports.SHELL_LD_PROJECT = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $0674c3afd9dbc41c$var$SHELL_LD_PROJECT = "unified-shell"; // Only certain projects can be forced to be re-fetched.
module.exports.SHELL_LD_PROJECT = $0674c3afd9dbc41c$var$SHELL_LD_PROJECT;
const $0674c3afd9dbc41c$var$FORCIBLE_PROJECTS = [
    $0674c3afd9dbc41c$var$SHELL_LD_PROJECT
]; // Launch Darkly projects need to be onboarded to the GraphQL Service
// If you need to add a project here, you'll also need to add it to
// https://git.corp.adobe.com/excgql-fed-excelerate/graphql-service
module.exports.FORCIBLE_PROJECTS = $0674c3afd9dbc41c$var$FORCIBLE_PROJECTS;
const $0674c3afd9dbc41c$var$ORG_ONLY_PROJECTS = [
    "aem-generate-variations",
    "aep-co-pilot",
    "experience-platform",
    "sapphire",
    "target",
    $0674c3afd9dbc41c$var$SHELL_LD_PROJECT
];
module.exports.ORG_ONLY_PROJECTS = $0674c3afd9dbc41c$var$ORG_ONLY_PROJECTS;
const $0674c3afd9dbc41c$var$ORG_SANDBOX_PROJECTS = [
    "cjm",
    "project-m",
    "voyager",
    "voyager-dev"
];
module.exports.ORG_SANDBOX_PROJECTS = $0674c3afd9dbc41c$var$ORG_SANDBOX_PROJECTS;
const $0674c3afd9dbc41c$var$VALID_LAUNCH_DARKLY_PROJECTS = [
    ...$0674c3afd9dbc41c$var$ORG_SANDBOX_PROJECTS,
    ...$0674c3afd9dbc41c$var$ORG_ONLY_PROJECTS
];
module.exports.VALID_LAUNCH_DARKLY_PROJECTS = $0674c3afd9dbc41c$var$VALID_LAUNCH_DARKLY_PROJECTS;
const $0674c3afd9dbc41c$var$LD_GRAPHQL_QUERY_DATA_KEY = "multiProjectFeatureFlags";
module.exports.LD_GRAPHQL_QUERY_DATA_KEY = $0674c3afd9dbc41c$var$LD_GRAPHQL_QUERY_DATA_KEY;

});

parcelRegister("11cjw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSelectedWorkspace = $0bdf6fb76a964d08$var$getSelectedWorkspace;
module.exports.getSelectedSideNavItemId = $0bdf6fb76a964d08$var$getSelectedSideNavItemId;
module.exports.default = module.exports.MAX_WAIT_MS = module.exports.waitForShellHeader = void 0;

var $0bdf6fb76a964d08$var$_capabilities = $0bdf6fb76a964d08$var$_interopRequireDefault((parcelRequire("jePGM")));

var $dDEjQ = parcelRequire("dDEjQ");

var $jVeiz = parcelRequire("jVeiz");

var $bzq4v = parcelRequire("bzq4v");

var $0bdf6fb76a964d08$var$_metrics = $0bdf6fb76a964d08$var$_interopRequireDefault((parcelRequire("83dfQ")));

var $iNslS = parcelRequire("iNslS");

var $0bdf6fb76a964d08$var$_react = $0bdf6fb76a964d08$var$_interopRequireDefault((parcelRequire("7eprg")));

var $ctGaZ = parcelRequire("ctGaZ");

var $3Zpnv = parcelRequire("3Zpnv");

var $4OKVd = parcelRequire("4OKVd");

var $2qT0f = parcelRequire("2qT0f");
function $0bdf6fb76a964d08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0bdf6fb76a964d08$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0bdf6fb76a964d08$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $0bdf6fb76a964d08$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $0bdf6fb76a964d08$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0bdf6fb76a964d08$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

const $0bdf6fb76a964d08$var$postAuthPromise = Promise.resolve().then(function() {
    return (parcelRequire("7rHmB"));
}).then((res)=>$0bdf6fb76a964d08$var$_interopRequireWildcard(res));
let $0bdf6fb76a964d08$var$shellHeaderResolve; // A promise to be resolved when the shell header is loaded. Waiting for this prevents
// toasts from firing before the React Spectrum styling loads.
const $0bdf6fb76a964d08$var$shellHeaderPromise = new Promise((resolve)=>$0bdf6fb76a964d08$var$shellHeaderResolve = resolve);
const $0bdf6fb76a964d08$var$waitForShellHeader = ()=>$0bdf6fb76a964d08$var$shellHeaderPromise;
module.exports.waitForShellHeader = $0bdf6fb76a964d08$var$waitForShellHeader;
const $0bdf6fb76a964d08$var$MAX_WAIT_MS = 250;
module.exports.MAX_WAIT_MS = $0bdf6fb76a964d08$var$MAX_WAIT_MS;
function $0bdf6fb76a964d08$var$getSelectedWorkspace(ws) {
    const { hash: hash, search: search } = $bzq4v.history.location;
    let { pathname: pathname } = $bzq4v.history.location;
    const { origin: origin } = window.location;
    pathname = (0, $jVeiz.getPathWithoutTenant)(pathname);
    const { searchParams: searchParams } = new URL(`${origin}${search}`);
    const extendedPath = `${pathname}${search}${hash}`;
    return $0bdf6fb76a964d08$var$getWorkspaces(ws).find((w)=>{
        if (/^http/.test(w.url)) return false;
        const selected = w.selectOn && w.selectOn.find((s)=>s.test(extendedPath));
        if (selected) return selected;
        const url = new URL(`${origin}${w.url}`);
        const { hash: wsHash, pathname: wsPath, searchParams: wsSearchParams } = url;
        if (!new RegExp(`^${wsPath}([#/?]|$)`).test(pathname)) return false;
        const params = Array.from(wsSearchParams.keys());
        return hash === wsHash && params.every((key)=>searchParams.get(key) === wsSearchParams.get(key));
    });
}
const $0bdf6fb76a964d08$var$BACKCOMPAT_URL = {
    "/cjm": "/journey-optimizer"
};
const $0bdf6fb76a964d08$var$SELECTION_URL = {
    "/fusion/connections-page": "/fusion/[0-9]+/connections",
    "/fusion/data-stores-page": "/fusion/[0-9]+/data-stores",
    "/fusion/data-structures-page": "/fusion/[0-9]+/udts",
    "/fusion/keys-page": "/fusion/[0-9]+/keys",
    "/fusion/org-overview-page": "/fusion/organization/[0-9]+",
    "/fusion/scenario-page": "/fusion/[0-9]+/scenario",
    "/fusion/team-overview-page": "/fusion/[0-9]+/team",
    "/fusion/templates-page": "/fusion/templates",
    "/fusion/webhooks-page": "/fusion/[0-9]+/hooks",
    "/journey-optimizer/platform/components/placements": "/journey-optimizer/platform/components",
    "/journey-optimizer/platform/offers/offers": "/journey-optimizer/platform/offers"
};
function $0bdf6fb76a964d08$var$getSelectedSideNavItemId(navMenu, config) {
    // If there is a specific selected id defined in the configuration, use that
    // without going through any of the other logic.
    if (config?.workHubSelectedId) return config?.workHubSelectedId;
    let pathname = (0, $jVeiz.getPathWithoutTenant)((0, $jVeiz.hashToPath)());
    if (!pathname.endsWith("/")) pathname = `${pathname}/`;
     // Uses the BACKCOMPAT_URL object to determine if the url being matched needs
    // to be converted to the new format of the path. This will only be necessary
    // before Work Hub service has outdated paths.
    // Uses SELECTION_URL object to get all matching paths that should
    // cause left nav item to be selected.
    const itemMatch = (url, enabled = true)=>{
        const key = Object.keys($0bdf6fb76a964d08$var$BACKCOMPAT_URL).find((prefix)=>url.startsWith(prefix));
        const newUrl = key ? url.replace(key, $0bdf6fb76a964d08$var$BACKCOMPAT_URL[key]) : url;
        const regex = new RegExp(`^((${newUrl})|(${$0bdf6fb76a964d08$var$SELECTION_URL[newUrl]}))($|/|#|\\?)`);
        return regex.test(pathname) && enabled;
    };
    const workhubNavs = navMenu.reduce((arr, current)=>{
        const items = [];
        (current.items || [
            current
        ]).forEach((item)=>{
            if (item.selectOn) {
                item.selectOn.forEach((path)=>items.push({
                        ...item,
                        url: path
                    }));
                (item.url || item.urlTemplate) && items.push(item);
            } else items.push(item);
        });
        return [
            ...arr,
            ...items
        ];
    }, []); // Add extra paths given in selectOn attributes in capabilities
    const extraPaths = $0bdf6fb76a964d08$var$_capabilities.default.reduce((arr, current)=>current.selectOn && workhubNavs.some((n)=>n.id === current.id) ? [
            ...arr,
            ...current.selectOn.map((path)=>({
                    ...workhubNavs.find((n)=>n.id === current.id),
                    urlTemplate: path.path
                }))
        ] : arr, []);
    const allNavs = workhubNavs.concat(extraPaths); // This sorts nav items for matching from greatest length to shortest (by `/`).
    // The idea is to match largest paths first.
    const sortedNavMenu = [
        ...allNavs
    ].sort((a, b)=>{
        const aLen = (a.urlTemplate || a.url).split("/").length;
        const bLen = (b.urlTemplate || b.url).split("/").length;
        if (aLen < bLen) return 1;
        else if (aLen > bLen) return -1;
        return 0;
    });
    for (const item of sortedNavMenu){
        if ((item.urlTemplate || item.url) && itemMatch(item.urlTemplate || item.url, item.enabled)) return item.id;
    }
    return "";
}
/**
 * This function generates a list of workspaces, using BFS to identify menu
 * workspaces.
 * @param {Object[]} workspaces Array of workspaces.
 * @returns {Object[]} Array of workspaces including menu workspaces.
 */ function $0bdf6fb76a964d08$var$getWorkspaces(workspaces) {
    const queue = [];
    const menus = [];
    workspaces.forEach((w)=>{
        queue.push(w);
        while(queue.length){
            const ws = queue.shift();
            menus.push(ws);
            ws.menu && ws.menu.forEach((m)=>queue.push(m));
        }
    });
    menus.sort((a, b)=>a.url.split("/").length - b.url.split("/").length);
    menus.reverse();
    return menus;
}

class $0bdf6fb76a964d08$var$ShellWrapper extends $0bdf6fb76a964d08$var$_react.default.Component {
    constructor(props){
        super(props);
        $0bdf6fb76a964d08$var$_defineProperty(this, "loadShellHeaderAsync", ()=>{
            if (!this.deferredLoadStarted) {
                // Wait 250ms or until the browser is idle - whichever comes first.
                // Then import shell header.
                const deferredPromise = (0, $iNslS.runWithTimeout)((0, $3Zpnv.runInBackground)(true), $0bdf6fb76a964d08$var$MAX_WAIT_MS).then(()=>Promise.resolve().then(function() {
                        return (parcelRequire("iBUcR"));
                    }).then((res)=>$0bdf6fb76a964d08$var$_interopRequireWildcard(res)));
                this.deferredLoadStarted = true; // When the shell header has loaded, resolve the shell header promise.
                deferredPromise.then($0bdf6fb76a964d08$var$shellHeaderResolve);
                Promise.all([
                    $0bdf6fb76a964d08$var$postAuthPromise,
                    deferredPromise
                ]).then(([{ showInitialToasts: showInitialToasts }])=>showInitialToasts({
                        getComponentContext: this.props.getComponentContext,
                        metrics: this.metrics
                    }));
                this.setState({
                    deferredPromise: deferredPromise
                });
            }
        });
        $0bdf6fb76a964d08$var$_defineProperty(this, "afterPrint", (ev)=>{
            if (this.props.afterPrintHandler) this.props.afterPrintHandler(ev);
        });
        $0bdf6fb76a964d08$var$_defineProperty(this, "beforePrint", (ev)=>{
            if (this.props.beforePrintHandler) this.props.beforePrintHandler(ev);
        });
        this.state = {};
        this.metrics = $0bdf6fb76a964d08$var$_metrics.default.create("exc.core.Shell");
        const bootstrap = (0, $dDEjQ.getBootstrap)();
        this.xql = bootstrap.config.endpoints.xql;
        this.devMode = bootstrap.isDevMode();
        this.deferredLoadStarted = false;
        window.addEventListener("afterprint", this.afterPrint);
        window.addEventListener("beforeprint", this.beforePrint);
    }
    componentDidMount() {
        this.deferredLoadStarted || (0, $iNslS.wait)($0bdf6fb76a964d08$var$MAX_WAIT_MS).then(this.loadShellHeaderAsync);
    }
    onHeroClick() {
        const { customHeroClick: customHeroClick, basePath: basePath, hero: hero, noSolution: noSolution } = this.props;
        if (noSolution) {
            (0, $2qT0f.updatePath)({
                path: "/home"
            });
            return;
        } // A lot of apps have custom hero clicks that don't make sense when they are
        // part of composed apps, so if an app is composed we disable it.
        if (!hero.composed && customHeroClick) {
            customHeroClick();
            return;
        }
        (0, $2qT0f.updatePath)({
            path: hero.path || basePath
        });
    }
    render() {
        const props = this.props;
        const { appId: appId, digitalData: digitalData, environment: environment, featureFlags: featureFlags, feedbackConfig: feedbackConfig, hero: hero, locale: locale, networkErrorProps: networkErrorProps, noAccess: noAccess, pulse: pulse, selectedImsOrg: selectedImsOrg, selectedImsOrgName: selectedImsOrgName, selectedTenantId: selectedTenantId, serviceEnvironment: serviceEnvironment, shellResponse: shellResponse, showDebugModal: showDebugModal, sideNav: { config: config }, workHubResponse: workHubResponse } = props;
        this.deferredLoadStarted || appId && this.loadShellHeaderAsync();
        const { deferredPromise: deferredPromise } = this.state;
        const customButtons = props.customButtons || {};
        const profile = props.profile || {};
        const router = $0bdf6fb76a964d08$var$_react.default.Children.only(props.children);
        const selectedWorkspace = $0bdf6fb76a964d08$var$getSelectedWorkspace(props.workspaces);
        const selectedSideNavItemId = workHubResponse ? $0bdf6fb76a964d08$var$getSelectedSideNavItemId(workHubResponse, config) : $0bdf6fb76a964d08$var$getSelectedSideNavItemId(config?.menu || []);
        const helpCenterConfig = {
            canAuthorize: environment === "prod",
            customButtons: customButtons,
            digitalData: digitalData,
            environment: environment,
            featureFlags: featureFlags,
            feedbackAttachmentsEnabled: true,
            feedbackConfig: feedbackConfig,
            imsPayload: {
                accessToken: props.accessToken,
                clientId: props.clientId,
                displayName: profile.displayName,
                email: profile.email,
                environment: serviceEnvironment,
                firstName: profile.first_name,
                lastName: profile.last_name,
                orgId: selectedImsOrg,
                orgName: selectedImsOrgName,
                userId: profile.userId
            },
            onCustomButtonClick: props.onCustomButtonClick,
            ...props.helpCenter,
            services: shellResponse.services,
            showDebugTab: props.internal && featureFlags?.["demo-quiet-mode"] === "true",
            solutions: shellResponse.solutions,
            solutionTitle: hero.title,
            xqlEndpoint: this.xql
        };
        return /*#__PURE__*/ $0bdf6fb76a964d08$var$_react.default.createElement($4OKVd.Shell, {
            accessOverridesEnabled: props.accessOverridesEnabled,
            agreements: props.agreements,
            appContainer: props.appContainer,
            appId: props.appId,
            appRoot: props.appRoot,
            appTheme: props.appTheme,
            authId: props.authId,
            backgroundReady: props.backgroundReady,
            basePath: props.basePath,
            clientId: props.clientId,
            closeLanguagePicker: props.closeLanguagePicker,
            coachMark: props.coachMark,
            currentActiveTenantId: selectedTenantId,
            customButtons: customButtons,
            customEnvLabel: props.customEnvLabel,
            customHeroClick: props.customHeroClick,
            customProfileButtons: customButtons.userProfile,
            customSearch: props.customSearch,
            defaultComponent: props.defaultComponent,
            deferredComponentsPromise: deferredPromise,
            devMode: this.devMode,
            disableShellFeedbackButton: props.disableShellFeedbackButton,
            environment: environment,
            featureFlags: featureFlags,
            feedback: props.feedback,
            filteredSandboxes: props.filteredSandboxes,
            getCapabilityWithIconUrl: props.getCapabilityWithIconUrl,
            getLDFeatureFlags: props.getLDFeatureFlags,
            globalSearch: props.globalSearch,
            hasAccountClusterData: props.hasAccountClusterData,
            hasAssistantPermission: props.hasAssistantPermission,
            helpCenterConfig: helpCenterConfig,
            imsOrgs: props.imsOrgs,
            initialAppLoaded: props.initialAppLoaded,
            internal: props.internal,
            isImpersonating: props.isImpersonating,
            landingpage: shellResponse.landingpage,
            locale: locale,
            modal: props.modal,
            networkErrorProps: networkErrorProps,
            noAccess: noAccess,
            onCustomButtonClick: props.onCustomButtonClick,
            onCustomProfileButtonClick: props.onCustomButtonClick,
            onGlobalDialogOpen: props.onGlobalDialogOpen,
            onImsOrgChange: props.onImsOrgChange,
            onLanguageChange: props.onLanguageChange,
            onSetUserTheme: props.onSetUserTheme,
            onSignOutClick: props.onSignOut,
            onSolutionClick: this.onHeroClick.bind(this),
            orgToSubOrgsMap: props.orgToSubOrgsMap,
            parentId: props.parentId,
            preferredLanguages: props.preferredLanguages,
            profile: profile,
            pulse: pulse,
            recentSandboxes: props.recentSandboxes,
            registerKeyHandler: (...args)=>$0bdf6fb76a964d08$var$postAuthPromise.then(({ eventObserver: eventObserver })=>eventObserver.registerKeyHandler(...args)),
            releaseType: props.releaseType,
            sandbox: props.sandbox,
            selectedImsOrg: props.selectedImsOrg,
            selectedSideNavItemId: selectedSideNavItemId,
            selectedSubOrg: props.selectedSubOrg,
            selectedWorkspaceId: selectedWorkspace && selectedWorkspace.uid,
            serviceEnvironment: props.serviceEnvironment,
            services: shellResponse.services,
            settingsData: props.settingsData,
            settingsService: props.settingsService,
            showDebugModal: showDebugModal,
            showLanguagePicker: props.showLanguagePicker,
            showToast: props.showToast,
            sideNav: props.sideNav,
            solutionIcon: hero.icon,
            solutionReleaseType: hero.releaseType,
            solutionShortTitle: hero.shortTitle,
            solutionTitle: hero.title,
            solutions: shellResponse.solutions,
            subOrgAccessOnlyOnCurrentOrg: props.subOrgAccessOnlyOnCurrentOrg,
            theme: props.theme,
            toastPlacement: props.toastPlacement,
            translationService: props.translationService,
            userAvatar: props.userAvatar,
            userRecentSandboxesHandler: props.userRecentSandboxesHandler,
            userToken: props.accessToken,
            workHubResponse: workHubResponse,
            workspaces: props.workspaces
        }, /*#__PURE__*/ $0bdf6fb76a964d08$var$_react.default.createElement($0bdf6fb76a964d08$var$_react.default.Suspense, {
            fallback: props.defaultComponent
        }, router));
    }
}
module.exports.default = $0bdf6fb76a964d08$var$ShellWrapper;
$0bdf6fb76a964d08$var$ShellWrapper.defaultProps = {
    accessToken: null,
    appContainer: null,
    backgroundReady: false,
    customEnvLabel: [],
    customSearch: {
        enabled: false,
        onClick: $iNslS.NOOP,
        open: false
    },
    environment: "dev",
    hasAccountClusterData: false,
    helpCenter: {
        featured: [],
        resources: []
    },
    hero: {
        icon: null,
        releaseType: $ctGaZ.RELEASE_TYPE.GA,
        shortTitle: "",
        title: ""
    },
    imsOrgs: [],
    initialAppLoaded: false,
    locale: "en-US",
    noAccess: false,
    profile: {},
    releaseType: $ctGaZ.RELEASE_TYPE.GA,
    sandbox: {
        enabled: false,
        onChange: $iNslS.NOOP,
        sandboxes: [],
        selected: null
    },
    selectedImsOrg: null,
    sideNav: {
        buttonEnabled: false,
        config: {},
        enabled: false
    },
    solutionParent: "",
    toastPlacement: "top center",
    toggleSideNav: $iNslS.NOOP,
    workspaces: []
};

});
parcelRegister("jePGM", function(module, exports) {
"use strict";
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // The ids and displayNames for each capability must match the ids and displayNames
// from Work Hub. If it is not in Work Hub yet, do not add here.
const $e0176b7ac1a17338$var$capabilities = [
    {
        displayName: "Profiles",
        icon: "Enterprise",
        id: "accountProfile"
    },
    {
        displayName: "Configurations",
        icon: "Gears",
        id: "admin"
    },
    {
        displayName: "Alerts",
        icon: "Alert",
        id: "alert"
    },
    {
        displayName: "App Configurations",
        icon: "DesktopAndMobile",
        id: "appconfigurations"
    },
    {
        displayName: "App Surfaces",
        icon: "DesktopAndMobile",
        id: "appsurfaces"
    },
    {
        displayName: "Applications",
        icon: "Service",
        id: "applications"
    },
    {
        displayName: "Assets",
        icon: "Asset",
        id: "assets"
    },
    {
        displayName: "Assurance",
        icon: "Assurance",
        id: "assurance"
    },
    {
        displayName: "Tags",
        icon: "ClientLaunch",
        id: "clientproperties"
    },
    {
        displayName: "Campaigns",
        icon: "Promote",
        id: "campaigns",
        selectOn: [
            {
                path: "/journey-optimizer/reports/campaign"
            },
            {
                path: "/journey-optimizer/campaign/report"
            }
        ]
    },
    {
        displayName: "Components",
        icon: "Attributes",
        id: "components"
    },
    {
        displayName: "Dashboards",
        icon: "Dashboard",
        id: "dashboard"
    },
    {
        displayName: "Dataflows",
        icon: "DataFlow",
        id: "dataflow"
    },
    {
        displayName: "Datasets",
        icon: "Data",
        id: "dataset"
    },
    {
        displayName: "Datastreams",
        icon: "DataStreams",
        id: "datastreams"
    },
    {
        displayName: "Datastreams (Beta)",
        icon: "DataStreams",
        id: "datastreamsbeta"
    },
    {
        displayName: "Destinations",
        icon: "Destination",
        id: "destination"
    },
    {
        displayName: "Home",
        icon: "Home",
        id: "home"
    },
    {
        displayName: "Home",
        icon: "Home",
        id: "experiencePlatformUI-home"
    },
    {
        displayName: "Identities",
        icon: "IdentityService",
        id: "identities"
    },
    {
        displayName: "Identities",
        icon: "IdentityService",
        id: "identity"
    },
    {
        displayName: "Journeys",
        icon: "Journey",
        id: "journeys",
        selectOn: [
            {
                path: "/journey-optimizer/journey/report"
            }
        ]
    },
    {
        displayName: "Journeys",
        icon: "Journey",
        id: "journeysNextAdmin"
    },
    {
        displayName: "Journeys",
        icon: "Journey",
        id: "journeysNextAuthoring"
    },
    {
        displayName: "Landing pages",
        icon: "LandingPages",
        id: "landingPages",
        selectOn: [
            {
                path: "/journey-optimizer/landing-page/report"
            }
        ]
    },
    {
        displayName: "Loyalty Challenge",
        icon: "InvertAdj",
        id: "ajoLoyaltyChallenge"
    },
    {
        displayName: "License Usage",
        icon: "LicenseUsage",
        id: "licenseUsage"
    },
    {
        displayName: "Messages",
        icon: "Message",
        id: "messages"
    },
    {
        displayName: "Models",
        icon: "Beaker",
        id: "model"
    },
    {
        displayName: "Monitoring",
        icon: "Monitorings",
        id: "monitoring"
    },
    {
        displayName: "Monitoring",
        icon: "Monitorings",
        id: "datacollectionmonitoring"
    },
    {
        displayName: "Notebooks",
        icon: "Code",
        id: "notebook"
    },
    {
        displayName: "Offers",
        icon: "Offer",
        id: "offer"
    },
    {
        displayName: "Components",
        icon: "OfferActivity",
        id: "offeractivity"
    },
    {
        displayName: "Policies",
        icon: "Privacy",
        id: "policy"
    },
    {
        displayName: "Audits",
        icon: "TaskList",
        id: "privacyAudit"
    },
    {
        displayName: "Profiles",
        icon: "User",
        id: "profile"
    },
    {
        displayName: "Queries",
        icon: "DataSearch",
        id: "query"
    },
    {
        displayName: "Requests",
        icon: "TaskList",
        id: "request"
    },
    {
        displayName: "Sandboxes",
        icon: "Actions",
        id: "sandbox"
    },
    {
        displayName: "Schemas",
        icon: "Schema",
        id: "schema"
    },
    {
        displayName: "Segments",
        icon: "Segmentation",
        id: "segment"
    },
    {
        displayName: "Audiences",
        icon: "Segmentation",
        id: "segmentAudience"
    },
    {
        displayName: "Segments",
        icon: "Segmentation",
        id: "accountSegments"
    },
    {
        displayName: "Subscription list",
        icon: "Subscriptions",
        id: "subscriptions",
        selectOn: [
            {
                path: "/journey-optimizer/subscription/report"
            }
        ]
    },
    {
        displayName: "Event Forwarding",
        icon: "ServerLaunch",
        id: "serverproperties"
    },
    {
        displayName: "Services",
        icon: "Service",
        id: "service"
    },
    {
        displayName: "Channels",
        icon: "Settings",
        id: "settings"
    },
    {
        displayName: "Sources",
        icon: "Source",
        id: "source"
    },
    {
        displayName: "Workflows",
        icon: "Merge",
        id: "workflow"
    },
    {
        displayName: "Business rules",
        icon: "BidRule",
        id: "businessRules"
    },
    {
        displayName: "Business rules",
        icon: "BidRule",
        id: "controlRules"
    },
    {
        displayName: "Tags",
        icon: "UnifiedTags",
        id: "unifiedTags"
    },
    {
        displayName: "Tags (Beta)",
        icon: "UnifiedTags",
        id: "unifiedTagsBeta"
    },
    {
        displayName: "Data Hygiene",
        icon: "DataCleansing",
        id: "dataCleansing"
    },
    {
        displayName: "Privacy Console",
        icon: "PrivacyConsole",
        id: "privacyConsole"
    },
    {
        displayName: "Playbooks",
        icon: "experience",
        id: "playbooks"
    },
    {
        displayName: "Initiatives",
        icon: "project",
        id: "initiatives"
    },
    {
        displayName: "Places",
        icon: "Places",
        id: "places"
    },
    {
        displayName: "Permissions",
        icon: "Permissions",
        id: "permissionsUI"
    },
    {
        displayName: "Content Templates",
        icon: "Experience",
        id: "contentTemplates"
    },
    {
        displayName: "Fragments",
        icon: "FilingCabinet",
        id: "fragments"
    },
    {
        displayName: "Overview",
        icon: "Home",
        id: "ammhome"
    },
    {
        displayName: "Marketing Campaigns",
        icon: "Journey",
        id: "marketingCampaign"
    },
    {
        displayName: "Reports",
        icon: "DataSearch",
        id: "report",
        selectOn: [
            {
                path: "/journey-optimizer/channel/report"
            }
        ]
    },
    {
        displayName: "Model Management",
        icon: "Service",
        id: "modelmanagement"
    },
    {
        displayName: "Scenarios",
        icon: "Offer",
        id: "scenario"
    },
    {
        displayName: "Models",
        icon: "FileData",
        id: "ammmodels"
    },
    {
        displayName: "Plans",
        icon: "FileChart",
        id: "ammplans"
    },
    {
        displayName: "Harmonized datasets",
        icon: "DataCheck",
        id: "ammharmonization"
    },
    {
        displayName: "Encryption",
        icon: "EncryptionKey",
        id: "platformUIEncryption"
    },
    {
        displayName: "Profiles",
        icon: "User",
        id: "prospectProfile"
    },
    {
        displayName: "Audiences",
        icon: "Segmentation",
        id: "prospectAudience"
    },
    {
        displayName: "Reports",
        icon: "FileTxt",
        id: "channelReporting"
    },
    {
        displayName: "Items",
        icon: "DecisionItems",
        id: "decisionItems"
    },
    {
        displayName: "Configuration",
        icon: "DecisionConfiguration",
        id: "decisionConfiguration"
    },
    {
        displayName: "Translation projects",
        icon: "GlobeGrid",
        id: "translationProjects"
    },
    {
        displayName: "Translations",
        icon: "GlobeGrid",
        id: "translationServiceAdmin"
    },
    {
        displayName: "Optimization metrics",
        icon: "SuccessMetric",
        id: "optimizationMetrics"
    },
    {
        displayName: "Home",
        icon: "Home",
        id: "sapphireHome",
        selectOn: [
            {
                path: "/journey-optimizer-b2b/home"
            }
        ]
    },
    {
        displayName: "Account Journeys",
        icon: "Journey",
        id: "sapphireAccountJourney",
        selectOn: [
            {
                path: "/journey-optimizer-b2b/account-journeys"
            }
        ]
    },
    {
        displayName: "Account Audiences",
        icon: "Segmentation",
        id: "sapphireAccountAudience",
        selectOn: [
            {
                path: "/journey-optimizer-b2b/platform/account/audience"
            }
        ]
    },
    {
        displayName: "Dashboard",
        icon: "Dashboard",
        id: "sapphireInsightsDashboard",
        selectOn: [
            {
                path: "/journey-optimizer-b2b/insights-dashboard"
            }
        ]
    },
    {
        displayName: "Buying Group Templates",
        icon: "Workflow",
        id: "sapphireBuyingGroupTemplates",
        selectOn: [
            {
                path: "/journey-optimizer-b2b/buying-groups"
            }
        ]
    },
    {
        displayName: "Assets",
        icon: "Asset",
        id: "sapphireMarketoAssets",
        selectOn: [
            {
                path: "/journey-optimizer-b2b/marketo-assets"
            },
            {
                path: "/journey-optimizer-b2b/assets-listing"
            }
        ]
    },
    {
        displayName: "Assets",
        icon: "Asset",
        id: "sapphireAssetListing",
        selectOn: [
            {
                path: "/journey-optimizer-b2b/assets-listing"
            }
        ]
    },
    {
        displayName: "Templates",
        icon: "Experience",
        id: "sapphireEmailTemplates",
        selectOn: [
            {
                path: "/journey-optimizer-b2b/email-templates"
            }
        ]
    },
    {
        displayName: "SMS API Credentials",
        icon: "Settings",
        id: "sapphireSMSConfig"
    },
    {
        displayName: "Account journeys",
        icon: "JourneyVoyager",
        id: "sapphireAccountJourneyV2",
        selectOn: [
            {
                path: "/journey-optimizer-b2b/account-journeys"
            }
        ]
    },
    {
        displayName: "Profiles",
        icon: "Building",
        id: "sapphireAccountProfiles"
    },
    {
        displayName: "Audiences",
        icon: "Enterprise",
        id: "sapphireAccountAudienceV2",
        selectOn: [
            {
                path: "/journey-optimizer-b2b/platform/account/audience"
            }
        ]
    },
    {
        displayName: "Buying groups",
        icon: "UserGroup",
        id: "sapphireBuyingGroupTemplatesV2",
        selectOn: [
            {
                path: "/journey-optimizer-b2b/buying-groups"
            }
        ]
    },
    {
        displayName: "Assets",
        icon: "Asset",
        id: "sapphireMarketoAssetsV2",
        selectOn: [
            {
                path: "/journey-optimizer-b2b/marketo-assets"
            },
            {
                path: "/journey-optimizer-b2b/assets-listing"
            }
        ]
    },
    {
        displayName: "Fragments",
        icon: "FilingCabinet",
        id: "sapphireFragments",
        selectOn: [
            {
                path: "/journey-optimizer-b2b/fragments"
            }
        ]
    },
    {
        displayName: "Schema",
        icon: "Schema",
        id: "sapphireSchema"
    },
    {
        displayName: "Datasets",
        icon: "Data",
        id: "sapphireDatasets"
    },
    {
        displayName: "Queries",
        icon: "SQLQuery",
        id: "sapphireQueries"
    },
    {
        displayName: "Monitoring",
        icon: "Monitoring",
        id: "sapphireMonitoring"
    },
    {
        displayName: "Audit log",
        icon: "TaskList",
        id: "sapphireAuditLog"
    },
    {
        displayName: "Configuration",
        icon: "Gears",
        id: "sapphireAdminConfig"
    },
    {
        displayName: "Channels",
        icon: "EmailGear",
        id: "sapphireChannelConfig",
        selectOn: [
            {
                path: "/journey-optimizer-b2b/channels-config"
            }
        ]
    },
    {
        displayName: "Permissions",
        icon: "UserLock",
        id: "sapphirePermissions"
    },
    {
        displayName: "Sources",
        icon: "Source",
        id: "sapphireSource"
    },
    {
        displayName: "Destinations",
        icon: "Destination",
        id: "sapphireDestination"
    },
    {
        displayName: "Requests",
        icon: "TaskList",
        id: "sapphireRequest"
    },
    {
        displayName: "Home",
        icon: "Home",
        id: "orionHome"
    },
    {
        displayName: "Campaigns",
        icon: "Promote",
        id: "orionCampaigns",
        selectOn: [
            {
                path: "/orion/reports/campaign"
            }
        ]
    },
    {
        displayName: "Journeys",
        icon: "Journey",
        id: "orionJourneys"
    },
    {
        displayName: "Assets",
        icon: "Asset",
        id: "orionAssets"
    },
    {
        displayName: "Audiences",
        icon: "Segmentation",
        id: "orionSegmentAudience"
    },
    {
        displayName: "Projects",
        icon: "DesktopAndMobile",
        id: "orionProjects"
    },
    {
        displayName: "Schemas",
        icon: "Schema",
        id: "orionSchemas"
    },
    {
        displayName: "Assets",
        icon: "Asset",
        id: "genStudioAssets"
    },
    {
        displayName: "Models",
        icon: "Models",
        id: "federatedModel"
    },
    {
        displayName: "Audit trail",
        icon: "Gears",
        id: "federatedAudit"
    },
    {
        displayName: "Federated Databases",
        icon: "FederatedDatabase",
        id: "federatedDatabase"
    }
];
module.exports = $e0176b7ac1a17338$var$capabilities;

});

parcelRegister("4OKVd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Shell = void 0;

var $gYPan = parcelRequire("gYPan");

var $38203aa4ae2f249d$var$localizationStringsShell = $38203aa4ae2f249d$var$_interopRequireWildcard((parcelRequire("gN0dh")));

var $38203aa4ae2f249d$var$_react = $38203aa4ae2f249d$var$_interopRequireDefault((parcelRequire("7eprg")));

var $38203aa4ae2f249d$var$_Shell = $38203aa4ae2f249d$var$_interopRequireDefault((parcelRequire("xjllR")));
function $38203aa4ae2f249d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $38203aa4ae2f249d$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $38203aa4ae2f249d$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $38203aa4ae2f249d$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $38203aa4ae2f249d$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $38203aa4ae2f249d$var$I18nShell = (props)=>/*#__PURE__*/ $38203aa4ae2f249d$var$_react.default.createElement($gYPan.IntlProvider, {
        messages: $38203aa4ae2f249d$var$localizationStringsShell
    }, /*#__PURE__*/ $38203aa4ae2f249d$var$_react.default.createElement($38203aa4ae2f249d$var$_Shell.default, props));
module.exports.Shell = $38203aa4ae2f249d$var$I18nShell;

});
parcelRegister("gN0dh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "en_US", {
    enumerable: true,
    get: function() {
        return $c39163453a01d9e4$var$_en_us.default;
    }
});
Object.defineProperty(module.exports, "de_DE", {
    enumerable: true,
    get: function() {
        return $c39163453a01d9e4$var$_de_de.default;
    }
});
Object.defineProperty(module.exports, "es_ES", {
    enumerable: true,
    get: function() {
        return $c39163453a01d9e4$var$_es_es.default;
    }
});
Object.defineProperty(module.exports, "fr_FR", {
    enumerable: true,
    get: function() {
        return $c39163453a01d9e4$var$_fr_fr.default;
    }
});
Object.defineProperty(module.exports, "it_IT", {
    enumerable: true,
    get: function() {
        return $c39163453a01d9e4$var$_it_it.default;
    }
});
Object.defineProperty(module.exports, "ja_JP", {
    enumerable: true,
    get: function() {
        return $c39163453a01d9e4$var$_ja_jp.default;
    }
});
Object.defineProperty(module.exports, "ko_KR", {
    enumerable: true,
    get: function() {
        return $c39163453a01d9e4$var$_ko_kr.default;
    }
});
Object.defineProperty(module.exports, "pt_BR", {
    enumerable: true,
    get: function() {
        return $c39163453a01d9e4$var$_pt_br.default;
    }
});
Object.defineProperty(module.exports, "zh_CN", {
    enumerable: true,
    get: function() {
        return $c39163453a01d9e4$var$_zh_cn.default;
    }
});
Object.defineProperty(module.exports, "zh_TW", {
    enumerable: true,
    get: function() {
        return $c39163453a01d9e4$var$_zh_tw.default;
    }
});

var $c39163453a01d9e4$var$_en_us = $c39163453a01d9e4$var$_interopRequireDefault((parcelRequire("jbt2n")));

var $c39163453a01d9e4$var$_de_de = $c39163453a01d9e4$var$_interopRequireDefault((parcelRequire("8987C")));

var $c39163453a01d9e4$var$_es_es = $c39163453a01d9e4$var$_interopRequireDefault((parcelRequire("iCtRV")));

var $c39163453a01d9e4$var$_fr_fr = $c39163453a01d9e4$var$_interopRequireDefault((parcelRequire("La51G")));

var $c39163453a01d9e4$var$_it_it = $c39163453a01d9e4$var$_interopRequireDefault((parcelRequire("2E5ek")));

var $c39163453a01d9e4$var$_ja_jp = $c39163453a01d9e4$var$_interopRequireDefault((parcelRequire("8Lp83")));

var $c39163453a01d9e4$var$_ko_kr = $c39163453a01d9e4$var$_interopRequireDefault((parcelRequire("2hPoW")));

var $c39163453a01d9e4$var$_pt_br = $c39163453a01d9e4$var$_interopRequireDefault((parcelRequire("cuBLS")));

var $c39163453a01d9e4$var$_zh_cn = $c39163453a01d9e4$var$_interopRequireDefault((parcelRequire("7ZM9Z")));

var $c39163453a01d9e4$var$_zh_tw = $c39163453a01d9e4$var$_interopRequireDefault((parcelRequire("g5OZ2")));
function $c39163453a01d9e4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("jbt2n", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"alpha":"Alpha","alphaFeedback":"Alpha Feedback","beta":"Beta","betaFeedback":"Beta Feedback","customReleaseTrial":"Trial","releaseBadgeAlpha":"Alpha","releaseBadgeBeta":"Beta","releaseBadgeDev":"Dev","releaseBadgePoc":"POC"}');

});

parcelRegister("8987C", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"alpha":"Alpha","alphaFeedback":"Alpha-Feedback","beta":"Beta","betaFeedback":"Beta-Feedback","customReleaseTrial":"Testversion","releaseBadgeAlpha":"Alpha","releaseBadgeBeta":"Beta","releaseBadgeDev":"Entw.","releaseBadgePoc":"POC"}');

});

parcelRegister("iCtRV", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"alpha":"Alfa","alphaFeedback":"Feedback de la versi\xf3n alfa","beta":"Beta","betaFeedback":"Comentarios sobre la beta","customReleaseTrial":"Versi\xf3n de prueba","releaseBadgeAlpha":"Alpha","releaseBadgeBeta":"Beta","releaseBadgeDev":"Dev","releaseBadgePoc":"POC"}');

});

parcelRegister("La51G", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"alpha":"Alpha","alphaFeedback":"Commentaires sur la version alpha","beta":"B\xeata","betaFeedback":"Commentaires sur la version b\xeata","customReleaseTrial":"Essai","releaseBadgeAlpha":"Alpha","releaseBadgeBeta":"Version b\xeata","releaseBadgeDev":"D\xe9veloppement","releaseBadgePoc":"POC"}');

});

parcelRegister("2E5ek", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"alpha":"Alfa","alphaFeedback":"Feedback alfa","beta":"Beta","betaFeedback":"Feedback beta","customReleaseTrial":"Versione di prova","releaseBadgeAlpha":"Alfa","releaseBadgeBeta":"Beta","releaseBadgeDev":"Dev","releaseBadgePoc":"PoC"}');

});

parcelRegister("8Lp83", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"alpha":"\u30A2\u30EB\u30D5\u30A1\u7248","alphaFeedback":"\u30A2\u30EB\u30D5\u30A1\u7248\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF","beta":"\u30D9\u30FC\u30BF\u7248","betaFeedback":"\u30D9\u30FC\u30BF\u7248\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF","customReleaseTrial":"\u4F53\u9A13\u7248","releaseBadgeAlpha":"\u30A2\u30EB\u30D5\u30A1\u7248","releaseBadgeBeta":"\u30D9\u30FC\u30BF\u7248","releaseBadgeDev":"\u958B\u767A","releaseBadgePoc":"POC"}');

});

parcelRegister("2hPoW", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"alpha":"Alpha","alphaFeedback":"Alpha \uD53C\uB4DC\uBC31","beta":"Beta","betaFeedback":"Beta \uD53C\uB4DC\uBC31","customReleaseTrial":"\uCCB4\uD5D8\uD310","releaseBadgeAlpha":"Alpha","releaseBadgeBeta":"Beta","releaseBadgeDev":"\uAC1C\uBC1C","releaseBadgePoc":"POC"}');

});

parcelRegister("cuBLS", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"alpha":"Alfa","alphaFeedback":"Feedback alfa","beta":"Beta","betaFeedback":"Feedback beta","customReleaseTrial":"Vers\xe3o de avalia\xe7\xe3o","releaseBadgeAlpha":"Alfa","releaseBadgeBeta":"Beta","releaseBadgeDev":"Desenvolvedor","releaseBadgePoc":"POC"}');

});

parcelRegister("7ZM9Z", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"alpha":"Alpha","alphaFeedback":"Alpha \u53CD\u9988","beta":"Beta","betaFeedback":"Beta \u53CD\u9988","customReleaseTrial":"\u8BD5\u7528\u7248","releaseBadgeAlpha":"Alpha","releaseBadgeBeta":"Beta","releaseBadgeDev":"\u5F00\u53D1","releaseBadgePoc":"POC"}');

});

parcelRegister("g5OZ2", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"alpha":"Alpha","alphaFeedback":"Alpha \u610F\u898B\u53CD\u61C9","beta":"Beta","betaFeedback":"Beta \u610F\u898B\u56DE\u994B","customReleaseTrial":"\u8A66\u7528","releaseBadgeAlpha":"Alpha","releaseBadgeBeta":"Beta","releaseBadgeDev":"Dev","releaseBadgePoc":"POC"}');

});


parcelRegister("xjllR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSidebarEnabled = $0642165fd4f17614$var$isSidebarEnabled;
module.exports.default = void 0;

var $ixDuS = parcelRequire("ixDuS");

var $0642165fd4f17614$var$_classnames = $0642165fd4f17614$var$_interopRequireDefault((parcelRequire("g3elz")));

var $bMVp5 = parcelRequire("bMVp5");

var $hCG2Z = parcelRequire("hCG2Z");

var $fKhPa = parcelRequire("fKhPa");

var $0642165fd4f17614$var$_metrics = $0642165fd4f17614$var$_interopRequireDefault((parcelRequire("83dfQ")));

var $iNslS = parcelRequire("iNslS");

var $clith = parcelRequire("clith");

var $0642165fd4f17614$var$_react = $0642165fd4f17614$var$_interopRequireWildcard((parcelRequire("7eprg")));

var $ctGaZ = parcelRequire("ctGaZ");

var $cTuWH = parcelRequire("cTuWH");

var $0642165fd4f17614$var$_ShellWait = $0642165fd4f17614$var$_interopRequireDefault((parcelRequire("a7nYS")));

var $iJaYo = parcelRequire("iJaYo");

var $h7OjM = parcelRequire("h7OjM");

function $0642165fd4f17614$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0642165fd4f17614$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0642165fd4f17614$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $0642165fd4f17614$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $0642165fd4f17614$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0642165fd4f17614$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

const $0642165fd4f17614$var$ShellBanner = /*#__PURE__*/ $0642165fd4f17614$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("bLRyE"));
    }).then((res)=>$0642165fd4f17614$var$_interopRequireWildcard(res)));

const $0642165fd4f17614$var$ShellNetworkError = /*#__PURE__*/ $0642165fd4f17614$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("ju1lB"));
    }).then((res)=>$0642165fd4f17614$var$_interopRequireWildcard(res)));

const $0642165fd4f17614$var$ShellSidebar = /*#__PURE__*/ $0642165fd4f17614$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("3vxZE"));
    }).then((res)=>$0642165fd4f17614$var$_interopRequireWildcard(res)));

const $0642165fd4f17614$var$AIAssistantNotProvisionedWarning = /*#__PURE__*/ $0642165fd4f17614$var$_react.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("6eBmf"));
    }).then((res)=>$0642165fd4f17614$var$_interopRequireWildcard(res))); // For local testing of ShellNetworkError, uncomment below
// setTimeout(() => import('./ShellNetworkError'), 5000);
const $0642165fd4f17614$var$MEDIUM_MAX_WIDTH = 950;
const $0642165fd4f17614$var$SMALL_MAX_WIDTH = 700;
const $0642165fd4f17614$var$X_SMALL_MAX_WIDTH = 575;
const $0642165fd4f17614$var$MONTH = 2592000000;
const $0642165fd4f17614$var$AI_POC_LIST = [
    "cloudManagerUi"
];
const $0642165fd4f17614$var$GEN_AI_AGREEMENT_KEY = "gen-ai-ga-agreement"; // "Enabled" means the Assistant's ShellHeaderAction is visible, but doesn't guarantee provisioning.
function $0642165fd4f17614$var$isSidebarEnabled(appId, hasAIPermission, featureFlags) {
    if (appId === "analytics") return false;
    if (appId === "cloudManagerUi" && featureFlags["shell-ai-chat-aem-lh"] === "true") return true;
    if ((0, $hCG2Z.getQueryValue)("aiChatEnabled") === "true") return true;
    return !!hasAIPermission;
}
function $0642165fd4f17614$var$getBusinessApp(parentId, appId) {
    if (appId === "shell-testapp") return "AEP";
     // TODO(rrp): this is a special case, but we should clean up the logic here.
    // The problem is that CJA has "AEP" as the parent app.
    if (appId === "platformAnalytics") return "CJA";
    return parentId || appId;
}
/**
 * Shell Super component for Experience Cloud UI.
 */ const $0642165fd4f17614$var$shellMetrics = $0642165fd4f17614$var$_metrics.default.create("exc.shell.container");
class $0642165fd4f17614$var$Shell extends $0642165fd4f17614$var$_react.default.Component {
    constructor(props){
        super(props);
        $0642165fd4f17614$var$_defineProperty(this, "hasPropChanged", (prevProps, fn)=>fn(prevProps) !== fn(this.props));
        $0642165fd4f17614$var$_defineProperty(this, "loadAIPermissions", ()=>{
            this.props.hasAssistantPermission().then((res)=>this.setState({
                    hasAIPermission: res
                }));
        });
        $0642165fd4f17614$var$_defineProperty(this, "isAIPOC", (appId)=>$0642165fd4f17614$var$AI_POC_LIST.includes(appId));
        $0642165fd4f17614$var$_defineProperty(this, "onToggleSidebar", async ({ force: force = false, forceState: forceState = false, query: query } = {})=>{
            const { isAIAssistantProvisioned: isAIAssistantProvisioned, isSidebarOpen: isOpen } = this.state;
            const isSidebarOpen = force ? forceState : !isOpen;
            if (isAIAssistantProvisioned === false && isSidebarOpen) {
                this.setState({
                    isAIWarningOpen: true
                });
                $0642165fd4f17614$var$shellMetrics.event("ai.chat.sidebar.show-provisioning-warning");
                return;
            }
            if (isSidebarOpen) {
                const { accepted: accepted } = await this.props.agreements.show($0642165fd4f17614$var$GEN_AI_AGREEMENT_KEY, {
                    type: $ixDuS.AGREEMENT_TYPE.AI
                });
                if (!accepted) return;
            }
            this.setState({
                initialAIQuery: query,
                isSidebarOpen: isSidebarOpen
            });
            isSidebarOpen || this.aiToggleRef.current?.focus();
            $0642165fd4f17614$var$shellMetrics.event("ai.chat.sidebar.open", {
                force: force,
                isSidebarOpen: isSidebarOpen
            });
        });
        $0642165fd4f17614$var$_defineProperty(this, "onResize", ()=>{
            const width = window.innerWidth;
            let newSize;
            if (width > $0642165fd4f17614$var$MEDIUM_MAX_WIDTH) newSize = $clith.PAGE_SIZES.LARGE;
            else if (width <= $0642165fd4f17614$var$X_SMALL_MAX_WIDTH) newSize = $clith.PAGE_SIZES.EXTRA_SMALL;
            else if (width <= $0642165fd4f17614$var$SMALL_MAX_WIDTH) newSize = $clith.PAGE_SIZES.SMALL;
            else newSize = $clith.PAGE_SIZES.MEDIUM;
            newSize !== this.state.size && this.setState({
                size: newSize
            });
        });
        $0642165fd4f17614$var$_defineProperty(this, "dismissAIWarning", ()=>this.setState({
                isAIWarningOpen: false
            }));
        $0642165fd4f17614$var$_defineProperty(this, "canShowAjoBanner", ()=>this.props.parentId === "CJM" && !this.state.hideAjoBanner);
        $0642165fd4f17614$var$_defineProperty(this, "onAjoBannerDismiss", ()=>{
            $iJaYo.storage.local.set("ajoBannerDismissedPhase2", true, $0642165fd4f17614$var$MONTH);
            this.setState({
                hideAjoBanner: true
            });
        });
        this.state = {
            hasAIPermission: undefined,
            hasDeferredComponents: false,
            hideAjoBanner: true,
            isAIAssistantProvisioned: undefined,
            isAIWarningOpen: false,
            isNotOutlined: true,
            isSidebarOpen: false,
            segmentedCustomLabels: (0, $cTuWH.segmentCustomLabels)(props.customEnvLabel),
            size: $clith.PAGE_SIZES.LARGE
        };
        this.aiToggleRef = /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createRef();
    }
    componentDidMount() {
        window.addEventListener("resize", this.onResize);
        (0, $h7OjM.trackOmega)("shell.omega", window, Boolean((0, $hCG2Z.getQueryValue)("debugOmega")));
        this.onResize();
        this.loadDeferred();
        this.loadAIAssistantProvisioning();
        this.loadAIPermissions();
    }
    componentDidUpdate(prevProps) {
        // Workspaces update late sometimes, so need to run again when updated.
        const { agreements: agreements, customEnvLabel: customEnvLabel, selectedImsOrg: selectedImsOrg, workspaces: workspaces } = this.props;
        const { isAIAssistantProvisioned: isAIAssistantProvisioned } = this.state;
        const stateConfig = {};
        if (prevProps.workspaces && workspaces && prevProps.workspaces.length !== workspaces.length) this.onResize();
        if (!prevProps.deferredComponentsPromise) this.loadDeferred();
        if (JSON.stringify(customEnvLabel) !== JSON.stringify(prevProps.customEnvLabel)) stateConfig.segmentedCustomLabels = (0, $cTuWH.segmentCustomLabels)(customEnvLabel);
        if (typeof isAIAssistantProvisioned === "undefined") this.loadAIAssistantProvisioning();
        if (prevProps.selectedImsOrg && prevProps.selectedImsOrg !== selectedImsOrg) {
            agreements.get($0642165fd4f17614$var$GEN_AI_AGREEMENT_KEY).then((res)=>{
                res?.accepted !== true && this.state.isSidebarOpen && this.setState({
                    isSidebarOpen: false
                });
            });
            this.loadAIPermissions();
            this.loadAIAssistantProvisioning();
        } // If the sandbox or app changed, reload the AI permissions.
        const shouldReloadAIPermissions = this.hasPropChanged(prevProps, (props)=>props?.sandbox?.selected?.name) || this.hasPropChanged(prevProps, (props)=>props?.selectedImsOrg) || this.hasPropChanged(prevProps, (props)=>props?.appId);
        shouldReloadAIPermissions && this.loadAIPermissions();
        Object.keys(stateConfig).length && this.setState(stateConfig);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.onResize);
    }
    loadDeferred() {
        this.props.deferredComponentsPromise?.then((deferredComponents)=>{
            this.deferredComponents = deferredComponents;
            this.setState({
                hasDeferredComponents: true
            });
        });
    }
    // "Not provisioned" means launching the AI Assistant will trigger a dialog
    // that explains the user doesn't have access because additional legal terms
    // must be agreed to.
    async loadAIAssistantProvisioning() {
        const { appId: appId, featureFlags: featureFlags, getLDFeatureFlags: getLDFeatureFlags } = this.props;
        const { hasAIPermission: hasAIPermission } = this.state;
        if (!$0642165fd4f17614$var$isSidebarEnabled(appId, hasAIPermission, featureFlags)) return;
         // AI POC apps don't need to adhere to the assistant permissions check.
        if (this.isAIPOC(appId)) {
            this.setState({
                isAIAssistantProvisioned: true
            });
            return;
        }
        const flags = await getLDFeatureFlags([
            "aep-co-pilot"
        ]);
        this.setState({
            isAIAssistantProvisioned: flags["aep-co-pilot"]["assistant-permissions-enabled"] === "true"
        });
    }
    render() {
        const { accessOverridesEnabled: accessOverridesEnabled, appContainer: appContainer, appId: appId, appRoot: appRoot, appTheme: appTheme, authId: authId, backgroundReady: backgroundReady, basePath: basePath, children: children, closeLanguagePicker: closeLanguagePicker, coachMark: coachMark, currentActiveTenantId: currentActiveTenantId, customHeroClick: customHeroClick, customProfileButtons: customProfileButtons, customSearch: customSearch, devMode: devMode, disableShellFeedbackButton: disableShellFeedbackButton, environment: environment, featureFlags: featureFlags, feedback: feedback, getCapabilityWithIconUrl: getCapabilityWithIconUrl, globalSearch: globalSearch, hasAccountClusterData: hasAccountClusterData, helpCenterConfig: helpCenterConfig, imsOrgs: imsOrgs, internal: internal, intl: intl, isImpersonating: isImpersonating, landingpage: landingpage, locale: locale, localeData: localeData, modal: modal, networkErrorProps: networkErrorProps, noAccess: noAccess, onCustomProfileButtonClick: onCustomProfileButtonClick, onGlobalDialogOpen: onGlobalDialogOpen, onImsOrgChange: onImsOrgChange, onLanguageChange: onLanguageChange, onSetUserTheme: onSetUserTheme, onSignOutClick: onSignOutClick, onSolutionClick: onSolutionClick, orgToSubOrgsMap: orgToSubOrgsMap, parentId: parentId, profile: profile, pulse: pulse, preferredLanguages: preferredLanguages, recentSandboxes: recentSandboxes, registerKeyHandler: registerKeyHandler, releaseType: releaseType, sandbox: sandbox, selectedImsOrg: selectedImsOrg, selectedSideNavItemId: selectedSideNavItemId, selectedSubOrg: selectedSubOrg, selectedWorkspaceId: selectedWorkspaceId, serviceEnvironment: serviceEnvironment, services: services, settingsData: settingsData, settingsService: settingsService, showDebugModal: showDebugModal, showLanguagePicker: showLanguagePicker, showToast: showToast, sideNav: sideNav = {}, solutionIcon: solutionIcon, solutionReleaseType: solutionReleaseType, solutions: solutions, solutionShortTitle: solutionShortTitle, solutionTitle: solutionTitle, subOrgAccessOnlyOnCurrentOrg: subOrgAccessOnlyOnCurrentOrg, theme: theme, toastPlacement: toastPlacement, translationService: translationService, userAvatar: userAvatar, userRecentSandboxesHandler: userRecentSandboxesHandler, userToken: userToken, workHubResponse: workHubResponse, workspaces: workspaces } = this.props;
        const { hasAIPermission: hasAIPermission, hasDeferredComponents: hasDeferredComponents, initialAIQuery: initialAIQuery, isAIAssistantProvisioned: isAIAssistantProvisioned, isAIWarningOpen: isAIWarningOpen, isSidebarOpen: isSidebarOpen, segmentedCustomLabels: segmentedCustomLabels, size: size } = this.state;
        const aiSidebarEnabled = $0642165fd4f17614$var$isSidebarEnabled(appId, hasAIPermission, featureFlags);
        const ShellHeader = hasDeferredComponents ? this.deferredComponents.ShellHeader : "header";
        const releaseTypeMessages = {
            [$bMVp5.CustomRelease.TRIAL]: intl.formatMessage({
                defaultMessage: "Trial",
                description: "Label for Trial software access",
                id: "customReleaseTrial"
            }),
            [$ctGaZ.RELEASE_TYPE.ALPHA]: intl.formatMessage({
                defaultMessage: "Alpha",
                description: "Label for ALPHA service lifecycle",
                id: "releaseBadgeAlpha"
            }),
            [$ctGaZ.RELEASE_TYPE.BETA]: intl.formatMessage({
                defaultMessage: "Beta",
                description: "Label for BETA service lifecycle",
                id: "releaseBadgeBeta"
            }),
            [$ctGaZ.RELEASE_TYPE.DEV]: intl.formatMessage({
                defaultMessage: "Dev",
                description: "Label for DEV service lifecycle",
                id: "releaseBadgeDev"
            }),
            [$ctGaZ.RELEASE_TYPE.POC]: intl.formatMessage({
                defaultMessage: "POC",
                description: "Label for POC service lifecycle",
                id: "releaseBadgePoc"
            })
        };
        const ShellHeaderProps = hasDeferredComponents ? {
            accessOverridesEnabled: accessOverridesEnabled,
            aiSidebarEnabled: aiSidebarEnabled,
            aiToggleRef: this.aiToggleRef,
            appContainer: appContainer,
            appId: appId,
            appRoot: appRoot,
            appTheme: appTheme,
            backgroundReady: backgroundReady,
            basePath: basePath,
            coachMark: coachMark,
            currentActiveTenantId: currentActiveTenantId,
            customHeroClick: customHeroClick,
            customProfileButtons: customProfileButtons,
            customSearch: customSearch,
            devMode: devMode,
            disableShellFeedbackButton: disableShellFeedbackButton,
            environment: environment,
            featureFlags: featureFlags,
            feedback: feedback,
            globalSearch: {
                ...globalSearch,
                SearchWidget: this.deferredComponents.SearchWidget
            },
            hasAccountClusterData: hasAccountClusterData,
            helpCenterConfig: helpCenterConfig,
            imsOrgs: imsOrgs,
            internal: internal,
            isImpersonating: isImpersonating,
            landingpage: landingpage,
            locale: locale,
            localeData: localeData,
            modal: modal,
            noAccess: noAccess,
            onCustomProfileButtonClick: onCustomProfileButtonClick,
            onGlobalDialogOpen: onGlobalDialogOpen,
            onImsOrgChange: onImsOrgChange,
            onLanguageChange: onLanguageChange,
            onSetUserTheme: onSetUserTheme,
            onSignOutClick: onSignOutClick,
            onSolutionClick: onSolutionClick,
            onToggleSidebar: this.onToggleSidebar,
            orgToSubOrgsMap: orgToSubOrgsMap,
            parentId: parentId,
            preferredLanguages: preferredLanguages,
            pulse: pulse,
            recentSandboxes: recentSandboxes,
            registerKeyHandler: registerKeyHandler,
            releaseTypeMessages: releaseTypeMessages,
            sandbox: sandbox,
            segmentedCustomLabels: segmentedCustomLabels,
            selectedImsOrg: selectedImsOrg,
            selectedSubOrg: selectedSubOrg,
            selectedWorkspaceId: selectedWorkspaceId,
            serviceEnvironment: serviceEnvironment,
            services: services,
            settingsData: settingsData,
            settingsService: settingsService,
            showDebugModal: showDebugModal,
            sidebarOpen: isSidebarOpen,
            sideNav: sideNav,
            size: size,
            solutionIcon: solutionIcon,
            solutionReleaseType: solutionReleaseType,
            solutions: solutions,
            solutionShortTitle: solutionShortTitle,
            solutionTitle: solutionTitle,
            subOrgAccessOnlyOnCurrentOrg: subOrgAccessOnlyOnCurrentOrg,
            theme: theme,
            toastPlacement: toastPlacement,
            translationService: translationService,
            userAvatar: userAvatar,
            userEmail: profile.email,
            userFirstName: profile.first_name,
            userLastName: profile.last_name,
            userName: profile.name,
            userRecentSandboxesHandler: userRecentSandboxesHandler,
            userTitle: profile.job_function,
            userToken: userToken,
            workHubResponse: workHubResponse,
            workspaces: workspaces
        } : {
            className: `spectrum-Shell spectrum--${theme || "lightest"} spectrum-Shell-headingContainer`
        };
        let AlertsContainer = null;
        if (hasDeferredComponents) AlertsContainer = this.deferredComponents.AlertsContainer;
        const ShellSideNav = hasDeferredComponents ? this.deferredComponents.ShellSideNav : ()=>null;
        if (!disableShellFeedbackButton) {
            const feedbackReleaseTypes = [
                $ctGaZ.RELEASE_TYPE.ALPHA,
                $ctGaZ.RELEASE_TYPE.BETA
            ];
            const releaseTypes = [
                releaseType,
                solutionReleaseType
            ];
            const isAlphaOrBeta = !!feedbackReleaseTypes.filter((value)=>releaseTypes.includes(value)).length; // Only modify the feedback property if the releaseType or
            // solutionReleaseType is Alpha or Beta. In the other scenarios, the
            // feedback property should not be overwritten, as it will have come from
            // an API call from the application.
            if (isAlphaOrBeta) // If the feedback button hasn't been explicitly disabled,
            // check if the pre-release values are Alpha or Beta.
            // The order of the release types is important here.
            ShellHeaderProps.feedback = [
                releaseType,
                solutionReleaseType
            ].reduce((button, release)=>{
                if (button) // If we already have a button, then we're done
                return button;
                if (feedbackReleaseTypes.includes(release)) // If the pre-release value is Alpha or Beta, then we need to show the button
                return release === $ctGaZ.RELEASE_TYPE.ALPHA ? {
                    buttonLabel: intl.formatMessage({
                        defaultMessage: "Alpha Feedback",
                        description: "Alpha feedback button label",
                        id: "alphaFeedback"
                    }),
                    enabled: true,
                    type: "openFeedback"
                } : {
                    buttonLabel: intl.formatMessage({
                        defaultMessage: "Beta Feedback",
                        description: "Beta feedback button label",
                        id: "betaFeedback"
                    }),
                    enabled: true,
                    type: "openFeedback"
                };
            }, undefined);
        } // Add magenta border
        isImpersonating ? document.body.classList.add("impersonation") : document.body.classList.remove("impersonation");
        const businessApp = $0642165fd4f17614$var$getBusinessApp(parentId, appId);
        return /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement("div", {
            className: "spectrum-ShellContainer",
            "data-omega-feature": "shell header",
            "data-omega-widget": "shell header buttons",
            "data-omega-widget-type": "button"
        }, networkErrorProps?.showNetworkDisconnected && /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement($0642165fd4f17614$var$_react.Suspense, {
            fallback: null
        }, /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement($0642165fd4f17614$var$ShellNetworkError, networkErrorProps)), /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement(ShellHeader, ShellHeaderProps), /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement("div", {
            className: (0, $0642165fd4f17614$var$_classnames.default)("spectrum-ShellContainer-content", {
                "can-takeover": appContainer,
                "has-appContainer": appContainer,
                "modal-open": modal
            })
        }, hasDeferredComponents && showLanguagePicker && /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement($0642165fd4f17614$var$_react.Suspense, {
            fallback: /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement($0642165fd4f17614$var$_ShellWait.default, null)
        }, /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement(this.deferredComponents.ShellLanguagePicker, {
            authId: authId,
            closeLanguagePicker: closeLanguagePicker,
            locale: locale,
            onLanguageChange: onLanguageChange,
            serviceEnvironment: serviceEnvironment,
            showLanguagePicker: showLanguagePicker,
            userToken: userToken
        })), sideNav.config && /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement($0642165fd4f17614$var$_react.Suspense, {
            fallback: null
        }, /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement(ShellSideNav, {
            appContainer: appContainer,
            appId: appId,
            env: environment,
            featureFlags: featureFlags,
            getCapabilityWithIconUrl: getCapabilityWithIconUrl,
            isOpen: sideNav.enabled && sideNav.open,
            locale: locale,
            modal: modal,
            orgId: selectedImsOrg,
            releaseTypeMessages: releaseTypeMessages,
            selectedSideNavItemId: selectedSideNavItemId,
            settingsService: settingsService,
            sideNavConfig: sideNav.config,
            sideNavOpenByHover: sideNav.openByHover,
            theme: theme,
            toggleSideNav: sideNav.toggle,
            userId: profile.authId,
            workHubResponse: workHubResponse
        })), this.canShowAjoBanner() && /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement($0642165fd4f17614$var$_react.Suspense, {
            fallback: null
        }, /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement($0642165fd4f17614$var$ShellBanner, {
            locale: locale,
            onDismiss: this.onAjoBannerDismiss,
            sideNavOpen: sideNav.enabled && sideNav.open
        })), children, AlertsContainer && /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement($0642165fd4f17614$var$_react.Suspense, {
            fallback: null
        }, /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement(AlertsContainer, {
            theme: theme
        })), aiSidebarEnabled && (isAIAssistantProvisioned ? /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement($0642165fd4f17614$var$_react.Suspense, {
            fallback: null
        }, /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement($0642165fd4f17614$var$ShellSidebar, {
            appContainer: appContainer,
            appId: appId,
            authId: profile.authId,
            avatar: profile.avatar,
            businessApp: businessApp,
            debugEnabled: featureFlags?.["co-pilot-review-enabled"] === "true",
            email: profile.email || "",
            env: environment,
            featureFlags: featureFlags,
            initialQuery: initialAIQuery,
            isPOC: this.isAIPOC(appId),
            onClose: this.onToggleSidebar,
            open: isSidebarOpen,
            orgId: selectedImsOrg,
            sandboxName: sandbox.selected?.name,
            services: services,
            settingsService: settingsService,
            showToast: showToast
        })) : /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement($0642165fd4f17614$var$_react.Suspense, {
            fallback: null
        }, /*#__PURE__*/ $0642165fd4f17614$var$_react.default.createElement($0642165fd4f17614$var$AIAssistantNotProvisionedWarning, {
            isOpen: isAIWarningOpen,
            onDismiss: this.dismissAIWarning
        })))));
    }
}
$0642165fd4f17614$var$Shell.defaultProps = {
    appContainer: null,
    backgroundReady: false,
    currentActiveTenantId: "",
    customButtons: [],
    customSearch: {
        enabled: false,
        onClick: ()=>{},
        open: false
    },
    hasAccountClusterData: false,
    helpCenterConfig: {},
    landingpage: {},
    locale: "en-US",
    noAccess: false,
    onCustomButtonClick: $iNslS.NOOP,
    onImsOrgChange: $iNslS.NOOP,
    onSignOutClick: $iNslS.NOOP,
    onSolutionClick: $iNslS.NOOP,
    releaseType: $ctGaZ.RELEASE_TYPE.GA,
    sandbox: {
        enabled: false,
        onChange: $iNslS.NOOP,
        sandboxes: [],
        selected: null
    },
    selectedWorkspaceId: "",
    services: [],
    showDebugModal: null,
    solutionReleaseType: $ctGaZ.RELEASE_TYPE.GA,
    solutions: [],
    solutionShortTitle: "AEC",
    solutionTitle: "Adobe Experience Cloud",
    userAvatar: undefined,
    userName: "Adobe User",
    userTitle: undefined,
    workspaces: []
};
var $0642165fd4f17614$var$_default = (0, $fKhPa.default)($0642165fd4f17614$var$Shell);
module.exports.default = $0642165fd4f17614$var$_default;

});
parcelRegister("ixDuS", function(module, exports) {
"use strict";
/*************************************************************************
 * Copyright 2024 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OPERATIONS = module.exports.AGREEMENT_TYPE = void 0;

var $4jIM2 = parcelRequire("4jIM2");
var $d7f9f25677cd4a4b$var$AGREEMENT_TYPE;
(function(AGREEMENT_TYPE) {
    AGREEMENT_TYPE["AI"] = "AI";
    AGREEMENT_TYPE["BETA"] = "BETA";
})($d7f9f25677cd4a4b$var$AGREEMENT_TYPE = module.exports.AGREEMENT_TYPE || (module.exports.AGREEMENT_TYPE = {}));
var $d7f9f25677cd4a4b$var$OPERATIONS;
(function(OPERATIONS) {
    OPERATIONS["CLEAR"] = "clear";
    OPERATIONS["GET"] = "get";
    OPERATIONS["SHOW"] = "show";
})($d7f9f25677cd4a4b$var$OPERATIONS = module.exports.OPERATIONS || (module.exports.OPERATIONS = {}));
const $d7f9f25677cd4a4b$var$agreements = {
    clearResponse: (key, options)=>(0, $4jIM2.getImpl)("agreements")().clearResponse(key, options),
    getResponse: (key, options)=>(0, $4jIM2.getImpl)("agreements")().getResponse(key, options),
    showAgreement: (key, options)=>(0, $4jIM2.getImpl)("agreements")().showAgreement(key, options)
};
module.exports.default = $d7f9f25677cd4a4b$var$agreements;

});

parcelRegister("clith", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateElementWidth = module.exports.PAGE_SIZES = module.exports.SECOND_ACTION_BAR_ITEMS = module.exports.ELEMENT_INDICES = module.exports.resizingOrder = module.exports.ELEMENTS = module.exports.HEADING_CONTAINER_RIGHT_MARGIN = module.exports.SEARCH_ICON_WIDTH = module.exports.SEARCHBAR_WIDTH = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $8f920524b1f27e77$var$SEARCHBAR_WIDTH = 260;
module.exports.SEARCHBAR_WIDTH = $8f920524b1f27e77$var$SEARCHBAR_WIDTH;
const $8f920524b1f27e77$var$SEARCH_ICON_WIDTH = 48;
module.exports.SEARCH_ICON_WIDTH = $8f920524b1f27e77$var$SEARCH_ICON_WIDTH;
const $8f920524b1f27e77$var$HEADING_CONTAINER_RIGHT_MARGIN = 16;
module.exports.HEADING_CONTAINER_RIGHT_MARGIN = $8f920524b1f27e77$var$HEADING_CONTAINER_RIGHT_MARGIN;
let $8f920524b1f27e77$var$ELEMENTS;
module.exports.ELEMENTS = $8f920524b1f27e77$var$ELEMENTS;
(function(ELEMENTS) {
    ELEMENTS["APP_SWITCHER"] = "app-switcher-button";
    ELEMENTS["CUSTOM_SEARCH"] = "custom-search";
    ELEMENTS["ENV_LABELS"] = "env-labels";
    ELEMENTS["FEEDBACK"] = "feedback-button";
    ELEMENTS["GLOBAL_SEARCH"] = "global-search-placeholder";
    ELEMENTS["GLOBAL_SEARCH_ICON"] = "search-menu";
    ELEMENTS["HELP"] = "help-menu";
    ELEMENTS["HERO"] = "hero-title";
    ELEMENTS["ORG_SWITCHER"] = "org-button";
    ELEMENTS["OTHER_LABELS"] = "other-labels";
    ELEMENTS["PULSE"] = "pulse-button";
    ELEMENTS["SANDBOX"] = "sandbox-button-text";
    ELEMENTS["SIDEBAR"] = "sidebar-button";
})($8f920524b1f27e77$var$ELEMENTS || (module.exports.ELEMENTS = $8f920524b1f27e77$var$ELEMENTS = {}));
const $8f920524b1f27e77$var$resizingOrder = [
    [
        $8f920524b1f27e77$var$ELEMENTS.GLOBAL_SEARCH
    ],
    [
        $8f920524b1f27e77$var$ELEMENTS.PULSE,
        $8f920524b1f27e77$var$ELEMENTS.HELP
    ],
    [
        $8f920524b1f27e77$var$ELEMENTS.CUSTOM_SEARCH
    ],
    [
        $8f920524b1f27e77$var$ELEMENTS.FEEDBACK
    ],
    [
        $8f920524b1f27e77$var$ELEMENTS.SANDBOX
    ],
    [
        $8f920524b1f27e77$var$ELEMENTS.APP_SWITCHER
    ],
    [
        $8f920524b1f27e77$var$ELEMENTS.GLOBAL_SEARCH_ICON
    ],
    [
        $8f920524b1f27e77$var$ELEMENTS.SIDEBAR
    ],
    [
        $8f920524b1f27e77$var$ELEMENTS.HERO
    ],
    [
        $8f920524b1f27e77$var$ELEMENTS.HERO
    ],
    [
        $8f920524b1f27e77$var$ELEMENTS.ORG_SWITCHER
    ],
    [
        $8f920524b1f27e77$var$ELEMENTS.ENV_LABELS
    ],
    [
        $8f920524b1f27e77$var$ELEMENTS.OTHER_LABELS
    ]
];
module.exports.resizingOrder = $8f920524b1f27e77$var$resizingOrder;
const $8f920524b1f27e77$var$ELEMENT_INDICES = {
    [$8f920524b1f27e77$var$ELEMENTS.GLOBAL_SEARCH]: 0,
    [$8f920524b1f27e77$var$ELEMENTS.HELP]: 1,
    [$8f920524b1f27e77$var$ELEMENTS.PULSE]: 1,
    [$8f920524b1f27e77$var$ELEMENTS.CUSTOM_SEARCH]: 2,
    [$8f920524b1f27e77$var$ELEMENTS.FEEDBACK]: 3,
    [$8f920524b1f27e77$var$ELEMENTS.SANDBOX]: 4,
    [$8f920524b1f27e77$var$ELEMENTS.APP_SWITCHER]: 5,
    [$8f920524b1f27e77$var$ELEMENTS.GLOBAL_SEARCH_ICON]: 6,
    [$8f920524b1f27e77$var$ELEMENTS.SIDEBAR]: 7,
    [$8f920524b1f27e77$var$ELEMENTS.HERO]: 8,
    [$8f920524b1f27e77$var$ELEMENTS.ORG_SWITCHER]: 10,
    [$8f920524b1f27e77$var$ELEMENTS.ENV_LABELS]: 11,
    [$8f920524b1f27e77$var$ELEMENTS.OTHER_LABELS]: 12
};
module.exports.ELEMENT_INDICES = $8f920524b1f27e77$var$ELEMENT_INDICES;
const $8f920524b1f27e77$var$SECOND_ACTION_BAR_ITEMS = [
    $8f920524b1f27e77$var$ELEMENTS.ENV_LABELS,
    $8f920524b1f27e77$var$ELEMENTS.OTHER_LABELS,
    $8f920524b1f27e77$var$ELEMENTS.FEEDBACK
];
module.exports.SECOND_ACTION_BAR_ITEMS = $8f920524b1f27e77$var$SECOND_ACTION_BAR_ITEMS;
let $8f920524b1f27e77$var$PAGE_SIZES;
/**
 * Turns a string representation of pixel style value into a number
 * @param {string} style The pixel value
 * @returns The numeric pixel value
 */ module.exports.PAGE_SIZES = $8f920524b1f27e77$var$PAGE_SIZES;
(function(PAGE_SIZES) {
    PAGE_SIZES["LARGE"] = "L";
    PAGE_SIZES["MEDIUM"] = "M";
    PAGE_SIZES["SMALL"] = "S";
    PAGE_SIZES["EXTRA_SMALL"] = "XS";
})($8f920524b1f27e77$var$PAGE_SIZES || (module.exports.PAGE_SIZES = $8f920524b1f27e77$var$PAGE_SIZES = {}));
const $8f920524b1f27e77$var$parsePixels = (style)=>parseInt(style.replace("px", ""));
/**
 * Returns the extra width added to the element by padding, border, and margin,
 * and, in the case of the sandbox button text and pulse menu, the extra width of the parent.
 * @param {Element} element The element to calculate the extra width of
 * @returns {number} The extra width not included in the clientWidth of the element
 */ const $8f920524b1f27e77$var$getExtraWidth = (element)=>{
    const style = getComputedStyle(element);
    let extraWidth = $8f920524b1f27e77$var$parsePixels(style.marginLeft) + $8f920524b1f27e77$var$parsePixels(style.marginRight) + $8f920524b1f27e77$var$parsePixels(style.borderWidth) * 2; // For the sandbox text, removing the label also removes the margin around the entire element, as the badge has its own margin
    // For custom search, the margin is added to the div surrounding the button
    if ([
        $8f920524b1f27e77$var$ELEMENTS.CUSTOM_SEARCH,
        $8f920524b1f27e77$var$ELEMENTS.SANDBOX
    ].includes(element.id) && element.parentElement) extraWidth += $8f920524b1f27e77$var$getExtraWidth(element.parentElement);
     // Pulse sometimes has a wrapper and sometimes doesn't, so we need to check
    if (element.id === $8f920524b1f27e77$var$ELEMENTS.PULSE && element.parentElement && !element.parentElement.className) extraWidth += $8f920524b1f27e77$var$getExtraWidth(element.parentElement);
     // There is a 10px gap between the labels and the release badge/workspaces
    if ([
        $8f920524b1f27e77$var$ELEMENTS.ENV_LABELS,
        $8f920524b1f27e77$var$ELEMENTS.OTHER_LABELS
    ].includes(element.id)) extraWidth += 10;
     // The hero icon gains an extra 7px margin when the title is removed
    if (element.id === $8f920524b1f27e77$var$ELEMENTS.HERO) extraWidth -= 7;
    return extraWidth;
};
/**
 * Given an id, find the element and calculate its width, including extra width (margin, padding, border)
 * @param {string} id The id to use to query
 * @returns {number} The width of the element
 */ const $8f920524b1f27e77$var$calculateElementWidth = (id)=>{
    const element = document.querySelector(`#${id}`);
    if (element) {
        // Removing the searchbar adds the search icon to the header
        if (id === $8f920524b1f27e77$var$ELEMENTS.GLOBAL_SEARCH) return element.clientWidth - $8f920524b1f27e77$var$SEARCH_ICON_WIDTH;
        return element.clientWidth + $8f920524b1f27e77$var$getExtraWidth(element);
    }
    return 0;
};
module.exports.calculateElementWidth = $8f920524b1f27e77$var$calculateElementWidth;

});

parcelRegister("cTuWH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.segmentCustomLabels = module.exports.getOrgDisplayName = void 0;

var $bMVp5 = parcelRequire("bMVp5");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * Gets display name for org switcher button based on selected orgs and sub orgs.
 * @param {string[]} imsOrgs List of IMS orgs.
 * @param {string} selectedImsOrg The current selected IMS org.
 * @param {string} selectedSubOrg The current selected sub org if existing.
 * @param {Object<String, Object[]>} orgToSubOrgsMap Maps IMS org ids to list of sub orgs.
 */ const $9632a044fcca3076$var$getOrgDisplayName = (imsOrgs = [], selectedImsOrg, selectedSubOrg, orgToSubOrgsMap = {})=>{
    if (Object.keys(orgToSubOrgsMap).length && selectedSubOrg && orgToSubOrgsMap[selectedImsOrg] && orgToSubOrgsMap[selectedImsOrg].length > 1) return selectedSubOrg.name;
    const imsOrgDisplayName = imsOrgs.find(({ value: value })=>value === selectedImsOrg);
    return imsOrgDisplayName && imsOrgDisplayName.label;
};
/**
 * Takes the config value of `customEnvLabel` and filters the items.
 * The returned object uses the CustomLabelType enum for keys.
 * It returns a single CustomLabelDesc for CustomLabelType.RELEASE or undefined.
 * All other keys return an array.
 * @param {Array<CustomLabelDesc>} customEnvLabel
 * @returns {Object<CustomLabelType, CustomLabelDesc[] | CustomLabelDesc | undefined>}
 */ module.exports.getOrgDisplayName = $9632a044fcca3076$var$getOrgDisplayName;
const $9632a044fcca3076$var$segmentCustomLabels = (customEnvLabel)=>({
        [$bMVp5.CustomLabelType.ENVIRONMENT]: customEnvLabel.filter((l)=>l.type === $bMVp5.CustomLabelType.ENVIRONMENT),
        [$bMVp5.CustomLabelType.RELEASE]: customEnvLabel.find((l)=>l.type === $bMVp5.CustomLabelType.RELEASE)
    });
module.exports.segmentCustomLabels = $9632a044fcca3076$var$segmentCustomLabels;

});

parcelRegister("h7OjM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getOmegaEvent = $86a402fa9e025355$var$getOmegaEvent;
Object.defineProperty(module.exports, "trackOmega", {
    enumerable: true,
    get: function() {
        return $4TRME.trackOmega;
    }
});
Object.defineProperty(module.exports, "sendOmegaEvent", {
    enumerable: true,
    get: function() {
        return $bchKo.sendOmegaEvent;
    }
});
module.exports.filterOmegaProps = void 0;

var $4TRME = parcelRequire("4TRME");

var $bchKo = parcelRequire("bchKo");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * Generates an object of omega event data.
 * @param data Omega event data.
 * @param data.attributes Optional list of attributes.
 * @param data.element The name or label of the element acted upon.
 * @param data.event The event.
 * @param data.feature The feature.
 * @param data.search Optional search.
 * @param data.type The type.
 * @param data.widget The widget, a subset of the feature.
 * @returns Correctly formatted object of event information.
 */ function $86a402fa9e025355$var$getOmegaEvent({ action: action, attributes: attributes, element: element, event: event, feature: feature, search: search, type: type, widget: widget }) {
    action = action || event && event.type;
    type = type || event && event.target && event.target.nodeName.toLowerCase();
    feature = feature || "shell header";
    widget = widget || {
        name: element,
        type: type
    };
    const eventData = {
        action: action,
        attributes: attributes,
        element: element,
        feature: feature,
        search: search,
        type: type,
        widget: widget
    };
    if (!eventData.attributes) delete eventData.attributes;
    if (!eventData.search) delete eventData.search;
    return eventData;
}
/**
 * Filter props to only include specific Omega properties. This function is only used
 * in cases where users want to pass data-omega-feature, data-omega-widget and
 * data-omega-widget-type to override the default omega attributes added by Quarry or
 * other components having default omega attributes. It can also be used to filter
 * default omega props passed to components, or to pass other attributes such as
 * data-omega-attribute-* and data-omega-action. This function does not retain
 * the element and action omega attributes as they do not support default values.
 * @param props - An object containing any props.
 * @returns An object containing only the props that have Omega properties.
 */ const $86a402fa9e025355$var$filterOmegaProps = (props)=>{
    const omegaProps = {};
    Object.entries(props).forEach(([key, value])=>{
        if ([
            "data-omega-feature",
            "data-omega-feature-default",
            "data-omega-widget",
            "data-omega-widget-default",
            "data-omega-widget-type",
            "data-omega-widget-type-default",
            "data-omega-action",
            "data-omega-search-term",
            "data-omega-search-resultcount"
        ].includes(key) || key.startsWith("data-omega-attribute-")) omegaProps[key] = value;
    });
    return omegaProps;
};
module.exports.filterOmegaProps = $86a402fa9e025355$var$filterOmegaProps;

});
parcelRegister("4TRME", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.trackOmega = $7d439e3876025482$var$trackOmega;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * Creates list of attributes to be included in omega payload.
 */ const $7d439e3876025482$var$getAttributes = (element)=>{
    let currentElement = element;
    const attributes = {
        url: window.location.href // eslint-disable-line
    };
    while(currentElement){
        const dataAttrs = Object.values(currentElement.attributes);
        Object.values(dataAttrs).forEach(({ nodeName: nodeName, nodeValue: nodeValue })=>{
            if (nodeName.startsWith("data-omega-attribute-") && nodeValue) {
                const attrName = nodeName.replace("data-omega-attribute-", "");
                attributes[attrName] = nodeValue;
            }
        });
        if (currentElement.hasAttribute("data-omega-feature") || currentElement.hasAttribute("data-omega-feature-default")) break;
        currentElement = currentElement.parentElement;
    } // add default attributes
    const defaultFeature = $7d439e3876025482$var$getClosestAttribute(element, "data-omega-feature-default");
    const defaultWidget = $7d439e3876025482$var$getClosestAttribute(element, "data-omega-widget-default");
    const defaultWidgetType = $7d439e3876025482$var$getClosestAttribute(element, "data-omega-widget-type-default");
    if (defaultFeature) attributes.defaultFeature = defaultFeature;
    if (defaultWidget) attributes.defaultWidget = defaultWidget;
    if (defaultWidgetType) attributes.defaultWidgetType = defaultWidgetType;
    return {
        attributes: attributes
    };
};
/**
 * Gets closest parent with omega props if the target of the click
 * is not the element with omega props.
 */ const $7d439e3876025482$var$getAdjustedTarget = (element)=>{
    const omegaElement = element.closest("[data-omega-element]");
    return omegaElement ? omegaElement : element;
};
/**
 * Gets closest parent with the specific omega attribute and returns the value
 * of that attribute if found.
 */ const $7d439e3876025482$var$getHigherAttribute = (element, attr)=>{
    const omegaElement = element.closest(`[${attr}]`);
    if (omegaElement) return omegaElement.getAttribute(attr);
};
/**
 * Checks for data attribute on the element. If it doesn't exist, checks up the
 * dom tree to find it.
 */ const $7d439e3876025482$var$getClosestAttribute = (element, attr)=>element.getAttribute(attr) || $7d439e3876025482$var$getHigherAttribute(element, attr);
/**
 * Checks for data attribute on current element and immediate parent only.
 */ const $7d439e3876025482$var$getAttributeFromElementOrParent = (element, attribute)=>element.getAttribute(attribute) || element.parentElement?.getAttribute(attribute);
/**
 * Sends an event to OMEGA.
 */ const $7d439e3876025482$var$processEvent = (targetElement, metrics, debugOn, win, idAttribute)=>{
    // If the element does not have an element attribute, it is not a valid omega annotation.
    const element = targetElement.getAttribute("data-omega-element");
    const elementId = targetElement.getAttribute("data-testid") || targetElement.getAttribute("data-test-id") || undefined;
    if (element) {
        // check for feature
        const feature = $7d439e3876025482$var$getClosestAttribute(targetElement, "data-omega-feature") || $7d439e3876025482$var$getClosestAttribute(targetElement, "data-omega-feature-default"); // check for widget name
        const widgetName = $7d439e3876025482$var$getClosestAttribute(targetElement, "data-omega-widget") || $7d439e3876025482$var$getClosestAttribute(targetElement, "data-omega-widget-default"); // check for widget type
        const widgetType = $7d439e3876025482$var$getClosestAttribute(targetElement, "data-omega-widget-type") || $7d439e3876025482$var$getClosestAttribute(targetElement, "data-omega-widget-type-default"); // check for search term and result count
        const searchTerm = $7d439e3876025482$var$getClosestAttribute(targetElement, "data-omega-search-term");
        const searchResultCount = $7d439e3876025482$var$getClosestAttribute(targetElement, "data-omega-search-resultcount");
        if (feature && widgetName) {
            // Optional Values
            const customAction = targetElement.getAttribute("data-omega-action");
            const type = targetElement.nodeName.toLowerCase();
            const attributes = $7d439e3876025482$var$getAttributes(targetElement);
            const payload = {
                action: customAction || "click",
                element: element,
                elementId: elementId,
                feature: feature,
                ...searchTerm || searchResultCount ? {
                    search: {
                        resultcount: searchResultCount,
                        term: searchTerm
                    }
                } : {},
                type: type,
                widget: {
                    name: widgetName,
                    type: widgetType || type
                },
                ...attributes
            };
            metrics.analytics.trackEvent(payload); // If the debugging query param is present, console the payload
            if (debugOn) console.log(payload); // eslint-disable-line
        }
    } else if (idAttribute && win._satellite) {
        const elementInstanceId = $7d439e3876025482$var$getAttributeFromElementOrParent(targetElement, "data-instance-id");
        win._satellite?.track("dataInstanceIdScanned", {
            "data-instance-id": elementInstanceId
        }); // If the debugging query param is present, console the payload
        if (debugOn) console.log({
            id: idAttribute,
            element: elementInstanceId
        }); // eslint-disable-line
    }
};
/**
 * Handles events of type 'omega-event', 'pointerup' and 'keydown'.
 * Ensures that Omega event is only sent once for 'omega-event' when a single action
 * triggers multiple events ('omega-event' along with 'pointerup' or 'keydown').
 */ const $7d439e3876025482$var$handleEventFn = (e, metrics, debugOn, win, idAttribute)=>{
    if (e.type === "keydown" && e.key !== "Enter") return;
     // instanceof must check against the correct global context.
    if (!(e.target instanceof win.HTMLElement)) return;
    let targetElement = e.target; // Sometimes the target element is a child of the omega annotated element.
    if (!targetElement.getAttribute("data-omega-element")) targetElement = $7d439e3876025482$var$getAdjustedTarget(targetElement);
     // Prevent duplicate event handling ('omega-event' takes precedence over other event types)
    if (e.type === "omega-event") {
        // Add a flag attribute to target element to indicate that the 'omega-event' has been handled.
        targetElement.setAttribute("data-omega-handled", "true");
        $7d439e3876025482$var$processEvent(targetElement, metrics, debugOn, win, idAttribute);
    } else // Defer execution when event type is 'pointerup' or 'keydown'
    return win.requestAnimationFrame(()=>{
        if (targetElement.getAttribute("data-omega-handled") !== "true") $7d439e3876025482$var$processEvent(targetElement, metrics, debugOn, win, idAttribute);
        else targetElement.removeAttribute("data-omega-handled");
    });
}; // eslint-disable-next-line no-restricted-globals
function $7d439e3876025482$var$trackOmega(name = "exc.omega", win = window, debugOn = false, newMetrics, idAttribute) {
    const { metrics: metricsApi } = win["exc-module-runtime"] || {};
    if (!newMetrics && !metricsApi) throw new Error("Cannot access the Metrics SDK");
    const metrics = newMetrics || metricsApi.create(name);
    const handleEvent = (e)=>$7d439e3876025482$var$handleEventFn(e, metrics, debugOn, win, idAttribute);
    win.addEventListener("omega-event", handleEvent, {
        capture: true
    });
    win.addEventListener("pointerup", handleEvent, {
        capture: true
    });
    win.addEventListener("keydown", handleEvent, {
        capture: true
    });
}

});

parcelRegister("bchKo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sendOmegaEvent = void 0;

var $f11Yl = parcelRequire("f11Yl");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * Calls all functions in the order they were chained with the same arguments.
 * See https://github.com/adobe/react-spectrum/blob/3efd6c0ba65d93b66d981b479255a16fc14e54c6/packages/%40react-aria/utils/src/chain.ts#L16
 * for original implementation.
 */ function $636195cf647e69ae$var$chain(...callbacks) {
    return (...args)=>{
        for (const callback of callbacks)if (typeof callback === "function") callback(...args);
    };
}
/**
 * sendOmegaEvent - A higher-order function that wraps a given event handler function
 *                  to add omega attributes and handle custom omega events. If a handler
 *                  is not provided, the function still adds omega attributes to the target element.
 * @param {string} elementName - The name of the element (e.g., button) or the group name for
 * collection components (e.g., Menu, ActionGroup, ListBox). `elementName` will be used as the base
 * value for the `data-omega-element` attribute. The final attribute value depends on the type of the
 * argument passed to the event handler, representing the type of event or the selected
 * data (`Event`, `DateValue`, `RangeValue`, etc).
 * - For `Event` types, `elementName` is used directly: `data-omega-element="<elementName>"`
 * - For other types, selections are appended to `elementName` inside square brackets. For example,
 * a `DateValue` would result in `data-omega-element="<elementName> [<year>_<month>_<day>]"`,
 * a `RangeValue` would transform into `data-omega-element="<elementName> [<startValue>,<endValue>]"`.
 * Other event types are handled in a similar fashion.
 * @param {React.RefObject<{UNSAFE_getDOMNode?: () => HTMLElement}> | null} ref - A reference object created
 * using React's useRef hook. For handlers passing an `Event` to the callback, `ref` can be `null`, as the target
 * element can be derived from the `Event` object (e.g., Button). In all other cases, `ref` should be provided
 * as it is essential for identifying the target element that will receive the Omega attributes
 * (e.g., Menu, ActionGroup, ListBox, Calendar, RangeSlider etc).
 * @param {object} [options] - An optional object containing additional options.
 * @property {function} [options.onEvent] - The event handler function to be wrapped (optional).
 * @property {string} [options.action] - An optional action value for the `data-omega-action` attribute.
 * @property {string} [options.feature] - An optional feature value for the `data-omega-feature` attribute.
 * @property {string} [options.widget] - An optional widget value for the `data-omega-widget` attribute.
 * @property {string} [options.widgetType] - An optional widget value for the `data-omega-widget-type` attribute.
 * @property {object} [options.attributes] - An optional attributes object containing `key-value` pairs to be used
 * for the `data-omega-attribute-*` attributes. For instance, if `attributes: {version: "beta"}` is passed, then
 * `sendOmegaEvent` will set`data-omega-attribute-version="beta"` to the target element.
 * @property {object} [options.search] - An optional `search` object containing `term` and `resultcount` properties for
 * the `data-omega-search-term` and `data-omega-search-resultcount` attributes respectively.
 * @property {boolean} [options.debug] - A flag indicating whether debug information should be printed to the console.
 *
 * @example
 * ```typescript
 * // With a React Spectrum button or a regular button
 * <Button
 *   variant="cta"
 *   onPress={sendOmegaEvent("open", null, {onEvent: onPressHandler,action: "display"})}
 * >
 *   Open
 * </Button>;
 *
 * // With an ActionGroup collection component
 * const actionGroupRef = useRef(null);
 * const items = [
 *   { label: "React", name: "react" },
 *   { label: "Add", name: "add"},
 *   { label: "Delete", name: "delete" },
 * ];
 *
 * <ActionGroup
 *   items={items}
 *   onAction={sendOmegaEvent("group links", actionGroupRef, {onEvent: onActionHandler})}
 *   ref={actionGroupRef}
 *   overflowMode="collapse"
 * >
 *   {(item) => <Item key={item.name}>{item.label}</Item>}
 * </ActionGroup>;
 *
 * // With a Menu collection component
 * const menuRef = useRef(null);
 * const menuItems = [
 *   { label: "Add", name: "add"},
 *   { label: "Delete", name: "delete"},
 * ];
 *
 * <MenuTrigger>
 *   <Button variant="cta" onPress={sendOmegaEvent("open", null)}>
 *      Open Menu
 *   </Button>
 *   <Menu
 *     items={menuItems}
 *     onAction={sendOmegaEvent("menu links", menuRef, {feature: "menu", widget: "menu widget"})}
 *     ref={menuRef}
 *   >
 *     {(item) => <MenuItem key={item.name}>{item.label}</MenuItem>}
 *   </Menu>
 * </MenuTrigger>;
 *
 * // With a ListBox collection component with multiple selection
 * const listBoxRef = useRef(null);
 * const handleSelection = (keys) => {
 *     setSelectedKeys(keys);
 * };
 *
 * <ListBox
 *   aria-label="Example with onSelectionChange"
 *   selectionMode="multiple"
 *   onSelectionChange={sendOmegaEvent("listbox items", listBoxRef, {onEvent: handleSelection})}
 *   selectedKeys={selectedKeys}
 *   ref={listBoxRef}
 * >
 *   <Item key="one">One</Item>
 *   <Item key="two">Two</Item>
 *   <Item key="three">Three</Item>
 * </ListBox>;
 *
 * // With a RangeSlider component
 * const sliderRef = useRef(null);
 *
 * <RangeSlider
 *   label="Range"
 *   onChangeEnd={sendOmegaEvent("slider", sliderRef, {onEvent: onChangeHandler}
 *   defaultValue={{ start: 12, end: 36 }}
 *   ref={sliderRef}
 * />
 *
 * // With a Calendar component
 * const dateRef = useRef(null);
 *
 * <Calendar
 *   aria-label="Event date"
 *   onChange={sendOmegaEvent("calendar", dateRef, {onEvent: onChangeHandler}}
 *   ref={dateRef}
 * />
 *```
 */ const $636195cf647e69ae$var$sendOmegaEvent = (elementName, ref = null, options = {})=>{
    const { onEvent: // eslint-disable-next-line @typescript-eslint/no-empty-function
    onEvent = ()=>{}, action: action, feature: feature, widget: widget, widgetType: widgetType, attributes: attributes = {}, debug: debug = false, search: search = {} } = options;
    const customHandler = (eventData)=>{
        let target = null;
        let omegaElement = "";
        const handlers = [
            {
                handler: $f11Yl.handleTime,
                test: $f11Yl.isTime
            },
            {
                handler: $f11Yl.handleDateRange,
                test: $f11Yl.isDateRange
            },
            {
                handler: $f11Yl.handleDate,
                test: $f11Yl.isDate
            },
            {
                handler: $f11Yl.handleRange,
                test: $f11Yl.isRange
            },
            {
                handler: $f11Yl.handleBoolean,
                test: $f11Yl.isBool
            }
        ];
        for (const { test: test, handler: handler } of handlers)if (test(eventData)) {
            omegaElement = handler(elementName, eventData);
            break;
        }
        if (!omegaElement) {
            if (eventData == null) // When eventData is not defined or empty
            omegaElement = elementName;
            else if (Array.isArray(eventData) || eventData instanceof Set) {
                // For components with multiple selection (e.g., ListBox, CheckboxGroup)
                const selectedItems = Array.from(eventData);
                omegaElement = selectedItems.length > 0 ? `${elementName} [${selectedItems}]` : elementName;
            } else if (typeof eventData === "string" || typeof eventData === "number") // For components where eventData is a string or number (e.g., Menu, ActionGroup, Slider)
            omegaElement = `${elementName} [${eventData}]`;
            else if ("target" in eventData) {
                // For components where eventData is an Event (e.g., Button)
                omegaElement = elementName;
                target = eventData.target;
            } else if (debug) {
                console.error(`Error: event type passed to callback is not supported.`); // eslint-disable-line
                return;
            }
        } // Determine the target for the Omega attributes if not defined yet
        if (!target && ref && ref.current) target = ref.current.UNSAFE_getDOMNode ? ref.current.UNSAFE_getDOMNode() : null;
        if (!target && debug) {
            console.error("Error: ref or ref.current is not defined or UNSAFE_getDOMNode is missing"); // eslint-disable-line
            return;
        }
        if (target) {
            // add omega attributes to target element
            target.setAttribute("data-omega-element", omegaElement);
            action && target.setAttribute("data-omega-action", action);
            feature && target.setAttribute("data-omega-feature", feature);
            widget && target.setAttribute("data-omega-widget", widget);
            widgetType && target.setAttribute("data-omega-widget-type", widgetType);
            for(const key in attributes)target.setAttribute(`data-omega-attribute-${key}`, attributes[key]);
            if (search.term) target.setAttribute("data-omega-search-term", search.term);
            if (search.resultcount) target.setAttribute("data-omega-search-resultcount", search.resultcount);
            target.setAttribute("data-omega-attribute-omegahandler", "true"); // create and dispatch custom omega event
            const omegaEvent = new CustomEvent("omega-event");
            target.dispatchEvent(omegaEvent);
            if (debug) console.log("Target element with Omega annotations: ", target); // eslint-disable-line
        }
    };
    return $636195cf647e69ae$var$chain(customHandler, onEvent);
};
module.exports.sendOmegaEvent = $636195cf647e69ae$var$sendOmegaEvent;

});
parcelRegister("f11Yl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.handleBoolean = module.exports.handleRange = module.exports.handleDate = module.exports.handleDateRange = module.exports.handleTime = module.exports.isTime = module.exports.isDateRange = module.exports.isDate = module.exports.isRange = module.exports.isBool = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $e1233156eb9ea7f9$var$hasProperties = (obj, props)=>typeof obj === "object" && props.every((prop)=>prop in obj);
const $e1233156eb9ea7f9$var$isBool = (obj)=>typeof obj === "boolean";
module.exports.isBool = $e1233156eb9ea7f9$var$isBool;
const $e1233156eb9ea7f9$var$isRange = (obj)=>$e1233156eb9ea7f9$var$hasProperties(obj, [
        "start",
        "end"
    ]);
module.exports.isRange = $e1233156eb9ea7f9$var$isRange;
const $e1233156eb9ea7f9$var$isDate = (obj)=>$e1233156eb9ea7f9$var$hasProperties(obj, [
        "year",
        "month",
        "day"
    ]);
module.exports.isDate = $e1233156eb9ea7f9$var$isDate;
const $e1233156eb9ea7f9$var$isDateRange = (obj)=>$e1233156eb9ea7f9$var$hasProperties(obj, [
        "start",
        "end"
    ]) && $e1233156eb9ea7f9$var$isDate(obj.start) && $e1233156eb9ea7f9$var$isDate(obj.end);
module.exports.isDateRange = $e1233156eb9ea7f9$var$isDateRange;
const $e1233156eb9ea7f9$var$isTime = (obj)=>$e1233156eb9ea7f9$var$hasProperties(obj, [
        "hour",
        "minute",
        "second"
    ]);
/**
 * Handler functions to generate `omegaElement` strings based on the type of data received.
 * Different handlers are used depending on the type of component.
 */ // For Time components (e.g., Timefield)
module.exports.isTime = $e1233156eb9ea7f9$var$isTime;
const $e1233156eb9ea7f9$var$handleTime = (elementName, time)=>`${elementName} [${time.hour}_${time.minute}_${time.second}]`; // For Date Range components (e.g., DateRangePicker)
module.exports.handleTime = $e1233156eb9ea7f9$var$handleTime;
const $e1233156eb9ea7f9$var$handleDateRange = (elementName, range)=>`${elementName} [${range.start.year}_${range.start.month}_${range.start.day},${range.end.year}_${range.end.month}_${range.end.day}]`; // For Date components (e.g., Calendar, DatePicker)
module.exports.handleDateRange = $e1233156eb9ea7f9$var$handleDateRange;
const $e1233156eb9ea7f9$var$handleDate = (elementName, date)=>`${elementName} [${date.year}_${date.month}_${date.day}]`; // For Range components (e.g., RangeSlider)
module.exports.handleDate = $e1233156eb9ea7f9$var$handleDate;
const $e1233156eb9ea7f9$var$handleRange = (elementName, range)=>`${elementName} [${range.start},${range.end}]`; // For Boolean components (e.g., Checkbox, Switch)
module.exports.handleRange = $e1233156eb9ea7f9$var$handleRange;
const $e1233156eb9ea7f9$var$handleBoolean = (elementName, bool)=>bool ? `${elementName} [selected]` : `${elementName} [deselected]`;
module.exports.handleBoolean = $e1233156eb9ea7f9$var$handleBoolean;

});



parcelRegister("bLRyE", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");




module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("gPfp9")),
    $Ha5sG("ctfMK"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("gPPdO")),
    $Ha5sG("fKsOx")
]).then(()=>parcelRequire("gYBGF"));

});

parcelRegister("ju1lB", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");




module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("aQ9cw")),
    $Ha5sG("ctfMK"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("gPPdO")),
    $Ha5sG("dCrv8")
]).then(()=>parcelRequire("henu9"));

});

parcelRegister("3vxZE", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");






















module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("2rJ3i")),
    $Ha5sG("iAoZ0"),
    $Ha5sG("4bJ8e"),
    $Ha5sG("jXgXA"),
    $Ha5sG("9u8DV"),
    $Ha5sG("cYwRf"),
    $Ha5sG("2arCC"),
    $Ha5sG("hue8D"),
    $Ha5sG("5wCcX"),
    $Ha5sG("5200E"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("bwRqG")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("9j9Pi")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("ki2nr")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("7GSTZ")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("ms5mk")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("dglIe")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("D8UTn")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("5AGJz")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("7Zn3b")),
    $Ha5sG("8COgs"),
    $Ha5sG("ctfMK"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("gPPdO")),
    $Ha5sG("aLVmW"),
    $Ha5sG("a2Z05")
]).then(()=>parcelRequire("cCS3t"));

});

parcelRegister("6eBmf", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");




module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("7Zn3b")),
    $Ha5sG("8COgs"),
    $Ha5sG("ctfMK"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("gPPdO")),
    $Ha5sG("aLVmW"),
    $Ha5sG("cN3SH")
]).then(()=>parcelRequire("gia9l"));

});



parcelRegister("iBUcR", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");












module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("bw5xw")),
    $Ha5sG("f3Y5a"),
    $Ha5sG("dmVTS"),
    $Ha5sG("7bkF4"),
    $Ha5sG("9w19Q"),
    $Ha5sG("i92TE"),
    $Ha5sG("jNvOp"),
    $Ha5sG("7zD5V"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("iH25S")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("6UnT0")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("d3ppd")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("7Zn3b")),
    $Ha5sG("8COgs"),
    $Ha5sG("ctfMK"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("gPPdO")),
    $Ha5sG("aLVmW"),
    $Ha5sG("aOxQg")
]).then(()=>parcelRequire("eAUzO"));

});


parcelRegister("fnqzv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ua75 = parcelRequire("4ua75");

var $dDEjQ = parcelRequire("dDEjQ");
function $b8c2e2c23219e964$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $b8c2e2c23219e964$var$TranslationService {
    constructor(serviceDomain){
        $b8c2e2c23219e964$var$_defineProperty(this, "baseUrl", void 0);
        this.baseUrl = serviceDomain;
    }
    /**
   * Calls translation service endpoint to get translated text
   * in specified language.
   * @async
   * @param {Array} arr Array of strings to translate.
   * @param {string} language Locale for language str is translated.
   * Default is locale for english (en_US).
   * @returns {Promise<Object>} Returns object that contains original text
   * and translated text, but also with locale of original and translated text.
   */ async translate(arr, language = "en_US") {
        const { clientId: clientId } = (0, $dDEjQ.getBootstrap)();
        let body;
        try {
            const response = await (0, $4ua75.fetch)(`${this.baseUrl}/api/v5/translate`, {
                body: JSON.stringify({
                    contentType: "UGC",
                    domain: "GENERIC",
                    str: arr,
                    to: [
                        language
                    ]
                }),
                headers: {
                    "Content-Type": "application/json",
                    "x-api-key": clientId
                },
                method: "POST",
                scope: $4ua75.FetchScope.AUTH
            });
            body = await response.json();
        } catch (error) {
            return {
                error: error
            };
        } // code -9 is returned if from and to language are same
        if (body.code === -9) return arr.map((str)=>({
                from: language,
                translatedText: str
            }));
         // Construct a flattened object of the translation data for
        // backwards compatibility from v2 => v5 upgrade (summer 2023)
        const { from: from, originalText: originalText, translations: translations } = Object.values(body)[0][0];
        const { success: success, to: to, translatedText: translatedText } = translations[0]; // Return an object inside an array for backwards compatibility
        // Previously returned Object.values(body)[0];
        return [
            {
                from: from,
                originalText: originalText,
                success: success,
                to: to,
                translatedText: translatedText
            }
        ];
    }
}
var $b8c2e2c23219e964$var$_default = $b8c2e2c23219e964$var$TranslationService;
module.exports.default = $b8c2e2c23219e964$var$_default;

});

parcelRegister("4dTp4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $iNslS = parcelRequire("iNslS");

var $iJaYo = parcelRequire("iJaYo");

var $eJBOk = parcelRequire("eJBOk");

var $hCG2Z = parcelRequire("hCG2Z");

var $d14ca43eae4e4c32$var$_metrics = $d14ca43eae4e4c32$var$_interopRequireWildcard((parcelRequire("17AVh")));

var $ctGaZ = parcelRequire("ctGaZ");

var $3Zpnv = parcelRequire("3Zpnv");
function $d14ca43eae4e4c32$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $d14ca43eae4e4c32$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $d14ca43eae4e4c32$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d14ca43eae4e4c32$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d14ca43eae4e4c32$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $d14ca43eae4e4c32$var$STORAGE_KEY = "unifiedShellWorkHub";
const $d14ca43eae4e4c32$var$EXPIRY = 86400000;
const $d14ca43eae4e4c32$var$localCache = (0, $iJaYo.getLocalCache)($d14ca43eae4e4c32$var$STORAGE_KEY);
class $d14ca43eae4e4c32$var$WorkHubService {
    constructor(appConfigs = []){
        $d14ca43eae4e4c32$var$_defineProperty(this, "promises", {});
        $d14ca43eae4e4c32$var$_defineProperty(this, "metrics", $d14ca43eae4e4c32$var$_metrics.default.create("exc.core.services.WorkHubService"));
        $d14ca43eae4e4c32$var$_defineProperty(this, "fetched", new Set());
        $d14ca43eae4e4c32$var$_defineProperty(this, "appConfigs", void 0);
        this.appConfigs = appConfigs;
    }
    /**
   * This method utilizes the appConfigs passed in at contruction time and reduces
   * the data to a hashmap of pre-release appConfig paths and release types.
   * This hashmap is cached with a key that pins it to the SPA release version.
   * @returns A hashmap of pre-release appConfig paths
   * @private
   */ async getPrereleasePaths() {
        const key = `preReleasePaths-${window.config?.spaVersion}`;
        const cached = await $d14ca43eae4e4c32$var$localCache.get(key);
        if (cached) // If yes, use them
        return cached.items;
         // Filter out GA apps and recreate a hashmap of appConfig URLs and release types
        const configs = this.appConfigs.reduce((acc, app)=>{
            if (app.releaseType && app.releaseType !== $ctGaZ.RELEASE_TYPE.GA && (!app.releaseScope || app.releaseScope === $ctGaZ.RELEASE_SCOPE.SELF)) {
                const paths = [
                    app.path,
                    ...app.redirectFrom?.map((r)=>r.path) || []
                ];
                paths.forEach((path)=>acc[path] = app.releaseType);
            }
            return acc;
        }, {}); // Store the preReleaseConfigs
        const fulfilled = Date.now();
        const expires = fulfilled + $d14ca43eae4e4c32$var$EXPIRY;
        $d14ca43eae4e4c32$var$localCache.set(key, {
            expires: expires,
            fulfilled: fulfilled,
            items: configs
        });
        return configs;
    }
    /**
   * Returns an existing response for a Work Hub request.
   * Looks at the cache first, and then at pending requests.
   * @param {string} key - unique key (imsOrgId:locale:product)
   * @returns The existing response if available.
   * @private
   */ async getExistingResponse(key) {
        try {
            // Look for existing result (or pending result) in memory
            const existingPromise = this.promises[key]; // Look for cached result. Note localCache already verifies expiry.
            let response = await $d14ca43eae4e4c32$var$localCache.get(key); // If no cached, use a pending response if we have one.
            if (existingPromise && !response) response = await existingPromise;
            if (response && Date.now() < response.expires) return response;
        } catch (err) {
            this.metrics.warn("Failed to get Work Hub response from cache or memory", {
                err: err
            });
        }
    }
    /**
   * Gets Work Hub response from cache or fetch
   * @param options - parameters to send to Work Hub
   * @returns The augmented Work Hub response
   */ async getWorkHub(options) {
        const { capability: capability, imsOrgId: imsOrgId, locale: locale, sandbox: sandbox } = options; // Prevent storing data with null id
        if (!imsOrgId) return;
        const key = `${imsOrgId}:${sandbox}:${locale}:${capability}`;
        const response = await this.getExistingResponse(key); // Don't need to go through the staleWhileRevalidate workflow every single
        // time. It's more of a once per page load kind of experience. If the
        // key has been fetched this session, return the cached response.
        if (this.fetched.has(key) && response) {
            this.metrics.event("Core.workHubCachedResponse", this.getMetricsOutput(response.items), {
                level: $d14ca43eae4e4c32$var$_metrics.Level.INFO
            });
            return response;
        } // A request must be made to get the latest. Add the key to the fetched set
        // so subsequent requests do not make additional requests this load.
        this.fetched.add(key);
        const getWorkHubPromise = ()=>{
            const workHubPromise = Promise.all([
                this.getPrereleasePaths(),
                this.fetchWorkhub({
                    capability: capability,
                    locale: locale
                })
            ]).then((resps)=>this.mergeAppData(resps)).then((workHubResponse)=>this.onComplete(key, workHubResponse)).catch((error)=>{
                !!response && this.onError(key, error);
                return undefined;
            }).finally(()=>delete this.promises[key]);
            this.promises[key] = workHubPromise;
            return workHubPromise;
        }; // If we have no response, wait for this promise.
        // Otherwise, it used for a future request (stale-while-revalidate)
        return (0, $3Zpnv.staleWhileRevalidate)(getWorkHubPromise, response);
    }
    /**
   * Updates Work Hub response with releaseType information
   * @param param0 - preReleasePaths and workHubResponse
   * @returns The updated response
   */ mergeAppData([preReleasePaths, workHubResponse]) {
        return workHubResponse.map((item)=>({
                ...item,
                releaseType: preReleasePaths[item.urlTemplate]
            }));
    }
    /**
   * Fetches Work Hub response from service
   * @param options - parameters to send to Work Hub
   * @returns A promise with the Work Hub response
   */ async fetchWorkhub({ capability: capability, locale: locale }) {
        let variables = {
            capability: capability,
            locale: locale
        };
        const workhubVersion = (0, $hCG2Z.getQueryValue)("workHubVersion");
        if (workhubVersion) variables = {
            ...variables,
            workhubVersion: workhubVersion
        };
        const response = await (0, $eJBOk.getNavigationsData)(variables);
        if (!(response.getNavigationsData && Array.isArray(response.getNavigationsData))) throw new Error("Invalid Workhub data returned");
        return response.getNavigationsData;
    }
    /**
   * Caches a Work Hub response after its complete.
   * @param {string} key - Work Hub key (imsOrgId:locale:product)
   * @param items - Work Hub items from response
   * @returns Cacheable Work Hub response with extended data
   * @private
   */ onComplete(key, items) {
        const fulfilled = Date.now();
        const expires = fulfilled + $d14ca43eae4e4c32$var$EXPIRY;
        const cacheResponse = {
            expires: expires,
            fulfilled: fulfilled,
            items: items
        };
        this.metrics.event("Core.workHubFetchSuccess", this.getMetricsOutput(items), {
            level: $d14ca43eae4e4c32$var$_metrics.Level.INFO
        });
        this.metrics.event("WorkHub.cacheSet", {
            expires: expires,
            key: key
        });
        $d14ca43eae4e4c32$var$localCache.set(key, cacheResponse);
        return cacheResponse;
    }
    /**
   * Logs an error for background, non-blocking Work Hub failures.
   * @param {string} key
   * @param {Error} error - Error information
   * @private
   */ onError(key, error) {
        // The request failed for this key, so don't cache that response in the
        // fetched set. Now subsequent requests will re-fetch.
        this.fetched.delete(key);
        const message = (0, $iNslS.getErrorMessage)(error);
        this.metrics.event("WorkHub.backgroundError", {
            key: key,
            message: message
        }, {
            level: $d14ca43eae4e4c32$var$_metrics.Level.ERROR
        });
    }
    /**
   * Prepares data to be sent to metrics.
   * @param items Response data.
   * @returns Data to be sent to metrics.
   */ getMetricsOutput(items) {
        const getData = ({ displayName: displayName, id: id })=>({
                displayName: displayName,
                id: id
            });
        return {
            count: items.length,
            disabled: items.filter((item)=>!item.enabled).map(getData),
            enabled: items.filter((item)=>!!item.enabled).map(getData),
            items: items.map((item)=>item.displayName) // This is to keep backcompat if it was in-use.
        };
    }
}
module.exports.default = $d14ca43eae4e4c32$var$WorkHubService;

});
parcelRegister("eJBOk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getNavigationsData = module.exports.WORKHUB_QUERY = void 0;

var $4ua75 = parcelRequire("4ua75");

var $apIgy = parcelRequire("apIgy");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $353f36a48f266da1$var$WORKHUB_QUERY = `
  query workhub($locale:String, $capability:String, $workhubVersion:String) {
    getNavigationsData(reqData:{locale: $locale, capability: $capability, workhubVersion: $workhubVersion}) {
      applicationId
      category
      description
      displayName
      enabled
      icon
      id
      newTab
      nounName
      nouns
      urlTemplate
      urlRoot
      visible
      navigationSubTreeElements {
        applicationId
        category
        description
        displayName
        enabled
        icon
        id
        newTab
        nounName
        urlTemplate
        visible
      }
    }
  }
`;
module.exports.WORKHUB_QUERY = $353f36a48f266da1$var$WORKHUB_QUERY;
const $353f36a48f266da1$var$getNavigationsData = (vars)=>(0, $apIgy.gqlQuery)($353f36a48f266da1$var$WORKHUB_QUERY, vars, {
        scope: $4ua75.FetchScope.SANDBOX_PLUS
    });
module.exports.getNavigationsData = $353f36a48f266da1$var$getNavigationsData;

});


parcelRegister("1bitX", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");


















module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("4hwyN")),
    $Ha5sG("kD9B8"),
    $Ha5sG("1CCfP"),
    $Ha5sG("kGujd"),
    $Ha5sG("f3Y5a"),
    $Ha5sG("1gZNf"),
    $Ha5sG("9w19Q"),
    $Ha5sG("i92TE"),
    $Ha5sG("5Tu3R"),
    $Ha5sG("9u8DV"),
    $Ha5sG("2arCC"),
    $Ha5sG("5wCcX"),
    $Ha5sG("5200E"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("cMWIw")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("lMVqA")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("iH25S")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("d3ppd")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("dCRVZ")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("5AGJz")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("7Zn3b")),
    $Ha5sG("8COgs"),
    $Ha5sG("ctfMK"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("gPPdO")),
    $Ha5sG("aLVmW"),
    $Ha5sG("cBjZF")
]).then(()=>parcelRequire("gEnWH"));

});

parcelRegister("405KG", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");


module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("c3hhK")),
    $Ha5sG("4xfe0")
]).then(()=>parcelRequire("bcsVN"));

});

parcelRegister("ftmUA", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");










module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("fLwKB")),
    $Ha5sG("jXgXA"),
    $Ha5sG("9u8DV"),
    $Ha5sG("ds4Wh"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("ms5mk")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("D8UTn")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("7Zn3b")),
    $Ha5sG("8COgs"),
    $Ha5sG("ctfMK"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("gPPdO")),
    $Ha5sG("aLVmW"),
    $Ha5sG("l4THr")
]).then(()=>parcelRequire("cndL0"));

});

parcelRegister("6E0hT", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");




module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("hbYF9")),
    $Ha5sG("ctfMK"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("gPPdO")),
    $Ha5sG("epkLF")
]).then(()=>parcelRequire("6IHbK"));

});

parcelRegister("6VQBX", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");


















module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("hNPxz")),
    $Ha5sG("6RT6w"),
    $Ha5sG("4bJ8e"),
    $Ha5sG("jXgXA"),
    $Ha5sG("9u8DV"),
    $Ha5sG("cYwRf"),
    $Ha5sG("hue8D"),
    $Ha5sG("5wCcX"),
    $Ha5sG("5200E"),
    $Ha5sG("8COgs"),
    $Ha5sG("ctfMK"),
    $Ha5sG("8ldnw"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("8Aorl")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("ki2nr")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("7GSTZ")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("ms5mk")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("D8UTn")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("5AGJz")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("aLgse")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("gPPdO")),
    $Ha5sG("lvRQb")
]).then(()=>parcelRequire("aqwBD"));

});

parcelRegister("3DCrn", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");










module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("5X6Dv")),
    $Ha5sG("4bJ8e"),
    $Ha5sG("9u8DV"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("ki2nr")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("D8UTn")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("7Zn3b")),
    $Ha5sG("8COgs"),
    $Ha5sG("ctfMK"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("gPPdO")),
    $Ha5sG("aLVmW"),
    $Ha5sG("iDUdO")
]).then(()=>parcelRequire("i9Y48"));

});

parcelRegister("8zvyw", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");




module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("7Zn3b")),
    $Ha5sG("8COgs"),
    $Ha5sG("ctfMK"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("gPPdO")),
    $Ha5sG("aLVmW")
]).then(()=>parcelRequire("ilE0W"));

});

parcelRegister("9i99Z", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");




module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("7Zn3b")),
    $Ha5sG("8COgs"),
    $Ha5sG("ctfMK"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("gPPdO")),
    $Ha5sG("aLVmW"),
    $Ha5sG("bJmE1")
]).then(()=>parcelRequire("9Iyqm"));

});

parcelRegister("iL5Qm", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");






module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("b2duX")),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("7Zn3b")),
    $Ha5sG("8COgs"),
    $Ha5sG("ctfMK"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("gPPdO")),
    $Ha5sG("aLVmW"),
    $Ha5sG("5dhoM")
]).then(()=>parcelRequire("3tliT"));

});

parcelRegister("hFGrB", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = $Ha5sG("bZL4Z").then(()=>parcelRequire("jypch"));

});

parcelRegister("23swY", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");






module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("aLXeK")),
    $Ha5sG("dmVTS"),
    $Ha5sG("jNvOp"),
    $Ha5sG("7zD5V"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("etrgu")),
    $Ha5sG("f3Y5a"),
    $Ha5sG("7bkF4"),
    $Ha5sG("6eHUl"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("d3ppd")),
    $Ha5sG("8q4cv")
]).then(()=>parcelRequire("eN51o"));

});

parcelRegister("2uQiR", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = $Ha5sG("g5xy1").then(()=>parcelRequire("41mS5"));

});

parcelRegister("hg1YG", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = $Ha5sG("e3AuO").then(()=>parcelRequire("le7Sw"));

});

parcelRegister("9gBaS", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");




module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("dLdHy")),
    $Ha5sG("7bkF4"),
    $Ha5sG("1gZNf"),
    $Ha5sG("9w19Q"),
    $Ha5sG("jNvOp"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("d3ppd")),
    $Ha5sG("6EokD")
]).then(()=>parcelRequire("f3AM0"));

});

parcelRegister("lqH9o", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = $Ha5sG("jVnWt").then(()=>parcelRequire("5qwG0"));

});

parcelRegister("3qlqs", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");


module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("etrgu")),
    $Ha5sG("f3Y5a"),
    $Ha5sG("7bkF4"),
    $Ha5sG("6eHUl")
]).then(()=>parcelRequire("jxPUT"));

});

parcelRegister("l9FnH", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");




module.exports = Promise.all([
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("7Jp6c")),
    $Ha5sG("dmVTS"),
    $Ha5sG("jNvOp"),
    $Ha5sG("7zD5V"),
    (parcelRequire("98wYO"))((parcelRequire("3cmwu")).resolve("d3ppd")),
    $Ha5sG("d1gl7")
]).then(()=>parcelRequire("cqdnu"));

});


parcelRegister("ePsJb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "en_US", {
    enumerable: true,
    get: function() {
        return $acbc1cdc815240d8$var$_en_us.default;
    }
});
Object.defineProperty(module.exports, "de_DE", {
    enumerable: true,
    get: function() {
        return $acbc1cdc815240d8$var$_de_de.default;
    }
});
Object.defineProperty(module.exports, "es_ES", {
    enumerable: true,
    get: function() {
        return $acbc1cdc815240d8$var$_es_es.default;
    }
});
Object.defineProperty(module.exports, "fr_FR", {
    enumerable: true,
    get: function() {
        return $acbc1cdc815240d8$var$_fr_fr.default;
    }
});
Object.defineProperty(module.exports, "it_IT", {
    enumerable: true,
    get: function() {
        return $acbc1cdc815240d8$var$_it_it.default;
    }
});
Object.defineProperty(module.exports, "ja_JP", {
    enumerable: true,
    get: function() {
        return $acbc1cdc815240d8$var$_ja_jp.default;
    }
});
Object.defineProperty(module.exports, "ko_KR", {
    enumerable: true,
    get: function() {
        return $acbc1cdc815240d8$var$_ko_kr.default;
    }
});
Object.defineProperty(module.exports, "pt_BR", {
    enumerable: true,
    get: function() {
        return $acbc1cdc815240d8$var$_pt_br.default;
    }
});
Object.defineProperty(module.exports, "zh_CN", {
    enumerable: true,
    get: function() {
        return $acbc1cdc815240d8$var$_zh_cn.default;
    }
});
Object.defineProperty(module.exports, "zh_TW", {
    enumerable: true,
    get: function() {
        return $acbc1cdc815240d8$var$_zh_tw.default;
    }
});

var $acbc1cdc815240d8$var$_en_us = $acbc1cdc815240d8$var$_interopRequireDefault((parcelRequire("bSasr")));

var $acbc1cdc815240d8$var$_de_de = $acbc1cdc815240d8$var$_interopRequireDefault((parcelRequire("gw05t")));

var $acbc1cdc815240d8$var$_es_es = $acbc1cdc815240d8$var$_interopRequireDefault((parcelRequire("5jnzK")));

var $acbc1cdc815240d8$var$_fr_fr = $acbc1cdc815240d8$var$_interopRequireDefault((parcelRequire("laeka")));

var $acbc1cdc815240d8$var$_it_it = $acbc1cdc815240d8$var$_interopRequireDefault((parcelRequire("4cS1R")));

var $acbc1cdc815240d8$var$_ja_jp = $acbc1cdc815240d8$var$_interopRequireDefault((parcelRequire("j4JxG")));

var $acbc1cdc815240d8$var$_ko_kr = $acbc1cdc815240d8$var$_interopRequireDefault((parcelRequire("5punx")));

var $acbc1cdc815240d8$var$_pt_br = $acbc1cdc815240d8$var$_interopRequireDefault((parcelRequire("bSbj9")));

var $acbc1cdc815240d8$var$_zh_cn = $acbc1cdc815240d8$var$_interopRequireDefault((parcelRequire("6hqdH")));

var $acbc1cdc815240d8$var$_zh_tw = $acbc1cdc815240d8$var$_interopRequireDefault((parcelRequire("jA52Q")));
function $acbc1cdc815240d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("bSasr", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"iframeWaitingMessage":"Thank you for waiting. Just a few more moments...","solutionIframe":"Main Content"}');

});

parcelRegister("gw05t", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"iframeWaitingMessage":"Vielen Dank f\xfcr Ihre Geduld. Nur noch ein kurzer Moment\xa0...","solutionIframe":"Hauptinhalt"}');

});

parcelRegister("5jnzK", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"iframeWaitingMessage":"Gracias por su paciencia. Espere un poco m\xe1s\u2026","solutionIframe":"Contenido principal"}');

});

parcelRegister("laeka", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"iframeWaitingMessage":"Merci pour votre patience. Encore quelques instants...","solutionIframe":"Contenu principal"}');

});

parcelRegister("4cS1R", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"iframeWaitingMessage":"Grazie per l\u2019attesa. Ancora qualche istante...","solutionIframe":"Contenuto principale"}');

});

parcelRegister("j4JxG", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"iframeWaitingMessage":"\u304A\u5F85\u3061\u3044\u305F\u3060\u304D\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u3042\u3068\u5C11\u3057\u304A\u5F85\u3061\u304F\u3060\u3055\u3044...","solutionIframe":"\u30E1\u30A4\u30F3\u30B3\u30F3\u30C6\u30F3\u30C4"}');

});

parcelRegister("5punx", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"iframeWaitingMessage":"\uAE30\uB2E4\uB824 \uC8FC\uC154\uC11C \uAC10\uC0AC\uD569\uB2C8\uB2E4. \uC7A0\uC2DC\uB9CC \uB354 \uAE30\uB2E4\uB824 \uC8FC\uC2ED\uC2DC\uC624.","solutionIframe":"\uBA54\uC778 \uCF58\uD150\uCE20"}');

});

parcelRegister("bSbj9", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"iframeWaitingMessage":"Obrigado por aguardar. S\xf3 mais um momento...","solutionIframe":"Conte\xfado principal"}');

});

parcelRegister("6hqdH", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"iframeWaitingMessage":"\u611F\u8C22\u60A8\u7684\u8010\u5FC3\u7B49\u5F85\u3002\u5373\u5C06\u5904\u7406\u5B8C\u6BD5...","solutionIframe":"\u4E3B\u8981\u5185\u5BB9"}');

});

parcelRegister("jA52Q", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"iframeWaitingMessage":"\u611F\u8B1D\u60A8\u7684\u8010\u5FC3\u7B49\u5019\u3002\u8ACB\u518D\u7A0D\u5019\u7247\u523B\u2026","solutionIframe":"\u4E3B\u8981\u5167\u5BB9"}');

});


parcelRegister("58zmb", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = $Ha5sG("9bhTi").then(()=>parcelRequire("jGtAe"));

});



parcelRegister("aspzj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRoutes = void 0;

var $e92ce8e22756a86a$var$routes = $e92ce8e22756a86a$var$_interopRequireWildcard((parcelRequire("chVM9")));
function $e92ce8e22756a86a$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $e92ce8e22756a86a$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $e92ce8e22756a86a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e92ce8e22756a86a$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * Returns all Unified Shell routes. This method is used:
 * 1. Enable Unit Tests (Can be mocked)
 * 2. Type the imported routes.
 */ const $e92ce8e22756a86a$var$getRoutes = ()=>$e92ce8e22756a86a$var$routes;
module.exports.getRoutes = $e92ce8e22756a86a$var$getRoutes;

});
parcelRegister("chVM9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f51822763a134398$var$_exportNames = {
    abmweb: true,
    accp: true,
    accreportsui: true,
    acctriggersui: true,
    accwebui: true,
    accwebuiLocalization: true,
    admin: true,
    adobepassunifiedshellconsoleclient: true,
    adobeReachUI: true,
    advertisingssc: true,
    aemCfModelEditor: true,
    aemHomeUi: true,
    aemOutboundMarketing: true,
    affiliatesPlatformAdvertiser: true,
    affiliatesPlatformAffiliate: true,
    agoraUI: true,
    ajoContentEditor: true,
    amplify: true,
    analytics: true,
    annotations: true,
    ansiblegenai: true,
    assetsCollections: true,
    audiencemanager: true,
    berlinHome: true,
    blank: true,
    campaignAccWebUiSpa: true,
    cjaModules: true,
    cloudManager: true,
    cloudManagerBackOfficeUi: true,
    cmConsoleUI: true,
    cmStandaloneMfe: true,
    commerce: true,
    commerceCatalogServiceDemoUI: true,
    commerceSaaS: true,
    complianceDroid: true,
    contentHub: true,
    coPilotReview: true,
    creativeDesigner: true,
    customerEngineeringEnablementManager: true,
    dataComposer: true,
    dataComposerStorybook: true,
    ddam: true,
    depapp: true,
    designerOnWebId: true,
    developerconsoleID: true,
    documentAnalyzer: true,
    dxCommerceBackgroundGenerationSpaTest: true,
    exdDecisionPolicyAssist: true,
    exim: true,
    experienceManager: true,
    experiencePlatform: true,
    experiencePlatformHomePueblo: true,
    platformAmplify: true,
    platformAudienceOrchestrationUi: true,
    platformMexp: true,
    platformPermissionsUI: true,
    platformUnifiedTags: true,
    platformUIEncryption: true,
    platformUIQueries: true,
    platformUIOffers: true,
    platformUIComponents: true,
    platformUIDashboards: true,
    platformUIExperiments: true,
    platformUIMetricsCatalog: true,
    platformUILicenseUsage: true,
    platformUIDatasets: true,
    platformFederatedDataUI: true,
    firstmile: true,
    formsAuthoringAssistantSpa: true,
    formsSpa: true,
    formsvrdashboard: true,
    fusion: true,
    genStudio: true,
    griffon: true,
    hummingbird: true,
    hummingbirdTranslations: true,
    inappEditor: true,
    internalDataSync: true,
    journeysNextAdmin: true,
    journeysNextAuthoring: true,
    landing: true,
    maestroUI: true,
    marketoEmails: true,
    marketoLandingPage: true,
    notifications: true,
    peopleUi: true,
    permissionsUI: true,
    personalizationEditor: true,
    personalizationEditorDemo: true,
    platformUIIdentity: true,
    profileexplorer: true,
    prospectAi: true,
    pulseAutomationid: true,
    reportScheduleManagement: true,
    reportScheduler: true,
    ruleEditorUiService: true,
    sandboxManagementApp: true,
    screens: true,
    softwareDistribution: true,
    spadebugger: true,
    starter: true,
    targetSandbox: true,
    uberReleaseRegistry: true,
    uisAutomation: true,
    uistoolsui: true,
    userPreferences: true,
    webEditor: true,
    workfront: true,
    workfrontPreview: true
};
Object.defineProperty(module.exports, "abmweb", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_abmweb.default;
    }
});
Object.defineProperty(module.exports, "accp", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_accp.default;
    }
});
Object.defineProperty(module.exports, "accreportsui", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_accreportsui.default;
    }
});
Object.defineProperty(module.exports, "acctriggersui", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_acctriggersui.default;
    }
});
Object.defineProperty(module.exports, "accwebui", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_accwebui.default;
    }
});
Object.defineProperty(module.exports, "accwebuiLocalization", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_accwebuiLocalization.default;
    }
});
Object.defineProperty(module.exports, "admin", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_admin.default;
    }
});
Object.defineProperty(module.exports, "adobepassunifiedshellconsoleclient", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_adobepassunifiedshellconsoleclient.default;
    }
});
Object.defineProperty(module.exports, "adobeReachUI", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_adobeReachUI.default;
    }
});
Object.defineProperty(module.exports, "advertisingssc", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_advertisingSsc.default;
    }
});
Object.defineProperty(module.exports, "aemCfModelEditor", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_aemCfModelEditor.default;
    }
});
Object.defineProperty(module.exports, "aemHomeUi", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_aemHomeUi.default;
    }
});
Object.defineProperty(module.exports, "aemOutboundMarketing", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_aemOutboundMarketing.default;
    }
});
Object.defineProperty(module.exports, "affiliatesPlatformAdvertiser", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_affiliatesPlatformAdvertiser.default;
    }
});
Object.defineProperty(module.exports, "affiliatesPlatformAffiliate", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_affiliatesPlatformAffiliate.default;
    }
});
Object.defineProperty(module.exports, "agoraUI", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_agoraUI.default;
    }
});
Object.defineProperty(module.exports, "ajoContentEditor", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_ajoContentEditor.default;
    }
});
Object.defineProperty(module.exports, "amplify", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_amplify.default;
    }
});
Object.defineProperty(module.exports, "analytics", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_analytics.default;
    }
});
Object.defineProperty(module.exports, "annotations", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_annotations.default;
    }
});
Object.defineProperty(module.exports, "ansiblegenai", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_ansiblegenai.default;
    }
});
Object.defineProperty(module.exports, "assetsCollections", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_assetsCollections.default;
    }
});
Object.defineProperty(module.exports, "audiencemanager", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_audiencemanager.default;
    }
});
Object.defineProperty(module.exports, "berlinHome", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_berlinHome.default;
    }
});
Object.defineProperty(module.exports, "blank", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_blank.default;
    }
});
Object.defineProperty(module.exports, "campaignAccWebUiSpa", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_campaignAccWebUiSpa.default;
    }
});
Object.defineProperty(module.exports, "cjaModules", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_cjaModules.default;
    }
});
Object.defineProperty(module.exports, "cloudManager", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_cloudManager.default;
    }
});
Object.defineProperty(module.exports, "cloudManagerBackOfficeUi", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_cloudManagerBackOfficeUi.default;
    }
});
Object.defineProperty(module.exports, "cmConsoleUI", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_cmConsoleUi.default;
    }
});
Object.defineProperty(module.exports, "cmStandaloneMfe", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_cmStandaloneMfe.default;
    }
});
Object.defineProperty(module.exports, "commerce", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_commerce.default;
    }
});
Object.defineProperty(module.exports, "commerceCatalogServiceDemoUI", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_commerceCatalogServiceDemoUI.default;
    }
});
Object.defineProperty(module.exports, "commerceSaaS", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_commerceSaaS.default;
    }
});
Object.defineProperty(module.exports, "complianceDroid", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_complianceDroid.default;
    }
});
Object.defineProperty(module.exports, "contentHub", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_contentHub.default;
    }
});
Object.defineProperty(module.exports, "coPilotReview", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_coPilotReview.default;
    }
});
Object.defineProperty(module.exports, "creativeDesigner", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_creativeDesigner.default;
    }
});
Object.defineProperty(module.exports, "customerEngineeringEnablementManager", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_customerEngineeringEnablementManager.default;
    }
});
Object.defineProperty(module.exports, "dataComposer", {
    enumerable: true,
    get: function() {
        return $f0USY.dataComposer;
    }
});
Object.defineProperty(module.exports, "dataComposerStorybook", {
    enumerable: true,
    get: function() {
        return $f0USY.dataComposerStorybook;
    }
});
Object.defineProperty(module.exports, "ddam", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_ddam.default;
    }
});
Object.defineProperty(module.exports, "depapp", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_depapp.default;
    }
});
Object.defineProperty(module.exports, "designerOnWebId", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_designerOnWebId.default;
    }
});
Object.defineProperty(module.exports, "developerconsoleID", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_developerconsoleID.default;
    }
});
Object.defineProperty(module.exports, "documentAnalyzer", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_documentAnalyzer.default;
    }
});
Object.defineProperty(module.exports, "dxCommerceBackgroundGenerationSpaTest", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_dxCommerceBackgroundGenerationSpaTest.default;
    }
});
Object.defineProperty(module.exports, "exdDecisionPolicyAssist", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_exdDecisionPolicyAssist.default;
    }
});
Object.defineProperty(module.exports, "exim", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_exim.default;
    }
});
Object.defineProperty(module.exports, "experienceManager", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_experienceManager.default;
    }
});
Object.defineProperty(module.exports, "experiencePlatform", {
    enumerable: true,
    get: function() {
        return $lBBEP.experiencePlatform;
    }
});
Object.defineProperty(module.exports, "experiencePlatformHomePueblo", {
    enumerable: true,
    get: function() {
        return $lBBEP.experiencePlatformHomePueblo;
    }
});
Object.defineProperty(module.exports, "platformAmplify", {
    enumerable: true,
    get: function() {
        return $lBBEP.platformAmplify;
    }
});
Object.defineProperty(module.exports, "platformAudienceOrchestrationUi", {
    enumerable: true,
    get: function() {
        return $lBBEP.platformAudienceOrchestrationUi;
    }
});
Object.defineProperty(module.exports, "platformMexp", {
    enumerable: true,
    get: function() {
        return $lBBEP.platformMexp;
    }
});
Object.defineProperty(module.exports, "platformPermissionsUI", {
    enumerable: true,
    get: function() {
        return $lBBEP.platformPermissionsUI;
    }
});
Object.defineProperty(module.exports, "platformUnifiedTags", {
    enumerable: true,
    get: function() {
        return $lBBEP.platformUnifiedTags;
    }
});
Object.defineProperty(module.exports, "platformUIEncryption", {
    enumerable: true,
    get: function() {
        return $lBBEP.platformUIEncryption;
    }
});
Object.defineProperty(module.exports, "platformUIQueries", {
    enumerable: true,
    get: function() {
        return $lBBEP.platformUIQueries;
    }
});
Object.defineProperty(module.exports, "platformUIOffers", {
    enumerable: true,
    get: function() {
        return $lBBEP.platformUIOffers;
    }
});
Object.defineProperty(module.exports, "platformUIComponents", {
    enumerable: true,
    get: function() {
        return $lBBEP.platformUIComponents;
    }
});
Object.defineProperty(module.exports, "platformUIDashboards", {
    enumerable: true,
    get: function() {
        return $lBBEP.platformUIDashboards;
    }
});
Object.defineProperty(module.exports, "platformUIExperiments", {
    enumerable: true,
    get: function() {
        return $lBBEP.platformUIExperiments;
    }
});
Object.defineProperty(module.exports, "platformUIMetricsCatalog", {
    enumerable: true,
    get: function() {
        return $lBBEP.platformUIMetricsCatalog;
    }
});
Object.defineProperty(module.exports, "platformUILicenseUsage", {
    enumerable: true,
    get: function() {
        return $lBBEP.platformUILicenseUsage;
    }
});
Object.defineProperty(module.exports, "platformUIDatasets", {
    enumerable: true,
    get: function() {
        return $lBBEP.platformUIDatasets;
    }
});
Object.defineProperty(module.exports, "platformFederatedDataUI", {
    enumerable: true,
    get: function() {
        return $lBBEP.platformFederatedDataUI;
    }
});
Object.defineProperty(module.exports, "firstmile", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_firstmile.default;
    }
});
Object.defineProperty(module.exports, "formsAuthoringAssistantSpa", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_formsAuthoringAssistantSpa.default;
    }
});
Object.defineProperty(module.exports, "formsSpa", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_formsSpa.default;
    }
});
Object.defineProperty(module.exports, "formsvrdashboard", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_formsvrdashboard.default;
    }
});
Object.defineProperty(module.exports, "fusion", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_fusion.default;
    }
});
Object.defineProperty(module.exports, "genStudio", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_genStudio.default;
    }
});
Object.defineProperty(module.exports, "griffon", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_griffon.default;
    }
});
Object.defineProperty(module.exports, "hummingbird", {
    enumerable: true,
    get: function() {
        return $j764q.hummingbird;
    }
});
Object.defineProperty(module.exports, "hummingbirdTranslations", {
    enumerable: true,
    get: function() {
        return $j764q.hummingbirdTranslations;
    }
});
Object.defineProperty(module.exports, "inappEditor", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_inappEditor.default;
    }
});
Object.defineProperty(module.exports, "internalDataSync", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_internalDataSync.default;
    }
});
Object.defineProperty(module.exports, "journeysNextAdmin", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_journeysNextAdmin.default;
    }
});
Object.defineProperty(module.exports, "journeysNextAuthoring", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_journeysNextAuthoring.default;
    }
});
Object.defineProperty(module.exports, "landing", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_landing.default;
    }
});
Object.defineProperty(module.exports, "maestroUI", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_maestroUI.default;
    }
});
Object.defineProperty(module.exports, "marketoEmails", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_marketoEmails.default;
    }
});
Object.defineProperty(module.exports, "marketoLandingPage", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_marketoLandingPage.default;
    }
});
Object.defineProperty(module.exports, "notifications", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_notifications.default;
    }
});
Object.defineProperty(module.exports, "peopleUi", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_peopleUi.default;
    }
});
Object.defineProperty(module.exports, "permissionsUI", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_permissionsUI.default;
    }
});
Object.defineProperty(module.exports, "personalizationEditor", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_personalizationEditor.default;
    }
});
Object.defineProperty(module.exports, "personalizationEditorDemo", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_personalizationEditorDemo.default;
    }
});
Object.defineProperty(module.exports, "platformUIIdentity", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_platformUIIdentity.default;
    }
});
Object.defineProperty(module.exports, "profileexplorer", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_profileexplorer.default;
    }
});
Object.defineProperty(module.exports, "prospectAi", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_prospectAi.default;
    }
});
Object.defineProperty(module.exports, "pulseAutomationid", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_pulseAutomationid.default;
    }
});
Object.defineProperty(module.exports, "reportScheduleManagement", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_reportScheduleManagement.default;
    }
});
Object.defineProperty(module.exports, "reportScheduler", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_reportScheduler.default;
    }
});
Object.defineProperty(module.exports, "ruleEditorUiService", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_ruleeditoruiservice.default;
    }
});
Object.defineProperty(module.exports, "sandboxManagementApp", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_sandboxManagementApp.default;
    }
});
Object.defineProperty(module.exports, "screens", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_screens.default;
    }
});
Object.defineProperty(module.exports, "softwareDistribution", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_softwareDistribution.default;
    }
});
Object.defineProperty(module.exports, "spadebugger", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_spadebugger.default;
    }
});
Object.defineProperty(module.exports, "starter", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_starter.default;
    }
});
Object.defineProperty(module.exports, "targetSandbox", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_targetSandbox.default;
    }
});
Object.defineProperty(module.exports, "uberReleaseRegistry", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_uberReleaseRegistry.default;
    }
});
Object.defineProperty(module.exports, "uisAutomation", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_uisAutomation.default;
    }
});
Object.defineProperty(module.exports, "uistoolsui", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_uistoolsui.default;
    }
});
Object.defineProperty(module.exports, "userPreferences", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_userPreferences.default;
    }
});
Object.defineProperty(module.exports, "webEditor", {
    enumerable: true,
    get: function() {
        return $f51822763a134398$var$_webEditor.default;
    }
});
Object.defineProperty(module.exports, "workfront", {
    enumerable: true,
    get: function() {
        return $lAqcL.workfront;
    }
});
Object.defineProperty(module.exports, "workfrontPreview", {
    enumerable: true,
    get: function() {
        return $lAqcL.workfrontPreview;
    }
});

var $74mDa = parcelRequire("74mDa");
Object.keys($74mDa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $74mDa[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $74mDa[key];
        }
    });
});

var $hWgGd = parcelRequire("hWgGd");
Object.keys($hWgGd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $hWgGd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hWgGd[key];
        }
    });
});

var $8FSbO = parcelRequire("8FSbO");
Object.keys($8FSbO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8FSbO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8FSbO[key];
        }
    });
});

var $kR92m = parcelRequire("kR92m");
Object.keys($kR92m).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $kR92m[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kR92m[key];
        }
    });
});

var $jqwuU = parcelRequire("jqwuU");
Object.keys($jqwuU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $jqwuU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jqwuU[key];
        }
    });
});

var $ejaTZ = parcelRequire("ejaTZ");
Object.keys($ejaTZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ejaTZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ejaTZ[key];
        }
    });
});

var $Yx8hT = parcelRequire("Yx8hT");
Object.keys($Yx8hT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $Yx8hT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $Yx8hT[key];
        }
    });
});

var $9L7xH = parcelRequire("9L7xH");
Object.keys($9L7xH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9L7xH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9L7xH[key];
        }
    });
});

var $be9hY = parcelRequire("be9hY");
Object.keys($be9hY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $be9hY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $be9hY[key];
        }
    });
});

var $6tXYl = parcelRequire("6tXYl");
Object.keys($6tXYl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6tXYl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6tXYl[key];
        }
    });
});

var $81gmm = parcelRequire("81gmm");
Object.keys($81gmm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $81gmm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $81gmm[key];
        }
    });
});

var $arIPj = parcelRequire("arIPj");
Object.keys($arIPj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $arIPj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $arIPj[key];
        }
    });
});

var $9AEgh = parcelRequire("9AEgh");
Object.keys($9AEgh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9AEgh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9AEgh[key];
        }
    });
});

var $lsPrI = parcelRequire("lsPrI");
Object.keys($lsPrI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $lsPrI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lsPrI[key];
        }
    });
});

var $jl3Tk = parcelRequire("jl3Tk");
Object.keys($jl3Tk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $jl3Tk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jl3Tk[key];
        }
    });
});

var $7DZAa = parcelRequire("7DZAa");
Object.keys($7DZAa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7DZAa[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7DZAa[key];
        }
    });
});

var $dSQaL = parcelRequire("dSQaL");
Object.keys($dSQaL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dSQaL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dSQaL[key];
        }
    });
});

var $gyj38 = parcelRequire("gyj38");
Object.keys($gyj38).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $gyj38[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gyj38[key];
        }
    });
});

var $6kTFF = parcelRequire("6kTFF");
Object.keys($6kTFF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6kTFF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6kTFF[key];
        }
    });
});

var $aejSY = parcelRequire("aejSY");
Object.keys($aejSY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $aejSY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aejSY[key];
        }
    });
});

var $2JP99 = parcelRequire("2JP99");
Object.keys($2JP99).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2JP99[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2JP99[key];
        }
    });
});

var $k5kpY = parcelRequire("k5kpY");
Object.keys($k5kpY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $k5kpY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $k5kpY[key];
        }
    });
});

var $eq1T3 = parcelRequire("eq1T3");
Object.keys($eq1T3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $eq1T3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eq1T3[key];
        }
    });
});

var $h5LFe = parcelRequire("h5LFe");
Object.keys($h5LFe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $h5LFe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h5LFe[key];
        }
    });
});

var $9TqP1 = parcelRequire("9TqP1");
Object.keys($9TqP1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f51822763a134398$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9TqP1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9TqP1[key];
        }
    });
});

var $f51822763a134398$var$_abmweb = $f51822763a134398$var$_interopRequireDefault((parcelRequire("6ed5a")));

var $f51822763a134398$var$_accp = $f51822763a134398$var$_interopRequireDefault((parcelRequire("aLgRx")));

var $f51822763a134398$var$_accreportsui = $f51822763a134398$var$_interopRequireDefault((parcelRequire("9UeED")));

var $f51822763a134398$var$_acctriggersui = $f51822763a134398$var$_interopRequireDefault((parcelRequire("kXH9R")));

var $f51822763a134398$var$_accwebui = $f51822763a134398$var$_interopRequireDefault((parcelRequire("4B3xI")));

var $f51822763a134398$var$_accwebuiLocalization = $f51822763a134398$var$_interopRequireDefault((parcelRequire("g8b9W")));

var $f51822763a134398$var$_admin = $f51822763a134398$var$_interopRequireDefault((parcelRequire("jx8LV")));

var $f51822763a134398$var$_adobepassunifiedshellconsoleclient = $f51822763a134398$var$_interopRequireDefault((parcelRequire("axFeZ")));

var $f51822763a134398$var$_adobeReachUI = $f51822763a134398$var$_interopRequireDefault((parcelRequire("BMsAk")));

var $f51822763a134398$var$_advertisingSsc = $f51822763a134398$var$_interopRequireDefault((parcelRequire("edAmi")));

var $f51822763a134398$var$_aemCfModelEditor = $f51822763a134398$var$_interopRequireDefault((parcelRequire("eM1dm")));

var $f51822763a134398$var$_aemHomeUi = $f51822763a134398$var$_interopRequireDefault((parcelRequire("4h3Pv")));

var $f51822763a134398$var$_aemOutboundMarketing = $f51822763a134398$var$_interopRequireDefault((parcelRequire("dvLkR")));

var $f51822763a134398$var$_affiliatesPlatformAdvertiser = $f51822763a134398$var$_interopRequireDefault((parcelRequire("jJQ21")));

var $f51822763a134398$var$_affiliatesPlatformAffiliate = $f51822763a134398$var$_interopRequireDefault((parcelRequire("fX3NY")));

var $f51822763a134398$var$_agoraUI = $f51822763a134398$var$_interopRequireDefault((parcelRequire("8daGr")));

var $f51822763a134398$var$_ajoContentEditor = $f51822763a134398$var$_interopRequireDefault((parcelRequire("3V3fc")));

var $f51822763a134398$var$_amplify = $f51822763a134398$var$_interopRequireDefault((parcelRequire("h8iFD")));

var $f51822763a134398$var$_analytics = $f51822763a134398$var$_interopRequireDefault((parcelRequire("8I2YL")));

var $f51822763a134398$var$_annotations = $f51822763a134398$var$_interopRequireDefault((parcelRequire("94aCm")));

var $f51822763a134398$var$_ansiblegenai = $f51822763a134398$var$_interopRequireDefault((parcelRequire("3o3dI")));

var $f51822763a134398$var$_assetsCollections = $f51822763a134398$var$_interopRequireDefault((parcelRequire("a8DXY")));

var $f51822763a134398$var$_audiencemanager = $f51822763a134398$var$_interopRequireDefault((parcelRequire("4MkqN")));

var $f51822763a134398$var$_berlinHome = $f51822763a134398$var$_interopRequireDefault((parcelRequire("fAQXr")));

var $f51822763a134398$var$_blank = $f51822763a134398$var$_interopRequireDefault((parcelRequire("3O627")));

var $f51822763a134398$var$_campaignAccWebUiSpa = $f51822763a134398$var$_interopRequireDefault((parcelRequire("ivoHP")));

var $f51822763a134398$var$_cjaModules = $f51822763a134398$var$_interopRequireDefault((parcelRequire("jpfsG")));

var $f51822763a134398$var$_cloudManager = $f51822763a134398$var$_interopRequireDefault((parcelRequire("gsxpd")));

var $f51822763a134398$var$_cloudManagerBackOfficeUi = $f51822763a134398$var$_interopRequireDefault((parcelRequire("ioE0I")));

var $f51822763a134398$var$_cmConsoleUi = $f51822763a134398$var$_interopRequireDefault((parcelRequire("8Y61l")));

var $f51822763a134398$var$_cmStandaloneMfe = $f51822763a134398$var$_interopRequireDefault((parcelRequire("2SHGh")));

var $f51822763a134398$var$_commerce = $f51822763a134398$var$_interopRequireDefault((parcelRequire("eYBz3")));

var $f51822763a134398$var$_commerceCatalogServiceDemoUI = $f51822763a134398$var$_interopRequireDefault((parcelRequire("6PGAu")));

var $f51822763a134398$var$_commerceSaaS = $f51822763a134398$var$_interopRequireDefault((parcelRequire("frfKH")));

var $f51822763a134398$var$_complianceDroid = $f51822763a134398$var$_interopRequireDefault((parcelRequire("4UfcS")));

var $f51822763a134398$var$_contentHub = $f51822763a134398$var$_interopRequireDefault((parcelRequire("dUfEi")));

var $f51822763a134398$var$_coPilotReview = $f51822763a134398$var$_interopRequireDefault((parcelRequire("27u2w")));

var $f51822763a134398$var$_creativeDesigner = $f51822763a134398$var$_interopRequireDefault((parcelRequire("gdIeY")));

var $f51822763a134398$var$_customerEngineeringEnablementManager = $f51822763a134398$var$_interopRequireDefault((parcelRequire("k61PW")));

var $f0USY = parcelRequire("f0USY");

var $f51822763a134398$var$_ddam = $f51822763a134398$var$_interopRequireDefault((parcelRequire("ewVCA")));

var $f51822763a134398$var$_depapp = $f51822763a134398$var$_interopRequireDefault((parcelRequire("84sS8")));

var $f51822763a134398$var$_designerOnWebId = $f51822763a134398$var$_interopRequireDefault((parcelRequire("j9a4I")));

var $f51822763a134398$var$_developerconsoleID = $f51822763a134398$var$_interopRequireDefault((parcelRequire("8Ithn")));

var $f51822763a134398$var$_documentAnalyzer = $f51822763a134398$var$_interopRequireDefault((parcelRequire("aoZOZ")));

var $f51822763a134398$var$_dxCommerceBackgroundGenerationSpaTest = $f51822763a134398$var$_interopRequireDefault((parcelRequire("d4TPC")));

var $f51822763a134398$var$_exdDecisionPolicyAssist = $f51822763a134398$var$_interopRequireDefault((parcelRequire("4sEmx")));

var $f51822763a134398$var$_exim = $f51822763a134398$var$_interopRequireDefault((parcelRequire("fiW4l")));

var $f51822763a134398$var$_experienceManager = $f51822763a134398$var$_interopRequireDefault((parcelRequire("cgZLs")));

var $lBBEP = parcelRequire("lBBEP");

var $f51822763a134398$var$_firstmile = $f51822763a134398$var$_interopRequireDefault((parcelRequire("8jxYY")));

var $f51822763a134398$var$_formsAuthoringAssistantSpa = $f51822763a134398$var$_interopRequireDefault((parcelRequire("k4ZFV")));

var $f51822763a134398$var$_formsSpa = $f51822763a134398$var$_interopRequireDefault((parcelRequire("h8iik")));

var $f51822763a134398$var$_formsvrdashboard = $f51822763a134398$var$_interopRequireDefault((parcelRequire("7JRYZ")));

var $f51822763a134398$var$_fusion = $f51822763a134398$var$_interopRequireDefault((parcelRequire("7v60K")));

var $f51822763a134398$var$_genStudio = $f51822763a134398$var$_interopRequireDefault((parcelRequire("8B4Dg")));

var $f51822763a134398$var$_griffon = $f51822763a134398$var$_interopRequireDefault((parcelRequire("c1NsA")));

var $j764q = parcelRequire("j764q");

var $f51822763a134398$var$_inappEditor = $f51822763a134398$var$_interopRequireDefault((parcelRequire("8GiLQ")));

var $f51822763a134398$var$_internalDataSync = $f51822763a134398$var$_interopRequireDefault((parcelRequire("1fAhd")));

var $f51822763a134398$var$_journeysNextAdmin = $f51822763a134398$var$_interopRequireDefault((parcelRequire("bISJe")));

var $f51822763a134398$var$_journeysNextAuthoring = $f51822763a134398$var$_interopRequireDefault((parcelRequire("lMagz")));

var $f51822763a134398$var$_landing = $f51822763a134398$var$_interopRequireDefault((parcelRequire("bTV69")));

var $f51822763a134398$var$_maestroUI = $f51822763a134398$var$_interopRequireDefault((parcelRequire("bAy8L")));

var $f51822763a134398$var$_marketoEmails = $f51822763a134398$var$_interopRequireDefault((parcelRequire("aCFNv")));

var $f51822763a134398$var$_marketoLandingPage = $f51822763a134398$var$_interopRequireDefault((parcelRequire("1pB7p")));

var $f51822763a134398$var$_notifications = $f51822763a134398$var$_interopRequireDefault((parcelRequire("gEYVQ")));

var $f51822763a134398$var$_peopleUi = $f51822763a134398$var$_interopRequireDefault((parcelRequire("d8wAc")));

var $f51822763a134398$var$_permissionsUI = $f51822763a134398$var$_interopRequireDefault((parcelRequire("6AMM5")));

var $f51822763a134398$var$_personalizationEditor = $f51822763a134398$var$_interopRequireDefault((parcelRequire("5haes")));

var $f51822763a134398$var$_personalizationEditorDemo = $f51822763a134398$var$_interopRequireDefault((parcelRequire("92QnR")));

var $f51822763a134398$var$_platformUIIdentity = $f51822763a134398$var$_interopRequireDefault((parcelRequire("lbmFS")));

var $f51822763a134398$var$_profileexplorer = $f51822763a134398$var$_interopRequireDefault((parcelRequire("jtNwG")));

var $f51822763a134398$var$_prospectAi = $f51822763a134398$var$_interopRequireDefault((parcelRequire("lSe4e")));

var $f51822763a134398$var$_pulseAutomationid = $f51822763a134398$var$_interopRequireDefault((parcelRequire("4hvhb")));

var $f51822763a134398$var$_reportScheduleManagement = $f51822763a134398$var$_interopRequireDefault((parcelRequire("3HKv7")));

var $f51822763a134398$var$_reportScheduler = $f51822763a134398$var$_interopRequireDefault((parcelRequire("dYXRj")));

var $f51822763a134398$var$_ruleeditoruiservice = $f51822763a134398$var$_interopRequireDefault((parcelRequire("cToEf")));

var $f51822763a134398$var$_sandboxManagementApp = $f51822763a134398$var$_interopRequireDefault((parcelRequire("dNqV3")));

var $f51822763a134398$var$_screens = $f51822763a134398$var$_interopRequireDefault((parcelRequire("e2CEz")));

var $f51822763a134398$var$_softwareDistribution = $f51822763a134398$var$_interopRequireDefault((parcelRequire("eliQt")));

var $f51822763a134398$var$_spadebugger = $f51822763a134398$var$_interopRequireDefault((parcelRequire("f64Cl")));

var $f51822763a134398$var$_starter = $f51822763a134398$var$_interopRequireDefault((parcelRequire("l8mNV")));

var $f51822763a134398$var$_targetSandbox = $f51822763a134398$var$_interopRequireDefault((parcelRequire("hAm5M")));

var $f51822763a134398$var$_uberReleaseRegistry = $f51822763a134398$var$_interopRequireDefault((parcelRequire("kKa0Y")));

var $f51822763a134398$var$_uisAutomation = $f51822763a134398$var$_interopRequireDefault((parcelRequire("cb8F7")));

var $f51822763a134398$var$_uistoolsui = $f51822763a134398$var$_interopRequireDefault((parcelRequire("luX4S")));

var $f51822763a134398$var$_userPreferences = $f51822763a134398$var$_interopRequireDefault((parcelRequire("kbzze")));

var $f51822763a134398$var$_webEditor = $f51822763a134398$var$_interopRequireDefault((parcelRequire("cY7mL")));

var $lAqcL = parcelRequire("lAqcL");
function $f51822763a134398$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("74mDa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.aemtrustcenter = module.exports.aemxmngr = module.exports.releaseToggles = module.exports.aemExperienceSuccessStudio = module.exports.aemGenerateVariations = module.exports.customerAlertingCenter = module.exports.skylineUniversalEditor = module.exports.universalEditor = module.exports.aemCommonsStorybook = module.exports.aemCfEditorStorybook = module.exports.aemCfEditor = module.exports.aemCfAdmin = module.exports.aemSkyline = void 0;

var $0b11c45a78fc4aa2$var$_aemCfModelEditor = $0b11c45a78fc4aa2$var$_interopRequireDefault((parcelRequire("eM1dm")));

var $jOW4N = parcelRequire("jOW4N");

var $ctGaZ = parcelRequire("ctGaZ");
function $0b11c45a78fc4aa2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/aem.ts
const $0b11c45a78fc4aa2$var$payload = [
    "imsOrg",
    "imsProfile",
    "path"
];
const $0b11c45a78fc4aa2$var$requiredPayload = [];
const $0b11c45a78fc4aa2$var$aemSkyline = {
    appId: "aemshell",
    appRoot: "experienceManagerUI",
    analytics: {
        code: "aem"
    },
    gainsight: {
        productKey: "AP-AULLRFDZLJ9K-2"
    },
    hideTenant: true,
    path: "/aem",
    runtime: $ctGaZ.RUNTIME.CDN_LEGACY,
    sandbox: {
        hideInitialSpinner: true,
        pageTimeout: 0,
        history: {
            type: $ctGaZ.HISTORY.SERVER,
            config: {
                absolutePaths: true
            }
        },
        sources: {
            dev: {
                discovery: "/bin/unifiedshell/discovery?configid=ims",
                payload: $0b11c45a78fc4aa2$var$payload,
                reduceProfile: true,
                requiredPayload: $0b11c45a78fc4aa2$var$requiredPayload,
                redirectOnFailure: {
                    code: [
                        403
                    ],
                    path: "/experiencemanager"
                },
                withCredentials: true
            },
            qa: {
                discovery: "/bin/unifiedshell/discovery?configid=ims",
                payload: $0b11c45a78fc4aa2$var$payload,
                reduceProfile: true,
                requiredPayload: $0b11c45a78fc4aa2$var$requiredPayload,
                redirectOnFailure: {
                    code: [
                        403
                    ],
                    path: "/experiencemanager"
                },
                withCredentials: true
            },
            stage: {
                cache: {
                    scope: $jOW4N.CACHE_SCOPE.LOCAL,
                    ttl: 43200 // 12 hours
                },
                discovery: "/bin/unifiedshell/discovery?configid=ims",
                payload: $0b11c45a78fc4aa2$var$payload,
                reduceProfile: true,
                requiredPayload: $0b11c45a78fc4aa2$var$requiredPayload,
                redirectOnFailure: {
                    code: [
                        403
                    ],
                    path: "/experiencemanager"
                },
                url: "/",
                withCredentials: true
            },
            prod: {
                cache: {
                    scope: $jOW4N.CACHE_SCOPE.LOCAL,
                    ttl: 43200 // 12 hours
                },
                discovery: "/bin/unifiedshell/discovery?configid=ims",
                payload: $0b11c45a78fc4aa2$var$payload,
                reduceProfile: true,
                requiredPayload: $0b11c45a78fc4aa2$var$requiredPayload,
                redirectOnFailure: {
                    code: [
                        403
                    ],
                    path: "/experiencemanager"
                },
                url: "/",
                withCredentials: true
            }
        }
    },
    withinSkyline: true,
    access: {
        code: [
            "dma_aem_cloud",
            "dma_media_library"
        ]
    }
};
module.exports.aemSkyline = $0b11c45a78fc4aa2$var$aemSkyline;
const $0b11c45a78fc4aa2$var$aemCfAdmin = {
    appId: "aem-cf-admin",
    sharedCaches: [
        "aem-headless"
    ],
    spaAppId: "cq-aem-headless-ui-admin",
    path: "/aem/cf/admin",
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER,
    gainsight: {
        productKey: "AP-AULLRFDZLJ9K-2"
    },
    analytics: {
        code: "aem-cf-admin",
        scripts: {
            dev: "//assets.adobedtm.com/a7d65461e54e/72cd1ca12e34/launch-38d64c9ec532-development.min.js",
            qa: "//assets.adobedtm.com/a7d65461e54e/72cd1ca12e34/launch-38d64c9ec532-development.min.js",
            stage: "//assets.adobedtm.com/a7d65461e54e/72cd1ca12e34/launch-2de795b312e7-staging.min.js",
            prod: "//assets.adobedtm.com/a7d65461e54e/72cd1ca12e34/launch-cbc5f9ab5f51.min.js"
        }
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:12399"
        }
    },
    access: {
        code: [
            "dma_aem_ams",
            "dma_aem_onprem",
            "dma_aem_cloud"
        ]
    },
    betaFeedbackConfigId: "aem-cf-admin"
};
module.exports.aemCfAdmin = $0b11c45a78fc4aa2$var$aemCfAdmin;
const $0b11c45a78fc4aa2$var$aemCfEditorBaseConfig = {
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.AA
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    gainsight: {
        productKey: "AP-AULLRFDZLJ9K-2"
    },
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:12398"
        }
    },
    spaAppId: "cq-aem-headless-ui-cf-editor",
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
const $0b11c45a78fc4aa2$var$assetSelectorsAemCfEditor = {
    ...$0b11c45a78fc4aa2$var$aemCfEditorBaseConfig,
    appId: "assets-selectors",
    gainsight: {
        productKey: "AP-GI70AEBJW3LJ-2"
    },
    spaAppId: "CQ-assets-selectors"
};
const $0b11c45a78fc4aa2$var$aemCfEditor = {
    ...$0b11c45a78fc4aa2$var$aemCfEditorBaseConfig,
    appId: "aem-cf-editor",
    nestedApps: [
        $0b11c45a78fc4aa2$var$assetSelectorsAemCfEditor
    ],
    path: "/aem/cf/editor",
    permissionsPolicy: [
        "clipboard-write"
    ],
    access: {
        code: [
            "dma_aem_ams",
            "dma_aem_onprem",
            "dma_aem_cloud"
        ]
    },
    sharedCaches: [
        "aem-headless"
    ],
    omegaSuiteId: "aem"
};
module.exports.aemCfEditor = $0b11c45a78fc4aa2$var$aemCfEditor;
const $0b11c45a78fc4aa2$var$aemCfEditorStorybook = {
    appId: "aem-cf-editor-storybook",
    path: "/aem/cf/editor-storybook",
    sharedCaches: [
        "aem-headless"
    ],
    spaAppId: "cq-aem-headless-ui-cf-editor",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        pathPrefix: {
            default: "/static-assets/storybook/index.html"
        },
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:12391",
            prod: ""
        }
    }
};
module.exports.aemCfEditorStorybook = $0b11c45a78fc4aa2$var$aemCfEditorStorybook;
const $0b11c45a78fc4aa2$var$aemCommonsStorybook = {
    appId: "aem-commons-storybook",
    path: "/aem/commons-storybook",
    sharedCaches: [
        "aem-headless"
    ],
    spaAppId: "cq-aem-headless-ui-commons",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:12395",
            prod: ""
        }
    }
};
module.exports.aemCommonsStorybook = $0b11c45a78fc4aa2$var$aemCommonsStorybook;
const $0b11c45a78fc4aa2$var$universalEditor = {
    appId: "universalEditor",
    path: "/aem/editor",
    omegaSuiteId: "aem",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.AA
    },
    spaAppId: "cq-universal-editor",
    nestedApps: [
        $0b11c45a78fc4aa2$var$_aemCfModelEditor.default
    ],
    permissionsPolicy: [
        "clipboard-read",
        "clipboard-write"
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
/**
 * Local development may not work for this application as it is part of AEM and
 * is required to load on adobeaemcloud.com. The application can be developed,
 * however at it's original location.
 */ module.exports.universalEditor = $0b11c45a78fc4aa2$var$universalEditor;
const $0b11c45a78fc4aa2$var$skylineUniversalEditor = {
    ...$0b11c45a78fc4aa2$var$universalEditor,
    appId: "skylineUniversalEditor",
    path: "/aem/universal-editor",
    withinSkyline: true
};
module.exports.skylineUniversalEditor = $0b11c45a78fc4aa2$var$skylineUniversalEditor;
const $0b11c45a78fc4aa2$var$customerAlertingCenter = {
    appId: "customerAlertingCenter",
    path: "/aem/actions-center",
    omegaSuiteId: "aem",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.AA
    },
    spaAppId: "experience-platform-customer-alerting-center",
    sandbox: {
        history: $ctGaZ.HISTORY.HASH,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
module.exports.customerAlertingCenter = $0b11c45a78fc4aa2$var$customerAlertingCenter;
const $0b11c45a78fc4aa2$var$aemGenerateVariations = {
    appId: "aemGenerateVariations",
    path: "/aem/generate-variations",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.AA
    },
    omegaSuiteId: "aem",
    permissionsPolicy: [
        "clipboard-read",
        "clipboard-write"
    ],
    refreshOnImsChange: true,
    runtime: $ctGaZ.RUNTIME.CDN_LEGACY,
    sandbox: {
        history: $ctGaZ.HISTORY.SERVER,
        overrideParams: true,
        sources: {
            local: "https://localhost:9080",
            workspace: "https://245265-879aquaant-{workspace}.adobeio-static.net/index.html",
            dev: "https://245265-879aquaant-development.adobeio-static.net/index.html",
            qa: "https://245265-879aquaant-qa.adobeio-static.net/index.html",
            stage: "https://245265-879aquaant-stage.adobeio-static.net/index.html",
            prod: "https://245265-879aquaant.adobeio-static.net/index.html"
        }
    }
};
module.exports.aemGenerateVariations = $0b11c45a78fc4aa2$var$aemGenerateVariations;
const $0b11c45a78fc4aa2$var$aemExperienceSuccessStudio = {
    appId: "aemExperienceSuccessStudio",
    path: "/aem/experience-success-studio",
    releaseType: $ctGaZ.RELEASE_TYPE.ALPHA,
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    omegaSuiteId: "aem",
    permissionsPolicy: [
        "clipboard-read",
        "clipboard-write"
    ],
    refreshOnImsChange: true,
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.SERVER,
        overrideParams: true,
        sources: {
            local: "https://localhost:9080",
            workspace: "https://245265-aemsuccessstudio-{workspace}.adobeio-static.net/index.html",
            dev: "https://245265-aemsuccessstudio-development.adobeio-static.net/index.html",
            qa: "https://245265-aemsuccessstudio-qa.adobeio-static.net/index.html",
            stage: "https://245265-aemsuccessstudio-stage.adobeio-static.net/index.html",
            prod: "https://245265-aemsuccessstudio.adobeio-static.net/index.html"
        }
    },
    access: {
        flag: "aem-exp-success-studio-enabled"
    }
};
module.exports.aemExperienceSuccessStudio = $0b11c45a78fc4aa2$var$aemExperienceSuccessStudio;
const $0b11c45a78fc4aa2$var$releaseToggles = {
    appId: "releaseToggles",
    path: "/aem/toggles",
    betaFeedbackConfigId: "aem-release-toggles-ui",
    spaAppId: "experience-platform-skyline-release-toggles-ui-frontend",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    access: {
        flag: "release-toggles-enabled"
    }
};
module.exports.releaseToggles = $0b11c45a78fc4aa2$var$releaseToggles;
const $0b11c45a78fc4aa2$var$aemxmngr = {
    appId: "aemxmngr",
    appRoot: "experienceManagerUI",
    path: "/aem/extension-manager",
    omegaSuiteId: "aemxmngr",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.AA
    },
    spaAppId: "devx-services-aemx-mngr-spa",
    runtime: $ctGaZ.RUNTIME.CDN,
    permissionsPolicy: [
        "clipboard-write"
    ],
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:12399"
        }
    }
};
module.exports.aemxmngr = $0b11c45a78fc4aa2$var$aemxmngr;
const $0b11c45a78fc4aa2$var$aemtrustcenter = {
    appId: "aemtrustcenter",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/aem/trust-center",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    permissionsPolicy: [
        "clipboard-write"
    ],
    spaAppId: "experience-platform-aemtrustcenter",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
module.exports.aemtrustcenter = $0b11c45a78fc4aa2$var$aemtrustcenter;

});
parcelRegister("eM1dm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/aemCfModelEditor.ts
const $95948957fd465293$var$aemCfModelEditor = {
    appId: "aem-cf-model-editor",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/aem/cf/model-editor",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "CQ-aem-headless-ui-cf-model-editor",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:12401",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $95948957fd465293$var$_default = $95948957fd465293$var$aemCfModelEditor;
module.exports.default = $95948957fd465293$var$_default;

});

parcelRegister("jOW4N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiscoveryResponseSource = module.exports.PATH_CACHE_METHOD = module.exports.CACHE_SCOPE = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ let $6dfb7d76e8169e39$var$CACHE_SCOPE;
module.exports.CACHE_SCOPE = $6dfb7d76e8169e39$var$CACHE_SCOPE;
(function(CACHE_SCOPE) {
    CACHE_SCOPE["NONE"] = "NONE";
    CACHE_SCOPE["LOCAL"] = "LOCAL";
})($6dfb7d76e8169e39$var$CACHE_SCOPE || (module.exports.CACHE_SCOPE = $6dfb7d76e8169e39$var$CACHE_SCOPE = {}));
let $6dfb7d76e8169e39$var$PATH_CACHE_METHOD;
module.exports.PATH_CACHE_METHOD = $6dfb7d76e8169e39$var$PATH_CACHE_METHOD;
(function(PATH_CACHE_METHOD) {
    PATH_CACHE_METHOD[PATH_CACHE_METHOD["CACHE_PATH"] = 0] = "CACHE_PATH";
    PATH_CACHE_METHOD[PATH_CACHE_METHOD["CACHE_PARAMS"] = 1] = "CACHE_PARAMS";
    PATH_CACHE_METHOD[PATH_CACHE_METHOD["CACHE_DEFAULT_PATH"] = 2] = "CACHE_DEFAULT_PATH";
})($6dfb7d76e8169e39$var$PATH_CACHE_METHOD || (module.exports.PATH_CACHE_METHOD = $6dfb7d76e8169e39$var$PATH_CACHE_METHOD = {}));
let $6dfb7d76e8169e39$var$DiscoveryResponseSource;
module.exports.DiscoveryResponseSource = $6dfb7d76e8169e39$var$DiscoveryResponseSource;
(function(DiscoveryResponseSource) {
    DiscoveryResponseSource["CACHE"] = "cache";
    DiscoveryResponseSource["DIRECT"] = "direct";
    DiscoveryResponseSource["MEMORY"] = "memory";
})($6dfb7d76e8169e39$var$DiscoveryResponseSource || (module.exports.DiscoveryResponseSource = $6dfb7d76e8169e39$var$DiscoveryResponseSource = {}));

});


parcelRegister("hWgGd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.aemCloudMigration = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/aem-migration.ts
const $353515e655b7f4b8$var$aemCloudMigration = {
    appId: "aem-migration",
    analytics: {
        code: "cam",
        scripts: {
            dev: "//assets.adobedtm.com/a7d65461e54e/1df46f55b80a/launch-7f21d788b890-staging.min.js",
            qa: "//assets.adobedtm.com/a7d65461e54e/1df46f55b80a/launch-7f21d788b890-staging.min.js",
            stage: "//assets.adobedtm.com/a7d65461e54e/1df46f55b80a/launch-7f21d788b890-staging.min.js",
            prod: "//assets.adobedtm.com/a7d65461e54e/1df46f55b80a/launch-b371e5428f52.min.js"
        }
    },
    spaAppId: "cq-aem-cloud-adoption-ui",
    gainsight: {
        productKey: "AP-UBWAIBMYGXAJ-2"
    },
    path: "/aem/migration",
    runtime: $ctGaZ.RUNTIME.CDN,
    serviceCode: "dma_aem_cloud",
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:12399"
        }
    },
    access: {
        code: [
            "dma_aem_ams",
            "dma_aem_onprem",
            "dma_aem_cloud"
        ],
        flag: "aem-on-prem-enabled"
    }
};
module.exports.aemCloudMigration = $353515e655b7f4b8$var$aemCloudMigration;

});

parcelRegister("8FSbO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.aemPages = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/aem-pages.ts
const $e0c16286aa69b00b$var$aemPages = {
    appId: "aem-pages",
    path: "/aem-pages",
    sandbox: {
        history: $ctGaZ.HISTORY.SERVER,
        sources: {
            dev: "https://localhost.corp.adobe.com:12399/",
            qa: "https://dev--helix-organizer--adobe.hlx.live/",
            stage: "https://stage--helix-organizer--adobe.hlx.live/",
            prod: "https://main--helix-organizer--adobe.hlx.live/"
        }
    },
    access: {
        flag: "aem-pages-enabled"
    }
};
module.exports.aemPages = $e0c16286aa69b00b$var$aemPages;

});

parcelRegister("kR92m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.aiqUiCc = module.exports.aiqUiHome = module.exports.aiqUiTve = module.exports.aiqUiD2c = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/aiq-ui.ts
const $bb2196866f6911ff$var$sharedConfig = {
    spaAppId: "primetime-aiq-ui-unified-shell",
    appRoot: "primetime",
    experienceLeague: {
        communities: "adobe-primetime",
        filter: "Primetime"
    },
    serviceCode: "dma_primetime",
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:12399"
        }
    },
    urlContext: {
        key: "sandbox",
        optional: true
    }
};
const $bb2196866f6911ff$var$aiqUiD2c = {
    ...$bb2196866f6911ff$var$sharedConfig,
    appId: "aiq-ui-d2c",
    path: "/aiq/d2c",
    sandbox: {
        pathPrefix: {
            default: "/d2c"
        },
        ...$bb2196866f6911ff$var$sharedConfig.sandbox
    }
};
module.exports.aiqUiD2c = $bb2196866f6911ff$var$aiqUiD2c;
const $bb2196866f6911ff$var$aiqUiTve = {
    ...$bb2196866f6911ff$var$sharedConfig,
    appId: "aiq-ui-tve",
    path: "/aiq/tve",
    sandbox: {
        pathPrefix: {
            default: "/tve"
        },
        ...$bb2196866f6911ff$var$sharedConfig.sandbox
    }
};
module.exports.aiqUiTve = $bb2196866f6911ff$var$aiqUiTve;
const $bb2196866f6911ff$var$aiqUiHome = {
    ...$bb2196866f6911ff$var$sharedConfig,
    appId: "aiq-ui-home",
    path: "/aiq/home",
    redirectFrom: [
        {
            path: "/aiq",
            options: {
                end: true
            }
        }
    ],
    sandbox: {
        pathPrefix: {
            default: "/home"
        },
        ...$bb2196866f6911ff$var$sharedConfig.sandbox
    }
};
module.exports.aiqUiHome = $bb2196866f6911ff$var$aiqUiHome;
const $bb2196866f6911ff$var$aiqUiCc = {
    ...$bb2196866f6911ff$var$sharedConfig,
    appId: "aiq-ui-cc",
    path: "/aiq/cc",
    sandbox: {
        pathPrefix: {
            default: "/cc"
        },
        ...$bb2196866f6911ff$var$sharedConfig.sandbox
    }
};
module.exports.aiqUiCc = $bb2196866f6911ff$var$aiqUiCc;

});

parcelRegister("jqwuU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ansible = module.exports.ansibleStorybook = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/ansible.ts
const $b37d8cf0428218e2$var$ansibleStorybook = {
    appId: "ansible-storybook",
    path: "/segment-builder/storybook",
    spaAppId: "Ansible-ansible-sdk",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        pathPrefix: {
            default: "/storybook",
            dev: ""
        },
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://ansible.local.cloud.adobe.io:6006",
            prod: ""
        }
    },
    urlContext: {
        key: "sandbox",
        optional: true
    }
};
module.exports.ansibleStorybook = $b37d8cf0428218e2$var$ansibleStorybook;
const $b37d8cf0428218e2$var$ansible = {
    appId: "ansible",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    path: "/segment-builder",
    spaAppId: "Ansible-ansible-sdk",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://ansible.local.cloud.adobe.io:6006",
            prod: ""
        }
    },
    urlContext: {
        key: "sandbox",
        optional: true
    }
};
module.exports.ansible = $b37d8cf0428218e2$var$ansible;

});

parcelRegister("ejaTZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assetsDynamicMediaMicroFrontendsStorybook = module.exports.assetsMicroFrontendsAssetsSampleMfeStorybook = module.exports.assetsMicroFrontendsAssetsUploadStorybook = module.exports.assetsMicroFrontendsAppContainerStorybook = module.exports.assetsMicroFrontendsTaxonomyStorybook = module.exports.assetsMicroFrontendsExpressEditorStorybook = module.exports.assetsMicroFrontendsAdminStorybook = module.exports.assetsMicroFrontendsCollectionsStorybook = module.exports.assetsMicroFrontendsSelectorsStorybook = module.exports.assetsMicroFrontendsReportingStorybook = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/assetsMicroFrontends.ts
const $c375febaade4eb45$var$getAssetsMFEStorybook = (name, spaAppId)=>{
    const repoName = /^(^cq-)?(.+)/i.exec(spaAppId)?.[2];
    return {
        appId: `${repoName}-storybook`,
        spaAppId: spaAppId,
        path: `/assets-micro-frontends/${repoName}`,
        sandbox: {
            pathPrefix: {
                default: "/static-assets/storybook/index.html"
            },
            history: $ctGaZ.HISTORY.HISTORY,
            sources: {
                dev: "https://localhost.corp.adobe.com:8443/",
                dev443: "https://localhost.corp.adobe.com:443/",
                prod: ""
            }
        },
        runtime: $ctGaZ.RUNTIME.CDN,
        urlContext: {
            key: "sandbox",
            optional: true
        }
    };
};
const $c375febaade4eb45$var$assetsMicroFrontendsReportingStorybook = $c375febaade4eb45$var$getAssetsMFEStorybook("Assets Micro Frontends Reporting storybook", "cq-assets-reporting");
module.exports.assetsMicroFrontendsReportingStorybook = $c375febaade4eb45$var$assetsMicroFrontendsReportingStorybook;
const $c375febaade4eb45$var$assetsMicroFrontendsSelectorsStorybook = $c375febaade4eb45$var$getAssetsMFEStorybook("Assets Micro Frontends Selectors storybook", "CQ-assets-selectors");
module.exports.assetsMicroFrontendsSelectorsStorybook = $c375febaade4eb45$var$assetsMicroFrontendsSelectorsStorybook;
const $c375febaade4eb45$var$assetsMicroFrontendsCollectionsStorybook = $c375febaade4eb45$var$getAssetsMFEStorybook("Assets Micro Frontends Collections storybook", "cq-assets-collections");
module.exports.assetsMicroFrontendsCollectionsStorybook = $c375febaade4eb45$var$assetsMicroFrontendsCollectionsStorybook;
const $c375febaade4eb45$var$assetsMicroFrontendsAdminStorybook = $c375febaade4eb45$var$getAssetsMFEStorybook("Assets Micro Frontends Admin Settings storybook", "CQ-assets-admin");
module.exports.assetsMicroFrontendsAdminStorybook = $c375febaade4eb45$var$assetsMicroFrontendsAdminStorybook;
const $c375febaade4eb45$var$assetsMicroFrontendsExpressEditorStorybook = $c375febaade4eb45$var$getAssetsMFEStorybook("Assets Micro Frontends Express Editor storybook", "CQ-assets-express-editor");
module.exports.assetsMicroFrontendsExpressEditorStorybook = $c375febaade4eb45$var$assetsMicroFrontendsExpressEditorStorybook;
const $c375febaade4eb45$var$assetsMicroFrontendsTaxonomyStorybook = $c375febaade4eb45$var$getAssetsMFEStorybook("Assets Micro Frontends Taxonomy storybook", "cq-assets-taxonomy");
module.exports.assetsMicroFrontendsTaxonomyStorybook = $c375febaade4eb45$var$assetsMicroFrontendsTaxonomyStorybook;
const $c375febaade4eb45$var$assetsMicroFrontendsAppContainerStorybook = $c375febaade4eb45$var$getAssetsMFEStorybook("Assets Micro Frontends App Container storybook", "CQ-app-container");
module.exports.assetsMicroFrontendsAppContainerStorybook = $c375febaade4eb45$var$assetsMicroFrontendsAppContainerStorybook;
const $c375febaade4eb45$var$assetsMicroFrontendsAssetsUploadStorybook = $c375febaade4eb45$var$getAssetsMFEStorybook("Assets Micro Frontends Assets Upload storybook", "CQ-assets-upload");
module.exports.assetsMicroFrontendsAssetsUploadStorybook = $c375febaade4eb45$var$assetsMicroFrontendsAssetsUploadStorybook;
const $c375febaade4eb45$var$assetsMicroFrontendsAssetsSampleMfeStorybook = $c375febaade4eb45$var$getAssetsMFEStorybook("Assets Micro Frontends Assets Sample MFE storybook", "CQ-assets-sample-mfe");
module.exports.assetsMicroFrontendsAssetsSampleMfeStorybook = $c375febaade4eb45$var$assetsMicroFrontendsAssetsSampleMfeStorybook;
const $c375febaade4eb45$var$assetsDynamicMediaMicroFrontendsStorybook = $c375febaade4eb45$var$getAssetsMFEStorybook("Assets Dynamic Media Micro Frontends storybook", "CQ-assets-dm");
module.exports.assetsDynamicMediaMicroFrontendsStorybook = $c375febaade4eb45$var$assetsDynamicMediaMicroFrontendsStorybook;

});

parcelRegister("Yx8hT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.marketoMeasureInternal = module.exports.bizible = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /* eslint-disable sort-keys */ // This file was generated automatically from ../solutions/bizible.ts
const $638673971e7071fc$var$marketoMeasureUi = {
    appId: "marketoMeasure",
    path: "/marketo-measure",
    spaAppId: "bizible-marketo-measure-ui",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "http://localhost:3000",
            prod: "" // Remove this line before the production release
        }
    },
    sideNav: {},
    access: {
        code: [
            "dma_bizible"
        ],
        flag: "bizible-enabled"
    },
    isAlternate: true
};
const $638673971e7071fc$var$bizible = {
    appId: "bizible",
    path: "/marketo-measure",
    redirectFrom: [
        {
            path: "/bizible"
        }
    ],
    serviceCode: "dma_bizible",
    analytics: {
        code: "biz"
    },
    gainsight: {
        productKey: "AP-VHKUZCDZTYNN-2"
    },
    permissionsPolicy: [
        "clipboard-write"
    ],
    refreshOnImsChange: true,
    sandbox: {
        hideInitialSpinner: false,
        history: {
            type: $ctGaZ.HISTORY.SERVER,
            config: {
                absolutePaths: true,
                spinnerOnChange: false
            }
        },
        sources: {
            dev: {
                discovery: "https://localhost:44301/api/UnifiedShell/ImsLogin",
                withCredentials: true,
                payload: [
                    "imsOrg",
                    "imsProfile",
                    "locale",
                    "path"
                ],
                reduceProfile: true
            },
            qa: {
                discovery: "https://bizible-int.adobe.com/api/UnifiedShell/ImsLogin",
                withCredentials: true,
                payload: [
                    "imsOrg",
                    "imsProfile",
                    "locale",
                    "path"
                ],
                reduceProfile: true
            },
            stage: {
                discovery: "https://bizible-stage.adobe.com/api/UnifiedShell/ImsLogin",
                withCredentials: true,
                payload: [
                    "imsOrg",
                    "imsProfile",
                    "locale",
                    "path"
                ],
                reduceProfile: true
            },
            prod: {
                discovery: "https://bizible.adobe.com/api/UnifiedShell/ImsLogin",
                withCredentials: true,
                payload: [
                    "imsOrg",
                    "imsProfile",
                    "locale",
                    "path"
                ],
                reduceProfile: true
            }
        }
    },
    access: {
        code: [
            "dma_bizible"
        ],
        flag: "bizible-enabled"
    },
    alternateRoute: [
        {
            config: $638673971e7071fc$var$marketoMeasureUi,
            flag: "marketo-measure-v2-enabled",
            path: /^\/marketo-measure\/discover\/(.*)$/i
        }
    ]
};
module.exports.bizible = $638673971e7071fc$var$bizible;
const $638673971e7071fc$var$marketoMeasureInternal = {
    appId: "marketoMeasureInternal",
    path: "/marketo-measure-internal",
    spaAppId: "bizible-marketo-measure-internal-ui",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "http://localhost:3000"
        }
    },
    access: {
        code: [
            "dma_bizible"
        ],
        flag: "bizible-internal-enabled",
        logicOp: "AND"
    }
};
module.exports.marketoMeasureInternal = $638673971e7071fc$var$marketoMeasureInternal;

});

parcelRegister("9L7xH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.campaignTrainingSub = module.exports.campaignPartnerSub = module.exports.campaignDemoSub = module.exports.campaignSub = module.exports.campaign = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/campaign.ts
const $268d31069a3ddcb3$var$common = {
    access: {
        code: [
            "dma_campaign"
        ]
    },
    autoInstantiateRuntime: true,
    analytics: {
        code: "ac"
    },
    appId: "acs",
    experienceLeague: {
        communities: "adobe-campaign-standard",
        filter: "Campaign Standard"
    },
    serviceCode: "dma_campaign"
}; // Campaign Launch Page Next
const $268d31069a3ddcb3$var$campaign = {
    ...$268d31069a3ddcb3$var$common,
    appId: "campaignLaunch",
    access: {
        code: [
            "dma_campaign",
            "dma_campaign_classic"
        ]
    },
    path: "/campaign",
    spaAppId: "Campaign-unified-campaign-launch-page",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:12399"
        }
    }
};
module.exports.campaign = $268d31069a3ddcb3$var$campaign;
const $268d31069a3ddcb3$var$getSources = (domain = "campaign.adobe.com")=>({
        dev: {
            discovery: "https://localhost.corp.adobe.com/rest/head/imsSession/",
            payload: [
                "imsOrg"
            ],
            withCredentials: true,
            url: "https://localhost.corp.adobe.com/{1}",
            defaults: {
                1: "view/home"
            }
        },
        qa: {
            discovery: `https://{mySubOrg}.qa.${domain}/rest/head/imsSession/`,
            payload: [
                "imsOrg"
            ],
            withCredentials: true,
            url: `https://{mySubOrg}.qa.${domain}/{1}`,
            defaults: {
                1: "view/home"
            }
        },
        stage: {
            discovery: `https://{mySubOrg}.qa.${domain}/rest/head/imsSession/`,
            payload: [
                "imsOrg"
            ],
            withCredentials: true,
            url: `https://{mySubOrg}.qa.${domain}/{1}`,
            defaults: {
                1: "view/home"
            }
        },
        // All production IMS environment
        prod: {
            discovery: `https://{mySubOrg}.${domain}/rest/head/imsSession/`,
            payload: [
                "imsOrg"
            ],
            withCredentials: true,
            url: `https://{mySubOrg}.${domain}/{1}`,
            defaults: {
                1: "view/home"
            }
        },
        qe: "",
        // TO FILL when production (apparently AZURE URLs)
        rd: {
            discovery: `https://{mySubOrg}.rd.${domain}/rest/head/imsSession/`,
            payload: [
                "imsOrg"
            ],
            withCredentials: true,
            url: `https://{mySubOrg}.rd.${domain}/{1}`,
            defaults: {
                1: "view/home"
            }
        }
    });
const $268d31069a3ddcb3$var$commonSandbox = {
    history: {
        type: $ctGaZ.HISTORY.SERVER,
        config: {
            spinnerOnChange: true,
            absolutePaths: true
        }
    },
    pageTimeout: 90000
}; // Campaign Instances
const $268d31069a3ddcb3$var$campaignSub = {
    ...$268d31069a3ddcb3$var$common,
    path: "/campaign/:mySubOrg",
    sandbox: {
        ...$268d31069a3ddcb3$var$commonSandbox,
        sources: $268d31069a3ddcb3$var$getSources()
    }
}; // Campaign Demo Instances
module.exports.campaignSub = $268d31069a3ddcb3$var$campaignSub;
const $268d31069a3ddcb3$var$campaignDemoSub = {
    ...$268d31069a3ddcb3$var$common,
    path: "/campaign/demo/:mySubOrg",
    sandbox: {
        ...$268d31069a3ddcb3$var$commonSandbox,
        sources: $268d31069a3ddcb3$var$getSources("campaign-demo.adobe.com")
    }
}; // Campaign Partner Instances
module.exports.campaignDemoSub = $268d31069a3ddcb3$var$campaignDemoSub;
const $268d31069a3ddcb3$var$campaignPartnerSub = {
    ...$268d31069a3ddcb3$var$common,
    path: "/campaign/partner/:mySubOrg",
    sandbox: {
        ...$268d31069a3ddcb3$var$commonSandbox,
        sources: $268d31069a3ddcb3$var$getSources("campaign-sandbox.adobe.com")
    }
}; // Campaign Training Instances
module.exports.campaignPartnerSub = $268d31069a3ddcb3$var$campaignPartnerSub;
const $268d31069a3ddcb3$var$campaignTrainingSub = {
    ...$268d31069a3ddcb3$var$common,
    path: "/campaign/training/:mySubOrg",
    sandbox: {
        ...$268d31069a3ddcb3$var$commonSandbox,
        sources: $268d31069a3ddcb3$var$getSources("adobevlab.com")
    }
};
module.exports.campaignTrainingSub = $268d31069a3ddcb3$var$campaignTrainingSub;

});

parcelRegister("be9hY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cjmBrandJourneyUi = module.exports.ajoOrion = module.exports.ajoloyaltychallengesui = module.exports.cjmMexp = module.exports.cjmPreviewsUI = module.exports.cjmFragmentsUI = module.exports.cjmTemplateFragmentUI = module.exports.cjmAdminReporting = module.exports.cjmTranslations = module.exports.cjmUseCases = module.exports.audienceOrchestrationUi = module.exports.ajoCampaignsCJA = module.exports.ajoCampaigns = module.exports.cjmChannelHandlerUI = module.exports.ajobusinessrulesui = module.exports.ajofrequencyrulesui = module.exports.unifiedTags = module.exports.ajoPermissionsUI = module.exports.cjmConfigUi = module.exports.cjmEmailDesigner = module.exports.cjmJourneysNextAuthoring = module.exports.cjmJourneysNextAdmin = module.exports.ajoJourneysCJA = module.exports.ajoReportsCJA = module.exports.cjmLiveReport = module.exports.UnifiedDecisioning = module.exports.ajoSubscriptionsCJA = module.exports.cjmSubscriptionsUi = module.exports.ajoLandingPagesCJA = module.exports.cjmLandingPagesUi = module.exports.cjmPlatformUIOffers = module.exports.cjmPlatformUIComponents = module.exports.cjmPlatform = module.exports.cjmAdminNext = module.exports.cjmAssets = module.exports.cjmHome = void 0;

var $e8f753a06dc081d6$var$_ajoContentEditor = $e8f753a06dc081d6$var$_interopRequireDefault((parcelRequire("3V3fc")));

var $jqwuU = parcelRequire("jqwuU");

var $ewVCA = parcelRequire("ewVCA");

var $lBBEP = parcelRequire("lBBEP");

var $ctGaZ = parcelRequire("ctGaZ");

var $e8f753a06dc081d6$var$_inappEditor = $e8f753a06dc081d6$var$_interopRequireDefault((parcelRequire("8GiLQ")));

var $e8f753a06dc081d6$var$_journeysNextAdmin = $e8f753a06dc081d6$var$_interopRequireDefault((parcelRequire("bISJe")));

var $e8f753a06dc081d6$var$_journeysNextAuthoring = $e8f753a06dc081d6$var$_interopRequireDefault((parcelRequire("lMagz")));

var $e8f753a06dc081d6$var$_permissionsUI = $e8f753a06dc081d6$var$_interopRequireDefault((parcelRequire("6AMM5")));

var $e8f753a06dc081d6$var$_personalizationEditor = $e8f753a06dc081d6$var$_interopRequireDefault((parcelRequire("5haes")));

var $gyj38 = parcelRequire("gyj38");

var $kXzzK = parcelRequire("kXzzK");

var $JdG5O = parcelRequire("JdG5O");

var $6iVyY = parcelRequire("6iVyY");
function $e8f753a06dc081d6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /*
 * While onboarding another app in cjm.js, please identify
 * if there are sharable configs among apps and if yes, then
 * create a baseConfig object and move common configs there
 */ // This file was generated automatically from ../solutions/cjm.ts
const $e8f753a06dc081d6$var$access = {
    code: [
        "acp"
    ],
    fi: [
        "acp:cjm_foundation"
    ],
    logicOp: "AND"
};
const $e8f753a06dc081d6$var$sideNav = {
    id: "cjm",
    workHubId: "CJM"
};
const $e8f753a06dc081d6$var$personalizationEditorAjo = {
    ...$e8f753a06dc081d6$var$_personalizationEditor.default,
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "cjm"
};
const $e8f753a06dc081d6$var$ansibleAjo = {
    ...$jqwuU.ansible,
    omegaSuiteId: "cjm"
};
const $e8f753a06dc081d6$var$baseConfig = {
    appContainer: "#dp-ui",
    appRoot: "cjm-home",
    access: $e8f753a06dc081d6$var$access,
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    experienceLeague: {
        communities: "adobe-journey-optimizer",
        filter: "Journey Optimizer"
    },
    fiServiceCode: "acp",
    gainsight: {
        productKey: "AP-GLVNMB5BLV8T-2"
    },
    omegaSuiteId: "cjm",
    parent: "CJM",
    sideNav: $e8f753a06dc081d6$var$sideNav,
    unifiedSearch: {
        enabled: true
    },
    urlContext: {
        key: "sandbox"
    },
    betaFeedbackConfigId: "cjm",
    nestedApps: [
        $e8f753a06dc081d6$var$ansibleAjo,
        $e8f753a06dc081d6$var$personalizationEditorAjo
    ]
};
const $e8f753a06dc081d6$var$cjmHome = {
    ...$e8f753a06dc081d6$var$baseConfig,
    ...$kXzzK.puebloBaseConfig,
    appContainer: "#container",
    appId: "cjm-home",
    dataPrefetchContracts: [
        "recents-sandbox",
        "dashboard-sandbox"
    ],
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "cjm",
    path: "/journey-optimizer/home",
    redirectFrom: [
        {
            path: "/journey-optimizer",
            options: {
                end: true
            }
        },
        {
            path: "/cjm/home"
        },
        {
            path: "/cjm",
            options: {
                end: true
            }
        }
    ]
};
module.exports.cjmHome = $e8f753a06dc081d6$var$cjmHome;
const $e8f753a06dc081d6$var$cjmAssets = {
    ...$e8f753a06dc081d6$var$baseConfig,
    ...$ewVCA.assetsBase,
    appContainer: undefined,
    appId: "cjm-assets",
    metricsAppId: "cjm-assets",
    path: "/journey-optimizer/assets",
    redirectFrom: [
        {
            path: "/cjm/assets"
        }
    ],
    unifiedSearch: {
        ...$e8f753a06dc081d6$var$baseConfig.unifiedSearch,
        compact: true
    }
};
module.exports.cjmAssets = $e8f753a06dc081d6$var$cjmAssets;
const $e8f753a06dc081d6$var$cjmAdminNext = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appContainer: "#root",
    appId: "cjm-next-admin",
    path: "/journey-optimizer/admin",
    spaAppId: "Voyager-voyager-authoring-ui-react",
    redirectFrom: [
        {
            path: "/cjm/admin"
        },
        {
            path: "/journey-optimizer/v2/admin"
        }
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        pathPrefix: {
            default: "/admin-app",
            preHash: true
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8098"
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
module.exports.cjmAdminNext = $e8f753a06dc081d6$var$cjmAdminNext;
const $e8f753a06dc081d6$var$cjmPlatform = {
    ...$e8f753a06dc081d6$var$baseConfig,
    ...$lBBEP.experiencePlatformSpa,
    appContainer: undefined,
    appId: "cjm-platform",
    appRoot: "cjm-home",
    omegaSuiteId: "cjm",
    parent: "CJM",
    path: "/journey-optimizer/platform",
    alternateRoute: [
        {
            flag: "aep-offers-v-2-enabled",
            param: "cjm-ajo-ui-decisioning-management_version",
            path: /\/journey-optimizer\/platform\/offers(\/.*)/,
            redirect: "/journey-optimizer/platform/v2/offers$1"
        },
        {
            flag: "aep-offers-components-v-2-enabled",
            param: "cjm-ajo-ui-decisioning-management_version",
            path: /\/journey-optimizer\/platform\/components(\/.*)/,
            redirect: "/journey-optimizer/platform/v2/components$1"
        }
    ],
    redirectFrom: [
        {
            path: "/cjm/platform"
        }
    ],
    sideNav: $e8f753a06dc081d6$var$sideNav // This is necessary because the experiencePlatformSpa will override the setting in baseConfig. This will be a problem when AEP has a sideNav.
};
module.exports.cjmPlatform = $e8f753a06dc081d6$var$cjmPlatform;
const $e8f753a06dc081d6$var$cjmPlatformUIComponents = {
    ...$e8f753a06dc081d6$var$baseConfig,
    ...$lBBEP.platformUIComponents,
    alternateRoute: [
        {
            flag: "aep-offers-components-v-2-enabled",
            param: "cjm-ajo-ui-decisioning-management_version",
            signalsInactive: true,
            path: /\/journey-optimizer\/platform\/components(\/.*)/,
            redirect: "/journey-optimizer/platform/v2/components$1"
        }
    ],
    appContainer: undefined,
    appId: "cjm-platformUIDecisioningManagementComponents",
    appRoot: "cjm-home",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "cjm",
    parent: "CJM",
    path: "/journey-optimizer/platform/v2/components",
    sideNav: $e8f753a06dc081d6$var$sideNav
};
module.exports.cjmPlatformUIComponents = $e8f753a06dc081d6$var$cjmPlatformUIComponents;
const $e8f753a06dc081d6$var$cjmPlatformUIOffers = {
    ...$e8f753a06dc081d6$var$baseConfig,
    ...$lBBEP.platformUIOffers,
    alternateRoute: [
        {
            flag: "aep-offers-v-2-enabled",
            param: "cjm-ajo-ui-decisioning-management_version",
            signalsInactive: true,
            path: /\/journey-optimizer\/platform\/offers(\/.*)/,
            redirect: "/journey-optimizer/platform/v2/offers$1"
        }
    ],
    appContainer: undefined,
    appId: "cjm-platformUIDecisioningManagementOffers",
    appRoot: "cjm-home",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "cjm",
    parent: "CJM",
    path: "/journey-optimizer/platform/v2/offers",
    sideNav: $e8f753a06dc081d6$var$sideNav
};
module.exports.cjmPlatformUIOffers = $e8f753a06dc081d6$var$cjmPlatformUIOffers;
const $e8f753a06dc081d6$var$cjmLandingPagesUi = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appId: "cjmLandingPagesUi",
    settingsAppId: "analytics",
    path: "/journey-optimizer/landing-pages",
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "cjm-landing-pages-ui",
    sandbox: {
        pathPrefix: {
            default: "/landing-pages"
        },
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8449"
        }
    }
};
module.exports.cjmLandingPagesUi = $e8f753a06dc081d6$var$cjmLandingPagesUi;
const $e8f753a06dc081d6$var$ajoLandingPagesCJA = {
    ...$e8f753a06dc081d6$var$baseConfig,
    ...$gyj38.platformAnalytics,
    access: $e8f753a06dc081d6$var$cjmLandingPagesUi.access,
    appId: "platformAnalytics-ajoLandingPagesApp",
    // This must start with platformAnalytics for CJA to load correctly. We could fix this later.
    omegaSuiteId: "cjm",
    parent: "CJM",
    path: "/journey-optimizer/landing-page/report",
    sideNav: $e8f753a06dc081d6$var$sideNav // This is necessary to override the sideNav in platformAnalytics if it ever has one.
};
module.exports.ajoLandingPagesCJA = $e8f753a06dc081d6$var$ajoLandingPagesCJA;
const $e8f753a06dc081d6$var$cjmSubscriptionsUi = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appId: "cjmSubscriptionsUi",
    settingsAppId: "analytics",
    path: "/journey-optimizer/subscriptions",
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "cjm-landing-pages-ui",
    sandbox: {
        pathPrefix: {
            default: "/subscriptions"
        },
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8449"
        }
    }
};
module.exports.cjmSubscriptionsUi = $e8f753a06dc081d6$var$cjmSubscriptionsUi;
const $e8f753a06dc081d6$var$ajoSubscriptionsCJA = {
    ...$e8f753a06dc081d6$var$baseConfig,
    ...$gyj38.platformAnalytics,
    access: $e8f753a06dc081d6$var$cjmSubscriptionsUi.access,
    appId: "platformAnalytics-ajoSubscriptionsApp",
    // This must start with platformAnalytics for CJA to load correctly. We could fix this later.
    omegaSuiteId: "cjm",
    parent: "CJM",
    path: "/journey-optimizer/subscription/report",
    sideNav: $e8f753a06dc081d6$var$sideNav // This is necessary to override the sideNav in platformAnalytics if it ever has one.
};
module.exports.ajoSubscriptionsCJA = $e8f753a06dc081d6$var$ajoSubscriptionsCJA;
const $e8f753a06dc081d6$var$UnifiedDecisioning = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appId: "UnifiedDecisioning",
    path: "/journey-optimizer/unified-decisioning",
    spaAppId: "cjm-unified-decisioning-ui",
    releaseType: $ctGaZ.RELEASE_TYPE.GA,
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        pathPrefix: {
            default: "/unified-decisioning"
        },
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
module.exports.UnifiedDecisioning = $e8f753a06dc081d6$var$UnifiedDecisioning;
const $e8f753a06dc081d6$var$cjmLiveReport = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appContainer: "#cjm-live-reporting-app",
    appId: "cjm-live-report",
    settingsAppId: "analytics",
    path: "/journey-optimizer/reports",
    redirectFrom: [
        {
            path: "/cjm/livereports"
        },
        {
            path: "/journey-optimizer/livereports"
        }
    ],
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "cjm",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:3000"
        },
        ims: {
            client_id: "cjm-live-report",
            scopes: "AdobeID, openid, read_organizations, ab.manage, additional_info, additional_info.projectedProductContext, additional_info.roles, read_pc.acp, read_pc, read_pc.dma_tartan"
        }
    },
    spaAppId: "cjm-live-reporting-ui"
};
module.exports.cjmLiveReport = $e8f753a06dc081d6$var$cjmLiveReport;
const $e8f753a06dc081d6$var$ajoReportsCJA = {
    ...$e8f753a06dc081d6$var$baseConfig,
    ...$gyj38.platformAnalytics,
    access: $e8f753a06dc081d6$var$cjmLiveReport.access,
    appId: "platformAnalytics-ajoReportsApp",
    // This must start with platformAnalytics for CJA to load correctly. We could fix this later.
    omegaSuiteId: "cjm",
    parent: "CJM",
    path: "/journey-optimizer/channel/report",
    sideNav: $e8f753a06dc081d6$var$sideNav // This is necessary to override the sideNav in platformAnalytics if it ever has one.
};
module.exports.ajoReportsCJA = $e8f753a06dc081d6$var$ajoReportsCJA;
const $e8f753a06dc081d6$var$ajoJourneysCJA = {
    ...$e8f753a06dc081d6$var$baseConfig,
    ...$gyj38.platformAnalytics,
    appId: "platformAnalytics-ajoJourneysApp",
    // This must start with platformAnalytics for CJA to load correctly. We could fix this later.
    omegaSuiteId: "cjm",
    parent: "CJM",
    path: "/journey-optimizer/journey/report",
    access: {
        ...$e8f753a06dc081d6$var$access,
        fi: [
            "acp:cjm_orch",
            "acp:cjm_foundation"
        ]
    },
    sideNav: $e8f753a06dc081d6$var$sideNav // This is necessary to override the sideNav in platformAnalytics if it ever has one.
};
module.exports.ajoJourneysCJA = $e8f753a06dc081d6$var$ajoJourneysCJA;
const $e8f753a06dc081d6$var$cjmJourneysNextAdmin = {
    ...$e8f753a06dc081d6$var$_journeysNextAdmin.default,
    ...$e8f753a06dc081d6$var$baseConfig,
    redirectFrom: [
        {
            path: "/cjm/journeys"
        },
        {
            path: "/journey-optimizer/v2/journeys"
        }
    ],
    appId: "cjm-journeys-next-admin",
    settingsAppId: "analytics",
    path: "/journey-optimizer/journeys",
    access: $e8f753a06dc081d6$var$access
};
module.exports.cjmJourneysNextAdmin = $e8f753a06dc081d6$var$cjmJourneysNextAdmin;
const $e8f753a06dc081d6$var$cjmJourneysNextAuthoring = {
    ...$e8f753a06dc081d6$var$_journeysNextAuthoring.default,
    ...$e8f753a06dc081d6$var$baseConfig,
    redirectFrom: [
        {
            path: "/journey-optimizer/v2/journeys/journey"
        }
    ],
    appId: "cjm-journeys-next-authoring",
    settingsAppId: "analytics",
    path: "/journey-optimizer/journeys/journey",
    access: $e8f753a06dc081d6$var$access
};
module.exports.cjmJourneysNextAuthoring = $e8f753a06dc081d6$var$cjmJourneysNextAuthoring;
const $e8f753a06dc081d6$var$cjmEmailDesigner = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appContainer: "main",
    appId: "cjm-email-designer",
    path: "/journey-optimizer/content/email-designer",
    redirectFrom: [
        {
            path: "/cjm/email-designer"
        },
        {
            path: "/cjm/content/email-designer"
        }
    ],
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    spaAppId: "pixel-acrites-ui",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        hideInitialSpinner: true,
        history: $ctGaZ.HISTORY.HASH,
        sources: {
            dev: "https://localhost.rd.campaign.adobe.com:9000/"
        }
    },
    sideNav: {
        ...$e8f753a06dc081d6$var$baseConfig.sideNav,
        closeOnLoad: true
    }
};
module.exports.cjmEmailDesigner = $e8f753a06dc081d6$var$cjmEmailDesigner;
const $e8f753a06dc081d6$var$cjmConfigUi = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appContainer: "#root",
    appId: "cjm-configui",
    path: "/journey-optimizer/configui",
    redirectFrom: [
        {
            path: "/cjm/configui"
        }
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "exc-cjm-config-ui",
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
module.exports.cjmConfigUi = $e8f753a06dc081d6$var$cjmConfigUi;
const $e8f753a06dc081d6$var$ajoPermissionsUI = {
    ...$e8f753a06dc081d6$var$baseConfig,
    ...$e8f753a06dc081d6$var$_permissionsUI.default,
    appContainer: "#root",
    appId: "ajo-permissionsUI",
    path: "/journey-optimizer/admin/permissions"
};
module.exports.ajoPermissionsUI = $e8f753a06dc081d6$var$ajoPermissionsUI;
const $e8f753a06dc081d6$var$unifiedTags = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appContainer: "#root",
    appId: "unifiedTags",
    path: "/journey-optimizer/tags",
    spaAppId: "exc-unified-tags-ui",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    access: {
        flag: "tags-enabled"
    },
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    }
};
module.exports.unifiedTags = $e8f753a06dc081d6$var$unifiedTags;
const $e8f753a06dc081d6$var$ajofrequencyrulesui = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appContainer: "#root",
    appId: "ajofrequencyrulesui",
    path: "/journey-optimizer/rules/frequency",
    spaAppId: "cjm-frequency-rules-ui",
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
module.exports.ajofrequencyrulesui = $e8f753a06dc081d6$var$ajofrequencyrulesui;
const $e8f753a06dc081d6$var$ajobusinessrulesui = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appContainer: "#root",
    appId: "ajobusinessrulesui",
    path: "/journey-optimizer/rules/frequency/rules",
    spaAppId: "cjm-business-rules-ui",
    releaseType: $ctGaZ.RELEASE_TYPE.BETA,
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
module.exports.ajobusinessrulesui = $e8f753a06dc081d6$var$ajobusinessrulesui;
const $e8f753a06dc081d6$var$cjmChannelHandlerUI = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appId: "cjmChannelHandlerUI",
    path: "/journey-optimizer/channel-handler",
    spaAppId: "cjm-channel-handler-ui",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "cjm",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    }
};
module.exports.cjmChannelHandlerUI = $e8f753a06dc081d6$var$cjmChannelHandlerUI;
const $e8f753a06dc081d6$var$ajoCampaigns = {
    ...$e8f753a06dc081d6$var$baseConfig,
    nestedApps: [
        ...$e8f753a06dc081d6$var$baseConfig.nestedApps,
        $e8f753a06dc081d6$var$_ajoContentEditor.default,
        $e8f753a06dc081d6$var$cjmChannelHandlerUI,
        $e8f753a06dc081d6$var$_inappEditor.default
    ],
    appContainer: "#root",
    autoInstantiateRuntime: true,
    appId: "ajoCampaignsApp",
    settingsAppId: "analytics",
    path: "/journey-optimizer/campaigns",
    redirectFrom: [
        {
            path: "/ajo-campaigns"
        }
    ],
    spaAppId: "ajo-mobile-ajo-campaigns-ui",
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER,
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "cjm",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    access: {
        ...$e8f753a06dc081d6$var$access,
        fi: [
            "acp:cjm_msg",
            "acp:cjm_foundation"
        ]
    }
};
module.exports.ajoCampaigns = $e8f753a06dc081d6$var$ajoCampaigns;
const $e8f753a06dc081d6$var$ajoCampaignsCJA = {
    ...$e8f753a06dc081d6$var$baseConfig,
    ...$gyj38.platformAnalytics,
    appId: "platformAnalytics-ajoCampaignsApp",
    // This must start with platformAnalytics for CJA to load correctly. We could fix this later.
    omegaSuiteId: "cjm",
    parent: "CJM",
    path: "/journey-optimizer/campaign/report",
    access: $e8f753a06dc081d6$var$ajoCampaigns.access,
    sideNav: $e8f753a06dc081d6$var$sideNav // This is necessary to override the sideNav in platformAnalytics if it ever has one.
};
module.exports.ajoCampaignsCJA = $e8f753a06dc081d6$var$ajoCampaignsCJA;
const $e8f753a06dc081d6$var$audienceOrchestrationUi = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appId: "audienceOrchestrationUi",
    path: "/journey-optimizer/audience/compose",
    redirectFrom: [
        {
            path: "/journey-optimizer/audience/orchestration"
        }
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "cjm-audience-orchestration-ui",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "cjm",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
module.exports.audienceOrchestrationUi = $e8f753a06dc081d6$var$audienceOrchestrationUi;
const $e8f753a06dc081d6$var$cjmUseCases = {
    ...$e8f753a06dc081d6$var$baseConfig,
    ...$6iVyY.useCasesConfig,
    appContainer: "#root",
    appId: "cjm-use-cases",
    appRoot: "cjm-home",
    parent: "CJM",
    path: "/journey-optimizer/use-cases"
};
module.exports.cjmUseCases = $e8f753a06dc081d6$var$cjmUseCases;
const $e8f753a06dc081d6$var$cjmTranslations = {
    ...$e8f753a06dc081d6$var$baseConfig,
    ...$JdG5O.translationConfig,
    appId: "cjm-translationService",
    path: "/journey-optimizer/translations",
    metadata: {
        productId: "AJO",
        productName: "Adobe Journey Optimizer"
    }
};
module.exports.cjmTranslations = $e8f753a06dc081d6$var$cjmTranslations;
const $e8f753a06dc081d6$var$cjmAdminReporting = {
    ...$e8f753a06dc081d6$var$cjmConfigUi,
    appId: "cjm-admin-reporting",
    path: "/journey-optimizer/admin/reporting",
    redirectFrom: undefined,
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013/userDataset/list",
            qa: "https://experience-qa.adobe.com/solutions/exc-cjm-config-ui/userDataset/list",
            stage: "https://experience-stage.adobe.com/solutions/exc-cjm-config-ui/userDataset/list",
            prod: "https://experience.adobe.com/solutions/exc-cjm-config-ui/userDataset/list"
        }
    },
    spaAppId: undefined // Need to do this to pass and to override the sources effectively
};
module.exports.cjmAdminReporting = $e8f753a06dc081d6$var$cjmAdminReporting;
const $e8f753a06dc081d6$var$cjmTemplateFragmentUI = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appId: "cjmTemplateFragmentUI",
    path: "/journey-optimizer/content-templates",
    spaAppId: "cjm-template-fragment-ui",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
module.exports.cjmTemplateFragmentUI = $e8f753a06dc081d6$var$cjmTemplateFragmentUI;
const $e8f753a06dc081d6$var$cjmFragmentsUI = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appId: "cjmFragmentsUI",
    path: "/journey-optimizer/fragments",
    spaAppId: "cjm-fragments-ui",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
module.exports.cjmFragmentsUI = $e8f753a06dc081d6$var$cjmFragmentsUI;
const $e8f753a06dc081d6$var$cjmPreviewsUI = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appId: "cjmPreviewUI",
    path: "/journey-optimizer/preview-ui",
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER,
    runtime: $ctGaZ.RUNTIME.CDN,
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    spaAppId: "cjm-preview-ui",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    }
};
module.exports.cjmPreviewsUI = $e8f753a06dc081d6$var$cjmPreviewsUI;
const $e8f753a06dc081d6$var$cjmMexp = {
    ...$e8f753a06dc081d6$var$baseConfig,
    ...$lBBEP.mexpBaseConfig,
    appId: "ajo-mexp",
    path: "/journey-optimizer/mexp",
    access: {
        ...$lBBEP.mexpAccess,
        fi: [
            "acp:cjm_foundation"
        ]
    }
};
module.exports.cjmMexp = $e8f753a06dc081d6$var$cjmMexp;
const $e8f753a06dc081d6$var$ajoloyaltychallengesui = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appId: "ajoloyaltychallengesui",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/journey-optimizer/loyalty/challenges",
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "cjm-challenges-ui",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER,
    access: {
        ...$e8f753a06dc081d6$var$access,
        flag: "loyalty-challenge-enabled"
    }
};
module.exports.ajoloyaltychallengesui = $e8f753a06dc081d6$var$ajoloyaltychallengesui;
const $e8f753a06dc081d6$var$ajoOrion = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appId: "ajoFirstmile",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/journey-optimizer/firstmile",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "dms-mobile-phoenix",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            proxy: "https://local.orion.adobe.com",
            dev: "https://local.orion.adobe.com:8888",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
module.exports.ajoOrion = $e8f753a06dc081d6$var$ajoOrion;
const $e8f753a06dc081d6$var$cjmBrandJourneyUi = {
    ...$e8f753a06dc081d6$var$baseConfig,
    appId: "cjm-brand-journey-ui",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/journey-optimizer/journeys/batch-journey",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "cjm-brand-journey-ui",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
module.exports.cjmBrandJourneyUi = $e8f753a06dc081d6$var$cjmBrandJourneyUi;

});
parcelRegister("3V3fc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/ajoContentEditor.ts
const $f0a12eeaa80861df$var$ajoContentEditor = {
    appId: "ajoContentEditor",
    parent: "CJM",
    path: "/ajo-content-editor",
    spaAppId: "cjm-ajo-content-editor",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    urlContext: {
        key: "sandbox"
    }
};
var $f0a12eeaa80861df$var$_default = $f0a12eeaa80861df$var$ajoContentEditor;
module.exports.default = $f0a12eeaa80861df$var$_default;

});

parcelRegister("ewVCA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.assetsBase = void 0;

var $ctGaZ = parcelRequire("ctGaZ");

var $5jesu = parcelRequire("5jesu");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/ddam.ts
const $b9cfbc2fcd6cfd25$var$assetsBase = {
    metadata: {
        idAttribute: "data-instance-id"
    },
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    gainsight: {
        productKey: "AP-GGNFMVCRYIQI-2"
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        hideInitialSpinner: true,
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        ims: {
            client_id: "aem-assets-frontend-1",
            scopes: "AdobeID,openid,read_organizations,ab.manage,additional_info.projectedProductContext,firefly_api"
        },
        sources: {
            // TODO: leave for now but this should be removed after people have time to switch to dev443
            devcjm: "https://localhost.corp.adobe.com:443/",
            dev443: "https://localhost.corp.adobe.com:443/",
            dev: "https://localhost.corp.adobe.com:8443/"
        }
    },
    spaAppId: "CQ-assets-app",
    thunderbird: $5jesu.THUNDERBIRD.SERVICE_WORKER
};
module.exports.assetsBase = $b9cfbc2fcd6cfd25$var$assetsBase;
const $b9cfbc2fcd6cfd25$var$assetSelectors = {
    ...$b9cfbc2fcd6cfd25$var$assetsBase,
    appId: "assets-selectors",
    gainsight: {
        productKey: "AP-GI70AEBJW3LJ-2"
    },
    spaAppId: "CQ-assets-selectors"
};
const $b9cfbc2fcd6cfd25$var$ddam = {
    ...$b9cfbc2fcd6cfd25$var$assetsBase,
    appId: "ddam",
    experienceLeague: {
        communities: "adobe-experience-manager",
        filter: "Experience Manager"
    },
    metricsAppId: "assets",
    nestedApps: [
        $b9cfbc2fcd6cfd25$var$assetSelectors
    ],
    path: "/assets",
    permissionsPolicy: [
        "clipboard-write"
    ],
    access: {
        code: [
            "dma_media_library",
            "dma_ddam"
        ],
        fd: [
            {
                code: "dma_aem_cloud",
                property: "aemSolutions",
                propertyDefault: [],
                value: "contenthub",
                exists: false
            }
        ],
        flag: "assets-essentials-enabled",
        visibleName: [
            {
                code: "dma_aem_contenthub",
                name: /^Default Adobe GenStudio administrators$/
            }
        ]
    }
};
var $b9cfbc2fcd6cfd25$var$_default = $b9cfbc2fcd6cfd25$var$ddam;
module.exports.default = $b9cfbc2fcd6cfd25$var$_default;

});

parcelRegister("lBBEP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.platformAmplify = module.exports.platformMexp = module.exports.mexpBaseConfig = module.exports.mexpAccess = module.exports.platformAudienceOrchestrationUi = module.exports.platformFederatedDataUI = module.exports.platformUnifiedTags = module.exports.platformUILicenseUsage = module.exports.platformUIDashboards = module.exports.platformUIMetricsCatalog = module.exports.platformUIExperiments = module.exports.platformUIDatasets = module.exports.platformUIComponents = module.exports.platformUIOffers = module.exports.platformUIQueries = module.exports.platformUIEncryption = module.exports.platformPermissionsUI = module.exports.experiencePlatformHomePueblo = module.exports.experiencePlatform = module.exports.experiencePlatformSpa = module.exports.platformBase = module.exports.ansiblePlatform = void 0;

var $9d8bde023f47c655$var$_amplify = $9d8bde023f47c655$var$_interopRequireDefault((parcelRequire("h8iFD")));

var $jqwuU = parcelRequire("jqwuU");

var $f0USY = parcelRequire("f0USY");

var $ctGaZ = parcelRequire("ctGaZ");

var $9d8bde023f47c655$var$_permissionsUI = $9d8bde023f47c655$var$_interopRequireDefault((parcelRequire("6AMM5")));

var $9d8bde023f47c655$var$_platformUIDashboards = $9d8bde023f47c655$var$_interopRequireDefault((parcelRequire("g0QiH")));

var $fi5OI = parcelRequire("fi5OI");

var $5WTWJ = parcelRequire("5WTWJ");

var $9d8bde023f47c655$var$_platformUIEncryption = $9d8bde023f47c655$var$_interopRequireDefault((parcelRequire("6bn9c")));

var $jylik = parcelRequire("jylik");

var $9d8bde023f47c655$var$_platformUILicenseUsage = $9d8bde023f47c655$var$_interopRequireDefault((parcelRequire("2icWJ")));

var $fAzMG = parcelRequire("fAzMG");

var $kXzzK = parcelRequire("kXzzK");
function $9d8bde023f47c655$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/experiencePlatform.ts
const $9d8bde023f47c655$var$aepGainsight = {
    productKey: "AP-GLVNMB5BLV8T-2",
    triggers: {
        fulfillableItems: [
            "acp_b2b_prof",
            "acp_b2b_ui"
        ],
        serviceCode: "acp"
    }
};
const $9d8bde023f47c655$var$ansiblePlatform = {
    ...$jqwuU.ansible,
    omegaSuiteId: "platform"
};
module.exports.ansiblePlatform = $9d8bde023f47c655$var$ansiblePlatform;
const $9d8bde023f47c655$var$platformBase = {
    appRoot: "experiencePlatformUI",
    sharedCaches: [
        "aep-cache"
    ],
    experienceLeague: {
        communities: "adobe-experience-platform",
        filter: "Experience Platform"
    },
    fiServiceCode: "acp",
    gainsight: $9d8bde023f47c655$var$aepGainsight,
    omegaSuiteId: "platform",
    parent: "AEP",
    permissionsPolicy: [
        "clipboard-write"
    ],
    runtime: $ctGaZ.RUNTIME.CDN_LEGACY,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        pageTimeout: 40000
    },
    serviceCode: "acp",
    sideNav: {
        id: "aep",
        workHubId: "AEP"
    },
    unifiedSearch: {
        enabled: true
    },
    urlContext: {
        key: "sandbox"
    }
};
module.exports.platformBase = $9d8bde023f47c655$var$platformBase;
const $9d8bde023f47c655$var$platformSpaCommon = {
    ...$9d8bde023f47c655$var$platformBase,
    nestedApps: [
        $9d8bde023f47c655$var$ansiblePlatform
    ],
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        ...$9d8bde023f47c655$var$platformBase.sandbox,
        sources: {
            dev: "https://localhost.dev.cloud.adobe.io:3000",
            dev2: "https://localhost.corp.adobe.com:3000",
            dev3: "https://localhost.dev.cloud.adobe.io",
            qa: "https://experience-qa.adobe.com/solutions/experience-platform-platform-ui-client",
            stage: "https://experience-stage.adobe.com/solutions/experience-platform-platform-ui-client",
            prod: "https://experience.adobe.com/solutions/experience-platform-platform-ui-client"
        }
    },
    spaAppId: "experience-platform-platform-ui-client"
}; // DO NOT REMOVE: This is used by AJO and Data Collection.
const $9d8bde023f47c655$var$experiencePlatformSpa = {
    ...$9d8bde023f47c655$var$platformSpaCommon,
    appId: "experiencePlatformUI",
    path: "/platform",
    dashboard: true,
    access: {
        code: [
            "acp"
        ]
    }
};
module.exports.experiencePlatformSpa = $9d8bde023f47c655$var$experiencePlatformSpa;
const $9d8bde023f47c655$var$experiencePlatform = {
    ...$9d8bde023f47c655$var$experiencePlatformSpa,
    alternateRoute: [
        {
            flag: "aep-queries-v-2-enabled",
            param: "experience-platform-aep-ui-queries_version",
            path: /\/platform\/query(\/.*|$)/,
            redirect: "/platform/v2/query$1"
        },
        {
            flag: "aep-offers-v-2-enabled",
            param: "cjm-ajo-ui-decisioning-management_version",
            path: /\/platform\/offers(\/.*|$)/,
            redirect: "/platform/v2/offers$1"
        },
        {
            flag: "aep-offers-components-v-2-enabled",
            param: "cjm-ajo-ui-decisioning-management_version",
            path: /\/platform\/components(\/.*|$)/,
            redirect: "/platform/v2/components$1"
        },
        {
            flag: "aep-datasets-v-2-enabled",
            param: "experience-platform-aep-ui-datasets_version",
            path: /\/platform\/dataset(\/.*|$)/,
            redirect: "/platform/v2/dataset$1"
        },
        {
            flag: "aep-dashboards-v-2-enabled",
            param: "experience-platform-aep-ui-dashboards_version",
            path: /\/platform\/dashboard(\/.*|$)/,
            redirect: "/platform/v2/dashboard$1"
        },
        {
            flag: "aep-license-usage-v-2-enabled",
            param: "experience-platform-aep-ui-license-usage_version",
            path: /\/platform\/licenseUsage(\/.*|$)/,
            redirect: "/platform/license-usage$1"
        }
    ]
};
module.exports.experiencePlatform = $9d8bde023f47c655$var$experiencePlatform;
const $9d8bde023f47c655$var$experiencePlatformHomePueblo = {
    ...$9d8bde023f47c655$var$platformBase,
    ...$kXzzK.puebloBaseConfig,
    gainsight: $9d8bde023f47c655$var$aepGainsight,
    omegaSuiteId: "platform",
    appId: "experiencePlatformUI-home",
    path: "/platform/home",
    redirectFrom: [
        {
            path: "/platform",
            options: {
                end: true
            }
        },
        {
            path: "/platform/v2/home"
        }
    ],
    access: {
        code: [
            "acp"
        ]
    },
    dataPrefetchContracts: [
        "dashboard-sandbox"
    ]
};
module.exports.experiencePlatformHomePueblo = $9d8bde023f47c655$var$experiencePlatformHomePueblo;
const $9d8bde023f47c655$var$platformPermissionsUI = {
    ...$9d8bde023f47c655$var$platformBase,
    ...$9d8bde023f47c655$var$_permissionsUI.default,
    appId: "aep-permissionsUI",
    path: "/platform/admin/permissions"
};
module.exports.platformPermissionsUI = $9d8bde023f47c655$var$platformPermissionsUI;
const $9d8bde023f47c655$var$platformUIEncryption = {
    ...$9d8bde023f47c655$var$platformBase,
    ...$9d8bde023f47c655$var$_platformUIEncryption.default
};
module.exports.platformUIEncryption = $9d8bde023f47c655$var$platformUIEncryption;
const $9d8bde023f47c655$var$queriesUI = {
    appId: "platformUIQueries",
    path: "/platform/v2/query",
    alternateRoute: [
        {
            flag: "aep-queries-v-2-enabled",
            param: "experience-platform-aep-ui-queries_version",
            signalsInactive: true,
            path: /\/platform\/query(\/.*|$)/,
            redirect: "/platform/v2/query$1"
        }
    ],
    spaAppId: "experience-platform-aep-ui-queries",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "platform",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8014"
        }
    },
    autoInstantiateRuntime: true,
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
const $9d8bde023f47c655$var$platformUIQueries = {
    ...$9d8bde023f47c655$var$platformBase,
    ...$9d8bde023f47c655$var$queriesUI
};
module.exports.platformUIQueries = $9d8bde023f47c655$var$platformUIQueries;
const $9d8bde023f47c655$var$platformUIOffers = {
    ...$9d8bde023f47c655$var$platformBase,
    ...$5WTWJ.platformUIDecisioningManagementOffers
};
module.exports.platformUIOffers = $9d8bde023f47c655$var$platformUIOffers;
const $9d8bde023f47c655$var$platformUIComponents = {
    ...$9d8bde023f47c655$var$platformBase,
    ...$5WTWJ.platformUIDecisioningManagementComponents
};
module.exports.platformUIComponents = $9d8bde023f47c655$var$platformUIComponents;
const $9d8bde023f47c655$var$platformUIDatasets = {
    ...$9d8bde023f47c655$var$platformBase,
    ...$fi5OI.platformUIDatasets
};
module.exports.platformUIDatasets = $9d8bde023f47c655$var$platformUIDatasets;
const $9d8bde023f47c655$var$platformUIExperiments = {
    ...$9d8bde023f47c655$var$platformBase,
    ...$jylik.platformUIExperiments
};
module.exports.platformUIExperiments = $9d8bde023f47c655$var$platformUIExperiments;
const $9d8bde023f47c655$var$platformUIMetricsCatalog = {
    ...$9d8bde023f47c655$var$platformBase,
    ...$fAzMG.platformUIMetricsCatalog
};
module.exports.platformUIMetricsCatalog = $9d8bde023f47c655$var$platformUIMetricsCatalog;
const $9d8bde023f47c655$var$platformUIDashboards = {
    ...$9d8bde023f47c655$var$platformBase,
    ...$9d8bde023f47c655$var$_platformUIDashboards.default
};
module.exports.platformUIDashboards = $9d8bde023f47c655$var$platformUIDashboards;
const $9d8bde023f47c655$var$platformUILicenseUsage = {
    ...$9d8bde023f47c655$var$platformBase,
    ...$9d8bde023f47c655$var$_platformUILicenseUsage.default
};
module.exports.platformUILicenseUsage = $9d8bde023f47c655$var$platformUILicenseUsage;
const $9d8bde023f47c655$var$platformUnifiedTags = {
    ...$9d8bde023f47c655$var$platformBase,
    appContainer: "#root",
    appId: "aep-unifiedTags",
    path: "/platform/tags",
    spaAppId: "exc-unified-tags-ui",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    access: {
        flag: "tags-enabled"
    },
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    }
};
module.exports.platformUnifiedTags = $9d8bde023f47c655$var$platformUnifiedTags;
const $9d8bde023f47c655$var$platformFederatedDataUI = {
    ...$9d8bde023f47c655$var$platformBase,
    ...$f0USY.dataComposer,
    appId: "aep-federatedDataUI",
    path: "/platform/federated-data",
    sideNav: {
        id: "aep",
        workHubId: "AEP"
    }
};
module.exports.platformFederatedDataUI = $9d8bde023f47c655$var$platformFederatedDataUI;
const $9d8bde023f47c655$var$platformAudienceOrchestrationUi = {
    ...$9d8bde023f47c655$var$platformBase,
    appId: "aep-audienceOrchestrationUi",
    path: "/platform/audience/compose",
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "cjm-audience-orchestration-ui",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "platform",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER,
    nestedApps: [
        $9d8bde023f47c655$var$ansiblePlatform
    ]
};
module.exports.platformAudienceOrchestrationUi = $9d8bde023f47c655$var$platformAudienceOrchestrationUi;
const $9d8bde023f47c655$var$mexpAccess = {
    code: [
        "acp"
    ],
    flag: "project-m-enabled",
    logicOp: "AND"
};
module.exports.mexpAccess = $9d8bde023f47c655$var$mexpAccess;
const $9d8bde023f47c655$var$mexpBaseConfig = {
    spaAppId: "experience-platform-mexp",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HASH,
        sources: {
            dev: "https://localhost.corp.adobe.com:8443"
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
module.exports.mexpBaseConfig = $9d8bde023f47c655$var$mexpBaseConfig;
const $9d8bde023f47c655$var$platformMexp = {
    ...$9d8bde023f47c655$var$platformBase,
    ...$9d8bde023f47c655$var$mexpBaseConfig,
    appId: "aep-mexp",
    path: "/platform/mexp",
    access: $9d8bde023f47c655$var$mexpAccess
};
module.exports.platformMexp = $9d8bde023f47c655$var$platformMexp;
const $9d8bde023f47c655$var$platformAmplify = {
    ...$9d8bde023f47c655$var$platformBase,
    ...$9d8bde023f47c655$var$_amplify.default,
    access: $9d8bde023f47c655$var$mexpAccess,
    appId: "aep-amplify",
    path: "/platform/mexp/plays",
    sandbox: {
        ...$9d8bde023f47c655$var$_amplify.default.sandbox,
        pathPrefix: {
            default: "/plays"
        }
    }
};
module.exports.platformAmplify = $9d8bde023f47c655$var$platformAmplify;

});
parcelRegister("h8iFD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/amplify.ts
const $938cf62600119bfb$var$amplify = {
    access: {
        flag: "amplify-enabled"
    },
    appId: "amplify",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/amplify",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "experience-platform-amplify",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER,
    urlContext: {
        key: "sandbox",
        optional: true
    }
};
var $938cf62600119bfb$var$_default = $938cf62600119bfb$var$amplify;
module.exports.default = $938cf62600119bfb$var$_default;

});

parcelRegister("f0USY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dataComposerStorybook = module.exports.dataComposer = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/dataComposer.ts
const $dd259665aec47681$var$dataComposer = {
    appContainer: "#root",
    appId: "federatedData",
    path: "/federated-data",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    spaAppId: "experience-platform-data-composer-ui",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    urlContext: {
        key: "sandbox",
        optional: false
    }
};
module.exports.dataComposer = $dd259665aec47681$var$dataComposer;
const $dd259665aec47681$var$dataComposerStorybook = {
    appId: "federatedDataStorybook",
    path: "/federated-data/storybook",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    spaAppId: "experience-platform-data-composer-ui",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        pathPrefix: {
            default: "/static-assets/storybook/index.html",
            dev: ""
        },
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8014",
            prod: ""
        }
    }
};
module.exports.dataComposerStorybook = $dd259665aec47681$var$dataComposerStorybook;

});

parcelRegister("6AMM5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/permissionsUI.ts
const $161505ecee251df0$var$permissionsUI = {
    appId: "permissionsUI",
    path: "/admin/permissions",
    gainsight: {
        productKey: "AP-GLVNMB5BLV8T-2"
    },
    spaAppId: "experience-platform-permissions-ui",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    access: {
        code: [
            "acp"
        ],
        fi: [
            "acp:acp_data_services_foundation"
        ],
        flag: "upf-enabled",
        logicOp: "AND"
    }
};
var $161505ecee251df0$var$_default = $161505ecee251df0$var$permissionsUI;
module.exports.default = $161505ecee251df0$var$_default;

});

parcelRegister("g0QiH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/platformUIDashboards.ts
const $a232e0fa9ea6ee02$var$platformUIDashboards = {
    appId: "platformUIDashboards",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    parent: "AEP",
    path: "/platform/v2/dashboard",
    alternateRoute: [
        {
            flag: "aep-dashboards-v-2-enabled",
            param: "experience-platform-aep-ui-dashboards_version",
            signalsInactive: true,
            path: /\/platform\/dashboard(\/.*|$)/,
            redirect: "/platform/v2/dashboard$1"
        }
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "experience-platform-aep-ui-dashboards",
    omegaSuiteId: "platform",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8020"
        }
    },
    autoInstantiateRuntime: true,
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $a232e0fa9ea6ee02$var$_default = $a232e0fa9ea6ee02$var$platformUIDashboards;
module.exports.default = $a232e0fa9ea6ee02$var$_default;

});

parcelRegister("fi5OI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.platformUIDatasets = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/platformUIDatasets.ts
const $3c805878b9b5e504$var$platformUIDatasets = {
    appId: "platformUIDatasets",
    parent: "AEP",
    path: "/platform/v2/dataset",
    alternateRoute: [
        {
            flag: "aep-datasets-v-2-enabled",
            param: "experience-platform-aep-ui-datasets_version",
            signalsInactive: true,
            redirect: "/platform/dataset"
        }
    ],
    spaAppId: "experience-platform-aep-ui-datasets",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8018",
            prod: ""
        }
    },
    omegaSuiteId: "platform",
    runtime: $ctGaZ.RUNTIME.CDN,
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    autoInstantiateRuntime: true,
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
module.exports.platformUIDatasets = $3c805878b9b5e504$var$platformUIDatasets;
var $3c805878b9b5e504$var$_default = $3c805878b9b5e504$var$platformUIDatasets;
module.exports.default = $3c805878b9b5e504$var$_default;

});

parcelRegister("5WTWJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.platformUIDecisioningManagementComponents = module.exports.platformUIDecisioningManagementOffers = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/platformUIDecisioningManagement.ts
const $1d011ed30f992ad2$var$platformUIDecisioningManagementOffers = {
    appId: "platformUIDecisioningManagementOffers",
    path: "/platform/v2/offers",
    alternateRoute: [
        {
            flag: "aep-offers-v-2-enabled",
            param: "cjm-ajo-ui-decisioning-management_version",
            signalsInactive: true,
            path: /\/platform\/offers(\/.*|$)/,
            redirect: "/platform/v2/offers$1"
        }
    ],
    spaAppId: "cjm-ajo-ui-decisioning-management",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "platform",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        pathPrefix: {
            default: "/offers"
        },
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8026"
        }
    },
    autoInstantiateRuntime: true,
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
module.exports.platformUIDecisioningManagementOffers = $1d011ed30f992ad2$var$platformUIDecisioningManagementOffers;
const $1d011ed30f992ad2$var$platformUIDecisioningManagementComponents = {
    appId: "platformUIDecisioningManagementComponents",
    path: "/platform/v2/components",
    alternateRoute: [
        {
            flag: "aep-offers-components-v-2-enabled",
            param: "cjm-ajo-ui-decisioning-management_version",
            signalsInactive: true,
            path: /\/platform\/components(\/.*|$)/,
            redirect: "/platform/v2/components$1"
        }
    ],
    spaAppId: "cjm-ajo-ui-decisioning-management",
    runtime: $ctGaZ.RUNTIME.CDN,
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "platform",
    sandbox: {
        pathPrefix: {
            default: "/components"
        },
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8026"
        }
    },
    autoInstantiateRuntime: true,
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
module.exports.platformUIDecisioningManagementComponents = $1d011ed30f992ad2$var$platformUIDecisioningManagementComponents;

});

parcelRegister("6bn9c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/platformUIEncryption.ts
const $e0008f212c47fccd$var$platformUIEncryption = {
    appId: "platformUIEncryption",
    parent: "AEP",
    path: "/platform/encryption",
    spaAppId: "experience-platform-aep-ui-encryption",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8015"
        }
    },
    access: {
        code: [
            "acp"
        ],
        fi: [
            "acp:acp_ps_shld",
            "acp:acp_hc_shld"
        ],
        flag: "cmk-enabled",
        logicOp: "AND"
    },
    omegaSuiteId: "platform",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $e0008f212c47fccd$var$_default = $e0008f212c47fccd$var$platformUIEncryption;
module.exports.default = $e0008f212c47fccd$var$_default;

});

parcelRegister("jylik", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.platformUIExperiments = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/platformUIExperiments.ts
const $6666da17956cfc47$var$platformUIExperiments = {
    appId: "platformUIExperiments",
    parent: "AEP",
    path: "/platform/experiment",
    spaAppId: "experience-platform-aep-ui-experiments",
    sandbox: {
        pathPrefix: {
            default: "/experiment"
        },
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8234",
            prod: ""
        }
    },
    omegaSuiteId: "platform",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
module.exports.platformUIExperiments = $6666da17956cfc47$var$platformUIExperiments;

});

parcelRegister("2icWJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/platformUILicenseUsage.ts
const $336d65739142020f$var$platformUILicenseUsage = {
    appId: "platformUILicenseUsage",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    path: "/platform/license-usage",
    parent: "AEP",
    alternateRoute: [
        {
            flag: "aep-license-usage-v-2-enabled",
            param: "experience-platform-aep-ui-license-usage_version",
            signalsInactive: true,
            path: /\/platform\/licenseUsage(\/.*|$)/,
            redirect: "/platform/license-usage$1"
        }
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "experience-platform-aep-ui-license-usage",
    omegaSuiteId: "platform",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8030"
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $336d65739142020f$var$_default = $336d65739142020f$var$platformUILicenseUsage;
module.exports.default = $336d65739142020f$var$_default;

});

parcelRegister("fAzMG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.platformUIMetricsCatalog = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/platformUIMetricsCatalog.ts
const $6a7c9130aa1160ed$var$platformUIMetricsCatalog = {
    appId: "platformUIMetricsCatalog",
    parent: "AEP",
    path: "/platform/metrics",
    spaAppId: "experience-platform-aep-ui-metrics-catalog",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8027"
        }
    },
    omegaSuiteId: "platform",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
module.exports.platformUIMetricsCatalog = $6a7c9130aa1160ed$var$platformUIMetricsCatalog;
var $6a7c9130aa1160ed$var$_default = $6a7c9130aa1160ed$var$platformUIMetricsCatalog;
module.exports.default = $6a7c9130aa1160ed$var$_default;

});

parcelRegister("kXzzK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.puebloBaseConfig = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/pueblo.ts
const $f1441cbcf0420335$var$puebloBaseConfig = {
    appContainer: "#container",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HASH,
        sources: {
            dev: "https://localhost.corp.adobe.com:23999"
        }
    },
    spaAppId: "exc-pueblo",
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
module.exports.puebloBaseConfig = $f1441cbcf0420335$var$puebloBaseConfig;

});


parcelRegister("8GiLQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/inappEditor.ts
const $67581165632b836e$var$inappEditor = {
    appId: "inappEditor",
    path: "/inapp-editor",
    releaseType: $ctGaZ.RELEASE_TYPE.BETA,
    spaAppId: "cjm-inapp-editor",
    runtime: $ctGaZ.RUNTIME.CDN,
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
var $67581165632b836e$var$_default = $67581165632b836e$var$inappEditor;
module.exports.default = $67581165632b836e$var$_default;

});

parcelRegister("bISJe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/journeysNextAdmin.ts
const $0d05a9d20504560b$var$journeysNextAdmin = {
    appId: "journeysNextAdmin",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    experienceLeague: {
        communities: "journey-orchestration",
        filter: "Journey Orchestration"
    },
    path: "/journeys",
    redirectFrom: [
        {
            path: "/journeys/v2"
        }
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "Voyager-voyager-authoring-ui-react",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        pathPrefix: {
            default: "/admin-app",
            preHash: true
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8098"
        }
    },
    access: {
        code: [
            "bso"
        ]
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $0d05a9d20504560b$var$_default = $0d05a9d20504560b$var$journeysNextAdmin;
module.exports.default = $0d05a9d20504560b$var$_default;

});

parcelRegister("lMagz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/journeysNextAuthoring.ts
const $ae8f6860b30759f4$var$journeysNextAuthoring = {
    appId: "journeysNextAuthoring",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    redirectFrom: [
        {
            path: "/journeys/v2/journey"
        }
    ],
    path: "/journeys/journey",
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "Voyager-voyager-authoring-ui-react",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        pathPrefix: {
            default: "/authoring-app",
            preHash: true
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8099"
        }
    },
    access: {
        code: [
            "bso"
        ]
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $ae8f6860b30759f4$var$_default = $ae8f6860b30759f4$var$journeysNextAuthoring;
module.exports.default = $ae8f6860b30759f4$var$_default;

});

parcelRegister("5haes", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/personalizationEditor.ts
const $1d0002abe7d13c88$var$personalizationEditor = {
    appId: "personalizationEditor",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/personalization-editor",
    spaAppId: "cjm-personalization-editor",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    }
};
var $1d0002abe7d13c88$var$_default = $1d0002abe7d13c88$var$personalizationEditor;
module.exports.default = $1d0002abe7d13c88$var$_default;

});

parcelRegister("gyj38", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.platformAnalytics = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/platformAnalytics.ts
const $b0168c035566ff40$var$base = {
    settingsAppId: "analytics",
    experienceLeague: {
        communities: "adobe-analytics",
        filter: "Customer Journey Analytics"
    },
    mfeAppIds: [
        "AnalyticsUI-core"
    ],
    serviceCode: "dx_awp",
    omegaSuiteId: "aa",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.AA
    },
    gainsight: {
        productKey: "AP-WVMZ1DVKRDJD-2"
    },
    permissionsPolicy: [
        "clipboard-write"
    ],
    access: {
        code: [
            "dx_awp"
        ]
    }
};
const $b0168c035566ff40$var$platformAnalytics = {
    ...$b0168c035566ff40$var$base,
    appId: "platformAnalytics",
    decodeUrl: true,
    parent: "AEP",
    path: "/platform/analytics",
    runtime: $ctGaZ.RUNTIME.CDN_LEGACY,
    sandbox: {
        hideInitialSpinner: true,
        history: $ctGaZ.HISTORY.SERVER,
        ims: {
            client_id: "WorkspacePlatform",
            scopes: "openid,AdobeID,session,read_organizations,additional_info.job_function,additional_info.user_image_url,additional_info.projectedProductContext,additional_info.roles"
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8443/platformAnalytics.html",
            qa: "https://stage.analytics.adobe.com",
            stage: "https://stage.analytics.adobe.com",
            prod: "https://analytics.adobe.com"
        }
    }
};
module.exports.platformAnalytics = $b0168c035566ff40$var$platformAnalytics;

});

parcelRegister("JdG5O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.translationConfig = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/translationService.ts
const $0f748363a447d27e$var$translationConfig = {
    appId: "translationService",
    path: "/translations",
    spaAppId: "g11n-dxts-DXTS",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HASH,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    releaseType: $ctGaZ.RELEASE_TYPE.GA,
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    }
};
module.exports.translationConfig = $0f748363a447d27e$var$translationConfig;

});

parcelRegister("6iVyY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useCasesConfig = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/useCases.ts
const $86d44d427e380648$var$useCasesConfig = {
    appId: "useCases",
    path: "/use-cases",
    spaAppId: "exc-dx-usecase-ui",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    urlContext: {
        key: "sandbox"
    }
};
module.exports.useCasesConfig = $86d44d427e380648$var$useCasesConfig;

});


parcelRegister("6tXYl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.experienceGenerationContentAssistantStorybook = module.exports.experienceGenerationContentAssistant = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/experienceGenerationContentAssistant.ts
const $df8447b6f09bfbf9$var$baseConfig = {
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "cjm-genai-content-assistant",
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER,
    urlContext: {
        key: "sandbox"
    }
};
const $df8447b6f09bfbf9$var$experienceGenerationContentAssistant = {
    ...$df8447b6f09bfbf9$var$baseConfig,
    appId: "experienceGenerationContentAssistant",
    path: "/genai-content-assistant",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    }
};
module.exports.experienceGenerationContentAssistant = $df8447b6f09bfbf9$var$experienceGenerationContentAssistant;
const $df8447b6f09bfbf9$var$experienceGenerationContentAssistantStorybook = {
    ...$df8447b6f09bfbf9$var$baseConfig,
    appId: "experienceGenerationContentAssistantStorybook",
    path: "/genai-content-assistant/storybook",
    sandbox: {
        pathPrefix: {
            default: "/static-assets/storybook/index.html",
            dev: ""
        },
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Storybook should not be enabled in production.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.OFF
};
module.exports.experienceGenerationContentAssistantStorybook = $df8447b6f09bfbf9$var$experienceGenerationContentAssistantStorybook;

});

parcelRegister("81gmm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.firefly3rd = module.exports.firefly = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/firefly.ts
const $960649d75359e0b8$var$common = {
    appRoot: "firefly",
    serviceCode: "dma_app_builder",
    permissionsPolicy: [
        "accelerometer",
        "camera",
        "clipboard-read",
        "clipboard-write",
        "display-capture",
        "geolocation",
        "gyroscope",
        "magnetometer",
        "microphone",
        "midi"
    ],
    refreshOnImsChange: true,
    runtime: $ctGaZ.RUNTIME.CDN_LEGACY,
    access: {
        code: [
            "dma_app_builder",
            "dma_app_builder_trial"
        ],
        flag: [
            "fg:firefly-enabled-list",
            "firefly-enabled-list"
        ]
    }
};
const $960649d75359e0b8$var$payload = [
    "imsOrg",
    "fullPath"
];
const $960649d75359e0b8$var$commonSources = {
    qa: {
        discovery: "https://jaeger-qa.adobe.io/resolver",
        payload: $960649d75359e0b8$var$payload,
        xApiKey: true
    },
    stage: {
        discovery: "https://jaeger-stage.adobe.io/resolver",
        payload: $960649d75359e0b8$var$payload,
        xApiKey: true
    },
    prod: {
        discovery: "https://jaeger.adobe.io/resolver",
        payload: $960649d75359e0b8$var$payload,
        xApiKey: true
    }
};
const $960649d75359e0b8$var$firefly = {
    ...$960649d75359e0b8$var$common,
    appId: "firefly",
    path: "/custom-apps",
    refreshOnImsChange: true,
    redirectFrom: [
        {
            path: "/myapps"
        },
        {
            path: "/apps"
        }
    ],
    sandbox: {
        hideInitialSpinner: true,
        history: $ctGaZ.HISTORY.SERVER,
        sources: $960649d75359e0b8$var$commonSources
    }
};
module.exports.firefly = $960649d75359e0b8$var$firefly;
const $960649d75359e0b8$var$firefly3rd = {
    ...$960649d75359e0b8$var$common,
    appId: "firefly-3rd",
    path: "/custom-apps/:id",
    redirectFrom: [
        {
            path: "/myapps/:id"
        },
        {
            path: "/apps/:id"
        }
    ],
    sandbox: {
        history: $ctGaZ.HISTORY.SERVER,
        sources: $960649d75359e0b8$var$commonSources,
        thirdParty: true
    }
};
module.exports.firefly3rd = $960649d75359e0b8$var$firefly3rd;

});

parcelRegister("arIPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.genstudioSharedUi = module.exports.genstudioContentSdk = module.exports.genstudioContentSharedUi = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/genStudioStorybooks.ts
const $241967d43af148ff$var$getGenStudioStorybook = (name, appId)=>({
        appId: appId,
        spaAppId: appId,
        analytics: {
            omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
        },
        path: `/${appId.toLowerCase()}`,
        releaseType: $ctGaZ.RELEASE_TYPE.POC,
        runtime: $ctGaZ.RUNTIME.CDN,
        sandbox: {
            pathPrefix: {
                default: "/static-assets/storybook/index.html",
                dev: "/"
            },
            history: $ctGaZ.HISTORY.HISTORY,
            sources: {
                dev: "https://localhost.corp.adobe.com:8013",
                prod: "" // Do not remove line, storybook should not go to production.
            }
        }
    });
const $241967d43af148ff$var$genstudioContentSharedUi = $241967d43af148ff$var$getGenStudioStorybook("Gen Studio Content Shared UI storybook", "GenStudio-content-shared-ui");
module.exports.genstudioContentSharedUi = $241967d43af148ff$var$genstudioContentSharedUi;
const $241967d43af148ff$var$genstudioContentSdk = $241967d43af148ff$var$getGenStudioStorybook("Gen Studio Content SDK storybook", "GenStudio-content-sdk");
module.exports.genstudioContentSdk = $241967d43af148ff$var$genstudioContentSdk;
const $241967d43af148ff$var$genstudioSharedUi = $241967d43af148ff$var$getGenStudioStorybook("Gen Studio Shared UI storybook", "GenStudio-shared-ui");
module.exports.genstudioSharedUi = $241967d43af148ff$var$genstudioSharedUi;

});

parcelRegister("9AEgh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.adobemixmodelerplatform = module.exports.adobemixmodeler = module.exports.labsexperienceintelligence = module.exports.intelligentservicesumm = module.exports.intelligentserviceslabs = module.exports.intelligentservices = void 0;

var $lBBEP = parcelRequire("lBBEP");

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/intelligentservices.ts
const $1a1de0417a5ac4f9$var$intelligentServicesBase = {
    spaAppId: "DSNP-UI-SDK-Monorepo",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "platform",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
const $1a1de0417a5ac4f9$var$intelligentservices = {
    ...$1a1de0417a5ac4f9$var$intelligentServicesBase,
    appId: "intelligentservices",
    appRoot: "experiencePlatformUI",
    parent: "AEP",
    path: "/platform/intelligent-services",
    sideNav: {
        id: "aep",
        workHubId: "AEP",
        workHubSelectedId: "service"
    },
    access: {
        code: [
            "acp"
        ]
    },
    urlContext: {
        key: "sandbox"
    }
};
module.exports.intelligentservices = $1a1de0417a5ac4f9$var$intelligentservices;
const $1a1de0417a5ac4f9$var$intelligentserviceslabs = {
    ...$1a1de0417a5ac4f9$var$intelligentServicesBase,
    appId: "intelligentserviceslabs",
    path: "/labs/intelligent-services",
    // Removing access requirement
    // access: { code: ['acp'] },
    urlContext: {
        key: "sandbox",
        optional: true
    }
};
module.exports.intelligentserviceslabs = $1a1de0417a5ac4f9$var$intelligentserviceslabs;
const $1a1de0417a5ac4f9$var$intelligentservicesumm = {
    ...$1a1de0417a5ac4f9$var$intelligentServicesBase,
    appId: "intelligentservicesumm",
    path: "/labs/umm-playground",
    // Removing the side nav, and we'll probably want a new one for the umm
    // sideNav: {
    //   workHubId: 'AEP',
    //   workHubSelectedId: 'service'
    // },
    access: {
        code: [
            "acp"
        ]
    },
    urlContext: {
        key: "sandbox"
    }
};
module.exports.intelligentservicesumm = $1a1de0417a5ac4f9$var$intelligentservicesumm;
const $1a1de0417a5ac4f9$var$labsexperienceintelligence = {
    ...$1a1de0417a5ac4f9$var$intelligentServicesBase,
    appId: "labsexperienceintelligence",
    path: "/labs/experience-intelligence",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    spaAppId: "XI-frontend-foundations",
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
module.exports.labsexperienceintelligence = $1a1de0417a5ac4f9$var$labsexperienceintelligence;
const $1a1de0417a5ac4f9$var$ummRouteBase = {
    sideNav: {
        id: "umm",
        workHubId: "UMM"
    },
    access: {
        code: [
            "acp"
        ]
    },
    urlContext: {
        key: "sandbox"
    }
};
const $1a1de0417a5ac4f9$var$adobemixmodeler = {
    ...$1a1de0417a5ac4f9$var$intelligentServicesBase,
    ...$1a1de0417a5ac4f9$var$ummRouteBase,
    appId: "adobemixmodeler",
    path: "/mix-modeler",
    access: {
        fi: [
            "acp:acp_mixmod",
            "acp:acp_mixmod_models"
        ],
        flag: "adobemixmodeler-enabled"
    }
};
module.exports.adobemixmodeler = $1a1de0417a5ac4f9$var$adobemixmodeler;
const $1a1de0417a5ac4f9$var$adobemixmodelerplatform = {
    ...$1a1de0417a5ac4f9$var$intelligentServicesBase,
    ...$lBBEP.platformBase,
    ...$1a1de0417a5ac4f9$var$ummRouteBase,
    nestedApps: [
        $lBBEP.ansiblePlatform
    ],
    appContainer: undefined,
    appId: "adobemixmodelerplatform",
    path: "/mix-modeler/platform",
    appRoot: undefined,
    parent: undefined,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    spaAppId: "experience-platform-platform-ui-client"
};
module.exports.adobemixmodelerplatform = $1a1de0417a5ac4f9$var$adobemixmodelerplatform;

});

parcelRegister("lsPrI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.platformLaunchGriffon = module.exports.platformLaunchPlaces = module.exports.platformLaunchDataCollectionDatastreams = module.exports.platformLaunchDataCollection = module.exports.launchGriffon = module.exports.launchPlatform = module.exports.launchPlaces = module.exports.launchDataCollectionDatastreams = module.exports.launchDataCollection = module.exports.dataCollectionHome = void 0;

var $lBBEP = parcelRequire("lBBEP");

var $73cb5ce2d8ad0467$var$_griffon = $73cb5ce2d8ad0467$var$_interopRequireDefault((parcelRequire("c1NsA")));

var $ctGaZ = parcelRequire("ctGaZ");

var $kXzzK = parcelRequire("kXzzK");
function $73cb5ce2d8ad0467$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/launch.ts
const $73cb5ce2d8ad0467$var$sideNav = {
    id: "launch",
    workHubId: "LAUNCH"
};
const $73cb5ce2d8ad0467$var$dataCollectionCommon = {
    appRoot: "launchDataCollection",
    experienceLeague: {
        communities: "adobe-launch-community",
        filter: "Data Collection"
    },
    parent: "DC",
    analytics: {
        code: "launch"
    },
    gainsight: {
        productKey: "AP-GLVNMB5BLV8T-2"
    },
    runtime: $ctGaZ.RUNTIME.CDN_LEGACY,
    browserParamFilterList: [
        "lens_env"
    ],
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        ims: {
            client_id: "Activation-DTM",
            scopes: "openid,AdobeID,session,read_organizations,additional_info.projectedProductContext,additional_info.job_function,additional_info.roles,audiencemanager_api"
        },
        overrideParams: true
    },
    sideNav: $73cb5ce2d8ad0467$var$sideNav,
    urlContext: {
        key: "sandbox",
        optional: true
    }
};
const $73cb5ce2d8ad0467$var$dataCollectionHome = {
    ...$73cb5ce2d8ad0467$var$dataCollectionCommon,
    ...$kXzzK.puebloBaseConfig,
    appId: "data-collection-home",
    appRoot: "launchDataCollection",
    omegaSuiteId: "al",
    redirectFrom: [
        {
            path: "/data-collection",
            options: {
                end: true
            }
        },
        {
            path: "/launch"
        }
    ],
    path: "/data-collection/home",
    parent: "DC",
    dataPrefetchContracts: [
        "dashboard-org"
    ],
    // Overrides
    browserParamFilterList: undefined,
    urlContext: undefined
};
module.exports.dataCollectionHome = $73cb5ce2d8ad0467$var$dataCollectionHome;
const $73cb5ce2d8ad0467$var$launchDataCollection = {
    ...$73cb5ce2d8ad0467$var$dataCollectionCommon,
    path: "/data-collection",
    appId: "launchDataCollection",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        ...$73cb5ce2d8ad0467$var$dataCollectionCommon.sandbox,
        sources: {
            // ims stage
            dev: "https://localhost:9002/solutions/reactor-lens?lens_env=dev",
            dev1: "https://experience-qa.adobe.com/solutions/reactor-lens?lens_env=dev",
            engd: "https://experience-qa.adobe.com/solutions/reactor-lens?lens_env=engd",
            qa: "https://experience-qa.adobe.com/solutions/reactor-lens?lens_env=qa",
            stage: "https://experience-stage.adobe.com/solutions/reactor-lens?lens_env=stage",
            // ims prod
            demo: "https://experience.adobe.com/solutions/reactor-lens?lens_env=demo",
            prod: "https://experience.adobe.com/solutions/reactor-lens?lens_env=prod"
        }
    }
};
module.exports.launchDataCollection = $73cb5ce2d8ad0467$var$launchDataCollection;
const $73cb5ce2d8ad0467$var$launchDataCollectionDatastreams = {
    ...$73cb5ce2d8ad0467$var$dataCollectionCommon,
    appId: "launchDataCollectionDatastreams",
    path: "/data-collection/scramjet",
    sandbox: {
        ...$73cb5ce2d8ad0467$var$dataCollectionCommon.sandbox,
        sources: {
            dev: "https://localhost.corp.adobe.com:9002"
        }
    },
    spaAppId: "Activation-scramjet",
    runtime: $ctGaZ.RUNTIME.CDN
};
module.exports.launchDataCollectionDatastreams = $73cb5ce2d8ad0467$var$launchDataCollectionDatastreams;
const $73cb5ce2d8ad0467$var$launchPlaces = {
    ...$73cb5ce2d8ad0467$var$dataCollectionCommon,
    appId: "launch-places",
    path: "/data-collection/places",
    redirectFrom: [
        {
            path: "/places"
        }
    ],
    sandbox: {
        hideInitialSpinner: true,
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://ui-dev.places.adobe.com/unified/index.html",
            qa: "https://ui-qa.places.adobe.com/unified/index.html",
            stage: "https://ui-preprod.places.adobe.com/unified/index.html",
            prod: "https://ui.places.adobe.com/unified/index.html"
        }
    },
    access: {
        fi: [
            "acp:acp_places"
        ]
    }
};
module.exports.launchPlaces = $73cb5ce2d8ad0467$var$launchPlaces;
const $73cb5ce2d8ad0467$var$launchPlatform = {
    ...$lBBEP.experiencePlatformSpa,
    appId: "launch-platform",
    appRoot: "launchDataCollection",
    omegaSuiteId: "al",
    gainsight: {
        productKey: "AP-GLVNMB5BLV8T-2"
    },
    path: "/data-collection/platform",
    parent: "DC",
    sideNav: $73cb5ce2d8ad0467$var$sideNav
};
module.exports.launchPlatform = $73cb5ce2d8ad0467$var$launchPlatform;
const $73cb5ce2d8ad0467$var$launchGriffon = {
    ...$73cb5ce2d8ad0467$var$dataCollectionCommon,
    ...$73cb5ce2d8ad0467$var$_griffon.default,
    appId: "launch-griffon",
    path: "/data-collection/assurance",
    redirectFrom: [
        {
            path: "/data-collection/griffon"
        }
    ],
    access: {
        ...$73cb5ce2d8ad0467$var$_griffon.default.access,
        flag: "assurance-capability-enabled"
    },
    urlContext: undefined
};
/**
 * THESE ARE PLATFORM BUT WOULD HAVE CIRCULAR DEPENDENCY SO THEY LIVE HERE :(
 */ module.exports.launchGriffon = $73cb5ce2d8ad0467$var$launchGriffon;
const $73cb5ce2d8ad0467$var$platformLaunchDataCollection = {
    ...$73cb5ce2d8ad0467$var$launchDataCollection,
    appId: "platformLaunchDataCollection",
    appRoot: "experiencePlatformUI",
    parent: "AEP",
    path: "/platform/data-collection",
    sideNav: {
        id: "aep",
        workHubId: "AEP"
    }
};
module.exports.platformLaunchDataCollection = $73cb5ce2d8ad0467$var$platformLaunchDataCollection;
const $73cb5ce2d8ad0467$var$platformLaunchDataCollectionDatastreams = {
    ...$73cb5ce2d8ad0467$var$launchDataCollectionDatastreams,
    appId: "platformLaunchDataCollectionDatastreams",
    appRoot: "experiencePlatformUI",
    parent: "AEP",
    path: "/platform/data-collection/scramjet",
    sideNav: {
        id: "aep",
        workHubId: "AEP"
    }
};
module.exports.platformLaunchDataCollectionDatastreams = $73cb5ce2d8ad0467$var$platformLaunchDataCollectionDatastreams;
const $73cb5ce2d8ad0467$var$platformLaunchPlaces = {
    ...$73cb5ce2d8ad0467$var$launchPlaces,
    appId: "platform-launch-places",
    appRoot: "experiencePlatformUI",
    parent: "AEP",
    path: "/platform/data-collection/places",
    redirectFrom: undefined,
    sideNav: {
        id: "aep",
        workHubId: "AEP"
    }
};
module.exports.platformLaunchPlaces = $73cb5ce2d8ad0467$var$platformLaunchPlaces;
const $73cb5ce2d8ad0467$var$platformLaunchGriffon = {
    ...$73cb5ce2d8ad0467$var$launchGriffon,
    appId: "platform-launch-griffon",
    appRoot: "experiencePlatformUI",
    parent: "AEP",
    path: "/platform/data-collection/assurance",
    redirectFrom: [
        {
            path: "/platform/data-collection/griffon"
        }
    ],
    sideNav: {
        id: "aep",
        workHubId: "AEP"
    }
};
module.exports.platformLaunchGriffon = $73cb5ce2d8ad0467$var$platformLaunchGriffon;

});
parcelRegister("c1NsA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/griffon.ts
const $22d61b137d9b38f9$var$griffon = {
    appId: "griffon",
    path: "/assurance",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.AA
    },
    omegaSuiteId: "griffon",
    gainsight: {
        productKey: "AP-GLVNMB5BLV8T-2"
    },
    redirectFrom: [
        {
            path: "/griffon"
        }
    ],
    access: {
        fi: [
            "acp:acp_assurance"
        ],
        flag: "assurance-root-enabled"
    },
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            proxy: "https://local.griffon.adobe.com",
            dev: "https://local.griffon.adobe.com:8888/"
        }
    },
    spaAppId: "dms-mobile-gemini"
};
var $22d61b137d9b38f9$var$_default = $22d61b137d9b38f9$var$griffon;
module.exports.default = $22d61b137d9b38f9$var$_default;

});


parcelRegister("jl3Tk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.macuiAudiences = module.exports.macuiCustomerAttributes = module.exports.macuiAssets = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/macui.ts
const $06514630507f3787$var$landingPath = "/apps/mac/landing.html";
const $06514630507f3787$var$macuiRoutes = (destination)=>({
        devs: `https://localhost.corp.adobe.com${$06514630507f3787$var$landingPath}?dest=${destination}`,
        qa: `https://{tenant}.experience-qa.corp.adobe.com${$06514630507f3787$var$landingPath}?dest=${destination}`,
        stage: `https://{tenant}.experiencecloud-stage.adobe.com${$06514630507f3787$var$landingPath}?dest=${destination}`,
        prod: `https://{tenant}.experiencecloud.adobe.com${$06514630507f3787$var$landingPath}?dest=${destination}`
    });
const $06514630507f3787$var$baseConfigs = {
    base: "/core-services",
    experienceLeague: {
        communities: "adobe-macui",
        filter: "macui"
    },
    refreshOnImsChange: true,
    analytics: {
        code: "macui"
    },
    gainsight: {
        productKey: "AP-4CEBSL6PUX23-2"
    }
};
const $06514630507f3787$var$getConfig = (destination, appId, overrides = {})=>({
        ...$06514630507f3787$var$baseConfigs,
        appId: `${appId}`,
        path: `/core-services/${destination}`,
        sandbox: {
            history: {
                type: $ctGaZ.HISTORY.HASH,
                config: {
                    hashType: $ctGaZ.HASH_TYPE.NOSLASH
                }
            },
            sources: $06514630507f3787$var$macuiRoutes(destination)
        },
        ...overrides
    });
const $06514630507f3787$var$macuiAssets = $06514630507f3787$var$getConfig("assets", "macuiAssets", {
    name: "Adobe Assets Core Services",
    serviceCode: "dma_tartan",
    access: {},
    redirectFrom: [
        {
            path: "/core-services",
            options: {
                end: true
            }
        }
    ]
});
module.exports.macuiAssets = $06514630507f3787$var$macuiAssets;
const $06514630507f3787$var$macuiCustomerAttributes = $06514630507f3787$var$getConfig("customer-attributes", "macuiCustomerAttributes", {
    name: "Adobe Customer Attributes Core Services",
    serviceCode: "dma_crs",
    access: {
        code: [
            "dma_tartan"
        ]
    }
});
module.exports.macuiCustomerAttributes = $06514630507f3787$var$macuiCustomerAttributes;
const $06514630507f3787$var$macuiAudiences = $06514630507f3787$var$getConfig("audiences", "macuiAudiences", {
    name: "Adobe Audiences Library Core Services",
    serviceCode: "dma_audience_library",
    access: {
        code: [
            "dma_tartan"
        ]
    }
});
module.exports.macuiAudiences = $06514630507f3787$var$macuiAudiences;

});

parcelRegister("7DZAa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.marketoEngage = module.exports.marketo = void 0;

var $jOW4N = parcelRequire("jOW4N");

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/marketo.ts
const $a2dfd55004aea487$var$getSubOrgName = (prodCtx)=>{
    const { user_visible_name: user_visible_name = null, fulfillable_entity_resource_name: fulfillable_entity_resource_name = null } = prodCtx; // Marketo suborgs should use the user friendly "user_visible_name" from the
    // product context if it exists. Otherwise, use "fulfillable_entity_resource_name".
    return user_visible_name || fulfillable_entity_resource_name;
};
const $a2dfd55004aea487$var$access = {
    code: [
        "dma_marketo"
    ]
};
const $a2dfd55004aea487$var$DISCOVERY_CACHE = {
    pathCacheMethod: $jOW4N.PATH_CACHE_METHOD.CACHE_PARAMS,
    scope: $jOW4N.CACHE_SCOPE.LOCAL,
    ttl: 86400
};
const $a2dfd55004aea487$var$getDiscovery = (discovery, cache)=>({
        cache: cache ? $a2dfd55004aea487$var$DISCOVERY_CACHE : undefined,
        discovery: discovery,
        payload: [
            "activeProductContext",
            "imsOrg",
            "imsProfile",
            "path"
        ],
        reduceProfile: true,
        withCredentials: true
    });
const $a2dfd55004aea487$var$marketo = {
    appId: "marketo",
    experienceLeague: {
        communities: "marketo",
        filter: "Marketo Engage"
    },
    helpCenter: {
        hideDefaultResources: true
    },
    path: "/marketo",
    permissionsPolicy: [
        "clipboard-write"
    ],
    spaAppId: "meue-exc-launch-page",
    sandbox: {
        history: $ctGaZ.HISTORY.HASH,
        sources: {
            dev: "https://localhost.corp.adobe.com:12399"
        }
    },
    access: $a2dfd55004aea487$var$access
};
module.exports.marketo = $a2dfd55004aea487$var$marketo;
const $a2dfd55004aea487$var$marketoEngage = {
    appId: "marketoEngage",
    appRoot: "marketo",
    experienceLeague: {
        communities: "marketo",
        filter: "Marketo Engage"
    },
    helpCenter: {
        hideDefaultResources: true
    },
    path: "/marketo-engage",
    permissionsPolicy: [
        "clipboard-write"
    ],
    browserParamFilterList: [
        "uShell",
        "idsSSOToken",
        "symfony",
        "xsrfId",
        "munchkinId",
        "appUrl",
        "clusterId",
        "dataCenterId",
        "languages"
    ],
    sandbox: {
        history: $ctGaZ.HISTORY.HASH,
        sources: {
            dev: $a2dfd55004aea487$var$getDiscovery("https://meue-loader.devdocker.marketo.com/discovery"),
            dev2: $a2dfd55004aea487$var$getDiscovery("https://meueloader.mkto.dev/discovery"),
            int: $a2dfd55004aea487$var$getDiscovery("https://engage-int.marketo.com/discovery"),
            qa: $a2dfd55004aea487$var$getDiscovery("https://engage-qe.marketo.com/discovery"),
            stage: $a2dfd55004aea487$var$getDiscovery("https://engage-qe.marketo.com/discovery"),
            marketo_stage: $a2dfd55004aea487$var$getDiscovery("https://engage-st.marketo.com/discovery"),
            prod: $a2dfd55004aea487$var$getDiscovery("https://engage-ab.marketo.com/discovery")
        }
    },
    serviceCode: "dma_marketo",
    urlContext: {
        key: "subOrg",
        config: {
            customIdName: "munchkinId",
            id: "fulfillable_entity_resource_locator",
            name: $a2dfd55004aea487$var$getSubOrgName,
            serviceCode: "dma_marketo",
            useRootPathOnChange: true
        }
    },
    access: $a2dfd55004aea487$var$access,
    subOrgAccessOnlyOnCurrentOrg: true
};
module.exports.marketoEngage = $a2dfd55004aea487$var$marketoEngage;

});

parcelRegister("dSQaL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.orionStorybook = module.exports.orionSchemas = module.exports.orionPlatform = module.exports.orionJourneys = module.exports.orionHome = module.exports.orionCampaigns = module.exports.orionAssets = module.exports.orion = void 0;

var $ewVCA = parcelRequire("ewVCA");

var $lBBEP = parcelRequire("lBBEP");

var $ctGaZ = parcelRequire("ctGaZ");

var $kXzzK = parcelRequire("kXzzK");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/orion.ts
const $3ed05ce6029ebfde$var$access = {
    flag: "project-orion-enabled"
};
const $3ed05ce6029ebfde$var$sideNav = {
    id: "orion",
    workHubId: "ORION"
};
const $3ed05ce6029ebfde$var$baseConfig = {
    access: $3ed05ce6029ebfde$var$access,
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    appRoot: "orion",
    omegaSuiteId: "platform",
    parent: "ORION",
    sideNav: $3ed05ce6029ebfde$var$sideNav,
    urlContext: {
        key: "sandbox"
    }
};
const $3ed05ce6029ebfde$var$baseOrionSpaSandbox = {
    history: {
        type: $ctGaZ.HISTORY.HASH,
        config: {
            addParamsToHash: true
        }
    },
    sources: {
        proxy: "https://local.orion.adobe.com",
        dev: "https://local.orion.adobe.com:8888"
    }
};
const $3ed05ce6029ebfde$var$orion = {
    ...$3ed05ce6029ebfde$var$baseConfig,
    appId: "orion",
    path: "/orion/projects",
    redirectFrom: [
        {
            path: "/orion",
            options: {
                end: true
            }
        }
    ],
    sandbox: $3ed05ce6029ebfde$var$baseOrionSpaSandbox,
    spaAppId: "dms-mobile-taurus"
};
module.exports.orion = $3ed05ce6029ebfde$var$orion;
const $3ed05ce6029ebfde$var$orionAssets = {
    ...$3ed05ce6029ebfde$var$baseConfig,
    ...$ewVCA.assetsBase,
    appContainer: undefined,
    appId: "orion-assets",
    metricsAppId: "orion-assets",
    path: "/orion/assets",
    unifiedSearch: undefined
};
module.exports.orionAssets = $3ed05ce6029ebfde$var$orionAssets;
const $3ed05ce6029ebfde$var$orionCampaigns = {
    ...$3ed05ce6029ebfde$var$baseConfig,
    appContainer: "#root",
    autoInstantiateRuntime: true,
    appId: "orionCampaignsApp",
    path: "/orion/campaigns",
    spaAppId: "ajo-mobile-ajo-campaigns-ui",
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER,
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "platform",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    access: {
        ...$3ed05ce6029ebfde$var$access,
        fi: [
            "acp:cjm_msg",
            "acp:cjm_foundation"
        ]
    }
};
module.exports.orionCampaigns = $3ed05ce6029ebfde$var$orionCampaigns;
const $3ed05ce6029ebfde$var$orionHome = {
    ...$3ed05ce6029ebfde$var$baseConfig,
    ...$kXzzK.puebloBaseConfig,
    appContainer: "#container",
    appId: "orion-home",
    dataPrefetchContracts: [
        "recents-sandbox"
    ],
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "platform",
    path: "/orion/home"
}; // The solution config for the Journeys Orchestration app
module.exports.orionHome = $3ed05ce6029ebfde$var$orionHome;
const $3ed05ce6029ebfde$var$orionJourneys = {
    ...$3ed05ce6029ebfde$var$baseConfig,
    appContainer: undefined,
    appId: "orion-journeys",
    path: "/orion/journeys",
    runtime: $ctGaZ.RUNTIME.CDN_LEGACY,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        ims: {
            client_id: "voyager",
            scopes: "AdobeID,openid,additional_info.projectedProductContext,read_organizations"
        },
        sources: {
            dev: "https://localhost.corp.adobe.com/",
            qa: "https://journeys-dev.adobe.com/",
            stage: "https://journeys-stage.adobe.com/",
            prod: "https://journeys.adobe.com/"
        }
    },
    access: {
        ...$3ed05ce6029ebfde$var$access,
        fi: [
            "acp:cjm_orch",
            "acp:cjm_foundation"
        ]
    }
};
module.exports.orionJourneys = $3ed05ce6029ebfde$var$orionJourneys;
const $3ed05ce6029ebfde$var$orionPlatform = {
    ...$3ed05ce6029ebfde$var$baseConfig,
    ...$lBBEP.experiencePlatformSpa,
    appContainer: undefined,
    appId: "orion-platform",
    appRoot: "orion-home",
    omegaSuiteId: "platform",
    parent: "ORION",
    path: "/orion/platform",
    sideNav: $3ed05ce6029ebfde$var$sideNav // This is necessary because the experiencePlatformSpa will override the setting in baseConfig. This will be a problem when AEP has a sideNav.
};
module.exports.orionPlatform = $3ed05ce6029ebfde$var$orionPlatform;
const $3ed05ce6029ebfde$var$orionSchemas = {
    ...$3ed05ce6029ebfde$var$baseConfig,
    appId: "orion-schemas",
    path: "/orion/schemas",
    spaAppId: "dms-mobile-taurus",
    sandbox: {
        ...$3ed05ce6029ebfde$var$baseOrionSpaSandbox,
        pathPrefix: {
            default: "/schemas"
        }
    }
};
module.exports.orionSchemas = $3ed05ce6029ebfde$var$orionSchemas;
const $3ed05ce6029ebfde$var$orionStorybook = {
    appId: "orion-storybook",
    path: "/orion/storybook",
    spaAppId: "dms-mobile-taurus",
    sandbox: {
        pathPrefix: {
            default: "/static-assets/storybook/index.html"
        },
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://local.orion.adobe.com:9002",
            prod: ""
        }
    }
};
module.exports.orionStorybook = $3ed05ce6029ebfde$var$orionStorybook;

});

parcelRegister("6kTFF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.quarrySampleApp = module.exports.quarryStorybookAjo = module.exports.quarryStorybookConnected = void 0;

var $45fd16730a7130e7$var$_ajoContentEditor = $45fd16730a7130e7$var$_interopRequireDefault((parcelRequire("3V3fc")));

var $jqwuU = parcelRequire("jqwuU");

var $be9hY = parcelRequire("be9hY");

var $ctGaZ = parcelRequire("ctGaZ");

var $45fd16730a7130e7$var$_personalizationEditor = $45fd16730a7130e7$var$_interopRequireDefault((parcelRequire("5haes")));
function $45fd16730a7130e7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/quarry.ts
const $45fd16730a7130e7$var$quarryStorybookConnected = {
    appId: "quarryStorybookConnected",
    path: "/quarry/storybook-connected",
    permissionsPolicy: [
        "clipboard-write"
    ],
    redirectFrom: [
        {
            path: "/quarry",
            options: {
                end: true
            }
        }
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        pathPrefix: {
            default: "/storybook-connected",
            dev: ""
        },
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:2019/",
            dev443: "https://localhost.corp.adobe.com:443/",
            prod: ""
        }
    },
    spaAppId: "frontend-quarry",
    urlContext: {
        key: "sandbox",
        optional: true
    },
    nestedApps: [
        $jqwuU.ansible,
        $45fd16730a7130e7$var$_ajoContentEditor.default,
        $45fd16730a7130e7$var$_personalizationEditor.default
    ]
};
module.exports.quarryStorybookConnected = $45fd16730a7130e7$var$quarryStorybookConnected;
const $45fd16730a7130e7$var$quarryStorybookAjo = {
    appId: "quarryStorybookAjo",
    path: "/quarry/storybook-ajo",
    redirectFrom: [
        {
            path: "/quarry/ajo"
        }
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        pathPrefix: {
            default: "/storybook-ajo",
            dev: ""
        },
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:2019/",
            dev443: "https://localhost.corp.adobe.com:443/",
            prod: ""
        }
    },
    spaAppId: "frontend-quarry",
    urlContext: {
        key: "sandbox",
        optional: true
    },
    nestedApps: [
        $jqwuU.ansible,
        $45fd16730a7130e7$var$_ajoContentEditor.default,
        $45fd16730a7130e7$var$_personalizationEditor.default,
        $be9hY.cjmChannelHandlerUI,
        $45fd16730a7130e7$var$_ajoContentEditor.default
    ]
};
module.exports.quarryStorybookAjo = $45fd16730a7130e7$var$quarryStorybookAjo;
const $45fd16730a7130e7$var$quarrySampleApp = {
    appId: "quarry-sample-app",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/quarry/sample",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "frontend-quarry-sample-app",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
module.exports.quarrySampleApp = $45fd16730a7130e7$var$quarrySampleApp;

});

parcelRegister("aejSY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sapphireHome = module.exports.sapphireAdminChannelsUI = module.exports.sapphireAdminConfigsUI = module.exports.sapphireChannelFragmentsUI = module.exports.sapphireBuyingGroups = module.exports.sapphireConfigUI = module.exports.sapphireAssetsUI = module.exports.sapphirePersonalizationEditor = module.exports.sapphireEmailTemplates = module.exports.sapphirePlatform = module.exports.sapphireUI = void 0;

var $lBBEP = parcelRequire("lBBEP");

var $ctGaZ = parcelRequire("ctGaZ");

var $kXzzK = parcelRequire("kXzzK");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/sapphireUI.ts
const $dd212ea40cdab82c$var$access = {
    code: [
        "acp",
        "dma_marketo"
    ],
    codeLogicOp: "AND",
    flag: "sapphire-enabled",
    logicOp: "AND"
};
const $dd212ea40cdab82c$var$sideNav = {
    id: "sapphire",
    workHubId: "SAPPHIRE"
};
const $dd212ea40cdab82c$var$baseConfig = {
    access: $dd212ea40cdab82c$var$access,
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    appRoot: "sapphireUI",
    parent: "SAPPHIRE",
    releaseScope: $ctGaZ.RELEASE_SCOPE.PARENT,
    releaseType: $ctGaZ.RELEASE_TYPE.BETA,
    sideNav: $dd212ea40cdab82c$var$sideNav,
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER,
    urlContext: {
        key: "sandbox"
    }
};
const $dd212ea40cdab82c$var$baseUrl = "/journey-optimizer-b2b";
const $dd212ea40cdab82c$var$sapphireBaseUrl = "/sapphire";
const $dd212ea40cdab82c$var$sapphireUI = {
    ...$dd212ea40cdab82c$var$baseConfig,
    appId: "sapphireUI",
    path: $dd212ea40cdab82c$var$baseUrl,
    redirectFrom: [
        {
            path: $dd212ea40cdab82c$var$sapphireBaseUrl
        }
    ],
    spaAppId: "sapphire-sapphire-ui",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
module.exports.sapphireUI = $dd212ea40cdab82c$var$sapphireUI;
const $dd212ea40cdab82c$var$sapphirePlatform = {
    ...$dd212ea40cdab82c$var$baseConfig,
    ...$lBBEP.experiencePlatformSpa,
    appContainer: undefined,
    appId: "sapphire-platform",
    path: `${$dd212ea40cdab82c$var$baseUrl}/platform`,
    redirectFrom: [
        {
            path: `${$dd212ea40cdab82c$var$sapphireBaseUrl}/platform`
        }
    ],
    // Necessary because the experiencePlatformSpa overrides baseConfig.
    appRoot: "sapphireUI",
    parent: "SAPPHIRE",
    sideNav: $dd212ea40cdab82c$var$sideNav,
    unifiedSearch: undefined
};
module.exports.sapphirePlatform = $dd212ea40cdab82c$var$sapphirePlatform;
const $dd212ea40cdab82c$var$sapphireEmailTemplates = {
    ...$dd212ea40cdab82c$var$baseConfig,
    appId: "sapphireEmailTemplates",
    path: `${$dd212ea40cdab82c$var$baseUrl}/email-templates`,
    redirectFrom: [
        {
            path: `${$dd212ea40cdab82c$var$sapphireBaseUrl}/email-templates`
        }
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "sapphire-email-templates",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8015"
        }
    }
};
module.exports.sapphireEmailTemplates = $dd212ea40cdab82c$var$sapphireEmailTemplates;
const $dd212ea40cdab82c$var$sapphirePersonalizationEditor = {
    ...$dd212ea40cdab82c$var$baseConfig,
    appId: "sapphirePersonalizationEditor",
    path: `${$dd212ea40cdab82c$var$baseUrl}/personalization-editor`,
    redirectFrom: [
        {
            path: `${$dd212ea40cdab82c$var$sapphireBaseUrl}/personalization-editor`
        }
    ],
    spaAppId: "sapphire-personalization-editor",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8014"
        }
    }
};
module.exports.sapphirePersonalizationEditor = $dd212ea40cdab82c$var$sapphirePersonalizationEditor;
const $dd212ea40cdab82c$var$sapphireAssetsUI = {
    ...$dd212ea40cdab82c$var$baseConfig,
    appId: "sapphireAssetsUI",
    path: `${$dd212ea40cdab82c$var$baseUrl}/assets-listing`,
    redirectFrom: [
        {
            path: `${$dd212ea40cdab82c$var$baseUrl}/marketo-assets`
        },
        {
            path: `${$dd212ea40cdab82c$var$sapphireBaseUrl}/marketo-assets`
        }
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "sapphire-sapphire-assets-ui",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8016"
        }
    }
};
module.exports.sapphireAssetsUI = $dd212ea40cdab82c$var$sapphireAssetsUI;
const $dd212ea40cdab82c$var$sapphireConfigUI = {
    ...$dd212ea40cdab82c$var$baseConfig,
    appId: "sapphireConfigUI",
    path: `${$dd212ea40cdab82c$var$baseUrl}/config`,
    redirectFrom: [
        {
            path: `${$dd212ea40cdab82c$var$sapphireBaseUrl}/config`
        }
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "sapphire-sapphire-config-ui",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8044"
        }
    }
};
module.exports.sapphireConfigUI = $dd212ea40cdab82c$var$sapphireConfigUI;
const $dd212ea40cdab82c$var$sapphireBuyingGroups = {
    ...$dd212ea40cdab82c$var$baseConfig,
    appId: "sapphireBuyingGroups",
    path: `${$dd212ea40cdab82c$var$baseUrl}/buying-groups`,
    redirectFrom: [
        {
            path: `${$dd212ea40cdab82c$var$sapphireBaseUrl}/buying-groups`
        }
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "sapphire-buying-groups",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
module.exports.sapphireBuyingGroups = $dd212ea40cdab82c$var$sapphireBuyingGroups;
const $dd212ea40cdab82c$var$sapphireChannelFragmentsUI = {
    ...$dd212ea40cdab82c$var$baseConfig,
    appId: "sapphireChannelFragmentsUI",
    path: `${$dd212ea40cdab82c$var$baseUrl}/fragments`,
    redirectFrom: [
        {
            path: `${$dd212ea40cdab82c$var$sapphireBaseUrl}/fragments`
        }
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "sapphire-channel-fragments",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
module.exports.sapphireChannelFragmentsUI = $dd212ea40cdab82c$var$sapphireChannelFragmentsUI;
const $dd212ea40cdab82c$var$sapphireAdminConfigsUI = {
    ...$dd212ea40cdab82c$var$baseConfig,
    appId: "sapphireAdminConfigsUI",
    path: `${$dd212ea40cdab82c$var$baseUrl}/admin-configs`,
    redirectFrom: [
        {
            path: `${$dd212ea40cdab82c$var$sapphireBaseUrl}/admin-configs`
        }
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "sapphire-sapphire-admin-configs-ui",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
module.exports.sapphireAdminConfigsUI = $dd212ea40cdab82c$var$sapphireAdminConfigsUI;
const $dd212ea40cdab82c$var$sapphireAdminChannelsUI = {
    ...$dd212ea40cdab82c$var$baseConfig,
    appId: "sapphireAdminChannelsUI",
    path: `${$dd212ea40cdab82c$var$baseUrl}/channels-config`,
    redirectFrom: [
        {
            path: `${$dd212ea40cdab82c$var$sapphireBaseUrl}/channels-config`
        }
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "sapphire-sapphire-admin-channels-ui",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
module.exports.sapphireAdminChannelsUI = $dd212ea40cdab82c$var$sapphireAdminChannelsUI;
const $dd212ea40cdab82c$var$sapphireHome = {
    ...$dd212ea40cdab82c$var$baseConfig,
    ...$kXzzK.puebloBaseConfig,
    appId: "sapphireHome",
    appContainer: "#container",
    path: `${$dd212ea40cdab82c$var$baseUrl}/home`,
    redirectFrom: [
        {
            path: $dd212ea40cdab82c$var$baseUrl,
            options: {
                end: true
            }
        },
        {
            path: $dd212ea40cdab82c$var$sapphireBaseUrl,
            options: {
                end: true
            }
        }
    ]
};
module.exports.sapphireHome = $dd212ea40cdab82c$var$sapphireHome;

});

parcelRegister("2JP99", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sitesMicroFrontendsStorybook = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/sitesMicroFrontends.ts
const $4ed7a16200c27949$var$getSitesMFEStorybook = (name, spaAppId)=>{
    const repoName = /^(^cq-)?(.+)/i.exec(spaAppId)?.[2];
    return {
        appId: `${repoName}-storybook`,
        spaAppId: spaAppId,
        path: `/sites-micro-frontends/${repoName}`,
        sandbox: {
            pathPrefix: {
                default: "/static-assets/storybook/index.html"
            },
            history: $ctGaZ.HISTORY.HISTORY,
            sources: {
                dev: "https://localhost.corp.adobe.com:8443/",
                prod: ""
            }
        },
        runtime: $ctGaZ.RUNTIME.CDN,
        urlContext: {
            key: "sandbox",
            optional: true
        }
    };
};
const $4ed7a16200c27949$var$sitesMicroFrontendsStorybook = $4ed7a16200c27949$var$getSitesMFEStorybook("Sites Micro Frontends Content Fragment Selector storybook", "CQ-sites-content-fragment-selector");
module.exports.sitesMicroFrontendsStorybook = $4ed7a16200c27949$var$sitesMicroFrontendsStorybook;

});

parcelRegister("k5kpY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ajoUiTemplate = module.exports.spaTemplateAEP = module.exports.spaTemplateTypescriptWebpackRtl = module.exports.spaTemplateParcel = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/spaTemplates.ts
const $2e2d1effa11aae1f$var$templateCommon = {
    autoInstantiateRuntime: true,
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Templates should not run in Prod
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
const $2e2d1effa11aae1f$var$spaTemplateParcel = {
    ...$2e2d1effa11aae1f$var$templateCommon,
    appId: "spaTemplateParcel",
    path: "/spa-templates/parcel-template",
    spaAppId: "dx-spa-templates-spa-template-parcel"
};
module.exports.spaTemplateParcel = $2e2d1effa11aae1f$var$spaTemplateParcel;
const $2e2d1effa11aae1f$var$spaTemplateTypescriptWebpackRtl = {
    ...$2e2d1effa11aae1f$var$templateCommon,
    appId: "spaTemplateTypescriptWebpackRtl",
    path: "/spa-templates/webpack-typescript-rtl-template",
    spaAppId: "dx-spa-templates-spa-template-typescript-webpack-rtl"
};
module.exports.spaTemplateTypescriptWebpackRtl = $2e2d1effa11aae1f$var$spaTemplateTypescriptWebpackRtl;
const $2e2d1effa11aae1f$var$spaTemplateAEP = {
    ...$2e2d1effa11aae1f$var$templateCommon,
    appId: "spaTemplateAEPUI",
    path: "/spa-templates/aep-ui-template",
    spaAppId: "dx-spa-templates-aep-ui-template",
    urlContext: {
        key: "sandbox"
    }
};
module.exports.spaTemplateAEP = $2e2d1effa11aae1f$var$spaTemplateAEP;
const $2e2d1effa11aae1f$var$ajoUiTemplate = {
    ...$2e2d1effa11aae1f$var$templateCommon,
    appId: "ajoUiTemplate",
    path: "/spa-templates/ajo-ui-template",
    spaAppId: "dx-spa-templates-ajo-ui-template",
    urlContext: {
        key: "sandbox"
    }
};
module.exports.ajoUiTemplate = $2e2d1effa11aae1f$var$ajoUiTemplate;

});

parcelRegister("eq1T3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.targetProducts = module.exports.targetOffers = module.exports.targetSetup = module.exports.targetAudiences = module.exports.targetActivities = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/target.ts
const $678b79a80cc52472$var$baseConfigs = {
    appId: "target",
    base: "/target",
    experienceLeague: {
        communities: "adobe-target",
        filter: "Target"
    },
    refreshOnImsChange: true,
    serviceCode: "dma_bullseye",
    access: {
        code: [
            "dma_tnt",
            "dma_bullseye"
        ]
    },
    analytics: {
        code: "at"
    },
    gainsight: {
        productKey: "AP-4CEBSL6PUX23-2"
    }
};
const $678b79a80cc52472$var$landingPath = "/apps/mac/target/pages/landing.html";
var $678b79a80cc52472$var$AppTypes;
(function(AppTypes) {
    AppTypes["MAC_UI"] = "MAC_UI";
    AppTypes["SPA_PIPELINE"] = "SPA_PIPELINE";
})($678b79a80cc52472$var$AppTypes || ($678b79a80cc52472$var$AppTypes = {}));
const $678b79a80cc52472$var$spaRoutes = (destination)=>({
        dev: `http://localhost.corp.adobe.com:4200/${destination}`,
        devs: `https://localhost.corp.adobe.com:4200/${destination}`,
        qa: `https://experience-qa.adobe.com/solutions/tnt-bullet#/${destination}`,
        stage: `https://experience-stage.adobe.com/solutions/tnt-bullet#/${destination}`,
        prod: `https://experience.adobe.com/solutions/tnt-bullet#/${destination}`
    });
const $678b79a80cc52472$var$macuiRoutes = (destination)=>({
        dev: `http://localhost.corp.adobe.com:4502${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        dev_old: `http://localhost.corp.adobe.com:4502${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        dev_next: `http://localhost.corp.adobe.com:4502${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        devs: `https://localhost.corp.adobe.com${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        devs_old: `https://localhost.corp.adobe.com${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        devs_next: `https://localhost.corp.adobe.com${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        qa12: `https://{tenant}.marketing-qa12.corp.adobe.com${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        qa12_old: `https://{tenant}.marketing-qa12.corp.adobe.com${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        qa12_next: `https://{tenant}.marketing-qa12.corp.adobe.com${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        qa: `https://{tenant}.experience-qa.corp.adobe.com${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        qa_old: `https://{tenant}.experience-qa.corp.adobe.com${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        qa_next: `https://{tenant}.experience-qa.corp.adobe.com${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        beta: `https://{tenant}.experiencecloud-beta.adobe.com${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        stage: `https://{tenant}.experiencecloud-stage.adobe.com${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        stage_old: `https://{tenant}.experiencecloud-stage.adobe.com${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        stage_next: `https://{tenant}.experiencecloud-stage.adobe.com${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        prod: `https://{tenant}.experiencecloud.adobe.com${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        prod_old: `https://{tenant}.experiencecloud.adobe.com${$678b79a80cc52472$var$landingPath}?dest=${destination}`,
        prod_next: `https://{tenant}.experiencecloud.adobe.com${$678b79a80cc52472$var$landingPath}?dest=${destination}`
    });
const $678b79a80cc52472$var$getConfig = (destination, type = $678b79a80cc52472$var$AppTypes.MAC_UI, overrides = {})=>({
        ...$678b79a80cc52472$var$baseConfigs,
        appId: `${$678b79a80cc52472$var$baseConfigs.appId}-${destination}`,
        path: `/target/${destination}`,
        sandbox: {
            history: {
                type: $ctGaZ.HISTORY.HASH,
                config: {
                    addParamsToHash: true
                }
            },
            sources: type === $678b79a80cc52472$var$AppTypes.SPA_PIPELINE ? $678b79a80cc52472$var$spaRoutes(destination) : $678b79a80cc52472$var$macuiRoutes(destination)
        },
        spaAppId: type === $678b79a80cc52472$var$AppTypes.SPA_PIPELINE ? "tnt-bullet" : undefined,
        runtime: type === $678b79a80cc52472$var$AppTypes.SPA_PIPELINE ? $ctGaZ.RUNTIME.CDN : undefined,
        ...overrides
    });
const $678b79a80cc52472$var$targetActivities = $678b79a80cc52472$var$getConfig("activities", $678b79a80cc52472$var$AppTypes.MAC_UI, {
    appId: "target",
    alternateRoute: [
        {
            config: $678b79a80cc52472$var$getConfig("activities", $678b79a80cc52472$var$AppTypes.SPA_PIPELINE, {
                appId: "target"
            }),
            flag: "target-activities-enabled",
            regex: true
        }
    ],
    redirectFrom: [
        {
            path: "/target",
            options: {
                end: true
            }
        }
    ]
});
module.exports.targetActivities = $678b79a80cc52472$var$targetActivities;
const $678b79a80cc52472$var$targetAudiences = $678b79a80cc52472$var$getConfig("audiences", $678b79a80cc52472$var$AppTypes.SPA_PIPELINE, {
    alternateRoute: [
        {
            config: $678b79a80cc52472$var$getConfig("audiences", $678b79a80cc52472$var$AppTypes.MAC_UI),
            flag: "target-audiences-spa-enabled",
            regex: true
        }
    ]
});
module.exports.targetAudiences = $678b79a80cc52472$var$targetAudiences;
const $678b79a80cc52472$var$targetSetup = $678b79a80cc52472$var$getConfig("setup", $678b79a80cc52472$var$AppTypes.SPA_PIPELINE, {
    alternateRoute: [
        {
            config: $678b79a80cc52472$var$getConfig("setup", $678b79a80cc52472$var$AppTypes.MAC_UI),
            flag: "target-setup-enabled",
            regex: true
        }
    ]
});
module.exports.targetSetup = $678b79a80cc52472$var$targetSetup;
const $678b79a80cc52472$var$targetOffers = $678b79a80cc52472$var$getConfig("offers", $678b79a80cc52472$var$AppTypes.MAC_UI, {
    alternateRoute: [
        {
            config: $678b79a80cc52472$var$getConfig("offers", $678b79a80cc52472$var$AppTypes.SPA_PIPELINE),
            flag: "target-offers-enabled",
            regex: true
        }
    ]
});
module.exports.targetOffers = $678b79a80cc52472$var$targetOffers;
const $678b79a80cc52472$var$targetProducts = $678b79a80cc52472$var$getConfig("products", $678b79a80cc52472$var$AppTypes.MAC_UI, {
    alternateRoute: [
        {
            config: $678b79a80cc52472$var$getConfig("products", $678b79a80cc52472$var$AppTypes.SPA_PIPELINE),
            flag: "target-products-enabled",
            regex: true
        }
    ]
});
module.exports.targetProducts = $678b79a80cc52472$var$targetProducts;

});

parcelRegister("h5LFe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.trident = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/trident.ts
const $15c97c24979b0432$var$trident = {
    appId: "trident",
    path: "/trident",
    spaAppId: "exc-trident",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8014",
            prod: ""
        }
    },
    urlContext: {
        key: "sandbox",
        optional: true
    }
};
module.exports.trident = $15c97c24979b0432$var$trident;

});

parcelRegister("9TqP1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cjmUiServices = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /*
 * While onboarding another app in cjm.js, please identify
 * if there are sharable configs among apps and if yes, then
 * create a baseConfig object and move common configs there
*/ // This file was generated automatically from ../solutions/ui-services.ts
const $0aa38ddf229b9d9f$var$cjmUiServices = {
    appId: "cjmUiServices",
    urlContext: {
        key: "sandbox"
    },
    path: "/ui-services",
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "cjm-ui-services",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8565",
            prod: "" // Remove this line before the production release.
        }
    }
};
module.exports.cjmUiServices = $0aa38ddf229b9d9f$var$cjmUiServices;

});

parcelRegister("6ed5a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/abmweb.ts
const $a020d85bbe09f9b3$var$abmweb = {
    appId: "abmweb",
    path: "/abm",
    spaAppId: "exc-play-abm-web",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    }
};
var $a020d85bbe09f9b3$var$_default = $a020d85bbe09f9b3$var$abmweb;
module.exports.default = $a020d85bbe09f9b3$var$_default;

});

parcelRegister("aLgRx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/accp.ts
const $d244f80a67fbcf95$var$accp = {
    appId: "accp",
    path: "/controlpanel",
    serviceCode: "dma_campaign",
    sandbox: {
        hideInitialSpinner: true,
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:1234",
            qa: "https://accp-dev.campaign.adobe.com",
            snapshot: "https://accp-snapshot.campaign.adobe.com/{base}",
            stage: "https://accp-stage.campaign.adobe.com",
            prod: "https://accp.campaign.adobe.com"
        },
        ims: {
            client_id: "accp",
            scopes: "AdobeID,openid,read_organizations,creative_cloud,additional_info.company,additional_info.projectedProductContext,session,acss_cpanelapi,additional_info.roles"
        }
    }
};
var $d244f80a67fbcf95$var$_default = $d244f80a67fbcf95$var$accp;
module.exports.default = $d244f80a67fbcf95$var$_default;

});

parcelRegister("9UeED", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/accreportsui.ts
const $6319b07140b158b4$var$accreportsui = {
    appId: "accreportsui",
    serviceCode: "dma_campaign_classic",
    path: "/acc/dynamicReports/:mySubOrg",
    access: {
        code: [
            "dma_campaign_classic"
        ]
    },
    analytics: {
        code: "cc"
    },
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.SERVER,
            config: {
                spinnerOnChange: true,
                absolutePaths: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com",
            qa: `https://{mySubOrg}.campaign.adobe.com`,
            rd: `https://{mySubOrg}.rd.campaign.adobe.com`,
            stage: `https://{mySubOrg}.campaign.adobe.com`,
            prod: `https://{mySubOrg}.campaign.adobe.com`
        }
    }
};
var $6319b07140b158b4$var$_default = $6319b07140b158b4$var$accreportsui;
module.exports.default = $6319b07140b158b4$var$_default;

});

parcelRegister("kXH9R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/acctriggersui.ts
const $9c84ec66f2b51cb8$var$acctriggersui = {
    appId: "acctriggersui",
    path: "/triggers",
    spaAppId: "campaign-triggers-ui",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    access: {
        code: [
            "dma_campaign",
            "dma_campaign_classic"
        ],
        logicOp: "AND",
        subServiceCode: [
            "dma_analytics:triggers"
        ]
    }
};
var $9c84ec66f2b51cb8$var$_default = $9c84ec66f2b51cb8$var$acctriggersui;
module.exports.default = $9c84ec66f2b51cb8$var$_default;

});

parcelRegister("4B3xI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/accwebui.ts
const $1dc5ee213574ecc4$var$getSubOrgName = (prodCtx)=>{
    const { tenantid: tenantid } = JSON.parse(prodCtx.fulfillable_data || "{}");
    return tenantid || prodCtx.tenant_id;
};
const $1dc5ee213574ecc4$var$accwebui = {
    appId: "accwebui",
    appContainer: "#root",
    path: "/acc",
    permissionsPolicy: [
        "clipboard-write"
    ],
    spaAppId: "campaign-acc-web-ui",
    gainsight: {
        productKey: "AP-3QN514NBNJA6-2"
    },
    omegaSuiteId: "cc",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:12399"
        }
    },
    urlContext: {
        key: "subOrg",
        config: {
            customPathKey: "name",
            dontWaitForLoad: true,
            id: "ident",
            name: $1dc5ee213574ecc4$var$getSubOrgName,
            orgIdName: $1dc5ee213574ecc4$var$getSubOrgName,
            serviceCode: "dma_campaign_classic"
        }
    },
    access: {
        code: [
            "dma_campaign_classic"
        ]
    }
};
var $1dc5ee213574ecc4$var$_default = $1dc5ee213574ecc4$var$accwebui;
module.exports.default = $1dc5ee213574ecc4$var$_default;

});

parcelRegister("g8b9W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/accwebui-localization.ts
const $8c761c2366fb4c79$var$accwebuiLocalization = {
    appId: "accwebui-localization",
    path: "/acc/translator",
    spaAppId: "Campaign-acc-web-ui-localization",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    }
};
var $8c761c2366fb4c79$var$_default = $8c761c2366fb4c79$var$accwebuiLocalization;
module.exports.default = $8c761c2366fb4c79$var$_default;

});

parcelRegister("jx8LV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/admin.ts
const $026d341ecee62642$var$admin = {
    appId: "admin",
    path: "/admin",
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "admin-tool",
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:1240"
        }
    },
    releaseType: $ctGaZ.RELEASE_TYPE.BETA
};
var $026d341ecee62642$var$_default = $026d341ecee62642$var$admin;
module.exports.default = $026d341ecee62642$var$_default;

});

parcelRegister("axFeZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/adobepassunifiedshellconsoleclient.ts
const $888c207d8151ab66$var$adobePassUnifiedShellConsoleClient = {
    access: {
        code: [
            "dma_primetime"
        ],
        flag: "pass-authentication-enabled",
        logicOp: "AND"
    },
    appId: "adobepassunifiedshellconsoleclient",
    experienceLeague: {
        communities: "adobe-primetime",
        filter: "Pass"
    },
    permissionsPolicy: [
        "clipboard-write"
    ],
    path: "/pass/authentication",
    spaAppId: "AdobePass-adobepass-unifiedshell-console-client",
    serviceCode: "dma_primetime",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
var $888c207d8151ab66$var$_default = $888c207d8151ab66$var$adobePassUnifiedShellConsoleClient;
module.exports.default = $888c207d8151ab66$var$_default;

});

parcelRegister("BMsAk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/adobeReachUI.ts
const $acb84ed74c620174$var$adobeReachUI = {
    appId: "adobeReachUI",
    path: "/reach",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    spaAppId: "experience-platform-adobe-reach-ui",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    }
};
var $acb84ed74c620174$var$_default = $acb84ed74c620174$var$adobeReachUI;
module.exports.default = $acb84ed74c620174$var$_default;

});

parcelRegister("edAmi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/advertising-ssc.ts
const $48d74fc402fc269e$var$advertisingssc = {
    appId: "advertising-ssc",
    betaFeedbackConfigId: "advertising-ssc",
    path: "/advertising/ssc",
    releaseType: $ctGaZ.RELEASE_TYPE.ALPHA,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "AMO-ad-opt-ui",
    sandbox: {
        history: $ctGaZ.HISTORY.SERVER,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER,
    access: {
        flag: "advertising-ssc-enabled"
    }
};
var $48d74fc402fc269e$var$_default = $48d74fc402fc269e$var$advertisingssc;
module.exports.default = $48d74fc402fc269e$var$_default;

});

parcelRegister("4h3Pv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/aemHomeUi.ts
const $1215fdbe798f2cc9$var$aemHomeUi = {
    appId: "aem-home-ui",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/aem-home",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "experience-platform-aem-home-ui",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $1215fdbe798f2cc9$var$_default = $1215fdbe798f2cc9$var$aemHomeUi;
module.exports.default = $1215fdbe798f2cc9$var$_default;

});

parcelRegister("dvLkR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/aemOutboundMarketing.ts
const $a3f9345401f2f26b$var$aemOutboundMarketing = {
    appId: "aemOutboundMarketing",
    path: "/aem-outbound-marketing",
    spaAppId: "CQ-aem-outbound-marketing-ui",
    urlContext: {
        key: "sandbox",
        optional: true
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
var $a3f9345401f2f26b$var$_default = $a3f9345401f2f26b$var$aemOutboundMarketing;
module.exports.default = $a3f9345401f2f26b$var$_default;

});

parcelRegister("jJQ21", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/affiliatesPlatformAdvertiser.ts
const $13edc83142963fde$var$affiliatesPlatformAdvertiser = {
    appId: "affiliates-platform-advertiser",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/affiliates-platform-advertiser",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "experience-platform-affiliate-platform-advertisers",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $13edc83142963fde$var$_default = $13edc83142963fde$var$affiliatesPlatformAdvertiser;
module.exports.default = $13edc83142963fde$var$_default;

});

parcelRegister("fX3NY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/affiliatesPlatformAffiliate.ts
const $9fb740ff3060810c$var$affiliatesPlatformAffiliate = {
    appId: "affiliates-platform-affiliate",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/affiliates-platform-affiliate",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "experience-platform-affiliate-platform-affiliate",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8014",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $9fb740ff3060810c$var$_default = $9fb740ff3060810c$var$affiliatesPlatformAffiliate;
module.exports.default = $9fb740ff3060810c$var$_default;

});

parcelRegister("8daGr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/agoraUI.ts
const $aab0a665da1052f8$var$agoraUI = {
    appId: "agoraUI",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    parent: "AEP",
    path: "/platform/agora",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    fiServiceCode: "acp",
    spaAppId: "experience-platform-aep-ui-agora",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8765",
            prod: "" // Remove this line before the production release.
        }
    }
};
var $aab0a665da1052f8$var$_default = $aab0a665da1052f8$var$agoraUI;
module.exports.default = $aab0a665da1052f8$var$_default;

});

parcelRegister("8I2YL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jOW4N = parcelRequire("jOW4N");

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/analytics.ts
const $5255327020e433ab$var$cache = {
    keepParams: [
        "company",
        "current_org"
    ],
    pathCacheMethod: $jOW4N.PATH_CACHE_METHOD.CACHE_PARAMS,
    removeParams: [
        "jpj",
        "redirectedFromUnifiedShellHtml",
        "redirected",
        "ssSession",
        "unifiedShellImsRedirectForPhp"
    ],
    scope: $jOW4N.CACHE_SCOPE.LOCAL,
    ttl: 2678400 // One month
};
const $5255327020e433ab$var$payload = [
    "activeProductContext",
    "imsOrg",
    "path"
];
const $5255327020e433ab$var$getErrorInfo = (res)=>{
    // Special case for the discovery services.
    if (res.errorCode === "400" && res.errorDescription?.startsWith("Could not find Analytics Company")) return {
        id: "company_notfound"
    };
    return {
        description: res.errorDescription,
        heading: res.errorHeading,
        id: res.errorCode
    };
};
const $5255327020e433ab$var$sessionDiscovery = {
    cache: {
        pathCacheMethod: $jOW4N.PATH_CACHE_METHOD.CACHE_DEFAULT_PATH,
        removeParams: [
            "jpj",
            "ssSession"
        ],
        scope: $jOW4N.CACHE_SCOPE.LOCAL,
        ttl: 2678400
    },
    discovery: "{lastOrigin}/sc15/json/generatePhpSession.php",
    getErrorInfo: $5255327020e433ab$var$getErrorInfo,
    includesSession: true,
    payload: [
        "path",
        "activeProductContext",
        "company",
        "tenant",
        "imsOrg",
        "imsProfile"
    ],
    reduceProfile: true,
    simpleRequest: true,
    withCredentials: true
};
const $5255327020e433ab$var$getDiscoveryUrl = (url)=>({
        cache: $5255327020e433ab$var$cache,
        discovery: url,
        getErrorInfo: $5255327020e433ab$var$getErrorInfo,
        payload: $5255327020e433ab$var$payload,
        next: $5255327020e433ab$var$sessionDiscovery
    });
const $5255327020e433ab$var$analytics = {
    appId: "analytics",
    settingsAppId: "analytics",
    decodeUrl: true,
    experienceLeague: {
        communities: "adobe-analytics",
        filter: "Analytics"
    },
    path: "/analytics",
    serviceCode: "dma_analytics",
    analytics: {
        code: "aa"
    },
    mfeAppIds: [
        "AnalyticsUI-core"
    ],
    gainsight: {
        productKey: "AP-WVMZ1DVKRDJD-2"
    },
    permissionsPolicy: [
        "clipboard-write"
    ],
    urlContext: {
        key: "subOrg",
        config: {
            id: "global_company_id",
            name: "login_company",
            preferred: "is_preferred",
            serviceCode: "dma_analytics"
        }
    },
    sections: [
        {
            name: "Analytics SPA",
            route: "/spa/",
            metricsAppId: "analytics"
        },
        {
            name: "Analytics PHP",
            route: "/p/",
            sessionParameter: "ssSession",
            metricsAppId: "analytics-php"
        },
        {
            name: "Analytics PHP",
            route: "/sc15/",
            sessionParameter: "ssSession",
            metricsAppId: "analytics-php"
        }
    ],
    runtime: $ctGaZ.RUNTIME.CDN_LEGACY,
    sandbox: {
        hideInitialSpinner: true,
        history: {
            type: $ctGaZ.HISTORY.SERVER,
            config: {
                absolutePaths: true
            }
        },
        ims: {
            client_id: "SiteCatalyst2",
            scopes: "openid,AdobeID,session,read_organizations,additional_info.job_function,additional_info.user_image_url,additional_info.projectedProductContext,additional_info.roles"
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8443/analytics.html",
            qa: $5255327020e433ab$var$getDiscoveryUrl("https://appservice-discovery-stage.int.ethos11-stage-ut1.ethos.adobe.net/1.0/unifiedShell"),
            stage: $5255327020e433ab$var$getDiscoveryUrl("https://appservice-discovery-stage.int.ethos11-stage-ut1.ethos.adobe.net/1.0/unifiedShell"),
            prod: $5255327020e433ab$var$getDiscoveryUrl("https://analytics.discovery.adobe.net/1.0/unifiedShell")
        },
        pageTimeout: 300000
    },
    session: {
        defaultTTL: 7200,
        // 2 hours, can be extended by Analytics.
        getFromDiscovery: true,
        multiSessions: true,
        scope: $ctGaZ.SessionScope.CONTEXT
    },
    access: {
        code: [
            "dma_analytics"
        ]
    },
    getPathOrgFromContext: (location)=>{
        const url = new URL(`https://test.url/${location.search}`);
        return decodeURIComponent(url.searchParams.get("current_org") || "");
    }
};
var $5255327020e433ab$var$_default = $5255327020e433ab$var$analytics;
module.exports.default = $5255327020e433ab$var$_default;

});

parcelRegister("94aCm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/annotations.ts
const $5ab6181c4769c56b$var$annotations = {
    appId: "annotations",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/annotations",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "experience-platform-annotations",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $5ab6181c4769c56b$var$_default = $5ab6181c4769c56b$var$annotations;
module.exports.default = $5ab6181c4769c56b$var$_default;

});

parcelRegister("3o3dI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/ansiblegenai.ts
const $e436adb813f7e5bd$var$ansiblegenai = {
    appId: "ansiblegenai",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/audiencegenai",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    spaAppId: "Ansible-ansible-genai",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    }
};
var $e436adb813f7e5bd$var$_default = $e436adb813f7e5bd$var$ansiblegenai;
module.exports.default = $e436adb813f7e5bd$var$_default;

});

parcelRegister("a8DXY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/assetsCollections.ts
const $bc029976c128e56e$var$assetsCollections = {
    appId: "assetsCollections",
    path: "/assets-collections",
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "cq-assets-collections",
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8443",
            prod: "" // Remove this line before the production release.
        }
    }
};
var $bc029976c128e56e$var$_default = $bc029976c128e56e$var$assetsCollections;
module.exports.default = $bc029976c128e56e$var$_default;

});

parcelRegister("4MkqN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jOW4N = parcelRequire("jOW4N");

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/audiencemanager.ts
const $f7abfffc56ebf481$var$payload = [
    "imsOrg",
    "path"
];
const $f7abfffc56ebf481$var$cache = {
    scope: $jOW4N.CACHE_SCOPE.LOCAL,
    ttl: 1200 // 20 minutes
};
const $f7abfffc56ebf481$var$audienceManager = {
    appId: "audiencemanager",
    experienceLeague: {
        communities: "adobe-audience-manager",
        filter: "Audience Manager"
    },
    path: "/audience-manager",
    serviceCode: "dma_audiencemanager",
    refreshOnImsChange: true,
    analytics: {
        code: "aam"
    },
    gainsight: {
        productKey: "AP-LTAZSTOEXW3L-2"
    },
    sandbox: {
        pageTimeout: 60000,
        history: {
            type: $ctGaZ.HISTORY.SERVER,
            config: {
                absolutePaths: true
            }
        },
        sources: {
            dev: {
                cache: $f7abfffc56ebf481$var$cache,
                discovery: "https://localhost.demdex.com/portal/unifiedshell",
                payload: $f7abfffc56ebf481$var$payload,
                withCredentials: true
            },
            qa: {
                cache: $f7abfffc56ebf481$var$cache,
                discovery: "https://qa.aam.adobe.com/portal/unifiedshell",
                payload: $f7abfffc56ebf481$var$payload,
                withCredentials: true
            },
            stage: {
                cache: $f7abfffc56ebf481$var$cache,
                discovery: "https://stage.aam.adobe.com/portal/unifiedshell",
                payload: $f7abfffc56ebf481$var$payload,
                withCredentials: true
            },
            prod: {
                cache: $f7abfffc56ebf481$var$cache,
                discovery: "https://audience-manager.adobe.com/portal/unifiedshell",
                payload: $f7abfffc56ebf481$var$payload,
                withCredentials: true
            }
        }
    },
    access: {
        code: [
            "dma_audiencemanager"
        ]
    }
};
var $f7abfffc56ebf481$var$_default = $f7abfffc56ebf481$var$audienceManager;
module.exports.default = $f7abfffc56ebf481$var$_default;

});

parcelRegister("fAQXr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/berlinHome.ts
const $d0c3c17bdb5552c8$var$berlinHome = {
    appId: "berlin-home",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/berlin-home",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    sharedCaches: [
        "aem-headless"
    ],
    spaAppId: "experience-platform-project-berlin-home",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $d0c3c17bdb5552c8$var$_default = $d0c3c17bdb5552c8$var$berlinHome;
module.exports.default = $d0c3c17bdb5552c8$var$_default;

});

parcelRegister("3O627", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/blank.ts
const $3cc82992fda0ba20$var$blank = {
    appId: "blank",
    path: "/blank",
    permissionsPolicy: [
        "clipboard-write"
    ],
    dashboard: true,
    spaAppId: "exc-about-blank-app",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        ims: {
            client_id: "g11n_selector",
            scopes: "AdobeID,openid"
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:12399"
        }
    }
};
var $3cc82992fda0ba20$var$_default = $3cc82992fda0ba20$var$blank;
module.exports.default = $3cc82992fda0ba20$var$_default;

});

parcelRegister("ivoHP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/campaignAccWebUiSpa.ts
const $bdcb419c1b05734c$var$campaignAccWebUiSpa = {
    appId: "campaign-acc-web-ui-spa",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/acc-web-ui-spa-demo",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "Campaign-acc-web-ui-spa",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $bdcb419c1b05734c$var$_default = $bdcb419c1b05734c$var$campaignAccWebUiSpa;
module.exports.default = $bdcb419c1b05734c$var$_default;

});

parcelRegister("jpfsG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/cjaModules.ts
const $a164c318435c225f$var$cjaModules = {
    appId: "cjaModules",
    path: "/cjaModules",
    spaAppId: "CJA-UI-cja-ui-library",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com",
            prod: ""
        }
    }
};
var $a164c318435c225f$var$_default = $a164c318435c225f$var$cjaModules;
module.exports.default = $a164c318435c225f$var$_default;

});

parcelRegister("gsxpd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/cloudManager.ts
const $b0b3f524b809be93$var$cloudManager = {
    appId: "cloudManagerUi",
    spaAppId: "experience-platform-self-service-cvui",
    path: "/cloud-manager",
    permissionsPolicy: [
        "clipboard-write"
    ],
    omegaSuiteId: "cm",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    gainsight: {
        productKey: "AP-KDZIABJIM4XD-2"
    },
    serviceCode: "dma_aem_cloud",
    sideNav: {
        closeOnLoad: true
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    access: {
        code: [
            "dma_aem_ams",
            "dma_aem_cloud",
            "dma_media_library",
            "dma_commerce_cloud",
            "dma_aem_onprem"
        ],
        flag: "aem-on-prem-enabled"
    },
    sandbox: {
        ims: {
            client_id: "ssp_ui",
            scopes: "openid,AdobeID,session,read_organizations,ab.manage,additional_info.projectedProductContext,additional_info.user_image_url,additional_info.roles"
        },
        hideInitialSpinner: true,
        history: $ctGaZ.HISTORY.HISTORY,
        pageTimeout: 90000,
        sources: {
            local: "https://local.corp.adobe.com"
        }
    },
    settingsAppId: "cloudManagerUi"
};
var $b0b3f524b809be93$var$_default = $b0b3f524b809be93$var$cloudManager;
module.exports.default = $b0b3f524b809be93$var$_default;

});

parcelRegister("ioE0I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/cloudManagerBackOfficeUi.ts
const $33cfd67a823c159f$var$cloudManagerBackOfficeUi = {
    appId: "cloudManagerBackOfficeUi",
    path: "/cloud-manager-back-office",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    spaAppId: "experience-platform-cm-back-office-ui",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    }
};
var $33cfd67a823c159f$var$_default = $33cfd67a823c159f$var$cloudManagerBackOfficeUi;
module.exports.default = $33cfd67a823c159f$var$_default;

});

parcelRegister("8Y61l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/cm-console-ui.ts
const $b17819a1984ce9a9$var$cmConsoleUI = {
    spaAppId: "primetime-cm-console-ui",
    appId: "cm-console-ui",
    appRoot: "primetime",
    experienceLeague: {
        communities: "adobe-primetime",
        filter: "Primetime"
    },
    path: "/cm-console",
    serviceCode: "dma_primetime",
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        ims: {
            client_id: "cm-console-ui",
            scopes: "AdobeID,openid,dma_group_mapping,read_organizations,additional_info.projectedProductContext"
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:12399"
        },
        pageTimeout: 30000
    }
};
var $b17819a1984ce9a9$var$_default = $b17819a1984ce9a9$var$cmConsoleUI;
module.exports.default = $b17819a1984ce9a9$var$_default;

});

parcelRegister("2SHGh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/cmStandaloneMfe.ts
const $2d76598e912569f3$var$cmStandaloneMfe = {
    appId: "cmStandaloneMfe",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/cm-standalone-mfe",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "experience-platform-cm-standalone-mfe",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $2d76598e912569f3$var$_default = $2d76598e912569f3$var$cmStandaloneMfe;
module.exports.default = $2d76598e912569f3$var$_default;

});

parcelRegister("eYBz3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/commerce.ts
const $a37f67e46b133567$var$commerce = {
    appId: "commerceInstanceDiscovery",
    path: "/commerce",
    spaAppId: "Adobe-Commerce-Admin-discovery-ui",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    access: {
        flag: "commerce-enabled"
    }
};
var $a37f67e46b133567$var$_default = $a37f67e46b133567$var$commerce;
module.exports.default = $a37f67e46b133567$var$_default;

});

parcelRegister("6PGAu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/commerceCatalogServiceDemoUI.ts
const $7f93fea23e52987e$var$commerceCatalogServiceDemoUI = {
    appId: "commerceCatalogServiceDemoUI",
    path: "/catalog-service-demo-ui",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "commerce-ro-catalog-service-demo-ui",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    }
};
var $7f93fea23e52987e$var$_default = $7f93fea23e52987e$var$commerceCatalogServiceDemoUI;
module.exports.default = $7f93fea23e52987e$var$_default;

});

parcelRegister("frfKH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/commerceSaaS.ts
const $3f59ea156526ef8f$var$commerceSaaS = {
    appId: "commerceSaaS",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/commercesaas",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "core-commerce-saas-commerce-saas-unified-experience",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $3f59ea156526ef8f$var$_default = $3f59ea156526ef8f$var$commerceSaaS;
module.exports.default = $3f59ea156526ef8f$var$_default;

});

parcelRegister("4UfcS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/complianceDroid.ts
const $402708b75ae32e31$var$complianceDroid = {
    appId: "compliance-droid",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/compliance-droid",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "experience-platform-compliance-droid-ui",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $402708b75ae32e31$var$_default = $402708b75ae32e31$var$complianceDroid;
module.exports.default = $402708b75ae32e31$var$_default;

});

parcelRegister("dUfEi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/content-hub.ts
const $4ee530786f57c77b$var$contentHub = {
    appId: "ContentHub",
    path: "/assets/contenthub",
    permissionsPolicy: [
        "clipboard-write"
    ],
    runtime: $ctGaZ.RUNTIME.CDN,
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    gainsight: {
        productKey: "AP-AULLRFDZLJ9K-2"
    },
    spaAppId: "CQ-contenthub",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        ims: {
            client_id: "aem-assets-content-hub-1",
            scopes: "additional_info.ownerOrg,additional_info.projectedProductContext,AdobeID,openid,session,read_organizations,ab.manage"
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            dev443: "https://localhost.corp.adobe.com:443"
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER,
    access: {
        code: [
            "dma_aem_contenthub"
        ],
        fd: [
            {
                code: "dma_aem_cloud",
                property: "aemSolutions",
                value: "contenthub",
                exists: true
            }
        ],
        flag: "content-hub-enabled"
    }
};
var $4ee530786f57c77b$var$_default = $4ee530786f57c77b$var$contentHub;
module.exports.default = $4ee530786f57c77b$var$_default;

});

parcelRegister("27u2w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/coPilotReview.ts
const $be07ef904de83787$var$coPilotReview = {
    appId: "coPilotReview",
    path: "/co-pilot/review",
    permissionsPolicy: [
        "clipboard-write"
    ],
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    spaAppId: "experience-platform-co-pilot-review",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    access: {
        flag: "co-pilot-review-enabled"
    }
};
var $be07ef904de83787$var$_default = $be07ef904de83787$var$coPilotReview;
module.exports.default = $be07ef904de83787$var$_default;

});

parcelRegister("gdIeY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/creativeDesigner.ts
const $d68736e37fe62f8e$var$creativeDesigner = {
    appId: "creative-designer",
    path: "/creative-designer",
    permissionsPolicy: [
        "clipboard-write"
    ],
    serviceCode: "dma_campaign",
    spaAppId: "pixel-acrites-ui",
    omegaSuiteId: "cc",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        hideInitialSpinner: true,
        history: $ctGaZ.HISTORY.HASH,
        sources: {
            dev: "https://localhost.rd.campaign.adobe.com:9000/"
        }
    }
};
var $d68736e37fe62f8e$var$_default = $d68736e37fe62f8e$var$creativeDesigner;
module.exports.default = $d68736e37fe62f8e$var$_default;

});

parcelRegister("k61PW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/customerEngineeringEnablementManager.ts
const $c9b77fb5b5451598$var$customerEngineeringEnablementManager = {
    appId: "customerEngineeringEnablementManager",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/customer-engineering-enablement-manager",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "dx-customer-engineering-customer-engineering-enablement-manager",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $c9b77fb5b5451598$var$_default = $c9b77fb5b5451598$var$customerEngineeringEnablementManager;
module.exports.default = $c9b77fb5b5451598$var$_default;

});

parcelRegister("84sS8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/depapp.ts
const $7ae2aed9aeb0bad1$var$depapp = {
    appId: "depapp",
    path: "/dep-provisioning",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    spaAppId: "dx-customer-engineering-dep-poc-app",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
var $7ae2aed9aeb0bad1$var$_default = $7ae2aed9aeb0bad1$var$depapp;
module.exports.default = $7ae2aed9aeb0bad1$var$_default;

});

parcelRegister("j9a4I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/designerOnWebId.ts
const $ff7bf611beb93165$var$designerOnWebId = {
    appId: "designerOnWebId",
    path: "/designer-onweb",
    permissionsPolicy: [
        "clipboard-write",
        "clipboard-read"
    ],
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "livecycle-web-designer-host",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    }
};
var $ff7bf611beb93165$var$_default = $ff7bf611beb93165$var$designerOnWebId;
module.exports.default = $ff7bf611beb93165$var$_default;

});

parcelRegister("8Ithn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/developerconsoleID.ts
const $417f01b279ff53ac$var$developerconsoleID = {
    appId: "developerconsoleID",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/skyline-console",
    releaseType: $ctGaZ.RELEASE_TYPE.ALPHA,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "experience-platform-skyline-aem-console",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    access: {
        flag: "new-devconsole-enabled"
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $417f01b279ff53ac$var$_default = $417f01b279ff53ac$var$developerconsoleID;
module.exports.default = $417f01b279ff53ac$var$_default;

});

parcelRegister("aoZOZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/documentAnalyzer.ts
const $555fa34841df8c81$var$documentAnalyzer = {
    appId: "documentAnalyzer",
    path: "/document-analyzer",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    spaAppId: "workfront-measure-document-analyzer",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: ""
        }
    }
};
var $555fa34841df8c81$var$_default = $555fa34841df8c81$var$documentAnalyzer;
module.exports.default = $555fa34841df8c81$var$_default;

});

parcelRegister("d4TPC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/dxCommerceBackgroundGenerationSpaTest.ts
const $844137cad78d6168$var$dxCommerceBackgroundGenerationSpaTest = {
    appId: "dxCommerceBackgroundGenerationSpaTest",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/dx-commerce-background-generation-spa-test",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "Commerce-Genai-spa-pipeline-test-app",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $844137cad78d6168$var$_default = $844137cad78d6168$var$dxCommerceBackgroundGenerationSpaTest;
module.exports.default = $844137cad78d6168$var$_default;

});

parcelRegister("4sEmx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/exdDecisionPolicyAssist.ts
const $defd83b74f84e8a9$var$exdDecisionPolicyAssist = {
    appId: "exdDecisionPolicyAssist",
    path: "/exd-decision-policy-assist",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    spaAppId: "cjm-exd-decision-policy-assist",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    urlContext: {
        key: "sandbox"
    }
};
var $defd83b74f84e8a9$var$_default = $defd83b74f84e8a9$var$exdDecisionPolicyAssist;
module.exports.default = $defd83b74f84e8a9$var$_default;

});

parcelRegister("fiW4l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/exim.ts
const $5da854d93a2779d8$var$exim = {
    appId: "exim",
    parent: "AEP",
    path: "/platform/sandbox/export-import",
    spaAppId: "exc-exim-ui",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    urlContext: {
        key: "sandbox"
    },
    access: {
        code: [
            "acp"
        ]
    }
};
var $5da854d93a2779d8$var$_default = $5da854d93a2779d8$var$exim;
module.exports.default = $5da854d93a2779d8$var$_default;

});

parcelRegister("cgZLs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/experienceManager.ts
const $aa55c96aef895267$var$experienceManager = {
    appId: "experienceManagerUI",
    appContainer: "#landing-container",
    experienceLeague: {
        communities: "adobe-experience-manager",
        filter: "Experience Manager"
    },
    path: "/experiencemanager",
    spaAppId: "experience-platform-self-service-ui-landing",
    gainsight: {
        productKey: "AP-AULLRFDZLJ9K-2"
    },
    omegaSuiteId: "aem",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.AA
    },
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8089"
        }
    },
    access: {
        code: [
            "dma_aem_ams",
            "dma_scene7",
            "dma_mpod",
            "dma_aem_cloud",
            "dma_aem_onprem"
        ],
        flag: "aem-on-prem-enabled"
    }
};
var $aa55c96aef895267$var$_default = $aa55c96aef895267$var$experienceManager;
module.exports.default = $aa55c96aef895267$var$_default;

});

parcelRegister("8jxYY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/firstmile.ts
const $f7375c1598241ec0$var$firstmile = {
    appId: "firstmile",
    path: "/firstmile",
    spaAppId: "dms-mobile-chamaeleon",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.AA
    },
    sandbox: {
        hideInitialSpinner: true,
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            proxy: "https://local.firstmile.adobe.com",
            dev: "https://local.firstmile.adobe.com:8888"
        }
    },
    urlContext: {
        key: "sandbox"
    }
};
var $f7375c1598241ec0$var$_default = $f7375c1598241ec0$var$firstmile;
module.exports.default = $f7375c1598241ec0$var$_default;

});

parcelRegister("k4ZFV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/formsAuthoringAssistantSpa.ts
const $43810713a5e8fba1$var$formsAuthoringAssistantSpa = {
    appId: "formsAuthoringAssistantSpa",
    path: "/livecycle-authoring-assistant",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    spaAppId: "livecycle-authoring-assistant-spa",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    }
};
var $43810713a5e8fba1$var$_default = $43810713a5e8fba1$var$formsAuthoringAssistantSpa;
module.exports.default = $43810713a5e8fba1$var$_default;

});

parcelRegister("h8iik", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/formsSpa.ts
const $d257d59e2a2b9bd7$var$formsSpa = {
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    appId: "formsSpa",
    gainsight: {
        productKey: "AP-AULLRFDZLJ9K-2"
    },
    metricsAppId: "forms-af-wizard",
    omegaSuiteId: "aem",
    path: "/aem/forms/af/create",
    spaAppId: "livecycle-forms-spa",
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
var $d257d59e2a2b9bd7$var$_default = $d257d59e2a2b9bd7$var$formsSpa;
module.exports.default = $d257d59e2a2b9bd7$var$_default;

});

parcelRegister("7JRYZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/formsvrdashboard.ts
const $f63d6f293d14542a$var$formsvrdashboard = {
    appId: "formsvrdashboard",
    path: "/aem/forms/vr/dashboard",
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "livecycle-forms-vr-dashboard",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
var $f63d6f293d14542a$var$_default = $f63d6f293d14542a$var$formsvrdashboard;
module.exports.default = $f63d6f293d14542a$var$_default;

});

parcelRegister("7v60K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.getSubOrgName = module.exports.getHostFromContext = module.exports.getProdHostByLane = module.exports.hostByLaneMap = module.exports.getLane = module.exports.orgLaneMap = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/fusion.ts
const $2e4ed91b38badc85$var$orgLaneMap = new Map();
module.exports.orgLaneMap = $2e4ed91b38badc85$var$orgLaneMap;
const $2e4ed91b38badc85$var$getLane = (resourceLocator)=>{
    const url = resourceLocator.toString().split("https://");
    return url[1].split(".")[0];
};
module.exports.getLane = $2e4ed91b38badc85$var$getLane;
const $2e4ed91b38badc85$var$hostByLaneMap = {
    app: "https://fusion.adobe.com/",
    "app-az": "https://az.fusion.adobe.com/",
    "app-eu": "https://eu.fusion.adobe.com/",
    "app-qa": "https://qa.fusion.adobe.com/",
    "app-qa-az": "https://qa-az.fusion.adobe.com/"
};
module.exports.hostByLaneMap = $2e4ed91b38badc85$var$hostByLaneMap;
const $2e4ed91b38badc85$var$getProdHostByLane = (lane)=>$2e4ed91b38badc85$var$hostByLaneMap[lane];
module.exports.getProdHostByLane = $2e4ed91b38badc85$var$getProdHostByLane;
const $2e4ed91b38badc85$var$getHostFromContext = (prodCtx, subOrg)=>{
    if (subOrg?.id && subOrg?.name) {
        const subOrgNameSplit = subOrg.name.split(" ");
        const orgId = subOrgNameSplit[subOrgNameSplit.length - 1];
        return $2e4ed91b38badc85$var$getProdHostByLane($2e4ed91b38badc85$var$orgLaneMap.get(orgId));
    }
    return $2e4ed91b38badc85$var$getProdHostByLane($2e4ed91b38badc85$var$getLane(prodCtx.fulfillable_entity_resource_locator));
};
module.exports.getHostFromContext = $2e4ed91b38badc85$var$getHostFromContext;
const $2e4ed91b38badc85$var$SOURCE = {
    discovery: "{host}api/v2/ims/login",
    findHostFromContext: {
        getHostFromContext: (prodCtx, subOrg)=>$2e4ed91b38badc85$var$getHostFromContext(prodCtx, subOrg),
        serviceCode: "workfront_fusion",
        useAdobeDomain: true
    },
    payload: [],
    url: "{host}",
    withCredentials: false
};
const $2e4ed91b38badc85$var$getSubOrgName = (prodCtx)=>{
    const resource_locator = prodCtx.fulfillable_entity_resource_locator.toString();
    const orgId = resource_locator.match(/organizations\/\d*/g).toString().split("/")[1];
    const lane = $2e4ed91b38badc85$var$getLane(resource_locator);
    $2e4ed91b38badc85$var$orgLaneMap.set(orgId, lane);
    return `Workfront Fusion ${orgId}`;
};
module.exports.getSubOrgName = $2e4ed91b38badc85$var$getSubOrgName;
const $2e4ed91b38badc85$var$fusion = {
    access: {
        code: [
            "workfront_fusion"
        ]
    },
    permissionsPolicy: [
        "clipboard-read",
        "clipboard-write"
    ],
    appId: "fusion",
    analytics: {
        code: "fsn",
        scripts: {
            dev: "https://assets.adobedtm.com/a7d65461e54e/131eab4f05ba/launch-dad7c63134f3-development.min.js",
            qa: "https://assets.adobedtm.com/a7d65461e54e/131eab4f05ba/launch-dad7c63134f3-development.min.js",
            stage: "https://assets.adobedtm.com/a7d65461e54e/131eab4f05ba/launch-bc4eeee2b723-staging.min.js",
            prod: "https://assets.adobedtm.com/a7d65461e54e/131eab4f05ba/launch-2614b56e9b37.min.js"
        }
    },
    gainsight: {
        productKey: "AP-IZHYZRAKQRSY-2"
    },
    experienceLeague: {
        communities: "workfront",
        filter: "Workfront"
    },
    path: "/fusion",
    refreshOnImsChange: true,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        ims: {
            client_id: "workfront-fusion-web",
            scopes: [
                "additional_info.projectedProductContext",
                "AdobeID",
                "openid",
                "workfront.fusion-license-reporting",
                "workfront.fusion-templates",
                "workfront.fusion-log-retrieval"
            ].join(",")
        },
        sources: {
            dev: "https://master.fusion.adobe.com/",
            qa: "https://dev.fusion.adobe.com/",
            stage: $2e4ed91b38badc85$var$SOURCE,
            prod: $2e4ed91b38badc85$var$SOURCE
        }
    },
    urlContext: {
        key: "subOrg",
        config: {
            customPathKey: "name",
            id: "fulfillable_entity_resource_locator",
            name: $2e4ed91b38badc85$var$getSubOrgName,
            serviceCode: "workfront_fusion",
            useRootPathOnChange: true
        }
    }
};
var $2e4ed91b38badc85$var$_default = $2e4ed91b38badc85$var$fusion;
module.exports.default = $2e4ed91b38badc85$var$_default;

});

parcelRegister("8B4Dg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.GenStudio = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/genStudio.ts
const $d383c2c951d0c36e$var$GenStudio = {
    appId: "GenStudio",
    path: "/genstudio",
    redirectFrom: [
        {
            path: "/genstudio/app"
        }
    ],
    permissionsPolicy: [
        "clipboard-write",
        "clipboard-read"
    ],
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    gainsight: {
        productKey: "AP-XLSAXLU5ZZBT-2"
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "GenStudio-app",
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        ims: {
            client_id: "genstudio",
            scopes: "additional_info.projectedProductContext,additional_info.ownerOrg,AdobeID,openid,session,read_organizations,ab.manage"
        },
        overrideParams: true,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            dev443: "https://localhost.corp.adobe.com:443"
        }
    },
    theme: $ctGaZ.THEME.DARK,
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER,
    access: {
        code: [
            "dx_genstudio"
        ],
        flag: "GenStudio"
    }
};
module.exports.GenStudio = $d383c2c951d0c36e$var$GenStudio;
var $d383c2c951d0c36e$var$_default = $d383c2c951d0c36e$var$GenStudio;
module.exports.default = $d383c2c951d0c36e$var$_default;

});

parcelRegister("j764q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hummingbirdTranslations = module.exports.hummingbird = module.exports.getSubOrgName = void 0;

var $ctGaZ = parcelRequire("ctGaZ");

var $JdG5O = parcelRequire("JdG5O");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $d76e3016231a4caa$var$getSubOrgName = (prodCtx)=>{
    // fallback to ferl if fullfillable_data.custPrefix doesn't exist
    let subOrg = prodCtx.fulfillable_entity_resource_locator;
    let fd = {};
    try {
        fd = JSON.parse(prodCtx.fulfillable_data || "{}");
    } catch (_err) {
        fd = {};
    }
    if (fd.custPrefix) subOrg = fd.custPrefix;
    return subOrg;
};
module.exports.getSubOrgName = $d76e3016231a4caa$var$getSubOrgName;
const $d76e3016231a4caa$var$baseConfig = {
    access: {
        code: [
            "dma_dynamic_chat"
        ]
    },
    urlContext: {
        key: "subOrg",
        config: {
            dontWaitForLoad: true,
            id: "fulfillable_entity_resource_locator",
            name: $d76e3016231a4caa$var$getSubOrgName,
            orgIdName: $d76e3016231a4caa$var$getSubOrgName,
            serviceCode: "dma_dynamic_chat"
        }
    }
};
const $d76e3016231a4caa$var$hummingbird = {
    ...$d76e3016231a4caa$var$baseConfig,
    appId: "hummingbird",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    gainsight: {
        productKey: "AP-BMO3UTBNWBLE-2"
    },
    path: "/dynamic-chat",
    refreshOnImsChange: true,
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:3000"
        }
    },
    spaAppId: "Project-Hummingbird-designer-ui",
    serviceCode: "dma_dynamic_chat",
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
module.exports.hummingbird = $d76e3016231a4caa$var$hummingbird;
const $d76e3016231a4caa$var$hummingbirdTranslations = {
    ...$d76e3016231a4caa$var$baseConfig,
    ...$JdG5O.translationConfig,
    appId: "dynamic-chat-translationService",
    path: "/dynamic-chat/translations",
    metadata: {
        productId: "DynamicChat",
        productName: "Adobe Dynamic Chat"
    }
};
module.exports.hummingbirdTranslations = $d76e3016231a4caa$var$hummingbirdTranslations;

});

parcelRegister("1fAhd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/internal-data-sync.ts
const $92fa9d464e7daaee$var$internalDataSync = {
    appId: "internal-data-sync",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/internal-data-sync",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "workfront-measure-internal-data-sync",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $92fa9d464e7daaee$var$_default = $92fa9d464e7daaee$var$internalDataSync;
module.exports.default = $92fa9d464e7daaee$var$_default;

});

parcelRegister("bTV69", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");

var $kXzzK = parcelRequire("kXzzK");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/landing.ts
const $9651f7e67e46d94b$var$landing = {
    ...$kXzzK.puebloBaseConfig,
    appId: "landing",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "landing",
    dataPrefetchContracts: [
        "recents-org",
        "user-roles",
        "dashboard-org"
    ],
    path: "/home",
    permissionsPolicy: [
        "clipboard-write"
    ],
    redirectFrom: [
        {
            path: "/login"
        }
    ],
    gainsight: {
        productKey: "AP-DFHK5XLSAWVI-2"
    },
    unifiedSearch: {
        access: {
            appIds: [
                "cjm-home",
                "experiencePlatformUI"
            ]
        }
    }
};
var $9651f7e67e46d94b$var$_default = $9651f7e67e46d94b$var$landing;
module.exports.default = $9651f7e67e46d94b$var$_default;

});

parcelRegister("bAy8L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/maestroUI.ts
const $dc4631409ae66bec$var$maestroUI = {
    appId: "maestroUI",
    path: "/maestro",
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            local: "https://localhost.corp.adobe.com:3000",
            dev: "https://maestro-dev.workfront-dev.adobe.com",
            qa: "https://maestro-qa.workfront-dev.adobe.com",
            stage: "",
            prod: "" // Remove this line before the production release.
        }
    },
    permissionsPolicy: [
        "clipboard-read",
        "clipboard-write"
    ]
};
var $dc4631409ae66bec$var$_default = $dc4631409ae66bec$var$maestroUI;
module.exports.default = $dc4631409ae66bec$var$_default;

});

parcelRegister("aCFNv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/marketoEmails.ts
const $a08444cb9bc8bd78$var$marketoEmails = {
    appId: "marketo-emails",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/marketo-emails",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "marketo-apps-email-ui",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $a08444cb9bc8bd78$var$_default = $a08444cb9bc8bd78$var$marketoEmails;
module.exports.default = $a08444cb9bc8bd78$var$_default;

});

parcelRegister("1pB7p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/marketoLandingPage.ts
const $2c0e0e75f119cced$var$marketoLandingPage = {
    appId: "marketo-landing-page",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/marketo-landing-page",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "marketo-apps-landing-page-ui",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $2c0e0e75f119cced$var$_default = $2c0e0e75f119cced$var$marketoLandingPage;
module.exports.default = $2c0e0e75f119cced$var$_default;

});

parcelRegister("gEYVQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/notifications.ts
const $a2ab266bf3186a6b$var$notifications = {
    appId: "pulse",
    hero: {
        icon: "AdobeExperienceCloud",
        path: "/home",
        shortTitle: "AEC",
        title: "Adobe Experience Cloud"
    },
    path: "/home/notifications",
    spaAppId: "pulse-v2",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        hideInitialSpinner: true,
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://status.dev01.corp.adobe.com:3535/"
        }
    },
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    }
};
var $a2ab266bf3186a6b$var$_default = $a2ab266bf3186a6b$var$notifications;
module.exports.default = $a2ab266bf3186a6b$var$_default;

});

parcelRegister("d8wAc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/peopleUi.ts
const $af5e980ae1a32c18$var$peopleUi = {
    appId: "people-ui",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/customer-attributes",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "AnalyticsCXE-crs-ui",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:12399",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $af5e980ae1a32c18$var$_default = $af5e980ae1a32c18$var$peopleUi;
module.exports.default = $af5e980ae1a32c18$var$_default;

});

parcelRegister("92QnR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");

var $069c729dc971fd34$var$_personalizationEditor = $069c729dc971fd34$var$_interopRequireDefault((parcelRequire("5haes")));
function $069c729dc971fd34$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/personalizationEditorDemo.ts
const $069c729dc971fd34$var$personalizationEditorDemo = {
    appId: "personalizationEditorDemo",
    path: "/personalization-editor-demo",
    spaAppId: "cjm-personalization-editor-demo",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8014",
            prod: "" // Remove this line before the production release.
        }
    },
    urlContext: {
        key: "sandbox",
        optional: true
    },
    nestedApps: [
        $069c729dc971fd34$var$_personalizationEditor.default
    ]
};
var $069c729dc971fd34$var$_default = $069c729dc971fd34$var$personalizationEditorDemo;
module.exports.default = $069c729dc971fd34$var$_default;

});

parcelRegister("lbmFS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/platformUIIdentity.ts
const $34a655a87570ae5d$var$platformUIIdentity = {
    appId: "platformUIIdentity",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.BOTH
    },
    omegaSuiteId: "platform",
    path: "/aep-identity",
    spaAppId: "experience-platform-platform-ui-identity",
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    }
};
var $34a655a87570ae5d$var$_default = $34a655a87570ae5d$var$platformUIIdentity;
module.exports.default = $34a655a87570ae5d$var$_default;

});

parcelRegister("jtNwG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/profileexplorer.ts
const $5b88b9fcfe6ee2c0$var$profileexplorer = {
    appId: "profileshikariui",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    parent: "AEP",
    path: "/platform/profile-explorer",
    spaAppId: "experience-platform-profile-shikari-spa",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    serviceCode: "acp",
    urlContext: {
        key: "sandbox"
    },
    access: {
        code: [
            "acp"
        ]
    }
};
var $5b88b9fcfe6ee2c0$var$_default = $5b88b9fcfe6ee2c0$var$profileexplorer;
module.exports.default = $5b88b9fcfe6ee2c0$var$_default;

});

parcelRegister("lSe4e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/prospect-ai.ts
const $315c39ac03529ac5$var$prospectAi = {
    appId: "prospect-ai",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/prospect-ai",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "sales-devops-prospectai-frontent",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $315c39ac03529ac5$var$_default = $315c39ac03529ac5$var$prospectAi;
module.exports.default = $315c39ac03529ac5$var$_default;

});

parcelRegister("4hvhb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/pulseAutomationid.ts
const $bcab6008954021c9$var$CONFIG = {
    appId: "pulseAutomationid",
    path: "/pulse-automation",
    spaAppId: "exc-Pulse_Template_Automation",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    access: {
        flag: "pulse-ss-enabled"
    }
};
var $bcab6008954021c9$var$_default = $bcab6008954021c9$var$CONFIG;
module.exports.default = $bcab6008954021c9$var$_default;

});

parcelRegister("3HKv7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/reportScheduleManagement.ts
const $8e61eb2df15e4c3d$var$reportScheduleManagement = {
    appId: "reportScheduleManagement",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/report-schedule-management",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "experience-platform-report-schedule-management-ui",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $8e61eb2df15e4c3d$var$_default = $8e61eb2df15e4c3d$var$reportScheduleManagement;
module.exports.default = $8e61eb2df15e4c3d$var$_default;

});

parcelRegister("dYXRj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/reportScheduler.ts
const $10369a50ed4f1eb3$var$reportScheduler = {
    appId: "reportScheduler",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/report-scheduler",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    spaAppId: "experience-platform-report-scheduler-ui",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    }
};
var $10369a50ed4f1eb3$var$_default = $10369a50ed4f1eb3$var$reportScheduler;
module.exports.default = $10369a50ed4f1eb3$var$_default;

});

parcelRegister("cToEf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/ruleeditoruiservice.ts
const $40f41848f4ade200$var$ruleEditorUiService = {
    appId: "ruleEditorUiService",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/aem/forms/rule-editor",
    releaseType: $ctGaZ.RELEASE_TYPE.POC,
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "livecycle-ruleeditor-ui-service",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013",
            prod: "" // Remove this line before the production release.
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER
};
var $40f41848f4ade200$var$_default = $40f41848f4ade200$var$ruleEditorUiService;
module.exports.default = $40f41848f4ade200$var$_default;

});

parcelRegister("dNqV3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/sandboxManagementApp.ts
const $185b53dc90cdd255$var$sandboxManagementApp = {
    appId: "sandboxManagementApp",
    path: "/sandbox-management",
    spaAppId: "dx-customer-engineering-sandbox-management-app",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:9080"
        }
    }
};
var $185b53dc90cdd255$var$_default = $185b53dc90cdd255$var$sandboxManagementApp;
module.exports.default = $185b53dc90cdd255$var$_default;

});

parcelRegister("e2CEz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/screens.ts
const $2abc3c30ea420f3f$var$screens = {
    appId: "screens",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/screens",
    sandbox: {
        history: $ctGaZ.HISTORY.HASH,
        sources: {
            dev: "https://localhost.corp.adobe.com:9000",
            qa: "https://localhost.corp.adobe.com:9000",
            stage: "https://screens-stage.adobeio-static.net",
            prod: "https://screens.adobeio-static.net"
        }
    },
    session: {
        defaultTTL: 86400,
        // 1 day max, actual ttl controlled by screens
        scope: $ctGaZ.SessionScope.USER
    },
    access: {
        code: [
            "dma_aem_ams",
            "dma_aem_cloud"
        ]
    }
};
var $2abc3c30ea420f3f$var$_default = $2abc3c30ea420f3f$var$screens;
module.exports.default = $2abc3c30ea420f3f$var$_default;

});

parcelRegister("eliQt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/softwareDistribution.ts
const $d432b866e4423bd8$var$softwareDistribution = {
    appId: "softwareDistribution",
    path: "/downloads",
    runtime: $ctGaZ.RUNTIME.CDN_LEGACY,
    sandbox: {
        pageTimeout: 60000,
        history: {
            type: $ctGaZ.HISTORY.SERVER,
            config: {
                absolutePaths: true,
                hashType: $ctGaZ.HASH_TYPE.NOSLASH
            }
        },
        sources: {
            local: {
                discovery: "https://localhost/bin/softwaredistribution/login.html?configid=ims",
                payload: [
                    "path"
                ],
                requestId: true,
                withCredentials: true
            },
            dev: {
                discovery: "https://downloads-dev.experiencecloud.adobe.com/bin/softwaredistribution/login.html?configid=ims",
                payload: [
                    "path"
                ],
                requestId: true,
                withCredentials: true
            },
            dev2: {
                discovery: "https://downloads-dev2.experiencecloud.adobe.com/bin/softwaredistribution/login.html?configid=ims",
                payload: [
                    "path"
                ],
                requestId: true,
                withCredentials: true
            },
            dev3: {
                discovery: "https://downloads-dev3.experiencecloud.adobe.com/bin/softwaredistribution/login.html?configid=ims",
                payload: [
                    "path"
                ],
                requestId: true,
                withCredentials: true
            },
            qa: {
                discovery: "https://downloads-qa.experiencecloud.adobe.com/bin/softwaredistribution/login.html?configid=ims",
                payload: [
                    "path"
                ],
                requestId: true,
                withCredentials: true
            },
            qacdn: {
                discovery: "https://publish-p11553-e21242.adobeaemcloud.com/bin/softwaredistribution/login.html?configid=ims",
                payload: [
                    "path"
                ],
                requestId: true,
                withCredentials: true
            },
            prod: {
                discovery: "https://downloads.experiencecloud.adobe.com/bin/softwaredistribution/login.html?configid=ims",
                payload: [
                    "path"
                ],
                requestId: true,
                withCredentials: true
            },
            prod2: {
                discovery: "https://downloads-temp.experiencecloud.adobe.com/bin/softwaredistribution/login.html?configid=ims",
                payload: [
                    "path"
                ],
                requestId: true,
                withCredentials: true
            },
            stagecdn: {
                discovery: "https://publish-p2606-e4990.adobeaemcloud.com/bin/softwaredistribution/bin/softwaredistribution/login.html?configid=ims",
                payload: [
                    "path"
                ],
                requestId: true,
                withCredentials: true
            },
            stage: {
                discovery: "https://downloads-stage.experiencecloud.adobe.com/bin/softwaredistribution/login.html?configid=ims",
                payload: [
                    "path"
                ],
                requestId: true,
                withCredentials: true
            }
        }
    },
    serviceCode: "",
    hideTenant: true
};
var $d432b866e4423bd8$var$_default = $d432b866e4423bd8$var$softwareDistribution;
module.exports.default = $d432b866e4423bd8$var$_default;

});

parcelRegister("f64Cl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/spadebugger.ts
const $e055e122600427e5$var$spadebugger = {
    appId: "spadebugger",
    path: "/spa-debugger",
    spaAppId: "exc-spa-debugger",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
var $e055e122600427e5$var$_default = $e055e122600427e5$var$spadebugger;
module.exports.default = $e055e122600427e5$var$_default;

});

parcelRegister("l8mNV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/starter.ts
const $9fcb294208a81997$var$starter = {
    appId: "starter",
    autoInstantiateRuntime: true,
    path: "/sample",
    redirectFrom: [
        {
            path: "/starter"
        }
    ],
    sharedCaches: [
        "cacheSample"
    ],
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER,
    spaAppId: "exc-unified-shell-starter",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:12399"
        }
    },
    session: {
        defaultTTL: 7200,
        // 2 hours
        scope: $ctGaZ.SessionScope.CONTEXT
    },
    urlContext: {
        key: "sandbox",
        optional: true
    }
};
var $9fcb294208a81997$var$_default = $9fcb294208a81997$var$starter;
module.exports.default = $9fcb294208a81997$var$_default;

});

parcelRegister("hAm5M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/targetSandbox.ts
const $435c47911ef1026e$var$targetSandbox = {
    appId: "targetSandbox",
    path: "/target-sandbox",
    serviceCode: "dma_target_sandbox",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        hideInitialSpinner: true,
        history: $ctGaZ.HISTORY.HASH,
        sources: {
            dev: "https://localhost.corp.adobe.com:4200",
            qa: "https://experience-qa.adobe.com/solutions/tnt-bullet",
            stage: "https://experience-stage.adobe.com/solutions/tnt-bullet",
            prod: ""
        }
    },
    access: {
        code: [
            "dma_target_sandbox"
        ]
    }
};
var $435c47911ef1026e$var$_default = $435c47911ef1026e$var$targetSandbox;
module.exports.default = $435c47911ef1026e$var$_default;

});

parcelRegister("kKa0Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/uberReleaseRegistry.ts
const $a5016dba6241b077$var$uberReleaseRegistry = {
    appId: "uberReleaseRegistry",
    path: "/uber-release-registry",
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            dev: "https://localhost.corp.adobe.com:3000/ui/",
            qa: "https://releaseregistry-dev-va6.stage.cloud.adobe.io/ui/",
            stage: "https://releaseregistry-dev-va6.stage.cloud.adobe.io/ui/",
            prod: "https://release-registry.corp.adobe.com/ui/"
        }
    },
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.AA
    }
};
var $a5016dba6241b077$var$_default = $a5016dba6241b077$var$uberReleaseRegistry;
module.exports.default = $a5016dba6241b077$var$_default;

});

parcelRegister("cb8F7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/uisAutomation.ts
const $7671ca68987d40aa$var$uisAutomation = {
    appId: "uisAutomation",
    path: "/uis-automation",
    spaAppId: "dx-customer-engineering-uis-automation-app",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
var $7671ca68987d40aa$var$_default = $7671ca68987d40aa$var$uisAutomation;
module.exports.default = $7671ca68987d40aa$var$_default;

});

parcelRegister("luX4S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/uistoolsui.ts
const $0d3164451c2e044b$var$uistoolsui = {
    appId: "uistoolsui",
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    },
    path: "/uis-debug-tools",
    spaAppId: "mc-visitor-uis-tools-ui",
    runtime: $ctGaZ.RUNTIME.CDN,
    sandbox: {
        history: $ctGaZ.HISTORY.HASH,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    }
};
var $0d3164451c2e044b$var$_default = $0d3164451c2e044b$var$uistoolsui;
module.exports.default = $0d3164451c2e044b$var$_default;

});

parcelRegister("kbzze", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/userPreferences.ts
const $5210ce4ca949937f$var$userPreferences = {
    appId: "userPreferences",
    autoInstantiateRuntime: true,
    path: "/preferences",
    runtime: $ctGaZ.RUNTIME.CDN,
    spaAppId: "exc-exc-preferences",
    sandbox: {
        history: $ctGaZ.HISTORY.HASH,
        sources: {
            dev: "https://localhost.corp.adobe.com:8013"
        }
    },
    thunderbird: $ctGaZ.THUNDERBIRD.SERVICE_WORKER,
    analytics: {
        omegaGlobal: $ctGaZ.PDH_GLOBAL.WEBSDK
    }
};
var $5210ce4ca949937f$var$_default = $5210ce4ca949937f$var$userPreferences;
module.exports.default = $5210ce4ca949937f$var$_default;

});

parcelRegister("cY7mL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ctGaZ = parcelRequire("ctGaZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/webEditor.ts
const $7de50ac5828d89e7$var$webEditor = {
    appId: "webEditor",
    path: "/sample-web-editor",
    spaAppId: "tnt-spa-web-editor",
    sandbox: {
        history: {
            type: $ctGaZ.HISTORY.HASH,
            config: {
                addParamsToHash: true
            }
        },
        sources: {
            dev: "https://localhost.corp.adobe.com:4200",
            prod: "" // Remove this line before the production release.
        }
    }
};
var $7de50ac5828d89e7$var$_default = $7de50ac5828d89e7$var$webEditor;
module.exports.default = $7de50ac5828d89e7$var$_default;

});

parcelRegister("lAqcL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.workfrontPreview = module.exports.workfront = module.exports.isPreferredSubOrg = module.exports.getSubOrgName = module.exports.getHostFromContext = module.exports.parseFulfillableData = module.exports.getLaneFromEnv = module.exports.getDataFromLane = void 0;

var $1af0302d508def8d$var$_metrics = $1af0302d508def8d$var$_interopRequireDefault((parcelRequire("17AVh")));

var $hCG2Z = parcelRequire("hCG2Z");

var $ctGaZ = parcelRequire("ctGaZ");
function $1af0302d508def8d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // This file was generated automatically from ../solutions/workfront.ts
const $1af0302d508def8d$var$metrics = $1af0302d508def8d$var$_metrics.default.create("unifiedshell.solution.workfront");
/**
 * Wiki for Workfront's integration and new solution configs:
 * https://git.corp.adobe.com/exc/unified-shell/wiki/Workfront-Integration-and-New-Configs
 */ const $1af0302d508def8d$var$laneToDataMap = {
    local: {
        name: "{subdomain} - Local",
        url: "https://{subdomain}.local.workfront-dev.adobe.com"
    },
    devtest: {
        name: "{subdomain} - Dev",
        url: "https://{subdomain}.devtest.workfront-dev.adobe.com"
    },
    hub: {
        name: "{subdomain} - Hub",
        url: "https://{subdomain}.workfront.adobe.com"
    },
    prod: {
        name: "{subdomain} - Production",
        url: "https://{subdomain}.my.workfront.adobe.com"
    },
    preview: {
        name: "{subdomain} - Preview",
        url: "https://{subdomain}.preview.workfront.adobe.com"
    },
    testdrive: {
        name: "{subdomain} - Test Drive",
        url: "https://{subdomain}.testdrive.workfront.adobe.com"
    }
};
const $1af0302d508def8d$var$envNameToLaneMap = {
    dev: "devtest",
    hub: "hub",
    production: "prod",
    preview: "preview",
    "test drive": "testdrive"
};
const $1af0302d508def8d$var$getDataFromLane = (lane)=>{
    if (!lane) return;
    const sandboxMatch = lane.match(/^sandbox(\d+)$/);
    if (!sandboxMatch) return $1af0302d508def8d$var$laneToDataMap[lane];
    const num = parseInt(sandboxMatch[1], 10);
    const zerodNum = num < 10 ? `0${num}` : num;
    return {
        name: `{subdomain} - Sandbox ${num}`,
        url: `https://{subdomain}.sb${zerodNum}.workfront.adobe.com`
    };
};
module.exports.getDataFromLane = $1af0302d508def8d$var$getDataFromLane;
const $1af0302d508def8d$var$getLaneFromEnv = (env)=>{
    const sandboxMatch = env.match(/^sandbox (\d+)$/);
    return sandboxMatch ? `sandbox${sandboxMatch[1]}` : $1af0302d508def8d$var$envNameToLaneMap[env];
}; // These are common sandbox source names for other Solutions that we can map to Workfront lane names
module.exports.getLaneFromEnv = $1af0302d508def8d$var$getLaneFromEnv;
const $1af0302d508def8d$var$sandboxSourceToLaneMap = {
    local: "local",
    dev: "devtest",
    qa: "devtest",
    hub: "hub",
    preview: "preview",
    prod: "prod"
};
const $1af0302d508def8d$var$parseFulfillableData = (prodCtx)=>{
    try {
        const output = JSON.parse(prodCtx.fulfillable_data || "{}");
        if (typeof output === "string") return JSON.parse(output);
        return output;
    } catch (e) {
        $1af0302d508def8d$var$metrics.error("parseFulfillableData: Error parsing fulfillable data", e);
        return {};
    }
};
module.exports.parseFulfillableData = $1af0302d508def8d$var$parseFulfillableData;
const $1af0302d508def8d$var$getHostFromContext = (prodCtx, subOrg, preview = false)=>{
    const { hostname: hostname, lane: lane, subdomain: subdomain } = $1af0302d508def8d$var$parseFulfillableData(prodCtx);
    const shellSourceLane = $1af0302d508def8d$var$sandboxSourceToLaneMap[(0, $hCG2Z.getQueryValue)("source")];
    if (subOrg?.id && subOrg.name) {
        const [subdomainString, envName = ""] = subOrg.name.split(" - ");
        return $1af0302d508def8d$var$getDataFromLane(shellSourceLane || $1af0302d508def8d$var$getLaneFromEnv(envName.toLowerCase()))?.url?.replace("{subdomain}", subdomainString);
    }
    if (lane && subdomain) return $1af0302d508def8d$var$getDataFromLane(shellSourceLane || lane)?.url?.replace("{subdomain}", subdomain);
    return hostname.replace(/(my)\.workfront/, `${preview ? "preview" : "my"}.workfront`);
};
module.exports.getHostFromContext = $1af0302d508def8d$var$getHostFromContext;
const $1af0302d508def8d$var$getSubOrgName = (prodCtx)=>{
    const data = $1af0302d508def8d$var$parseFulfillableData(prodCtx);
    const { hostname: hostname } = data;
    let { lane: lane, subdomain: subdomain } = data;
    if (lane && subdomain) return $1af0302d508def8d$var$getDataFromLane(lane)?.name?.replace("{subdomain}", subdomain) || "Undefined";
    if (!hostname) {
        $1af0302d508def8d$var$metrics.error("getSubOrgName: No hostname found in product context");
        return "Undefined";
    } // The hostname from the product context is a url that looks like
    // https://{subdomain}.{lane}.workfront.com e.g. unifiedshell.devtest.workfront.com
    // We parse this to get the sub org name in the form of {subdomain} - {lane}
    // e.g. unifiedshell - devtest,
    // where lane = environment in Workfront terms.
    [subdomain, lane] = hostname.split(".");
    return `${subdomain.split("https://")[1]} - ${lane}`;
};
module.exports.getSubOrgName = $1af0302d508def8d$var$getSubOrgName;
const $1af0302d508def8d$var$isPreferredSubOrg = (prodCtx)=>{
    const { lane: lane } = $1af0302d508def8d$var$parseFulfillableData(prodCtx);
    return lane === "prod";
};
module.exports.isPreferredSubOrg = $1af0302d508def8d$var$isPreferredSubOrg;
const $1af0302d508def8d$var$SOURCE = {
    discovery: "{host}/authn/authenticate/access_token/ims?refreshable",
    findHostFromContext: {
        getHostFromContext: (prodCtx, subOrg)=>$1af0302d508def8d$var$getHostFromContext(prodCtx, subOrg),
        serviceCode: "workfront",
        useAdobeDomain: true
    },
    payload: [],
    url: "{host}",
    withCredentials: true
};
const $1af0302d508def8d$var$PREVIEW_SOURCE = {
    ...$1af0302d508def8d$var$SOURCE,
    findHostFromContext: {
        ...$1af0302d508def8d$var$SOURCE.findHostFromContext,
        getHostFromContext: (prodCtx, subOrg)=>$1af0302d508def8d$var$getHostFromContext(prodCtx, subOrg, true)
    }
};
const $1af0302d508def8d$var$localSource = {
    ...$1af0302d508def8d$var$SOURCE,
    discovery: `{host}/authn/authenticate/access_token/ims?refreshable&lane=${(0, $hCG2Z.getQueryParams)()["wfLane"] || "devtest"}`
};
const $1af0302d508def8d$var$workfront = {
    appId: "workfront",
    autoInstantiateRuntime: true,
    experienceLeague: {
        communities: "workfront",
        filter: "Workfront"
    },
    gainsight: {
        productKey: "AP-IZHYZRAKQRSY-2"
    },
    path: "/workfront",
    refreshOnImsChange: true,
    urlContext: {
        key: "subOrg",
        config: {
            customPathKey: "name",
            id: "fulfillable_entity_resource_locator",
            name: $1af0302d508def8d$var$getSubOrgName,
            preferred: $1af0302d508def8d$var$isPreferredSubOrg,
            serviceCode: "workfront",
            useRootPathOnChange: true
        }
    },
    sandbox: {
        history: $ctGaZ.HISTORY.HISTORY,
        sources: {
            local: $1af0302d508def8d$var$localSource,
            dev: $1af0302d508def8d$var$SOURCE,
            qa: $1af0302d508def8d$var$SOURCE,
            stage: $1af0302d508def8d$var$SOURCE,
            prod: $1af0302d508def8d$var$SOURCE
        },
        pageTimeout: 360000
    },
    access: {
        code: [
            "workfront"
        ],
        flag: "workfront-enabled",
        logicOp: "AND"
    },
    permissionsPolicy: [
        "clipboard-read",
        "clipboard-write"
    ]
};
module.exports.workfront = $1af0302d508def8d$var$workfront;
const $1af0302d508def8d$var$workfrontPreview = {
    ...$1af0302d508def8d$var$workfront,
    path: "/workfront/preview",
    sandbox: {
        ...$1af0302d508def8d$var$workfront.sandbox,
        sources: {
            local: $1af0302d508def8d$var$localSource,
            dev: $1af0302d508def8d$var$PREVIEW_SOURCE,
            qa: $1af0302d508def8d$var$PREVIEW_SOURCE,
            stage: $1af0302d508def8d$var$PREVIEW_SOURCE,
            prod: $1af0302d508def8d$var$PREVIEW_SOURCE
        }
    }
};
module.exports.workfrontPreview = $1af0302d508def8d$var$workfrontPreview;

});




var $2b2aa5bbd47f6036$exports = {};

(parcelRequire("3cmwu")).register(new URL("", import.meta.url).toString(), JSON.parse('["aVYDG","main.b3dd10de.js","jrioA","postAuth.d1be4a25.js","bZL4Z","aem-fallback.dc6b5bb2.js","6ztEU","pulse-sdk.9c123b16.js","9eA6B","feedback.0df2a8ae.js","01Ohm","azureStorage.2b4fe0c9.js","h7RDM","azureStorage.101fdd88.js","1z9CA","azureStorage.5cb7d3d9.js","8ldnw","SurveyService.29f03de2.js","dGnnZ","CapabilityIcons.186cd8e6.svg","ds4Wh","postAuth.372a8ee3.js","4CIDK","cache-mini-polyfill.0ac23b27.js","7j7ww","CustomTokenService.ed70ec25.js","7zD5V","Heading.15ec3824.js","i2aes","Error.973f01cd.js","gPPdO","Error.b336a1d6.css","ctfMK","Error.fb6d90d5.js","7UsoS","Error.b9f6e139.css","6gGye","AppMonitorService.4a0593e2.js","1vCZj","pako.0ea1d2a4.js","lBjGD","AdobeExperienceCloud.bfdb429e.svg","8F1HD","AdobeExperiencePlatform.6e79ef30.svg","lArOC","AdobeExperienceSubCloud.6e2f998e.svg","1TE5G","HeroIcons.6620f5dc.svg","im4hl","WorkfrontHero.7efae3c8.svg","2l10r","ServiceWorkerUpdateService.4c22c5d6.js","fKsOx","ShellBanner.577fd783.js","gPfp9","ShellBanner.cd7bfff3.css","dCrv8","ShellNetworkError.c52e5df3.js","aQ9cw","ShellNetworkError.4911fa5d.css","a2Z05","ShellSidebar.163fb96d.js","3C8ZN","PickerPanel.7a37534f.js","9WdFZ","PickerPanel.ee6919b6.js","8I7lg","PickerPanel.995d6e6e.css","cQBVA","ResponseWell.d727e9a1.js","cEIZM","index.esm.adbbb7f9.js","itBAo","index.esm.2e64fe23.css","dCRVZ","ResponseWell.cf00dd00.css","hT1Ic","ResponseWell.11f2199c.css","5Tu3R","ResponseWell.14aaa98f.js","53iSF","SourceQuery.413bd3c3.js","44Tdp","SourceQuery.03316372.css","fUDxW","forest.c3307101.webp","aLVmW","module.83dfa3fd.js","8COgs","TuxContainer.35b332d6.js","7Zn3b","module.a07beaf3.css","5AGJz","ShellSidebar.fd9bc2fc.css","D8UTn","ShellSidebar.8f9ea003.css","dglIe","ShellSidebar.2dbf8346.css","ms5mk","ShellSidebar.711d058e.css","7GSTZ","HelpCenter.7a687b11.css","ki2nr","ShellSidebar.5e6e4c4c.css","9j9Pi","ShellSidebar.0ae1b403.css","bwRqG","ShellSidebar.a79e7b8a.css","5200E","ShellSidebar.e7a46f39.js","5wCcX","ShellSidebar.7c417518.js","hue8D","ShellSidebar.98ad2f11.js","2arCC","ShellSidebar.0e20c56c.js","cYwRf","ShellSidebar.3ca50d6a.js","9u8DV","ShellSidebar.9b984736.js","jXgXA","ShellSidebar.58bf318a.js","4bJ8e","ShellSidebar.9b6259d3.js","iAoZ0","ShellSidebar.fdf8de17.js","2rJ3i","ShellSidebar.8a7ef6cd.css","cN3SH","NotProvisionedWarning.8ac603bf.js","aOxQg","js-deferred.3ed70ad3.js","fPaBh","HelpCenter.3650d058.js","1V5LZ","azureStorage.7428c01f.js","kZ0pp","DebugPanel.b61d9f74.js","350pN","DebugPanel.6eafbea3.css","23tLV","HelpCenter.1ca0d658.css","7wout","Learning_64px.392efad8.svg","fCU3X","Community_64px.b165383f.svg","9fWRL","support.7c8e3cd1.svg","04pYp","HelpCenter.a3cb499f.css","8Aorl","HelpCenter.17645334.css","6RT6w","HelpCenter.ec83dacf.js","1gZNf","HelpCenter.54a3db0d.js","87Alr","HelpCenter.32893d6a.css","hXcwy","PulseWidgetWrapper.feccc88e.js","XrDy7","PulseWidgetWrapper.5f20e6f4.css","8wmPv","PulseWidgetWrapper.97be9a6c.js","kGujd","PulseWidgetWrapper.7245f83d.js","gxblT","PulseWidgetWrapper.0a9a98d1.js","2cPnp","PulseWidgetWrapper.00d01679.js","h9B3N","PulseWidgetWrapper.7759ce6a.js","c0rcy","PulseWidgetWrapper.0ea8b859.js","ew5yp","CircleExperienceCloud.69d1dfda.svg","5pBTj","PulseWidgetWrapper.6bf82d1f.css","9CWHJ","PulseContainer.d2e8391d.js","heqd9","ShellAppSwitcher.6faee417.js","cxhjJ","ShellAppSwitcher.6b2eded7.css","jkFE8","UserProfile.64e60ec7.js","9KXoz","UserProfile.3e709481.css","2MrQ5","ShellOrgSwitcher.4fb84f7c.js","5IPZf","ShellOrgSwitcher.58abcf84.css","hssB3","ShellSandboxSwitcher.c7a6d952.js","cbtcS","ShellSandboxSwitcher.2559746b.css","hnITK","CoachMark.a8bb2b68.js","iRzRH","CoachMark.b016afc4.css","hCdO9","ShellSkipMenu.a1aa6983.js","2tBkT","ShellSkipMenu.f226d28f.css","5jRML","ShellWorkspace.7bf6d99d.js","6uwFD","ShellWorkspace.8637b049.css","eoavB","AlertsContainer.ad860cee.js","lL1Wk","AlertsContainer.96a22d5b.css","gTsWi","search.e0b72636.js","hggbf","AdobeExperienceCloud.bfdb429e.svg","3P1kF","search.fda6b843.css","lMVqA","search.bd1e9865.css","86m8v","search.3cbf5b5c.js","1CCfP","search.9c1cc52c.js","172AX","search.eee7aa68.css","bthgT","ShellLanguagePicker.7f780106.js","kD9B8","ShellLanguagePicker.e6b614ed.js","8YOwA","ShellLanguagePicker.19ea1299.css","6kJDD","ShellSideNav.6bf3de35.js","iM2Re","ShellSideNav.c085ed24.css","d3ppd","js-deferred.723070c8.css","6UnT0","js-deferred.62cf3975.css","iH25S","js-deferred.bd23d512.css","jNvOp","js-deferred.b37b29e0.js","i92TE","js-deferred.012adec6.js","9w19Q","js-deferred.d1d42ad5.js","7bkF4","js-deferred.1ad43625.js","dmVTS","js-deferred.0b8ca584.js","f3Y5a","js-deferred.e39822af.js","bw5xw","js-deferred.ae573318.css","cBjZF","Debug.b39cdf6b.js","cMWIw","Debug.49dbc2c6.css","4hwyN","Debug.b138089a.css","4xfe0","ShellNoAccess.ee0d2b72.js","c3hhK","ShellNoAccess.a49ef516.css","l4THr","ShellRolesModal.444356b4.js","5PyIM","RolesModalIcons.8981ac12.svg","fLwKB","ShellRolesModal.5c6d71b7.css","epkLF","ShellRolesModalInvite.2f39c02c.js","hbYF9","ShellRolesModalInvite.2d2b6c00.css","lvRQb","TuxContainer.00c23cb9.js","aLgse","TuxContainer.6df8c3dd.css","hNPxz","TuxContainer.8b1acfeb.css","iDUdO","UserConsent.f12a47ad.js","5X6Dv","UserConsent.3a0c1cbe.css","bJmE1","HistoryBlockerDialog.8591243a.js","5dhoM","BetaAgreement.04eb2827.js","b2duX","BetaAgreement.ab58f340.css","8q4cv","RideError.9bf50bf1.js","6eHUl","ModalContainer.8c78067d.js","etrgu","ModalContainer.caf0cf50.css","aLXeK","RideError.62a4a7f0.css","g5xy1","AppAssemblyService.4858162d.js","6LPJY","BrandIcons.82ac0f69.svg","e3AuO","FeedbackService.8e27457b.js","6EokD","ShellToast.78f9d3f9.js","dLdHy","ShellToast.83e82176.css","jVnWt","settings.7472ebb1.js","d1gl7","ComponentModal.61080f31.js","7Jp6c","ComponentModal.f7f1c637.css","9bhTi","offlineVerification.6b43ee4a.js"]'));

"use strict";

var $5f54e6514f782bd1$var$_react = $5f54e6514f782bd1$var$_interopRequireDefault((parcelRequire("7eprg")));

var $5f54e6514f782bd1$var$_reactDom = $5f54e6514f782bd1$var$_interopRequireDefault((parcelRequire("5hg2n")));

var $5f54e6514f782bd1$var$_App = $5f54e6514f782bd1$var$_interopRequireDefault((parcelRequire("4Idm1")));
function $5f54e6514f782bd1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $5f54e6514f782bd1$var$config = {
    cdn: "",
    env: "",
    region: "",
    scripts: {},
    scriptsPath: "/assets",
    spaVersion: "",
    ...window.config || {}
};
$5f54e6514f782bd1$var$_reactDom.default.render(/*#__PURE__*/ $5f54e6514f782bd1$var$_react.default.createElement($5f54e6514f782bd1$var$_App.default, {
    cdn: $5f54e6514f782bd1$var$config.cdn,
    env: $5f54e6514f782bd1$var$config.env,
    region: $5f54e6514f782bd1$var$config.region,
    scriptsPath: $5f54e6514f782bd1$var$config.scriptsPath,
    spaVersion: $5f54e6514f782bd1$var$config.spaVersion
}), document.getElementById("exc"));


//# sourceMappingURL=main.b3dd10de.js.map
